(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7644"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7644"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f13ecebb1f16f955$export$f7ad0328861e2f03, (v) => $f13ecebb1f16f955$export$f7ad0328861e2f03 = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("i9Aqn", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => (parcelRequire("fqRLw")).popperGenerator);
$parcel$export(module.exports, "detectOverflow", () => (parcelRequire("leSQw")).default);
$parcel$export(module.exports, "createPopperBase", () => (parcelRequire("fqRLw")).createPopper);
$parcel$export(module.exports, "createPopper", () => (parcelRequire("2oJ1v")).createPopper);
$parcel$export(module.exports, "createPopperLite", () => (parcelRequire("hQXXi")).createPopper);

var $l6ej2 = parcelRequire("l6ej2");

var $1Evkg = parcelRequire("1Evkg");

var $fqRLw = parcelRequire("fqRLw");
var $leSQw = parcelRequire("leSQw");

var $2oJ1v = parcelRequire("2oJ1v");

var $hQXXi = parcelRequire("hQXXi");
$parcel$exportWildcard(module.exports, $l6ej2);
$parcel$exportWildcard(module.exports, $1Evkg);

});
parcelRegister("l6ej2", function(module, exports) {

$parcel$export(module.exports, "top", () => $f5c54167a3c62105$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $f5c54167a3c62105$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $f5c54167a3c62105$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $f5c54167a3c62105$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $f5c54167a3c62105$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $f5c54167a3c62105$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $f5c54167a3c62105$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $f5c54167a3c62105$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $f5c54167a3c62105$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $f5c54167a3c62105$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $f5c54167a3c62105$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $f5c54167a3c62105$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $f5c54167a3c62105$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $f5c54167a3c62105$export$803cd8101b6c182b);
$parcel$export(module.exports, "beforeRead", () => $f5c54167a3c62105$export$421679a7c3d56e);
$parcel$export(module.exports, "read", () => $f5c54167a3c62105$export$aafa59e2e03f2942);
$parcel$export(module.exports, "afterRead", () => $f5c54167a3c62105$export$6964f6c886723980);
$parcel$export(module.exports, "beforeMain", () => $f5c54167a3c62105$export$c65e99957a05207c);
$parcel$export(module.exports, "main", () => $f5c54167a3c62105$export$f22da7240b7add18);
$parcel$export(module.exports, "afterMain", () => $f5c54167a3c62105$export$bab79516f2d662fe);
$parcel$export(module.exports, "beforeWrite", () => $f5c54167a3c62105$export$8d4d2d70e7d46032);
$parcel$export(module.exports, "write", () => $f5c54167a3c62105$export$68d8715fc104d294);
$parcel$export(module.exports, "afterWrite", () => $f5c54167a3c62105$export$70a6e5159acce2e6);
$parcel$export(module.exports, "modifierPhases", () => $f5c54167a3c62105$export$d087d3878fdf71d5);
var $f5c54167a3c62105$export$1e95b668f3b82d = "top";
var $f5c54167a3c62105$export$40e543e69a8b3fbb = "bottom";
var $f5c54167a3c62105$export$79ffe56a765070d2 = "right";
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = "left";
var $f5c54167a3c62105$export$dfb5619354ba860 = "auto";
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = "start";
var $f5c54167a3c62105$export$bd5df0f255a350f8 = "end";
var $f5c54167a3c62105$export$390fd549c5303b4d = "clippingParents";
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = "viewport";
var $f5c54167a3c62105$export$ae5ab1c730825774 = "popper";
var $f5c54167a3c62105$export$ca50aac9f3ba507f = "reference";
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = "beforeRead";
var $f5c54167a3c62105$export$aafa59e2e03f2942 = "read";
var $f5c54167a3c62105$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = "beforeMain";
var $f5c54167a3c62105$export$f22da7240b7add18 = "main";
var $f5c54167a3c62105$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = "beforeWrite";
var $f5c54167a3c62105$export$68d8715fc104d294 = "write";
var $f5c54167a3c62105$export$70a6e5159acce2e6 = "afterWrite";
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];

});

parcelRegister("1Evkg", function(module, exports) {

$parcel$export(module.exports, "applyStyles", () => (parcelRequire("bjlic")).default);
$parcel$export(module.exports, "arrow", () => (parcelRequire("2c83k")).default);
$parcel$export(module.exports, "computeStyles", () => (parcelRequire("hfLNM")).default);
$parcel$export(module.exports, "eventListeners", () => (parcelRequire("lUt2x")).default);
$parcel$export(module.exports, "flip", () => (parcelRequire("fhdOY")).default);
$parcel$export(module.exports, "hide", () => (parcelRequire("201VR")).default);
$parcel$export(module.exports, "offset", () => (parcelRequire("aE9ix")).default);
$parcel$export(module.exports, "popperOffsets", () => (parcelRequire("k1fcs")).default);
$parcel$export(module.exports, "preventOverflow", () => (parcelRequire("4lgpD")).default);

var $bjlic = parcelRequire("bjlic");

var $2c83k = parcelRequire("2c83k");

var $hfLNM = parcelRequire("hfLNM");

var $lUt2x = parcelRequire("lUt2x");

var $fhdOY = parcelRequire("fhdOY");

var $201VR = parcelRequire("201VR");

var $aE9ix = parcelRequire("aE9ix");

var $k1fcs = parcelRequire("k1fcs");

var $4lgpD = parcelRequire("4lgpD");

});
parcelRegister("bjlic", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c1fc4c4e58d7dd$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");
// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $iG0HL.isHTMLElement)(element) || !(0, $6NwRo.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $iG0HL.isHTMLElement)(element) || !(0, $6NwRo.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        "computeStyles"
    ]
};

});
parcelRegister("6NwRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f30cf0ce50e075e$export$2e2bcd8739ae039);
function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("iG0HL", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $d98cb23738a6d9d0$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $d98cb23738a6d9d0$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $d98cb23738a6d9d0$export$af51f0f06c0f328a);

var $jc5j7 = parcelRequire("jc5j7");
function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $jc5j7.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $jc5j7.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $jc5j7.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("jc5j7", function(module, exports) {

$parcel$export(module.exports, "default", () => $df9341392e6ed7b1$export$2e2bcd8739ae039);
function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("2c83k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1992f2d714808ab6$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $4bNP2 = parcelRequire("4bNP2");

var $ioj8K = parcelRequire("ioj8K");

var $ecwzm = parcelRequire("ecwzm");

var $fxYmH = parcelRequire("fxYmH");

var $fHMKD = parcelRequire("fHMKD");

var $4QECX = parcelRequire("4QECX");

var $6CeE3 = parcelRequire("6CeE3");

var $l6ej2 = parcelRequire("l6ej2");
var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4QECX.default)(typeof padding !== "number" ? padding : (0, $6CeE3.default)(padding, (0, $l6ej2.basePlacements)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f6ekA.default)(state.placement);
    var axis = (0, $fxYmH.default)(basePlacement);
    var isVertical = [
        (0, $l6ej2.left),
        (0, $l6ej2.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $4bNP2.default)(arrowElement);
    var minProp = axis === "y" ? (0, $l6ej2.top) : (0, $l6ej2.left);
    var maxProp = axis === "y" ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $ecwzm.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $fHMKD.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ioj8K.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});
parcelRegister("f6ekA", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe288682115fde3$export$2e2bcd8739ae039);

function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("4bNP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ced62b744c6cfe$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");
function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bkFj6.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("bkFj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $84019ab652aa921b$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");

var $aPr9y = parcelRequire("aPr9y");

var $jc5j7 = parcelRequire("jc5j7");

var $d9GIF = parcelRequire("d9GIF");
function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $iG0HL.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $aPr9y.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $aPr9y.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $iG0HL.isElement)(element) ? (0, $jc5j7.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d9GIF.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("aPr9y", function(module, exports) {

$parcel$export(module.exports, "max", () => $7e23bad950468b82$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $7e23bad950468b82$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $7e23bad950468b82$export$2077e0241d6afd3c);
var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("d9GIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $993d40d65cc118cd$export$2e2bcd8739ae039);

var $cqLtw = parcelRequire("cqLtw");
function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cqLtw.default)());
}

});
parcelRegister("cqLtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $90ccbd5892233dd2$export$2e2bcd8739ae039);
function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});




parcelRegister("ioj8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $d63950b756706495$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");
function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $iG0HL.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ecwzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a56b734280245ffb$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");

var $6NwRo = parcelRequire("6NwRo");

var $5Edas = parcelRequire("5Edas");

var $iG0HL = parcelRequire("iG0HL");

var $8WsnW = parcelRequire("8WsnW");

var $23yvR = parcelRequire("23yvR");

var $cqLtw = parcelRequire("cqLtw");
function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $iG0HL.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5Edas.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cqLtw.default)());
    var isIE = /Trident/i.test((0, $cqLtw.default)());
    if (isIE && (0, $iG0HL.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5Edas.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $23yvR.default)(element);
    if ((0, $iG0HL.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $iG0HL.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $6NwRo.default)(currentNode)) < 0){
        var css = (0, $5Edas.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $jc5j7.default)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $8WsnW.default)(offsetParent) && (0, $5Edas.default)(offsetParent).position === "static")offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6NwRo.default)(offsetParent) === "html" || (0, $6NwRo.default)(offsetParent) === "body" && (0, $5Edas.default)(offsetParent).position === "static")) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}

});
parcelRegister("5Edas", function(module, exports) {

$parcel$export(module.exports, "default", () => $41cae7042543c5d5$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $jc5j7.default)(element).getComputedStyle(element);
}

});

parcelRegister("8WsnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6829c22fb01dde5a$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");
function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $6NwRo.default)(element)) >= 0;
}

});

parcelRegister("23yvR", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f6a21d28fc02f5$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");

var $5LRDP = parcelRequire("5LRDP");

var $iG0HL = parcelRequire("iG0HL");
function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $6NwRo.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $iG0HL.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $5LRDP.default)(element) // fallback
    );
}

});
parcelRegister("5LRDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $433af39bc2fae35d$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");
function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $iG0HL.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("fxYmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b518c35b71cf930f$export$2e2bcd8739ae039);
function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});

parcelRegister("fHMKD", function(module, exports) {

$parcel$export(module.exports, "within", () => $b6f0b0266e764faa$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $b6f0b0266e764faa$export$86c8af6d3ef0b4a);

var $aPr9y = parcelRequire("aPr9y");
function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $aPr9y.max)(min, (0, $aPr9y.min)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("4QECX", function(module, exports) {

$parcel$export(module.exports, "default", () => $387b887da02b7e69$export$2e2bcd8739ae039);

var $8WQnk = parcelRequire("8WQnk");
function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8WQnk.default)(), paddingObject);
}

});
parcelRegister("8WQnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $683c5e26d5f8bfe5$export$2e2bcd8739ae039);
function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("6CeE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d11a6decde23bf9$export$2e2bcd8739ae039);
function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("hfLNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f8eadcf7685dc5$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $ecwzm = parcelRequire("ecwzm");

var $jc5j7 = parcelRequire("jc5j7");

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $f6ekA = parcelRequire("f6ekA");

var $ayUxD = parcelRequire("ayUxD");

var $aPr9y = parcelRequire("aPr9y");
var $c8f8eadcf7685dc5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $aPr9y.round)(x * dpr) / dpr || 0,
        y: (0, $aPr9y.round)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $l6ej2.left);
    var sideY = (0, $l6ej2.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $ecwzm.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $jc5j7.default)(popper)) {
            offsetParent = (0, $5LRDP.default)(popper);
            if ((0, $5Edas.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $l6ej2.top) || (placement === (0, $l6ej2.left) || placement === (0, $l6ej2.right)) && variation === (0, $l6ej2.end)) {
            sideY = (0, $l6ej2.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $l6ej2.left) || (placement === (0, $l6ej2.top) || placement === (0, $l6ej2.bottom)) && variation === (0, $l6ej2.end)) {
            sideX = (0, $l6ej2.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $jc5j7.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f6ekA.default)(state.placement),
        variation: (0, $ayUxD.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};

});
parcelRegister("ayUxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b08f0526e425773$export$2e2bcd8739ae039);
function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});


parcelRegister("lUt2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff355aafd082b0cd$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $jc5j7.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};

});

parcelRegister("fhdOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1f32a1d9525a032$export$2e2bcd8739ae039);

var $bbSog = parcelRequire("bbSog");

var $f6ekA = parcelRequire("f6ekA");

var $ac6AR = parcelRequire("ac6AR");

var $leSQw = parcelRequire("leSQw");

var $iScBU = parcelRequire("iScBU");

var $l6ej2 = parcelRequire("l6ej2");

var $ayUxD = parcelRequire("ayUxD");
function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f6ekA.default)(placement) === (0, $l6ej2.auto)) return [];
    var oppositePlacement = (0, $bbSog.default)(placement);
    return [
        (0, $ac6AR.default)(placement),
        oppositePlacement,
        (0, $ac6AR.default)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f6ekA.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $bbSog.default)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f6ekA.default)(placement) === (0, $l6ej2.auto) ? (0, $iScBU.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f6ekA.default)(placement);
        var isStartVariation = (0, $ayUxD.default)(placement) === (0, $l6ej2.start);
        var isVertical = [
            (0, $l6ej2.top),
            (0, $l6ej2.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $leSQw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $l6ej2.right) : (0, $l6ej2.left) : isStartVariation ? (0, $l6ej2.bottom) : (0, $l6ej2.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $bbSog.default)(mainVariationSide);
        var altVariationSide = (0, $bbSog.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("bbSog", function(module, exports) {

$parcel$export(module.exports, "default", () => $825ae98fe4f5d029$export$2e2bcd8739ae039);
var $825ae98fe4f5d029$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}

});

parcelRegister("ac6AR", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c023b5f4bd6339$export$2e2bcd8739ae039);
var $76c023b5f4bd6339$var$hash = {
    start: "end",
    end: "start"
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}

});

parcelRegister("leSQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f765731200b57f98$export$2e2bcd8739ae039);

var $8vjqA = parcelRequire("8vjqA");

var $5LRDP = parcelRequire("5LRDP");

var $bkFj6 = parcelRequire("bkFj6");

var $kcANe = parcelRequire("kcANe");

var $fbi7z = parcelRequire("fbi7z");

var $l6ej2 = parcelRequire("l6ej2");

var $iG0HL = parcelRequire("iG0HL");

var $4QECX = parcelRequire("4QECX");

var $6CeE3 = parcelRequire("6CeE3");
function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $l6ej2.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $l6ej2.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $l6ej2.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4QECX.default)(typeof padding !== "number" ? padding : (0, $6CeE3.default)(padding, (0, $l6ej2.basePlacements)));
    var altContext = elementContext === (0, $l6ej2.popper) ? (0, $l6ej2.reference) : (0, $l6ej2.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $8vjqA.default)((0, $iG0HL.isElement)(element) ? element : element.contextElement || (0, $5LRDP.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bkFj6.default)(state.elements.reference);
    var popperOffsets = (0, $kcANe.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $fbi7z.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $l6ej2.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $l6ej2.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $l6ej2.right),
                (0, $l6ej2.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $l6ej2.top),
                (0, $l6ej2.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("8vjqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $631049efb60e96c6$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $ayVYt = parcelRequire("ayVYt");

var $5mmoF = parcelRequire("5mmoF");

var $egjGe = parcelRequire("egjGe");

var $ecwzm = parcelRequire("ecwzm");

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $iG0HL = parcelRequire("iG0HL");

var $bkFj6 = parcelRequire("bkFj6");

var $23yvR = parcelRequire("23yvR");

var $ioj8K = parcelRequire("ioj8K");

var $6NwRo = parcelRequire("6NwRo");

var $fbi7z = parcelRequire("fbi7z");

var $aPr9y = parcelRequire("aPr9y");
function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bkFj6.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $l6ej2.viewport) ? (0, $fbi7z.default)((0, $ayVYt.default)(element, strategy)) : (0, $iG0HL.isElement)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $fbi7z.default)((0, $5mmoF.default)((0, $5LRDP.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $egjGe.default)((0, $23yvR.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $5Edas.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $iG0HL.isHTMLElement)(element) ? (0, $ecwzm.default)(element) : element;
    if (!(0, $iG0HL.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $iG0HL.isElement)(clippingParent) && (0, $ioj8K.default)(clippingParent, clipperElement) && (0, $6NwRo.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $aPr9y.max)(rect.top, accRect.top);
        accRect.right = (0, $aPr9y.min)(rect.right, accRect.right);
        accRect.bottom = (0, $aPr9y.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $aPr9y.max)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("ayVYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0a0ce1fa68929f$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");

var $5LRDP = parcelRequire("5LRDP");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $d9GIF = parcelRequire("d9GIF");
function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $jc5j7.default)(element);
    var html = (0, $5LRDP.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d9GIF.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $cJ1Bs.default)(element),
        y: y
    };
}

});
parcelRegister("cJ1Bs", function(module, exports) {

$parcel$export(module.exports, "default", () => $943aee5c7065ad53$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");

var $5LRDP = parcelRequire("5LRDP");

var $8Z1VN = parcelRequire("8Z1VN");
function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bkFj6.default)((0, $5LRDP.default)(element)).left + (0, $8Z1VN.default)(element).scrollLeft;
}

});
parcelRegister("8Z1VN", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a584be1dc90596$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $jc5j7.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("5mmoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e70615fb3e74824$export$2e2bcd8739ae039);

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $8Z1VN = parcelRequire("8Z1VN");

var $aPr9y = parcelRequire("aPr9y");
function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $5LRDP.default)(element);
    var winScroll = (0, $8Z1VN.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $aPr9y.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $aPr9y.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $cJ1Bs.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5Edas.default)(body || html).direction === "rtl") x += (0, $aPr9y.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("egjGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a621d360f1a81b88$export$2e2bcd8739ae039);

var $5nNqk = parcelRequire("5nNqk");

var $23yvR = parcelRequire("23yvR");

var $jc5j7 = parcelRequire("jc5j7");

var $25Alw = parcelRequire("25Alw");
function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $5nNqk.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $jc5j7.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $25Alw.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $23yvR.default)(target)));
}

});
parcelRegister("5nNqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb5703c925e0e5d$export$2e2bcd8739ae039);

var $23yvR = parcelRequire("23yvR");

var $25Alw = parcelRequire("25Alw");

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");
function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $6NwRo.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $iG0HL.isHTMLElement)(node) && (0, $25Alw.default)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $23yvR.default)(node));
}

});
parcelRegister("25Alw", function(module, exports) {

$parcel$export(module.exports, "default", () => $18583dfdff147fd4$export$2e2bcd8739ae039);

var $5Edas = parcelRequire("5Edas");
function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5Edas.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("fbi7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d5f0927fb8bf5c$export$2e2bcd8739ae039);
function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("kcANe", function(module, exports) {

$parcel$export(module.exports, "default", () => $03cba2f7a1498b5f$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $ayUxD = parcelRequire("ayUxD");

var $fxYmH = parcelRequire("fxYmH");

var $l6ej2 = parcelRequire("l6ej2");
function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f6ekA.default)(placement) : null;
    var variation = placement ? (0, $ayUxD.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $l6ej2.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $l6ej2.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $l6ej2.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $l6ej2.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $fxYmH.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $l6ej2.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $l6ej2.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("iScBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd70d4ba9902caa$export$2e2bcd8739ae039);

var $ayUxD = parcelRequire("ayUxD");

var $l6ej2 = parcelRequire("l6ej2");

var $leSQw = parcelRequire("leSQw");

var $f6ekA = parcelRequire("f6ekA");
function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $l6ej2.placements) : _options$allowedAutoP;
    var variation = (0, $ayUxD.default)(placement);
    var placements = variation ? flipVariations ? (0, $l6ej2.variationPlacements) : (0, $l6ej2.variationPlacements).filter(function(placement) {
        return (0, $ayUxD.default)(placement) === variation;
    }) : (0, $l6ej2.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $leSQw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f6ekA.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("201VR", function(module, exports) {

$parcel$export(module.exports, "default", () => $174d14927bb4f43b$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $leSQw = parcelRequire("leSQw");
function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $l6ej2.top),
        (0, $l6ej2.right),
        (0, $l6ej2.bottom),
        (0, $l6ej2.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $leSQw.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $leSQw.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $174d14927bb4f43b$var$hide
};

});

parcelRegister("aE9ix", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c04da2e958a3fe8$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $l6ej2 = parcelRequire("l6ej2");
function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f6ekA.default)(placement);
    var invertDistance = [
        (0, $l6ej2.left),
        (0, $l6ej2.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $l6ej2.left),
        (0, $l6ej2.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $l6ej2.placements).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $7c04da2e958a3fe8$var$offset
};

});

parcelRegister("k1fcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92fb10df1450f31$export$2e2bcd8739ae039);

var $kcANe = parcelRequire("kcANe");
function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $kcANe.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};

});

parcelRegister("4lgpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3295dac8746ffe59$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $f6ekA = parcelRequire("f6ekA");

var $fxYmH = parcelRequire("fxYmH");

var $iByzU = parcelRequire("iByzU");

var $fHMKD = parcelRequire("fHMKD");

var $4bNP2 = parcelRequire("4bNP2");

var $ecwzm = parcelRequire("ecwzm");

var $leSQw = parcelRequire("leSQw");

var $ayUxD = parcelRequire("ayUxD");

var $8WQnk = parcelRequire("8WQnk");

var $aPr9y = parcelRequire("aPr9y");
function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $leSQw.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f6ekA.default)(state.placement);
    var variation = (0, $ayUxD.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $fxYmH.default)(basePlacement);
    var altAxis = (0, $iByzU.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $l6ej2.top) : (0, $l6ej2.left);
        var altSide = mainAxis === "y" ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $l6ej2.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $l6ej2.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $4bNP2.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $8WQnk.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $fHMKD.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $ecwzm.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $fHMKD.within)(tether ? (0, $aPr9y.min)(min, tetherMin) : min, offset, tether ? (0, $aPr9y.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $l6ej2.top) : (0, $l6ej2.left);
        var _altSide = mainAxis === "x" ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $l6ej2.top),
            (0, $l6ej2.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $fHMKD.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $fHMKD.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("iByzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8b68132b61080af$export$2e2bcd8739ae039);
function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});



parcelRegister("fqRLw", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $b3c2fd6800546b4b$export$ed5e13716264f202);
$parcel$export(module.exports, "createPopper", () => $b3c2fd6800546b4b$export$8f7491d57c8f97a9);

var $4wmXH = parcelRequire("4wmXH");

var $4bNP2 = parcelRequire("4bNP2");

var $egjGe = parcelRequire("egjGe");

var $ecwzm = parcelRequire("ecwzm");

var $10cit = parcelRequire("10cit");

var $dlaWb = parcelRequire("dlaWb");

var $657FY = parcelRequire("657FY");

var $leSQw = parcelRequire("leSQw");

var $iG0HL = parcelRequire("iG0HL");
var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $iG0HL.isElement)(reference) ? (0, $egjGe.default)(reference) : reference.contextElement ? (0, $egjGe.default)(reference.contextElement) : [],
                    popper: (0, $egjGe.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $10cit.default)((0, $657FY.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4wmXH.default)(reference, (0, $ecwzm.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $4bNP2.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlaWb.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4wmXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $34abf65a06d63352$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");

var $hlFJX = parcelRequire("hlFJX");

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $5LRDP = parcelRequire("5LRDP");

var $25Alw = parcelRequire("25Alw");

var $aPr9y = parcelRequire("aPr9y");
function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $aPr9y.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $aPr9y.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $iG0HL.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $iG0HL.isHTMLElement)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $5LRDP.default)(offsetParent);
    var rect = (0, $bkFj6.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6NwRo.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $25Alw.default)(documentElement)) scroll = (0, $hlFJX.default)(offsetParent);
        if ((0, $iG0HL.isHTMLElement)(offsetParent)) {
            offsets = (0, $bkFj6.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $cJ1Bs.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("hlFJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca14c6927ef497ac$export$2e2bcd8739ae039);

var $8Z1VN = parcelRequire("8Z1VN");

var $jc5j7 = parcelRequire("jc5j7");

var $iG0HL = parcelRequire("iG0HL");

var $crSja = parcelRequire("crSja");
function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $jc5j7.default)(node) || !(0, $iG0HL.isHTMLElement)(node)) return (0, $8Z1VN.default)(node);
    else return (0, $crSja.default)(node);
}

});
parcelRegister("crSja", function(module, exports) {

$parcel$export(module.exports, "default", () => $9102221f9e13ae54$export$2e2bcd8739ae039);
function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("10cit", function(module, exports) {

$parcel$export(module.exports, "default", () => $0baf5472b5ad4a5a$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");
function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $l6ej2.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("dlaWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b65b878009bf47f$export$2e2bcd8739ae039);
function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("657FY", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d929ffbbd3136a$export$2e2bcd8739ae039);
function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("2oJ1v", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $1bf0bf541303046d$export$8f7491d57c8f97a9);

var $fqRLw = parcelRequire("fqRLw");

var $lUt2x = parcelRequire("lUt2x");

var $k1fcs = parcelRequire("k1fcs");

var $hfLNM = parcelRequire("hfLNM");

var $bjlic = parcelRequire("bjlic");

var $aE9ix = parcelRequire("aE9ix");

var $fhdOY = parcelRequire("fhdOY");

var $4lgpD = parcelRequire("4lgpD");

var $2c83k = parcelRequire("2c83k");

var $201VR = parcelRequire("201VR");


var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $lUt2x.default),
    (0, $k1fcs.default),
    (0, $hfLNM.default),
    (0, $bjlic.default),
    (0, $aE9ix.default),
    (0, $fhdOY.default),
    (0, $4lgpD.default),
    (0, $2c83k.default),
    (0, $201VR.default)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fqRLw.popperGenerator)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("hQXXi", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $cff5cce2532d9fa1$export$8f7491d57c8f97a9);

var $fqRLw = parcelRequire("fqRLw");

var $lUt2x = parcelRequire("lUt2x");

var $k1fcs = parcelRequire("k1fcs");

var $hfLNM = parcelRequire("hfLNM");

var $bjlic = parcelRequire("bjlic");
var $cff5cce2532d9fa1$export$d34966752335dd47 = [
    (0, $lUt2x.default),
    (0, $k1fcs.default),
    (0, $hfLNM.default),
    (0, $bjlic.default)
];
var $cff5cce2532d9fa1$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fqRLw.popperGenerator)({
    defaultModifiers: $cff5cce2532d9fa1$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


parcelRegister("hzkBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca5b087693dd19a$export$2e2bcd8739ae039);
parcelRequire("6j4kq");
var $cca5b087693dd19a$var$notify = function(type, title, message) {
    $.notify({
        title: title,
        message: message
    }, {
        newest_on_top: true,
        placement: {
            from: "top",
            align: "center"
        },
        mouse_over: "pause",
        type: type,
        template: '<div data-notify="container" class="col-11 col-sm-7 alert alert-{0}" role="alert"><button type="button" aria-hidden="true" class="btn-close mt-2" data-notify="dismiss"></button><span data-notify="icon"></span> <strong data-notify="title">{1}</strong> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" class="w-0"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
    });
};
var $cca5b087693dd19a$export$2e2bcd8739ae039 = $cca5b087693dd19a$var$notify;

});
parcelRegister("6j4kq", function(module, exports) {

/*
* Project: Bootstrap Notify = v3.1.3
* Description: Turns standard Bootstrap alerts into "Growl-like" notifications.
* Author: Mouse0270 aka Robert McIntosh
* License: MIT License
* Website: https://github.com/mouse0270/bootstrap-growl
*/ (function(factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery"
    ], factory);
    else // Node/CommonJS
    factory((parcelRequire("iUSsr")));
})(function($) {
    // Create the defaults once
    var defaults = {
        element: "body",
        position: null,
        type: "info",
        allow_dismiss: true,
        newest_on_top: false,
        showProgressbar: false,
        placement: {
            from: "top",
            align: "right"
        },
        offset: 20,
        spacing: 10,
        z_index: 1031,
        delay: 5000,
        timer: 1000,
        url_target: "_blank",
        mouse_over: null,
        animate: {
            enter: "animated fadeInDown",
            exit: "animated fadeOutUp"
        },
        onShow: null,
        onShown: null,
        onClose: null,
        onClosed: null,
        icon_type: "class",
        template: '<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss">&times;</button><span data-notify="icon"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
    };
    String.format = function() {
        var str = arguments[0];
        for(var i = 1; i < arguments.length; i++)str = str.replace(RegExp("\\{" + (i - 1) + "\\}", "gm"), arguments[i]);
        return str;
    };
    function Notify(element, content, options) {
        // Setup Content of Notify
        var content = {
            content: {
                message: typeof content == "object" ? content.message : content,
                title: content.title ? content.title : "",
                icon: content.icon ? content.icon : "",
                url: content.url ? content.url : "#",
                target: content.target ? content.target : "-"
            }
        };
        options = $.extend(true, {}, content, options);
        this.settings = $.extend(true, {}, defaults, options);
        this._defaults = defaults;
        if (this.settings.content.target == "-") this.settings.content.target = this.settings.url_target;
        this.animations = {
            start: "webkitAnimationStart oanimationstart MSAnimationStart animationstart",
            end: "webkitAnimationEnd oanimationend MSAnimationEnd animationend"
        };
        if (typeof this.settings.offset == "number") this.settings.offset = {
            x: this.settings.offset,
            y: this.settings.offset
        };
        this.init();
    }
    $.extend(Notify.prototype, {
        init: function() {
            var self = this;
            this.buildNotify();
            if (this.settings.content.icon) this.setIcon();
            if (this.settings.content.url != "#") this.styleURL();
            this.styleDismiss();
            this.placement();
            this.bind();
            this.notify = {
                $ele: this.$ele,
                update: function(command, update) {
                    var commands = {};
                    if (typeof command == "string") commands[command] = update;
                    else commands = command;
                    for(var command in commands)switch(command){
                        case "type":
                            this.$ele.removeClass("alert-" + self.settings.type);
                            this.$ele.find('[data-notify="progressbar"] > .progress-bar').removeClass("progress-bar-" + self.settings.type);
                            self.settings.type = commands[command];
                            this.$ele.addClass("alert-" + commands[command]).find('[data-notify="progressbar"] > .progress-bar').addClass("progress-bar-" + commands[command]);
                            break;
                        case "icon":
                            var $icon = this.$ele.find('[data-notify="icon"]');
                            if (self.settings.icon_type.toLowerCase() == "class") $icon.removeClass(self.settings.content.icon).addClass(commands[command]);
                            else {
                                if (!$icon.is("img")) $icon.find("img");
                                $icon.attr("src", commands[command]);
                            }
                            break;
                        case "progress":
                            var newDelay = self.settings.delay - self.settings.delay * (commands[command] / 100);
                            this.$ele.data("notify-delay", newDelay);
                            this.$ele.find('[data-notify="progressbar"] > div').attr("aria-valuenow", commands[command]).css("width", commands[command] + "%");
                            break;
                        case "url":
                            this.$ele.find('[data-notify="url"]').attr("href", commands[command]);
                            break;
                        case "target":
                            this.$ele.find('[data-notify="url"]').attr("target", commands[command]);
                            break;
                        default:
                            this.$ele.find('[data-notify="' + command + '"]').html(commands[command]);
                    }
                    var posX = this.$ele.outerHeight() + parseInt(self.settings.spacing) + parseInt(self.settings.offset.y);
                    self.reposition(posX);
                },
                close: function() {
                    self.close();
                }
            };
        },
        buildNotify: function() {
            var content = this.settings.content;
            this.$ele = $(String.format(this.settings.template, this.settings.type, content.title, content.message, content.url, content.target));
            this.$ele.attr("data-notify-position", this.settings.placement.from + "-" + this.settings.placement.align);
            if (!this.settings.allow_dismiss) this.$ele.find('[data-notify="dismiss"]').css("display", "none");
            if (this.settings.delay <= 0 && !this.settings.showProgressbar || !this.settings.showProgressbar) this.$ele.find('[data-notify="progressbar"]').remove();
        },
        setIcon: function() {
            if (this.settings.icon_type.toLowerCase() == "class") this.$ele.find('[data-notify="icon"]').addClass(this.settings.content.icon);
            else if (this.$ele.find('[data-notify="icon"]').is("img")) this.$ele.find('[data-notify="icon"]').attr("src", this.settings.content.icon);
            else this.$ele.find('[data-notify="icon"]').append('<img src="' + this.settings.content.icon + '" alt="Notify Icon" />');
        },
        styleDismiss: function() {
            this.$ele.find('[data-notify="dismiss"]').css({
                position: "absolute",
                right: "10px",
                top: "5px",
                zIndex: this.settings.z_index + 2
            });
        },
        styleURL: function() {
            this.$ele.find('[data-notify="url"]').css({
                backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)",
                height: "100%",
                left: "0px",
                position: "absolute",
                top: "0px",
                width: "100%",
                zIndex: this.settings.z_index + 1
            });
        },
        placement: function() {
            var self = this, offsetAmt = this.settings.offset.y, css = {
                display: "inline-block",
                margin: "0px auto",
                position: this.settings.position ? this.settings.position : this.settings.element === "body" ? "fixed" : "absolute",
                transition: "all .5s ease-in-out",
                zIndex: this.settings.z_index
            }, hasAnimation = false, settings = this.settings;
            $('[data-notify-position="' + this.settings.placement.from + "-" + this.settings.placement.align + '"]:not([data-closing="true"])').each(function() {
                return offsetAmt = Math.max(offsetAmt, parseInt($(this).css(settings.placement.from)) + parseInt($(this).outerHeight()) + parseInt(settings.spacing));
            });
            if (this.settings.newest_on_top == true) offsetAmt = this.settings.offset.y;
            css[this.settings.placement.from] = offsetAmt + "px";
            switch(this.settings.placement.align){
                case "left":
                case "right":
                    css[this.settings.placement.align] = this.settings.offset.x + "px";
                    break;
                case "center":
                    css.left = 0;
                    css.right = 0;
                    break;
            }
            this.$ele.css(css).addClass(this.settings.animate.enter);
            $.each(Array("webkit-", "moz-", "o-", "ms-", ""), function(index, prefix) {
                self.$ele[0].style[prefix + "AnimationIterationCount"] = 1;
            });
            $(this.settings.element).append(this.$ele);
            if (this.settings.newest_on_top == true) {
                offsetAmt = parseInt(offsetAmt) + parseInt(this.settings.spacing) + this.$ele.outerHeight();
                this.reposition(offsetAmt);
            }
            if ($.isFunction(self.settings.onShow)) self.settings.onShow.call(this.$ele);
            this.$ele.one(this.animations.start, function(event) {
                hasAnimation = true;
            }).one(this.animations.end, function(event) {
                if ($.isFunction(self.settings.onShown)) self.settings.onShown.call(this);
            });
            setTimeout(function() {
                if (!hasAnimation) {
                    if ($.isFunction(self.settings.onShown)) self.settings.onShown.call(this);
                }
            }, 600);
        },
        bind: function() {
            var self = this;
            this.$ele.find('[data-notify="dismiss"]').on("click", function() {
                self.close();
            });
            this.$ele.mouseover(function(e) {
                $(this).data("data-hover", "true");
            }).mouseout(function(e) {
                $(this).data("data-hover", "false");
            });
            this.$ele.data("data-hover", "false");
            if (this.settings.delay > 0) {
                self.$ele.data("notify-delay", self.settings.delay);
                var timer = setInterval(function() {
                    var delay = parseInt(self.$ele.data("notify-delay")) - self.settings.timer;
                    if (self.$ele.data("data-hover") === "false" && self.settings.mouse_over == "pause" || self.settings.mouse_over != "pause") {
                        var percent = (self.settings.delay - delay) / self.settings.delay * 100;
                        self.$ele.data("notify-delay", delay);
                        self.$ele.find('[data-notify="progressbar"] > div').attr("aria-valuenow", percent).css("width", percent + "%");
                    }
                    if (delay <= -self.settings.timer) {
                        clearInterval(timer);
                        self.close();
                    }
                }, self.settings.timer);
            }
        },
        close: function() {
            var self = this, $successors = null, posX = parseInt(this.$ele.css(this.settings.placement.from)), hasAnimation = false;
            this.$ele.data("closing", "true").addClass(this.settings.animate.exit);
            self.reposition(posX);
            if ($.isFunction(self.settings.onClose)) self.settings.onClose.call(this.$ele);
            this.$ele.one(this.animations.start, function(event) {
                hasAnimation = true;
            }).one(this.animations.end, function(event) {
                $(this).remove();
                if ($.isFunction(self.settings.onClosed)) self.settings.onClosed.call(this);
            });
            setTimeout(function() {
                if (!hasAnimation) {
                    self.$ele.remove();
                    if (self.settings.onClosed) self.settings.onClosed(self.$ele);
                }
            }, 600);
        },
        reposition: function(posX) {
            var self = this, notifies = '[data-notify-position="' + this.settings.placement.from + "-" + this.settings.placement.align + '"]:not([data-closing="true"])', $elements = this.$ele.nextAll(notifies);
            if (this.settings.newest_on_top == true) $elements = this.$ele.prevAll(notifies);
            $elements.each(function() {
                $(this).css(self.settings.placement.from, posX);
                posX = parseInt(posX) + parseInt(self.settings.spacing) + $(this).outerHeight();
            });
        }
    });
    $.notify = function(content, options) {
        var plugin = new Notify(this, content, options);
        return plugin.notify;
    };
    $.notifyDefaults = function(options) {
        defaults = $.extend(true, {}, defaults, options);
        return defaults;
    };
    $.notifyClose = function(command) {
        if (typeof command === "undefined" || command == "all") $("[data-notify]").find('[data-notify="dismiss"]').trigger("click");
        else $('[data-notify-position="' + command + '"]').find('[data-notify="dismiss"]').trigger("click");
    };
});

});


parcelRegister("JSMaE", function(module, exports) {

$parcel$export(module.exports, "default", () => $089eb17244b6b9e7$export$2e2bcd8739ae039);

var $13AFs = parcelRequire("13AFs");
var $089eb17244b6b9e7$var$formatters = {
    /**
   * CleanString2CorrectNumber formatter
   *
   * Maakt een string schoon en geeft een string terug met daarin een getal met twee decimalen met een punt als separator
   *
   * @param {string} value
   * @returns {string}
   */ cleanString2CorrectNumber: function(value) {
        if (typeof value !== "undefined" && value !== null) {
            value = value.toString();
            value = value.replace(/\,/g, "."); // Vervang alle komma's voor een punt
            value = value.replace(/[^0-9.]/g, ""); // Verwijder alles behalve cijfers en punten
            var last = value.lastIndexOf("."); // Verkrijg de positie van de laatste punt
            var butLast = value.substring(0, last).replace(/\./g, ""); // Verwijder alle punten uit het deel van de string voor de komma
            if (butLast !== "") value = butLast + value.substring(last, last + 3); // Plak deel voor en na de komma weer aan elkaar
            else value = butLast + value.substring(last); // Plak deel voor en na de komma weer aan elkaar
        } else value = "";
        return value;
    },
    /**
   * CleanNaN formatter
   *
   * Geeft een lege string terug als de string 'NaN' is
   *
   * @param {string} value
   * @returns {string}
   */ cleanNaN: function(value) {
        if (value.indexOf("NaN") > -1) value = "";
        return value;
    },
    /**
   * Sanitizer
   *
   * Sanitize een string
   *
   * @param {string} value
   * @returns {string}
   */ sanitizeString: function(value) {
        var replaceArray = [
            [
                "get ",
                "get. "
            ],
            [
                "&",
                " en "
            ],
            [
                "\u20AC",
                "EUR"
            ],
            [
                "  ",
                " "
            ]
        ];
        replaceArray.forEach(function(item) {
            value = value.replace(item[0], item[1]);
        });
        return value;
    },
    /**
   * Commatodot formatter
   *
   * @param {string} value
   * @returns {string}
   */ commaToDot: function(value) {
        value = value.replace(/\,/g, ".");
        return value;
    },
    /**
   * Currency base formatter
   *
   * @param {string} value
   * @returns {string}
   */ currencyBase: function(value, separator, symbol, decimal) {
        value = value || "";
        value = value.toString();
        value = value.trim();
        var outputValue = value;
        outputValue = $089eb17244b6b9e7$var$formatters.cleanString2CorrectNumber(outputValue);
        outputValue = outputValue.replace(".", ",");
        outputValue = (0, (/*@__PURE__*/$parcel$interopDefault($13AFs)))(outputValue, {
            decimal: decimal,
            separator: separator,
            symbol: symbol
        });
        outputValue = outputValue.format();
        outputValue = $089eb17244b6b9e7$var$formatters.cleanNaN(outputValue);
        if ("" !== outputValue && "-" === value.charAt(0)) outputValue = "-" + outputValue;
        return outputValue;
    },
    /**
   * Currency formatter
   *
   * @param {string} value
   * @returns {string}
   */ currency: function(value) {
        value = $089eb17244b6b9e7$var$formatters.currencyBase(value, ".", "", ",");
        return value;
    },
    /**
   * Currency formatter with no separator
   *
   * @param {string} value
   * @returns {string}
   */ currencyNoSeparator: function(value) {
        value = $089eb17244b6b9e7$var$formatters.currencyBase(value, "", "", ",");
        return value;
    },
    /**
   * Currency with euro sign formatter
   *
   * @param {string} value
   * @returns {string}
   */ currencyEuroSign: function(value) {
        value = $089eb17244b6b9e7$var$formatters.currencyBase(value, ".", "\u20AC ", ",");
        return value;
    },
    /**
   * Dottocomma formatter
   *
   * @param {string} value
   * @returns {string}
   */ dotToComma: function(value) {
        value = value.replace(".", ",");
        return value;
    },
    /**
   * Lowercase formatter
   *
   * @param {string} value
   * @returns {string}
   */ lowerCase: function(value) {
        value = value.toLowerCase();
        return value;
    },
    /**
   * Nulltoemptystring formatter
   *
   * @param {string} value
   * @returns {string}
   */ nullToEmptyString: function(value) {
        if (value == null) value = "";
        return value;
    },
    /**
   * Percentage formatter
   *
   * @param {string} value
   * @returns {string}
   */ percentage: function(value) {
        value = value.toString();
        value = $089eb17244b6b9e7$var$formatters.dotToComma(value);
        return value;
    },
    /**
   * Percentage with two decimals formatter
   *
   * @param {string} value
   * @returns {string}
   */ percentageTwoDecimalsMax100: function(value) {
        if (value != null) {
            if (value.indexOf("-") > -1) value = 0;
            value = $089eb17244b6b9e7$var$formatters.cleanString2CorrectNumber(value);
            if (parseFloat(value) > 100) value = 100;
            else if (parseFloat(value) < 0) value = 0;
            value = $089eb17244b6b9e7$var$formatters.dotToComma(value.toString());
        }
        return value;
    },
    /**
   * Removespaces formatter
   *
   * @param {string} value
   * @returns {string}
   */ removeSpaces: function(value) {
        value = value.replace(/\s/g, "");
        return value;
    },
    /**
   * Spacetounderscore formatter
   *
   * @param {string} value
   * @returns {string}
   */ spaceToUnderscore: function(value) {
        value = value.replace(" ", "_");
        return value;
    },
    /**
   * Uppercase formatter
   *
   * @param {string} value
   * @returns {string}
   */ upperCase: function(value) {
        value = value.toUpperCase();
        return value;
    },
    /**
   * Uppercasefirst formatter
   *
   * @param {string} value
   * @returns {string}
   */ upperCaseFirst: function(value) {
        value = value.charAt(0).toUpperCase() + value.slice(1);
        return value;
    }
};
var $089eb17244b6b9e7$export$2e2bcd8739ae039 = $089eb17244b6b9e7$var$formatters;

});
parcelRegister("13AFs", function(module, exports) {
/*
 currency.js - v2.0.4
 http://scurker.github.io/currency.js

 Copyright (c) 2021 Jason Wilson
 Released under MIT license
*/ (function(e, g) {
    module.exports = g();
})(module.exports, function() {
    function e(b, a) {
        if (!(this instanceof e)) return new e(b, a);
        a = Object.assign({}, m, a);
        var d = Math.pow(10, a.precision);
        this.intValue = b = g(b, a);
        this.value = b / d;
        a.increment = a.increment || 1 / d;
        a.groups = a.useVedic ? n : p;
        this.s = a;
        this.p = d;
    }
    function g(b, a) {
        var d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : !0;
        var c = a.decimal;
        var h = a.errorOnInvalid, k = a.fromCents, l = Math.pow(10, a.precision), f = b instanceof e;
        if (f && k) return b.intValue;
        if ("number" === typeof b || f) c = f ? b.value : b;
        else if ("string" === typeof b) h = new RegExp("[^-\\d" + c + "]", "g"), c = new RegExp("\\" + c, "g"), c = (c = b.replace(/\((.*)\)/, "-$1").replace(h, "").replace(c, ".")) || 0;
        else {
            if (h) throw Error("Invalid Input");
            c = 0;
        }
        k || (c = (c * l).toFixed(4));
        return d ? Math.round(c) : c;
    }
    var m = {
        symbol: "$",
        separator: ",",
        decimal: ".",
        errorOnInvalid: !1,
        precision: 2,
        pattern: "!#",
        negativePattern: "-!#",
        format: function(b, a) {
            var d = a.pattern, c = a.negativePattern, h = a.symbol, k = a.separator, l = a.decimal;
            a = a.groups;
            var f = ("" + b).replace(/^-/, "").split("."), q = f[0];
            f = f[1];
            return (0 <= b.value ? d : c).replace("!", h).replace("#", q.replace(a, "$1" + k) + (f ? l + f : ""));
        },
        fromCents: !1
    }, p = /(\d)(?=(\d{3})+\b)/g, n = /(\d)(?=(\d\d)+\d\b)/g;
    e.prototype = {
        add: function(b) {
            var a = this.s, d = this.p;
            return e((this.intValue + g(b, a)) / (a.fromCents ? 1 : d), a);
        },
        subtract: function(b) {
            var a = this.s, d = this.p;
            return e((this.intValue - g(b, a)) / (a.fromCents ? 1 : d), a);
        },
        multiply: function(b) {
            var a = this.s;
            return e(this.intValue * b / (a.fromCents ? 1 : Math.pow(10, a.precision)), a);
        },
        divide: function(b) {
            var a = this.s;
            return e(this.intValue / g(b, a, !1), a);
        },
        distribute: function(b) {
            var a = this.intValue, d = this.p, c = this.s, h = [], k = Math[0 <= a ? "floor" : "ceil"](a / b), l = Math.abs(a - k * b);
            for(d = c.fromCents ? 1 : d; 0 !== b; b--){
                var f = e(k / d, c);
                0 < l-- && (f = f[0 <= a ? "add" : "subtract"](1 / d));
                h.push(f);
            }
            return h;
        },
        dollars: function() {
            return ~~this.value;
        },
        cents: function() {
            return ~~(this.intValue % this.p);
        },
        format: function(b) {
            var a = this.s;
            return "function" === typeof b ? b(this, a) : a.format(this, Object.assign({}, a, b));
        },
        toString: function() {
            var b = this.s, a = b.increment;
            return (Math.round(this.intValue / this.p / a) * a).toFixed(b.precision);
        },
        toJSON: function() {
            return this.value;
        }
    };
    return e;
});

});


parcelRegister("av3Vx", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("8R3xZ")).then(()=>parcelRequire("fvpAO"));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case "preload":
            return $55a6d16921f8ab25$var$cachedPreloads;
        case "prefetch":
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("heTgs", function(module, exports) {




/*!
  * Bootstrap base-component.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("k3cvB")), (parcelRequire("1GheJ")), (parcelRequire("c0HzZ")), (parcelRequire("94df5")));
})(module.exports, function(Data, EventHandler, Config, index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const VERSION = "5.3.3";
    /**
   * Class definition
   */ class BaseComponent extends Config {
        constructor(element, config){
            super();
            element = index_js.getElement(element);
            if (!element) return;
            this._element = element;
            this._config = this._getConfig(config);
            Data.set(this._element, this.constructor.DATA_KEY, this);
        }
        // Public
        dispose() {
            Data.remove(this._element, this.constructor.DATA_KEY);
            EventHandler.off(this._element, this.constructor.EVENT_KEY);
            for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
        }
        _queueCallback(callback, element, isAnimated = true) {
            index_js.executeAfterTransition(callback, element, isAnimated);
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config, this._element);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        // Static
        static getInstance(element) {
            return Data.get(index_js.getElement(element), this.DATA_KEY);
        }
        static getOrCreateInstance(element, config = {}) {
            return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
        }
        static get VERSION() {
            return VERSION;
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
        static eventName(name) {
            return `${name}${this.EVENT_KEY}`;
        }
    }
    return BaseComponent;
});

});
parcelRegister("k3cvB", function(module, exports) {
/*!
  * Bootstrap data.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const elementMap = new Map();
    const data = {
        set (element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            const instanceMap = elementMap.get(element);
            // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
                return;
            }
            instanceMap.set(key, instance);
        },
        get (element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove (element, key) {
            if (!elementMap.has(element)) return;
            const instanceMap = elementMap.get(element);
            instanceMap.delete(key);
            // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    return data;
});

});

parcelRegister("1GheJ", function(module, exports) {

/*!
  * Bootstrap event-handler.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("94df5")));
})(module.exports, function(index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    const stripNameRegex = /\..*/;
    const stripUidRegex = /::\d+$/;
    const eventRegistry = {}; // Events storage
    let uidEvent = 1;
    const customEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
    const nativeEvents = new Set([
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ]);
    /**
   * Private methods
   */ function makeEventUid(element, uid) {
        return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
    }
    function getElementEvents(element) {
        const uid = makeEventUid(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
        return function handler(event) {
            hydrateObj(event, {
                delegateTarget: element
            });
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            const domElements = element.querySelectorAll(selector);
            for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
                if (domElement !== target) continue;
                hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        };
    }
    function findHandler(events, callable, delegationSelector = null) {
        return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
    }
    function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
        const isDelegated = typeof handler === "string";
        // TODO: tooltip passes `false` instead of selector, so we need to check
        const callable = isDelegated ? delegationFunction : handler || delegationFunction;
        let typeEvent = getTypeEvent(originalTypeEvent);
        if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
        return [
            isDelegated,
            callable,
            typeEvent
        ];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        let [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
        // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (originalTypeEvent in customEvents) {
            const wrapFunction = (fn)=>{
                return function(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            callable = wrapFunction(callable);
        }
        const events = getElementEvents(element);
        const handlers = events[typeEvent] || (events[typeEvent] = {});
        const previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
        if (previousFunction) {
            previousFunction.oneOff = previousFunction.oneOff && oneOff;
            return;
        }
        const uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ""));
        const fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
        fn.delegationSelector = isDelegated ? handler : null;
        fn.callable = callable;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, isDelegated);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        const fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        const storeElementEvent = events[typeEvent] || {};
        for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
    }
    function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, "");
        return customEvents[event] || event;
    }
    const EventHandler = {
        on (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, false);
        },
        one (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, true);
        },
        off (element, originalTypeEvent, handler, delegationFunction) {
            if (typeof originalTypeEvent !== "string" || !element) return;
            const [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
            const inNamespace = typeEvent !== originalTypeEvent;
            const events = getElementEvents(element);
            const storeElementEvent = events[typeEvent] || {};
            const isNamespace = originalTypeEvent.startsWith(".");
            if (typeof callable !== "undefined") {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!Object.keys(storeElementEvent).length) return;
                removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
                return;
            }
            if (isNamespace) for (const elementEvent of Object.keys(events))removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
                const handlerKey = keyHandlers.replace(stripUidRegex, "");
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        },
        trigger (element, event, args) {
            if (typeof event !== "string" || !element) return null;
            const $ = index_js.getjQuery();
            const typeEvent = getTypeEvent(event);
            const inNamespace = event !== typeEvent;
            let jQueryEvent = null;
            let bubbles = true;
            let nativeDispatch = true;
            let defaultPrevented = false;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            const evt = hydrateObj(new Event(event, {
                bubbles: bubbles,
                cancelable: true
            }), args);
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
            return evt;
        }
    };
    function hydrateObj(obj, meta = {}) {
        for (const [key, value] of Object.entries(meta))try {
            obj[key] = value;
        } catch (_unused) {
            Object.defineProperty(obj, key, {
                configurable: true,
                get () {
                    return value;
                }
            });
        }
        return obj;
    }
    return EventHandler;
});

});
parcelRegister("94df5", function(module, exports) {
/*!
  * Bootstrap index.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const MAX_UID = 1000000;
    const MILLISECONDS_MULTIPLIER = 1000;
    const TRANSITION_END = "transitionend";
    /**
   * Properly escape IDs selectors to handle weird IDs
   * @param {string} selector
   * @returns {string}
   */ const parseSelector = (selector)=>{
        if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
        selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
        return selector;
    };
    // Shout-out Angus Croll (https://goo.gl/pxwQGp)
    const toType = (object)=>{
        if (object === null || object === undefined) return `${object}`;
        return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    /**
   * Public Util API
   */ const getUID = (prefix)=>{
        do prefix += Math.floor(Math.random() * MAX_UID);
        while (document.getElementById(prefix));
        return prefix;
    };
    const getTransitionDurationFromElement = (element)=>{
        if (!element) return 0;
        // Get transition-duration of the element
        let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
        const floatTransitionDuration = Number.parseFloat(transitionDuration);
        const floatTransitionDelay = Number.parseFloat(transitionDelay);
        // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
        // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(",")[0];
        transitionDelay = transitionDelay.split(",")[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    const triggerTransitionEnd = (element)=>{
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    const isElement = (object)=>{
        if (!object || typeof object !== "object") return false;
        if (typeof object.jquery !== "undefined") object = object[0];
        return typeof object.nodeType !== "undefined";
    };
    const getElement = (object)=>{
        // it's a jQuery object or a node element
        if (isElement(object)) return object.jquery ? object[0] : object;
        if (typeof object === "string" && object.length > 0) return document.querySelector(parseSelector(object));
        return null;
    };
    const isVisible = (element)=>{
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
        // Handle `details` element as its content may falsie appear visible when it is closed
        const closedDetails = element.closest("details:not([open])");
        if (!closedDetails) return elementIsVisible;
        if (closedDetails !== element) {
            const summary = element.closest("summary");
            if (summary && summary.parentNode !== closedDetails) return false;
            if (summary === null) return false;
        }
        return elementIsVisible;
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    const findShadowRoot = (element)=>{
        if (!document.documentElement.attachShadow) return null;
        // Can find the shadow root otherwise it'll return the document
        if (typeof element.getRootNode === "function") {
            const root = element.getRootNode();
            return root instanceof ShadowRoot ? root : null;
        }
        if (element instanceof ShadowRoot) return element;
        // when we don't find a shadow root
        if (!element.parentNode) return null;
        return findShadowRoot(element.parentNode);
    };
    const noop = ()=>{};
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        element.offsetHeight; // eslint-disable-line no-unused-expressions
    };
    const getjQuery = ()=>{
        if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                for (const callback of DOMContentLoadedCallbacks)callback();
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const isRTL = ()=>document.documentElement.dir === "rtl";
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    const execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
        return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
    };
    const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        const durationPadding = 5;
        const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        let called = false;
        const handler = ({ target: target })=>{
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(()=>{
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
        const listLength = list.length;
        let index = list.indexOf(activeElement);
        // if the element does not exist in the list return an element
        // depending on the direction and if cycle is allowed
        if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    exports1.defineJQueryPlugin = defineJQueryPlugin;
    exports1.execute = execute;
    exports1.executeAfterTransition = executeAfterTransition;
    exports1.findShadowRoot = findShadowRoot;
    exports1.getElement = getElement;
    exports1.getNextActiveElement = getNextActiveElement;
    exports1.getTransitionDurationFromElement = getTransitionDurationFromElement;
    exports1.getUID = getUID;
    exports1.getjQuery = getjQuery;
    exports1.isDisabled = isDisabled;
    exports1.isElement = isElement;
    exports1.isRTL = isRTL;
    exports1.isVisible = isVisible;
    exports1.noop = noop;
    exports1.onDOMContentLoaded = onDOMContentLoaded;
    exports1.parseSelector = parseSelector;
    exports1.reflow = reflow;
    exports1.toType = toType;
    exports1.triggerTransitionEnd = triggerTransitionEnd;
    Object.defineProperty(exports1, Symbol.toStringTag, {
        value: "Module"
    });
});

});


parcelRegister("c0HzZ", function(module, exports) {


/*!
  * Bootstrap config.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("kRRoH")), (parcelRequire("94df5")));
})(module.exports, function(Manipulator, index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/config.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Class definition
   */ class Config {
        // Getters
        static get Default() {
            return {};
        }
        static get DefaultType() {
            return {};
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            return config;
        }
        _mergeConfigObj(config, element) {
            const jsonConfig = index_js.isElement(element) ? Manipulator.getDataAttribute(element, "config") : {}; // try to parse
            return {
                ...this.constructor.Default,
                ...typeof jsonConfig === "object" ? jsonConfig : {},
                ...index_js.isElement(element) ? Manipulator.getDataAttributes(element) : {},
                ...typeof config === "object" ? config : {}
            };
        }
        _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
            for (const [property, expectedTypes] of Object.entries(configTypes)){
                const value = config[property];
                const valueType = index_js.isElement(value) ? "element" : index_js.toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
            }
        }
    }
    return Config;
});

});
parcelRegister("kRRoH", function(module, exports) {
/*!
  * Bootstrap manipulator.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(value) {
        if (value === "true") return true;
        if (value === "false") return false;
        if (value === Number(value).toString()) return Number(value);
        if (value === "" || value === "null") return null;
        if (typeof value !== "string") return value;
        try {
            return JSON.parse(decodeURIComponent(value));
        } catch (_unused) {
            return value;
        }
    }
    function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
    }
    const Manipulator = {
        setDataAttribute (element, key, value) {
            element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
        },
        removeDataAttribute (element, key) {
            element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
        },
        getDataAttributes (element) {
            if (!element) return {};
            const attributes = {};
            const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
            for (const key of bsKeys){
                let pureKey = key.replace(/^bs/, "");
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                attributes[pureKey] = normalizeData(element.dataset[key]);
            }
            return attributes;
        },
        getDataAttribute (element, key) {
            return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
        }
    };
    return Manipulator;
});

});



parcelRegister("16soP", function(module, exports) {
/*!
  * Bootstrap sanitizer.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ // js-docs-start allow-list
    const ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    const DefaultAllowlist = {
        // Global attributes allowed on any supplied element below.
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    // js-docs-end allow-list
    const uriAttributes = new Set([
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ]);
    /**
   * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
   * contexts.
   *
   * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
   */ // eslint-disable-next-line unicorn/better-regex
    const SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
    const allowedAttribute = (attribute, allowedAttributeList)=>{
        const attributeName = attribute.nodeName.toLowerCase();
        if (allowedAttributeList.includes(attributeName)) {
            if (uriAttributes.has(attributeName)) return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue));
            return true;
        }
        // Check if a regular expression validates the attribute.
        return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
    };
    function sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
        if (!unsafeHtml.length) return unsafeHtml;
        if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
        const domParser = new window.DOMParser();
        const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
        const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
        for (const element of elements){
            const elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            const attributeList = [].concat(...element.attributes);
            const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
            for (const attribute of attributeList)if (!allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
        }
        return createdDocument.body.innerHTML;
    }
    exports1.DefaultAllowlist = DefaultAllowlist;
    exports1.sanitizeHtml = sanitizeHtml;
    Object.defineProperty(exports1, Symbol.toStringTag, {
        value: "Module"
    });
});

});

parcelRegister("2VzTm", function(module, exports) {




/*!
  * Bootstrap template-factory.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("lNr3n")), (parcelRequire("c0HzZ")), (parcelRequire("16soP")), (parcelRequire("94df5")));
})(module.exports, function(SelectorEngine, Config, sanitizer_js, index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/template-factory.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = "TemplateFactory";
    const Default = {
        allowList: sanitizer_js.DefaultAllowlist,
        content: {},
        // { selector : text ,  selector2 : text2 , }
        extraClass: "",
        html: false,
        sanitize: true,
        sanitizeFn: null,
        template: "<div></div>"
    };
    const DefaultType = {
        allowList: "object",
        content: "object",
        extraClass: "(string|function)",
        html: "boolean",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        template: "string"
    };
    const DefaultContentType = {
        entry: "(string|element|function|null)",
        selector: "(string|element)"
    };
    /**
   * Class definition
   */ class TemplateFactory extends Config {
        constructor(config){
            super();
            this._config = this._getConfig(config);
        }
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        getContent() {
            return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
        }
        hasContent() {
            return this.getContent().length > 0;
        }
        changeContent(content) {
            this._checkContent(content);
            this._config.content = {
                ...this._config.content,
                ...content
            };
            return this;
        }
        toHtml() {
            const templateWrapper = document.createElement("div");
            templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
            for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
            const template = templateWrapper.children[0];
            const extraClass = this._resolvePossibleFunction(this._config.extraClass);
            if (extraClass) template.classList.add(...extraClass.split(" "));
            return template;
        }
        // Private
        _typeCheckConfig(config) {
            super._typeCheckConfig(config);
            this._checkContent(config.content);
        }
        _checkContent(arg) {
            for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
                selector: selector,
                entry: content
            }, DefaultContentType);
        }
        _setContent(template, content, selector) {
            const templateElement = SelectorEngine.findOne(selector, template);
            if (!templateElement) return;
            content = this._resolvePossibleFunction(content);
            if (!content) {
                templateElement.remove();
                return;
            }
            if (index_js.isElement(content)) {
                this._putElementInTemplate(index_js.getElement(content), templateElement);
                return;
            }
            if (this._config.html) {
                templateElement.innerHTML = this._maybeSanitize(content);
                return;
            }
            templateElement.textContent = content;
        }
        _maybeSanitize(arg) {
            return this._config.sanitize ? sanitizer_js.sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
        }
        _resolvePossibleFunction(arg) {
            return index_js.execute(arg, [
                this
            ]);
        }
        _putElementInTemplate(element, templateElement) {
            if (this._config.html) {
                templateElement.innerHTML = "";
                templateElement.append(element);
                return;
            }
            templateElement.textContent = element.textContent;
        }
    }
    return TemplateFactory;
});

});
parcelRegister("lNr3n", function(module, exports) {

/*!
  * Bootstrap selector-engine.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("94df5")));
})(module.exports, function(index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttribute = element.getAttribute("href");
            // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
            // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
            selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
        }
        return selector ? selector.split(",").map((sel)=>index_js.parseSelector(sel)).join(",") : null;
    };
    const SelectorEngine = {
        find (selector, element = document.documentElement) {
            return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
        },
        findOne (selector, element = document.documentElement) {
            return Element.prototype.querySelector.call(element, selector);
        },
        children (element, selector) {
            return [].concat(...element.children).filter((child)=>child.matches(selector));
        },
        parents (element, selector) {
            const parents = [];
            let ancestor = element.parentNode.closest(selector);
            while(ancestor){
                parents.push(ancestor);
                ancestor = ancestor.parentNode.closest(selector);
            }
            return parents;
        },
        prev (element, selector) {
            let previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next (element, selector) {
            let next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren (element) {
            const focusables = [
                "a",
                "button",
                "input",
                "textarea",
                "select",
                "details",
                "[tabindex]",
                '[contenteditable="true"]'
            ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
            return this.find(focusables, element).filter((el)=>!index_js.isDisabled(el) && index_js.isVisible(el));
        },
        getSelectorFromElement (element) {
            const selector = getSelector(element);
            if (selector) return SelectorEngine.findOne(selector) ? selector : null;
            return null;
        },
        getElementFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.findOne(selector) : null;
        },
        getMultipleElementsFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.find(selector) : [];
        }
    };
    return SelectorEngine;
});

});


parcelRegister("kORcI", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("hvXQi")).then(()=>parcelRequire("cqEhQ"));

});

parcelRegister("4Cg4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c72c6d1a669592$export$2e2bcd8739ae039);


var $JSMaE = parcelRequire("JSMaE");
var $35c72c6d1a669592$var$HandsontableFunctions = {
    // Functie om handsontable row toe te voegen
    addRow: function(hot) {
        hot.alter("insert_row_below");
    },
    // Functie om tooltip aan te maken
    createHeaderTooltip: function(col, th, gridSettings) {
        if (gridSettings.tooltips != undefined) {
            if (gridSettings.tooltips[col] !== null) {
                var currentHelpIcon = $(th).find(".handsontable-help-icon");
                if (currentHelpIcon.length < 1) {
                    var helpIcon = document.createElement("i");
                    helpIcon.classList.add("handsontable-help-icon", "fas", "fa-question-circle", "fa-sm", "text-muted", "ms-2");
                }
                var tableHeader = $(th).find("span").parent();
                tableHeader.append(helpIcon);
                tableHeader.find(".handsontable-help-icon").attr("data-toggle", "tooltip");
                tableHeader.find(".handsontable-help-icon").attr("title", gridSettings.tooltips[col]);
                $("[data-toggle=tooltip]").tooltip();
            }
        }
    },
    // Check of het grid rows heeft
    hasRows: function(hot) {
        var rowsCount = hot.countRows();
        if (rowsCount < 1) return false;
        return true;
    },
    // Functie om te kijken of er cellen zijn met validatie errors
    isValid: function(hot) {
        var rowsCount = hot.countRows();
        for(var row = 0; row < rowsCount; row++){
            var metaCols = hot.getCellMetaAtRow(row);
            if (metaCols.some(function(col) {
                return !col.valid;
            })) return false;
        }
        return true;
    },
    // Functie om handsontable redo te triggeren
    redo: function(hot) {
        hot.redo();
    },
    // Functie om de handsontable preloader te verwijderen
    removePreloader: function() {
        var element = document.getElementById("handsontableLoader");
        if (typeof element != "undefined" && element != null) element.parentNode.removeChild(element);
    },
    // Functie om handsontable geselecteerde row te verwijderen
    removeRow: function(hot) {
        var selected = hot.getSelected();
        if (selected !== undefined) hot.alter("remove_row", selected[0][0]);
    },
    // Function to save data
    saveData: function(hot, gridStap, path, uitvraagID) {
        // Post gegevens
        $.ajax({
            type: "POST",
            url: path + uitvraagID + "/" + "saveToFile",
            data: {
                "dataJSON": JSON.stringify(hot.getData()),
                "dataDesc": $("[name=dataDesc]").val(),
                "dataStap": gridStap,
                "autosave": true
            }
        });
    },
    // Functie om handsontable undo te triggeren
    undo: function(hot) {
        hot.undo();
    },
    // Functie om de data die in een sel wordt ingevoerd te formatteren
    formatAfterChange: function(changes, source, columns, hot) {
        // Wanneer het om een handmatige wijziging in een cel gaat
        if (source === "edit") $35c72c6d1a669592$var$HandsontableFunctions.formatData(hot, columns);
        else if (source === "CopyPaste.paste") $35c72c6d1a669592$var$HandsontableFunctions.formatChange(changes, hot, columns);
    },
    // Format de data in een handsontable data array
    formatData: function(hot, columns) {
        // Haal de data uit het grid, itereer over rijen en kolommen en als er een formatter is gedefinieerd pas deze toe
        var data = hot.getData();
        data.forEach(function(rowContent, rowNumber) {
            rowContent.forEach(function(colContent, colNumber) {
                var formatter = columns.settings[colNumber].formatter || null;
                if (formatter !== null) data[rowNumber][colNumber] = (0, $JSMaE.default)[formatter](colContent);
            });
        });
        // Update het grid met de nieuwe data
        hot.updateSettings({
            data: data
        });
    },
    // Format de data in een handsontable change array
    formatChange: function(changes, hot, columns) {
        // Itereer over elke wijziging en als er een formatter is gedefinieerd pas deze toe
        changes.forEach(function([rowNumber, colNumber, oldValue, newValue]) {
            if (oldValue !== newValue) {
                var formatter = columns.settings[colNumber].formatter || null;
                if (formatter !== null) {
                    var valueFormatted = (0, $JSMaE.default)[formatter](newValue);
                    setTimeout(function() {
                        hot.setDataAtCell(rowNumber, colNumber, valueFormatted);
                    }, 1);
                }
            }
        });
    },
    // Functie om handsontable disabled of enabled te maken
    disableForPaste: function(target, source, disable = true) {
        if (disable) {
            if (source === "CopyPaste.paste") $(target).addClass("opacity-75 pointer-events-none");
        } else setTimeout(function() {
            $(target).removeClass("opacity-75 pointer-events-none");
        }, 500);
    }
};
var $35c72c6d1a669592$export$2e2bcd8739ae039 = $35c72c6d1a669592$var$HandsontableFunctions;

});

parcelRegister("6OMV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f6d5c34e4e3279a$export$2e2bcd8739ae039);


var $4Cg4a = parcelRequire("4Cg4a");
const $4f6d5c34e4e3279a$var$HandsontableControls = {
    init: function() {
        // Check if handsontable controls are present
        if ($("#handsontableControls").length) {
            // Bind Add Row button aan functie
            $("#addRow").on("click", function() {
                (0, $4Cg4a.default).addRow(window.app.hot);
            });
            // Bind Remove Row button to remove row function
            $("#removeRow").on("click", function() {
                (0, $4Cg4a.default).removeRow(window.app.hot);
            });
            // Bind export button to export function
            $("#exportcsv").on("click", function() {
                window.app.hot.getPlugin("exportFile").downloadFile("csv", {
                    filename: "export_gegevens",
                    columnHeaders: true,
                    columnDelimiter: ";"
                });
            });
            // Bind import button to upload field
            $("#importcsv").on("click", function() {
                $("input#importFile[type=file]").prop("value", "").trigger("click");
            });
            // Bind undo button
            $("#undo").on("click", function() {
                (0, $4Cg4a.default).undo(window.app.hot);
            });
            // Bind redo button to redo function
            $("#redo").on("click", function() {
                (0, $4Cg4a.default).redo(window.app.hot);
            });
            // Bind undo button to undo function
            $("#empty").on("click", function() {
                window.app.hot.updateSettings({
                    data: []
                });
            });
            // Bind redo button to fill function
            $("#fill").on("click", function() {
                window.app.hot.updateSettings({
                    data: JSON.parse(window.hotEl.getAttribute("data-data"))
                });
            });
            // Bind upload field to PapaParse
            $("input#importFile[type=file]").on("change", function() {
                $(this).parse({
                    config: {
                        skipEmptyLines: true,
                        complete: function(results) {
                            results.data.shift();
                            window.app.hot.updateSettings({
                                data: []
                            });
                            window.app.hot.updateSettings({
                                data: results.data
                            });
                            window.app.hot.validateCells();
                        }
                    }
                });
            });
        }
    }
};
var $4f6d5c34e4e3279a$export$2e2bcd8739ae039 = $4f6d5c34e4e3279a$var$HandsontableControls;

});

parcelRegister("d553s", function(module, exports) {

$parcel$export(module.exports, "default", () => $985fa9c549359e7c$export$2e2bcd8739ae039);


var $JSMaE = parcelRequire("JSMaE");
const $985fa9c549359e7c$var$Handsontable = window.Handsontable;
var $985fa9c549359e7c$var$HandsontableRenderers = {
    init: function() {
        // Salary renderer
        window.Handsontable.renderers.registerRenderer("bedrag", function(instance, td, row, col, prop, value) {
            window.Handsontable.renderers.BaseRenderer.apply(this, arguments);
            td.innerHTML = (0, $JSMaE.default).currencyEuroSign(value);
            return td;
        });
        // Percentage renderer
        window.Handsontable.renderers.registerRenderer("percentage", function(instance, td, row, col, prop, value) {
            window.Handsontable.renderers.BaseRenderer.apply(this, arguments);
            if (value == null) td.innerHTML = "";
            else {
                if (value > 100) value = 100;
                else if (value < 0) value = 0;
                td.innerHTML = (0, $JSMaE.default).percentage(value);
            }
            return td;
        });
    }
};
var $985fa9c549359e7c$export$2e2bcd8739ae039 = $985fa9c549359e7c$var$HandsontableRenderers;

});

parcelRegister("g7vmf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc59fc80293515d$export$2e2bcd8739ae039);


var $hGrZR = parcelRequire("hGrZR");
const $bbc59fc80293515d$var$Handsontable = window.Handsontable;
// Handsontable validator functions
var $bbc59fc80293515d$var$handsontableValidators = {
    // Create the validators on init
    init: function() {
        $bbc59fc80293515d$var$handsontableValidators.createValidators();
    },
    // Connector function for the default validation library
    connector: function(result) {
        if (result == "success") return true;
        else return false;
    },
    // Function that creates all validators
    createValidators: function() {
        // Register validators voor elke validator functie TODO: Herschrijven naar forEach als ie 11 uitgefaseerd wordt
        $.each((0, $hGrZR.default), function(key) {
            // Register validator
            window.Handsontable.validators.registerValidator(key, function(value, callback) {
                if (!$bbc59fc80293515d$var$handsontableValidators.connector((0, $hGrZR.default).notEmpty(value))) // Waarde mag niet leeg zijn dus return false als de waarde leeg is of niet geset
                callback(false);
                else {
                    // Valideer de waarde met de validatie functie
                    var result = $bbc59fc80293515d$var$handsontableValidators.connector((0, $hGrZR.default)[key](value));
                    callback(result);
                }
            });
            // Register zelfde validator die ook leeg mag zijn
            window.Handsontable.validators.registerValidator(key + "OrEmpty", function(value, callback) {
                if (!$bbc59fc80293515d$var$handsontableValidators.connector((0, $hGrZR.default).notEmpty(value))) // Waarde mag leeg zijn dus return true als de waarde leeg is of niet geset
                callback(true);
                else {
                    // Valideer de waarde met de validatie functie
                    var result = $bbc59fc80293515d$var$handsontableValidators.connector((0, $hGrZR.default)[key](value));
                    callback(result);
                }
            });
        });
    }
};
var $bbc59fc80293515d$export$2e2bcd8739ae039 = $bbc59fc80293515d$var$handsontableValidators;

});
parcelRegister("hGrZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdfc13796f55e41a$export$2e2bcd8739ae039);

var $JSMaE = parcelRequire("JSMaE");

var $7FBkt = parcelRequire("7FBkt");

var $13AFs = parcelRequire("13AFs");

var $cz4VK = parcelRequire("cz4VK");
var $cdfc13796f55e41a$var$validators = {
    helpers: {
        /**
     * Checks if a value is numeric
     * This is based on jQuery's isNumeric function without the jQuery dependency
     *
     * @param {*} value - The value to check
     * @returns {string} 'success' if numeric, 'error' otherwise
     */ isNumeric: function(value) {
            // Convert the value to a string for consistency
            var type = typeof value;
            if (type === "number" || type === "string") {
                var strValue = String(value);
                // Trim whitespace
                strValue = strValue.trim();
                // Check if it's a valid number
                if (strValue !== "") // Use parseFloat to handle both integers and decimals
                // Then check if it's finite and not NaN
                return !isNaN(strValue) && isFinite(strValue);
            }
            return false;
        }
    },
    /**
   * Notempty validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ notEmpty: function(value) {
        if (!value || value == "" || value == null || value == "undefined") return "error";
        else return "success";
    },
    /**
   * Required validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ required: function(value) {
        if (value == "") return "error";
        return "success";
    },
    /**
   * Isnull validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ isNull: function(value) {
        if (value === null) return "error";
        return "success";
    },
    /**
   * Alphanumeric validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphanumeric: function(value) {
        var filter = /^[a-z0-9]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphabetic_dot validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphabetic_dot: function(value) {
        var filter = /^[a-z\.]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphabetic_dot_space validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphabetic_dot_space: function(value) {
        var filter = /^[a-z \.\_]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphanumeric_dot_space validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphanumeric_dot_space: function(value) {
        var filter = /^[a-z0-9 \.\_]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphanumeric_minus validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphanumeric_minus: function(value) {
        var filter = /^[a-z0-9\-]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphabetic_dot_space_add_plus_and validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphabetic_dot_space_add_plus_and: function(value) {
        var filter = /^[a-z \.\_\@\+\&]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphabetic_dot_space_add_plus_and_minus validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphabetic_dot_space_add_plus_and_minus: function(value) {
        var filter = /^[a-z \.\-\_\@\+\&]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphanumeric_dot_space_minus validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphanumeric_dot_space_minus: function(value) {
        var filter = /^[a-z0-9 \.\-]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphanumeric_dot_space_add_plus_and validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphanumeric_dot_space_add_plus_and: function(value) {
        var filter = /^[a-z0-9 \.\_\@\+\&]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphanumeric_dot_space_add_plus_and_minus validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphanumeric_dot_space_add_plus_and_minus: function(value) {
        var filter = /^[a-z0-9 \.\-\_\@\+\&]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphanumeric_username validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphanumeric_username: function(value) {
        var filter = /^[a-z0-9\.\@\-]+$/i;
        if (!filter.test(value)) return "error";
        return "success";
    },
    /**
   * Alphabetic validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ alphabetic: function(value) {
        var filter = /^[a-z]+$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Musthavealphabetic validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ mustHaveAlphabetic: function(value) {
        var filter = /[a-z]/i;
        if (!value.match(filter)) return "error";
        return "success";
    },
    /**
   * Numeric validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ numeric: function(value) {
        if (!$cdfc13796f55e41a$var$validators.helpers.isNumeric(value) || value === null || value === "" || Array.isArray(value)) return "error";
        return "success";
    },
    /**
   * Numericnodecimals validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ numericNoDecimals: function(value) {
        var filter = /^[0-9]+$/;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Csv_only_numeric validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ csv_only_numeric: function(value) {
        var valueArray = value.replace(/\s+/g, "").split(",");
        for(var i = 0; i < valueArray.length; i++){
            if (isNaN(valueArray[i]) || valueArray[i] === "") return "error";
        }
        return "success";
    },
    /**
   * Decimalsallowed validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ decimalsAllowed: function(value) {
        var filter = /^(\d+|\d+,\d{1,2})$/;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Negativedecimalsallowed validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ negativeDecimalsAllowed: function(value) {
        var filter = /^[+-]?[0-9]{1,9}(?:\,[0-9]{1,2})?$/;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Decimalsallowedpipe validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ decimalsAllowedPipe: function(value) {
        var filter = /^[0-9\.\|]+$/;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Decimalsallowednochange validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ decimalsAllowedNoChange: function(value) {
        value = (0, $JSMaE.default).dotToComma(value);
        var filter = /^(\d+|\d+,\d{1,2})$/;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Decimalsrequired validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ decimalsRequired: function(value) {
        var filter = /^[0-9]+\,[0-9][0-9]$/;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Negativedecimalsrequired validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ negativeDecimalsRequired: function(value) {
        var filter = /^[+-]?[0-9]+\,[0-9][0-9]$/;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Email validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ email: function(value) {
        var filter = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,61}$/;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Date validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ date: function(value) {
        var m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
        if (m == null) return "error";
        else {
            var d = new Date(m[3], m[2] - 1, m[1]);
            if (d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() != m[1] * 1 + "-" + m[2] * 1 + "-" + m[3] * 1) return "error";
        }
        return "success";
    },
    /**
   *
   * @param {string} value
   * @param {array} settings
   * @returns {string}
   */ daterange: function(value, settings) {
        var enteredDate, startDate, endDate;
        var m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
        if (null !== m && null !== m[3]) {
            enteredDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
            startDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
            endDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
        }
        var field1 = settings[0];
        if (field1 !== undefined && field1 !== null && field1 !== "") {
            m = field1.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
            if (null !== m && null !== m[3]) startDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
        }
        var field2 = settings[1];
        if (field2 !== undefined && field2 !== null && field2 !== "") {
            m = field2.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
            if (null !== m && null !== m[3]) endDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
        }
        if (startDate == null || endDate == null || enteredDate == null || enteredDate < startDate || enteredDate > endDate) {
            if (settings[3] == "noError") return "warning";
            else return "error";
        }
        return "success";
    },
    /**
   * Daterangetodaywarning validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ daterangeTodayWarning: function(value) {
        var startDate = new Date();
        startDate.setDate(startDate.getDate() - 1);
        var m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
        var enteredDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
        if (Date.parse(startDate) > enteredDate) return "warning";
        return "success";
    },
    /**
   * Daterangetodaydanger validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ daterangeTodayDanger: function(value) {
        var startDate = new Date();
        startDate.setDate(startDate.getDate() - 1);
        var m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
        var enteredDate = Date.parse(new Date(m[3], m[2] - 1, m[1]));
        if (Date.parse(startDate) > enteredDate) return "error";
        return "success";
    },
    /**
   * Datemonthyear validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ datemonthyear: function(value) {
        var m = value.match(/^(\d{1,2})-(\d{4})$/);
        if (m === null) return "error";
        var month = parseInt(m[1], 10);
        if (month < 1 || month > 12) return "error";
        return "success";
    },
    /**
   * Kvk validator
   *
   * @param {string} value
   * @returns {string}
   */ kvk: function(value) {
        var filter = /^[0-9]+$/;
        if (!$cdfc13796f55e41a$var$validators.helpers.isNumeric(value) || value.length !== 8 || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Loonheffingennummer validator
   *
   * @param {string} value
   * @returns {string}
   */ loonheffingennummer: function(value) {
        var filter = /^[0-9]+$/;
        if (!$cdfc13796f55e41a$var$validators.helpers.isNumeric(value) || value.length !== 9 || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * RSIN validator
   *
   * @param {string} value
   * @returns {string}
   */ rsin: function(value) {
        var filter = /^[0-9]+$/;
        if (!$cdfc13796f55e41a$var$validators.helpers.isNumeric(value) || value.length !== 9 || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Range validator
   *
   * @param {string} value
   * @param {array} settings
   *
   * @returns {string}
   */ range: function(value, settings) {
        var field1 = settings[0];
        var field2 = settings[1];
        var value_check = parseFloat(value.replace(",", "."));
        var minValue = parseFloat(field1);
        var maxValue = parseFloat(field2);
        if (value_check < minValue || value_check > maxValue) return "error";
        return "success";
    },
    /**
   * Maxchar validator
   *
   * @param {string} value
   * @param {array} settings
   *
   * @returns {string}
   */ maxchar: function(value, settings) {
        var length = settings[0];
        if (value.length > length) return "error";
        return "success";
    },
    /**
   * Minchar validator
   *
   * @param {string} value
   * @param {array} settings
   *
   * @returns {string}
   */ minchar: function(value, settings) {
        var length = settings[0];
        if (value.length < length) return "error";
        return "success";
    },
    /**
   * Gsm validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ gsm: function(value) {
        var filter = /^(((\\0)6){1}[1-9]{1}[0-9]{7})$/i;
        filter = /^((06){1}[1-9]{1}[0-9]{7})$/i;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Phone validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ phone: function(value) {
        var filter = /^(((0)[1-9]{2}[0-9][\-]?[1-9][0-9]{5})|((0)[1-9][0-9][\-]?[1-9][0-9]{6})|(06){1}[1-9]{1}[0-9]{7})$/;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Tel validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ tel: function(element) {
        const itiId = element.getAttribute("data-iti-id");
        let iti = window.itiInstances[itiId];
        var value = iti.telInput.value.trim();
        if ("" !== value && !iti.isValidNumber()) return "error";
        return "success";
    },
    /**
   * Postcode validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ postcode: function(value) {
        var filter = /^[1-9][0-9]{3}[A-Z]{2}$/;
        if (typeof value !== "string" || !filter.test(value)) return "error";
        return "success";
    },
    /**
   * Mustagree validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ mustAgree: function(value) {
        if (value != "yes" && value != "ja") return "error";
        return "success";
    },
    /**
   * Checkbox validation
   *
   * @param {input} array
   *
   * @returns {string}
   */ checkbox: function(input) {
        if (input.checked == false) return "error";
        return "success";
    },
    /**
   * PasswordScore validation
   *
   * @param {string} value
   * @param {array} settings
   *
   * @returns {string}
   */ passwordScore: function(value, settings) {
        var score = settings[0];
        if (score <= 25) return "error";
        return "success";
    },
    /**
   * Password2 validation
   *
   * @param {string} value
   * @param {array} settings
   *
   * @returns {string}
   */ password2: function(value, settings) {
        if (settings[0] != value) return "error";
        return "success";
    },
    /**
   * Bsn validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ bsn: function(value) {
        if (value.length == 8) value = "0" + value;
        if (value.length != 9) return "error";
        else {
            var numbers = value.split("");
            var check = parseInt(numbers[0], 10) * 9 + parseInt(numbers[1], 10) * 8 + parseInt(numbers[2], 10) * 7 + parseInt(numbers[3], 10) * 6 + parseInt(numbers[4], 10) * 5 + parseInt(numbers[5], 10) * 4 + parseInt(numbers[6], 10) * 3 + parseInt(numbers[7], 10) * 2 + parseInt(numbers[8], 10) * -1;
            if (check % 11 !== 0) return "error";
        }
        return "success";
    },
    /**
   * maxFileSize validation
   *
   * @param {array} settings
   *
   * @returns {string}
   */ maxFileSize: function(settings) {
        var maxfilesize = settings[0] * 1048576;
        if (typeof settings[1] !== "undefined") for(var i = 0; i < settings[1].length; ++i){
            var size = settings[1].item(i).size;
            if (size > maxfilesize) return "error";
        }
        return "success";
    },
    /**
   * minFileSizeByte validation
   *
   * @param {array} settings
   *
   * @returns {string}
   */ minFileSizeByte: function(settings) {
        var minfilesize = settings[0];
        if (typeof settings[1] !== "undefined") for(var i = 0; i < settings[1].length; ++i){
            var size = settings[1].item(i).size;
            if (size < minfilesize) return "error";
        }
        return "success";
    },
    /**
   * FileExtension validation
   *
   * @param {string} value
   * @param {array} settings
   *
   * @returns {string}
   */ fileExtension: function(value, settings) {
        var field1 = settings[0];
        var fileExtension = field1.split(",");
        var valueSplit = value.toLowerCase().split(".");
        var ext = "." + valueSplit[valueSplit.length - 1];
        if (fileExtension.indexOf(ext) == -1) return "error";
        return "success";
    },
    /**
   * Iban validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ iban: function(value) {
        if (!$cz4VK.isValidIBAN(value)) return "error";
        return "success";
    },
    /**
   * Nosemicolon validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ nosemicolon: function(value) {
        if (value.indexOf(";") > -1) return "error";
        return "success";
    },
    /**
   * Betalingskenmerk validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ betalingskenmerk: function(value) {
        if (value === "") return "warning";
        var kenmerkArrayGecorrigeerd = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var kenmerkArrayGewicht = [
            10,
            5,
            8,
            4,
            2,
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2
        ];
        var regex = /[\d]/g;
        var kenmerkArray = value.match(regex);
        var offset = kenmerkArrayGecorrigeerd.length - kenmerkArray.length;
        switch(kenmerkArray.length){
            case 7:
                var filter = /^[0-9]{7}$/;
                if (typeof value !== "string" || !filter.test(value)) return "warning";
                return "success";
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
                var beginOffset = 1;
                var C = kenmerkArray[0];
                if (kenmerkArray.length < 16) {
                    var L = kenmerkArray[1];
                    var calculatedL = kenmerkArray.length - 2;
                    if (calculatedL > 9) calculatedL = calculatedL - 10;
                    if (calculatedL != L) return "warning";
                    beginOffset = 2;
                }
                for(var i = beginOffset; i < kenmerkArray.length; i++)kenmerkArrayGecorrigeerd[i + offset] = parseInt(kenmerkArray[i]);
                var Som = 0;
                for(i = 0; i < kenmerkArrayGecorrigeerd.length; i++){
                    var subSom = kenmerkArrayGecorrigeerd[i] * kenmerkArrayGewicht[i];
                    Som = Som + subSom;
                }
                var calculatedC = 11 - Som % 11;
                if (calculatedC != C) return "warning";
                else {
                    var j = 0;
                    var valueReturn = "";
                    for(i = kenmerkArray.length - 1; i >= 0; i--){
                        if (j == 4) {
                            valueReturn = "-" + valueReturn;
                            j = 0;
                        }
                        valueReturn = kenmerkArray[i] + valueReturn;
                        j++;
                    }
                    value = valueReturn;
                }
                return "success";
            default:
                return "warning";
        }
    },
    /**
   * Salaris validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ salaris: function(value) {
        value = (0, (/*@__PURE__*/$parcel$interopDefault($13AFs)))(value, {
            decimal: ",",
            separator: "."
        });
        value = value.value;
        if (!$cdfc13796f55e41a$var$validators.helpers.isNumeric(value) || value > 999999 || value < 100) return "error";
        else return "success";
    },
    /**
   * Salarisnegativeallowed validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ salarisNegativeAllowed: function(value) {
        value = (0, (/*@__PURE__*/$parcel$interopDefault($13AFs)))(value, {
            decimal: ",",
            separator: "."
        });
        value = value.value;
        if (isNaN(parseFloat(value)) || value > 999999 || value < -999999 || value === 0) return "error";
        else return "success";
    },
    /**
   * Salarisnegativeandzeroallowed validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ salarisNegativeAndZeroAllowed: function(value) {
        value = (0, (/*@__PURE__*/$parcel$interopDefault($13AFs)))(value, {
            decimal: ",",
            separator: "."
        });
        value = value.value;
        if (isNaN(parseFloat(value)) || value > 999999 || value < -999999) return "error";
        else return "success";
    },
    /**
   * percentage validation
   *
   * @param {string} value
   *
   * @returns {string}
   */ percentage: function(value) {
        if (isNaN(parseFloat(value))) return "error";
        if (parseFloat(value) > 100 || parseFloat(value) < 0) return "error";
        return "success";
    },
    /**
   * relatieGebruikersnaam validation (A123678-054)
   *
   * @param {string} value
   *
   * @returns {string}
   */ relatieGebruikersnaam: function(value) {
        var filter = /^[R,W]\d+-[0-9]{3}$/i;
        if (!filter.test(value)) return "error";
        return "success";
    },
    /**
   * activatieCode validation (a1234)
   *
   * @param {string} value
   *
   * @returns {string}
   */ activatieCode: function(value) {
        let filter = /^[a-z][0-9]{4}$/;
        if (!filter.test(value)) return "error";
        return "success";
    },
    /**
   * Check of value is lowercase
   *
   * @param {string} value
   *
   * @returns {string}
   */ lowercase: function(value) {
        let filter = /[A-Z]/;
        if (filter.test(value)) return "error";
        return "success";
    },
    /**
   * Check if password is strong enough
   *
   * @param {string} value
   * @param {array} settings
   *
   * @returns {string}
   */ password: function(value, settings) {
        let usernameFieldQuery = settings[0] || '[name="username"]';
        let username = document.querySelector(usernameFieldQuery)?.value || "";
        let timeoutPromise = new Promise((resolve)=>{
            setTimeout(()=>{
                resolve("error");
            }, 1000);
        });
        let passwordStrengthPromise = new Promise((resolve)=>{
            (0, $7FBkt.default).send("POST", window.app.passwordStrengtUrl, function(data) {
                if (typeof data !== "undefined") {
                    data = JSON.parse(data);
                    if (data) resolve("success");
                    else resolve("error");
                }
            }, (0, $7FBkt.default).encodeFormData({
                password: value,
                username: username
            }));
        });
        return Promise.race([
            passwordStrengthPromise,
            timeoutPromise
        ]);
    },
    /**
   * SpecificValue validation
   *
   * Voeg attributes data-validate="specificValue" en data-specific-value="[\"##value##\",\"{t}##label##{/t}\"]" toe:
   * ##value## is de value waarop je wil matchen, ##label## is de string in de errormelding
   *
   * @param {string} value de input van de gebruiker
   * @param {array} settings bevat de te matchen value die in de specificValue attribute wordt meegegeven
   * @returns {string}
   */ specificValue: function(value, settings) {
        const valueLowercase = value.toLowerCase();
        const inputValue = settings[0].toLowerCase();
        if (valueLowercase != inputValue) return "error";
        return "success";
    }
};
var $cdfc13796f55e41a$export$2e2bcd8739ae039 = $cdfc13796f55e41a$var$validators;

});
parcelRegister("7FBkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $59595187dd551f1a$export$2e2bcd8739ae039);

var $hzkBE = parcelRequire("hzkBE");
const $59595187dd551f1a$var$httpRequest = {
    /**
   * Beschrijving
   *
   * @param {string} method
   * @param {object} callback
   * @param {object|null} body
   * @param {bool} async
   *
   * @returns {string}
   */ send: function(method, url, callback, body = null, async = true) {
        var xhr = new XMLHttpRequest();
        xhr.open(method.toUpperCase(), url, async);
        xhr.onload = function() {
            if (this.status >= 200 && this.status < 400) callback(this.response);
            else (0, $hzkBE.default)("danger", "", "Er is iets misgegaan. Probeer het nogmaals.");
        };
        xhr.send(body);
    },
    /**
   * Beschrijving
   *
   * @param {object} url
   * @param {object} callback
   *
   * @returns {string}
   */ get: function(url, callback) {
        $59595187dd551f1a$var$httpRequest.send("GET", url, callback);
    },
    /**
   * Beschrijving
   *
   * @param {object} url
   * @param {object} callback
   * @param {object|null} body
   *
   * @returns {string}
   */ post: function(url, callback, body = null) {
        $59595187dd551f1a$var$httpRequest.send("POST", url, callback, body);
    },
    /**
   * Beschrijving
   *
   * @param {object} url
   * @param {object} callback
   * @param {object|null} body
   *
   * @returns {string}
   */ put: function(url, callback, body = null) {
        $59595187dd551f1a$var$httpRequest.send("PUT", url, callback, body);
    },
    /**
   * Encode data voor submit
   *
   * @param {object} data
   *
   * @returns {string}
   */ encodeFormData: function(data) {
        var formData = new FormData();
        for (let [index, value] of Object.entries(data)){
            if (typeof value == "object") value = JSON.stringify(value);
            formData.append(index, value);
        }
        return formData;
    }
};
var $59595187dd551f1a$export$2e2bcd8739ae039 = $59595187dd551f1a$var$httpRequest;

});

parcelRegister("cz4VK", function(module, exports) {

$parcel$export(module.exports, "isValidIBAN", () => $925c93fc4d221334$export$90cbbdc8889fba6c);
/*!
 * @license
 * Copyright Saša Jovanić
 * Licensed under the Mozilla Public License, Version 2.0 or the MIT license,
 * at your option. This file may not be copied, modified, or distributed
 * except according to those terms.
 * SPDX-FileCopyrightText: Saša Jovanić
 * SPDX-License-Identifier: MIT or MPL/2.0
 */ /**
 * Validation, extraction and creation of IBAN, BBAN, BIC/SWIFT numbers plus some other helpful stuff
 * @package Documentation
 * @author Saša Jovanić
 * @module ibantools
 * @version 4.5.1
 * @license MIT or MPL-2.0
 * @preferred
 */ "use strict";
function $925c93fc4d221334$export$90cbbdc8889fba6c(iban, validationOptions) {
    if (validationOptions === void 0) validationOptions = {
        allowQRIBAN: true
    };
    if (iban === undefined || iban === null) return false;
    var reg = new RegExp("^[0-9]{2}$", "");
    var countryCode = iban.slice(0, 2);
    var spec = $925c93fc4d221334$export$7a657a5e983aaa8f[countryCode];
    if (spec === undefined || spec.bban_regexp === undefined || spec.bban_regexp === null || spec.chars === undefined) return false;
    return spec.chars === iban.length && reg.test(iban.slice(2, 4)) && $925c93fc4d221334$export$fd748ece6e31e633(iban.slice(4), countryCode) && $925c93fc4d221334$var$isValidIBANChecksum(iban) && (validationOptions.allowQRIBAN || !$925c93fc4d221334$export$eb68e544282cfb12(iban));
}
var $925c93fc4d221334$export$c2da9efdf70758cc;
(function(ValidationErrorsIBAN) {
    ValidationErrorsIBAN[ValidationErrorsIBAN["NoIBANProvided"] = 0] = "NoIBANProvided";
    ValidationErrorsIBAN[ValidationErrorsIBAN["NoIBANCountry"] = 1] = "NoIBANCountry";
    ValidationErrorsIBAN[ValidationErrorsIBAN["WrongBBANLength"] = 2] = "WrongBBANLength";
    ValidationErrorsIBAN[ValidationErrorsIBAN["WrongBBANFormat"] = 3] = "WrongBBANFormat";
    ValidationErrorsIBAN[ValidationErrorsIBAN["ChecksumNotNumber"] = 4] = "ChecksumNotNumber";
    ValidationErrorsIBAN[ValidationErrorsIBAN["WrongIBANChecksum"] = 5] = "WrongIBANChecksum";
    ValidationErrorsIBAN[ValidationErrorsIBAN["WrongAccountBankBranchChecksum"] = 6] = "WrongAccountBankBranchChecksum";
    ValidationErrorsIBAN[ValidationErrorsIBAN["QRIBANNotAllowed"] = 7] = "QRIBANNotAllowed";
})($925c93fc4d221334$export$c2da9efdf70758cc || ($925c93fc4d221334$export$c2da9efdf70758cc = {}));
function $925c93fc4d221334$export$c539377bd41d8ca9(iban, validationOptions) {
    if (validationOptions === void 0) validationOptions = {
        allowQRIBAN: true
    };
    var result = {
        errorCodes: [],
        valid: true
    };
    if (iban !== undefined && iban !== null && iban !== "") {
        var spec = $925c93fc4d221334$export$7a657a5e983aaa8f[iban.slice(0, 2)];
        if (!spec || !(spec.bban_regexp || spec.chars)) {
            result.valid = false;
            result.errorCodes.push($925c93fc4d221334$export$c2da9efdf70758cc.NoIBANCountry);
            return result;
        }
        if (spec && spec.chars && spec.chars !== iban.length) {
            result.valid = false;
            result.errorCodes.push($925c93fc4d221334$export$c2da9efdf70758cc.WrongBBANLength);
        }
        if (spec && spec.bban_regexp && !$925c93fc4d221334$var$checkFormatBBAN(iban.slice(4), spec.bban_regexp)) {
            result.valid = false;
            result.errorCodes.push($925c93fc4d221334$export$c2da9efdf70758cc.WrongBBANFormat);
        }
        if (spec && spec.bban_validation_func && !spec.bban_validation_func(iban.slice(4))) {
            result.valid = false;
            result.errorCodes.push($925c93fc4d221334$export$c2da9efdf70758cc.WrongAccountBankBranchChecksum);
        }
        var reg = new RegExp("^[0-9]{2}$", "");
        if (!reg.test(iban.slice(2, 4))) {
            result.valid = false;
            result.errorCodes.push($925c93fc4d221334$export$c2da9efdf70758cc.ChecksumNotNumber);
        }
        if (result.errorCodes.indexOf($925c93fc4d221334$export$c2da9efdf70758cc.WrongBBANFormat) !== -1 || !$925c93fc4d221334$var$isValidIBANChecksum(iban)) {
            result.valid = false;
            result.errorCodes.push($925c93fc4d221334$export$c2da9efdf70758cc.WrongIBANChecksum);
        }
        if (!validationOptions.allowQRIBAN && $925c93fc4d221334$export$eb68e544282cfb12(iban)) {
            result.valid = false;
            result.errorCodes.push($925c93fc4d221334$export$c2da9efdf70758cc.QRIBANNotAllowed);
        }
    } else {
        result.valid = false;
        result.errorCodes.push($925c93fc4d221334$export$c2da9efdf70758cc.NoIBANProvided);
    }
    return result;
}
function $925c93fc4d221334$export$fd748ece6e31e633(bban, countryCode) {
    if (bban === undefined || bban === null || countryCode === undefined || countryCode === null) return false;
    var spec = $925c93fc4d221334$export$7a657a5e983aaa8f[countryCode];
    if (spec === undefined || spec === null || spec.bban_regexp === undefined || spec.bban_regexp === null || spec.chars === undefined || spec.chars === null) return false;
    if (spec.chars - 4 === bban.length && $925c93fc4d221334$var$checkFormatBBAN(bban, spec.bban_regexp)) {
        if (spec.bban_validation_func) return spec.bban_validation_func(bban.replace(/[\s.]+/g, ""));
        return true;
    }
    return false;
}
function $925c93fc4d221334$export$84e43ed7b625498(countryCode) {
    if (countryCode !== undefined && countryCode !== null) {
        var spec = $925c93fc4d221334$export$7a657a5e983aaa8f[countryCode];
        if (spec !== undefined) return spec.SEPA ? spec.SEPA : false;
    }
    return false;
}
function $925c93fc4d221334$export$eb68e544282cfb12(iban) {
    if (iban === undefined || iban === null) return false;
    var countryCode = iban.slice(0, 2);
    var QRIBANCountries = [
        "LI",
        "CH"
    ];
    if (!QRIBANCountries.includes(countryCode)) return false;
    var reg = new RegExp("^3[0-1]{1}[0-9]{3}$", "");
    return reg.test(iban.slice(4, 9));
}
function $925c93fc4d221334$export$7d756fd11e5b6712(params) {
    var formated_bban = $925c93fc4d221334$export$4b0572dba75ea434(params.bban) || "";
    if (params.countryCode === null || params.countryCode === undefined) return null;
    var spec = $925c93fc4d221334$export$7a657a5e983aaa8f[params.countryCode];
    if (formated_bban !== "" && spec !== undefined && spec.chars && spec.chars !== null && spec.chars === formated_bban.length + 4 && spec.bban_regexp && spec.bban_regexp !== null && $925c93fc4d221334$var$checkFormatBBAN(formated_bban, spec.bban_regexp)) {
        var checksom = $925c93fc4d221334$var$mod9710Iban(params.countryCode + "00" + formated_bban);
        return params.countryCode + ("0" + (98 - checksom)).slice(-2) + formated_bban;
    }
    return null;
}
function $925c93fc4d221334$export$2e939f00b30fa963(iban) {
    var result = {};
    var eFormatIBAN = $925c93fc4d221334$export$4b0572dba75ea434(iban);
    result.iban = eFormatIBAN || iban;
    if (!!eFormatIBAN && $925c93fc4d221334$export$90cbbdc8889fba6c(eFormatIBAN)) {
        result.bban = eFormatIBAN.slice(4);
        result.countryCode = eFormatIBAN.slice(0, 2);
        result.valid = true;
        var spec = $925c93fc4d221334$export$7a657a5e983aaa8f[result.countryCode];
        if (spec.account_indentifier) {
            var ac = spec.account_indentifier.split("-");
            var starting = parseInt(ac[0]);
            var ending = parseInt(ac[1]);
            result.accountNumber = result.iban.slice(starting, ending + 1);
        }
        if (spec.bank_identifier) {
            var ac = spec.bank_identifier.split("-");
            var starting = parseInt(ac[0]);
            var ending = parseInt(ac[1]);
            result.bankIdentifier = result.bban.slice(starting, ending + 1);
        }
        if (spec.branch_indentifier) {
            var ac = spec.branch_indentifier.split("-");
            var starting = parseInt(ac[0]);
            var ending = parseInt(ac[1]);
            result.branchIdentifier = result.bban.slice(starting, ending + 1);
        }
    } else result.valid = false;
    return result;
}
/**
 * Check BBAN format
 *
 * @ignore
 */ function $925c93fc4d221334$var$checkFormatBBAN(bban, bformat) {
    var reg = new RegExp(bformat, "");
    return reg.test(bban);
}
function $925c93fc4d221334$export$4b0572dba75ea434(iban) {
    if (typeof iban !== "string") return null;
    return iban.replace(/[-\ ]/g, "").toUpperCase();
}
function $925c93fc4d221334$export$470bfae44a8c7e15(iban, separator) {
    if (typeof iban !== "string") return null;
    if (separator === undefined || separator === null) separator = " ";
    var electronic_iban = $925c93fc4d221334$export$4b0572dba75ea434(iban);
    /* istanbul ignore if */ if (electronic_iban === null) return null;
    return electronic_iban.replace(/(.{4})(?!$)/g, "$1" + separator);
}
/**
 * Calculate checksum of IBAN and compares it with checksum provided in IBAN Registry
 *
 * @ignore
 */ function $925c93fc4d221334$var$isValidIBANChecksum(iban) {
    var countryCode = iban.slice(0, 2);
    var providedChecksum = parseInt(iban.slice(2, 4), 10);
    var bban = iban.slice(4);
    // Wikipedia[validating_iban] says there are a specif way to check if a IBAN is valid but
    // it. It says 'If the remainder is 1, the check digit test is passed and the
    // IBAN might be valid.'. might, MIGHT!
    // We don't want might but want yes or no. Since every BBAN is IBAN from the fifth
    // (slice(4)) we can generate the IBAN from BBAN and country code(two first characters)
    // from in the IBAN.
    // To generate the (generate the iban check digits)[generating-iban-check]
    //   Move the country code to the end
    //   remove the checksum from the begging
    //   Add "00" to the end
    //   modulo 97 on the amount
    //   subtract remainder from 98, (98 - remainder)
    //   Add a leading 0 if the remainder is less then 10 (padStart(2, "0")) (we skip this
    //     since we compare int, not string)
    //
    // [validating_iban][https://en.wikipedia.org/wiki/International_Bank_Account_Number#Validating_the_IBAN]
    // [generating-iban-check][https://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits]
    var validationString = $925c93fc4d221334$var$replaceCharaterWithCode("".concat(bban).concat(countryCode, "00"));
    var rest = $925c93fc4d221334$var$mod9710(validationString);
    return 98 - rest === providedChecksum;
}
/**
 * Iban contain characters and should be converted to intereger by 55 substracted
 * from there ascii value
 *
 * @ignore
 */ function $925c93fc4d221334$var$replaceCharaterWithCode(str) {
    // It is slower but alot more readable
    // https://jsbench.me/ttkzgsekae/1
    return str.split("").map(function(c) {
        var code = c.charCodeAt(0);
        return code >= 65 ? (code - 55).toString() : c;
    }).join("");
}
/**
 * MOD-97-10
 *
 * @ignore
 */ function $925c93fc4d221334$var$mod9710Iban(iban) {
    return $925c93fc4d221334$var$mod9710($925c93fc4d221334$var$replaceCharaterWithCode(iban.slice(4) + iban.slice(0, 4)));
}
function $925c93fc4d221334$export$e716f2483decda32() {
    var countyMap = {};
    for(var countyCode in $925c93fc4d221334$export$7a657a5e983aaa8f){
        var county = $925c93fc4d221334$export$7a657a5e983aaa8f[countyCode];
        countyMap[countyCode] = {
            chars: county.chars || null,
            bban_regexp: county.bban_regexp || null,
            IBANRegistry: county.IBANRegistry || false,
            SEPA: county.SEPA || false
        };
    }
    return countyMap;
}
function $925c93fc4d221334$export$e38c2a15379bf9dd(bic) {
    if (!bic) return false;
    var reg = new RegExp("^[a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?$", "");
    var spec = $925c93fc4d221334$export$7a657a5e983aaa8f[bic.toUpperCase().slice(4, 6)];
    return reg.test(bic) && spec !== undefined;
}
var $925c93fc4d221334$export$fd52f4705d1e61da;
(function(ValidationErrorsBIC) {
    ValidationErrorsBIC[ValidationErrorsBIC["NoBICProvided"] = 0] = "NoBICProvided";
    ValidationErrorsBIC[ValidationErrorsBIC["NoBICCountry"] = 1] = "NoBICCountry";
    ValidationErrorsBIC[ValidationErrorsBIC["WrongBICFormat"] = 2] = "WrongBICFormat";
})($925c93fc4d221334$export$fd52f4705d1e61da || ($925c93fc4d221334$export$fd52f4705d1e61da = {}));
function $925c93fc4d221334$export$8390bd2c5bbd4530(bic) {
    var result = {
        errorCodes: [],
        valid: true
    };
    if (bic !== undefined && bic !== null && bic !== "") {
        var spec = $925c93fc4d221334$export$7a657a5e983aaa8f[bic.toUpperCase().slice(4, 6)];
        if (spec === undefined) {
            result.valid = false;
            result.errorCodes.push($925c93fc4d221334$export$fd52f4705d1e61da.NoBICCountry);
        } else {
            var reg = new RegExp("^[a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?$", "");
            if (!reg.test(bic)) {
                result.valid = false;
                result.errorCodes.push($925c93fc4d221334$export$fd52f4705d1e61da.WrongBICFormat);
            }
        }
    } else {
        result.valid = false;
        result.errorCodes.push($925c93fc4d221334$export$fd52f4705d1e61da.NoBICProvided);
    }
    return result;
}
function $925c93fc4d221334$export$243d3df89ab32a37(inputBic) {
    var result = {};
    var bic = inputBic.toUpperCase();
    if ($925c93fc4d221334$export$e38c2a15379bf9dd(bic)) {
        result.bankCode = bic.slice(0, 4);
        result.countryCode = bic.slice(4, 6);
        result.locationCode = bic.slice(6, 8);
        result.testBIC = result.locationCode[1] === "0" ? true : false;
        result.branchCode = bic.length > 8 ? bic.slice(8) : null;
        result.valid = true;
    } else result.valid = false;
    return result;
}
/**
 * Used for Norway BBAN check
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkNorwayBBAN = function(bban) {
    var weights = [
        5,
        4,
        3,
        2,
        7,
        6,
        5,
        4,
        3,
        2
    ];
    var bbanWithoutSpacesAndPeriods = bban.replace(/[\s.]+/g, "");
    var controlDigit = parseInt(bbanWithoutSpacesAndPeriods.charAt(10), 10);
    var bbanWithoutControlDigit = bbanWithoutSpacesAndPeriods.substring(0, 10);
    var sum = 0;
    for(var index = 0; index < 10; index++)sum += parseInt(bbanWithoutControlDigit.charAt(index), 10) * weights[index];
    var remainder = sum % 11;
    return controlDigit === (remainder === 0 ? 0 : 11 - remainder);
};
/**
 * Used for Belgian BBAN check
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkBelgianBBAN = function(bban) {
    var stripped = bban.replace(/[\s.]+/g, "");
    var checkingPart = parseInt(stripped.substring(0, stripped.length - 2), 10);
    var checksum = parseInt(stripped.substring(stripped.length - 2, stripped.length), 10);
    var remainder = checkingPart % 97 === 0 ? 97 : checkingPart % 97;
    return remainder === checksum;
};
/**
 * Mod 97/10 calculation
 *
 * @ignore
 */ var $925c93fc4d221334$var$mod9710 = function(validationString) {
    while(validationString.length > 2){
        // > Any computer programming language or software package that is used to compute D
        // > mod 97 directly must have the ability to handle integers of more than 30 digits.
        // > In practice, this can only be done by software that either supports
        // > arbitrary-precision arithmetic or that can handle 219-bit (unsigned) integers
        // https://en.wikipedia.org/wiki/International_Bank_Account_Number#Modulo_operation_on_IBAN
        var part = validationString.slice(0, 6);
        var partInt = parseInt(part, 10);
        if (isNaN(partInt)) return NaN;
        validationString = partInt % 97 + validationString.slice(part.length);
    }
    return parseInt(validationString, 10) % 97;
};
/**
 * Check BBAN based on Mod97/10 calculation for countries that support it:
 * BA, ME, MK, PT, RS, SI
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkMod9710BBAN = function(bban) {
    var stripped = bban.replace(/[\s.]+/g, "");
    var reminder = $925c93fc4d221334$var$mod9710(stripped);
    return reminder === 1;
};
/**
 * Used for Poland BBAN check
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkPolandBBAN = function(bban) {
    var weights = [
        3,
        9,
        7,
        1,
        3,
        9,
        7
    ];
    var controlDigit = parseInt(bban.charAt(7), 10);
    var toCheck = bban.substring(0, 7);
    var sum = 0;
    for(var index = 0; index < 7; index++)sum += parseInt(toCheck.charAt(index), 10) * weights[index];
    var remainder = sum % 10;
    return controlDigit === (remainder === 0 ? 0 : 10 - remainder);
};
/**
 * Spain (ES) BBAN check
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkSpainBBAN = function(bban) {
    var weightsBankBranch = [
        4,
        8,
        5,
        10,
        9,
        7,
        3,
        6
    ];
    var weightsAccount = [
        1,
        2,
        4,
        8,
        5,
        10,
        9,
        7,
        3,
        6
    ];
    var controlBankBranch = parseInt(bban.charAt(8), 10);
    var controlAccount = parseInt(bban.charAt(9), 10);
    var bankBranch = bban.substring(0, 8);
    var account = bban.substring(10, 20);
    var sum = 0;
    for(var index = 0; index < 8; index++)sum += parseInt(bankBranch.charAt(index), 10) * weightsBankBranch[index];
    var remainder = sum % 11;
    if (controlBankBranch !== (remainder === 0 ? 0 : remainder === 1 ? 1 : 11 - remainder)) return false;
    sum = 0;
    for(var index = 0; index < 10; index++)sum += parseInt(account.charAt(index), 10) * weightsAccount[index];
    remainder = sum % 11;
    return controlAccount === (remainder === 0 ? 0 : remainder === 1 ? 1 : 11 - remainder);
};
/**
 * Mod 11/10 check
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkMod1110 = function(toCheck, control) {
    var nr = 10;
    for(var index = 0; index < toCheck.length; index++){
        nr += parseInt(toCheck.charAt(index), 10);
        if (nr % 10 !== 0) nr = nr % 10;
        nr = nr * 2;
        nr = nr % 11;
    }
    return control === (11 - nr === 10 ? 0 : 11 - nr);
};
/**
 * Croatian (HR) BBAN check
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkCroatianBBAN = function(bban) {
    var controlBankBranch = parseInt(bban.charAt(6), 10);
    var controlAccount = parseInt(bban.charAt(16), 10);
    var bankBranch = bban.substring(0, 6);
    var account = bban.substring(7, 16);
    return $925c93fc4d221334$var$checkMod1110(bankBranch, controlBankBranch) && $925c93fc4d221334$var$checkMod1110(account, controlAccount);
};
/**
 * Czech (CZ) and Slowak (SK) BBAN check
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkCzechAndSlovakBBAN = function(bban) {
    var weightsPrefix = [
        10,
        5,
        8,
        4,
        2,
        1
    ];
    var weightsSuffix = [
        6,
        3,
        7,
        9,
        10,
        5,
        8,
        4,
        2,
        1
    ];
    var controlPrefix = parseInt(bban.charAt(9), 10);
    var controlSuffix = parseInt(bban.charAt(19), 10);
    var prefix = bban.substring(4, 9);
    var suffix = bban.substring(10, 19);
    var sum = 0;
    for(var index = 0; index < prefix.length; index++)sum += parseInt(prefix.charAt(index), 10) * weightsPrefix[index];
    var remainder = sum % 11;
    if (controlPrefix !== (remainder === 0 ? 0 : remainder === 1 ? 1 : 11 - remainder)) return false;
    sum = 0;
    for(var index = 0; index < suffix.length; index++)sum += parseInt(suffix.charAt(index), 10) * weightsSuffix[index];
    remainder = sum % 11;
    return controlSuffix === (remainder === 0 ? 0 : remainder === 1 ? 1 : 11 - remainder);
};
/**
 * Estonian (EE) BBAN check
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkEstonianBBAN = function(bban) {
    var weights = [
        7,
        1,
        3,
        7,
        1,
        3,
        7,
        1,
        3,
        7,
        1,
        3,
        7
    ];
    var controlDigit = parseInt(bban.charAt(15), 10);
    var toCheck = bban.substring(2, 15);
    var sum = 0;
    for(var index = 0; index < toCheck.length; index++)sum += parseInt(toCheck.charAt(index), 10) * weights[index];
    var remainder = sum % 10;
    return controlDigit === (remainder === 0 ? 0 : 10 - remainder);
};
/**
 * Check French (FR) BBAN
 * Also for Monaco (MC)
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkFrenchBBAN = function(bban) {
    var stripped = bban.replace(/[\s.]+/g, "");
    var normalized = Array.from(stripped);
    for(var index = 0; index < stripped.length; index++){
        var c = normalized[index].charCodeAt(0);
        if (c >= 65) switch(c){
            case 65:
            case 74:
                normalized[index] = "1";
                break;
            case 66:
            case 75:
            case 83:
                normalized[index] = "2";
                break;
            case 67:
            case 76:
            case 84:
                normalized[index] = "3";
                break;
            case 68:
            case 77:
            case 85:
                normalized[index] = "4";
                break;
            case 69:
            case 78:
            case 86:
                normalized[index] = "5";
                break;
            case 70:
            case 79:
            case 87:
                normalized[index] = "6";
                break;
            case 71:
            case 80:
            case 88:
                normalized[index] = "7";
                break;
            case 72:
            case 81:
            case 89:
                normalized[index] = "8";
                break;
            case 73:
            case 82:
            case 90:
                normalized[index] = "9";
                break;
        }
    }
    var remainder = $925c93fc4d221334$var$mod9710(normalized.join(""));
    return remainder === 0;
};
/**
 * Hungarian (HU) BBAN check
 *
 * @ignore
 */ var $925c93fc4d221334$var$checkHungarianBBAN = function(bban) {
    var weights = [
        9,
        7,
        3,
        1,
        9,
        7,
        3,
        1,
        9,
        7,
        3,
        1,
        9,
        7,
        3
    ];
    var controlDigitBankBranch = parseInt(bban.charAt(7), 10);
    var toCheckBankBranch = bban.substring(0, 7);
    var sum = 0;
    for(var index = 0; index < toCheckBankBranch.length; index++)sum += parseInt(toCheckBankBranch.charAt(index), 10) * weights[index];
    var remainder = sum % 10;
    if (controlDigitBankBranch !== (remainder === 0 ? 0 : 10 - remainder)) return false;
    sum = 0;
    if (bban.endsWith("00000000")) {
        var toCheckAccount = bban.substring(8, 15);
        var controlDigitAccount = parseInt(bban.charAt(15), 10);
        for(var index = 0; index < toCheckAccount.length; index++)sum += parseInt(toCheckAccount.charAt(index), 10) * weights[index];
        var remainder_1 = sum % 10;
        return controlDigitAccount === (remainder_1 === 0 ? 0 : 10 - remainder_1);
    } else {
        var toCheckAccount = bban.substring(8, 23);
        var controlDigitAccount = parseInt(bban.charAt(23), 10);
        for(var index = 0; index < toCheckAccount.length; index++)sum += parseInt(toCheckAccount.charAt(index), 10) * weights[index];
        var remainder_2 = sum % 10;
        return controlDigitAccount === (remainder_2 === 0 ? 0 : 10 - remainder_2);
    }
};
var $925c93fc4d221334$export$2931ce2b02e577bb = function(country, func) {
    if (typeof $925c93fc4d221334$export$7a657a5e983aaa8f[country] === "undefined") return false;
    $925c93fc4d221334$export$7a657a5e983aaa8f[country].bban_validation_func = func;
    return true;
};
var $925c93fc4d221334$export$7a657a5e983aaa8f = {
    AD: {
        chars: 24,
        bban_regexp: "^[0-9]{8}[A-Z0-9]{12}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "4-7",
        bank_identifier: "0-3",
        account_indentifier: "8-24"
    },
    AE: {
        chars: 23,
        bban_regexp: "^[0-9]{3}[0-9]{16}$",
        IBANRegistry: true,
        bank_identifier: "0-2",
        account_indentifier: "7-23"
    },
    AF: {},
    AG: {},
    AI: {},
    AL: {
        chars: 28,
        bban_regexp: "^[0-9]{8}[A-Z0-9]{16}$",
        IBANRegistry: true,
        branch_indentifier: "3-7",
        bank_identifier: "0-2",
        account_indentifier: "12-28"
    },
    AM: {},
    AO: {
        chars: 25,
        bban_regexp: "^[0-9]{21}$"
    },
    AQ: {},
    AR: {},
    AS: {},
    AT: {
        chars: 20,
        bban_regexp: "^[0-9]{16}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-4"
    },
    AU: {},
    AW: {},
    AX: {
        chars: 18,
        bban_regexp: "^[0-9]{14}$",
        IBANRegistry: true
    },
    AZ: {
        chars: 28,
        bban_regexp: "^[A-Z]{4}[A-Z0-9]{20}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "4-28"
    },
    BA: {
        chars: 20,
        bban_regexp: "^[0-9]{16}$",
        bban_validation_func: $925c93fc4d221334$var$checkMod9710BBAN,
        IBANRegistry: true,
        branch_indentifier: "3-5",
        bank_identifier: "0-2"
    },
    BB: {},
    BD: {},
    BE: {
        chars: 16,
        bban_regexp: "^[0-9]{12}$",
        bban_validation_func: $925c93fc4d221334$var$checkBelgianBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-2",
        account_indentifier: "0-16"
    },
    BF: {
        chars: 28,
        bban_regexp: "^[A-Z0-9]{2}[0-9]{22}$"
    },
    BG: {
        chars: 22,
        bban_regexp: "^[A-Z]{4}[0-9]{6}[A-Z0-9]{8}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "4-7",
        bank_identifier: "0-3"
    },
    BH: {
        chars: 22,
        bban_regexp: "^[A-Z]{4}[A-Z0-9]{14}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "8-22"
    },
    BI: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$",
        branch_indentifier: "5-9",
        bank_identifier: "0-4",
        account_indentifier: "14-27"
    },
    BJ: {
        chars: 28,
        bban_regexp: "^[A-Z0-9]{2}[0-9]{22}$"
    },
    BL: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$"
    },
    BM: {},
    BN: {},
    BO: {},
    BQ: {},
    BR: {
        chars: 29,
        bban_regexp: "^[0-9]{23}[A-Z]{1}[A-Z0-9]{1}$",
        IBANRegistry: true,
        branch_indentifier: "8-12",
        bank_identifier: "0-7",
        account_indentifier: "17-29"
    },
    BS: {},
    BT: {},
    BV: {},
    BW: {},
    BY: {
        chars: 28,
        bban_regexp: "^[A-Z]{4}[0-9]{4}[A-Z0-9]{16}$",
        IBANRegistry: true,
        bank_identifier: "0-3"
    },
    BZ: {},
    CA: {},
    CC: {},
    CD: {},
    CF: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$"
    },
    CG: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$"
    },
    CH: {
        chars: 21,
        bban_regexp: "^[0-9]{5}[A-Z0-9]{12}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-4"
    },
    CI: {
        chars: 28,
        bban_regexp: "^[A-Z]{1}[0-9]{23}$"
    },
    CK: {},
    CL: {},
    CM: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$"
    },
    CN: {},
    CO: {},
    CR: {
        chars: 22,
        bban_regexp: "^[0-9]{18}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "8-22"
    },
    CU: {},
    CV: {
        chars: 25,
        bban_regexp: "^[0-9]{21}$"
    },
    CW: {},
    CX: {},
    CY: {
        chars: 28,
        bban_regexp: "^[0-9]{8}[A-Z0-9]{16}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "3-7",
        bank_identifier: "0-2",
        account_indentifier: "12-28"
    },
    CZ: {
        chars: 24,
        bban_regexp: "^[0-9]{20}$",
        bban_validation_func: $925c93fc4d221334$var$checkCzechAndSlovakBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-3"
    },
    DE: {
        chars: 22,
        bban_regexp: "^[0-9]{18}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-7",
        account_indentifier: "13-22"
    },
    DJ: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$",
        branch_indentifier: "5-9",
        bank_identifier: "0-4",
        account_indentifier: "14-27"
    },
    DK: {
        chars: 18,
        bban_regexp: "^[0-9]{14}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-3",
        account_indentifier: "4-18"
    },
    DM: {},
    DO: {
        chars: 28,
        bban_regexp: "^[A-Z]{4}[0-9]{20}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "8-28"
    },
    DZ: {
        chars: 26,
        bban_regexp: "^[0-9]{22}$"
    },
    EC: {},
    EE: {
        chars: 20,
        bban_regexp: "^[0-9]{16}$",
        bban_validation_func: $925c93fc4d221334$var$checkEstonianBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-1",
        account_indentifier: "8-20"
    },
    EG: {
        chars: 29,
        bban_regexp: "^[0-9]{25}",
        IBANRegistry: true,
        branch_indentifier: "4-7",
        bank_identifier: "0-3",
        account_indentifier: "17-29"
    },
    EH: {},
    ER: {},
    ES: {
        chars: 24,
        bban_validation_func: $925c93fc4d221334$var$checkSpainBBAN,
        bban_regexp: "^[0-9]{20}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "4-7",
        bank_identifier: "0-3",
        account_indentifier: "14-24"
    },
    ET: {},
    FI: {
        chars: 18,
        bban_regexp: "^[0-9]{14}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-2",
        account_indentifier: "0-0"
    },
    FJ: {},
    FK: {
        chars: 18,
        bban_regexp: "^[A-Z]{2}[0-9]{12}$",
        bank_identifier: "0-1",
        account_indentifier: "6-18"
    },
    FM: {},
    FO: {
        chars: 18,
        bban_regexp: "^[0-9]{14}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "4-18"
    },
    FR: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        bban_validation_func: $925c93fc4d221334$var$checkFrenchBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-4",
        branch_indentifier: "5-9",
        account_indentifier: "14-24"
    },
    GA: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$"
    },
    GB: {
        chars: 22,
        bban_regexp: "^[A-Z]{4}[0-9]{14}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "4-9",
        bank_identifier: "0-3"
    },
    GD: {},
    GE: {
        chars: 22,
        bban_regexp: "^[A-Z0-9]{2}[0-9]{16}$",
        IBANRegistry: true,
        bank_identifier: "0-1",
        account_indentifier: "6-22"
    },
    GF: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    GG: {},
    GH: {},
    GI: {
        chars: 23,
        bban_regexp: "^[A-Z]{4}[A-Z0-9]{15}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-3",
        account_indentifier: "8-23"
    },
    GL: {
        chars: 18,
        bban_regexp: "^[0-9]{14}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "4-18"
    },
    GM: {},
    GN: {},
    GP: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    GQ: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$"
    },
    GR: {
        chars: 27,
        bban_regexp: "^[0-9]{7}[A-Z0-9]{16}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "3-6",
        bank_identifier: "0-2",
        account_indentifier: "7-27"
    },
    GS: {},
    GT: {
        chars: 28,
        bban_regexp: "^[A-Z0-9]{24}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "8-28"
    },
    GU: {},
    GW: {
        chars: 25,
        bban_regexp: "^[A-Z]{2}[0-9]{19}$"
    },
    GY: {},
    HK: {},
    HM: {},
    HN: {
        chars: 28,
        bban_regexp: "^[A-Z]{4}[0-9]{20}$"
    },
    HR: {
        chars: 21,
        bban_regexp: "^[0-9]{17}$",
        bban_validation_func: $925c93fc4d221334$var$checkCroatianBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-6"
    },
    HT: {},
    HU: {
        chars: 28,
        bban_regexp: "^[0-9]{24}$",
        bban_validation_func: $925c93fc4d221334$var$checkHungarianBBAN,
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "3-6",
        bank_identifier: "0-2"
    },
    ID: {},
    IE: {
        chars: 22,
        bban_regexp: "^[A-Z0-9]{4}[0-9]{14}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "4-9",
        bank_identifier: "0-3"
    },
    IL: {
        chars: 23,
        bban_regexp: "^[0-9]{19}$",
        IBANRegistry: true,
        branch_indentifier: "3-5",
        bank_identifier: "0-2"
    },
    IM: {},
    IN: {},
    IO: {},
    IQ: {
        chars: 23,
        bban_regexp: "^[A-Z]{4}[0-9]{15}$",
        IBANRegistry: true,
        branch_indentifier: "4-6",
        bank_identifier: "0-3",
        account_indentifier: "11-23"
    },
    IR: {
        chars: 26,
        bban_regexp: "^[0-9]{22}$"
    },
    IS: {
        chars: 26,
        bban_regexp: "^[0-9]{22}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "2-3",
        bank_identifier: "0-1"
    },
    IT: {
        chars: 27,
        bban_regexp: "^[A-Z]{1}[0-9]{10}[A-Z0-9]{12}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "6-10",
        bank_identifier: "1-5",
        account_indentifier: "4-27"
    },
    JE: {},
    JM: {},
    JO: {
        chars: 30,
        bban_regexp: "^[A-Z]{4}[0-9]{4}[A-Z0-9]{18}$",
        IBANRegistry: true,
        branch_indentifier: "4-7",
        bank_identifier: "4-7"
    },
    JP: {},
    KE: {},
    KG: {},
    KH: {},
    KI: {},
    KM: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$"
    },
    KN: {},
    KP: {},
    KR: {},
    KW: {
        chars: 30,
        bban_regexp: "^[A-Z]{4}[A-Z0-9]{22}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "20-30"
    },
    KY: {},
    KZ: {
        chars: 20,
        bban_regexp: "^[0-9]{3}[A-Z0-9]{13}$",
        IBANRegistry: true,
        bank_identifier: "0-2",
        account_indentifier: "0-20"
    },
    LA: {},
    LB: {
        chars: 28,
        bban_regexp: "^[0-9]{4}[A-Z0-9]{20}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "14-28"
    },
    LC: {
        chars: 32,
        bban_regexp: "^[A-Z]{4}[A-Z0-9]{24}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "8-32"
    },
    LI: {
        chars: 21,
        bban_regexp: "^[0-9]{5}[A-Z0-9]{12}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-4"
    },
    LK: {},
    LR: {},
    LS: {},
    LT: {
        chars: 20,
        bban_regexp: "^[0-9]{16}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-4"
    },
    LU: {
        chars: 20,
        bban_regexp: "^[0-9]{3}[A-Z0-9]{13}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-2"
    },
    LV: {
        chars: 21,
        bban_regexp: "^[A-Z]{4}[A-Z0-9]{13}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-3",
        account_indentifier: "0-21"
    },
    LY: {
        chars: 25,
        bban_regexp: "^[0-9]{21}$",
        IBANRegistry: true,
        branch_indentifier: "3-5",
        bank_identifier: "0-2",
        account_indentifier: "10-25"
    },
    MA: {
        chars: 28,
        bban_regexp: "^[0-9]{24}$"
    },
    MC: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        bban_validation_func: $925c93fc4d221334$var$checkFrenchBBAN,
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "5-9",
        bank_identifier: "0-4"
    },
    MD: {
        chars: 24,
        bban_regexp: "^[A-Z0-9]{2}[A-Z0-9]{18}$",
        IBANRegistry: true,
        bank_identifier: "0-1",
        account_indentifier: "6-24"
    },
    ME: {
        chars: 22,
        bban_regexp: "^[0-9]{18}$",
        bban_validation_func: $925c93fc4d221334$var$checkMod9710BBAN,
        IBANRegistry: true,
        bank_identifier: "0-2",
        account_indentifier: "4-22"
    },
    MF: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    MG: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$"
    },
    MH: {},
    MK: {
        chars: 19,
        bban_regexp: "^[0-9]{3}[A-Z0-9]{10}[0-9]{2}$",
        bban_validation_func: $925c93fc4d221334$var$checkMod9710BBAN,
        IBANRegistry: true,
        bank_identifier: "0-2"
    },
    ML: {
        chars: 28,
        bban_regexp: "^[A-Z0-9]{2}[0-9]{22}$"
    },
    MM: {},
    MN: {
        chars: 20,
        bban_regexp: "^[0-9]{16}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "8-20"
    },
    MO: {},
    MP: {},
    MQ: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    MR: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$",
        IBANRegistry: true,
        branch_indentifier: "5-9",
        bank_identifier: "0-4",
        account_indentifier: "4-27"
    },
    MS: {},
    MT: {
        chars: 31,
        bban_regexp: "^[A-Z]{4}[0-9]{5}[A-Z0-9]{18}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "4-8",
        bank_identifier: "0-3",
        account_indentifier: "15-31"
    },
    MU: {
        chars: 30,
        bban_regexp: "^[A-Z]{4}[0-9]{19}[A-Z]{3}$",
        IBANRegistry: true,
        branch_indentifier: "6-7",
        bank_identifier: "0-5",
        account_indentifier: "0-30"
    },
    MV: {},
    MW: {},
    MX: {},
    MY: {},
    MZ: {
        chars: 25,
        bban_regexp: "^[0-9]{21}$"
    },
    NA: {},
    NC: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    NE: {
        chars: 28,
        bban_regexp: "^[A-Z]{2}[0-9]{22}$"
    },
    NF: {},
    NG: {},
    NI: {
        chars: 28,
        bban_regexp: "^[A-Z]{4}[0-9]{20}$",
        bank_identifier: "0-3",
        IBANRegistry: true,
        account_indentifier: "8-28"
    },
    NL: {
        chars: 18,
        bban_regexp: "^[A-Z]{4}[0-9]{10}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-3",
        account_indentifier: "8-18"
    },
    NO: {
        chars: 15,
        bban_regexp: "^[0-9]{11}$",
        bban_validation_func: $925c93fc4d221334$var$checkNorwayBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-3",
        account_indentifier: "4-15"
    },
    NP: {},
    NR: {},
    NU: {},
    NZ: {},
    OM: {
        chars: 23,
        bban_regexp: "^[0-9]{3}[A-Z0-9]{16}$",
        IBANRegistry: true,
        SEPA: false,
        bank_identifier: "0-2"
    },
    PA: {},
    PE: {},
    PF: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    PG: {},
    PH: {},
    PK: {
        chars: 24,
        bban_regexp: "^[A-Z0-9]{4}[0-9]{16}$",
        IBANRegistry: true,
        bank_identifier: "0-3"
    },
    PL: {
        chars: 28,
        bban_validation_func: $925c93fc4d221334$var$checkPolandBBAN,
        bban_regexp: "^[0-9]{24}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "0-7",
        account_indentifier: "2-28"
    },
    PM: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    PN: {},
    PR: {},
    PS: {
        chars: 29,
        bban_regexp: "^[A-Z0-9]{4}[0-9]{21}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "17-29"
    },
    PT: {
        chars: 25,
        bban_regexp: "^[0-9]{21}$",
        bban_validation_func: $925c93fc4d221334$var$checkMod9710BBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-3"
    },
    PW: {},
    PY: {},
    QA: {
        chars: 29,
        bban_regexp: "^[A-Z]{4}[A-Z0-9]{21}$",
        IBANRegistry: true,
        bank_identifier: "0-3",
        account_indentifier: "8-29"
    },
    RE: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    RO: {
        chars: 24,
        bban_regexp: "^[A-Z]{4}[A-Z0-9]{16}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-3",
        account_indentifier: "0-24"
    },
    RS: {
        chars: 22,
        bban_regexp: "^[0-9]{18}$",
        bban_validation_func: $925c93fc4d221334$var$checkMod9710BBAN,
        IBANRegistry: true,
        bank_identifier: "0-2"
    },
    RU: {
        chars: 33,
        bban_regexp: "^[0-9]{14}[A-Z0-9]{15}$",
        IBANRegistry: true,
        branch_indentifier: "9-13",
        bank_identifier: "0-8",
        account_indentifier: "13-33"
    },
    RW: {},
    SA: {
        chars: 24,
        bban_regexp: "^[0-9]{2}[A-Z0-9]{18}$",
        IBANRegistry: true,
        bank_identifier: "0-1",
        account_indentifier: "12-24"
    },
    SB: {},
    SC: {
        chars: 31,
        bban_regexp: "^[A-Z]{4}[0-9]{20}[A-Z]{3}$",
        IBANRegistry: true,
        branch_indentifier: "6-7",
        bank_identifier: "0-5",
        account_indentifier: "12-28"
    },
    SD: {
        chars: 18,
        bban_regexp: "^[0-9]{14}$",
        IBANRegistry: true,
        bank_identifier: "0-1",
        account_indentifier: "6-18"
    },
    SE: {
        chars: 24,
        bban_regexp: "^[0-9]{20}$",
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: "0-2"
    },
    SG: {},
    SH: {},
    SI: {
        chars: 19,
        bban_regexp: "^[0-9]{15}$",
        bban_validation_func: $925c93fc4d221334$var$checkMod9710BBAN,
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "2-4",
        bank_identifier: "0-1",
        account_indentifier: "9-16"
    },
    SJ: {},
    SK: {
        chars: 24,
        bban_regexp: "^[0-9]{20}$",
        bban_validation_func: $925c93fc4d221334$var$checkCzechAndSlovakBBAN,
        IBANRegistry: true,
        SEPA: true
    },
    SL: {},
    SM: {
        chars: 27,
        bban_regexp: "^[A-Z]{1}[0-9]{10}[A-Z0-9]{12}$",
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: "6-10"
    },
    SN: {
        chars: 28,
        bban_regexp: "^[A-Z]{2}[0-9]{22}$"
    },
    SO: {
        chars: 23,
        bban_regexp: "^[0-9]{19}$",
        IBANRegistry: true,
        branch_indentifier: "4-6",
        account_indentifier: "11-23"
    },
    SR: {},
    SS: {},
    ST: {
        chars: 25,
        bban_regexp: "^[0-9]{21}$",
        IBANRegistry: true,
        branch_indentifier: "4-7"
    },
    SV: {
        chars: 28,
        bban_regexp: "^[A-Z]{4}[0-9]{20}$",
        IBANRegistry: true,
        account_indentifier: "8-28"
    },
    SX: {},
    SY: {},
    SZ: {},
    TC: {},
    TD: {
        chars: 27,
        bban_regexp: "^[0-9]{23}$"
    },
    TF: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    TG: {
        chars: 28,
        bban_regexp: "^[A-Z]{2}[0-9]{22}$"
    },
    TH: {},
    TJ: {},
    TK: {},
    TL: {
        chars: 23,
        bban_regexp: "^[0-9]{19}$",
        IBANRegistry: true,
        account_indentifier: "4-23"
    },
    TM: {},
    TN: {
        chars: 24,
        bban_regexp: "^[0-9]{20}$",
        IBANRegistry: true,
        branch_indentifier: "2-4",
        account_indentifier: "4-24"
    },
    TO: {},
    TR: {
        chars: 26,
        bban_regexp: "^[0-9]{5}[A-Z0-9]{17}$",
        IBANRegistry: true
    },
    TT: {},
    TV: {},
    TW: {},
    TZ: {},
    UA: {
        chars: 29,
        bban_regexp: "^[0-9]{6}[A-Z0-9]{19}$",
        IBANRegistry: true,
        account_indentifier: "15-29"
    },
    UG: {},
    UM: {},
    US: {},
    UY: {},
    UZ: {},
    VA: {
        chars: 22,
        bban_regexp: "^[0-9]{18}",
        IBANRegistry: true,
        SEPA: true,
        account_indentifier: "7-22"
    },
    VC: {},
    VE: {},
    VG: {
        chars: 24,
        bban_regexp: "^[A-Z0-9]{4}[0-9]{16}$",
        IBANRegistry: true,
        account_indentifier: "8-24"
    },
    VI: {},
    VN: {},
    VU: {},
    WF: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    WS: {},
    XK: {
        chars: 20,
        bban_regexp: "^[0-9]{16}$",
        IBANRegistry: true,
        branch_indentifier: "2-3",
        account_indentifier: "4-20"
    },
    YE: {},
    YT: {
        chars: 27,
        bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
        IBANRegistry: true
    },
    ZA: {},
    ZM: {},
    ZW: {}
};

});



parcelRegister("7K2tQ", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("234Ty")).then(()=>parcelRequire("7doPn"));

});

parcelRegister("94iP7", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a316bb01cb7cab$export$2e2bcd8739ae039);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
    return hookCallback.apply(null, arguments);
}
// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback(callback) {
    hookCallback = callback;
}
function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
}
function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === "[object Object]";
}
function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
    else {
        var k;
        for(k in obj){
            if (hasOwnProp(obj, k)) return false;
        }
        return true;
    }
}
function isUndefined(input) {
    return input === void 0;
}
function isNumber(input) {
    return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
}
function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
}
function map(arr, fn) {
    var res = [], i, arrLen = arr.length;
    for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
    return res;
}
function extend(a, b) {
    for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
    if (hasOwnProp(b, "toString")) a.toString = b.toString;
    if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
    return a;
}
function createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}
function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
    };
}
function getParsingFlags(m) {
    if (m._pf == null) m._pf = defaultParsingFlags();
    return m._pf;
}
var some;
if (Array.prototype.some) some = Array.prototype.some;
else some = function(fun) {
    var t = Object(this), len = t.length >>> 0, i;
    for(i = 0; i < len; i++){
        if (i in t && fun.call(this, t[i], i, t)) return true;
    }
    return false;
};
function isValid(m) {
    var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
    if (isNowValid) {
        flags = getParsingFlags(m);
        parsedParts = some.call(flags.parsedDateParts, function(i) {
            return i != null;
        });
        isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
    }
    if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
    else return isNowValid;
    return m._isValid;
}
function createInvalid(flags) {
    var m = createUTC(NaN);
    if (flags != null) extend(getParsingFlags(m), flags);
    else getParsingFlags(m).userInvalidated = true;
    return m;
}
// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [], updateInProgress = false;
function copyConfig(to, from) {
    var i, prop, val, momentPropertiesLen = momentProperties.length;
    if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
    if (!isUndefined(from._i)) to._i = from._i;
    if (!isUndefined(from._f)) to._f = from._f;
    if (!isUndefined(from._l)) to._l = from._l;
    if (!isUndefined(from._strict)) to._strict = from._strict;
    if (!isUndefined(from._tzm)) to._tzm = from._tzm;
    if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
    if (!isUndefined(from._offset)) to._offset = from._offset;
    if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
    if (!isUndefined(from._locale)) to._locale = from._locale;
    if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
        prop = momentProperties[i];
        val = from[prop];
        if (!isUndefined(val)) to[prop] = val;
    }
    return to;
}
// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) this._d = new Date(NaN);
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}
function isMoment(obj) {
    return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
}
function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
}
function deprecate(msg, fn) {
    var firstTime = true;
    return extend(function() {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
        if (firstTime) {
            var args = [], arg, i, key, argLen = arguments.length;
            for(i = 0; i < argLen; i++){
                arg = "";
                if (typeof arguments[i] === "object") {
                    arg += "\n[" + i + "] ";
                    for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else arg = arguments[i];
                args.push(arg);
            }
            warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}
var deprecations = {};
function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}
hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;
function isFunction(input) {
    return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
}
function set(config) {
    var prop, i;
    for(i in config)if (hasOwnProp(config, i)) {
        prop = config[i];
        if (isFunction(prop)) this[i] = prop;
        else this["_" + i] = prop;
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
}
function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
        } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
        else delete res[prop];
    }
    for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
    res[prop] = extend({}, res[prop]);
    return res;
}
function Locale(config) {
    if (config != null) this.set(config);
}
var keys;
if (Object.keys) keys = Object.keys;
else keys = function(obj) {
    var i, res = [];
    for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
    return res;
};
var defaultCalendar = {
    sameDay: "[Today at] LT",
    nextDay: "[Tomorrow at] LT",
    nextWeek: "dddd [at] LT",
    lastDay: "[Yesterday at] LT",
    lastWeek: "[Last] dddd [at] LT",
    sameElse: "L"
};
function calendar(key, mom, now) {
    var output = this._calendar[key] || this._calendar["sameElse"];
    return isFunction(output) ? output.call(mom, now) : output;
}
function zeroFill(number, targetLength, forceSign) {
    var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
    return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === "string") func = function() {
        return this[callback]();
    };
    if (token) formatTokenFunctions[token] = func;
    if (padded) formatTokenFunctions[padded[0]] = function() {
        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
    };
    if (ordinal) formatTokenFunctions[ordinal] = function() {
        return this.localeData().ordinal(func.apply(this, arguments), token);
    };
}
function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
    return input.replace(/\\/g, "");
}
function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;
    for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
    else array[i] = removeFormattingTokens(array[i]);
    return function(mom) {
        var output = "", i;
        for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        return output;
    };
}
// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) return m.localeData().invalidDate();
    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
    return formatFunctions[format](m);
}
function expandFormat(format, locale) {
    var i = 5;
    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }
    localFormattingTokens.lastIndex = 0;
    while(i >= 0 && localFormattingTokens.test(format)){
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }
    return format;
}
var defaultLongDateFormat = {
    LTS: "h:mm:ss A",
    LT: "h:mm A",
    L: "MM/DD/YYYY",
    LL: "MMMM D, YYYY",
    LLL: "MMMM D, YYYY h:mm A",
    LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(key) {
    var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
    if (format || !formatUpper) return format;
    this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
        if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
        return tok;
    }).join("");
    return this._longDateFormat[key];
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
    return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(number) {
    return this._ordinal.replace("%d", number);
}
var defaultRelativeTime = {
    future: "in %s",
    past: "%s ago",
    s: "a few seconds",
    ss: "%d seconds",
    m: "a minute",
    mm: "%d minutes",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    w: "a week",
    ww: "%d weeks",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
};
function relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
}
function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? "future" : "past"];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}
var aliases = {
    D: "date",
    dates: "date",
    date: "date",
    d: "day",
    days: "day",
    day: "day",
    e: "weekday",
    weekdays: "weekday",
    weekday: "weekday",
    E: "isoWeekday",
    isoweekdays: "isoWeekday",
    isoweekday: "isoWeekday",
    DDD: "dayOfYear",
    dayofyears: "dayOfYear",
    dayofyear: "dayOfYear",
    h: "hour",
    hours: "hour",
    hour: "hour",
    ms: "millisecond",
    milliseconds: "millisecond",
    millisecond: "millisecond",
    m: "minute",
    minutes: "minute",
    minute: "minute",
    M: "month",
    months: "month",
    month: "month",
    Q: "quarter",
    quarters: "quarter",
    quarter: "quarter",
    s: "second",
    seconds: "second",
    second: "second",
    gg: "weekYear",
    weekyears: "weekYear",
    weekyear: "weekYear",
    GG: "isoWeekYear",
    isoweekyears: "isoWeekYear",
    isoweekyear: "isoWeekYear",
    w: "week",
    weeks: "week",
    week: "week",
    W: "isoWeek",
    isoweeks: "isoWeek",
    isoweek: "isoWeek",
    y: "year",
    years: "year",
    year: "year"
};
function normalizeUnits(units) {
    return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}
function normalizeObjectUnits(inputObject) {
    var normalizedInput = {}, normalizedProp, prop;
    for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
        normalizedProp = normalizeUnits(prop);
        if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
    }
    return normalizedInput;
}
var priorities = {
    date: 9,
    day: 11,
    weekday: 11,
    isoWeekday: 11,
    dayOfYear: 4,
    hour: 13,
    millisecond: 16,
    minute: 14,
    month: 8,
    quarter: 7,
    second: 15,
    weekYear: 1,
    isoWeekYear: 1,
    week: 5,
    isoWeek: 5,
    year: 1
};
function getPrioritizedUnits(unitsObj) {
    var units = [], u;
    for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
        unit: u,
        priority: priorities[u]
    });
    units.sort(function(a, b) {
        return a.priority - b.priority;
    });
    return units;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
regexes = {};
function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
    };
}
function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
    return regexes[token](config._strict, config._locale);
}
// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}
function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function absFloor(number) {
    if (number < 0) // -0 -> 0
    return Math.ceil(number) || 0;
    else return Math.floor(number);
}
function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion, value = 0;
    if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
    return value;
}
var tokens = {};
function addParseToken(token, callback) {
    var i, func = callback, tokenLen;
    if (typeof token === "string") token = [
        token
    ];
    if (isNumber(callback)) func = function(input, array) {
        array[callback] = toInt(input);
    };
    tokenLen = token.length;
    for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
}
function addWeekParseToken(token, callback) {
    addParseToken(token, function(input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}
function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
}
function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
// FORMATTING
addFormatToken("Y", 0, 0, function() {
    var y = this.year();
    return y <= 9999 ? zeroFill(y, 4) : "+" + y;
});
addFormatToken(0, [
    "YY",
    2
], 0, function() {
    return this.year() % 100;
});
addFormatToken(0, [
    "YYYY",
    4
], 0, "year");
addFormatToken(0, [
    "YYYYY",
    5
], 0, "year");
addFormatToken(0, [
    "YYYYYY",
    6,
    true
], 0, "year");
// PARSING
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken([
    "YYYYY",
    "YYYYYY"
], YEAR);
addParseToken("YYYY", function(input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken("YY", function(input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken("Y", function(input, array) {
    array[YEAR] = parseInt(input, 10);
});
// HELPERS
function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}
// HOOKS
hooks.parseTwoDigitYear = function(input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};
// MOMENTS
var getSetYear = makeGetSet("FullYear", true);
function getIsLeapYear() {
    return isLeapYear(this.year());
}
function makeGetSet(unit, keepTime) {
    return function(value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else return get(this, unit);
    };
}
function get(mom, unit) {
    if (!mom.isValid()) return NaN;
    var d = mom._d, isUTC = mom._isUTC;
    switch(unit){
        case "Milliseconds":
            return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
        case "Seconds":
            return isUTC ? d.getUTCSeconds() : d.getSeconds();
        case "Minutes":
            return isUTC ? d.getUTCMinutes() : d.getMinutes();
        case "Hours":
            return isUTC ? d.getUTCHours() : d.getHours();
        case "Date":
            return isUTC ? d.getUTCDate() : d.getDate();
        case "Day":
            return isUTC ? d.getUTCDay() : d.getDay();
        case "Month":
            return isUTC ? d.getUTCMonth() : d.getMonth();
        case "FullYear":
            return isUTC ? d.getUTCFullYear() : d.getFullYear();
        default:
            return NaN; // Just in case
    }
}
function set$1(mom, unit, value) {
    var d, isUTC, year, month, date;
    if (!mom.isValid() || isNaN(value)) return;
    d = mom._d;
    isUTC = mom._isUTC;
    switch(unit){
        case "Milliseconds":
            return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
        case "Seconds":
            return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
        case "Minutes":
            return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
        case "Hours":
            return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
        case "Date":
            return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
        // case 'Day': // Not real
        //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
        // case 'Month': // Not used because we need to pass two variables
        //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
        case "FullYear":
            break; // See below ...
        default:
            return; // Just in case
    }
    year = value;
    month = mom.month();
    date = mom.date();
    date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
    isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
}
// MOMENTS
function stringGet(units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) return this[units]();
    return this;
}
function stringSet(units, value) {
    if (typeof units === "object") {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
        for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units](value);
    }
    return this;
}
function mod(n, x) {
    return (n % x + x) % x;
}
var indexOf;
if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
else indexOf = function(o) {
    // I know
    var i;
    for(i = 0; i < this.length; ++i){
        if (this[i] === o) return i;
    }
    return -1;
};
function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) return NaN;
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
}
// FORMATTING
addFormatToken("M", [
    "MM",
    2
], "Mo", function() {
    return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(format) {
    return this.localeData().monthsShort(this, format);
});
addFormatToken("MMMM", 0, 0, function(format) {
    return this.localeData().months(this, format);
});
// PARSING
addRegexToken("M", match1to2, match1to2NoLeadingZero);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken("MMMM", function(isStrict, locale) {
    return locale.monthsRegex(isStrict);
});
addParseToken([
    "M",
    "MM"
], function(input, array) {
    array[MONTH] = toInt(input) - 1;
});
addParseToken([
    "MMM",
    "MMMM"
], function(input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) array[MONTH] = month;
    else getParsingFlags(config).invalidMonth = input;
});
// LOCALES
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(m, format) {
    if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
    return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
}
function localeMonthsShort(m, format) {
    if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
}
function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for(i = 0; i < 12; ++i){
            mom = createUTC([
                2000,
                i
            ]);
            this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
        }
    }
    if (strict) {
        if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else if (format === "MMM") {
        ii = indexOf.call(this._shortMonthsParse, llc);
        if (ii !== -1) return ii;
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
    } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        if (ii !== -1) return ii;
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
    }
}
function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;
    if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }
    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for(i = 0; i < 12; i++){
        // make the regex if we don't have it already
        mom = createUTC([
            2000,
            i
        ]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
            this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
        }
        if (!strict && !this._monthsParse[i]) {
            regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
            this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
        }
        // test the regex
        if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
        else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
        else if (!strict && this._monthsParse[i].test(monthName)) return i;
    }
}
// MOMENTS
function setMonth(mom, value) {
    if (!mom.isValid()) // No op
    return mom;
    if (typeof value === "string") {
        if (/^\d+$/.test(value)) value = toInt(value);
        else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) return mom;
        }
    }
    var month = value, date = mom.date();
    date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
    mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
    return mom;
}
function getSetMonth(value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else return get(this, "Month");
}
function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
        if (isStrict) return this._monthsShortStrictRegex;
        else return this._monthsShortRegex;
    } else {
        if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}
function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
        if (isStrict) return this._monthsStrictRegex;
        else return this._monthsRegex;
    } else {
        if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
    }
}
function computeMonthsParse() {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }
    var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
    for(i = 0; i < 12; i++){
        // make the regex if we don't have it already
        mom = createUTC([
            2000,
            i
        ]);
        shortP = regexEscape(this.monthsShort(mom, ""));
        longP = regexEscape(this.months(mom, ""));
        shortPieces.push(shortP);
        longPieces.push(longP);
        mixedPieces.push(longP);
        mixedPieces.push(shortP);
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
    this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
}
function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date;
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) date.setFullYear(y);
    } else date = new Date(y, m, d, h, M, s, ms);
    return date;
}
function createUTCDate(y) {
    var date, args;
    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        // preserve leap years using a full 400 year cycle, then reset
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
    } else date = new Date(Date.UTC.apply(null, arguments));
    return date;
}
// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
    fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }
    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}
function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }
    return {
        week: resWeek,
        year: resYear
    };
}
function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
// FORMATTING
addFormatToken("w", [
    "ww",
    2
], "wo", "week");
addFormatToken("W", [
    "WW",
    2
], "Wo", "isoWeek");
// PARSING
addRegexToken("w", match1to2, match1to2NoLeadingZero);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2, match1to2NoLeadingZero);
addRegexToken("WW", match1to2, match2);
addWeekParseToken([
    "w",
    "ww",
    "W",
    "WW"
], function(input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});
// HELPERS
// LOCALES
function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
    dow: 0,
    doy: 6
};
function localeFirstDayOfWeek() {
    return this._week.dow;
}
function localeFirstDayOfYear() {
    return this._week.doy;
}
// MOMENTS
function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, "d");
}
function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, "d");
}
// FORMATTING
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(format) {
    return this.localeData().weekdaysMin(this, format);
});
addFormatToken("ddd", 0, 0, function(format) {
    return this.localeData().weekdaysShort(this, format);
});
addFormatToken("dddd", 0, 0, function(format) {
    return this.localeData().weekdays(this, format);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
// PARSING
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken("ddd", function(isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken("dddd", function(isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});
addWeekParseToken([
    "dd",
    "ddd",
    "dddd"
], function(input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) week.d = weekday;
    else getParsingFlags(config).invalidWeekday = input;
});
addWeekParseToken([
    "d",
    "e",
    "E"
], function(input, week, config, token) {
    week[token] = toInt(input);
});
// HELPERS
function parseWeekday(input, locale) {
    if (typeof input !== "string") return input;
    if (!isNaN(input)) return parseInt(input, 10);
    input = locale.weekdaysParse(input);
    if (typeof input === "number") return input;
    return null;
}
function parseIsoWeekday(input, locale) {
    if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
    return isNaN(input) ? null : input;
}
// LOCALES
function shiftWeekdays(ws, n) {
    return ws.slice(n, 7).concat(ws.slice(0, n));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(m, format) {
    var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
    return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
}
function localeWeekdaysShort(m) {
    return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(m) {
    return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}
function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for(i = 0; i < 7; ++i){
            mom = createUTC([
                2000,
                1
            ]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
        }
    }
    if (strict) {
        if (format === "dddd") {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === "ddd") {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === "dddd") {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === "ddd") {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}
function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;
    if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }
    for(i = 0; i < 7; i++){
        // make the regex if we don't have it already
        mom = createUTC([
            2000,
            1
        ]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
            this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
            this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
        }
        if (!this._weekdaysParse[i]) {
            regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
            this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
        }
        // test the regex
        if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
        else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
        else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
        else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
    }
}
// MOMENTS
function getSetDayOfWeek(input) {
    if (!this.isValid()) return input != null ? this : NaN;
    var day = get(this, "Day");
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, "d");
    } else return day;
}
function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) return input != null ? this : NaN;
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, "d");
}
function getSetISODayOfWeek(input) {
    if (!this.isValid()) return input != null ? this : NaN;
    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.
    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else return this.day() || 7;
}
function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
        if (isStrict) return this._weekdaysStrictRegex;
        else return this._weekdaysRegex;
    } else {
        if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}
function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
        if (isStrict) return this._weekdaysShortStrictRegex;
        else return this._weekdaysShortRegex;
    } else {
        if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}
function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
        if (isStrict) return this._weekdaysMinStrictRegex;
        else return this._weekdaysMinRegex;
    } else {
        if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}
function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }
    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
    for(i = 0; i < 7; i++){
        // make the regex if we don't have it already
        mom = createUTC([
            2000,
            1
        ]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ""));
        shortp = regexEscape(this.weekdaysShort(mom, ""));
        longp = regexEscape(this.weekdays(mom, ""));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;
    this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
    this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
}
// FORMATTING
function hFormat() {
    return this.hours() % 12 || 12;
}
function kFormat() {
    return this.hours() || 24;
}
addFormatToken("H", [
    "HH",
    2
], 0, "hour");
addFormatToken("h", [
    "hh",
    2
], 0, hFormat);
addFormatToken("k", [
    "kk",
    2
], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
    return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
    return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
    return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
    return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function() {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}
meridiem("a", true);
meridiem("A", false);
// PARSING
function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2, match1to2HasZero);
addRegexToken("h", match1to2, match1to2NoLeadingZero);
addRegexToken("k", match1to2, match1to2NoLeadingZero);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken([
    "H",
    "HH"
], HOUR);
addParseToken([
    "k",
    "kk"
], function(input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken([
    "a",
    "A"
], function(input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken([
    "h",
    "hh"
], function(input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken("hmm", function(input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken("hmmss", function(input, array, config) {
    var pos1 = input.length - 4, pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken("Hmm", function(input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken("Hmmss", function(input, array, config) {
    var pos1 = input.length - 4, pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});
// LOCALES
function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return (input + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
// specified which hour they want. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
getSetHour = makeGetSet("Hours", true);
function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) return isLower ? "pm" : "PM";
    else return isLower ? "am" : "AM";
}
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,
    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,
    week: defaultLocaleWeek,
    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,
    meridiemParse: defaultLocaleMeridiemParse
};
// internal storage for locale config files
var locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(arr1, arr2) {
    var i, minl = Math.min(arr1.length, arr2.length);
    for(i = 0; i < minl; i += 1){
        if (arr1[i] !== arr2[i]) return i;
    }
    return minl;
}
function normalizeLocale(key) {
    return key ? key.toLowerCase().replace("_", "-") : key;
}
// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;
    while(i < names.length){
        split = normalizeLocale(names[i]).split("-");
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split("-") : null;
        while(j > 0){
            locale = loadLocale(split.slice(0, j).join("-"));
            if (locale) return locale;
            if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
            j--;
        }
        i++;
    }
    return globalLocale;
}
function isLocaleNameSane(name) {
    // Prevent names that look like filesystem paths, i.e contain '/' or '\'
    // Ensure name is available and function returns boolean
    return !!(name && name.match("^[^/\\\\]*$"));
}
function loadLocale(name) {
    var oldLocale = null, aliasedRequire;
    // TODO: Find a better way to register and load all the locales in Node
    if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
        oldLocale = globalLocale._abbr;
        aliasedRequire = undefined;
        aliasedRequire("./locale/" + name);
        getSetGlobalLocale(oldLocale);
    } catch (e) {
        // mark as not found to avoid repeating expensive file require call causing high CPU
        // when trying to find en-US, en_US, en-us for every format call
        locales[name] = null; // null means not found
    }
    return locales[name];
}
// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale(key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) data = getLocale(key);
        else data = defineLocale(key, values);
        if (data) // moment.duration._locale = moment._locale = data;
        globalLocale = data;
        else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
        console.warn("Locale " + key + " not found. Did you forget to load it?");
    }
    return globalLocale._abbr;
}
function defineLocale(name, config) {
    if (config !== null) {
        var locale, parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
            else {
                locale = loadLocale(config.parentLocale);
                if (locale != null) parentConfig = locale._config;
                else {
                    if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
            defineLocale(x.name, x.config);
        });
        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);
        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}
function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
        locales[name].set(mergeConfigs(locales[name]._config, config));
        else {
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) parentConfig = tmpLocale._config;
            config = mergeConfigs(parentConfig, config);
            if (tmpLocale == null) // updateLocale is called for creating a new locale
            // Set abbr so it will have a name (getters return
            // undefined otherwise).
            config.abbr = name;
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;
        }
        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else // pass null for config to unupdate, useful for tests
    if (locales[name] != null) {
        if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
            if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
        } else if (locales[name] != null) delete locales[name];
    }
    return locales[name];
}
// returns locale data
function getLocale(key) {
    var locale;
    if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
    if (!key) return globalLocale;
    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) return locale;
        key = [
            key
        ];
    }
    return chooseLocale(key);
}
function listLocales() {
    return keys(locales);
}
function checkOverflow(m) {
    var overflow, a = m._a;
    if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
        getParsingFlags(m).overflow = overflow;
    }
    return m;
}
// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
    [
        "YYYYYY-MM-DD",
        /[+-]\d{6}-\d\d-\d\d/
    ],
    [
        "YYYY-MM-DD",
        /\d{4}-\d\d-\d\d/
    ],
    [
        "GGGG-[W]WW-E",
        /\d{4}-W\d\d-\d/
    ],
    [
        "GGGG-[W]WW",
        /\d{4}-W\d\d/,
        false
    ],
    [
        "YYYY-DDD",
        /\d{4}-\d{3}/
    ],
    [
        "YYYY-MM",
        /\d{4}-\d\d/,
        false
    ],
    [
        "YYYYYYMMDD",
        /[+-]\d{10}/
    ],
    [
        "YYYYMMDD",
        /\d{8}/
    ],
    [
        "GGGG[W]WWE",
        /\d{4}W\d{3}/
    ],
    [
        "GGGG[W]WW",
        /\d{4}W\d{2}/,
        false
    ],
    [
        "YYYYDDD",
        /\d{7}/
    ],
    [
        "YYYYMM",
        /\d{6}/,
        false
    ],
    [
        "YYYY",
        /\d{4}/,
        false
    ]
], // iso time formats and regexes
isoTimes = [
    [
        "HH:mm:ss.SSSS",
        /\d\d:\d\d:\d\d\.\d+/
    ],
    [
        "HH:mm:ss,SSSS",
        /\d\d:\d\d:\d\d,\d+/
    ],
    [
        "HH:mm:ss",
        /\d\d:\d\d:\d\d/
    ],
    [
        "HH:mm",
        /\d\d:\d\d/
    ],
    [
        "HHmmss.SSSS",
        /\d\d\d\d\d\d\.\d+/
    ],
    [
        "HHmmss,SSSS",
        /\d\d\d\d\d\d,\d+/
    ],
    [
        "HHmmss",
        /\d\d\d\d\d\d/
    ],
    [
        "HHmm",
        /\d\d\d\d/
    ],
    [
        "HH",
        /\d\d/
    ]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
// date from iso format
function configFromISO(config) {
    var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
    if (match) {
        getParsingFlags(config).iso = true;
        for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                // match[2] should be 'T' or space
                timeFormat = (match[2] || " ") + isoTimes[i][0];
                break;
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) tzFormat = "Z";
            else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
        configFromStringAndFormat(config);
    } else config._isValid = false;
}
function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];
    if (secondStr) result.push(parseInt(secondStr, 10));
    return result;
}
function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) return 2000 + year;
    else if (year <= 999) return 1900 + year;
    return year;
}
function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}
function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) return obsOffsets[obsOffset];
    else if (militaryOffset) // the only allowed military tz is Z
    return 0;
    else {
        var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}
// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
    if (match) {
        parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) return;
        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
    } else config._isValid = false;
}
// date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);
    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }
    configFromISO(config);
    if (config._isValid === false) delete config._isValid;
    else return;
    configFromRFC2822(config);
    if (config._isValid === false) delete config._isValid;
    else return;
    if (config._strict) config._isValid = false;
    else // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}
hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
    config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
});
// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) return a;
    if (b != null) return b;
    return c;
}
function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) return [
        nowValue.getUTCFullYear(),
        nowValue.getUTCMonth(),
        nowValue.getUTCDate()
    ];
    return [
        nowValue.getFullYear(),
        nowValue.getMonth(),
        nowValue.getDate()
    ];
}
// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray(config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
    if (config._d) return;
    currentDate = currentDateArray(config);
    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }
    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
    // Zero out whatever was not defaulted, including time
    for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }
    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    if (config._nextDay) config._a[HOUR] = 24;
    // check for mismatching day of week
    if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
}
function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;
        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) weekdayOverflow = true;
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
        // Default to current week.
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) weekdayOverflow = true;
        } else if (w.e != null) {
            // local weekday -- counting starts from beginning of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) weekdayOverflow = true;
        } else // default to beginning of week
        weekday = dow;
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
    else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
    else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}
// constant that refers to the ISO standard
hooks.ISO_8601 = function() {};
// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function() {};
// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;
    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
    tokenLen = tokens.length;
    for(i = 0; i < tokenLen; i++){
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) getParsingFlags(config).empty = false;
            else getParsingFlags(config).unusedTokens.push(token);
            addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
    }
    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
    // handle era
    era = getParsingFlags(config).era;
    if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
    configFromArray(config);
    checkOverflow(config);
}
function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;
    if (meridiem == null) // nothing to do
    return hour;
    if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
    else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) hour += 12;
        if (!isPm && hour === 12) hour = 0;
        return hour;
    } else // this is not supposed to happen
    return hour;
}
// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
    if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }
    for(i = 0; i < configfLen; i++){
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) validFormatFound = true;
        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;
        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
            if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
                if (validFormatFound) bestFormatIsValid = true;
            }
        } else if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }
    extend(config, bestMoment || tempConfig);
}
function configFromObject(config) {
    if (config._d) return;
    var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
    config._a = map([
        i.year,
        i.month,
        dayOrDate,
        i.hour,
        i.minute,
        i.second,
        i.millisecond
    ], function(obj) {
        return obj && parseInt(obj, 10);
    });
    configFromArray(config);
}
function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, "d");
        res._nextDay = undefined;
    }
    return res;
}
function prepareConfig(config) {
    var input = config._i, format = config._f;
    config._locale = config._locale || getLocale(config._l);
    if (input === null || format === undefined && input === "") return createInvalid({
        nullInput: true
    });
    if (typeof input === "string") config._i = input = config._locale.preparse(input);
    if (isMoment(input)) return new Moment(checkOverflow(input));
    else if (isDate(input)) config._d = input;
    else if (isArray(format)) configFromStringAndArray(config);
    else if (format) configFromStringAndFormat(config);
    else configFromInput(config);
    if (!isValid(config)) config._d = null;
    return config;
}
function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) config._d = new Date(hooks.now());
    else if (isDate(input)) config._d = new Date(input.valueOf());
    else if (typeof input === "string") configFromString(config);
    else if (isArray(input)) {
        config._a = map(input.slice(0), function(obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) configFromObject(config);
    else if (isNumber(input)) // from milliseconds
    config._d = new Date(input);
    else hooks.createFromInputFallback(config);
}
function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};
    if (format === true || format === false) {
        strict = format;
        format = undefined;
    }
    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }
    if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;
    return createFromConfig(c);
}
function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}
var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) return other < this ? this : other;
    else return createInvalid();
}), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) return other > this ? this : other;
    else return createInvalid();
});
// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
    if (!moments.length) return createLocal();
    res = moments[0];
    for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
    return res;
}
// TODO: Use [].sort instead?
function min() {
    var args = [].slice.call(arguments, 0);
    return pickBy("isBefore", args);
}
function max() {
    var args = [].slice.call(arguments, 0);
    return pickBy("isAfter", args);
}
var now = function() {
    return Date.now ? Date.now() : +new Date();
};
var ordering = [
    "year",
    "quarter",
    "month",
    "week",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
function isDurationValid(m) {
    var key, unitHasDecimal = false, i, orderLen = ordering.length;
    for(key in m){
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
    }
    for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
        if (unitHasDecimal) return false; // only allow non-integers for smallest unit
        if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
    }
    return true;
}
function isValid$1() {
    return this._isValid;
}
function createInvalid$1() {
    return createDuration(NaN);
}
function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
    this._isValid = isDurationValid(normalizedInput);
    // representation for dateAddRemove
    this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
    minutes * 6e4 + // 1000 * 60
    hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days + weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months + quarters * 3 + years * 12;
    this._data = {};
    this._locale = getLocale();
    this._bubble();
}
function isDuration(obj) {
    return obj instanceof Duration;
}
function absRound(number) {
    if (number < 0) return Math.round(-1 * number) * -1;
    else return Math.round(number);
}
// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
    for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
    return diffs + lengthDiff;
}
// FORMATTING
function offset(token, separator) {
    addFormatToken(token, 0, 0, function() {
        var offset = this.utcOffset(), sign = "+";
        if (offset < 0) {
            offset = -offset;
            sign = "-";
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
    });
}
offset("Z", ":");
offset("ZZ", "");
// PARSING
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken([
    "Z",
    "ZZ"
], function(input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});
// HELPERS
// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(matcher, string) {
    var matches = (string || "").match(matcher), chunk, parts, minutes;
    if (matches === null) return null;
    chunk = matches[matches.length - 1] || [];
    parts = (chunk + "").match(chunkOffset) || [
        "-",
        0,
        0
    ];
    minutes = +(parts[1] * 60) + toInt(parts[2]);
    return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
}
// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else return createLocal(input).local();
}
function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset());
}
// HOOKS
// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function() {};
// MOMENTS
// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0, localAdjust;
    if (!this.isValid()) return input != null ? this : NaN;
    if (input != null) {
        if (typeof input === "string") {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) return this;
        } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
        if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) this.add(localAdjust, "m");
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
            else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else return this._isUTC ? offset : getDateOffset(this);
}
function getSetZone(input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== "string") input = -input;
        this.utcOffset(input, keepLocalTime);
        return this;
    } else return -this.utcOffset();
}
function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}
function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) this.subtract(getDateOffset(this), "m");
    }
    return this;
}
function setOffsetToParsedOffset() {
    if (this._tzm != null) this.utcOffset(this._tzm, false, true);
    else if (typeof this._i === "string") {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) this.utcOffset(tZone);
        else this.utcOffset(0, true);
    }
    return this;
}
function hasAlignedHourOffset(input) {
    if (!this.isValid()) return false;
    input = input ? createLocal(input).utcOffset() : 0;
    return (this.utcOffset() - input) % 60 === 0;
}
function isDaylightSavingTime() {
    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
    var c = {}, other;
    copyConfig(c, this);
    c = prepareConfig(c);
    if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
    } else this._isDSTShifted = false;
    return this._isDSTShifted;
}
function isLocal() {
    return this.isValid() ? !this._isUTC : false;
}
function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
}
function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
// ASP.NET json date format regex
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(input, key) {
    var duration = input, // matching against regexp is expensive, do it on demand
    match = null, sign, ret, diffRes;
    if (isDuration(input)) duration = {
        ms: input._milliseconds,
        d: input._days,
        M: input._months
    };
    else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) duration[key] = +input;
        else duration.milliseconds = +input;
    } else if (match = aspNetRegex.exec(input)) {
        sign = match[1] === "-" ? -1 : 1;
        duration = {
            y: 0,
            d: toInt(match[DATE]) * sign,
            h: toInt(match[HOUR]) * sign,
            m: toInt(match[MINUTE]) * sign,
            s: toInt(match[SECOND]) * sign,
            ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
        };
    } else if (match = isoRegex.exec(input)) {
        sign = match[1] === "-" ? -1 : 1;
        duration = {
            y: parseIso(match[2], sign),
            M: parseIso(match[3], sign),
            w: parseIso(match[4], sign),
            d: parseIso(match[5], sign),
            h: parseIso(match[6], sign),
            m: parseIso(match[7], sign),
            s: parseIso(match[8], sign)
        };
    } else if (duration == null) // checks for null or undefined
    duration = {};
    else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }
    ret = new Duration(duration);
    if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
    if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
    return ret;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(",", "."));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}
function positiveMomentsDifference(base, other) {
    var res = {};
    res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
    res.milliseconds = +other - +base.clone().add(res.months, "M");
    return res;
}
function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) return {
        milliseconds: 0,
        months: 0
    };
    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
    else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }
    return res;
}
// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function(val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
            tmp = val;
            val = period;
            period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}
function addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
    if (!mom.isValid()) // No op
    return;
    updateOffset = updateOffset == null ? true : updateOffset;
    if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
    if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
    if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    if (updateOffset) hooks.updateOffset(mom, days || months);
}
var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString(input) {
    return typeof input === "string" || input instanceof String;
}
// type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
function isMomentInput(input) {
    return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
}
function isMomentInputObject(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
        "years",
        "year",
        "y",
        "months",
        "month",
        "M",
        "days",
        "day",
        "d",
        "dates",
        "date",
        "D",
        "hours",
        "hour",
        "h",
        "minutes",
        "minute",
        "m",
        "seconds",
        "second",
        "s",
        "milliseconds",
        "millisecond",
        "ms"
    ], i, property, propertyLen = properties.length;
    for(i = 0; i < propertyLen; i += 1){
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
    }
    return objectTest && propertyTest;
}
function isNumberOrStringArray(input) {
    var arrayTest = isArray(input), dataTypeTest = false;
    if (arrayTest) dataTypeTest = input.filter(function(item) {
        return !isNumber(item) && isString(input);
    }).length === 0;
    return arrayTest && dataTypeTest;
}
function isCalendarSpec(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
        "sameDay",
        "nextDay",
        "lastDay",
        "nextWeek",
        "lastWeek",
        "sameElse"
    ], i, property;
    for(i = 0; i < properties.length; i += 1){
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
    }
    return objectTest && propertyTest;
}
function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, "days", true);
    return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(time, formats) {
    // Support for single parameter, formats only overload to the calendar function
    if (arguments.length === 1) {
        if (!arguments[0]) {
            time = undefined;
            formats = undefined;
        } else if (isMomentInput(arguments[0])) {
            time = arguments[0];
            formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
            formats = arguments[0];
            time = undefined;
        }
    }
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}
function clone() {
    return new Moment(this);
}
function isAfter(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) return false;
    units = normalizeUnits(units) || "millisecond";
    if (units === "millisecond") return this.valueOf() > localInput.valueOf();
    else return localInput.valueOf() < this.clone().startOf(units).valueOf();
}
function isBefore(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) return false;
    units = normalizeUnits(units) || "millisecond";
    if (units === "millisecond") return this.valueOf() < localInput.valueOf();
    else return this.clone().endOf(units).valueOf() < localInput.valueOf();
}
function isBetween(from, to, units, inclusivity) {
    var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
    inclusivity = inclusivity || "()";
    return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
}
function isSame(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input), inputMs;
    if (!(this.isValid() && localInput.isValid())) return false;
    units = normalizeUnits(units) || "millisecond";
    if (units === "millisecond") return this.valueOf() === localInput.valueOf();
    else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}
function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
}
function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
}
function diff(input, units, asFloat) {
    var that, zoneDelta, output;
    if (!this.isValid()) return NaN;
    that = cloneWithOffset(input, this);
    if (!that.isValid()) return NaN;
    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
    units = normalizeUnits(units);
    switch(units){
        case "year":
            output = monthDiff(this, that) / 12;
            break;
        case "month":
            output = monthDiff(this, that);
            break;
        case "quarter":
            output = monthDiff(this, that) / 3;
            break;
        case "second":
            output = (this - that) / 1e3;
            break; // 1000
        case "minute":
            output = (this - that) / 6e4;
            break; // 1000 * 60
        case "hour":
            output = (this - that) / 36e5;
            break; // 1000 * 60 * 60
        case "day":
            output = (this - that - zoneDelta) / 864e5;
            break; // 1000 * 60 * 60 * 24, negate dst
        case "week":
            output = (this - that - zoneDelta) / 6048e5;
            break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default:
            output = this - that;
    }
    return asFloat ? output : absFloor(output);
}
function monthDiff(a, b) {
    if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
    // days than the end month.
    return -monthDiff(b, a);
    // difference in months
    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
    anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }
    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString() {
    return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(keepOffset) {
    if (!this.isValid()) return null;
    var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) return this.toDate().toISOString();
        else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
    }
    return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
}
/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */ function inspect() {
    if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
    var func = "moment", zone = "", prefix, year, datetime, suffix;
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
        zone = "Z";
    }
    prefix = "[" + func + '("]';
    year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
    datetime = "-MM-DD[T]HH:mm:ss.SSS";
    suffix = zone + '[")]';
    return this.format(prefix + year + datetime + suffix);
}
function format(inputString) {
    if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}
function from(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
        to: this,
        from: time
    }).locale(this.locale()).humanize(!withoutSuffix);
    else return this.localeData().invalidDate();
}
function fromNow(withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}
function to(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
        from: this,
        to: time
    }).locale(this.locale()).humanize(!withoutSuffix);
    else return this.localeData().invalidDate();
}
function toNow(withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}
// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale(key) {
    var newLocaleData;
    if (key === undefined) return this._locale._abbr;
    else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) this._locale = newLocaleData;
        return this;
    }
}
var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
    if (key === undefined) return this.localeData();
    else return this.locale(key);
});
function localeData() {
    return this._locale;
}
var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
// actual modulo - handles negative numbers (for dates before 1970):
function mod$1(dividend, divisor) {
    return (dividend % divisor + divisor) % divisor;
}
function localStartOfDate(y, m, d) {
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
    return new Date(y + 400, m, d) - MS_PER_400_YEARS;
    else return new Date(y, m, d).valueOf();
}
function utcStartOfDate(y, m, d) {
    // Date.UTC remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
    return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
    else return Date.UTC(y, m, d);
}
function startOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === undefined || units === "millisecond" || !this.isValid()) return this;
    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
    switch(units){
        case "year":
            time = startOfDate(this.year(), 0, 1);
            break;
        case "quarter":
            time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
            break;
        case "month":
            time = startOfDate(this.year(), this.month(), 1);
            break;
        case "week":
            time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
            break;
        case "isoWeek":
            time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
            break;
        case "day":
        case "date":
            time = startOfDate(this.year(), this.month(), this.date());
            break;
        case "hour":
            time = this._d.valueOf();
            time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
            break;
        case "minute":
            time = this._d.valueOf();
            time -= mod$1(time, MS_PER_MINUTE);
            break;
        case "second":
            time = this._d.valueOf();
            time -= mod$1(time, MS_PER_SECOND);
            break;
    }
    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
}
function endOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === undefined || units === "millisecond" || !this.isValid()) return this;
    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
    switch(units){
        case "year":
            time = startOfDate(this.year() + 1, 0, 1) - 1;
            break;
        case "quarter":
            time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
            break;
        case "month":
            time = startOfDate(this.year(), this.month() + 1, 1) - 1;
            break;
        case "week":
            time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
            break;
        case "isoWeek":
            time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
            break;
        case "day":
        case "date":
            time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
            break;
        case "hour":
            time = this._d.valueOf();
            time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
            break;
        case "minute":
            time = this._d.valueOf();
            time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
            break;
        case "second":
            time = this._d.valueOf();
            time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
            break;
    }
    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
}
function valueOf() {
    return this._d.valueOf() - (this._offset || 0) * 60000;
}
function unix() {
    return Math.floor(this.valueOf() / 1000);
}
function toDate() {
    return new Date(this.valueOf());
}
function toArray() {
    var m = this;
    return [
        m.year(),
        m.month(),
        m.date(),
        m.hour(),
        m.minute(),
        m.second(),
        m.millisecond()
    ];
}
function toObject() {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}
function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
    return isValid(this);
}
function parsingFlags() {
    return extend({}, getParsingFlags(this));
}
function invalidAt() {
    return getParsingFlags(this).overflow;
}
function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", [
    "y",
    1
], "yo", "eraYear");
addFormatToken("y", [
    "yy",
    2
], 0, "eraYear");
addFormatToken("y", [
    "yyy",
    3
], 0, "eraYear");
addFormatToken("y", [
    "yyyy",
    4
], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken([
    "N",
    "NN",
    "NNN",
    "NNNN",
    "NNNNN"
], function(input, array, config, token) {
    var era = config._locale.erasParse(input, token, config._strict);
    if (era) getParsingFlags(config).era = era;
    else getParsingFlags(config).invalidEra = input;
});
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken([
    "y",
    "yy",
    "yyy",
    "yyyy"
], YEAR);
addParseToken([
    "yo"
], function(input, array, config, token) {
    var match;
    if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
    if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
    else array[YEAR] = parseInt(input, 10);
});
function localeEras(m, format) {
    var i, l, date, eras = this._eras || getLocale("en")._eras;
    for(i = 0, l = eras.length; i < l; ++i){
        switch(typeof eras[i].since){
            case "string":
                // truncate time
                date = hooks(eras[i].since).startOf("day");
                eras[i].since = date.valueOf();
                break;
        }
        switch(typeof eras[i].until){
            case "undefined":
                eras[i].until = Infinity;
                break;
            case "string":
                // truncate time
                date = hooks(eras[i].until).startOf("day").valueOf();
                eras[i].until = date.valueOf();
                break;
        }
    }
    return eras;
}
function localeErasParse(eraName, format, strict) {
    var i, l, eras = this.eras(), name, abbr, narrow;
    eraName = eraName.toUpperCase();
    for(i = 0, l = eras.length; i < l; ++i){
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();
        if (strict) switch(format){
            case "N":
            case "NN":
            case "NNN":
                if (abbr === eraName) return eras[i];
                break;
            case "NNNN":
                if (name === eraName) return eras[i];
                break;
            case "NNNNN":
                if (narrow === eraName) return eras[i];
                break;
        }
        else if ([
            name,
            abbr,
            narrow
        ].indexOf(eraName) >= 0) return eras[i];
    }
}
function localeErasConvertYear(era, year) {
    var dir = era.since <= era.until ? 1 : -1;
    if (year === undefined) return hooks(era.since).year();
    else return hooks(era.since).year() + (year - era.offset) * dir;
}
function getEraName() {
    var i, l, val, eras = this.localeData().eras();
    for(i = 0, l = eras.length; i < l; ++i){
        // truncate time
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
        if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
    }
    return "";
}
function getEraNarrow() {
    var i, l, val, eras = this.localeData().eras();
    for(i = 0, l = eras.length; i < l; ++i){
        // truncate time
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
        if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
    }
    return "";
}
function getEraAbbr() {
    var i, l, val, eras = this.localeData().eras();
    for(i = 0, l = eras.length; i < l; ++i){
        // truncate time
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
        if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
    }
    return "";
}
function getEraYear() {
    var i, l, dir, val, eras = this.localeData().eras();
    for(i = 0, l = eras.length; i < l; ++i){
        dir = eras[i].since <= eras[i].until ? 1 : -1;
        // truncate time
        val = this.clone().startOf("day").valueOf();
        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
    }
    return this.year();
}
function erasNameRegex(isStrict) {
    if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
    return isStrict ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(isStrict) {
    if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
    return isStrict ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(isStrict) {
    if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
    return isStrict ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(isStrict, locale) {
    return locale.erasAbbrRegex(isStrict);
}
function matchEraName(isStrict, locale) {
    return locale.erasNameRegex(isStrict);
}
function matchEraNarrow(isStrict, locale) {
    return locale.erasNarrowRegex(isStrict);
}
function matchEraYearOrdinal(isStrict, locale) {
    return locale._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
    var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
    for(i = 0, l = eras.length; i < l; ++i){
        erasName = regexEscape(eras[i].name);
        erasAbbr = regexEscape(eras[i].abbr);
        erasNarrow = regexEscape(eras[i].narrow);
        namePieces.push(erasName);
        abbrPieces.push(erasAbbr);
        narrowPieces.push(erasNarrow);
        mixedPieces.push(erasName);
        mixedPieces.push(erasAbbr);
        mixedPieces.push(erasNarrow);
    }
    this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
    this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
    this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
    this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
}
// FORMATTING
addFormatToken(0, [
    "gg",
    2
], 0, function() {
    return this.weekYear() % 100;
});
addFormatToken(0, [
    "GG",
    2
], 0, function() {
    return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [
        token,
        token.length
    ], 0, getter);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
// ALIASES
// PARSING
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken([
    "gggg",
    "ggggg",
    "GGGG",
    "GGGGG"
], function(input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});
addWeekParseToken([
    "gg",
    "GG"
], function(input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});
// MOMENTS
function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
}
function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
}
function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
    return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}
function getWeeksInWeekYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}
function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) return weekOfYear(this, dow, doy).year;
    else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) week = weeksTarget;
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}
function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}
// FORMATTING
addFormatToken("Q", 0, "Qo", "quarter");
// PARSING
addRegexToken("Q", match1);
addParseToken("Q", function(input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});
// MOMENTS
function getSetQuarter(input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}
// FORMATTING
addFormatToken("D", [
    "DD",
    2
], "Do", "date");
// PARSING
addRegexToken("D", match1to2, match1to2NoLeadingZero);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
});
addParseToken([
    "D",
    "DD"
], DATE);
addParseToken("Do", function(input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});
// MOMENTS
var getSetDayOfMonth = makeGetSet("Date", true);
// FORMATTING
addFormatToken("DDD", [
    "DDDD",
    3
], "DDDo", "dayOfYear");
// PARSING
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken([
    "DDD",
    "DDDD"
], function(input, array, config) {
    config._dayOfYear = toInt(input);
});
// HELPERS
// MOMENTS
function getSetDayOfYear(input) {
    var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
    return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
}
// FORMATTING
addFormatToken("m", [
    "mm",
    2
], 0, "minute");
// PARSING
addRegexToken("m", match1to2, match1to2HasZero);
addRegexToken("mm", match1to2, match2);
addParseToken([
    "m",
    "mm"
], MINUTE);
// MOMENTS
var getSetMinute = makeGetSet("Minutes", false);
// FORMATTING
addFormatToken("s", [
    "ss",
    2
], 0, "second");
// PARSING
addRegexToken("s", match1to2, match1to2HasZero);
addRegexToken("ss", match1to2, match2);
addParseToken([
    "s",
    "ss"
], SECOND);
// MOMENTS
var getSetSecond = makeGetSet("Seconds", false);
// FORMATTING
addFormatToken("S", 0, 0, function() {
    return ~~(this.millisecond() / 100);
});
addFormatToken(0, [
    "SS",
    2
], 0, function() {
    return ~~(this.millisecond() / 10);
});
addFormatToken(0, [
    "SSS",
    3
], 0, "millisecond");
addFormatToken(0, [
    "SSSS",
    4
], 0, function() {
    return this.millisecond() * 10;
});
addFormatToken(0, [
    "SSSSS",
    5
], 0, function() {
    return this.millisecond() * 100;
});
addFormatToken(0, [
    "SSSSSS",
    6
], 0, function() {
    return this.millisecond() * 1000;
});
addFormatToken(0, [
    "SSSSSSS",
    7
], 0, function() {
    return this.millisecond() * 10000;
});
addFormatToken(0, [
    "SSSSSSSS",
    8
], 0, function() {
    return this.millisecond() * 100000;
});
addFormatToken(0, [
    "SSSSSSSSS",
    9
], 0, function() {
    return this.millisecond() * 1000000;
});
// PARSING
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token, getSetMillisecond;
for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
function parseMs(input, array) {
    array[MILLISECOND] = toInt(("0." + input) * 1000);
}
for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
getSetMillisecond = makeGetSet("Milliseconds", false);
// FORMATTING
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
// MOMENTS
function getZoneAbbr() {
    return this._isUTC ? "UTC" : "";
}
function getZoneName() {
    return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
    return "Moment<" + this.format() + ">";
};
proto.toJSON = toJSON;
proto.toString = toString;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
function createUnix(input) {
    return createLocal(input * 1000);
}
function createInZone() {
    return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(string) {
    return string;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1(format, index, field, setter) {
    var locale = getLocale(), utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}
function listMonthsImpl(format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }
    format = format || "";
    if (index != null) return get$1(format, index, field, "month");
    var i, out = [];
    for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
    return out;
}
// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === "boolean") {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
    }
    var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
    if (index != null) return get$1(format, (index + shift) % 7, field, "day");
    for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
    return out;
}
function listMonths(format, index) {
    return listMonthsImpl(format, index, "months");
}
function listMonthsShort(format, index) {
    return listMonthsImpl(format, index, "monthsShort");
}
function listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, "weekdays");
}
function listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
}
function listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
}
getSetGlobalLocale("en", {
    eras: [
        {
            since: "0001-01-01",
            until: Infinity,
            offset: 1,
            name: "Anno Domini",
            narrow: "AD",
            abbr: "AD"
        },
        {
            since: "0000-12-31",
            until: -Infinity,
            offset: 1,
            name: "Before Christ",
            narrow: "BC",
            abbr: "BC"
        }
    ],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function(number) {
        var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
        return number + output;
    }
});
// Side effect imports
hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
var mathAbs = Math.abs;
function abs() {
    var data = this._data;
    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);
    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);
    return this;
}
function addSubtract$1(duration, input, value, direction) {
    var other = createDuration(input, value);
    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;
    return duration._bubble();
}
// supports only 2.0-style add(1, 's') or add(duration)
function add$1(input, value) {
    return addSubtract$1(this, input, value, 1);
}
// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1(input, value) {
    return addSubtract$1(this, input, value, -1);
}
function absCeil(number) {
    if (number < 0) return Math.floor(number);
    else return Math.ceil(number);
}
function bubble() {
    var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }
    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;
    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;
    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;
    hours = absFloor(minutes / 60);
    data.hours = hours % 24;
    days += absFloor(hours / 24);
    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));
    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;
    data.days = days;
    data.months = months;
    data.years = years;
    return this;
}
function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}
function monthsToDays(months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}
function as(units) {
    if (!this.isValid()) return NaN;
    var days, months, milliseconds = this._milliseconds;
    units = normalizeUnits(units);
    if (units === "month" || units === "quarter" || units === "year") {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch(units){
            case "month":
                return months;
            case "quarter":
                return months / 3;
            case "year":
                return months / 12;
        }
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch(units){
            case "week":
                return days / 7 + milliseconds / 6048e5;
            case "day":
                return days + milliseconds / 864e5;
            case "hour":
                return days * 24 + milliseconds / 36e5;
            case "minute":
                return days * 1440 + milliseconds / 6e4;
            case "second":
                return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case "millisecond":
                return Math.floor(days * 864e5) + milliseconds;
            default:
                throw new Error("Unknown unit " + units);
        }
    }
}
function makeAs(alias) {
    return function() {
        return this.as(alias);
    };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
function clone$1() {
    return createDuration(this);
}
function get$2(units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + "s"]() : NaN;
}
function makeGetter(name) {
    return function() {
        return this.isValid() ? this._data[name] : NaN;
    };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
    return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
    ss: 44,
    s: 45,
    m: 45,
    h: 22,
    d: 26,
    w: null,
    M: 11
};
// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}
function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
    var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
        "s",
        seconds
    ] || seconds < thresholds.s && [
        "ss",
        seconds
    ] || minutes <= 1 && [
        "m"
    ] || minutes < thresholds.m && [
        "mm",
        minutes
    ] || hours <= 1 && [
        "h"
    ] || hours < thresholds.h && [
        "hh",
        hours
    ] || days <= 1 && [
        "d"
    ] || days < thresholds.d && [
        "dd",
        days
    ];
    if (thresholds.w != null) a = a || weeks <= 1 && [
        "w"
    ] || weeks < thresholds.w && [
        "ww",
        weeks
    ];
    a = a || months <= 1 && [
        "M"
    ] || months < thresholds.M && [
        "MM",
        months
    ] || years <= 1 && [
        "y"
    ] || [
        "yy",
        years
    ];
    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}
// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) return round;
    if (typeof roundingFunction === "function") {
        round = roundingFunction;
        return true;
    }
    return false;
}
// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) return false;
    if (limit === undefined) return thresholds[threshold];
    thresholds[threshold] = limit;
    if (threshold === "s") thresholds.ss = limit - 1;
    return true;
}
function humanize(argWithSuffix, argThresholds) {
    if (!this.isValid()) return this.localeData().invalidDate();
    var withSuffix = false, th = thresholds, locale, output;
    if (typeof argWithSuffix === "object") {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
    }
    if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
    if (typeof argThresholds === "object") {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
    }
    locale = this.localeData();
    output = relativeTime$1(this, !withSuffix, th, locale);
    if (withSuffix) output = locale.pastFuture(+this, output);
    return locale.postformat(output);
}
var abs$1 = Math.abs;
function sign(x) {
    return (x > 0) - (x < 0) || +x;
}
function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) return this.localeData().invalidDate();
    var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
    if (!total) // this is the same as C#'s (Noda) and python (isodate)...
    // but not other JS (goog.date)
    return "P0D";
    // 3600 seconds -> 60 minutes -> 1 hour
    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;
    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;
    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
    totalSign = total < 0 ? "-" : "";
    ymSign = sign(this._months) !== sign(total) ? "-" : "";
    daysSign = sign(this._days) !== sign(total) ? "-" : "";
    hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
    return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
proto$2.lang = lang;
// FORMATTING
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
// PARSING
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(input, array, config) {
    config._d = new Date(parseFloat(input) * 1000);
});
addParseToken("x", function(input, array, config) {
    config._d = new Date(toInt(input));
});
//! moment.js
hooks.version = "2.30.1";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
    DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
    DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
    DATE: "YYYY-MM-DD",
    TIME: "HH:mm",
    TIME_SECONDS: "HH:mm:ss",
    TIME_MS: "HH:mm:ss.SSS",
    WEEK: "GGGG-[W]WW",
    MONTH: "YYYY-MM"
};
var $69a316bb01cb7cab$export$2e2bcd8739ae039 = hooks;

});

var $32d7226b9bf937cf$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL("iwXxt"), JSON.parse('["iwXxt","bundle.main.min.js","8R3xZ","utils.2f09cc1c.js","hvXQi","werknemersGrid.9a8dc660.js","234Ty","handsontableLoader.9a44a03e.js"]'));


var $iUSsr = parcelRequire("iUSsr");
var $69739ba127b3007d$export$2e2bcd8739ae039 = window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));


var $91ca15859685b28b$exports = {};

$parcel$export($91ca15859685b28b$exports, "Alert", () => $91ca15859685b28b$export$caec2af78bcc877f);
$parcel$export($91ca15859685b28b$exports, "Button", () => $91ca15859685b28b$export$353f5b6fc5456de1);
$parcel$export($91ca15859685b28b$exports, "Carousel", () => $91ca15859685b28b$export$144901db2ea8e967);
$parcel$export($91ca15859685b28b$exports, "Collapse", () => $91ca15859685b28b$export$78768a9af065a7b);
$parcel$export($91ca15859685b28b$exports, "Dropdown", () => $91ca15859685b28b$export$931cbfb6bfb85fc);
$parcel$export($91ca15859685b28b$exports, "Modal", () => $91ca15859685b28b$export$2b77a92f1a5ad772);
$parcel$export($91ca15859685b28b$exports, "Offcanvas", () => $91ca15859685b28b$export$591ca0244c9dfcd4);
$parcel$export($91ca15859685b28b$exports, "Tooltip", () => $91ca15859685b28b$export$28c660c63b792dea);
$parcel$export($91ca15859685b28b$exports, "Popover", () => $91ca15859685b28b$export$5b6b19405a83ff9d);
$parcel$export($91ca15859685b28b$exports, "ScrollSpy", () => $91ca15859685b28b$export$a6472a5298a374be);
$parcel$export($91ca15859685b28b$exports, "Tab", () => $91ca15859685b28b$export$3e41faf802a29e71);
$parcel$export($91ca15859685b28b$exports, "Toast", () => $91ca15859685b28b$export$8d8dc7d5f743331b);
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
var $i9Aqn = parcelRequire("i9Aqn");
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$elementMap = new Map();
const $91ca15859685b28b$var$Data = {
    set (element, key, instance) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) $91ca15859685b28b$var$elementMap.set(element, new Map());
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($91ca15859685b28b$var$elementMap.has(element)) return $91ca15859685b28b$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) return;
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $91ca15859685b28b$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$MAX_UID = 1000000;
const $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER = 1000;
const $91ca15859685b28b$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $91ca15859685b28b$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $91ca15859685b28b$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $91ca15859685b28b$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $91ca15859685b28b$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $91ca15859685b28b$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER;
};
const $91ca15859685b28b$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($91ca15859685b28b$var$TRANSITION_END));
};
const $91ca15859685b28b$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $91ca15859685b28b$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($91ca15859685b28b$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($91ca15859685b28b$var$parseSelector(object));
    return null;
};
const $91ca15859685b28b$var$isVisible = (element)=>{
    if (!$91ca15859685b28b$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $91ca15859685b28b$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $91ca15859685b28b$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $91ca15859685b28b$var$findShadowRoot(element.parentNode);
};
const $91ca15859685b28b$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $91ca15859685b28b$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $91ca15859685b28b$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $91ca15859685b28b$var$DOMContentLoadedCallbacks = [];
const $91ca15859685b28b$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$91ca15859685b28b$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $91ca15859685b28b$var$DOMContentLoadedCallbacks)callback();
        });
        $91ca15859685b28b$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $91ca15859685b28b$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $91ca15859685b28b$var$defineJQueryPlugin = (plugin)=>{
    $91ca15859685b28b$var$onDOMContentLoaded(()=>{
        const $ = $91ca15859685b28b$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $91ca15859685b28b$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $91ca15859685b28b$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $91ca15859685b28b$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $91ca15859685b28b$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
        $91ca15859685b28b$var$execute(callback);
    };
    transitionElement.addEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $91ca15859685b28b$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $91ca15859685b28b$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $91ca15859685b28b$var$stripNameRegex = /\..*/;
const $91ca15859685b28b$var$stripUidRegex = /::\d+$/;
const $91ca15859685b28b$var$eventRegistry = {}; // Events storage
let $91ca15859685b28b$var$uidEvent = 1;
const $91ca15859685b28b$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $91ca15859685b28b$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $91ca15859685b28b$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$91ca15859685b28b$var$uidEvent++}` || element.uidEvent || $91ca15859685b28b$var$uidEvent++;
}
function $91ca15859685b28b$var$getElementEvents(element) {
    const uid = $91ca15859685b28b$var$makeEventUid(element);
    element.uidEvent = uid;
    $91ca15859685b28b$var$eventRegistry[uid] = $91ca15859685b28b$var$eventRegistry[uid] || {};
    return $91ca15859685b28b$var$eventRegistry[uid];
}
function $91ca15859685b28b$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $91ca15859685b28b$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $91ca15859685b28b$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $91ca15859685b28b$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $91ca15859685b28b$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $91ca15859685b28b$var$getTypeEvent(originalTypeEvent);
    if (!$91ca15859685b28b$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $91ca15859685b28b$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $91ca15859685b28b$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $91ca15859685b28b$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $91ca15859685b28b$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $91ca15859685b28b$var$makeEventUid(callable, originalTypeEvent.replace($91ca15859685b28b$var$namespaceRegex, ""));
    const fn = isDelegated ? $91ca15859685b28b$var$bootstrapDelegationHandler(element, handler, callable) : $91ca15859685b28b$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $91ca15859685b28b$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $91ca15859685b28b$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $91ca15859685b28b$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $91ca15859685b28b$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($91ca15859685b28b$var$stripNameRegex, "");
    return $91ca15859685b28b$var$customEvents[event] || event;
}
const $91ca15859685b28b$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $91ca15859685b28b$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $91ca15859685b28b$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$91ca15859685b28b$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($91ca15859685b28b$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $91ca15859685b28b$var$getjQuery();
        const typeEvent = $91ca15859685b28b$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $91ca15859685b28b$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $91ca15859685b28b$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $91ca15859685b28b$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $91ca15859685b28b$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $91ca15859685b28b$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $91ca15859685b28b$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $91ca15859685b28b$var$normalizeData(element.getAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $91ca15859685b28b$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $91ca15859685b28b$var$isElement(value) ? "element" : $91ca15859685b28b$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$VERSION = "5.3.3";
/**
 * Class definition
 */ class $91ca15859685b28b$var$BaseComponent extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        element = $91ca15859685b28b$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $91ca15859685b28b$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $91ca15859685b28b$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $91ca15859685b28b$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $91ca15859685b28b$var$Data.get($91ca15859685b28b$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $91ca15859685b28b$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$91ca15859685b28b$var$parseSelector(sel)).join(",") : null;
};
const $91ca15859685b28b$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$91ca15859685b28b$var$isDisabled(el) && $91ca15859685b28b$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        if (selector) return $91ca15859685b28b$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $91ca15859685b28b$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($91ca15859685b28b$var$isDisabled(this)) return;
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$f = "alert";
const $91ca15859685b28b$var$DATA_KEY$a = "bs.alert";
const $91ca15859685b28b$var$EVENT_KEY$b = `.${$91ca15859685b28b$var$DATA_KEY$a}`;
const $91ca15859685b28b$var$EVENT_CLOSE = `close${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$EVENT_CLOSED = `closed${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE$5 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $91ca15859685b28b$export$caec2af78bcc877f extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$e = "button";
const $91ca15859685b28b$var$DATA_KEY$9 = "bs.button";
const $91ca15859685b28b$var$EVENT_KEY$a = `.${$91ca15859685b28b$var$DATA_KEY$9}`;
const $91ca15859685b28b$var$DATA_API_KEY$6 = ".data-api";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$3 = "active";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6 = `click${$91ca15859685b28b$var$EVENT_KEY$a}${$91ca15859685b28b$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$353f5b6fc5456de1 extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5);
    const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$d = "swipe";
const $91ca15859685b28b$var$EVENT_KEY$9 = ".bs.swipe";
const $91ca15859685b28b$var$EVENT_TOUCHSTART = `touchstart${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHMOVE = `touchmove${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHEND = `touchend${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERDOWN = `pointerdown${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERUP = `pointerup${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$POINTER_TYPE_TOUCH = "touch";
const $91ca15859685b28b$var$POINTER_TYPE_PEN = "pen";
const $91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $91ca15859685b28b$var$SWIPE_THRESHOLD = 40;
const $91ca15859685b28b$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $91ca15859685b28b$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Swipe extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$91ca15859685b28b$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$c;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$c;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$d;
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $91ca15859685b28b$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $91ca15859685b28b$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $91ca15859685b28b$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_PEN || event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$c = "carousel";
const $91ca15859685b28b$var$DATA_KEY$8 = "bs.carousel";
const $91ca15859685b28b$var$EVENT_KEY$8 = `.${$91ca15859685b28b$var$DATA_KEY$8}`;
const $91ca15859685b28b$var$DATA_API_KEY$5 = ".data-api";
const $91ca15859685b28b$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $91ca15859685b28b$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $91ca15859685b28b$var$ORDER_NEXT = "next";
const $91ca15859685b28b$var$ORDER_PREV = "prev";
const $91ca15859685b28b$var$DIRECTION_LEFT = "left";
const $91ca15859685b28b$var$DIRECTION_RIGHT = "right";
const $91ca15859685b28b$var$EVENT_SLIDE = `slide${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_SLID = `slid${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN$1 = `keydown${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSEENTER$1 = `mouseenter${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSELEAVE$1 = `mouseleave${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_DRAG_START = `dragstart${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3 = `load${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5 = `click${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$CLASS_NAME_CAROUSEL = "carousel";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$2 = "active";
const $91ca15859685b28b$var$CLASS_NAME_SLIDE = "slide";
const $91ca15859685b28b$var$CLASS_NAME_END = "carousel-item-end";
const $91ca15859685b28b$var$CLASS_NAME_START = "carousel-item-start";
const $91ca15859685b28b$var$CLASS_NAME_NEXT = "carousel-item-next";
const $91ca15859685b28b$var$CLASS_NAME_PREV = "carousel-item-prev";
const $91ca15859685b28b$var$SELECTOR_ACTIVE = ".active";
const $91ca15859685b28b$var$SELECTOR_ITEM = ".carousel-item";
const $91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM = $91ca15859685b28b$var$SELECTOR_ACTIVE + $91ca15859685b28b$var$SELECTOR_ITEM;
const $91ca15859685b28b$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $91ca15859685b28b$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $91ca15859685b28b$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $91ca15859685b28b$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $91ca15859685b28b$var$KEY_TO_DIRECTION = {
    [$91ca15859685b28b$var$ARROW_LEFT_KEY$1]: $91ca15859685b28b$var$DIRECTION_RIGHT,
    [$91ca15859685b28b$var$ARROW_RIGHT_KEY$1]: $91ca15859685b28b$var$DIRECTION_LEFT
};
const $91ca15859685b28b$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $91ca15859685b28b$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$144901db2ea8e967 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $91ca15859685b28b$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$b;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$b;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$c;
    }
    // Public
    next() {
        this._slide($91ca15859685b28b$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $91ca15859685b28b$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($91ca15859685b28b$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $91ca15859685b28b$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $91ca15859685b28b$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM_IMG, this._element))$91ca15859685b28b$var$EventHandler.on(img, $91ca15859685b28b$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $91ca15859685b28b$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $91ca15859685b28b$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $91ca15859685b28b$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $91ca15859685b28b$var$ORDER_NEXT;
        const nextElement = element || $91ca15859685b28b$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $91ca15859685b28b$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($91ca15859685b28b$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_START : $91ca15859685b28b$var$CLASS_NAME_END;
        const orderClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_NEXT : $91ca15859685b28b$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $91ca15859685b28b$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($91ca15859685b28b$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($91ca15859685b28b$var$isRTL()) return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_PREV : $91ca15859685b28b$var$ORDER_NEXT;
        return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($91ca15859685b28b$var$isRTL()) return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_LEFT : $91ca15859685b28b$var$DIRECTION_RIGHT;
        return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_RIGHT : $91ca15859685b28b$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5, $91ca15859685b28b$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($91ca15859685b28b$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($91ca15859685b28b$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$b = "collapse";
const $91ca15859685b28b$var$DATA_KEY$7 = "bs.collapse";
const $91ca15859685b28b$var$EVENT_KEY$7 = `.${$91ca15859685b28b$var$DATA_KEY$7}`;
const $91ca15859685b28b$var$DATA_API_KEY$4 = ".data-api";
const $91ca15859685b28b$var$EVENT_SHOW$6 = `show${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_SHOWN$6 = `shown${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDE$6 = `hide${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$6 = `hidden${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4 = `click${$91ca15859685b28b$var$EVENT_KEY$7}${$91ca15859685b28b$var$DATA_API_KEY$4}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$7 = "show";
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSE = "collapse";
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSING = "collapsing";
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSED = "collapsed";
const $91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE} .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE}`;
const $91ca15859685b28b$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $91ca15859685b28b$var$WIDTH = "width";
const $91ca15859685b28b$var$HEIGHT = "height";
const $91ca15859685b28b$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $91ca15859685b28b$var$Default$a = {
    parent: null,
    toggle: true
};
const $91ca15859685b28b$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$78768a9af065a7b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $91ca15859685b28b$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $91ca15859685b28b$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$a;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$a;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $91ca15859685b28b$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_HORIZONTAL) ? $91ca15859685b28b$var$WIDTH : $91ca15859685b28b$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $91ca15859685b28b$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $91ca15859685b28b$var$SelectorEngine.getMultipleElementsFromSelector(this))$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$a = "dropdown";
const $91ca15859685b28b$var$DATA_KEY$6 = "bs.dropdown";
const $91ca15859685b28b$var$EVENT_KEY$6 = `.${$91ca15859685b28b$var$DATA_KEY$6}`;
const $91ca15859685b28b$var$DATA_API_KEY$3 = ".data-api";
const $91ca15859685b28b$var$ESCAPE_KEY$2 = "Escape";
const $91ca15859685b28b$var$TAB_KEY$1 = "Tab";
const $91ca15859685b28b$var$ARROW_UP_KEY$1 = "ArrowUp";
const $91ca15859685b28b$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $91ca15859685b28b$var$EVENT_HIDE$5 = `hide${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$5 = `hidden${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOW$5 = `show${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOWN$5 = `shown${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3 = `click${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API = `keydown${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYUP_DATA_API = `keyup${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$6 = "show";
const $91ca15859685b28b$var$CLASS_NAME_DROPUP = "dropup";
const $91ca15859685b28b$var$CLASS_NAME_DROPEND = "dropend";
const $91ca15859685b28b$var$CLASS_NAME_DROPSTART = "dropstart";
const $91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3}.${$91ca15859685b28b$var$CLASS_NAME_SHOW$6}`;
const $91ca15859685b28b$var$SELECTOR_MENU = ".dropdown-menu";
const $91ca15859685b28b$var$SELECTOR_NAVBAR = ".navbar";
const $91ca15859685b28b$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $91ca15859685b28b$var$PLACEMENT_TOP = $91ca15859685b28b$var$isRTL() ? "top-end" : "top-start";
const $91ca15859685b28b$var$PLACEMENT_TOPEND = $91ca15859685b28b$var$isRTL() ? "top-start" : "top-end";
const $91ca15859685b28b$var$PLACEMENT_BOTTOM = $91ca15859685b28b$var$isRTL() ? "bottom-end" : "bottom-start";
const $91ca15859685b28b$var$PLACEMENT_BOTTOMEND = $91ca15859685b28b$var$isRTL() ? "bottom-start" : "bottom-end";
const $91ca15859685b28b$var$PLACEMENT_RIGHT = $91ca15859685b28b$var$isRTL() ? "left-start" : "right-start";
const $91ca15859685b28b$var$PLACEMENT_LEFT = $91ca15859685b28b$var$isRTL() ? "right-start" : "left-start";
const $91ca15859685b28b$var$PLACEMENT_TOPCENTER = "top";
const $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $91ca15859685b28b$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $91ca15859685b28b$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$931cbfb6bfb85fc extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $91ca15859685b28b$var$SelectorEngine.next(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.prev(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$9;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$9;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($91ca15859685b28b$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, "mouseover", $91ca15859685b28b$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, "mouseover", $91ca15859685b28b$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $91ca15859685b28b$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$91ca15859685b28b$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$91ca15859685b28b$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $i9Aqn === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($91ca15859685b28b$var$isElement(this._config.reference)) referenceElement = $91ca15859685b28b$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $i9Aqn.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPEND)) return $91ca15859685b28b$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPSTART)) return $91ca15859685b28b$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER)) return $91ca15859685b28b$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER)) return $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP)) return isEnd ? $91ca15859685b28b$var$PLACEMENT_TOPEND : $91ca15859685b28b$var$PLACEMENT_TOP;
        return isEnd ? $91ca15859685b28b$var$PLACEMENT_BOTTOMEND : $91ca15859685b28b$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($91ca15859685b28b$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $91ca15859685b28b$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$91ca15859685b28b$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $91ca15859685b28b$var$getNextActiveElement(items, target, key === $91ca15859685b28b$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $91ca15859685b28b$var$TAB_KEY$1) return;
        const openToggles = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $91ca15859685b28b$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $91ca15859685b28b$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $91ca15859685b28b$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $91ca15859685b28b$var$ARROW_UP_KEY$1,
            $91ca15859685b28b$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3) ? this : $91ca15859685b28b$var$SelectorEngine.prev(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.next(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_MENU, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYUP_DATA_API, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$9 = "backdrop";
const $91ca15859685b28b$var$CLASS_NAME_FADE$4 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$5 = "show";
const $91ca15859685b28b$var$EVENT_MOUSEDOWN = `mousedown.bs.${$91ca15859685b28b$var$NAME$9}`;
const $91ca15859685b28b$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $91ca15859685b28b$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Backdrop extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$8;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$8;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $91ca15859685b28b$var$reflow(element);
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $91ca15859685b28b$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $91ca15859685b28b$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $91ca15859685b28b$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $91ca15859685b28b$var$EventHandler.on(element, $91ca15859685b28b$var$EVENT_MOUSEDOWN, ()=>{
            $91ca15859685b28b$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $91ca15859685b28b$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$8 = "focustrap";
const $91ca15859685b28b$var$DATA_KEY$5 = "bs.focustrap";
const $91ca15859685b28b$var$EVENT_KEY$5 = `.${$91ca15859685b28b$var$DATA_KEY$5}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN$2 = `focusin${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_TAB = `keydown.tab${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$TAB_KEY = "Tab";
const $91ca15859685b28b$var$TAB_NAV_FORWARD = "forward";
const $91ca15859685b28b$var$TAB_NAV_BACKWARD = "backward";
const $91ca15859685b28b$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $91ca15859685b28b$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$FocusTrap extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$7;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$7;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5); // guard against infinite focus loop
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $91ca15859685b28b$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $91ca15859685b28b$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $91ca15859685b28b$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $91ca15859685b28b$var$TAB_NAV_BACKWARD : $91ca15859685b28b$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $91ca15859685b28b$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $91ca15859685b28b$var$PROPERTY_PADDING = "padding-right";
const $91ca15859685b28b$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $91ca15859685b28b$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $91ca15859685b28b$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $91ca15859685b28b$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $91ca15859685b28b$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($91ca15859685b28b$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $91ca15859685b28b$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$7 = "modal";
const $91ca15859685b28b$var$DATA_KEY$4 = "bs.modal";
const $91ca15859685b28b$var$EVENT_KEY$4 = `.${$91ca15859685b28b$var$DATA_KEY$4}`;
const $91ca15859685b28b$var$DATA_API_KEY$2 = ".data-api";
const $91ca15859685b28b$var$ESCAPE_KEY$1 = "Escape";
const $91ca15859685b28b$var$EVENT_HIDE$4 = `hide${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$4 = `hidden${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOW$4 = `show${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOWN$4 = `shown${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_RESIZE$1 = `resize${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DISMISS = `click.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2 = `click${$91ca15859685b28b$var$EVENT_KEY$4}${$91ca15859685b28b$var$DATA_API_KEY$2}`;
const $91ca15859685b28b$var$CLASS_NAME_OPEN = "modal-open";
const $91ca15859685b28b$var$CLASS_NAME_FADE$3 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$4 = "show";
const $91ca15859685b28b$var$CLASS_NAME_STATIC = "modal-static";
const $91ca15859685b28b$var$OPEN_SELECTOR$1 = ".modal.show";
const $91ca15859685b28b$var$SELECTOR_DIALOG = ".modal-dialog";
const $91ca15859685b28b$var$SELECTOR_MODAL_BODY = ".modal-body";
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $91ca15859685b28b$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $91ca15859685b28b$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$2b77a92f1a5ad772 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $91ca15859685b28b$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$6;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$6;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($91ca15859685b28b$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(window, $91ca15859685b28b$var$EVENT_KEY$4);
        $91ca15859685b28b$var$EventHandler.off(this._dialog, $91ca15859685b28b$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $91ca15859685b28b$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($91ca15859685b28b$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$4, ()=>{
            if ($91ca15859685b28b$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $91ca15859685b28b$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$6 = "offcanvas";
const $91ca15859685b28b$var$DATA_KEY$3 = "bs.offcanvas";
const $91ca15859685b28b$var$EVENT_KEY$3 = `.${$91ca15859685b28b$var$DATA_KEY$3}`;
const $91ca15859685b28b$var$DATA_API_KEY$1 = ".data-api";
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2 = `load${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$ESCAPE_KEY = "Escape";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$3 = "show";
const $91ca15859685b28b$var$CLASS_NAME_SHOWING$1 = "showing";
const $91ca15859685b28b$var$CLASS_NAME_HIDING = "hiding";
const $91ca15859685b28b$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $91ca15859685b28b$var$OPEN_SELECTOR = ".offcanvas.show";
const $91ca15859685b28b$var$EVENT_SHOW$3 = `show${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_SHOWN$3 = `shown${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE$3 = `hide${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$3 = `hidden${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_RESIZE = `resize${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1 = `click${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $91ca15859685b28b$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $91ca15859685b28b$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$591ca0244c9dfcd4 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$5;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$5;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$3, $91ca15859685b28b$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $91ca15859685b28b$var$Backdrop({
            className: $91ca15859685b28b$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($91ca15859685b28b$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $91ca15859685b28b$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$OPEN_SELECTOR))$91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $91ca15859685b28b$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $91ca15859685b28b$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $91ca15859685b28b$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $91ca15859685b28b$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($91ca15859685b28b$var$uriAttributes.has(attributeName)) return Boolean($91ca15859685b28b$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $91ca15859685b28b$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$91ca15859685b28b$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$5 = "TemplateFactory";
const $91ca15859685b28b$var$Default$4 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $91ca15859685b28b$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $91ca15859685b28b$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$TemplateFactory extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$4;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$4;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $91ca15859685b28b$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $91ca15859685b28b$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($91ca15859685b28b$var$isElement(content)) {
            this._putElementInTemplate($91ca15859685b28b$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $91ca15859685b28b$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$4 = "tooltip";
const $91ca15859685b28b$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $91ca15859685b28b$var$CLASS_NAME_FADE$2 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_MODAL = "modal";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$2 = "show";
const $91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $91ca15859685b28b$var$SELECTOR_MODAL = `.${$91ca15859685b28b$var$CLASS_NAME_MODAL}`;
const $91ca15859685b28b$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $91ca15859685b28b$var$TRIGGER_HOVER = "hover";
const $91ca15859685b28b$var$TRIGGER_FOCUS = "focus";
const $91ca15859685b28b$var$TRIGGER_CLICK = "click";
const $91ca15859685b28b$var$TRIGGER_MANUAL = "manual";
const $91ca15859685b28b$var$EVENT_HIDE$2 = "hide";
const $91ca15859685b28b$var$EVENT_HIDDEN$2 = "hidden";
const $91ca15859685b28b$var$EVENT_SHOW$2 = "show";
const $91ca15859685b28b$var$EVENT_SHOWN$2 = "shown";
const $91ca15859685b28b$var$EVENT_INSERTED = "inserted";
const $91ca15859685b28b$var$EVENT_CLICK$1 = "click";
const $91ca15859685b28b$var$EVENT_FOCUSIN$1 = "focusin";
const $91ca15859685b28b$var$EVENT_FOCUSOUT$1 = "focusout";
const $91ca15859685b28b$var$EVENT_MOUSEENTER = "mouseenter";
const $91ca15859685b28b$var$EVENT_MOUSELEAVE = "mouseleave";
const $91ca15859685b28b$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $91ca15859685b28b$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $91ca15859685b28b$var$isRTL() ? "right" : "left"
};
const $91ca15859685b28b$var$Default$3 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $91ca15859685b28b$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$28c660c63b792dea extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        if (typeof $i9Aqn === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$3;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$3;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $91ca15859685b28b$var$EventHandler.off(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOW$2));
        const shadowRoot = $91ca15859685b28b$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, "mouseover", $91ca15859685b28b$var$noop);
        const complete = ()=>{
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, "mouseover", $91ca15859685b28b$var$noop);
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_FADE$2, $91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $91ca15859685b28b$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $91ca15859685b28b$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $91ca15859685b28b$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $91ca15859685b28b$var$AttachmentMap[placement.toUpperCase()];
        return $i9Aqn.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $91ca15859685b28b$var$EventHandler.on(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $91ca15859685b28b$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSEENTER) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSELEAVE) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSOUT$1);
                $91ca15859685b28b$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $91ca15859685b28b$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $91ca15859685b28b$var$EventHandler.on(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $91ca15859685b28b$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($91ca15859685b28b$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $91ca15859685b28b$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$3 = "popover";
const $91ca15859685b28b$var$SELECTOR_TITLE = ".popover-header";
const $91ca15859685b28b$var$SELECTOR_CONTENT = ".popover-body";
const $91ca15859685b28b$var$Default$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $91ca15859685b28b$var$DefaultType$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$5b6b19405a83ff9d extends $91ca15859685b28b$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$2;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$2;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TITLE]: this._getTitle(),
            [$91ca15859685b28b$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$2 = "scrollspy";
const $91ca15859685b28b$var$DATA_KEY$2 = "bs.scrollspy";
const $91ca15859685b28b$var$EVENT_KEY$2 = `.${$91ca15859685b28b$var$DATA_KEY$2}`;
const $91ca15859685b28b$var$DATA_API_KEY = ".data-api";
const $91ca15859685b28b$var$EVENT_ACTIVATE = `activate${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_CLICK = `click${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1 = `load${$91ca15859685b28b$var$EVENT_KEY$2}${$91ca15859685b28b$var$DATA_API_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$1 = "active";
const $91ca15859685b28b$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $91ca15859685b28b$var$SELECTOR_TARGET_LINKS = "[href]";
const $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $91ca15859685b28b$var$SELECTOR_NAV_LINKS = ".nav-link";
const $91ca15859685b28b$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $91ca15859685b28b$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $91ca15859685b28b$var$SELECTOR_LINK_ITEMS = `${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_NAV_ITEMS} > ${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_LIST_ITEMS}`;
const $91ca15859685b28b$var$SELECTOR_DROPDOWN = ".dropdown";
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $91ca15859685b28b$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $91ca15859685b28b$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$a6472a5298a374be extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$1;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$1;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $91ca15859685b28b$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $91ca15859685b28b$var$EventHandler.off(this._config.target, $91ca15859685b28b$var$EVENT_CLICK);
        $91ca15859685b28b$var$EventHandler.on(this._config.target, $91ca15859685b28b$var$EVENT_CLICK, $91ca15859685b28b$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $91ca15859685b28b$var$isDisabled(anchor)) continue;
            const observableSection = $91ca15859685b28b$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($91ca15859685b28b$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($91ca15859685b28b$var$SELECTOR_DROPDOWN)).classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $91ca15859685b28b$var$SelectorEngine.parents(target, $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $91ca15859685b28b$var$SelectorEngine.prev(listGroup, $91ca15859685b28b$var$SELECTOR_LINK_ITEMS))item.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $91ca15859685b28b$var$SelectorEngine.find(`${$91ca15859685b28b$var$SELECTOR_TARGET_LINKS}.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_SPY))$91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$1 = "tab";
const $91ca15859685b28b$var$DATA_KEY$1 = "bs.tab";
const $91ca15859685b28b$var$EVENT_KEY$1 = `.${$91ca15859685b28b$var$DATA_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDE$1 = `hide${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$1 = `hidden${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOW$1 = `show${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOWN$1 = `shown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API = `click${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN = `keydown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API = `load${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$ARROW_LEFT_KEY = "ArrowLeft";
const $91ca15859685b28b$var$ARROW_RIGHT_KEY = "ArrowRight";
const $91ca15859685b28b$var$ARROW_UP_KEY = "ArrowUp";
const $91ca15859685b28b$var$ARROW_DOWN_KEY = "ArrowDown";
const $91ca15859685b28b$var$HOME_KEY = "Home";
const $91ca15859685b28b$var$END_KEY = "End";
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE = "active";
const $91ca15859685b28b$var$CLASS_NAME_FADE$1 = "fade";
const $91ca15859685b28b$var$CLASS_NAME_SHOW$1 = "show";
const $91ca15859685b28b$var$CLASS_DROPDOWN = "dropdown";
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $91ca15859685b28b$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $91ca15859685b28b$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $91ca15859685b28b$var$SELECTOR_INNER = `.nav-link${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $91ca15859685b28b$var$SELECTOR_INNER_ELEM = `${$91ca15859685b28b$var$SELECTOR_INNER}, ${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$3e41faf802a29e71 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($91ca15859685b28b$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $91ca15859685b28b$var$EventHandler.trigger(active, $91ca15859685b28b$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(innerElem, $91ca15859685b28b$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        this._activate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $91ca15859685b28b$var$ARROW_LEFT_KEY,
            $91ca15859685b28b$var$ARROW_RIGHT_KEY,
            $91ca15859685b28b$var$ARROW_UP_KEY,
            $91ca15859685b28b$var$ARROW_DOWN_KEY,
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$91ca15859685b28b$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $91ca15859685b28b$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $91ca15859685b28b$var$ARROW_RIGHT_KEY,
                $91ca15859685b28b$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $91ca15859685b28b$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($91ca15859685b28b$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $91ca15859685b28b$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE, $91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU, $91ca15859685b28b$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($91ca15859685b28b$var$SELECTOR_INNER_ELEM) ? elem : $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($91ca15859685b28b$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE))$91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME = "toast";
const $91ca15859685b28b$var$DATA_KEY = "bs.toast";
const $91ca15859685b28b$var$EVENT_KEY = `.${$91ca15859685b28b$var$DATA_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOVER = `mouseover${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOUT = `mouseout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN = `focusin${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSOUT = `focusout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDE = `hide${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDDEN = `hidden${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOW = `show${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOWN = `shown${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE = "fade";
const $91ca15859685b28b$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $91ca15859685b28b$var$CLASS_NAME_SHOW = "show";
const $91ca15859685b28b$var$CLASS_NAME_SHOWING = "showing";
const $91ca15859685b28b$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $91ca15859685b28b$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$8d8dc7d5f743331b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME;
    }
    // Public
    show() {
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW, $91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING, $91ca15859685b28b$var$CLASS_NAME_SHOW);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN);
        };
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$8d8dc7d5f743331b);


var $f563eb57b4850461$export$2e2bcd8739ae039 = window.bootstrap = $91ca15859685b28b$exports;


parcelRequire("6j4kq");
var $4d10c830a3883503$exports = {};


(function(factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery"
    ], factory);
    else if (0, $4d10c830a3883503$exports) // Node/CommonJS
    $4d10c830a3883503$exports = function(root, jQuery1) {
        if (jQuery1 === undefined) {
            // require('jQuery') returns a factory that requires window to
            // build a jQuery instance, we normalize how we use modules
            // that require this pattern but the window provided is a noop
            // if it's defined (how jquery works)
            if (typeof window !== "undefined") jQuery1 = (parcelRequire("iUSsr"));
            else jQuery1 = (parcelRequire("iUSsr"))(root);
        }
        factory(jQuery1);
        return jQuery1;
    };
    else // Browser globals
    factory(jQuery);
})(function(jQuery1) {
    // This is needed so we can catch the AMD loader configuration and use it
    // The inner file should be wrapped (by `banner.start.js`) in a function that
    // returns the AMD loader references.
    var S2 = function() {
        // Restore the Select2 AMD loader so it can be used
        // Needed mostly in the language files, where the loader is not inserted
        if (jQuery1 && jQuery1.fn && jQuery1.fn.select2 && jQuery1.fn.select2.amd) var S2 = jQuery1.fn.select2.amd;
        var S2;
        (function() {
            if (!S2 || !S2.requirejs) {
                if (!S2) S2 = {};
                else require1 = S2;
                /**
 * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, http://github.com/requirejs/almond/LICENSE
 */ //Going sloppy to avoid 'use strict' string cost, but strict practices should
                //be followed.
                /*global setTimeout: false */ var requirejs, require1, define1;
                (function(undef) {
                    var main, req, makeMap, handlers, defined = {}, waiting = {}, config = {}, defining = {}, hasOwn = Object.prototype.hasOwnProperty, aps = [].slice, jsSuffixRegExp = /\.js$/;
                    function hasProp(obj, prop) {
                        return hasOwn.call(obj, prop);
                    }
                    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */ function normalize(name, baseName) {
                        var nameParts, nameSegment, mapValue, foundMap, lastIndex, foundI, foundStarMap, starI, i, j, part, normalizedBaseParts, baseParts = baseName && baseName.split("/"), map = config.map, starMap = map && map["*"] || {};
                        //Adjust any relative paths.
                        if (name) {
                            name = name.split("/");
                            lastIndex = name.length - 1;
                            // If wanting node ID compatibility, strip .js from end
                            // of IDs. Have to do this here, and not in nameToUrl
                            // because node allows either .js or non .js to map
                            // to same file.
                            if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, "");
                            // Starts with a '.' so need the baseName
                            if (name[0].charAt(0) === "." && baseParts) {
                                //Convert baseName to array, and lop off the last part,
                                //so that . matches that 'directory' and not name of the baseName's
                                //module. For instance, baseName of 'one/two/three', maps to
                                //'one/two/three.js', but we want the directory, 'one/two' for
                                //this normalization.
                                normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                                name = normalizedBaseParts.concat(name);
                            }
                            //start trimDots
                            for(i = 0; i < name.length; i++){
                                part = name[i];
                                if (part === ".") {
                                    name.splice(i, 1);
                                    i -= 1;
                                } else if (part === "..") {
                                    // If at the start, or previous value is still ..,
                                    // keep them so that when converted to a path it may
                                    // still work when converted to a path, even though
                                    // as an ID it is less than ideal. In larger point
                                    // releases, may be better to just kick out an error.
                                    if (i === 0 || i === 1 && name[2] === ".." || name[i - 1] === "..") continue;
                                    else if (i > 0) {
                                        name.splice(i - 1, 2);
                                        i -= 2;
                                    }
                                }
                            }
                            //end trimDots
                            name = name.join("/");
                        }
                        //Apply map config if available.
                        if ((baseParts || starMap) && map) {
                            nameParts = name.split("/");
                            for(i = nameParts.length; i > 0; i -= 1){
                                nameSegment = nameParts.slice(0, i).join("/");
                                if (baseParts) //Find the longest baseName segment match in the config.
                                //So, do joins on the biggest to smallest lengths of baseParts.
                                for(j = baseParts.length; j > 0; j -= 1){
                                    mapValue = map[baseParts.slice(0, j).join("/")];
                                    //baseName segment has  config, find if it has one for
                                    //this name.
                                    if (mapValue) {
                                        mapValue = mapValue[nameSegment];
                                        if (mapValue) {
                                            //Match, update name to the new value.
                                            foundMap = mapValue;
                                            foundI = i;
                                            break;
                                        }
                                    }
                                }
                                if (foundMap) break;
                                //Check for a star map match, but just hold on to it,
                                //if there is a shorter segment match later in a matching
                                //config, then favor over this star map.
                                if (!foundStarMap && starMap && starMap[nameSegment]) {
                                    foundStarMap = starMap[nameSegment];
                                    starI = i;
                                }
                            }
                            if (!foundMap && foundStarMap) {
                                foundMap = foundStarMap;
                                foundI = starI;
                            }
                            if (foundMap) {
                                nameParts.splice(0, foundI, foundMap);
                                name = nameParts.join("/");
                            }
                        }
                        return name;
                    }
                    function makeRequire(relName, forceSync) {
                        return function() {
                            //A version of a require function that passes a moduleName
                            //value for items that may need to
                            //look up paths relative to the moduleName
                            var args = aps.call(arguments, 0);
                            //If first arg is not require('string'), and there is only
                            //one arg, it is the array form without a callback. Insert
                            //a null so that the following concat is correct.
                            if (typeof args[0] !== "string" && args.length === 1) args.push(null);
                            return req.apply(undef, args.concat([
                                relName,
                                forceSync
                            ]));
                        };
                    }
                    function makeNormalize(relName) {
                        return function(name) {
                            return normalize(name, relName);
                        };
                    }
                    function makeLoad(depName) {
                        return function(value) {
                            defined[depName] = value;
                        };
                    }
                    function callDep(name) {
                        if (hasProp(waiting, name)) {
                            var args = waiting[name];
                            delete waiting[name];
                            defining[name] = true;
                            main.apply(undef, args);
                        }
                        if (!hasProp(defined, name) && !hasProp(defining, name)) throw new Error("No " + name);
                        return defined[name];
                    }
                    //Turns a plugin!resource to [plugin, resource]
                    //with the plugin being undefined if the name
                    //did not have a plugin prefix.
                    function splitPrefix(name) {
                        var prefix, index = name ? name.indexOf("!") : -1;
                        if (index > -1) {
                            prefix = name.substring(0, index);
                            name = name.substring(index + 1, name.length);
                        }
                        return [
                            prefix,
                            name
                        ];
                    }
                    //Creates a parts array for a relName where first part is plugin ID,
                    //second part is resource ID. Assumes relName has already been normalized.
                    function makeRelParts(relName) {
                        return relName ? splitPrefix(relName) : [];
                    }
                    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */ makeMap = function(name, relParts) {
                        var plugin, parts = splitPrefix(name), prefix = parts[0], relResourceName = relParts[1];
                        name = parts[1];
                        if (prefix) {
                            prefix = normalize(prefix, relResourceName);
                            plugin = callDep(prefix);
                        }
                        //Normalize according
                        if (prefix) {
                            if (plugin && plugin.normalize) name = plugin.normalize(name, makeNormalize(relResourceName));
                            else name = normalize(name, relResourceName);
                        } else {
                            name = normalize(name, relResourceName);
                            parts = splitPrefix(name);
                            prefix = parts[0];
                            name = parts[1];
                            if (prefix) plugin = callDep(prefix);
                        }
                        //Using ridiculous property names for space reasons
                        return {
                            f: prefix ? prefix + "!" + name : name,
                            n: name,
                            pr: prefix,
                            p: plugin
                        };
                    };
                    function makeConfig(name) {
                        return function() {
                            return config && config.config && config.config[name] || {};
                        };
                    }
                    handlers = {
                        require: function(name) {
                            return makeRequire(name);
                        },
                        exports: function(name) {
                            var e = defined[name];
                            if (typeof e !== "undefined") return e;
                            else return defined[name] = {};
                        },
                        module: function(name) {
                            return {
                                id: name,
                                uri: "",
                                exports: defined[name],
                                config: makeConfig(name)
                            };
                        }
                    };
                    main = function(name, deps, callback, relName) {
                        var cjsModule, depName, ret, map, i, relParts, args = [], callbackType = typeof callback, usingExports;
                        //Use name if no relName
                        relName = relName || name;
                        relParts = makeRelParts(relName);
                        //Call the callback to define the module, if necessary.
                        if (callbackType === "undefined" || callbackType === "function") {
                            //Pull out the defined dependencies and pass the ordered
                            //values to the callback.
                            //Default to [require, exports, module] if no deps
                            deps = !deps.length && callback.length ? [
                                "require",
                                "exports",
                                "module"
                            ] : deps;
                            for(i = 0; i < deps.length; i += 1){
                                map = makeMap(deps[i], relParts);
                                depName = map.f;
                                //Fast path CommonJS standard dependencies.
                                if (depName === "require") args[i] = handlers.require(name);
                                else if (depName === "exports") {
                                    //CommonJS module spec 1.1
                                    args[i] = handlers.exports(name);
                                    usingExports = true;
                                } else if (depName === "module") //CommonJS module spec 1.1
                                cjsModule = args[i] = handlers.module(name);
                                else if (hasProp(defined, depName) || hasProp(waiting, depName) || hasProp(defining, depName)) args[i] = callDep(depName);
                                else if (map.p) {
                                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                                    args[i] = defined[depName];
                                } else throw new Error(name + " missing " + depName);
                            }
                            ret = callback ? callback.apply(defined[name], args) : undefined;
                            if (name) {
                                //If setting exports via "module" is in play,
                                //favor that over return value and exports. After that,
                                //favor a non-undefined return value over exports use.
                                if (cjsModule && cjsModule.exports !== undef && cjsModule.exports !== defined[name]) defined[name] = cjsModule.exports;
                                else if (ret !== undef || !usingExports) //Use the return value from the function.
                                defined[name] = ret;
                            }
                        } else if (name) //May just be an object definition for the module. Only
                        //worry about defining if have a module name.
                        defined[name] = callback;
                    };
                    requirejs = require1 = req = function(deps, callback, relName, forceSync, alt) {
                        if (typeof deps === "string") {
                            if (handlers[deps]) //callback in this case is really relName
                            return handlers[deps](callback);
                            //Just return the module wanted. In this scenario, the
                            //deps arg is the module name, and second arg (if passed)
                            //is just the relName.
                            //Normalize module name, if it contains . or ..
                            return callDep(makeMap(deps, makeRelParts(callback)).f);
                        } else if (!deps.splice) {
                            //deps is a config object, not an array.
                            config = deps;
                            if (config.deps) req(config.deps, config.callback);
                            if (!callback) return;
                            if (callback.splice) {
                                //callback is an array, which means it is a dependency list.
                                //Adjust args if there are dependencies
                                deps = callback;
                                callback = relName;
                                relName = null;
                            } else deps = undef;
                        }
                        //Support require(['a'])
                        callback = callback || function() {};
                        //If relName is a function, it is an errback handler,
                        //so remove it.
                        if (typeof relName === "function") {
                            relName = forceSync;
                            forceSync = alt;
                        }
                        //Simulate async callback;
                        if (forceSync) main(undef, deps, callback, relName);
                        else //Using a non-zero value because of concern for what old browsers
                        //do, and latest browsers "upgrade" to 4 if lower value is used:
                        //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
                        //If want a value immediately, use require('id') instead -- something
                        //that works in almond on the global level, but not guaranteed and
                        //unlikely to work in other AMD implementations.
                        setTimeout(function() {
                            main(undef, deps, callback, relName);
                        }, 4);
                        return req;
                    };
                    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */ req.config = function(cfg) {
                        return req(cfg);
                    };
                    /**
     * Expose module registry for debugging and tooling
     */ requirejs._defined = defined;
                    define1 = function(name, deps, callback) {
                        if (typeof name !== "string") throw new Error("See almond README: incorrect module build, no module name");
                        //This module may not have dependencies
                        if (!deps.splice) {
                            //deps is not an array, so probably means
                            //an object literal or factory function for
                            //the value. Adjust args.
                            callback = deps;
                            deps = [];
                        }
                        if (!hasProp(defined, name) && !hasProp(waiting, name)) waiting[name] = [
                            name,
                            deps,
                            callback
                        ];
                    };
                    define1.amd = {
                        jQuery: true
                    };
                })();
                S2.requirejs = requirejs;
                S2.require = require1;
                S2.define = define1;
            }
        })();
        S2.define("almond", function() {});
        /* global jQuery:false, $:false */ S2.define("jquery", [], function() {
            var _$ = jQuery1 || $;
            if (_$ == null && console && console.error) console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page.");
            return _$;
        });
        S2.define("select2/utils", [
            "jquery"
        ], function($1) {
            var Utils = {};
            Utils.Extend = function(ChildClass, SuperClass) {
                var __hasProp = {}.hasOwnProperty;
                function BaseConstructor() {
                    this.constructor = ChildClass;
                }
                for(var key in SuperClass)if (__hasProp.call(SuperClass, key)) ChildClass[key] = SuperClass[key];
                BaseConstructor.prototype = SuperClass.prototype;
                ChildClass.prototype = new BaseConstructor();
                ChildClass.__super__ = SuperClass.prototype;
                return ChildClass;
            };
            function getMethods(theClass) {
                var proto = theClass.prototype;
                var methods = [];
                for(var methodName in proto){
                    var m = proto[methodName];
                    if (typeof m !== "function") continue;
                    if (methodName === "constructor") continue;
                    methods.push(methodName);
                }
                return methods;
            }
            Utils.Decorate = function(SuperClass, DecoratorClass) {
                var decoratedMethods = getMethods(DecoratorClass);
                var superMethods = getMethods(SuperClass);
                function DecoratedClass() {
                    var unshift = Array.prototype.unshift;
                    var argCount = DecoratorClass.prototype.constructor.length;
                    var calledConstructor = SuperClass.prototype.constructor;
                    if (argCount > 0) {
                        unshift.call(arguments, SuperClass.prototype.constructor);
                        calledConstructor = DecoratorClass.prototype.constructor;
                    }
                    calledConstructor.apply(this, arguments);
                }
                DecoratorClass.displayName = SuperClass.displayName;
                function ctr() {
                    this.constructor = DecoratedClass;
                }
                DecoratedClass.prototype = new ctr();
                for(var m = 0; m < superMethods.length; m++){
                    var superMethod = superMethods[m];
                    DecoratedClass.prototype[superMethod] = SuperClass.prototype[superMethod];
                }
                var calledMethod = function(methodName) {
                    // Stub out the original method if it's not decorating an actual method
                    var originalMethod = function() {};
                    if (methodName in DecoratedClass.prototype) originalMethod = DecoratedClass.prototype[methodName];
                    var decoratedMethod = DecoratorClass.prototype[methodName];
                    return function() {
                        var unshift = Array.prototype.unshift;
                        unshift.call(arguments, originalMethod);
                        return decoratedMethod.apply(this, arguments);
                    };
                };
                for(var d = 0; d < decoratedMethods.length; d++){
                    var decoratedMethod = decoratedMethods[d];
                    DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
                }
                return DecoratedClass;
            };
            var Observable = function() {
                this.listeners = {};
            };
            Observable.prototype.on = function(event, callback) {
                this.listeners = this.listeners || {};
                if (event in this.listeners) this.listeners[event].push(callback);
                else this.listeners[event] = [
                    callback
                ];
            };
            Observable.prototype.trigger = function(event) {
                var slice = Array.prototype.slice;
                var params = slice.call(arguments, 1);
                this.listeners = this.listeners || {};
                // Params should always come in as an array
                if (params == null) params = [];
                // If there are no arguments to the event, use a temporary object
                if (params.length === 0) params.push({});
                // Set the `_type` of the first object to the event
                params[0]._type = event;
                if (event in this.listeners) this.invoke(this.listeners[event], slice.call(arguments, 1));
                if ("*" in this.listeners) this.invoke(this.listeners["*"], arguments);
            };
            Observable.prototype.invoke = function(listeners, params) {
                for(var i = 0, len = listeners.length; i < len; i++)listeners[i].apply(this, params);
            };
            Utils.Observable = Observable;
            Utils.generateChars = function(length) {
                var chars = "";
                for(var i = 0; i < length; i++){
                    var randomChar = Math.floor(Math.random() * 36);
                    chars += randomChar.toString(36);
                }
                return chars;
            };
            Utils.bind = function(func, context) {
                return function() {
                    func.apply(context, arguments);
                };
            };
            Utils._convertData = function(data) {
                for(var originalKey in data){
                    var keys = originalKey.split("-");
                    var dataLevel = data;
                    if (keys.length === 1) continue;
                    for(var k = 0; k < keys.length; k++){
                        var key = keys[k];
                        // Lowercase the first letter
                        // By default, dash-separated becomes camelCase
                        key = key.substring(0, 1).toLowerCase() + key.substring(1);
                        if (!(key in dataLevel)) dataLevel[key] = {};
                        if (k == keys.length - 1) dataLevel[key] = data[originalKey];
                        dataLevel = dataLevel[key];
                    }
                    delete data[originalKey];
                }
                return data;
            };
            Utils.hasScroll = function(index, el) {
                // Adapted from the function created by @ShadowScripter
                // and adapted by @BillBarry on the Stack Exchange Code Review website.
                // The original code can be found at
                // http://codereview.stackexchange.com/q/13338
                // and was designed to be used with the Sizzle selector engine.
                var $el = $1(el);
                var overflowX = el.style.overflowX;
                var overflowY = el.style.overflowY;
                //Check both x and y declarations
                if (overflowX === overflowY && (overflowY === "hidden" || overflowY === "visible")) return false;
                if (overflowX === "scroll" || overflowY === "scroll") return true;
                return $el.innerHeight() < el.scrollHeight || $el.innerWidth() < el.scrollWidth;
            };
            Utils.escapeMarkup = function(markup) {
                var replaceMap = {
                    "\\": "&#92;",
                    "&": "&amp;",
                    "<": "&lt;",
                    ">": "&gt;",
                    '"': "&quot;",
                    "'": "&#39;",
                    "/": "&#47;"
                };
                // Do not try to escape the markup if it's not a string
                if (typeof markup !== "string") return markup;
                return String(markup).replace(/[&<>"'\/\\]/g, function(match) {
                    return replaceMap[match];
                });
            };
            // Append an array of jQuery nodes to a given element.
            Utils.appendMany = function($element, $nodes) {
                // jQuery 1.7.x does not support $.fn.append() with an array
                // Fall back to a jQuery object collection using $.fn.add()
                if ($1.fn.jquery.substr(0, 3) === "1.7") {
                    var $jqNodes = $1();
                    $1.map($nodes, function(node) {
                        $jqNodes = $jqNodes.add(node);
                    });
                    $nodes = $jqNodes;
                }
                $element.append($nodes);
            };
            // Cache objects in Utils.__cache instead of $.data (see #4346)
            Utils.__cache = {};
            var id = 0;
            Utils.GetUniqueElementId = function(element) {
                // Get a unique element Id. If element has no id,
                // creates a new unique number, stores it in the id
                // attribute and returns the new id.
                // If an id already exists, it simply returns it.
                var select2Id = element.getAttribute("data-select2-id");
                if (select2Id == null) {
                    // If element has id, use it.
                    if (element.id) {
                        select2Id = element.id;
                        element.setAttribute("data-select2-id", select2Id);
                    } else {
                        element.setAttribute("data-select2-id", ++id);
                        select2Id = id.toString();
                    }
                }
                return select2Id;
            };
            Utils.StoreData = function(element, name, value) {
                // Stores an item in the cache for a specified element.
                // name is the cache key.
                var id = Utils.GetUniqueElementId(element);
                if (!Utils.__cache[id]) Utils.__cache[id] = {};
                Utils.__cache[id][name] = value;
            };
            Utils.GetData = function(element, name) {
                // Retrieves a value from the cache by its key (name)
                // name is optional. If no name specified, return
                // all cache items for the specified element.
                // and for a specified element.
                var id = Utils.GetUniqueElementId(element);
                if (name) {
                    if (Utils.__cache[id]) {
                        if (Utils.__cache[id][name] != null) return Utils.__cache[id][name];
                        return $1(element).data(name); // Fallback to HTML5 data attribs.
                    }
                    return $1(element).data(name); // Fallback to HTML5 data attribs.
                } else return Utils.__cache[id];
            };
            Utils.RemoveData = function(element) {
                // Removes all cached items for a specified element.
                var id = Utils.GetUniqueElementId(element);
                if (Utils.__cache[id] != null) delete Utils.__cache[id];
                element.removeAttribute("data-select2-id");
            };
            return Utils;
        });
        S2.define("select2/results", [
            "jquery",
            "./utils"
        ], function($1, Utils) {
            function Results($element, options, dataAdapter) {
                this.$element = $element;
                this.data = dataAdapter;
                this.options = options;
                Results.__super__.constructor.call(this);
            }
            Utils.Extend(Results, Utils.Observable);
            Results.prototype.render = function() {
                var $results = $1('<ul class="select2-results__options" role="listbox"></ul>');
                if (this.options.get("multiple")) $results.attr("aria-multiselectable", "true");
                this.$results = $results;
                return $results;
            };
            Results.prototype.clear = function() {
                this.$results.empty();
            };
            Results.prototype.displayMessage = function(params) {
                var escapeMarkup = this.options.get("escapeMarkup");
                this.clear();
                this.hideLoading();
                var $message = $1('<li role="alert" aria-live="assertive" class="select2-results__option"></li>');
                var message = this.options.get("translations").get(params.message);
                $message.append(escapeMarkup(message(params.args)));
                $message[0].className += " select2-results__message";
                this.$results.append($message);
            };
            Results.prototype.hideMessages = function() {
                this.$results.find(".select2-results__message").remove();
            };
            Results.prototype.append = function(data) {
                this.hideLoading();
                var $options = [];
                if (data.results == null || data.results.length === 0) {
                    if (this.$results.children().length === 0) this.trigger("results:message", {
                        message: "noResults"
                    });
                    return;
                }
                data.results = this.sort(data.results);
                for(var d = 0; d < data.results.length; d++){
                    var item = data.results[d];
                    var $option = this.option(item);
                    $options.push($option);
                }
                this.$results.append($options);
            };
            Results.prototype.position = function($results, $dropdown) {
                var $resultsContainer = $dropdown.find(".select2-results");
                $resultsContainer.append($results);
            };
            Results.prototype.sort = function(data) {
                var sorter = this.options.get("sorter");
                return sorter(data);
            };
            Results.prototype.highlightFirstItem = function() {
                var $options = this.$results.find(".select2-results__option[aria-selected]");
                var $selected = $options.filter("[aria-selected=true]");
                // Check if there are any selected options
                if ($selected.length > 0) // If there are selected options, highlight the first
                $selected.first().trigger("mouseenter");
                else // If there are no selected options, highlight the first option
                // in the dropdown
                $options.first().trigger("mouseenter");
                this.ensureHighlightVisible();
            };
            Results.prototype.setClasses = function() {
                var self = this;
                this.data.current(function(selected) {
                    var selectedIds = $1.map(selected, function(s) {
                        return s.id.toString();
                    });
                    var $options = self.$results.find(".select2-results__option[aria-selected]");
                    $options.each(function() {
                        var $option = $1(this);
                        var item = Utils.GetData(this, "data");
                        // id needs to be converted to a string when comparing
                        var id = "" + item.id;
                        if (item.element != null && item.element.selected || item.element == null && $1.inArray(id, selectedIds) > -1) $option.attr("aria-selected", "true");
                        else $option.attr("aria-selected", "false");
                    });
                });
            };
            Results.prototype.showLoading = function(params) {
                this.hideLoading();
                var loadingMore = this.options.get("translations").get("searching");
                var loading = {
                    disabled: true,
                    loading: true,
                    text: loadingMore(params)
                };
                var $loading = this.option(loading);
                $loading.className += " loading-results";
                this.$results.prepend($loading);
            };
            Results.prototype.hideLoading = function() {
                this.$results.find(".loading-results").remove();
            };
            Results.prototype.option = function(data) {
                var option = document.createElement("li");
                option.className = "select2-results__option";
                var attrs = {
                    "role": "option",
                    "aria-selected": "false"
                };
                var matches = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
                if (data.element != null && matches.call(data.element, ":disabled") || data.element == null && data.disabled) {
                    delete attrs["aria-selected"];
                    attrs["aria-disabled"] = "true";
                }
                if (data.id == null) delete attrs["aria-selected"];
                if (data._resultId != null) option.id = data._resultId;
                if (data.title) option.title = data.title;
                if (data.children) {
                    attrs.role = "group";
                    attrs["aria-label"] = data.text;
                    delete attrs["aria-selected"];
                }
                for(var attr in attrs){
                    var val = attrs[attr];
                    option.setAttribute(attr, val);
                }
                if (data.children) {
                    var $option = $1(option);
                    var label = document.createElement("strong");
                    label.className = "select2-results__group";
                    var $label = $1(label);
                    this.template(data, label);
                    var $children = [];
                    for(var c = 0; c < data.children.length; c++){
                        var child = data.children[c];
                        var $child = this.option(child);
                        $children.push($child);
                    }
                    var $childrenContainer = $1("<ul></ul>", {
                        "class": "select2-results__options select2-results__options--nested"
                    });
                    $childrenContainer.append($children);
                    $option.append(label);
                    $option.append($childrenContainer);
                } else this.template(data, option);
                Utils.StoreData(option, "data", data);
                return option;
            };
            Results.prototype.bind = function(container, $container) {
                var self = this;
                var id = container.id + "-results";
                this.$results.attr("id", id);
                container.on("results:all", function(params) {
                    self.clear();
                    self.append(params.data);
                    if (container.isOpen()) {
                        self.setClasses();
                        self.highlightFirstItem();
                    }
                });
                container.on("results:append", function(params) {
                    self.append(params.data);
                    if (container.isOpen()) self.setClasses();
                });
                container.on("query", function(params) {
                    self.hideMessages();
                    self.showLoading(params);
                });
                container.on("select", function() {
                    if (!container.isOpen()) return;
                    self.setClasses();
                    if (self.options.get("scrollAfterSelect")) self.highlightFirstItem();
                });
                container.on("unselect", function() {
                    if (!container.isOpen()) return;
                    self.setClasses();
                    if (self.options.get("scrollAfterSelect")) self.highlightFirstItem();
                });
                container.on("open", function() {
                    // When the dropdown is open, aria-expended="true"
                    self.$results.attr("aria-expanded", "true");
                    self.$results.attr("aria-hidden", "false");
                    self.setClasses();
                    self.ensureHighlightVisible();
                });
                container.on("close", function() {
                    // When the dropdown is closed, aria-expended="false"
                    self.$results.attr("aria-expanded", "false");
                    self.$results.attr("aria-hidden", "true");
                    self.$results.removeAttr("aria-activedescendant");
                });
                container.on("results:toggle", function() {
                    var $highlighted = self.getHighlightedResults();
                    if ($highlighted.length === 0) return;
                    $highlighted.trigger("mouseup");
                });
                container.on("results:select", function() {
                    var $highlighted = self.getHighlightedResults();
                    if ($highlighted.length === 0) return;
                    var data = Utils.GetData($highlighted[0], "data");
                    if ($highlighted.attr("aria-selected") == "true") self.trigger("close", {});
                    else self.trigger("select", {
                        data: data
                    });
                });
                container.on("results:previous", function() {
                    var $highlighted = self.getHighlightedResults();
                    var $options = self.$results.find("[aria-selected]");
                    var currentIndex = $options.index($highlighted);
                    // If we are already at the top, don't move further
                    // If no options, currentIndex will be -1
                    if (currentIndex <= 0) return;
                    var nextIndex = currentIndex - 1;
                    // If none are highlighted, highlight the first
                    if ($highlighted.length === 0) nextIndex = 0;
                    var $next = $options.eq(nextIndex);
                    $next.trigger("mouseenter");
                    var currentOffset = self.$results.offset().top;
                    var nextTop = $next.offset().top;
                    var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);
                    if (nextIndex === 0) self.$results.scrollTop(0);
                    else if (nextTop - currentOffset < 0) self.$results.scrollTop(nextOffset);
                });
                container.on("results:next", function() {
                    var $highlighted = self.getHighlightedResults();
                    var $options = self.$results.find("[aria-selected]");
                    var currentIndex = $options.index($highlighted);
                    var nextIndex = currentIndex + 1;
                    // If we are at the last option, stay there
                    if (nextIndex >= $options.length) return;
                    var $next = $options.eq(nextIndex);
                    $next.trigger("mouseenter");
                    var currentOffset = self.$results.offset().top + self.$results.outerHeight(false);
                    var nextBottom = $next.offset().top + $next.outerHeight(false);
                    var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;
                    if (nextIndex === 0) self.$results.scrollTop(0);
                    else if (nextBottom > currentOffset) self.$results.scrollTop(nextOffset);
                });
                container.on("results:focus", function(params) {
                    params.element.addClass("select2-results__option--highlighted");
                });
                container.on("results:message", function(params) {
                    self.displayMessage(params);
                });
                if ($1.fn.mousewheel) this.$results.on("mousewheel", function(e) {
                    var top = self.$results.scrollTop();
                    var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;
                    var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
                    var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();
                    if (isAtTop) {
                        self.$results.scrollTop(0);
                        e.preventDefault();
                        e.stopPropagation();
                    } else if (isAtBottom) {
                        self.$results.scrollTop(self.$results.get(0).scrollHeight - self.$results.height());
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
                this.$results.on("mouseup", ".select2-results__option[aria-selected]", function(evt) {
                    var $this = $1(this);
                    var data = Utils.GetData(this, "data");
                    if ($this.attr("aria-selected") === "true") {
                        if (self.options.get("multiple")) self.trigger("unselect", {
                            originalEvent: evt,
                            data: data
                        });
                        else self.trigger("close", {});
                        return;
                    }
                    self.trigger("select", {
                        originalEvent: evt,
                        data: data
                    });
                });
                this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function(evt) {
                    var data = Utils.GetData(this, "data");
                    self.getHighlightedResults().removeClass("select2-results__option--highlighted");
                    self.trigger("results:focus", {
                        data: data,
                        element: $1(this)
                    });
                });
            };
            Results.prototype.getHighlightedResults = function() {
                var $highlighted = this.$results.find(".select2-results__option--highlighted");
                return $highlighted;
            };
            Results.prototype.destroy = function() {
                this.$results.remove();
            };
            Results.prototype.ensureHighlightVisible = function() {
                var $highlighted = this.getHighlightedResults();
                if ($highlighted.length === 0) return;
                var $options = this.$results.find("[aria-selected]");
                var currentIndex = $options.index($highlighted);
                var currentOffset = this.$results.offset().top;
                var nextTop = $highlighted.offset().top;
                var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);
                var offsetDelta = nextTop - currentOffset;
                nextOffset -= $highlighted.outerHeight(false) * 2;
                if (currentIndex <= 2) this.$results.scrollTop(0);
                else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) this.$results.scrollTop(nextOffset);
            };
            Results.prototype.template = function(result, container) {
                var template = this.options.get("templateResult");
                var escapeMarkup = this.options.get("escapeMarkup");
                var content = template(result, container);
                if (content == null) container.style.display = "none";
                else if (typeof content === "string") container.innerHTML = escapeMarkup(content);
                else $1(container).append(content);
            };
            return Results;
        });
        S2.define("select2/keys", [], function() {
            var KEYS = {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                SHIFT: 16,
                CTRL: 17,
                ALT: 18,
                ESC: 27,
                SPACE: 32,
                PAGE_UP: 33,
                PAGE_DOWN: 34,
                END: 35,
                HOME: 36,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                DELETE: 46
            };
            return KEYS;
        });
        S2.define("select2/selection/base", [
            "jquery",
            "../utils",
            "../keys"
        ], function($1, Utils, KEYS) {
            function BaseSelection($element, options) {
                this.$element = $element;
                this.options = options;
                BaseSelection.__super__.constructor.call(this);
            }
            Utils.Extend(BaseSelection, Utils.Observable);
            BaseSelection.prototype.render = function() {
                var $selection = $1('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
                this._tabindex = 0;
                if (Utils.GetData(this.$element[0], "old-tabindex") != null) this._tabindex = Utils.GetData(this.$element[0], "old-tabindex");
                else if (this.$element.attr("tabindex") != null) this._tabindex = this.$element.attr("tabindex");
                $selection.attr("title", this.$element.attr("title"));
                $selection.attr("tabindex", this._tabindex);
                $selection.attr("aria-disabled", "false");
                this.$selection = $selection;
                return $selection;
            };
            BaseSelection.prototype.bind = function(container, $container) {
                var self = this;
                var resultsId = container.id + "-results";
                this.container = container;
                this.$selection.on("focus", function(evt) {
                    self.trigger("focus", evt);
                });
                this.$selection.on("blur", function(evt) {
                    self._handleBlur(evt);
                });
                this.$selection.on("keydown", function(evt) {
                    self.trigger("keypress", evt);
                    if (evt.which === KEYS.SPACE) evt.preventDefault();
                });
                container.on("results:focus", function(params) {
                    self.$selection.attr("aria-activedescendant", params.data._resultId);
                });
                container.on("selection:update", function(params) {
                    self.update(params.data);
                });
                container.on("open", function() {
                    // When the dropdown is open, aria-expanded="true"
                    self.$selection.attr("aria-expanded", "true");
                    self.$selection.attr("aria-owns", resultsId);
                    self._attachCloseHandler(container);
                });
                container.on("close", function() {
                    // When the dropdown is closed, aria-expanded="false"
                    self.$selection.attr("aria-expanded", "false");
                    self.$selection.removeAttr("aria-activedescendant");
                    self.$selection.removeAttr("aria-owns");
                    self.$selection.trigger("focus");
                    self._detachCloseHandler(container);
                });
                container.on("enable", function() {
                    self.$selection.attr("tabindex", self._tabindex);
                    self.$selection.attr("aria-disabled", "false");
                });
                container.on("disable", function() {
                    self.$selection.attr("tabindex", "-1");
                    self.$selection.attr("aria-disabled", "true");
                });
            };
            BaseSelection.prototype._handleBlur = function(evt) {
                var self = this;
                // This needs to be delayed as the active element is the body when the tab
                // key is pressed, possibly along with others.
                window.setTimeout(function() {
                    // Don't trigger `blur` if the focus is still in the selection
                    if (document.activeElement == self.$selection[0] || $1.contains(self.$selection[0], document.activeElement)) return;
                    self.trigger("blur", evt);
                }, 1);
            };
            BaseSelection.prototype._attachCloseHandler = function(container) {
                $1(document.body).on("mousedown.select2." + container.id, function(e) {
                    var $target = $1(e.target);
                    var $select = $target.closest(".select2");
                    var $all = $1(".select2.select2-container--open");
                    $all.each(function() {
                        if (this == $select[0]) return;
                        var $element = Utils.GetData(this, "element");
                        $element.select2("close");
                    });
                });
            };
            BaseSelection.prototype._detachCloseHandler = function(container) {
                $1(document.body).off("mousedown.select2." + container.id);
            };
            BaseSelection.prototype.position = function($selection, $container) {
                var $selectionContainer = $container.find(".selection");
                $selectionContainer.append($selection);
            };
            BaseSelection.prototype.destroy = function() {
                this._detachCloseHandler(this.container);
            };
            BaseSelection.prototype.update = function(data) {
                throw new Error("The `update` method must be defined in child classes.");
            };
            /**
   * Helper method to abstract the "enabled" (not "disabled") state of this
   * object.
   *
   * @return {true} if the instance is not disabled.
   * @return {false} if the instance is disabled.
   */ BaseSelection.prototype.isEnabled = function() {
                return !this.isDisabled();
            };
            /**
   * Helper method to abstract the "disabled" state of this object.
   *
   * @return {true} if the disabled option is true.
   * @return {false} if the disabled option is false.
   */ BaseSelection.prototype.isDisabled = function() {
                return this.options.get("disabled");
            };
            return BaseSelection;
        });
        S2.define("select2/selection/single", [
            "jquery",
            "./base",
            "../utils",
            "../keys"
        ], function($1, BaseSelection, Utils, KEYS) {
            function SingleSelection() {
                SingleSelection.__super__.constructor.apply(this, arguments);
            }
            Utils.Extend(SingleSelection, BaseSelection);
            SingleSelection.prototype.render = function() {
                var $selection = SingleSelection.__super__.render.call(this);
                $selection.addClass("select2-selection--single");
                $selection.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>');
                return $selection;
            };
            SingleSelection.prototype.bind = function(container, $container) {
                var self = this;
                SingleSelection.__super__.bind.apply(this, arguments);
                var id = container.id + "-container";
                this.$selection.find(".select2-selection__rendered").attr("id", id).attr("role", "textbox").attr("aria-readonly", "true");
                this.$selection.attr("aria-labelledby", id);
                this.$selection.on("mousedown", function(evt) {
                    // Only respond to left clicks
                    if (evt.which !== 1) return;
                    self.trigger("toggle", {
                        originalEvent: evt
                    });
                });
                this.$selection.on("focus", function(evt) {
                // User focuses on the container
                });
                this.$selection.on("blur", function(evt) {
                // User exits the container
                });
                container.on("focus", function(evt) {
                    if (!container.isOpen()) self.$selection.trigger("focus");
                });
            };
            SingleSelection.prototype.clear = function() {
                var $rendered = this.$selection.find(".select2-selection__rendered");
                $rendered.empty();
                $rendered.removeAttr("title"); // clear tooltip on empty
            };
            SingleSelection.prototype.display = function(data, container) {
                var template = this.options.get("templateSelection");
                var escapeMarkup = this.options.get("escapeMarkup");
                return escapeMarkup(template(data, container));
            };
            SingleSelection.prototype.selectionContainer = function() {
                return $1("<span></span>");
            };
            SingleSelection.prototype.update = function(data) {
                if (data.length === 0) {
                    this.clear();
                    return;
                }
                var selection = data[0];
                var $rendered = this.$selection.find(".select2-selection__rendered");
                var formatted = this.display(selection, $rendered);
                $rendered.empty().append(formatted);
                var title = selection.title || selection.text;
                if (title) $rendered.attr("title", title);
                else $rendered.removeAttr("title");
            };
            return SingleSelection;
        });
        S2.define("select2/selection/multiple", [
            "jquery",
            "./base",
            "../utils"
        ], function($1, BaseSelection, Utils) {
            function MultipleSelection($element, options) {
                MultipleSelection.__super__.constructor.apply(this, arguments);
            }
            Utils.Extend(MultipleSelection, BaseSelection);
            MultipleSelection.prototype.render = function() {
                var $selection = MultipleSelection.__super__.render.call(this);
                $selection.addClass("select2-selection--multiple");
                $selection.html('<ul class="select2-selection__rendered"></ul>');
                return $selection;
            };
            MultipleSelection.prototype.bind = function(container, $container) {
                var self = this;
                MultipleSelection.__super__.bind.apply(this, arguments);
                this.$selection.on("click", function(evt) {
                    self.trigger("toggle", {
                        originalEvent: evt
                    });
                });
                this.$selection.on("click", ".select2-selection__choice__remove", function(evt) {
                    // Ignore the event if it is disabled
                    if (self.isDisabled()) return;
                    var $remove = $1(this);
                    var $selection = $remove.parent();
                    var data = Utils.GetData($selection[0], "data");
                    self.trigger("unselect", {
                        originalEvent: evt,
                        data: data
                    });
                });
            };
            MultipleSelection.prototype.clear = function() {
                var $rendered = this.$selection.find(".select2-selection__rendered");
                $rendered.empty();
                $rendered.removeAttr("title");
            };
            MultipleSelection.prototype.display = function(data, container) {
                var template = this.options.get("templateSelection");
                var escapeMarkup = this.options.get("escapeMarkup");
                return escapeMarkup(template(data, container));
            };
            MultipleSelection.prototype.selectionContainer = function() {
                var $container = $1('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>');
                return $container;
            };
            MultipleSelection.prototype.update = function(data) {
                this.clear();
                if (data.length === 0) return;
                var $selections = [];
                for(var d = 0; d < data.length; d++){
                    var selection = data[d];
                    var $selection = this.selectionContainer();
                    var formatted = this.display(selection, $selection);
                    $selection.append(formatted);
                    var title = selection.title || selection.text;
                    if (title) $selection.attr("title", title);
                    Utils.StoreData($selection[0], "data", selection);
                    $selections.push($selection);
                }
                var $rendered = this.$selection.find(".select2-selection__rendered");
                Utils.appendMany($rendered, $selections);
            };
            return MultipleSelection;
        });
        S2.define("select2/selection/placeholder", [
            "../utils"
        ], function(Utils) {
            function Placeholder(decorated, $element, options) {
                this.placeholder = this.normalizePlaceholder(options.get("placeholder"));
                decorated.call(this, $element, options);
            }
            Placeholder.prototype.normalizePlaceholder = function(_, placeholder) {
                if (typeof placeholder === "string") placeholder = {
                    id: "",
                    text: placeholder
                };
                return placeholder;
            };
            Placeholder.prototype.createPlaceholder = function(decorated, placeholder) {
                var $placeholder = this.selectionContainer();
                $placeholder.html(this.display(placeholder));
                $placeholder.addClass("select2-selection__placeholder").removeClass("select2-selection__choice");
                return $placeholder;
            };
            Placeholder.prototype.update = function(decorated, data) {
                var singlePlaceholder = data.length == 1 && data[0].id != this.placeholder.id;
                var multipleSelections = data.length > 1;
                if (multipleSelections || singlePlaceholder) return decorated.call(this, data);
                this.clear();
                var $placeholder = this.createPlaceholder(this.placeholder);
                this.$selection.find(".select2-selection__rendered").append($placeholder);
            };
            return Placeholder;
        });
        S2.define("select2/selection/allowClear", [
            "jquery",
            "../keys",
            "../utils"
        ], function($1, KEYS, Utils) {
            function AllowClear() {}
            AllowClear.prototype.bind = function(decorated, container, $container) {
                var self = this;
                decorated.call(this, container, $container);
                if (this.placeholder == null) {
                    if (this.options.get("debug") && window.console && console.error) console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option.");
                }
                this.$selection.on("mousedown", ".select2-selection__clear", function(evt) {
                    self._handleClear(evt);
                });
                container.on("keypress", function(evt) {
                    self._handleKeyboardClear(evt, container);
                });
            };
            AllowClear.prototype._handleClear = function(_, evt) {
                // Ignore the event if it is disabled
                if (this.isDisabled()) return;
                var $clear = this.$selection.find(".select2-selection__clear");
                // Ignore the event if nothing has been selected
                if ($clear.length === 0) return;
                evt.stopPropagation();
                var data = Utils.GetData($clear[0], "data");
                var previousVal = this.$element.val();
                this.$element.val(this.placeholder.id);
                var unselectData = {
                    data: data
                };
                this.trigger("clear", unselectData);
                if (unselectData.prevented) {
                    this.$element.val(previousVal);
                    return;
                }
                for(var d = 0; d < data.length; d++){
                    unselectData = {
                        data: data[d]
                    };
                    // Trigger the `unselect` event, so people can prevent it from being
                    // cleared.
                    this.trigger("unselect", unselectData);
                    // If the event was prevented, don't clear it out.
                    if (unselectData.prevented) {
                        this.$element.val(previousVal);
                        return;
                    }
                }
                this.$element.trigger("input").trigger("change");
                this.trigger("toggle", {});
            };
            AllowClear.prototype._handleKeyboardClear = function(_, evt, container) {
                if (container.isOpen()) return;
                if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) this._handleClear(evt);
            };
            AllowClear.prototype.update = function(decorated, data) {
                decorated.call(this, data);
                if (this.$selection.find(".select2-selection__placeholder").length > 0 || data.length === 0) return;
                var removeAll = this.options.get("translations").get("removeAllItems");
                var $remove = $1('<span class="select2-selection__clear" title="' + removeAll() + '">' + "&times;" + "</span>");
                Utils.StoreData($remove[0], "data", data);
                this.$selection.find(".select2-selection__rendered").prepend($remove);
            };
            return AllowClear;
        });
        S2.define("select2/selection/search", [
            "jquery",
            "../utils",
            "../keys"
        ], function($1, Utils, KEYS) {
            function Search(decorated, $element, options) {
                decorated.call(this, $element, options);
            }
            Search.prototype.render = function(decorated) {
                var $search = $1('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>');
                this.$searchContainer = $search;
                this.$search = $search.find("input");
                var $rendered = decorated.call(this);
                this._transferTabIndex();
                return $rendered;
            };
            Search.prototype.bind = function(decorated, container, $container) {
                var self = this;
                var resultsId = container.id + "-results";
                decorated.call(this, container, $container);
                container.on("open", function() {
                    self.$search.attr("aria-controls", resultsId);
                    self.$search.trigger("focus");
                });
                container.on("close", function() {
                    self.$search.val("");
                    self.$search.removeAttr("aria-controls");
                    self.$search.removeAttr("aria-activedescendant");
                    self.$search.trigger("focus");
                });
                container.on("enable", function() {
                    self.$search.prop("disabled", false);
                    self._transferTabIndex();
                });
                container.on("disable", function() {
                    self.$search.prop("disabled", true);
                });
                container.on("focus", function(evt) {
                    self.$search.trigger("focus");
                });
                container.on("results:focus", function(params) {
                    if (params.data._resultId) self.$search.attr("aria-activedescendant", params.data._resultId);
                    else self.$search.removeAttr("aria-activedescendant");
                });
                this.$selection.on("focusin", ".select2-search--inline", function(evt) {
                    self.trigger("focus", evt);
                });
                this.$selection.on("focusout", ".select2-search--inline", function(evt) {
                    self._handleBlur(evt);
                });
                this.$selection.on("keydown", ".select2-search--inline", function(evt) {
                    evt.stopPropagation();
                    self.trigger("keypress", evt);
                    self._keyUpPrevented = evt.isDefaultPrevented();
                    var key = evt.which;
                    if (key === KEYS.BACKSPACE && self.$search.val() === "") {
                        var $previousChoice = self.$searchContainer.prev(".select2-selection__choice");
                        if ($previousChoice.length > 0) {
                            var item = Utils.GetData($previousChoice[0], "data");
                            self.searchRemoveChoice(item);
                            evt.preventDefault();
                        }
                    }
                });
                this.$selection.on("click", ".select2-search--inline", function(evt) {
                    if (self.$search.val()) evt.stopPropagation();
                });
                // Try to detect the IE version should the `documentMode` property that
                // is stored on the document. This is only implemented in IE and is
                // slightly cleaner than doing a user agent check.
                // This property is not available in Edge, but Edge also doesn't have
                // this bug.
                var msie = document.documentMode;
                var disableInputEvents = msie && msie <= 11;
                // Workaround for browsers which do not support the `input` event
                // This will prevent double-triggering of events for browsers which support
                // both the `keyup` and `input` events.
                this.$selection.on("input.searchcheck", ".select2-search--inline", function(evt) {
                    // IE will trigger the `input` event when a placeholder is used on a
                    // search box. To get around this issue, we are forced to ignore all
                    // `input` events in IE and keep using `keyup`.
                    if (disableInputEvents) {
                        self.$selection.off("input.search input.searchcheck");
                        return;
                    }
                    // Unbind the duplicated `keyup` event
                    self.$selection.off("keyup.search");
                });
                this.$selection.on("keyup.search input.search", ".select2-search--inline", function(evt) {
                    // IE will trigger the `input` event when a placeholder is used on a
                    // search box. To get around this issue, we are forced to ignore all
                    // `input` events in IE and keep using `keyup`.
                    if (disableInputEvents && evt.type === "input") {
                        self.$selection.off("input.search input.searchcheck");
                        return;
                    }
                    var key = evt.which;
                    // We can freely ignore events from modifier keys
                    if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) return;
                    // Tabbing will be handled during the `keydown` phase
                    if (key == KEYS.TAB) return;
                    self.handleSearch(evt);
                });
            };
            /**
   * This method will transfer the tabindex attribute from the rendered
   * selection to the search box. This allows for the search box to be used as
   * the primary focus instead of the selection container.
   *
   * @private
   */ Search.prototype._transferTabIndex = function(decorated) {
                this.$search.attr("tabindex", this.$selection.attr("tabindex"));
                this.$selection.attr("tabindex", "-1");
            };
            Search.prototype.createPlaceholder = function(decorated, placeholder) {
                this.$search.attr("placeholder", placeholder.text);
            };
            Search.prototype.update = function(decorated, data) {
                var searchHadFocus = this.$search[0] == document.activeElement;
                this.$search.attr("placeholder", "");
                decorated.call(this, data);
                this.$selection.find(".select2-selection__rendered").append(this.$searchContainer);
                this.resizeSearch();
                if (searchHadFocus) this.$search.trigger("focus");
            };
            Search.prototype.handleSearch = function() {
                this.resizeSearch();
                if (!this._keyUpPrevented) {
                    var input = this.$search.val();
                    this.trigger("query", {
                        term: input
                    });
                }
                this._keyUpPrevented = false;
            };
            Search.prototype.searchRemoveChoice = function(decorated, item) {
                this.trigger("unselect", {
                    data: item
                });
                this.$search.val(item.text);
                this.handleSearch();
            };
            Search.prototype.resizeSearch = function() {
                this.$search.css("width", "25px");
                var width = "";
                if (this.$search.attr("placeholder") !== "") width = this.$selection.find(".select2-selection__rendered").width();
                else {
                    var minimumWidth = this.$search.val().length + 1;
                    width = minimumWidth * 0.75 + "em";
                }
                this.$search.css("width", width);
            };
            return Search;
        });
        S2.define("select2/selection/eventRelay", [
            "jquery"
        ], function($1) {
            function EventRelay() {}
            EventRelay.prototype.bind = function(decorated, container, $container) {
                var self = this;
                var relayEvents = [
                    "open",
                    "opening",
                    "close",
                    "closing",
                    "select",
                    "selecting",
                    "unselect",
                    "unselecting",
                    "clear",
                    "clearing"
                ];
                var preventableEvents = [
                    "opening",
                    "closing",
                    "selecting",
                    "unselecting",
                    "clearing"
                ];
                decorated.call(this, container, $container);
                container.on("*", function(name, params) {
                    // Ignore events that should not be relayed
                    if ($1.inArray(name, relayEvents) === -1) return;
                    // The parameters should always be an object
                    params = params || {};
                    // Generate the jQuery event for the Select2 event
                    var evt = $1.Event("select2:" + name, {
                        params: params
                    });
                    self.$element.trigger(evt);
                    // Only handle preventable events if it was one
                    if ($1.inArray(name, preventableEvents) === -1) return;
                    params.prevented = evt.isDefaultPrevented();
                });
            };
            return EventRelay;
        });
        S2.define("select2/translation", [
            "jquery",
            "require"
        ], function($1, require1) {
            function Translation(dict) {
                this.dict = dict || {};
            }
            Translation.prototype.all = function() {
                return this.dict;
            };
            Translation.prototype.get = function(key) {
                return this.dict[key];
            };
            Translation.prototype.extend = function(translation) {
                this.dict = $1.extend({}, translation.all(), this.dict);
            };
            // Static functions
            Translation._cache = {};
            Translation.loadPath = function(path) {
                if (!(path in Translation._cache)) {
                    var translations = require1(path);
                    Translation._cache[path] = translations;
                }
                return new Translation(Translation._cache[path]);
            };
            return Translation;
        });
        S2.define("select2/diacritics", [], function() {
            var diacritics = {
                "\u24B6": "A",
                "\uFF21": "A",
                "\xc0": "A",
                "\xc1": "A",
                "\xc2": "A",
                "\u1EA6": "A",
                "\u1EA4": "A",
                "\u1EAA": "A",
                "\u1EA8": "A",
                "\xc3": "A",
                "\u0100": "A",
                "\u0102": "A",
                "\u1EB0": "A",
                "\u1EAE": "A",
                "\u1EB4": "A",
                "\u1EB2": "A",
                "\u0226": "A",
                "\u01E0": "A",
                "\xc4": "A",
                "\u01DE": "A",
                "\u1EA2": "A",
                "\xc5": "A",
                "\u01FA": "A",
                "\u01CD": "A",
                "\u0200": "A",
                "\u0202": "A",
                "\u1EA0": "A",
                "\u1EAC": "A",
                "\u1EB6": "A",
                "\u1E00": "A",
                "\u0104": "A",
                "\u023A": "A",
                "\u2C6F": "A",
                "\uA732": "AA",
                "\xc6": "AE",
                "\u01FC": "AE",
                "\u01E2": "AE",
                "\uA734": "AO",
                "\uA736": "AU",
                "\uA738": "AV",
                "\uA73A": "AV",
                "\uA73C": "AY",
                "\u24B7": "B",
                "\uFF22": "B",
                "\u1E02": "B",
                "\u1E04": "B",
                "\u1E06": "B",
                "\u0243": "B",
                "\u0182": "B",
                "\u0181": "B",
                "\u24B8": "C",
                "\uFF23": "C",
                "\u0106": "C",
                "\u0108": "C",
                "\u010A": "C",
                "\u010C": "C",
                "\xc7": "C",
                "\u1E08": "C",
                "\u0187": "C",
                "\u023B": "C",
                "\uA73E": "C",
                "\u24B9": "D",
                "\uFF24": "D",
                "\u1E0A": "D",
                "\u010E": "D",
                "\u1E0C": "D",
                "\u1E10": "D",
                "\u1E12": "D",
                "\u1E0E": "D",
                "\u0110": "D",
                "\u018B": "D",
                "\u018A": "D",
                "\u0189": "D",
                "\uA779": "D",
                "\u01F1": "DZ",
                "\u01C4": "DZ",
                "\u01F2": "Dz",
                "\u01C5": "Dz",
                "\u24BA": "E",
                "\uFF25": "E",
                "\xc8": "E",
                "\xc9": "E",
                "\xca": "E",
                "\u1EC0": "E",
                "\u1EBE": "E",
                "\u1EC4": "E",
                "\u1EC2": "E",
                "\u1EBC": "E",
                "\u0112": "E",
                "\u1E14": "E",
                "\u1E16": "E",
                "\u0114": "E",
                "\u0116": "E",
                "\xcb": "E",
                "\u1EBA": "E",
                "\u011A": "E",
                "\u0204": "E",
                "\u0206": "E",
                "\u1EB8": "E",
                "\u1EC6": "E",
                "\u0228": "E",
                "\u1E1C": "E",
                "\u0118": "E",
                "\u1E18": "E",
                "\u1E1A": "E",
                "\u0190": "E",
                "\u018E": "E",
                "\u24BB": "F",
                "\uFF26": "F",
                "\u1E1E": "F",
                "\u0191": "F",
                "\uA77B": "F",
                "\u24BC": "G",
                "\uFF27": "G",
                "\u01F4": "G",
                "\u011C": "G",
                "\u1E20": "G",
                "\u011E": "G",
                "\u0120": "G",
                "\u01E6": "G",
                "\u0122": "G",
                "\u01E4": "G",
                "\u0193": "G",
                "\uA7A0": "G",
                "\uA77D": "G",
                "\uA77E": "G",
                "\u24BD": "H",
                "\uFF28": "H",
                "\u0124": "H",
                "\u1E22": "H",
                "\u1E26": "H",
                "\u021E": "H",
                "\u1E24": "H",
                "\u1E28": "H",
                "\u1E2A": "H",
                "\u0126": "H",
                "\u2C67": "H",
                "\u2C75": "H",
                "\uA78D": "H",
                "\u24BE": "I",
                "\uFF29": "I",
                "\xcc": "I",
                "\xcd": "I",
                "\xce": "I",
                "\u0128": "I",
                "\u012A": "I",
                "\u012C": "I",
                "\u0130": "I",
                "\xcf": "I",
                "\u1E2E": "I",
                "\u1EC8": "I",
                "\u01CF": "I",
                "\u0208": "I",
                "\u020A": "I",
                "\u1ECA": "I",
                "\u012E": "I",
                "\u1E2C": "I",
                "\u0197": "I",
                "\u24BF": "J",
                "\uFF2A": "J",
                "\u0134": "J",
                "\u0248": "J",
                "\u24C0": "K",
                "\uFF2B": "K",
                "\u1E30": "K",
                "\u01E8": "K",
                "\u1E32": "K",
                "\u0136": "K",
                "\u1E34": "K",
                "\u0198": "K",
                "\u2C69": "K",
                "\uA740": "K",
                "\uA742": "K",
                "\uA744": "K",
                "\uA7A2": "K",
                "\u24C1": "L",
                "\uFF2C": "L",
                "\u013F": "L",
                "\u0139": "L",
                "\u013D": "L",
                "\u1E36": "L",
                "\u1E38": "L",
                "\u013B": "L",
                "\u1E3C": "L",
                "\u1E3A": "L",
                "\u0141": "L",
                "\u023D": "L",
                "\u2C62": "L",
                "\u2C60": "L",
                "\uA748": "L",
                "\uA746": "L",
                "\uA780": "L",
                "\u01C7": "LJ",
                "\u01C8": "Lj",
                "\u24C2": "M",
                "\uFF2D": "M",
                "\u1E3E": "M",
                "\u1E40": "M",
                "\u1E42": "M",
                "\u2C6E": "M",
                "\u019C": "M",
                "\u24C3": "N",
                "\uFF2E": "N",
                "\u01F8": "N",
                "\u0143": "N",
                "\xd1": "N",
                "\u1E44": "N",
                "\u0147": "N",
                "\u1E46": "N",
                "\u0145": "N",
                "\u1E4A": "N",
                "\u1E48": "N",
                "\u0220": "N",
                "\u019D": "N",
                "\uA790": "N",
                "\uA7A4": "N",
                "\u01CA": "NJ",
                "\u01CB": "Nj",
                "\u24C4": "O",
                "\uFF2F": "O",
                "\xd2": "O",
                "\xd3": "O",
                "\xd4": "O",
                "\u1ED2": "O",
                "\u1ED0": "O",
                "\u1ED6": "O",
                "\u1ED4": "O",
                "\xd5": "O",
                "\u1E4C": "O",
                "\u022C": "O",
                "\u1E4E": "O",
                "\u014C": "O",
                "\u1E50": "O",
                "\u1E52": "O",
                "\u014E": "O",
                "\u022E": "O",
                "\u0230": "O",
                "\xd6": "O",
                "\u022A": "O",
                "\u1ECE": "O",
                "\u0150": "O",
                "\u01D1": "O",
                "\u020C": "O",
                "\u020E": "O",
                "\u01A0": "O",
                "\u1EDC": "O",
                "\u1EDA": "O",
                "\u1EE0": "O",
                "\u1EDE": "O",
                "\u1EE2": "O",
                "\u1ECC": "O",
                "\u1ED8": "O",
                "\u01EA": "O",
                "\u01EC": "O",
                "\xd8": "O",
                "\u01FE": "O",
                "\u0186": "O",
                "\u019F": "O",
                "\uA74A": "O",
                "\uA74C": "O",
                "\u0152": "OE",
                "\u01A2": "OI",
                "\uA74E": "OO",
                "\u0222": "OU",
                "\u24C5": "P",
                "\uFF30": "P",
                "\u1E54": "P",
                "\u1E56": "P",
                "\u01A4": "P",
                "\u2C63": "P",
                "\uA750": "P",
                "\uA752": "P",
                "\uA754": "P",
                "\u24C6": "Q",
                "\uFF31": "Q",
                "\uA756": "Q",
                "\uA758": "Q",
                "\u024A": "Q",
                "\u24C7": "R",
                "\uFF32": "R",
                "\u0154": "R",
                "\u1E58": "R",
                "\u0158": "R",
                "\u0210": "R",
                "\u0212": "R",
                "\u1E5A": "R",
                "\u1E5C": "R",
                "\u0156": "R",
                "\u1E5E": "R",
                "\u024C": "R",
                "\u2C64": "R",
                "\uA75A": "R",
                "\uA7A6": "R",
                "\uA782": "R",
                "\u24C8": "S",
                "\uFF33": "S",
                "\u1E9E": "S",
                "\u015A": "S",
                "\u1E64": "S",
                "\u015C": "S",
                "\u1E60": "S",
                "\u0160": "S",
                "\u1E66": "S",
                "\u1E62": "S",
                "\u1E68": "S",
                "\u0218": "S",
                "\u015E": "S",
                "\u2C7E": "S",
                "\uA7A8": "S",
                "\uA784": "S",
                "\u24C9": "T",
                "\uFF34": "T",
                "\u1E6A": "T",
                "\u0164": "T",
                "\u1E6C": "T",
                "\u021A": "T",
                "\u0162": "T",
                "\u1E70": "T",
                "\u1E6E": "T",
                "\u0166": "T",
                "\u01AC": "T",
                "\u01AE": "T",
                "\u023E": "T",
                "\uA786": "T",
                "\uA728": "TZ",
                "\u24CA": "U",
                "\uFF35": "U",
                "\xd9": "U",
                "\xda": "U",
                "\xdb": "U",
                "\u0168": "U",
                "\u1E78": "U",
                "\u016A": "U",
                "\u1E7A": "U",
                "\u016C": "U",
                "\xdc": "U",
                "\u01DB": "U",
                "\u01D7": "U",
                "\u01D5": "U",
                "\u01D9": "U",
                "\u1EE6": "U",
                "\u016E": "U",
                "\u0170": "U",
                "\u01D3": "U",
                "\u0214": "U",
                "\u0216": "U",
                "\u01AF": "U",
                "\u1EEA": "U",
                "\u1EE8": "U",
                "\u1EEE": "U",
                "\u1EEC": "U",
                "\u1EF0": "U",
                "\u1EE4": "U",
                "\u1E72": "U",
                "\u0172": "U",
                "\u1E76": "U",
                "\u1E74": "U",
                "\u0244": "U",
                "\u24CB": "V",
                "\uFF36": "V",
                "\u1E7C": "V",
                "\u1E7E": "V",
                "\u01B2": "V",
                "\uA75E": "V",
                "\u0245": "V",
                "\uA760": "VY",
                "\u24CC": "W",
                "\uFF37": "W",
                "\u1E80": "W",
                "\u1E82": "W",
                "\u0174": "W",
                "\u1E86": "W",
                "\u1E84": "W",
                "\u1E88": "W",
                "\u2C72": "W",
                "\u24CD": "X",
                "\uFF38": "X",
                "\u1E8A": "X",
                "\u1E8C": "X",
                "\u24CE": "Y",
                "\uFF39": "Y",
                "\u1EF2": "Y",
                "\xdd": "Y",
                "\u0176": "Y",
                "\u1EF8": "Y",
                "\u0232": "Y",
                "\u1E8E": "Y",
                "\u0178": "Y",
                "\u1EF6": "Y",
                "\u1EF4": "Y",
                "\u01B3": "Y",
                "\u024E": "Y",
                "\u1EFE": "Y",
                "\u24CF": "Z",
                "\uFF3A": "Z",
                "\u0179": "Z",
                "\u1E90": "Z",
                "\u017B": "Z",
                "\u017D": "Z",
                "\u1E92": "Z",
                "\u1E94": "Z",
                "\u01B5": "Z",
                "\u0224": "Z",
                "\u2C7F": "Z",
                "\u2C6B": "Z",
                "\uA762": "Z",
                "\u24D0": "a",
                "\uFF41": "a",
                "\u1E9A": "a",
                "\xe0": "a",
                "\xe1": "a",
                "\xe2": "a",
                "\u1EA7": "a",
                "\u1EA5": "a",
                "\u1EAB": "a",
                "\u1EA9": "a",
                "\xe3": "a",
                "\u0101": "a",
                "\u0103": "a",
                "\u1EB1": "a",
                "\u1EAF": "a",
                "\u1EB5": "a",
                "\u1EB3": "a",
                "\u0227": "a",
                "\u01E1": "a",
                "\xe4": "a",
                "\u01DF": "a",
                "\u1EA3": "a",
                "\xe5": "a",
                "\u01FB": "a",
                "\u01CE": "a",
                "\u0201": "a",
                "\u0203": "a",
                "\u1EA1": "a",
                "\u1EAD": "a",
                "\u1EB7": "a",
                "\u1E01": "a",
                "\u0105": "a",
                "\u2C65": "a",
                "\u0250": "a",
                "\uA733": "aa",
                "\xe6": "ae",
                "\u01FD": "ae",
                "\u01E3": "ae",
                "\uA735": "ao",
                "\uA737": "au",
                "\uA739": "av",
                "\uA73B": "av",
                "\uA73D": "ay",
                "\u24D1": "b",
                "\uFF42": "b",
                "\u1E03": "b",
                "\u1E05": "b",
                "\u1E07": "b",
                "\u0180": "b",
                "\u0183": "b",
                "\u0253": "b",
                "\u24D2": "c",
                "\uFF43": "c",
                "\u0107": "c",
                "\u0109": "c",
                "\u010B": "c",
                "\u010D": "c",
                "\xe7": "c",
                "\u1E09": "c",
                "\u0188": "c",
                "\u023C": "c",
                "\uA73F": "c",
                "\u2184": "c",
                "\u24D3": "d",
                "\uFF44": "d",
                "\u1E0B": "d",
                "\u010F": "d",
                "\u1E0D": "d",
                "\u1E11": "d",
                "\u1E13": "d",
                "\u1E0F": "d",
                "\u0111": "d",
                "\u018C": "d",
                "\u0256": "d",
                "\u0257": "d",
                "\uA77A": "d",
                "\u01F3": "dz",
                "\u01C6": "dz",
                "\u24D4": "e",
                "\uFF45": "e",
                "\xe8": "e",
                "\xe9": "e",
                "\xea": "e",
                "\u1EC1": "e",
                "\u1EBF": "e",
                "\u1EC5": "e",
                "\u1EC3": "e",
                "\u1EBD": "e",
                "\u0113": "e",
                "\u1E15": "e",
                "\u1E17": "e",
                "\u0115": "e",
                "\u0117": "e",
                "\xeb": "e",
                "\u1EBB": "e",
                "\u011B": "e",
                "\u0205": "e",
                "\u0207": "e",
                "\u1EB9": "e",
                "\u1EC7": "e",
                "\u0229": "e",
                "\u1E1D": "e",
                "\u0119": "e",
                "\u1E19": "e",
                "\u1E1B": "e",
                "\u0247": "e",
                "\u025B": "e",
                "\u01DD": "e",
                "\u24D5": "f",
                "\uFF46": "f",
                "\u1E1F": "f",
                "\u0192": "f",
                "\uA77C": "f",
                "\u24D6": "g",
                "\uFF47": "g",
                "\u01F5": "g",
                "\u011D": "g",
                "\u1E21": "g",
                "\u011F": "g",
                "\u0121": "g",
                "\u01E7": "g",
                "\u0123": "g",
                "\u01E5": "g",
                "\u0260": "g",
                "\uA7A1": "g",
                "\u1D79": "g",
                "\uA77F": "g",
                "\u24D7": "h",
                "\uFF48": "h",
                "\u0125": "h",
                "\u1E23": "h",
                "\u1E27": "h",
                "\u021F": "h",
                "\u1E25": "h",
                "\u1E29": "h",
                "\u1E2B": "h",
                "\u1E96": "h",
                "\u0127": "h",
                "\u2C68": "h",
                "\u2C76": "h",
                "\u0265": "h",
                "\u0195": "hv",
                "\u24D8": "i",
                "\uFF49": "i",
                "\xec": "i",
                "\xed": "i",
                "\xee": "i",
                "\u0129": "i",
                "\u012B": "i",
                "\u012D": "i",
                "\xef": "i",
                "\u1E2F": "i",
                "\u1EC9": "i",
                "\u01D0": "i",
                "\u0209": "i",
                "\u020B": "i",
                "\u1ECB": "i",
                "\u012F": "i",
                "\u1E2D": "i",
                "\u0268": "i",
                "\u0131": "i",
                "\u24D9": "j",
                "\uFF4A": "j",
                "\u0135": "j",
                "\u01F0": "j",
                "\u0249": "j",
                "\u24DA": "k",
                "\uFF4B": "k",
                "\u1E31": "k",
                "\u01E9": "k",
                "\u1E33": "k",
                "\u0137": "k",
                "\u1E35": "k",
                "\u0199": "k",
                "\u2C6A": "k",
                "\uA741": "k",
                "\uA743": "k",
                "\uA745": "k",
                "\uA7A3": "k",
                "\u24DB": "l",
                "\uFF4C": "l",
                "\u0140": "l",
                "\u013A": "l",
                "\u013E": "l",
                "\u1E37": "l",
                "\u1E39": "l",
                "\u013C": "l",
                "\u1E3D": "l",
                "\u1E3B": "l",
                "\u017F": "l",
                "\u0142": "l",
                "\u019A": "l",
                "\u026B": "l",
                "\u2C61": "l",
                "\uA749": "l",
                "\uA781": "l",
                "\uA747": "l",
                "\u01C9": "lj",
                "\u24DC": "m",
                "\uFF4D": "m",
                "\u1E3F": "m",
                "\u1E41": "m",
                "\u1E43": "m",
                "\u0271": "m",
                "\u026F": "m",
                "\u24DD": "n",
                "\uFF4E": "n",
                "\u01F9": "n",
                "\u0144": "n",
                "\xf1": "n",
                "\u1E45": "n",
                "\u0148": "n",
                "\u1E47": "n",
                "\u0146": "n",
                "\u1E4B": "n",
                "\u1E49": "n",
                "\u019E": "n",
                "\u0272": "n",
                "\u0149": "n",
                "\uA791": "n",
                "\uA7A5": "n",
                "\u01CC": "nj",
                "\u24DE": "o",
                "\uFF4F": "o",
                "\xf2": "o",
                "\xf3": "o",
                "\xf4": "o",
                "\u1ED3": "o",
                "\u1ED1": "o",
                "\u1ED7": "o",
                "\u1ED5": "o",
                "\xf5": "o",
                "\u1E4D": "o",
                "\u022D": "o",
                "\u1E4F": "o",
                "\u014D": "o",
                "\u1E51": "o",
                "\u1E53": "o",
                "\u014F": "o",
                "\u022F": "o",
                "\u0231": "o",
                "\xf6": "o",
                "\u022B": "o",
                "\u1ECF": "o",
                "\u0151": "o",
                "\u01D2": "o",
                "\u020D": "o",
                "\u020F": "o",
                "\u01A1": "o",
                "\u1EDD": "o",
                "\u1EDB": "o",
                "\u1EE1": "o",
                "\u1EDF": "o",
                "\u1EE3": "o",
                "\u1ECD": "o",
                "\u1ED9": "o",
                "\u01EB": "o",
                "\u01ED": "o",
                "\xf8": "o",
                "\u01FF": "o",
                "\u0254": "o",
                "\uA74B": "o",
                "\uA74D": "o",
                "\u0275": "o",
                "\u0153": "oe",
                "\u01A3": "oi",
                "\u0223": "ou",
                "\uA74F": "oo",
                "\u24DF": "p",
                "\uFF50": "p",
                "\u1E55": "p",
                "\u1E57": "p",
                "\u01A5": "p",
                "\u1D7D": "p",
                "\uA751": "p",
                "\uA753": "p",
                "\uA755": "p",
                "\u24E0": "q",
                "\uFF51": "q",
                "\u024B": "q",
                "\uA757": "q",
                "\uA759": "q",
                "\u24E1": "r",
                "\uFF52": "r",
                "\u0155": "r",
                "\u1E59": "r",
                "\u0159": "r",
                "\u0211": "r",
                "\u0213": "r",
                "\u1E5B": "r",
                "\u1E5D": "r",
                "\u0157": "r",
                "\u1E5F": "r",
                "\u024D": "r",
                "\u027D": "r",
                "\uA75B": "r",
                "\uA7A7": "r",
                "\uA783": "r",
                "\u24E2": "s",
                "\uFF53": "s",
                "\xdf": "s",
                "\u015B": "s",
                "\u1E65": "s",
                "\u015D": "s",
                "\u1E61": "s",
                "\u0161": "s",
                "\u1E67": "s",
                "\u1E63": "s",
                "\u1E69": "s",
                "\u0219": "s",
                "\u015F": "s",
                "\u023F": "s",
                "\uA7A9": "s",
                "\uA785": "s",
                "\u1E9B": "s",
                "\u24E3": "t",
                "\uFF54": "t",
                "\u1E6B": "t",
                "\u1E97": "t",
                "\u0165": "t",
                "\u1E6D": "t",
                "\u021B": "t",
                "\u0163": "t",
                "\u1E71": "t",
                "\u1E6F": "t",
                "\u0167": "t",
                "\u01AD": "t",
                "\u0288": "t",
                "\u2C66": "t",
                "\uA787": "t",
                "\uA729": "tz",
                "\u24E4": "u",
                "\uFF55": "u",
                "\xf9": "u",
                "\xfa": "u",
                "\xfb": "u",
                "\u0169": "u",
                "\u1E79": "u",
                "\u016B": "u",
                "\u1E7B": "u",
                "\u016D": "u",
                "\xfc": "u",
                "\u01DC": "u",
                "\u01D8": "u",
                "\u01D6": "u",
                "\u01DA": "u",
                "\u1EE7": "u",
                "\u016F": "u",
                "\u0171": "u",
                "\u01D4": "u",
                "\u0215": "u",
                "\u0217": "u",
                "\u01B0": "u",
                "\u1EEB": "u",
                "\u1EE9": "u",
                "\u1EEF": "u",
                "\u1EED": "u",
                "\u1EF1": "u",
                "\u1EE5": "u",
                "\u1E73": "u",
                "\u0173": "u",
                "\u1E77": "u",
                "\u1E75": "u",
                "\u0289": "u",
                "\u24E5": "v",
                "\uFF56": "v",
                "\u1E7D": "v",
                "\u1E7F": "v",
                "\u028B": "v",
                "\uA75F": "v",
                "\u028C": "v",
                "\uA761": "vy",
                "\u24E6": "w",
                "\uFF57": "w",
                "\u1E81": "w",
                "\u1E83": "w",
                "\u0175": "w",
                "\u1E87": "w",
                "\u1E85": "w",
                "\u1E98": "w",
                "\u1E89": "w",
                "\u2C73": "w",
                "\u24E7": "x",
                "\uFF58": "x",
                "\u1E8B": "x",
                "\u1E8D": "x",
                "\u24E8": "y",
                "\uFF59": "y",
                "\u1EF3": "y",
                "\xfd": "y",
                "\u0177": "y",
                "\u1EF9": "y",
                "\u0233": "y",
                "\u1E8F": "y",
                "\xff": "y",
                "\u1EF7": "y",
                "\u1E99": "y",
                "\u1EF5": "y",
                "\u01B4": "y",
                "\u024F": "y",
                "\u1EFF": "y",
                "\u24E9": "z",
                "\uFF5A": "z",
                "\u017A": "z",
                "\u1E91": "z",
                "\u017C": "z",
                "\u017E": "z",
                "\u1E93": "z",
                "\u1E95": "z",
                "\u01B6": "z",
                "\u0225": "z",
                "\u0240": "z",
                "\u2C6C": "z",
                "\uA763": "z",
                "\u0386": "\u0391",
                "\u0388": "\u0395",
                "\u0389": "\u0397",
                "\u038A": "\u0399",
                "\u03AA": "\u0399",
                "\u038C": "\u039F",
                "\u038E": "\u03A5",
                "\u03AB": "\u03A5",
                "\u038F": "\u03A9",
                "\u03AC": "\u03B1",
                "\u03AD": "\u03B5",
                "\u03AE": "\u03B7",
                "\u03AF": "\u03B9",
                "\u03CA": "\u03B9",
                "\u0390": "\u03B9",
                "\u03CC": "\u03BF",
                "\u03CD": "\u03C5",
                "\u03CB": "\u03C5",
                "\u03B0": "\u03C5",
                "\u03CE": "\u03C9",
                "\u03C2": "\u03C3",
                "\u2019": "'"
            };
            return diacritics;
        });
        S2.define("select2/data/base", [
            "../utils"
        ], function(Utils) {
            function BaseAdapter($element, options) {
                BaseAdapter.__super__.constructor.call(this);
            }
            Utils.Extend(BaseAdapter, Utils.Observable);
            BaseAdapter.prototype.current = function(callback) {
                throw new Error("The `current` method must be defined in child classes.");
            };
            BaseAdapter.prototype.query = function(params, callback) {
                throw new Error("The `query` method must be defined in child classes.");
            };
            BaseAdapter.prototype.bind = function(container, $container) {
            // Can be implemented in subclasses
            };
            BaseAdapter.prototype.destroy = function() {
            // Can be implemented in subclasses
            };
            BaseAdapter.prototype.generateResultId = function(container, data) {
                var id = container.id + "-result-";
                id += Utils.generateChars(4);
                if (data.id != null) id += "-" + data.id.toString();
                else id += "-" + Utils.generateChars(4);
                return id;
            };
            return BaseAdapter;
        });
        S2.define("select2/data/select", [
            "./base",
            "../utils",
            "jquery"
        ], function(BaseAdapter, Utils, $1) {
            function SelectAdapter($element, options) {
                this.$element = $element;
                this.options = options;
                SelectAdapter.__super__.constructor.call(this);
            }
            Utils.Extend(SelectAdapter, BaseAdapter);
            SelectAdapter.prototype.current = function(callback) {
                var data = [];
                var self = this;
                this.$element.find(":selected").each(function() {
                    var $option = $1(this);
                    var option = self.item($option);
                    data.push(option);
                });
                callback(data);
            };
            SelectAdapter.prototype.select = function(data) {
                var self = this;
                data.selected = true;
                // If data.element is a DOM node, use it instead
                if ($1(data.element).is("option")) {
                    data.element.selected = true;
                    this.$element.trigger("input").trigger("change");
                    return;
                }
                if (this.$element.prop("multiple")) this.current(function(currentData) {
                    var val = [];
                    data = [
                        data
                    ];
                    data.push.apply(data, currentData);
                    for(var d = 0; d < data.length; d++){
                        var id = data[d].id;
                        if ($1.inArray(id, val) === -1) val.push(id);
                    }
                    self.$element.val(val);
                    self.$element.trigger("input").trigger("change");
                });
                else {
                    var val = data.id;
                    this.$element.val(val);
                    this.$element.trigger("input").trigger("change");
                }
            };
            SelectAdapter.prototype.unselect = function(data) {
                var self = this;
                if (!this.$element.prop("multiple")) return;
                data.selected = false;
                if ($1(data.element).is("option")) {
                    data.element.selected = false;
                    this.$element.trigger("input").trigger("change");
                    return;
                }
                this.current(function(currentData) {
                    var val = [];
                    for(var d = 0; d < currentData.length; d++){
                        var id = currentData[d].id;
                        if (id !== data.id && $1.inArray(id, val) === -1) val.push(id);
                    }
                    self.$element.val(val);
                    self.$element.trigger("input").trigger("change");
                });
            };
            SelectAdapter.prototype.bind = function(container, $container) {
                var self = this;
                this.container = container;
                container.on("select", function(params) {
                    self.select(params.data);
                });
                container.on("unselect", function(params) {
                    self.unselect(params.data);
                });
            };
            SelectAdapter.prototype.destroy = function() {
                // Remove anything added to child elements
                this.$element.find("*").each(function() {
                    // Remove any custom data set by Select2
                    Utils.RemoveData(this);
                });
            };
            SelectAdapter.prototype.query = function(params, callback) {
                var data = [];
                var self = this;
                var $options = this.$element.children();
                $options.each(function() {
                    var $option = $1(this);
                    if (!$option.is("option") && !$option.is("optgroup")) return;
                    var option = self.item($option);
                    var matches = self.matches(params, option);
                    if (matches !== null) data.push(matches);
                });
                callback({
                    results: data
                });
            };
            SelectAdapter.prototype.addOptions = function($options) {
                Utils.appendMany(this.$element, $options);
            };
            SelectAdapter.prototype.option = function(data) {
                var option;
                if (data.children) {
                    option = document.createElement("optgroup");
                    option.label = data.text;
                } else {
                    option = document.createElement("option");
                    if (option.textContent !== undefined) option.textContent = data.text;
                    else option.innerText = data.text;
                }
                if (data.id !== undefined) option.value = data.id;
                if (data.disabled) option.disabled = true;
                if (data.selected) option.selected = true;
                if (data.title) option.title = data.title;
                var $option = $1(option);
                var normalizedData = this._normalizeItem(data);
                normalizedData.element = option;
                // Override the option's data with the combined data
                Utils.StoreData(option, "data", normalizedData);
                return $option;
            };
            SelectAdapter.prototype.item = function($option) {
                var data = {};
                data = Utils.GetData($option[0], "data");
                if (data != null) return data;
                if ($option.is("option")) data = {
                    id: $option.val(),
                    text: $option.text(),
                    disabled: $option.prop("disabled"),
                    selected: $option.prop("selected"),
                    title: $option.prop("title")
                };
                else if ($option.is("optgroup")) {
                    data = {
                        text: $option.prop("label"),
                        children: [],
                        title: $option.prop("title")
                    };
                    var $children = $option.children("option");
                    var children = [];
                    for(var c = 0; c < $children.length; c++){
                        var $child = $1($children[c]);
                        var child = this.item($child);
                        children.push(child);
                    }
                    data.children = children;
                }
                data = this._normalizeItem(data);
                data.element = $option[0];
                Utils.StoreData($option[0], "data", data);
                return data;
            };
            SelectAdapter.prototype._normalizeItem = function(item) {
                if (item !== Object(item)) item = {
                    id: item,
                    text: item
                };
                item = $1.extend({}, {
                    text: ""
                }, item);
                var defaults = {
                    selected: false,
                    disabled: false
                };
                if (item.id != null) item.id = item.id.toString();
                if (item.text != null) item.text = item.text.toString();
                if (item._resultId == null && item.id && this.container != null) item._resultId = this.generateResultId(this.container, item);
                return $1.extend({}, defaults, item);
            };
            SelectAdapter.prototype.matches = function(params, data) {
                var matcher = this.options.get("matcher");
                return matcher(params, data);
            };
            return SelectAdapter;
        });
        S2.define("select2/data/array", [
            "./select",
            "../utils",
            "jquery"
        ], function(SelectAdapter, Utils, $1) {
            function ArrayAdapter($element, options) {
                this._dataToConvert = options.get("data") || [];
                ArrayAdapter.__super__.constructor.call(this, $element, options);
            }
            Utils.Extend(ArrayAdapter, SelectAdapter);
            ArrayAdapter.prototype.bind = function(container, $container) {
                ArrayAdapter.__super__.bind.call(this, container, $container);
                this.addOptions(this.convertToOptions(this._dataToConvert));
            };
            ArrayAdapter.prototype.select = function(data) {
                var $option = this.$element.find("option").filter(function(i, elm) {
                    return elm.value == data.id.toString();
                });
                if ($option.length === 0) {
                    $option = this.option(data);
                    this.addOptions($option);
                }
                ArrayAdapter.__super__.select.call(this, data);
            };
            ArrayAdapter.prototype.convertToOptions = function(data) {
                var self = this;
                var $existing = this.$element.find("option");
                var existingIds = $existing.map(function() {
                    return self.item($1(this)).id;
                }).get();
                var $options = [];
                // Filter out all items except for the one passed in the argument
                function onlyItem(item) {
                    return function() {
                        return $1(this).val() == item.id;
                    };
                }
                for(var d = 0; d < data.length; d++){
                    var item = this._normalizeItem(data[d]);
                    // Skip items which were pre-loaded, only merge the data
                    if ($1.inArray(item.id, existingIds) >= 0) {
                        var $existingOption = $existing.filter(onlyItem(item));
                        var existingData = this.item($existingOption);
                        var newData = $1.extend(true, {}, item, existingData);
                        var $newOption = this.option(newData);
                        $existingOption.replaceWith($newOption);
                        continue;
                    }
                    var $option = this.option(item);
                    if (item.children) {
                        var $children = this.convertToOptions(item.children);
                        Utils.appendMany($option, $children);
                    }
                    $options.push($option);
                }
                return $options;
            };
            return ArrayAdapter;
        });
        S2.define("select2/data/ajax", [
            "./array",
            "../utils",
            "jquery"
        ], function(ArrayAdapter, Utils, $1) {
            function AjaxAdapter($element, options) {
                this.ajaxOptions = this._applyDefaults(options.get("ajax"));
                if (this.ajaxOptions.processResults != null) this.processResults = this.ajaxOptions.processResults;
                AjaxAdapter.__super__.constructor.call(this, $element, options);
            }
            Utils.Extend(AjaxAdapter, ArrayAdapter);
            AjaxAdapter.prototype._applyDefaults = function(options) {
                var defaults = {
                    data: function(params) {
                        return $1.extend({}, params, {
                            q: params.term
                        });
                    },
                    transport: function(params, success, failure) {
                        var $request = $1.ajax(params);
                        $request.then(success);
                        $request.fail(failure);
                        return $request;
                    }
                };
                return $1.extend({}, defaults, options, true);
            };
            AjaxAdapter.prototype.processResults = function(results) {
                return results;
            };
            AjaxAdapter.prototype.query = function(params, callback) {
                var matches = [];
                var self = this;
                if (this._request != null) {
                    // JSONP requests cannot always be aborted
                    if ($1.isFunction(this._request.abort)) this._request.abort();
                    this._request = null;
                }
                var options = $1.extend({
                    type: "GET"
                }, this.ajaxOptions);
                if (typeof options.url === "function") options.url = options.url.call(this.$element, params);
                if (typeof options.data === "function") options.data = options.data.call(this.$element, params);
                function request() {
                    var $request = options.transport(options, function(data) {
                        var results = self.processResults(data, params);
                        if (self.options.get("debug") && window.console && console.error) // Check to make sure that the response included a `results` key.
                        {
                            if (!results || !results.results || !$1.isArray(results.results)) console.error("Select2: The AJAX results did not return an array in the `results` key of the response.");
                        }
                        callback(results);
                    }, function() {
                        // Attempt to detect if a request was aborted
                        // Only works if the transport exposes a status property
                        if ("status" in $request && ($request.status === 0 || $request.status === "0")) return;
                        self.trigger("results:message", {
                            message: "errorLoading"
                        });
                    });
                    self._request = $request;
                }
                if (this.ajaxOptions.delay && params.term != null) {
                    if (this._queryTimeout) window.clearTimeout(this._queryTimeout);
                    this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
                } else request();
            };
            return AjaxAdapter;
        });
        S2.define("select2/data/tags", [
            "jquery"
        ], function($1) {
            function Tags(decorated, $element, options) {
                var tags = options.get("tags");
                var createTag = options.get("createTag");
                if (createTag !== undefined) this.createTag = createTag;
                var insertTag = options.get("insertTag");
                if (insertTag !== undefined) this.insertTag = insertTag;
                decorated.call(this, $element, options);
                if ($1.isArray(tags)) for(var t = 0; t < tags.length; t++){
                    var tag = tags[t];
                    var item = this._normalizeItem(tag);
                    var $option = this.option(item);
                    this.$element.append($option);
                }
            }
            Tags.prototype.query = function(decorated, params, callback) {
                var self = this;
                this._removeOldTags();
                if (params.term == null || params.page != null) {
                    decorated.call(this, params, callback);
                    return;
                }
                function wrapper(obj, child) {
                    var data = obj.results;
                    for(var i = 0; i < data.length; i++){
                        var option = data[i];
                        var checkChildren = option.children != null && !wrapper({
                            results: option.children
                        }, true);
                        var optionText = (option.text || "").toUpperCase();
                        var paramsTerm = (params.term || "").toUpperCase();
                        var checkText = optionText === paramsTerm;
                        if (checkText || checkChildren) {
                            if (child) return false;
                            obj.data = data;
                            callback(obj);
                            return;
                        }
                    }
                    if (child) return true;
                    var tag = self.createTag(params);
                    if (tag != null) {
                        var $option = self.option(tag);
                        $option.attr("data-select2-tag", true);
                        self.addOptions([
                            $option
                        ]);
                        self.insertTag(data, tag);
                    }
                    obj.results = data;
                    callback(obj);
                }
                decorated.call(this, params, wrapper);
            };
            Tags.prototype.createTag = function(decorated, params) {
                var term = $1.trim(params.term);
                if (term === "") return null;
                return {
                    id: term,
                    text: term
                };
            };
            Tags.prototype.insertTag = function(_, data, tag) {
                data.unshift(tag);
            };
            Tags.prototype._removeOldTags = function(_) {
                var $options = this.$element.find("option[data-select2-tag]");
                $options.each(function() {
                    if (this.selected) return;
                    $1(this).remove();
                });
            };
            return Tags;
        });
        S2.define("select2/data/tokenizer", [
            "jquery"
        ], function($1) {
            function Tokenizer(decorated, $element, options) {
                var tokenizer = options.get("tokenizer");
                if (tokenizer !== undefined) this.tokenizer = tokenizer;
                decorated.call(this, $element, options);
            }
            Tokenizer.prototype.bind = function(decorated, container, $container) {
                decorated.call(this, container, $container);
                this.$search = container.dropdown.$search || container.selection.$search || $container.find(".select2-search__field");
            };
            Tokenizer.prototype.query = function(decorated, params, callback) {
                var self = this;
                function createAndSelect(data) {
                    // Normalize the data object so we can use it for checks
                    var item = self._normalizeItem(data);
                    // Check if the data object already exists as a tag
                    // Select it if it doesn't
                    var $existingOptions = self.$element.find("option").filter(function() {
                        return $1(this).val() === item.id;
                    });
                    // If an existing option wasn't found for it, create the option
                    if (!$existingOptions.length) {
                        var $option = self.option(item);
                        $option.attr("data-select2-tag", true);
                        self._removeOldTags();
                        self.addOptions([
                            $option
                        ]);
                    }
                    // Select the item, now that we know there is an option for it
                    select(item);
                }
                function select(data) {
                    self.trigger("select", {
                        data: data
                    });
                }
                params.term = params.term || "";
                var tokenData = this.tokenizer(params, this.options, createAndSelect);
                if (tokenData.term !== params.term) {
                    // Replace the search term if we have the search box
                    if (this.$search.length) {
                        this.$search.val(tokenData.term);
                        this.$search.trigger("focus");
                    }
                    params.term = tokenData.term;
                }
                decorated.call(this, params, callback);
            };
            Tokenizer.prototype.tokenizer = function(_, params, options, callback) {
                var separators = options.get("tokenSeparators") || [];
                var term = params.term;
                var i = 0;
                var createTag = this.createTag || function(params) {
                    return {
                        id: params.term,
                        text: params.term
                    };
                };
                while(i < term.length){
                    var termChar = term[i];
                    if ($1.inArray(termChar, separators) === -1) {
                        i++;
                        continue;
                    }
                    var part = term.substr(0, i);
                    var partParams = $1.extend({}, params, {
                        term: part
                    });
                    var data = createTag(partParams);
                    if (data == null) {
                        i++;
                        continue;
                    }
                    callback(data);
                    // Reset the term to not include the tokenized portion
                    term = term.substr(i + 1) || "";
                    i = 0;
                }
                return {
                    term: term
                };
            };
            return Tokenizer;
        });
        S2.define("select2/data/minimumInputLength", [], function() {
            function MinimumInputLength(decorated, $e, options) {
                this.minimumInputLength = options.get("minimumInputLength");
                decorated.call(this, $e, options);
            }
            MinimumInputLength.prototype.query = function(decorated, params, callback) {
                params.term = params.term || "";
                if (params.term.length < this.minimumInputLength) {
                    this.trigger("results:message", {
                        message: "inputTooShort",
                        args: {
                            minimum: this.minimumInputLength,
                            input: params.term,
                            params: params
                        }
                    });
                    return;
                }
                decorated.call(this, params, callback);
            };
            return MinimumInputLength;
        });
        S2.define("select2/data/maximumInputLength", [], function() {
            function MaximumInputLength(decorated, $e, options) {
                this.maximumInputLength = options.get("maximumInputLength");
                decorated.call(this, $e, options);
            }
            MaximumInputLength.prototype.query = function(decorated, params, callback) {
                params.term = params.term || "";
                if (this.maximumInputLength > 0 && params.term.length > this.maximumInputLength) {
                    this.trigger("results:message", {
                        message: "inputTooLong",
                        args: {
                            maximum: this.maximumInputLength,
                            input: params.term,
                            params: params
                        }
                    });
                    return;
                }
                decorated.call(this, params, callback);
            };
            return MaximumInputLength;
        });
        S2.define("select2/data/maximumSelectionLength", [], function() {
            function MaximumSelectionLength(decorated, $e, options) {
                this.maximumSelectionLength = options.get("maximumSelectionLength");
                decorated.call(this, $e, options);
            }
            MaximumSelectionLength.prototype.bind = function(decorated, container, $container) {
                var self = this;
                decorated.call(this, container, $container);
                container.on("select", function() {
                    self._checkIfMaximumSelected();
                });
            };
            MaximumSelectionLength.prototype.query = function(decorated, params, callback) {
                var self = this;
                this._checkIfMaximumSelected(function() {
                    decorated.call(self, params, callback);
                });
            };
            MaximumSelectionLength.prototype._checkIfMaximumSelected = function(_, successCallback) {
                var self = this;
                this.current(function(currentData) {
                    var count = currentData != null ? currentData.length : 0;
                    if (self.maximumSelectionLength > 0 && count >= self.maximumSelectionLength) {
                        self.trigger("results:message", {
                            message: "maximumSelected",
                            args: {
                                maximum: self.maximumSelectionLength
                            }
                        });
                        return;
                    }
                    if (successCallback) successCallback();
                });
            };
            return MaximumSelectionLength;
        });
        S2.define("select2/dropdown", [
            "jquery",
            "./utils"
        ], function($1, Utils) {
            function Dropdown($element, options) {
                this.$element = $element;
                this.options = options;
                Dropdown.__super__.constructor.call(this);
            }
            Utils.Extend(Dropdown, Utils.Observable);
            Dropdown.prototype.render = function() {
                var $dropdown = $1('<span class="select2-dropdown"><span class="select2-results"></span></span>');
                $dropdown.attr("dir", this.options.get("dir"));
                this.$dropdown = $dropdown;
                return $dropdown;
            };
            Dropdown.prototype.bind = function() {
            // Should be implemented in subclasses
            };
            Dropdown.prototype.position = function($dropdown, $container) {
            // Should be implemented in subclasses
            };
            Dropdown.prototype.destroy = function() {
                // Remove the dropdown from the DOM
                this.$dropdown.remove();
            };
            return Dropdown;
        });
        S2.define("select2/dropdown/search", [
            "jquery",
            "../utils"
        ], function($1, Utils) {
            function Search() {}
            Search.prototype.render = function(decorated) {
                var $rendered = decorated.call(this);
                var $search = $1('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>');
                this.$searchContainer = $search;
                this.$search = $search.find("input");
                $rendered.prepend($search);
                return $rendered;
            };
            Search.prototype.bind = function(decorated, container, $container) {
                var self = this;
                var resultsId = container.id + "-results";
                decorated.call(this, container, $container);
                this.$search.on("keydown", function(evt) {
                    self.trigger("keypress", evt);
                    self._keyUpPrevented = evt.isDefaultPrevented();
                });
                // Workaround for browsers which do not support the `input` event
                // This will prevent double-triggering of events for browsers which support
                // both the `keyup` and `input` events.
                this.$search.on("input", function(evt) {
                    // Unbind the duplicated `keyup` event
                    $1(this).off("keyup");
                });
                this.$search.on("keyup input", function(evt) {
                    self.handleSearch(evt);
                });
                container.on("open", function() {
                    self.$search.attr("tabindex", 0);
                    self.$search.attr("aria-controls", resultsId);
                    self.$search.trigger("focus");
                    window.setTimeout(function() {
                        self.$search.trigger("focus");
                    }, 0);
                });
                container.on("close", function() {
                    self.$search.attr("tabindex", -1);
                    self.$search.removeAttr("aria-controls");
                    self.$search.removeAttr("aria-activedescendant");
                    self.$search.val("");
                    self.$search.trigger("blur");
                });
                container.on("focus", function() {
                    if (!container.isOpen()) self.$search.trigger("focus");
                });
                container.on("results:all", function(params) {
                    if (params.query.term == null || params.query.term === "") {
                        var showSearch = self.showSearch(params);
                        if (showSearch) self.$searchContainer.removeClass("select2-search--hide");
                        else self.$searchContainer.addClass("select2-search--hide");
                    }
                });
                container.on("results:focus", function(params) {
                    if (params.data._resultId) self.$search.attr("aria-activedescendant", params.data._resultId);
                    else self.$search.removeAttr("aria-activedescendant");
                });
            };
            Search.prototype.handleSearch = function(evt) {
                if (!this._keyUpPrevented) {
                    var input = this.$search.val();
                    this.trigger("query", {
                        term: input
                    });
                }
                this._keyUpPrevented = false;
            };
            Search.prototype.showSearch = function(_, params) {
                return true;
            };
            return Search;
        });
        S2.define("select2/dropdown/hidePlaceholder", [], function() {
            function HidePlaceholder(decorated, $element, options, dataAdapter) {
                this.placeholder = this.normalizePlaceholder(options.get("placeholder"));
                decorated.call(this, $element, options, dataAdapter);
            }
            HidePlaceholder.prototype.append = function(decorated, data) {
                data.results = this.removePlaceholder(data.results);
                decorated.call(this, data);
            };
            HidePlaceholder.prototype.normalizePlaceholder = function(_, placeholder) {
                if (typeof placeholder === "string") placeholder = {
                    id: "",
                    text: placeholder
                };
                return placeholder;
            };
            HidePlaceholder.prototype.removePlaceholder = function(_, data) {
                var modifiedData = data.slice(0);
                for(var d = data.length - 1; d >= 0; d--){
                    var item = data[d];
                    if (this.placeholder.id === item.id) modifiedData.splice(d, 1);
                }
                return modifiedData;
            };
            return HidePlaceholder;
        });
        S2.define("select2/dropdown/infiniteScroll", [
            "jquery"
        ], function($1) {
            function InfiniteScroll(decorated, $element, options, dataAdapter) {
                this.lastParams = {};
                decorated.call(this, $element, options, dataAdapter);
                this.$loadingMore = this.createLoadingMore();
                this.loading = false;
            }
            InfiniteScroll.prototype.append = function(decorated, data) {
                this.$loadingMore.remove();
                this.loading = false;
                decorated.call(this, data);
                if (this.showLoadingMore(data)) {
                    this.$results.append(this.$loadingMore);
                    this.loadMoreIfNeeded();
                }
            };
            InfiniteScroll.prototype.bind = function(decorated, container, $container) {
                var self = this;
                decorated.call(this, container, $container);
                container.on("query", function(params) {
                    self.lastParams = params;
                    self.loading = true;
                });
                container.on("query:append", function(params) {
                    self.lastParams = params;
                    self.loading = true;
                });
                this.$results.on("scroll", this.loadMoreIfNeeded.bind(this));
            };
            InfiniteScroll.prototype.loadMoreIfNeeded = function() {
                var isLoadMoreVisible = $1.contains(document.documentElement, this.$loadingMore[0]);
                if (this.loading || !isLoadMoreVisible) return;
                var currentOffset = this.$results.offset().top + this.$results.outerHeight(false);
                var loadingMoreOffset = this.$loadingMore.offset().top + this.$loadingMore.outerHeight(false);
                if (currentOffset + 50 >= loadingMoreOffset) this.loadMore();
            };
            InfiniteScroll.prototype.loadMore = function() {
                this.loading = true;
                var params = $1.extend({}, {
                    page: 1
                }, this.lastParams);
                params.page++;
                this.trigger("query:append", params);
            };
            InfiniteScroll.prototype.showLoadingMore = function(_, data) {
                return data.pagination && data.pagination.more;
            };
            InfiniteScroll.prototype.createLoadingMore = function() {
                var $option = $1('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>');
                var message = this.options.get("translations").get("loadingMore");
                $option.html(message(this.lastParams));
                return $option;
            };
            return InfiniteScroll;
        });
        S2.define("select2/dropdown/attachBody", [
            "jquery",
            "../utils"
        ], function($1, Utils) {
            function AttachBody(decorated, $element, options) {
                this.$dropdownParent = $1(options.get("dropdownParent") || document.body);
                decorated.call(this, $element, options);
            }
            AttachBody.prototype.bind = function(decorated, container, $container) {
                var self = this;
                decorated.call(this, container, $container);
                container.on("open", function() {
                    self._showDropdown();
                    self._attachPositioningHandler(container);
                    // Must bind after the results handlers to ensure correct sizing
                    self._bindContainerResultHandlers(container);
                });
                container.on("close", function() {
                    self._hideDropdown();
                    self._detachPositioningHandler(container);
                });
                this.$dropdownContainer.on("mousedown", function(evt) {
                    evt.stopPropagation();
                });
            };
            AttachBody.prototype.destroy = function(decorated) {
                decorated.call(this);
                this.$dropdownContainer.remove();
            };
            AttachBody.prototype.position = function(decorated, $dropdown, $container) {
                // Clone all of the container classes
                $dropdown.attr("class", $container.attr("class"));
                $dropdown.removeClass("select2");
                $dropdown.addClass("select2-container--open");
                $dropdown.css({
                    position: "absolute",
                    top: -999999
                });
                this.$container = $container;
            };
            AttachBody.prototype.render = function(decorated) {
                var $container = $1("<span></span>");
                var $dropdown = decorated.call(this);
                $container.append($dropdown);
                this.$dropdownContainer = $container;
                return $container;
            };
            AttachBody.prototype._hideDropdown = function(decorated) {
                this.$dropdownContainer.detach();
            };
            AttachBody.prototype._bindContainerResultHandlers = function(decorated, container) {
                // These should only be bound once
                if (this._containerResultsHandlersBound) return;
                var self = this;
                container.on("results:all", function() {
                    self._positionDropdown();
                    self._resizeDropdown();
                });
                container.on("results:append", function() {
                    self._positionDropdown();
                    self._resizeDropdown();
                });
                container.on("results:message", function() {
                    self._positionDropdown();
                    self._resizeDropdown();
                });
                container.on("select", function() {
                    self._positionDropdown();
                    self._resizeDropdown();
                });
                container.on("unselect", function() {
                    self._positionDropdown();
                    self._resizeDropdown();
                });
                this._containerResultsHandlersBound = true;
            };
            AttachBody.prototype._attachPositioningHandler = function(decorated, container) {
                var self = this;
                var scrollEvent = "scroll.select2." + container.id;
                var resizeEvent = "resize.select2." + container.id;
                var orientationEvent = "orientationchange.select2." + container.id;
                var $watchers = this.$container.parents().filter(Utils.hasScroll);
                $watchers.each(function() {
                    Utils.StoreData(this, "select2-scroll-position", {
                        x: $1(this).scrollLeft(),
                        y: $1(this).scrollTop()
                    });
                });
                $watchers.on(scrollEvent, function(ev) {
                    var position = Utils.GetData(this, "select2-scroll-position");
                    $1(this).scrollTop(position.y);
                });
                $1(window).on(scrollEvent + " " + resizeEvent + " " + orientationEvent, function(e) {
                    self._positionDropdown();
                    self._resizeDropdown();
                });
            };
            AttachBody.prototype._detachPositioningHandler = function(decorated, container) {
                var scrollEvent = "scroll.select2." + container.id;
                var resizeEvent = "resize.select2." + container.id;
                var orientationEvent = "orientationchange.select2." + container.id;
                var $watchers = this.$container.parents().filter(Utils.hasScroll);
                $watchers.off(scrollEvent);
                $1(window).off(scrollEvent + " " + resizeEvent + " " + orientationEvent);
            };
            AttachBody.prototype._positionDropdown = function() {
                var $window = $1(window);
                var isCurrentlyAbove = this.$dropdown.hasClass("select2-dropdown--above");
                var isCurrentlyBelow = this.$dropdown.hasClass("select2-dropdown--below");
                var newDirection = null;
                var offset = this.$container.offset();
                offset.bottom = offset.top + this.$container.outerHeight(false);
                var container = {
                    height: this.$container.outerHeight(false)
                };
                container.top = offset.top;
                container.bottom = offset.top + container.height;
                var dropdown = {
                    height: this.$dropdown.outerHeight(false)
                };
                var viewport = {
                    top: $window.scrollTop(),
                    bottom: $window.scrollTop() + $window.height()
                };
                var enoughRoomAbove = viewport.top < offset.top - dropdown.height;
                var enoughRoomBelow = viewport.bottom > offset.bottom + dropdown.height;
                var css = {
                    left: offset.left,
                    top: container.bottom
                };
                // Determine what the parent element is to use for calculating the offset
                var $offsetParent = this.$dropdownParent;
                // For statically positioned elements, we need to get the element
                // that is determining the offset
                if ($offsetParent.css("position") === "static") $offsetParent = $offsetParent.offsetParent();
                var parentOffset = {
                    top: 0,
                    left: 0
                };
                if ($1.contains(document.body, $offsetParent[0]) || $offsetParent[0].isConnected) parentOffset = $offsetParent.offset();
                css.top -= parentOffset.top;
                css.left -= parentOffset.left;
                if (!isCurrentlyAbove && !isCurrentlyBelow) newDirection = "below";
                if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) newDirection = "above";
                else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) newDirection = "below";
                if (newDirection == "above" || isCurrentlyAbove && newDirection !== "below") css.top = container.top - parentOffset.top - dropdown.height;
                if (newDirection != null) {
                    this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + newDirection);
                    this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + newDirection);
                }
                this.$dropdownContainer.css(css);
            };
            AttachBody.prototype._resizeDropdown = function() {
                var css = {
                    width: this.$container.outerWidth(false) + "px"
                };
                if (this.options.get("dropdownAutoWidth")) {
                    css.minWidth = css.width;
                    css.position = "relative";
                    css.width = "auto";
                }
                this.$dropdown.css(css);
            };
            AttachBody.prototype._showDropdown = function(decorated) {
                this.$dropdownContainer.appendTo(this.$dropdownParent);
                this._positionDropdown();
                this._resizeDropdown();
            };
            return AttachBody;
        });
        S2.define("select2/dropdown/minimumResultsForSearch", [], function() {
            function countResults(data) {
                var count = 0;
                for(var d = 0; d < data.length; d++){
                    var item = data[d];
                    if (item.children) count += countResults(item.children);
                    else count++;
                }
                return count;
            }
            function MinimumResultsForSearch(decorated, $element, options, dataAdapter) {
                this.minimumResultsForSearch = options.get("minimumResultsForSearch");
                if (this.minimumResultsForSearch < 0) this.minimumResultsForSearch = Infinity;
                decorated.call(this, $element, options, dataAdapter);
            }
            MinimumResultsForSearch.prototype.showSearch = function(decorated, params) {
                if (countResults(params.data.results) < this.minimumResultsForSearch) return false;
                return decorated.call(this, params);
            };
            return MinimumResultsForSearch;
        });
        S2.define("select2/dropdown/selectOnClose", [
            "../utils"
        ], function(Utils) {
            function SelectOnClose() {}
            SelectOnClose.prototype.bind = function(decorated, container, $container) {
                var self = this;
                decorated.call(this, container, $container);
                container.on("close", function(params) {
                    self._handleSelectOnClose(params);
                });
            };
            SelectOnClose.prototype._handleSelectOnClose = function(_, params) {
                if (params && params.originalSelect2Event != null) {
                    var event = params.originalSelect2Event;
                    // Don't select an item if the close event was triggered from a select or
                    // unselect event
                    if (event._type === "select" || event._type === "unselect") return;
                }
                var $highlightedResults = this.getHighlightedResults();
                // Only select highlighted results
                if ($highlightedResults.length < 1) return;
                var data = Utils.GetData($highlightedResults[0], "data");
                // Don't re-select already selected resulte
                if (data.element != null && data.element.selected || data.element == null && data.selected) return;
                this.trigger("select", {
                    data: data
                });
            };
            return SelectOnClose;
        });
        S2.define("select2/dropdown/closeOnSelect", [], function() {
            function CloseOnSelect() {}
            CloseOnSelect.prototype.bind = function(decorated, container, $container) {
                var self = this;
                decorated.call(this, container, $container);
                container.on("select", function(evt) {
                    self._selectTriggered(evt);
                });
                container.on("unselect", function(evt) {
                    self._selectTriggered(evt);
                });
            };
            CloseOnSelect.prototype._selectTriggered = function(_, evt) {
                var originalEvent = evt.originalEvent;
                // Don't close if the control key is being held
                if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) return;
                this.trigger("close", {
                    originalEvent: originalEvent,
                    originalSelect2Event: evt
                });
            };
            return CloseOnSelect;
        });
        S2.define("select2/i18n/en", [], function() {
            // English
            return {
                errorLoading: function() {
                    return "The results could not be loaded.";
                },
                inputTooLong: function(args) {
                    var overChars = args.input.length - args.maximum;
                    var message = "Please delete " + overChars + " character";
                    if (overChars != 1) message += "s";
                    return message;
                },
                inputTooShort: function(args) {
                    var remainingChars = args.minimum - args.input.length;
                    var message = "Please enter " + remainingChars + " or more characters";
                    return message;
                },
                loadingMore: function() {
                    return "Loading more results\u2026";
                },
                maximumSelected: function(args) {
                    var message = "You can only select " + args.maximum + " item";
                    if (args.maximum != 1) message += "s";
                    return message;
                },
                noResults: function() {
                    return "No results found";
                },
                searching: function() {
                    return "Searching\u2026";
                },
                removeAllItems: function() {
                    return "Remove all items";
                }
            };
        });
        S2.define("select2/defaults", [
            "jquery",
            "require",
            "./results",
            "./selection/single",
            "./selection/multiple",
            "./selection/placeholder",
            "./selection/allowClear",
            "./selection/search",
            "./selection/eventRelay",
            "./utils",
            "./translation",
            "./diacritics",
            "./data/select",
            "./data/array",
            "./data/ajax",
            "./data/tags",
            "./data/tokenizer",
            "./data/minimumInputLength",
            "./data/maximumInputLength",
            "./data/maximumSelectionLength",
            "./dropdown",
            "./dropdown/search",
            "./dropdown/hidePlaceholder",
            "./dropdown/infiniteScroll",
            "./dropdown/attachBody",
            "./dropdown/minimumResultsForSearch",
            "./dropdown/selectOnClose",
            "./dropdown/closeOnSelect",
            "./i18n/en"
        ], function($1, require1, ResultsList, SingleSelection, MultipleSelection, Placeholder, AllowClear, SelectionSearch, EventRelay, Utils, Translation, DIACRITICS, SelectData, ArrayData, AjaxData, Tags, Tokenizer, MinimumInputLength, MaximumInputLength, MaximumSelectionLength, Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll, AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect, EnglishTranslation) {
            function Defaults() {
                this.reset();
            }
            Defaults.prototype.apply = function(options) {
                options = $1.extend(true, {}, this.defaults, options);
                if (options.dataAdapter == null) {
                    if (options.ajax != null) options.dataAdapter = AjaxData;
                    else if (options.data != null) options.dataAdapter = ArrayData;
                    else options.dataAdapter = SelectData;
                    if (options.minimumInputLength > 0) options.dataAdapter = Utils.Decorate(options.dataAdapter, MinimumInputLength);
                    if (options.maximumInputLength > 0) options.dataAdapter = Utils.Decorate(options.dataAdapter, MaximumInputLength);
                    if (options.maximumSelectionLength > 0) options.dataAdapter = Utils.Decorate(options.dataAdapter, MaximumSelectionLength);
                    if (options.tags) options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
                    if (options.tokenSeparators != null || options.tokenizer != null) options.dataAdapter = Utils.Decorate(options.dataAdapter, Tokenizer);
                    if (options.query != null) {
                        var Query = require1(options.amdBase + "compat/query");
                        options.dataAdapter = Utils.Decorate(options.dataAdapter, Query);
                    }
                    if (options.initSelection != null) {
                        var InitSelection = require1(options.amdBase + "compat/initSelection");
                        options.dataAdapter = Utils.Decorate(options.dataAdapter, InitSelection);
                    }
                }
                if (options.resultsAdapter == null) {
                    options.resultsAdapter = ResultsList;
                    if (options.ajax != null) options.resultsAdapter = Utils.Decorate(options.resultsAdapter, InfiniteScroll);
                    if (options.placeholder != null) options.resultsAdapter = Utils.Decorate(options.resultsAdapter, HidePlaceholder);
                    if (options.selectOnClose) options.resultsAdapter = Utils.Decorate(options.resultsAdapter, SelectOnClose);
                }
                if (options.dropdownAdapter == null) {
                    if (options.multiple) options.dropdownAdapter = Dropdown;
                    else {
                        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);
                        options.dropdownAdapter = SearchableDropdown;
                    }
                    if (options.minimumResultsForSearch !== 0) options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, MinimumResultsForSearch);
                    if (options.closeOnSelect) options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, CloseOnSelect);
                    if (options.dropdownCssClass != null || options.dropdownCss != null || options.adaptDropdownCssClass != null) {
                        var DropdownCSS = require1(options.amdBase + "compat/dropdownCss");
                        options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, DropdownCSS);
                    }
                    options.dropdownAdapter = Utils.Decorate(options.dropdownAdapter, AttachBody);
                }
                if (options.selectionAdapter == null) {
                    if (options.multiple) options.selectionAdapter = MultipleSelection;
                    else options.selectionAdapter = SingleSelection;
                    // Add the placeholder mixin if a placeholder was specified
                    if (options.placeholder != null) options.selectionAdapter = Utils.Decorate(options.selectionAdapter, Placeholder);
                    if (options.allowClear) options.selectionAdapter = Utils.Decorate(options.selectionAdapter, AllowClear);
                    if (options.multiple) options.selectionAdapter = Utils.Decorate(options.selectionAdapter, SelectionSearch);
                    if (options.containerCssClass != null || options.containerCss != null || options.adaptContainerCssClass != null) {
                        var ContainerCSS = require1(options.amdBase + "compat/containerCss");
                        options.selectionAdapter = Utils.Decorate(options.selectionAdapter, ContainerCSS);
                    }
                    options.selectionAdapter = Utils.Decorate(options.selectionAdapter, EventRelay);
                }
                // If the defaults were not previously applied from an element, it is
                // possible for the language option to have not been resolved
                options.language = this._resolveLanguage(options.language);
                // Always fall back to English since it will always be complete
                options.language.push("en");
                var uniqueLanguages = [];
                for(var l = 0; l < options.language.length; l++){
                    var language = options.language[l];
                    if (uniqueLanguages.indexOf(language) === -1) uniqueLanguages.push(language);
                }
                options.language = uniqueLanguages;
                options.translations = this._processTranslations(options.language, options.debug);
                return options;
            };
            Defaults.prototype.reset = function() {
                function stripDiacritics(text) {
                    // Used 'uni range + named function' from http://jsperf.com/diacritics/18
                    function match(a) {
                        return DIACRITICS[a] || a;
                    }
                    return text.replace(/[^\u0000-\u007E]/g, match);
                }
                function matcher(params, data) {
                    // Always return the object if there is nothing to compare
                    if ($1.trim(params.term) === "") return data;
                    // Do a recursive check for options with children
                    if (data.children && data.children.length > 0) {
                        // Clone the data object if there are children
                        // This is required as we modify the object to remove any non-matches
                        var match = $1.extend(true, {}, data);
                        // Check each child of the option
                        for(var c = data.children.length - 1; c >= 0; c--){
                            var child = data.children[c];
                            var matches = matcher(params, child);
                            // If there wasn't a match, remove the object in the array
                            if (matches == null) match.children.splice(c, 1);
                        }
                        // If any children matched, return the new object
                        if (match.children.length > 0) return match;
                        // If there were no matching children, check just the plain object
                        return matcher(params, match);
                    }
                    var original = stripDiacritics(data.text).toUpperCase();
                    var term = stripDiacritics(params.term).toUpperCase();
                    // Check if the text contains the term
                    if (original.indexOf(term) > -1) return data;
                    // If it doesn't contain the term, don't return anything
                    return null;
                }
                this.defaults = {
                    amdBase: "./",
                    amdLanguageBase: "./i18n/",
                    closeOnSelect: true,
                    debug: false,
                    dropdownAutoWidth: false,
                    escapeMarkup: Utils.escapeMarkup,
                    language: {},
                    matcher: matcher,
                    minimumInputLength: 0,
                    maximumInputLength: 0,
                    maximumSelectionLength: 0,
                    minimumResultsForSearch: 0,
                    selectOnClose: false,
                    scrollAfterSelect: false,
                    sorter: function(data) {
                        return data;
                    },
                    templateResult: function(result) {
                        return result.text;
                    },
                    templateSelection: function(selection) {
                        return selection.text;
                    },
                    theme: "default",
                    width: "resolve"
                };
            };
            Defaults.prototype.applyFromElement = function(options, $element) {
                var optionLanguage = options.language;
                var defaultLanguage = this.defaults.language;
                var elementLanguage = $element.prop("lang");
                var parentLanguage = $element.closest("[lang]").prop("lang");
                var languages = Array.prototype.concat.call(this._resolveLanguage(elementLanguage), this._resolveLanguage(optionLanguage), this._resolveLanguage(defaultLanguage), this._resolveLanguage(parentLanguage));
                options.language = languages;
                return options;
            };
            Defaults.prototype._resolveLanguage = function(language) {
                if (!language) return [];
                if ($1.isEmptyObject(language)) return [];
                if ($1.isPlainObject(language)) return [
                    language
                ];
                var languages;
                if (!$1.isArray(language)) languages = [
                    language
                ];
                else languages = language;
                var resolvedLanguages = [];
                for(var l = 0; l < languages.length; l++){
                    resolvedLanguages.push(languages[l]);
                    if (typeof languages[l] === "string" && languages[l].indexOf("-") > 0) {
                        // Extract the region information if it is included
                        var languageParts = languages[l].split("-");
                        var baseLanguage = languageParts[0];
                        resolvedLanguages.push(baseLanguage);
                    }
                }
                return resolvedLanguages;
            };
            Defaults.prototype._processTranslations = function(languages, debug) {
                var translations = new Translation();
                for(var l = 0; l < languages.length; l++){
                    var languageData = new Translation();
                    var language = languages[l];
                    if (typeof language === "string") try {
                        // Try to load it with the original name
                        languageData = Translation.loadPath(language);
                    } catch (e) {
                        try {
                            // If we couldn't load it, check if it wasn't the full path
                            language = this.defaults.amdLanguageBase + language;
                            languageData = Translation.loadPath(language);
                        } catch (ex) {
                            // The translation could not be loaded at all. Sometimes this is
                            // because of a configuration problem, other times this can be
                            // because of how Select2 helps load all possible translation files
                            if (debug && window.console && console.warn) console.warn('Select2: The language file for "' + language + '" could ' + "not be automatically loaded. A fallback will be used instead.");
                        }
                    }
                    else if ($1.isPlainObject(language)) languageData = new Translation(language);
                    else languageData = language;
                    translations.extend(languageData);
                }
                return translations;
            };
            Defaults.prototype.set = function(key, value) {
                var camelKey = $1.camelCase(key);
                var data = {};
                data[camelKey] = value;
                var convertedData = Utils._convertData(data);
                $1.extend(true, this.defaults, convertedData);
            };
            var defaults = new Defaults();
            return defaults;
        });
        S2.define("select2/options", [
            "require",
            "jquery",
            "./defaults",
            "./utils"
        ], function(require1, $1, Defaults, Utils) {
            function Options(options, $element) {
                this.options = options;
                if ($element != null) this.fromElement($element);
                if ($element != null) this.options = Defaults.applyFromElement(this.options, $element);
                this.options = Defaults.apply(this.options);
                if ($element && $element.is("input")) {
                    var InputCompat = require1(this.get("amdBase") + "compat/inputData");
                    this.options.dataAdapter = Utils.Decorate(this.options.dataAdapter, InputCompat);
                }
            }
            Options.prototype.fromElement = function($e) {
                var excludedData = [
                    "select2"
                ];
                if (this.options.multiple == null) this.options.multiple = $e.prop("multiple");
                if (this.options.disabled == null) this.options.disabled = $e.prop("disabled");
                if (this.options.dir == null) {
                    if ($e.prop("dir")) this.options.dir = $e.prop("dir");
                    else if ($e.closest("[dir]").prop("dir")) this.options.dir = $e.closest("[dir]").prop("dir");
                    else this.options.dir = "ltr";
                }
                $e.prop("disabled", this.options.disabled);
                $e.prop("multiple", this.options.multiple);
                if (Utils.GetData($e[0], "select2Tags")) {
                    if (this.options.debug && window.console && console.warn) console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.');
                    Utils.StoreData($e[0], "data", Utils.GetData($e[0], "select2Tags"));
                    Utils.StoreData($e[0], "tags", true);
                }
                if (Utils.GetData($e[0], "ajaxUrl")) {
                    if (this.options.debug && window.console && console.warn) console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2.");
                    $e.attr("ajax--url", Utils.GetData($e[0], "ajaxUrl"));
                    Utils.StoreData($e[0], "ajax-Url", Utils.GetData($e[0], "ajaxUrl"));
                }
                var dataset = {};
                function upperCaseLetter(_, letter) {
                    return letter.toUpperCase();
                }
                // Pre-load all of the attributes which are prefixed with `data-`
                for(var attr = 0; attr < $e[0].attributes.length; attr++){
                    var attributeName = $e[0].attributes[attr].name;
                    var prefix = "data-";
                    if (attributeName.substr(0, prefix.length) == prefix) {
                        // Get the contents of the attribute after `data-`
                        var dataName = attributeName.substring(prefix.length);
                        // Get the data contents from the consistent source
                        // This is more than likely the jQuery data helper
                        var dataValue = Utils.GetData($e[0], dataName);
                        // camelCase the attribute name to match the spec
                        var camelDataName = dataName.replace(/-([a-z])/g, upperCaseLetter);
                        // Store the data attribute contents into the dataset since
                        dataset[camelDataName] = dataValue;
                    }
                }
                // Prefer the element's `dataset` attribute if it exists
                // jQuery 1.x does not correctly handle data attributes with multiple dashes
                if ($1.fn.jquery && $1.fn.jquery.substr(0, 2) == "1." && $e[0].dataset) dataset = $1.extend(true, {}, $e[0].dataset, dataset);
                // Prefer our internal data cache if it exists
                var data = $1.extend(true, {}, Utils.GetData($e[0]), dataset);
                data = Utils._convertData(data);
                for(var key in data){
                    if ($1.inArray(key, excludedData) > -1) continue;
                    if ($1.isPlainObject(this.options[key])) $1.extend(this.options[key], data[key]);
                    else this.options[key] = data[key];
                }
                return this;
            };
            Options.prototype.get = function(key) {
                return this.options[key];
            };
            Options.prototype.set = function(key, val) {
                this.options[key] = val;
            };
            return Options;
        });
        S2.define("select2/core", [
            "jquery",
            "./options",
            "./utils",
            "./keys"
        ], function($1, Options, Utils, KEYS) {
            var Select2 = function($element, options) {
                if (Utils.GetData($element[0], "select2") != null) Utils.GetData($element[0], "select2").destroy();
                this.$element = $element;
                this.id = this._generateId($element);
                options = options || {};
                this.options = new Options(options, $element);
                Select2.__super__.constructor.call(this);
                // Set up the tabindex
                var tabindex = $element.attr("tabindex") || 0;
                Utils.StoreData($element[0], "old-tabindex", tabindex);
                $element.attr("tabindex", "-1");
                // Set up containers and adapters
                var DataAdapter = this.options.get("dataAdapter");
                this.dataAdapter = new DataAdapter($element, this.options);
                var $container = this.render();
                this._placeContainer($container);
                var SelectionAdapter = this.options.get("selectionAdapter");
                this.selection = new SelectionAdapter($element, this.options);
                this.$selection = this.selection.render();
                this.selection.position(this.$selection, $container);
                var DropdownAdapter = this.options.get("dropdownAdapter");
                this.dropdown = new DropdownAdapter($element, this.options);
                this.$dropdown = this.dropdown.render();
                this.dropdown.position(this.$dropdown, $container);
                var ResultsAdapter = this.options.get("resultsAdapter");
                this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
                this.$results = this.results.render();
                this.results.position(this.$results, this.$dropdown);
                // Bind events
                var self = this;
                // Bind the container to all of the adapters
                this._bindAdapters();
                // Register any DOM event handlers
                this._registerDomEvents();
                // Register any internal event handlers
                this._registerDataEvents();
                this._registerSelectionEvents();
                this._registerDropdownEvents();
                this._registerResultsEvents();
                this._registerEvents();
                // Set the initial state
                this.dataAdapter.current(function(initialData) {
                    self.trigger("selection:update", {
                        data: initialData
                    });
                });
                // Hide the original select
                $element.addClass("select2-hidden-accessible");
                $element.attr("aria-hidden", "true");
                // Synchronize any monitored attributes
                this._syncAttributes();
                Utils.StoreData($element[0], "select2", this);
                // Ensure backwards compatibility with $element.data('select2').
                $element.data("select2", this);
            };
            Utils.Extend(Select2, Utils.Observable);
            Select2.prototype._generateId = function($element) {
                var id = "";
                if ($element.attr("id") != null) id = $element.attr("id");
                else if ($element.attr("name") != null) id = $element.attr("name") + "-" + Utils.generateChars(2);
                else id = Utils.generateChars(4);
                id = id.replace(/(:|\.|\[|\]|,)/g, "");
                id = "select2-" + id;
                return id;
            };
            Select2.prototype._placeContainer = function($container) {
                $container.insertAfter(this.$element);
                var width = this._resolveWidth(this.$element, this.options.get("width"));
                if (width != null) $container.css("width", width);
            };
            Select2.prototype._resolveWidth = function($element, method) {
                var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                if (method == "resolve") {
                    var styleWidth = this._resolveWidth($element, "style");
                    if (styleWidth != null) return styleWidth;
                    return this._resolveWidth($element, "element");
                }
                if (method == "element") {
                    var elementWidth = $element.outerWidth(false);
                    if (elementWidth <= 0) return "auto";
                    return elementWidth + "px";
                }
                if (method == "style") {
                    var style = $element.attr("style");
                    if (typeof style !== "string") return null;
                    var attrs = style.split(";");
                    for(var i = 0, l = attrs.length; i < l; i = i + 1){
                        var attr = attrs[i].replace(/\s/g, "");
                        var matches = attr.match(WIDTH);
                        if (matches !== null && matches.length >= 1) return matches[1];
                    }
                    return null;
                }
                if (method == "computedstyle") {
                    var computedStyle = window.getComputedStyle($element[0]);
                    return computedStyle.width;
                }
                return method;
            };
            Select2.prototype._bindAdapters = function() {
                this.dataAdapter.bind(this, this.$container);
                this.selection.bind(this, this.$container);
                this.dropdown.bind(this, this.$container);
                this.results.bind(this, this.$container);
            };
            Select2.prototype._registerDomEvents = function() {
                var self = this;
                this.$element.on("change.select2", function() {
                    self.dataAdapter.current(function(data) {
                        self.trigger("selection:update", {
                            data: data
                        });
                    });
                });
                this.$element.on("focus.select2", function(evt) {
                    self.trigger("focus", evt);
                });
                this._syncA = Utils.bind(this._syncAttributes, this);
                this._syncS = Utils.bind(this._syncSubtree, this);
                if (this.$element[0].attachEvent) this.$element[0].attachEvent("onpropertychange", this._syncA);
                var observer = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                if (observer != null) {
                    this._observer = new observer(function(mutations) {
                        self._syncA();
                        self._syncS(null, mutations);
                    });
                    this._observer.observe(this.$element[0], {
                        attributes: true,
                        childList: true,
                        subtree: false
                    });
                } else if (this.$element[0].addEventListener) {
                    this.$element[0].addEventListener("DOMAttrModified", self._syncA, false);
                    this.$element[0].addEventListener("DOMNodeInserted", self._syncS, false);
                    this.$element[0].addEventListener("DOMNodeRemoved", self._syncS, false);
                }
            };
            Select2.prototype._registerDataEvents = function() {
                var self = this;
                this.dataAdapter.on("*", function(name, params) {
                    self.trigger(name, params);
                });
            };
            Select2.prototype._registerSelectionEvents = function() {
                var self = this;
                var nonRelayEvents = [
                    "toggle",
                    "focus"
                ];
                this.selection.on("toggle", function() {
                    self.toggleDropdown();
                });
                this.selection.on("focus", function(params) {
                    self.focus(params);
                });
                this.selection.on("*", function(name, params) {
                    if ($1.inArray(name, nonRelayEvents) !== -1) return;
                    self.trigger(name, params);
                });
            };
            Select2.prototype._registerDropdownEvents = function() {
                var self = this;
                this.dropdown.on("*", function(name, params) {
                    self.trigger(name, params);
                });
            };
            Select2.prototype._registerResultsEvents = function() {
                var self = this;
                this.results.on("*", function(name, params) {
                    self.trigger(name, params);
                });
            };
            Select2.prototype._registerEvents = function() {
                var self = this;
                this.on("open", function() {
                    self.$container.addClass("select2-container--open");
                });
                this.on("close", function() {
                    self.$container.removeClass("select2-container--open");
                });
                this.on("enable", function() {
                    self.$container.removeClass("select2-container--disabled");
                });
                this.on("disable", function() {
                    self.$container.addClass("select2-container--disabled");
                });
                this.on("blur", function() {
                    self.$container.removeClass("select2-container--focus");
                });
                this.on("query", function(params) {
                    if (!self.isOpen()) self.trigger("open", {});
                    this.dataAdapter.query(params, function(data) {
                        self.trigger("results:all", {
                            data: data,
                            query: params
                        });
                    });
                });
                this.on("query:append", function(params) {
                    this.dataAdapter.query(params, function(data) {
                        self.trigger("results:append", {
                            data: data,
                            query: params
                        });
                    });
                });
                this.on("keypress", function(evt) {
                    var key = evt.which;
                    if (self.isOpen()) {
                        if (key === KEYS.ESC || key === KEYS.TAB || key === KEYS.UP && evt.altKey) {
                            self.close(evt);
                            evt.preventDefault();
                        } else if (key === KEYS.ENTER) {
                            self.trigger("results:select", {});
                            evt.preventDefault();
                        } else if (key === KEYS.SPACE && evt.ctrlKey) {
                            self.trigger("results:toggle", {});
                            evt.preventDefault();
                        } else if (key === KEYS.UP) {
                            self.trigger("results:previous", {});
                            evt.preventDefault();
                        } else if (key === KEYS.DOWN) {
                            self.trigger("results:next", {});
                            evt.preventDefault();
                        }
                    } else if (key === KEYS.ENTER || key === KEYS.SPACE || key === KEYS.DOWN && evt.altKey) {
                        self.open();
                        evt.preventDefault();
                    }
                });
            };
            Select2.prototype._syncAttributes = function() {
                this.options.set("disabled", this.$element.prop("disabled"));
                if (this.isDisabled()) {
                    if (this.isOpen()) this.close();
                    this.trigger("disable", {});
                } else this.trigger("enable", {});
            };
            Select2.prototype._isChangeMutation = function(evt, mutations) {
                var changed = false;
                var self = this;
                // Ignore any mutation events raised for elements that aren't options or
                // optgroups. This handles the case when the select element is destroyed
                if (evt && evt.target && evt.target.nodeName !== "OPTION" && evt.target.nodeName !== "OPTGROUP") return;
                if (!mutations) // If mutation events aren't supported, then we can only assume that the
                // change affected the selections
                changed = true;
                else if (mutations.addedNodes && mutations.addedNodes.length > 0) for(var n = 0; n < mutations.addedNodes.length; n++){
                    var node = mutations.addedNodes[n];
                    if (node.selected) changed = true;
                }
                else if (mutations.removedNodes && mutations.removedNodes.length > 0) changed = true;
                else if ($1.isArray(mutations)) $1.each(mutations, function(evt, mutation) {
                    if (self._isChangeMutation(evt, mutation)) {
                        // We've found a change mutation.
                        // Let's escape from the loop and continue
                        changed = true;
                        return false;
                    }
                });
                return changed;
            };
            Select2.prototype._syncSubtree = function(evt, mutations) {
                var changed = this._isChangeMutation(evt, mutations);
                var self = this;
                // Only re-pull the data if we think there is a change
                if (changed) this.dataAdapter.current(function(currentData) {
                    self.trigger("selection:update", {
                        data: currentData
                    });
                });
            };
            /**
   * Override the trigger method to automatically trigger pre-events when
   * there are events that can be prevented.
   */ Select2.prototype.trigger = function(name, args) {
                var actualTrigger = Select2.__super__.trigger;
                var preTriggerMap = {
                    "open": "opening",
                    "close": "closing",
                    "select": "selecting",
                    "unselect": "unselecting",
                    "clear": "clearing"
                };
                if (args === undefined) args = {};
                if (name in preTriggerMap) {
                    var preTriggerName = preTriggerMap[name];
                    var preTriggerArgs = {
                        prevented: false,
                        name: name,
                        args: args
                    };
                    actualTrigger.call(this, preTriggerName, preTriggerArgs);
                    if (preTriggerArgs.prevented) {
                        args.prevented = true;
                        return;
                    }
                }
                actualTrigger.call(this, name, args);
            };
            Select2.prototype.toggleDropdown = function() {
                if (this.isDisabled()) return;
                if (this.isOpen()) this.close();
                else this.open();
            };
            Select2.prototype.open = function() {
                if (this.isOpen()) return;
                if (this.isDisabled()) return;
                this.trigger("query", {});
            };
            Select2.prototype.close = function(evt) {
                if (!this.isOpen()) return;
                this.trigger("close", {
                    originalEvent: evt
                });
            };
            /**
   * Helper method to abstract the "enabled" (not "disabled") state of this
   * object.
   *
   * @return {true} if the instance is not disabled.
   * @return {false} if the instance is disabled.
   */ Select2.prototype.isEnabled = function() {
                return !this.isDisabled();
            };
            /**
   * Helper method to abstract the "disabled" state of this object.
   *
   * @return {true} if the disabled option is true.
   * @return {false} if the disabled option is false.
   */ Select2.prototype.isDisabled = function() {
                return this.options.get("disabled");
            };
            Select2.prototype.isOpen = function() {
                return this.$container.hasClass("select2-container--open");
            };
            Select2.prototype.hasFocus = function() {
                return this.$container.hasClass("select2-container--focus");
            };
            Select2.prototype.focus = function(data) {
                // No need to re-trigger focus events if we are already focused
                if (this.hasFocus()) return;
                this.$container.addClass("select2-container--focus");
                this.trigger("focus", {});
            };
            Select2.prototype.enable = function(args) {
                if (this.options.get("debug") && window.console && console.warn) console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.');
                if (args == null || args.length === 0) args = [
                    true
                ];
                var disabled = !args[0];
                this.$element.prop("disabled", disabled);
            };
            Select2.prototype.data = function() {
                if (this.options.get("debug") && arguments.length > 0 && window.console && console.warn) console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
                var data = [];
                this.dataAdapter.current(function(currentData) {
                    data = currentData;
                });
                return data;
            };
            Select2.prototype.val = function(args) {
                if (this.options.get("debug") && window.console && console.warn) console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.');
                if (args == null || args.length === 0) return this.$element.val();
                var newVal = args[0];
                if ($1.isArray(newVal)) newVal = $1.map(newVal, function(obj) {
                    return obj.toString();
                });
                this.$element.val(newVal).trigger("input").trigger("change");
            };
            Select2.prototype.destroy = function() {
                this.$container.remove();
                if (this.$element[0].detachEvent) this.$element[0].detachEvent("onpropertychange", this._syncA);
                if (this._observer != null) {
                    this._observer.disconnect();
                    this._observer = null;
                } else if (this.$element[0].removeEventListener) {
                    this.$element[0].removeEventListener("DOMAttrModified", this._syncA, false);
                    this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, false);
                    this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, false);
                }
                this._syncA = null;
                this._syncS = null;
                this.$element.off(".select2");
                this.$element.attr("tabindex", Utils.GetData(this.$element[0], "old-tabindex"));
                this.$element.removeClass("select2-hidden-accessible");
                this.$element.attr("aria-hidden", "false");
                Utils.RemoveData(this.$element[0]);
                this.$element.removeData("select2");
                this.dataAdapter.destroy();
                this.selection.destroy();
                this.dropdown.destroy();
                this.results.destroy();
                this.dataAdapter = null;
                this.selection = null;
                this.dropdown = null;
                this.results = null;
            };
            Select2.prototype.render = function() {
                var $container = $1('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
                $container.attr("dir", this.options.get("dir"));
                this.$container = $container;
                this.$container.addClass("select2-container--" + this.options.get("theme"));
                Utils.StoreData($container[0], "element", this.$element);
                return $container;
            };
            return Select2;
        });
        S2.define("jquery-mousewheel", [
            "jquery"
        ], function($1) {
            // Used to shim jQuery.mousewheel for non-full builds.
            return $1;
        });
        S2.define("jquery.select2", [
            "jquery",
            "jquery-mousewheel",
            "./select2/core",
            "./select2/defaults",
            "./select2/utils"
        ], function($1, _, Select2, Defaults, Utils) {
            if ($1.fn.select2 == null) {
                // All methods that should return the element
                var thisMethods = [
                    "open",
                    "close",
                    "destroy"
                ];
                $1.fn.select2 = function(options) {
                    options = options || {};
                    if (typeof options === "object") {
                        this.each(function() {
                            var instanceOptions = $1.extend(true, {}, options);
                            var instance = new Select2($1(this), instanceOptions);
                        });
                        return this;
                    } else if (typeof options === "string") {
                        var ret;
                        var args = Array.prototype.slice.call(arguments, 1);
                        this.each(function() {
                            var instance = Utils.GetData(this, "select2");
                            if (instance == null && window.console && console.error) console.error("The select2('" + options + "') method was called on an " + "element that is not using Select2.");
                            ret = instance[options].apply(instance, args);
                        });
                        // Check if we should be returning `this`
                        if ($1.inArray(options, thisMethods) > -1) return this;
                        return ret;
                    } else throw new Error("Invalid arguments for Select2: " + options);
                };
            }
            if ($1.fn.select2.defaults == null) $1.fn.select2.defaults = Defaults;
            return Select2;
        });
        // Return the AMD loader configuration so it can be used outside of this file
        return {
            define: S2.define,
            require: S2.require
        };
    }();
    // Autoload the jQuery bindings
    // We know that all of the modules exist above this, so we're safe
    var select2 = S2.require("jquery.select2");
    // Hold the AMD module references on the jQuery function that was just loaded
    // This allows Select2 to use the internal loader outside of this file, such
    // as in the language files.
    jQuery1.fn.select2.amd = S2;
    // Return the Select2 instance for anyone who is importing it.
    return select2;
});


const $5c26211a2a30ef6f$var$topbarSelect = {
    init: function() {
        typeof $4d10c830a3883503$exports == "function" && $4d10c830a3883503$exports($);
        // Functie die de options van de topbar selects laad
        var topbarSelect = document.getElementsByClassName("topbar-select");
        if (topbarSelect !== undefined) for(var i = 0; i < topbarSelect.length; i++)topbarSelect[i].onchange = function() {
            if (this.value != "") {
                var elementName = this.id.replace("topbar_", "");
                document.location.href = "?" + elementName + "=" + this.value;
            }
        };
        // Functie die de value van de select als windows.location.href laadt
        var elementList = document.querySelectorAll("[data-select-link]");
        if (elementList !== undefined) for(var i = 0; i < elementList.length; i++)elementList[i].onchange = function() {
            if (this.value != "") document.location.href = this.value;
        };
        // Init select2
        $("#topbar_company, #topbar_tussenp, #topbar_group, #topbar_user").select2({
            theme: "bootstrap-5",
            ajax: {
                quietMillis: 1000,
                // wait 1000 milliseconds before triggering the request
                delay: 1000,
                // wait 1000 milliseconds before triggering the request
                dataType: "json",
                minimumInputLength: 2,
                url: "/select2/json/",
                data: function(params) {
                    var query = {
                        search: params.term,
                        type: $(this).attr("id"),
                        page: params.page || 1
                    };
                    // Query parameters will be ?search=[term]&type=public
                    return query;
                },
                processResults: function(data) {
                    return data;
                }
            }
        });
        // Init select2 multiple
        $("#topbar_team").select2({
            theme: "bootstrap-5"
        });
    }
};
var $5c26211a2a30ef6f$export$2e2bcd8739ae039 = $5c26211a2a30ef6f$var$topbarSelect;


var $87dc804c4fdb363e$export$2e2bcd8739ae039 = {
    init () {},
    finalize () {
        (0, $5c26211a2a30ef6f$export$2e2bcd8739ae039).init();
    }
};


parcelRequire("6j4kq");
var $f386ddc081ca0f1d$var$activeTabs = {
    activeTab: null,
    element: null,
    /**
   * Init
   *
   * @param {object} target
   *
   * @returns {void}
   */ init: function(target) {
        $f386ddc081ca0f1d$var$activeTabs.element = target.querySelector("[data-nav-tabs]") || null;
        $f386ddc081ca0f1d$var$activeTabs.activeTab = $f386ddc081ca0f1d$var$activeTabs.element?.dataset?.navTabsActive || 1;
        if ($f386ddc081ca0f1d$var$activeTabs.element !== null) {
            $f386ddc081ca0f1d$var$activeTabs.initEvents($f386ddc081ca0f1d$var$activeTabs.element);
            $f386ddc081ca0f1d$var$activeTabs.setActiveTab($f386ddc081ca0f1d$var$activeTabs.element, $f386ddc081ca0f1d$var$activeTabs.activeTab);
        }
    },
    /**
   * Init events
   * @param {object} target
   *
   * @returns {void}
   */ initEvents: function(target) {
        target.addEventListener("click", function(event) {
            for(var eventTarget = event.target; eventTarget && eventTarget != this; eventTarget = eventTarget.parentNode)if (eventTarget.matches("[data-nav-tabs-click] li[data-nav-tabs-item] a")) {
                if (!$f386ddc081ca0f1d$var$activeTabs.checkIfAllowed(event)) event.preventDefault();
                break;
            }
        }, false);
    },
    /**
   * Set active tab
   *
   * @param {object} target
   * @param {number} stap
   *
   * @returns {void}
   */ setActiveTab: function(target, stap) {
        const activeTab = target.querySelectorAll('[data-nav-tabs-item="' + stap + '"] a');
        activeTab?.forEach((element)=>element.classList.add("active"));
    },
    /**
   * Check if allowed
   *
   * @param {object} event
   *
   * @returns {boolean}
   */ checkIfAllowed: function(event) {
        const urlArray = event.target.closest("li")?.querySelector("a")?.getAttribute("href")?.split("/");
        if (typeof urlArray == "object" && urlArray[urlArray.length - 1] > $f386ddc081ca0f1d$var$activeTabs.activeTab) return false;
        return true;
    },
    /**
   * Voert de init functie uit van de geselecteerde tab als er een script voor gedefinieerd is
   *
   * @param tabScripts
   * @param tabIndex
   */ initTab (tabScripts, tabIndex = null) {
        tabIndex = tabIndex || $f386ddc081ca0f1d$var$activeTabs.getTabIndex();
        const index = tabIndex - 1;
        if (typeof tabScripts[index] !== "undefined") tabScripts[index].init();
    },
    /**
   * Verkrijgt de tab index uit de DOM
   *
   * @param [targetElement=null]
   *
   * @returns {string}
   */ getTabIndex (targetElement = null) {
        const element = targetElement || document.body;
        const tabIndex = element.querySelector("[data-nav-tabs-active]").dataset.navTabsActive || null;
        if (tabIndex !== null) return parseInt(tabIndex);
        return false;
    }
};
var $f386ddc081ca0f1d$export$2e2bcd8739ae039 = $f386ddc081ca0f1d$var$activeTabs;


var $46c3b49fce744198$var$selectValue = {
    /**
   * Zet selects op de option gelijk aan de value attribute
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        if (target instanceof $) target = target[0];
        if (typeof target !== "undefined") {
            $46c3b49fce744198$var$selectValue.initSetValue(target);
            $46c3b49fce744198$var$selectValue.initSetValueIfSingle(target);
        }
    },
    /**
   * Zet selects op de option gelijk aan de data-value attribute
   *
   * @param {object} target
   * @returns {void}
   */ initSetValue: function(target) {
        target.querySelectorAll("select[data-value]").forEach(function(select) {
            select.value = select.getAttribute("data-value");
            select.dispatchEvent(new Event("change"));
        });
    },
    /**
   * Selecteer de enige selecteerbare waarde in select (één keuze is géén keuze)
   *
   * @param {object} target
   * @returns {void}
   */ initSetValueIfSingle: function(target) {
        target.querySelectorAll("select[data-select-if-single]:not([readonly])").forEach(function(select) {
            let options = select.querySelectorAll("option:not([disabled])");
            let optionElements = Array.from(options).filter((option)=>option.value !== "");
            if (optionElements.length === 1) {
                select.value = optionElements[0].value;
                select.dispatchEvent(new Event("change"));
            }
        });
    }
};
var $46c3b49fce744198$export$2e2bcd8739ae039 = $46c3b49fce744198$var$selectValue;



/*!
 * Datepicker for Bootstrap v1.10.0 (https://github.com/uxsolutions/bootstrap-datepicker)
 *
 * Licensed under the Apache License v2.0 (https://www.apache.org/licenses/LICENSE-2.0)
 */ (function(factory) {
    if (typeof define === "function" && define.amd) define([
        "jquery"
    ], factory);
    else factory((parcelRequire("iUSsr")));
})(function($, undefined) {
    function UTCDate() {
        return new Date(Date.UTC.apply(Date, arguments));
    }
    function UTCToday() {
        var today = new Date();
        return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
    }
    function isUTCEquals(date1, date2) {
        return date1.getUTCFullYear() === date2.getUTCFullYear() && date1.getUTCMonth() === date2.getUTCMonth() && date1.getUTCDate() === date2.getUTCDate();
    }
    function alias(method, deprecationMsg) {
        return function() {
            if (deprecationMsg !== undefined) $.fn.datepicker.deprecated(deprecationMsg);
            return this[method].apply(this, arguments);
        };
    }
    function isValidDate(d) {
        return d && !isNaN(d.getTime());
    }
    var DateArray = function() {
        var extras = {
            get: function(i) {
                return this.slice(i)[0];
            },
            contains: function(d) {
                // Array.indexOf is not cross-browser;
                // $.inArray doesn't work with Dates
                var val = d && d.valueOf();
                for(var i = 0, l = this.length; i < l; i++)// Use date arithmetic to allow dates with different times to match
                if (0 <= this[i].valueOf() - val && this[i].valueOf() - val < 86400000) return i;
                return -1;
            },
            remove: function(i) {
                this.splice(i, 1);
            },
            replace: function(new_array) {
                if (!new_array) return;
                if (!Array.isArray(new_array)) new_array = [
                    new_array
                ];
                this.clear();
                this.push.apply(this, new_array);
            },
            clear: function() {
                this.length = 0;
            },
            copy: function() {
                var a = new DateArray();
                a.replace(this);
                return a;
            }
        };
        return function() {
            var a = [];
            a.push.apply(a, arguments);
            $.extend(a, extras);
            return a;
        };
    }();
    // Picker object
    var Datepicker = function(element, options) {
        $.data(element, "datepicker", this);
        this._events = [];
        this._secondaryEvents = [];
        this._process_options(options);
        this.dates = new DateArray();
        this.viewDate = this.o.defaultViewDate;
        this.focusDate = null;
        this.element = $(element);
        this.isInput = this.element.is("input");
        this.inputField = this.isInput ? this.element : this.element.find("input");
        this.component = this.element.hasClass("date") ? this.element.find(".add-on, .input-group-addon, .input-group-append, .input-group-prepend, .btn") : false;
        if (this.component && this.component.length === 0) this.component = false;
        if (this.o.isInline === null) this.isInline = !this.component && !this.isInput;
        else this.isInline = this.o.isInline;
        this.picker = $(DPGlobal.template);
        // Checking templates and inserting
        if (this._check_template(this.o.templates.leftArrow)) this.picker.find(".prev").html(this.o.templates.leftArrow);
        if (this._check_template(this.o.templates.rightArrow)) this.picker.find(".next").html(this.o.templates.rightArrow);
        this._buildEvents();
        this._attachEvents();
        if (this.isInline) this.picker.addClass("datepicker-inline").appendTo(this.element);
        else this.picker.addClass("datepicker-dropdown dropdown-menu");
        if (this.o.rtl) this.picker.addClass("datepicker-rtl");
        if (this.o.calendarWeeks) this.picker.find(".datepicker-days .datepicker-switch, thead .datepicker-title, tfoot .today, tfoot .clear").attr("colspan", function(i, val) {
            return Number(val) + 1;
        });
        this._process_options({
            startDate: this._o.startDate,
            endDate: this._o.endDate,
            daysOfWeekDisabled: this.o.daysOfWeekDisabled,
            daysOfWeekHighlighted: this.o.daysOfWeekHighlighted,
            datesDisabled: this.o.datesDisabled
        });
        this._allow_update = false;
        this.setViewMode(this.o.startView);
        this._allow_update = true;
        this.fillDow();
        this.fillMonths();
        this.update();
        if (this.isInline) this.show();
    };
    Datepicker.prototype = {
        constructor: Datepicker,
        _resolveViewName: function(view) {
            $.each(DPGlobal.viewModes, function(i, viewMode) {
                if (view === i || $.inArray(view, viewMode.names) !== -1) {
                    view = i;
                    return false;
                }
            });
            return view;
        },
        _resolveDaysOfWeek: function(daysOfWeek) {
            if (!Array.isArray(daysOfWeek)) daysOfWeek = daysOfWeek.split(/[,\s]*/);
            return $.map(daysOfWeek, Number);
        },
        _check_template: function(tmp) {
            try {
                // If empty
                if (tmp === undefined || tmp === "") return false;
                // If no html, everything ok
                if ((tmp.match(/[<>]/g) || []).length <= 0) return true;
                // Checking if html is fine
                var jDom = $(tmp);
                return jDom.length > 0;
            } catch (ex) {
                return false;
            }
        },
        _process_options: function(opts) {
            // Store raw options for reference
            this._o = $.extend({}, this._o, opts);
            // Processed options
            var o = this.o = $.extend({}, this._o);
            // Check if "de-DE" style date is available, if not language should
            // fallback to 2 letter code eg "de"
            var lang = o.language;
            if (!dates[lang]) {
                lang = lang.split("-")[0];
                if (!dates[lang]) lang = defaults.language;
            }
            o.language = lang;
            // Retrieve view index from any aliases
            o.startView = this._resolveViewName(o.startView);
            o.minViewMode = this._resolveViewName(o.minViewMode);
            o.maxViewMode = this._resolveViewName(o.maxViewMode);
            // Check view is between min and max
            o.startView = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, o.startView));
            // true, false, or Number > 0
            if (o.multidate !== true) {
                o.multidate = Number(o.multidate) || false;
                if (o.multidate !== false) o.multidate = Math.max(0, o.multidate);
            }
            o.multidateSeparator = String(o.multidateSeparator);
            o.weekStart %= 7;
            o.weekEnd = (o.weekStart + 6) % 7;
            var format = DPGlobal.parseFormat(o.format);
            if (o.startDate !== -Infinity) {
                if (!!o.startDate) {
                    if (o.startDate instanceof Date) o.startDate = this._local_to_utc(this._zero_time(o.startDate));
                    else o.startDate = DPGlobal.parseDate(o.startDate, format, o.language, o.assumeNearbyYear);
                } else o.startDate = -Infinity;
            }
            if (o.endDate !== Infinity) {
                if (!!o.endDate) {
                    if (o.endDate instanceof Date) o.endDate = this._local_to_utc(this._zero_time(o.endDate));
                    else o.endDate = DPGlobal.parseDate(o.endDate, format, o.language, o.assumeNearbyYear);
                } else o.endDate = Infinity;
            }
            o.daysOfWeekDisabled = this._resolveDaysOfWeek(o.daysOfWeekDisabled || []);
            o.daysOfWeekHighlighted = this._resolveDaysOfWeek(o.daysOfWeekHighlighted || []);
            o.datesDisabled = o.datesDisabled || [];
            if (!Array.isArray(o.datesDisabled)) o.datesDisabled = o.datesDisabled.split(",");
            o.datesDisabled = $.map(o.datesDisabled, function(d) {
                return DPGlobal.parseDate(d, format, o.language, o.assumeNearbyYear);
            });
            var plc = String(o.orientation).toLowerCase().split(/\s+/g), _plc = o.orientation.toLowerCase();
            plc = $.grep(plc, function(word) {
                return /^auto|left|right|top|bottom$/.test(word);
            });
            o.orientation = {
                x: "auto",
                y: "auto"
            };
            if (!_plc || _plc === "auto") ; // no action
            else if (plc.length === 1) switch(plc[0]){
                case "top":
                case "bottom":
                    o.orientation.y = plc[0];
                    break;
                case "left":
                case "right":
                    o.orientation.x = plc[0];
                    break;
            }
            else {
                _plc = $.grep(plc, function(word) {
                    return /^left|right$/.test(word);
                });
                o.orientation.x = _plc[0] || "auto";
                _plc = $.grep(plc, function(word) {
                    return /^top|bottom$/.test(word);
                });
                o.orientation.y = _plc[0] || "auto";
            }
            if (o.defaultViewDate instanceof Date || typeof o.defaultViewDate === "string") o.defaultViewDate = DPGlobal.parseDate(o.defaultViewDate, format, o.language, o.assumeNearbyYear);
            else if (o.defaultViewDate) {
                var year = o.defaultViewDate.year || new Date().getFullYear();
                var month = o.defaultViewDate.month || 0;
                var day = o.defaultViewDate.day || 1;
                o.defaultViewDate = UTCDate(year, month, day);
            } else o.defaultViewDate = UTCToday();
        },
        _applyEvents: function(evs) {
            for(var i = 0, el, ch, ev; i < evs.length; i++){
                el = evs[i][0];
                if (evs[i].length === 2) {
                    ch = undefined;
                    ev = evs[i][1];
                } else if (evs[i].length === 3) {
                    ch = evs[i][1];
                    ev = evs[i][2];
                }
                el.on(ev, ch);
            }
        },
        _unapplyEvents: function(evs) {
            for(var i = 0, el, ev, ch; i < evs.length; i++){
                el = evs[i][0];
                if (evs[i].length === 2) {
                    ch = undefined;
                    ev = evs[i][1];
                } else if (evs[i].length === 3) {
                    ch = evs[i][1];
                    ev = evs[i][2];
                }
                el.off(ev, ch);
            }
        },
        _buildEvents: function() {
            var events = {
                keyup: $.proxy(function(e) {
                    if ($.inArray(e.keyCode, [
                        27,
                        37,
                        39,
                        38,
                        40,
                        32,
                        13,
                        9
                    ]) === -1) this.update();
                }, this),
                keydown: $.proxy(this.keydown, this),
                paste: $.proxy(this.paste, this)
            };
            if (this.o.showOnFocus === true) events.focus = $.proxy(this.show, this);
            if (this.isInput) this._events = [
                [
                    this.element,
                    events
                ]
            ];
            else if (this.component && this.inputField.length) this._events = [
                // For components that are not readonly, allow keyboard nav
                [
                    this.inputField,
                    events
                ],
                [
                    this.component,
                    {
                        click: $.proxy(this.show, this)
                    }
                ]
            ];
            else this._events = [
                [
                    this.element,
                    {
                        click: $.proxy(this.show, this),
                        keydown: $.proxy(this.keydown, this)
                    }
                ]
            ];
            this._events.push(// Component: listen for blur on element descendants
            [
                this.element,
                "*",
                {
                    blur: $.proxy(function(e) {
                        this._focused_from = e.target;
                    }, this)
                }
            ], // Input: listen for blur on element
            [
                this.element,
                {
                    blur: $.proxy(function(e) {
                        this._focused_from = e.target;
                    }, this)
                }
            ]);
            if (this.o.immediateUpdates) // Trigger input updates immediately on changed year/month
            this._events.push([
                this.element,
                {
                    "changeYear changeMonth": $.proxy(function(e) {
                        this.update(e.date);
                    }, this)
                }
            ]);
            this._secondaryEvents = [
                [
                    this.picker,
                    {
                        click: $.proxy(this.click, this)
                    }
                ],
                [
                    this.picker,
                    ".prev, .next",
                    {
                        click: $.proxy(this.navArrowsClick, this)
                    }
                ],
                [
                    this.picker,
                    ".day:not(.disabled)",
                    {
                        click: $.proxy(this.dayCellClick, this)
                    }
                ],
                [
                    $(window),
                    {
                        resize: $.proxy(this.place, this)
                    }
                ],
                [
                    $(document),
                    {
                        "mousedown touchstart": $.proxy(function(e) {
                            // Clicked outside the datepicker, hide it
                            if (!(this.element.is(e.target) || this.element.find(e.target).length || this.picker.is(e.target) || this.picker.find(e.target).length || this.isInline)) this.hide();
                        }, this)
                    }
                ]
            ];
        },
        _attachEvents: function() {
            this._detachEvents();
            this._applyEvents(this._events);
        },
        _detachEvents: function() {
            this._unapplyEvents(this._events);
        },
        _attachSecondaryEvents: function() {
            this._detachSecondaryEvents();
            this._applyEvents(this._secondaryEvents);
        },
        _detachSecondaryEvents: function() {
            this._unapplyEvents(this._secondaryEvents);
        },
        _trigger: function(event, altdate) {
            var date = altdate || this.dates.get(-1), local_date = this._utc_to_local(date);
            this.element.trigger({
                type: event,
                date: local_date,
                viewMode: this.viewMode,
                dates: $.map(this.dates, this._utc_to_local),
                format: $.proxy(function(ix, format) {
                    if (arguments.length === 0) {
                        ix = this.dates.length - 1;
                        format = this.o.format;
                    } else if (typeof ix === "string") {
                        format = ix;
                        ix = this.dates.length - 1;
                    }
                    format = format || this.o.format;
                    var date = this.dates.get(ix);
                    return DPGlobal.formatDate(date, format, this.o.language);
                }, this)
            });
        },
        show: function() {
            if (this.inputField.is(":disabled") || this.inputField.prop("readonly") && this.o.enableOnReadonly === false) return;
            if (!this.isInline) this.picker.appendTo(this.o.container);
            this.place();
            this.picker.show();
            this._attachSecondaryEvents();
            this._trigger("show");
            if ((window.navigator.msMaxTouchPoints || "ontouchstart" in document) && this.o.disableTouchKeyboard) $(this.element).blur();
            return this;
        },
        hide: function() {
            if (this.isInline || !this.picker.is(":visible")) return this;
            this.focusDate = null;
            this.picker.hide().detach();
            this._detachSecondaryEvents();
            this.setViewMode(this.o.startView);
            if (this.o.forceParse && this.inputField.val()) this.setValue();
            this._trigger("hide");
            return this;
        },
        destroy: function() {
            this.hide();
            this._detachEvents();
            this._detachSecondaryEvents();
            this.picker.remove();
            delete this.element.data().datepicker;
            if (!this.isInput) delete this.element.data().date;
            return this;
        },
        paste: function(e) {
            var dateString;
            if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.types && $.inArray("text/plain", e.originalEvent.clipboardData.types) !== -1) dateString = e.originalEvent.clipboardData.getData("text/plain");
            else if (window.clipboardData) dateString = window.clipboardData.getData("Text");
            else return;
            this.setDate(dateString);
            this.update();
            e.preventDefault();
        },
        _utc_to_local: function(utc) {
            if (!utc) return utc;
            var local = new Date(utc.getTime() + utc.getTimezoneOffset() * 60000);
            if (local.getTimezoneOffset() !== utc.getTimezoneOffset()) local = new Date(utc.getTime() + local.getTimezoneOffset() * 60000);
            return local;
        },
        _local_to_utc: function(local) {
            return local && new Date(local.getTime() - local.getTimezoneOffset() * 60000);
        },
        _zero_time: function(local) {
            return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
        },
        _zero_utc_time: function(utc) {
            return utc && UTCDate(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
        },
        getDates: function() {
            return $.map(this.dates, this._utc_to_local);
        },
        getUTCDates: function() {
            return $.map(this.dates, function(d) {
                return new Date(d);
            });
        },
        getDate: function() {
            return this._utc_to_local(this.getUTCDate());
        },
        getUTCDate: function() {
            var selected_date = this.dates.get(-1);
            if (selected_date !== undefined) return new Date(selected_date);
            else return null;
        },
        clearDates: function() {
            this.inputField.val("");
            this._trigger("changeDate");
            this.update();
            if (this.o.autoclose) this.hide();
        },
        setDates: function() {
            var args = Array.isArray(arguments[0]) ? arguments[0] : arguments;
            this.update.apply(this, args);
            this._trigger("changeDate");
            this.setValue();
            return this;
        },
        setUTCDates: function() {
            var args = Array.isArray(arguments[0]) ? arguments[0] : arguments;
            this.setDates.apply(this, $.map(args, this._utc_to_local));
            return this;
        },
        setDate: alias("setDates"),
        setUTCDate: alias("setUTCDates"),
        remove: alias("destroy", "Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead"),
        setValue: function() {
            var formatted = this.getFormattedDate();
            this.inputField.val(formatted);
            return this;
        },
        getFormattedDate: function(format) {
            if (format === undefined) format = this.o.format;
            var lang = this.o.language;
            return $.map(this.dates, function(d) {
                return DPGlobal.formatDate(d, format, lang);
            }).join(this.o.multidateSeparator);
        },
        getStartDate: function() {
            return this.o.startDate;
        },
        setStartDate: function(startDate) {
            this._process_options({
                startDate: startDate
            });
            this.update();
            this.updateNavArrows();
            return this;
        },
        getEndDate: function() {
            return this.o.endDate;
        },
        setEndDate: function(endDate) {
            this._process_options({
                endDate: endDate
            });
            this.update();
            this.updateNavArrows();
            return this;
        },
        setDaysOfWeekDisabled: function(daysOfWeekDisabled) {
            this._process_options({
                daysOfWeekDisabled: daysOfWeekDisabled
            });
            this.update();
            return this;
        },
        setDaysOfWeekHighlighted: function(daysOfWeekHighlighted) {
            this._process_options({
                daysOfWeekHighlighted: daysOfWeekHighlighted
            });
            this.update();
            return this;
        },
        setDatesDisabled: function(datesDisabled) {
            this._process_options({
                datesDisabled: datesDisabled
            });
            this.update();
            return this;
        },
        place: function() {
            if (this.isInline) return this;
            var calendarWidth = this.picker.outerWidth(), calendarHeight = this.picker.outerHeight(), visualPadding = 10, container = $(this.o.container), windowWidth = container.width(), scrollTop = this.o.container === "body" ? $(document).scrollTop() : container.scrollTop(), appendOffset = container.offset();
            var parentsZindex = [
                0
            ];
            this.element.parents().each(function() {
                var itemZIndex = $(this).css("z-index");
                if (itemZIndex !== "auto" && Number(itemZIndex) !== 0) parentsZindex.push(Number(itemZIndex));
            });
            var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;
            var offset = this.component ? this.component.parent().offset() : this.element.offset();
            var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
            var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
            var left = offset.left - appendOffset.left;
            var top = offset.top - appendOffset.top;
            if (this.o.container !== "body") top += scrollTop;
            this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left");
            if (this.o.orientation.x !== "auto") {
                this.picker.addClass("datepicker-orient-" + this.o.orientation.x);
                if (this.o.orientation.x === "right") left -= calendarWidth - width;
            } else {
                if (offset.left < 0) {
                    // component is outside the window on the left side. Move it into visible range
                    this.picker.addClass("datepicker-orient-left");
                    left -= offset.left - visualPadding;
                } else if (left + calendarWidth > windowWidth) {
                    // the calendar passes the widow right edge. Align it to component right side
                    this.picker.addClass("datepicker-orient-right");
                    left += width - calendarWidth;
                } else if (this.o.rtl) // Default to right
                this.picker.addClass("datepicker-orient-right");
                else // Default to left
                this.picker.addClass("datepicker-orient-left");
            }
            // auto y orientation is best-situation: top or bottom, no fudging,
            // decision based on which shows more of the calendar
            var yorient = this.o.orientation.y, top_overflow;
            if (yorient === "auto") {
                top_overflow = -scrollTop + top - calendarHeight;
                yorient = top_overflow < 0 ? "bottom" : "top";
            }
            this.picker.addClass("datepicker-orient-" + yorient);
            if (yorient === "top") top -= calendarHeight + parseInt(this.picker.css("padding-top"));
            else top += height;
            if (this.o.rtl) {
                var right = windowWidth - (left + width);
                this.picker.css({
                    top: top,
                    right: right,
                    zIndex: zIndex
                });
            } else this.picker.css({
                top: top,
                left: left,
                zIndex: zIndex
            });
            return this;
        },
        _allow_update: true,
        update: function() {
            if (!this._allow_update) return this;
            var oldDates = this.dates.copy(), dates = [], fromArgs = false;
            if (arguments.length) {
                $.each(arguments, $.proxy(function(i, date) {
                    if (date instanceof Date) date = this._local_to_utc(date);
                    dates.push(date);
                }, this));
                fromArgs = true;
            } else {
                dates = this.isInput ? this.element.val() : this.element.data("date") || this.inputField.val();
                if (dates && this.o.multidate) dates = dates.split(this.o.multidateSeparator);
                else dates = [
                    dates
                ];
                delete this.element.data().date;
            }
            dates = $.map(dates, $.proxy(function(date) {
                return DPGlobal.parseDate(date, this.o.format, this.o.language, this.o.assumeNearbyYear);
            }, this));
            dates = $.grep(dates, $.proxy(function(date) {
                return !this.dateWithinRange(date) || !date;
            }, this), true);
            this.dates.replace(dates);
            if (this.o.updateViewDate) {
                if (this.dates.length) this.viewDate = new Date(this.dates.get(-1));
                else if (this.viewDate < this.o.startDate) this.viewDate = new Date(this.o.startDate);
                else if (this.viewDate > this.o.endDate) this.viewDate = new Date(this.o.endDate);
                else this.viewDate = this.o.defaultViewDate;
            }
            if (fromArgs) {
                // setting date by clicking
                this.setValue();
                this.element.change();
            } else if (this.dates.length) // setting date by typing
            {
                if (String(oldDates) !== String(this.dates) && fromArgs) {
                    this._trigger("changeDate");
                    this.element.change();
                }
            }
            if (!this.dates.length && oldDates.length) {
                this._trigger("clearDate");
                this.element.change();
            }
            this.fill();
            return this;
        },
        fillDow: function() {
            if (this.o.showWeekDays) {
                var dowCnt = this.o.weekStart, html = "<tr>";
                if (this.o.calendarWeeks) html += '<th class="cw">&#160;</th>';
                while(dowCnt < this.o.weekStart + 7){
                    html += '<th class="dow';
                    if ($.inArray(dowCnt, this.o.daysOfWeekDisabled) !== -1) html += " disabled";
                    html += '">' + dates[this.o.language].daysMin[dowCnt++ % 7] + "</th>";
                }
                html += "</tr>";
                this.picker.find(".datepicker-days thead").append(html);
            }
        },
        fillMonths: function() {
            var localDate = this._utc_to_local(this.viewDate);
            var html = "";
            var focused;
            for(var i = 0; i < 12; i++){
                focused = localDate && localDate.getMonth() === i ? " focused" : "";
                html += '<span class="month' + focused + '">' + dates[this.o.language].monthsShort[i] + "</span>";
            }
            this.picker.find(".datepicker-months td").html(html);
        },
        setRange: function(range) {
            if (!range || !range.length) delete this.range;
            else this.range = $.map(range, function(d) {
                return d.valueOf();
            });
            this.fill();
        },
        getClassNames: function(date) {
            var cls = [], year = this.viewDate.getUTCFullYear(), month = this.viewDate.getUTCMonth(), today = UTCToday();
            if (date.getUTCFullYear() < year || date.getUTCFullYear() === year && date.getUTCMonth() < month) cls.push("old");
            else if (date.getUTCFullYear() > year || date.getUTCFullYear() === year && date.getUTCMonth() > month) cls.push("new");
            if (this.focusDate && date.valueOf() === this.focusDate.valueOf()) cls.push("focused");
            // Compare internal UTC date with UTC today, not local today
            if (this.o.todayHighlight && isUTCEquals(date, today)) cls.push("today");
            if (this.dates.contains(date) !== -1) cls.push("active");
            if (!this.dateWithinRange(date)) cls.push("disabled");
            if (this.dateIsDisabled(date)) cls.push("disabled", "disabled-date");
            if ($.inArray(date.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1) cls.push("highlighted");
            if (this.range) {
                if (date > this.range[0] && date < this.range[this.range.length - 1]) cls.push("range");
                if ($.inArray(date.valueOf(), this.range) !== -1) cls.push("selected");
                if (date.valueOf() === this.range[0]) cls.push("range-start");
                if (date.valueOf() === this.range[this.range.length - 1]) cls.push("range-end");
            }
            return cls;
        },
        _fill_yearsView: function(selector, cssClass, factor, year, startYear, endYear, beforeFn) {
            var html = "";
            var step = factor / 10;
            var view = this.picker.find(selector);
            var startVal = Math.floor(year / factor) * factor;
            var endVal = startVal + step * 9;
            var focusedVal = Math.floor(this.viewDate.getFullYear() / step) * step;
            var selected = $.map(this.dates, function(d) {
                return Math.floor(d.getUTCFullYear() / step) * step;
            });
            var classes, tooltip, before;
            for(var currVal = startVal - step; currVal <= endVal + step; currVal += step){
                classes = [
                    cssClass
                ];
                tooltip = null;
                if (currVal === startVal - step) classes.push("old");
                else if (currVal === endVal + step) classes.push("new");
                if ($.inArray(currVal, selected) !== -1) classes.push("active");
                if (currVal < startYear || currVal > endYear) classes.push("disabled");
                if (currVal === focusedVal) classes.push("focused");
                if (beforeFn !== $.noop) {
                    before = beforeFn(new Date(currVal, 0, 1));
                    if (before === undefined) before = {};
                    else if (typeof before === "boolean") before = {
                        enabled: before
                    };
                    else if (typeof before === "string") before = {
                        classes: before
                    };
                    if (before.enabled === false) classes.push("disabled");
                    if (before.classes) classes = classes.concat(before.classes.split(/\s+/));
                    if (before.tooltip) tooltip = before.tooltip;
                }
                html += '<span class="' + classes.join(" ") + '"' + (tooltip ? ' title="' + tooltip + '"' : "") + ">" + currVal + "</span>";
            }
            view.find(".datepicker-switch").text(startVal + "-" + endVal);
            view.find("td").html(html);
        },
        fill: function() {
            var d = new Date(this.viewDate), year = d.getUTCFullYear(), month = d.getUTCMonth(), startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity, startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity, endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity, endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity, todaytxt = dates[this.o.language].today || dates["en"].today || "", cleartxt = dates[this.o.language].clear || dates["en"].clear || "", titleFormat = dates[this.o.language].titleFormat || dates["en"].titleFormat, todayDate = UTCToday(), titleBtnVisible = (this.o.todayBtn === true || this.o.todayBtn === "linked") && todayDate >= this.o.startDate && todayDate <= this.o.endDate && !this.weekOfDateIsDisabled(todayDate), tooltip, before;
            if (isNaN(year) || isNaN(month)) return;
            this.picker.find(".datepicker-days .datepicker-switch").text(DPGlobal.formatDate(d, titleFormat, this.o.language));
            this.picker.find("tfoot .today").text(todaytxt).css("display", titleBtnVisible ? "table-cell" : "none");
            this.picker.find("tfoot .clear").text(cleartxt).css("display", this.o.clearBtn === true ? "table-cell" : "none");
            this.picker.find("thead .datepicker-title").text(this.o.title).css("display", typeof this.o.title === "string" && this.o.title !== "" ? "table-cell" : "none");
            this.updateNavArrows();
            this.fillMonths();
            var prevMonth = UTCDate(year, month, 0), day = prevMonth.getUTCDate();
            prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7) % 7);
            var nextMonth = new Date(prevMonth);
            if (prevMonth.getUTCFullYear() < 100) nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
            nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
            nextMonth = nextMonth.valueOf();
            var html = [];
            var weekDay, clsName;
            while(prevMonth.valueOf() < nextMonth){
                weekDay = prevMonth.getUTCDay();
                if (weekDay === this.o.weekStart) {
                    html.push("<tr>");
                    if (this.o.calendarWeeks) {
                        // ISO 8601: First week contains first thursday.
                        // ISO also states week starts on Monday, but we can be more abstract here.
                        var // Start of current week: based on weekstart/current date
                        ws = new Date(+prevMonth + (this.o.weekStart - weekDay - 7) % 7 * 864e5), // Thursday of this week
                        th = new Date(Number(ws) + (11 - ws.getUTCDay()) % 7 * 864e5), // First Thursday of year, year from thursday
                        yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (11 - yth.getUTCDay()) % 7 * 864e5), // Calendar week: ms between thursdays, div ms per day, div 7 days
                        calWeek = (th - yth) / 864e5 / 7 + 1;
                        html.push('<td class="cw">' + calWeek + "</td>");
                    }
                }
                clsName = this.getClassNames(prevMonth);
                clsName.push("day");
                var content = prevMonth.getUTCDate();
                if (this.o.beforeShowDay !== $.noop) {
                    before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
                    if (before === undefined) before = {};
                    else if (typeof before === "boolean") before = {
                        enabled: before
                    };
                    else if (typeof before === "string") before = {
                        classes: before
                    };
                    if (before.enabled === false) clsName.push("disabled");
                    if (before.classes) clsName = clsName.concat(before.classes.split(/\s+/));
                    if (before.tooltip) tooltip = before.tooltip;
                    if (before.content) content = before.content;
                }
                //Check if uniqueSort exists (supported by jquery >=1.12 and >=2.2)
                //Fallback to unique function for older jquery versions
                if (typeof $.uniqueSort === "function") clsName = $.uniqueSort(clsName);
                else clsName = $.unique(clsName);
                html.push('<td class="' + clsName.join(" ") + '"' + (tooltip ? ' title="' + tooltip + '"' : "") + ' data-date="' + prevMonth.getTime().toString() + '">' + content + "</td>");
                tooltip = null;
                if (weekDay === this.o.weekEnd) html.push("</tr>");
                prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
            }
            this.picker.find(".datepicker-days tbody").html(html.join(""));
            var monthsTitle = dates[this.o.language].monthsTitle || dates["en"].monthsTitle || "Months";
            var months = this.picker.find(".datepicker-months").find(".datepicker-switch").text(this.o.maxViewMode < 2 ? monthsTitle : year).end().find("tbody span").removeClass("active");
            $.each(this.dates, function(i, d) {
                if (d.getUTCFullYear() === year) months.eq(d.getUTCMonth()).addClass("active");
            });
            if (year < startYear || year > endYear) months.addClass("disabled");
            if (year === startYear) months.slice(0, startMonth).addClass("disabled");
            if (year === endYear) months.slice(endMonth + 1).addClass("disabled");
            if (this.o.beforeShowMonth !== $.noop) {
                var that = this;
                $.each(months, function(i, month) {
                    var moDate = new Date(year, i, 1);
                    var before = that.o.beforeShowMonth(moDate);
                    if (before === undefined) before = {};
                    else if (typeof before === "boolean") before = {
                        enabled: before
                    };
                    else if (typeof before === "string") before = {
                        classes: before
                    };
                    if (before.enabled === false && !$(month).hasClass("disabled")) $(month).addClass("disabled");
                    if (before.classes) $(month).addClass(before.classes);
                    if (before.tooltip) $(month).prop("title", before.tooltip);
                });
            }
            // Generating decade/years picker
            this._fill_yearsView(".datepicker-years", "year", 10, year, startYear, endYear, this.o.beforeShowYear);
            // Generating century/decades picker
            this._fill_yearsView(".datepicker-decades", "decade", 100, year, startYear, endYear, this.o.beforeShowDecade);
            // Generating millennium/centuries picker
            this._fill_yearsView(".datepicker-centuries", "century", 1000, year, startYear, endYear, this.o.beforeShowCentury);
        },
        updateNavArrows: function() {
            if (!this._allow_update) return;
            var d = new Date(this.viewDate), year = d.getUTCFullYear(), month = d.getUTCMonth(), startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity, startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity, endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity, endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity, prevIsDisabled, nextIsDisabled, factor = 1;
            switch(this.viewMode){
                case 4:
                    factor *= 10;
                /* falls through */ case 3:
                    factor *= 10;
                /* falls through */ case 2:
                    factor *= 10;
                /* falls through */ case 1:
                    prevIsDisabled = Math.floor(year / factor) * factor <= startYear;
                    nextIsDisabled = Math.floor(year / factor) * factor + factor > endYear;
                    break;
                case 0:
                    prevIsDisabled = year <= startYear && month <= startMonth;
                    nextIsDisabled = year >= endYear && month >= endMonth;
                    break;
            }
            this.picker.find(".prev").toggleClass("disabled", prevIsDisabled);
            this.picker.find(".next").toggleClass("disabled", nextIsDisabled);
        },
        click: function(e) {
            e.preventDefault();
            e.stopPropagation();
            var target, dir, day, year, month;
            target = $(e.target);
            // Clicked on the switch
            if (target.hasClass("datepicker-switch") && this.viewMode !== this.o.maxViewMode) this.setViewMode(this.viewMode + 1);
            // Clicked on today button
            if (target.hasClass("today") && !target.hasClass("day")) {
                this.setViewMode(0);
                this._setDate(UTCToday(), this.o.todayBtn === "linked" ? null : "view");
            }
            // Clicked on clear button
            if (target.hasClass("clear")) this.clearDates();
            if (!target.hasClass("disabled")) // Clicked on a month, year, decade, century
            {
                if (target.hasClass("month") || target.hasClass("year") || target.hasClass("decade") || target.hasClass("century")) {
                    this.viewDate.setUTCDate(1);
                    day = 1;
                    if (this.viewMode === 1) {
                        month = target.parent().find("span").index(target);
                        year = this.viewDate.getUTCFullYear();
                        this.viewDate.setUTCMonth(month);
                    } else {
                        month = 0;
                        year = Number(target.text());
                        this.viewDate.setUTCFullYear(year);
                    }
                    this._trigger(DPGlobal.viewModes[this.viewMode - 1].e, this.viewDate);
                    if (this.viewMode === this.o.minViewMode) this._setDate(UTCDate(year, month, day));
                    else {
                        this.setViewMode(this.viewMode - 1);
                        this.fill();
                    }
                }
            }
            if (this.picker.is(":visible") && this._focused_from) this._focused_from.focus();
            delete this._focused_from;
        },
        dayCellClick: function(e) {
            var $target = $(e.currentTarget);
            var timestamp = $target.data("date");
            var date = new Date(timestamp);
            if (this.o.updateViewDate) {
                if (date.getUTCFullYear() !== this.viewDate.getUTCFullYear()) this._trigger("changeYear", this.viewDate);
                if (date.getUTCMonth() !== this.viewDate.getUTCMonth()) this._trigger("changeMonth", this.viewDate);
            }
            this._setDate(date);
        },
        // Clicked on prev or next
        navArrowsClick: function(e) {
            var $target = $(e.currentTarget);
            var dir = $target.hasClass("prev") ? -1 : 1;
            if (this.viewMode !== 0) dir *= DPGlobal.viewModes[this.viewMode].navStep * 12;
            this.viewDate = this.moveMonth(this.viewDate, dir);
            this._trigger(DPGlobal.viewModes[this.viewMode].e, this.viewDate);
            this.fill();
        },
        _toggle_multidate: function(date) {
            var ix = this.dates.contains(date);
            if (!date) this.dates.clear();
            if (ix !== -1) {
                if (this.o.multidate === true || this.o.multidate > 1 || this.o.toggleActive) this.dates.remove(ix);
            } else if (this.o.multidate === false) {
                this.dates.clear();
                this.dates.push(date);
            } else this.dates.push(date);
            if (typeof this.o.multidate === "number") while(this.dates.length > this.o.multidate)this.dates.remove(0);
        },
        _setDate: function(date, which) {
            if (!which || which === "date") this._toggle_multidate(date && new Date(date));
            if (!which && this.o.updateViewDate || which === "view") this.viewDate = date && new Date(date);
            this.fill();
            this.setValue();
            if (!which || which !== "view") this._trigger("changeDate");
            this.inputField.trigger("change");
            if (this.o.autoclose && (!which || which === "date")) this.hide();
        },
        moveDay: function(date, dir) {
            var newDate = new Date(date);
            newDate.setUTCDate(date.getUTCDate() + dir);
            return newDate;
        },
        moveWeek: function(date, dir) {
            return this.moveDay(date, dir * 7);
        },
        moveMonth: function(date, dir) {
            if (!isValidDate(date)) return this.o.defaultViewDate;
            if (!dir) return date;
            var new_date = new Date(date.valueOf()), day = new_date.getUTCDate(), month = new_date.getUTCMonth(), mag = Math.abs(dir), new_month, test;
            dir = dir > 0 ? 1 : -1;
            if (mag === 1) {
                test = dir === -1 ? function() {
                    return new_date.getUTCMonth() === month;
                } : function() {
                    return new_date.getUTCMonth() !== new_month;
                };
                new_month = month + dir;
                new_date.setUTCMonth(new_month);
                // Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
                new_month = (new_month + 12) % 12;
            } else {
                // For magnitudes >1, move one month at a time...
                for(var i = 0; i < mag; i++)// ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
                new_date = this.moveMonth(new_date, dir);
                // ...then reset the day, keeping it in the new month
                new_month = new_date.getUTCMonth();
                new_date.setUTCDate(day);
                test = function() {
                    return new_month !== new_date.getUTCMonth();
                };
            }
            // Common date-resetting loop -- if date is beyond end of month, make it
            // end of month
            while(test()){
                new_date.setUTCDate(--day);
                new_date.setUTCMonth(new_month);
            }
            return new_date;
        },
        moveYear: function(date, dir) {
            return this.moveMonth(date, dir * 12);
        },
        moveAvailableDate: function(date, dir, fn) {
            do {
                date = this[fn](date, dir);
                if (!this.dateWithinRange(date)) return false;
                fn = "moveDay";
            }while (this.dateIsDisabled(date));
            return date;
        },
        weekOfDateIsDisabled: function(date) {
            return $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
        },
        dateIsDisabled: function(date) {
            return this.weekOfDateIsDisabled(date) || $.grep(this.o.datesDisabled, function(d) {
                return isUTCEquals(date, d);
            }).length > 0;
        },
        dateWithinRange: function(date) {
            return date >= this.o.startDate && date <= this.o.endDate;
        },
        keydown: function(e) {
            if (!this.picker.is(":visible")) {
                if (e.keyCode === 40 || e.keyCode === 27) {
                    this.show();
                    e.stopPropagation();
                }
                return;
            }
            var dateChanged = false, dir, newViewDate, focusDate = this.focusDate || this.viewDate;
            switch(e.keyCode){
                case 27:
                    if (this.focusDate) {
                        this.focusDate = null;
                        this.viewDate = this.dates.get(-1) || this.viewDate;
                        this.fill();
                    } else this.hide();
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                case 37:
                case 38:
                case 39:
                case 40:
                    if (!this.o.keyboardNavigation || this.o.daysOfWeekDisabled.length === 7) break;
                    dir = e.keyCode === 37 || e.keyCode === 38 ? -1 : 1;
                    if (this.viewMode === 0) {
                        if (e.ctrlKey) {
                            newViewDate = this.moveAvailableDate(focusDate, dir, "moveYear");
                            if (newViewDate) this._trigger("changeYear", this.viewDate);
                        } else if (e.shiftKey) {
                            newViewDate = this.moveAvailableDate(focusDate, dir, "moveMonth");
                            if (newViewDate) this._trigger("changeMonth", this.viewDate);
                        } else if (e.keyCode === 37 || e.keyCode === 39) newViewDate = this.moveAvailableDate(focusDate, dir, "moveDay");
                        else if (!this.weekOfDateIsDisabled(focusDate)) newViewDate = this.moveAvailableDate(focusDate, dir, "moveWeek");
                    } else if (this.viewMode === 1) {
                        if (e.keyCode === 38 || e.keyCode === 40) dir = dir * 4;
                        newViewDate = this.moveAvailableDate(focusDate, dir, "moveMonth");
                    } else if (this.viewMode === 2) {
                        if (e.keyCode === 38 || e.keyCode === 40) dir = dir * 4;
                        newViewDate = this.moveAvailableDate(focusDate, dir, "moveYear");
                    }
                    if (newViewDate) {
                        this.focusDate = this.viewDate = newViewDate;
                        this.setValue();
                        this.fill();
                        e.preventDefault();
                    }
                    break;
                case 13:
                    if (!this.o.forceParse) break;
                    focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
                    if (this.o.keyboardNavigation) {
                        this._toggle_multidate(focusDate);
                        dateChanged = true;
                    }
                    this.focusDate = null;
                    this.viewDate = this.dates.get(-1) || this.viewDate;
                    this.setValue();
                    this.fill();
                    if (this.picker.is(":visible")) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (this.o.autoclose) this.hide();
                    }
                    break;
                case 9:
                    this.focusDate = null;
                    this.viewDate = this.dates.get(-1) || this.viewDate;
                    this.fill();
                    this.hide();
                    break;
            }
            if (dateChanged) {
                if (this.dates.length) this._trigger("changeDate");
                else this._trigger("clearDate");
                this.inputField.trigger("change");
            }
        },
        setViewMode: function(viewMode) {
            this.viewMode = viewMode;
            this.picker.children("div").hide().filter(".datepicker-" + DPGlobal.viewModes[this.viewMode].clsName).show();
            this.updateNavArrows();
            this._trigger("changeViewMode", new Date(this.viewDate));
        }
    };
    var DateRangePicker = function(element, options) {
        $.data(element, "datepicker", this);
        this.element = $(element);
        this.inputs = $.map(options.inputs, function(i) {
            return i.jquery ? i[0] : i;
        });
        delete options.inputs;
        this.keepEmptyValues = options.keepEmptyValues;
        delete options.keepEmptyValues;
        datepickerPlugin.call($(this.inputs), options).on("changeDate", $.proxy(this.dateUpdated, this));
        this.pickers = $.map(this.inputs, function(i) {
            return $.data(i, "datepicker");
        });
        this.updateDates();
    };
    DateRangePicker.prototype = {
        updateDates: function() {
            this.dates = $.map(this.pickers, function(i) {
                return i.getUTCDate();
            });
            this.updateRanges();
        },
        updateRanges: function() {
            var range = $.map(this.dates, function(d) {
                return d.valueOf();
            });
            $.each(this.pickers, function(i, p) {
                p.setRange(range);
            });
        },
        clearDates: function() {
            $.each(this.pickers, function(i, p) {
                p.clearDates();
            });
        },
        dateUpdated: function(e) {
            // `this.updating` is a workaround for preventing infinite recursion
            // between `changeDate` triggering and `setUTCDate` calling.  Until
            // there is a better mechanism.
            if (this.updating) return;
            this.updating = true;
            var dp = $.data(e.target, "datepicker");
            if (dp === undefined) return;
            var new_date = dp.getUTCDate(), keep_empty_values = this.keepEmptyValues, i = $.inArray(e.target, this.inputs), j = i - 1, k = i + 1, l = this.inputs.length;
            if (i === -1) return;
            $.each(this.pickers, function(i, p) {
                if (!p.getUTCDate() && (p === dp || !keep_empty_values)) p.setUTCDate(new_date);
            });
            if (new_date < this.dates[j]) // Date being moved earlier/left
            while(j >= 0 && new_date < this.dates[j] && (this.pickers[j].element.val() || "").length > 0)this.pickers[j--].setUTCDate(new_date);
            else if (new_date > this.dates[k]) // Date being moved later/right
            while(k < l && new_date > this.dates[k] && (this.pickers[k].element.val() || "").length > 0)this.pickers[k++].setUTCDate(new_date);
            this.updateDates();
            delete this.updating;
        },
        destroy: function() {
            $.map(this.pickers, function(p) {
                p.destroy();
            });
            $(this.inputs).off("changeDate", this.dateUpdated);
            delete this.element.data().datepicker;
        },
        remove: alias("destroy", "Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead")
    };
    function opts_from_el(el, prefix) {
        // Derive options from element data-attrs
        var data = $(el).data(), out = {}, inkey, replace = new RegExp("^" + prefix.toLowerCase() + "([A-Z])");
        prefix = new RegExp("^" + prefix.toLowerCase());
        function re_lower(_, a) {
            return a.toLowerCase();
        }
        for(var key in data)if (prefix.test(key)) {
            inkey = key.replace(replace, re_lower);
            out[inkey] = data[key];
        }
        return out;
    }
    function opts_from_locale(lang) {
        // Derive options from locale plugins
        var out = {};
        // Check if "de-DE" style date is available, if not language should
        // fallback to 2 letter code eg "de"
        if (!dates[lang]) {
            lang = lang.split("-")[0];
            if (!dates[lang]) return;
        }
        var d = dates[lang];
        $.each(locale_opts, function(i, k) {
            if (k in d) out[k] = d[k];
        });
        return out;
    }
    var old = $.fn.datepicker;
    var datepickerPlugin = function(option) {
        var args = Array.apply(null, arguments);
        args.shift();
        var internal_return;
        this.each(function() {
            var $this = $(this), data = $this.data("datepicker"), options = typeof option === "object" && option;
            if (!data) {
                var elopts = opts_from_el(this, "date"), // Preliminary otions
                xopts = $.extend({}, defaults, elopts, options), locopts = opts_from_locale(xopts.language), // Options priority: js args, data-attrs, locales, defaults
                opts = $.extend({}, defaults, locopts, elopts, options);
                if ($this.hasClass("input-daterange") || opts.inputs) {
                    $.extend(opts, {
                        inputs: opts.inputs || $this.find("input").toArray()
                    });
                    data = new DateRangePicker(this, opts);
                } else data = new Datepicker(this, opts);
                $this.data("datepicker", data);
            }
            if (typeof option === "string" && typeof data[option] === "function") internal_return = data[option].apply(data, args);
        });
        if (internal_return === undefined || internal_return instanceof Datepicker || internal_return instanceof DateRangePicker) return this;
        if (this.length > 1) throw new Error("Using only allowed for the collection of a single element (" + option + " function)");
        else return internal_return;
    };
    $.fn.datepicker = datepickerPlugin;
    var defaults = $.fn.datepicker.defaults = {
        assumeNearbyYear: false,
        autoclose: false,
        beforeShowDay: $.noop,
        beforeShowMonth: $.noop,
        beforeShowYear: $.noop,
        beforeShowDecade: $.noop,
        beforeShowCentury: $.noop,
        calendarWeeks: false,
        clearBtn: false,
        toggleActive: false,
        daysOfWeekDisabled: [],
        daysOfWeekHighlighted: [],
        datesDisabled: [],
        endDate: Infinity,
        forceParse: true,
        format: "mm/dd/yyyy",
        isInline: null,
        keepEmptyValues: false,
        keyboardNavigation: true,
        language: "en",
        minViewMode: 0,
        maxViewMode: 4,
        multidate: false,
        multidateSeparator: ",",
        orientation: "auto",
        rtl: false,
        startDate: -Infinity,
        startView: 0,
        todayBtn: false,
        todayHighlight: false,
        updateViewDate: true,
        weekStart: 0,
        disableTouchKeyboard: false,
        enableOnReadonly: true,
        showOnFocus: true,
        zIndexOffset: 10,
        container: "body",
        immediateUpdates: false,
        title: "",
        templates: {
            leftArrow: "&#x00AB;",
            rightArrow: "&#x00BB;"
        },
        showWeekDays: true
    };
    var locale_opts = $.fn.datepicker.locale_opts = [
        "format",
        "rtl",
        "weekStart"
    ];
    $.fn.datepicker.Constructor = Datepicker;
    var dates = $.fn.datepicker.dates = {
        en: {
            days: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            daysShort: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            daysMin: [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            months: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            monthsShort: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            today: "Today",
            clear: "Clear",
            titleFormat: "MM yyyy"
        }
    };
    var DPGlobal = {
        viewModes: [
            {
                names: [
                    "days",
                    "month"
                ],
                clsName: "days",
                e: "changeMonth"
            },
            {
                names: [
                    "months",
                    "year"
                ],
                clsName: "months",
                e: "changeYear",
                navStep: 1
            },
            {
                names: [
                    "years",
                    "decade"
                ],
                clsName: "years",
                e: "changeDecade",
                navStep: 10
            },
            {
                names: [
                    "decades",
                    "century"
                ],
                clsName: "decades",
                e: "changeCentury",
                navStep: 100
            },
            {
                names: [
                    "centuries",
                    "millennium"
                ],
                clsName: "centuries",
                e: "changeMillennium",
                navStep: 1000
            }
        ],
        validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
        nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
        parseFormat: function(format) {
            if (typeof format.toValue === "function" && typeof format.toDisplay === "function") return format;
            // IE treats \0 as a string end in inputs (truncating the value),
            // so it's a bad format delimiter, anyway
            var separators = format.replace(this.validParts, "\0").split("\0"), parts = format.match(this.validParts);
            if (!separators || !separators.length || !parts || parts.length === 0) throw new Error("Invalid date format.");
            return {
                separators: separators,
                parts: parts
            };
        },
        parseDate: function(date, format, language, assumeNearby) {
            if (!date) return undefined;
            if (date instanceof Date) return date;
            if (typeof format === "string") format = DPGlobal.parseFormat(format);
            if (format.toValue) return format.toValue(date, format, language);
            var fn_map = {
                d: "moveDay",
                m: "moveMonth",
                w: "moveWeek",
                y: "moveYear"
            }, dateAliases = {
                yesterday: "-1d",
                today: "+0d",
                tomorrow: "+1d"
            }, parts, part, dir, i, fn;
            if (date in dateAliases) date = dateAliases[date];
            if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/i.test(date)) {
                parts = date.match(/([\-+]\d+)([dmwy])/gi);
                date = new Date();
                for(i = 0; i < parts.length; i++){
                    part = parts[i].match(/([\-+]\d+)([dmwy])/i);
                    dir = Number(part[1]);
                    fn = fn_map[part[2].toLowerCase()];
                    date = Datepicker.prototype[fn](date, dir);
                }
                return Datepicker.prototype._zero_utc_time(date);
            }
            parts = date && date.match(this.nonpunctuation) || [];
            function applyNearbyYear(year, threshold) {
                if (threshold === true) threshold = 10;
                // if year is 2 digits or less, than the user most likely is trying to get a recent century
                if (year < 100) {
                    year += 2000;
                    // if the new year is more than threshold years in advance, use last century
                    if (year > new Date().getFullYear() + threshold) year -= 100;
                }
                return year;
            }
            var parsed = {}, setters_order = [
                "yyyy",
                "yy",
                "M",
                "MM",
                "m",
                "mm",
                "d",
                "dd"
            ], setters_map = {
                yyyy: function(d, v) {
                    return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
                },
                m: function(d, v) {
                    if (isNaN(d)) return d;
                    v -= 1;
                    while(v < 0)v += 12;
                    v %= 12;
                    d.setUTCMonth(v);
                    while(d.getUTCMonth() !== v)d.setUTCDate(d.getUTCDate() - 1);
                    return d;
                },
                d: function(d, v) {
                    return d.setUTCDate(v);
                }
            }, val, filtered;
            setters_map["yy"] = setters_map["yyyy"];
            setters_map["M"] = setters_map["MM"] = setters_map["mm"] = setters_map["m"];
            setters_map["dd"] = setters_map["d"];
            date = UTCToday();
            var fparts = format.parts.slice();
            // Remove noop parts
            if (parts.length !== fparts.length) fparts = $(fparts).filter(function(i, p) {
                return $.inArray(p, setters_order) !== -1;
            }).toArray();
            // Process remainder
            function match_part() {
                var m = this.slice(0, parts[i].length), p = parts[i].slice(0, m.length);
                return m.toLowerCase() === p.toLowerCase();
            }
            if (parts.length === fparts.length) {
                var cnt;
                for(i = 0, cnt = fparts.length; i < cnt; i++){
                    val = parseInt(parts[i], 10);
                    part = fparts[i];
                    if (isNaN(val)) switch(part){
                        case "MM":
                            filtered = $(dates[language].months).filter(match_part);
                            val = $.inArray(filtered[0], dates[language].months) + 1;
                            break;
                        case "M":
                            filtered = $(dates[language].monthsShort).filter(match_part);
                            val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
                            break;
                    }
                    parsed[part] = val;
                }
                var _date, s;
                for(i = 0; i < setters_order.length; i++){
                    s = setters_order[i];
                    if (s in parsed && !isNaN(parsed[s])) {
                        _date = new Date(date);
                        setters_map[s](_date, parsed[s]);
                        if (!isNaN(_date)) date = _date;
                    }
                }
            }
            return date;
        },
        formatDate: function(date, format, language) {
            if (!date) return "";
            if (typeof format === "string") format = DPGlobal.parseFormat(format);
            if (format.toDisplay) return format.toDisplay(date, format, language);
            var val = {
                d: date.getUTCDate(),
                D: dates[language].daysShort[date.getUTCDay()],
                DD: dates[language].days[date.getUTCDay()],
                m: date.getUTCMonth() + 1,
                M: dates[language].monthsShort[date.getUTCMonth()],
                MM: dates[language].months[date.getUTCMonth()],
                yy: date.getUTCFullYear().toString().substring(2),
                yyyy: date.getUTCFullYear()
            };
            val.dd = (val.d < 10 ? "0" : "") + val.d;
            val.mm = (val.m < 10 ? "0" : "") + val.m;
            date = [];
            var seps = $.extend([], format.separators);
            for(var i = 0, cnt = format.parts.length; i <= cnt; i++){
                if (seps.length) date.push(seps.shift());
                date.push(val[format.parts[i]]);
            }
            return date.join("");
        },
        headTemplate: '<thead><tr><th colspan="7" class="datepicker-title"></th></tr><tr><th class="prev">' + defaults.templates.leftArrow + "</th>" + '<th colspan="5" class="datepicker-switch"></th>' + '<th class="next">' + defaults.templates.rightArrow + "</th>" + "</tr>" + "</thead>",
        contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
        footTemplate: '<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'
    };
    DPGlobal.template = '<div class="datepicker"><div class="datepicker-days"><table class="table-condensed">' + DPGlobal.headTemplate + "<tbody></tbody>" + DPGlobal.footTemplate + "</table>" + "</div>" + '<div class="datepicker-months">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + "</table>" + "</div>" + '<div class="datepicker-years">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + "</table>" + "</div>" + '<div class="datepicker-decades">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + "</table>" + "</div>" + '<div class="datepicker-centuries">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + "</table>" + "</div>" + "</div>";
    $.fn.datepicker.DPGlobal = DPGlobal;
    /* DATEPICKER NO CONFLICT
	* =================== */ $.fn.datepicker.noConflict = function() {
        $.fn.datepicker = old;
        return this;
    };
    /* DATEPICKER VERSION
	 * =================== */ $.fn.datepicker.version = "1.10.0";
    $.fn.datepicker.deprecated = function(msg) {
        var console = window.console;
        if (console && console.warn) console.warn("DEPRECATED: " + msg);
    };
    /* DATEPICKER DATA-API
	* ================== */ $(document).on("focus.datepicker.data-api click.datepicker.data-api", '[data-provide="datepicker"]', function(e) {
        var $this = $(this);
        if ($this.data("datepicker")) return;
        e.preventDefault();
        // component click requires us to explicitly show it
        datepickerPlugin.call($this, "show");
    });
    $(function() {
        datepickerPlugin.call($('[data-provide="datepicker-inline"]'));
    });
});


(function($) {
    $.fn.datepicker.dates["nl"] = {
        days: [
            "zondag",
            "maandag",
            "dinsdag",
            "woensdag",
            "donderdag",
            "vrijdag",
            "zaterdag"
        ],
        daysShort: [
            "zo",
            "ma",
            "di",
            "wo",
            "do",
            "vr",
            "za"
        ],
        daysMin: [
            "zo",
            "ma",
            "di",
            "wo",
            "do",
            "vr",
            "za"
        ],
        months: [
            "januari",
            "februari",
            "maart",
            "april",
            "mei",
            "juni",
            "juli",
            "augustus",
            "september",
            "oktober",
            "november",
            "december"
        ],
        monthsShort: [
            "jan",
            "feb",
            "mrt",
            "apr",
            "mei",
            "jun",
            "jul",
            "aug",
            "sep",
            "okt",
            "nov",
            "dec"
        ],
        today: "Vandaag",
        monthsTitle: "Maanden",
        clear: "Wissen",
        weekStart: 1,
        format: "dd-mm-yyyy"
    };
})(jQuery);


(function($) {
    $.fn.datepicker.dates["en-US"] = {
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        daysShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        daysMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthsShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        today: "Today",
        monthsTitle: "Months",
        clear: "Clear",
        weekStart: 0,
        format: "m/d/yyyy"
    };
})(jQuery);


var $4ee4564850efd542$var$datepicker = {
    settings: {
        date: {
            autoclose: true,
            forceParse: false,
            enableOnReadonly: false,
            format: "dd-mm-yyyy"
        },
        month: {
            autoclose: true,
            forceParse: false,
            enableOnReadonly: false,
            format: "mm-yyyy",
            viewMode: "months",
            minViewMode: "months"
        }
    },
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function() {
        $4ee4564850efd542$var$datepicker.settings.date.language = $4ee4564850efd542$var$datepicker.getLanguage();
        $4ee4564850efd542$var$datepicker.settings.month.language = $4ee4564850efd542$var$datepicker.getLanguage();
        (function($) {
            /** Init basis datepicker */ $(".datepicker").datepicker($4ee4564850efd542$var$datepicker.settings.date);
            /** Init datepicker met alleen jaar en maand */ $(".datepicker-months").datepicker($4ee4564850efd542$var$datepicker.settings.month);
            /** Blur datepicker input as kalender verborgen wordt */ $(".datepicker, .datepicker-months").on("hide", function(event) {
                $(this).trigger("blur");
                let triggerEvent = new Event("blur");
                event.currentTarget?.dispatchEvent(triggerEvent);
            });
            /** Focus op juiste veld als kalender aangeklikt wordt */ $(".input-group-text.fa-calendar").click(function() {
                $(this).closest("input").focus();
                $(this).closest("div").find(".datepicker, .datepicker-months").focus();
            });
            /** Focus op juiste veld als datepicker geopend wordt */ $(".open-datepicker").click(function(e) {
                e.preventDefault();
                $(this).parent().parent().find("input").focus();
            });
        })(jQuery);
    },
    getLanguage () {
        if (typeof window.app.language !== "undefined") return window.app.language.replace("_", "-");
        else return "nl-NL";
    }
};
var $4ee4564850efd542$export$2e2bcd8739ae039 = $4ee4564850efd542$var$datepicker;



var $hzkBE = parcelRequire("hzkBE");

var $hGrZR = parcelRequire("hGrZR");

var $JSMaE = parcelRequire("JSMaE");
/**
 * Valideer de ingevoerde gegevens in een formulier.
 */ var $a60bd1631756ee00$var$validation = {
    /** Functie die required validation toevoegd aan input */ addRequired: function(input) {
        $a60bd1631756ee00$var$validation.internalAddRemoveRequired(input, true);
    },
    /** Functie die de input valideert, foutmelding toont en juiste feedback geeft */ checkInput: async function(input) {
        /** Verkrijg de validatie van dom element */ var validate = $(input).attr("data-validate");
        /** Knip de validaties op voor gebruik per individuele validatie (dus bijvoorbeeld required en email) */ var validateArray = validate.split(" ");
        /** Zet inputFout default op 0 (geen fout) */ var inputFout = 0;
        /** Definieer lege array voor de input settings in functie scope voor later gebruik */ var inputSettings = [];
        /** Verwijder alle validatie css classes van het dom element */ $a60bd1631756ee00$var$validation.removeValidationClasses(input);
        /** Valideer de value met elke aangegeven validatie type */ $.each(validateArray, function(index, typeValidation) {
            /** Definieer validatie type op function niveau */ $a60bd1631756ee00$var$validation.typeValidation = typeValidation;
            /** Als de validation required betreft en de waarde leeg is geef een error */ if ($a60bd1631756ee00$var$validation.typeValidation == "required") {
                if (input.value == "") inputFout = "error";
            }
            /** Definieer de input value */ var value = input.value;
            /** Definieer de input type */ var type = input.type || input.tagName.toLowerCase();
            /** Als de waarde niet leeg is pas dan de gevraagde validator toe */ if (value != "") {
                switch($a60bd1631756ee00$var$validation.typeValidation){
                    case "required":
                        break;
                    case "alphanumeric":
                    case "alphabetic_dot":
                    case "alphabetic_dot_space":
                    case "alphanumeric_dot_space":
                    case "alphabetic_dot_space_add_plus_and":
                    case "alphabetic_dot_space_add_plus_and_minus":
                    case "alphanumeric_minus":
                    case "alphanumeric_dot_space_minus":
                    case "alphanumeric_dot_space_add_plus_and":
                    case "alphanumeric_dot_space_add_plus_and_minus":
                    case "alphanumeric_username":
                    case "alphabetic":
                    case "mustHaveAlphabetic":
                    case "numeric":
                    case "numericNoDecimals":
                    case "csv_only_numeric":
                    case "decimalsAllowedNoChange":
                    case "email":
                    case "daterangeTodayWarning":
                    case "daterangeTodayDanger":
                    case "datemonthyear":
                    case "kvk":
                    case "loonheffingennummer":
                    case "gsm":
                    case "phone":
                    case "mustAgree":
                    case "bsn":
                    case "iban":
                    case "nosemicolon":
                    case "lowercase":
                    case "relatieGebruikersnaam":
                    case "activatieCode":
                    case "betalingskenmerk":
                    case "rsin":
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value);
                        break;
                    case "date":
                        value = (0, $JSMaE.default).nullToEmptyString(value);
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value);
                        break;
                    case "decimalsAllowed":
                    case "negativeDecimalsAllowed":
                    case "decimalsAllowedPipe":
                    case "decimalsRequired":
                    case "negativeDecimalsRequired":
                        value = (0, $JSMaE.default).dotToComma(value);
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value);
                        break;
                    case "postcode":
                        value = (0, $JSMaE.default).removeSpaces(value);
                        value = (0, $JSMaE.default).upperCase(value);
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value);
                        break;
                    case "tel":
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](input);
                        break;
                    case "daterange":
                        inputSettings = [
                            $(input).attr("data-startdate"),
                            $(input).attr("data-enddate")
                        ];
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value, inputSettings);
                        break;
                    case "daterangeNoError":
                        inputSettings = [
                            $(input).attr("data-startdate"),
                            $(input).attr("data-enddate"),
                            "noError"
                        ];
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value, inputSettings);
                        break;
                    case "range":
                        inputSettings = [
                            $(input).attr("data-minvalue"),
                            $(input).attr("data-maxvalue")
                        ];
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value, inputSettings);
                        break;
                    case "maxchar":
                        inputSettings = [
                            $(input).attr("data-maxchar")
                        ];
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value, inputSettings);
                        break;
                    case "minchar":
                        inputSettings = [
                            $(input).attr("data-minchar")
                        ];
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value, inputSettings);
                        break;
                    case "checkbox":
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](input);
                        break;
                    case "password":
                        inputSettings = [
                            $(input).attr("data-password-username-target")
                        ];
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value, inputSettings);
                        break;
                    case "password2":
                        inputSettings = [
                            $("[name=password]").val()
                        ];
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value, inputSettings);
                        break;
                    case "maxFileSize":
                        inputSettings = [
                            $(input).attr("data-maxfilesize"),
                            input.files
                        ];
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](inputSettings);
                        break;
                    case "minFileSizeByte":
                        inputSettings = [
                            $(input).attr("data-minfilesizebyte"),
                            input.files
                        ];
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](inputSettings);
                        break;
                    case "fileExtension":
                        inputSettings = [
                            $(input).attr("data-fileExtension").toLowerCase()
                        ];
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value, inputSettings);
                        break;
                    case "specificValue":
                        let inputSettingsJSON = $(input).attr("data-specific-value");
                        inputSettings = JSON.parse(inputSettingsJSON);
                        inputFout = (0, $hGrZR.default)[$a60bd1631756ee00$var$validation.typeValidation](value, inputSettings);
                        break;
                }
                /** Geef de input de value voor het geval dat deze geformatteerd is  */ if (type != "file" && type != "password") $(input).val(value);
                /** Controleer of het geen geselecteerde option van een select is en zet handmatig een typeValidation tbv het ophalen van de foutmelding */ if (type == "select-one") {
                    var selectedOption = input.options[input.selectedIndex];
                    var disabled = selectedOption.disabled || false;
                    if (disabled) {
                        inputFout = "error";
                        $a60bd1631756ee00$var$validation.typeValidation = "disabledSelectOption";
                    }
                }
            }
            /** Return false als er een error (1) is */ if (inputFout == "error") return false;
        });
        if (inputFout instanceof Promise) inputFout = await inputFout; // Pause until the promise resolves
        /** Formatteer bij errors (1) en warnings (2) de foutmeldingen */ if (inputFout == "error" || inputFout == "warning") {
            var errorLabel = $a60bd1631756ee00$var$validation.errorMsg[window.app.language][$a60bd1631756ee00$var$validation.typeValidation];
            var alternativeErrorLabel = $(input).data("validate-feedback-" + $a60bd1631756ee00$var$validation.typeValidation) || false;
            if (alternativeErrorLabel) errorLabel = alternativeErrorLabel;
            if (inputSettings != null) {
                if (inputSettings[0] != "") errorLabel = errorLabel.replace("#1#", inputSettings[0]);
                if (inputSettings[1] != "") errorLabel = errorLabel.replace("#2#", inputSettings[1]);
            }
            if ($(input).hasClass("inline-editable")) {
                $(input).closest("td").find(".invalid-tooltip").remove();
                $(input).closest("td").append('<div class="invalid-tooltip">' + errorLabel + "</div>");
            } else if ($(input).data("validate").includes("tel")) {
                $(input).closest("div.form-group").find(".invalid-feedback").remove();
                var hideFeedback = $(input).attr("data-validate-hide-feedback") || false;
                if (!hideFeedback) $(input).closest(".input-group").append('<div class="invalid-feedback d-block">' + errorLabel + "</div>");
            } else {
                $(input).closest("div.form-group").find(".invalid-feedback").remove();
                var hideFeedback = $(input).attr("data-validate-hide-feedback") || false;
                if (!hideFeedback) $(input).closest("div").append('<div class="invalid-feedback d-block">' + errorLabel + "</div>");
            }
        } else $(input).closest(".form-group").find(".invalid-feedback").html(errorLabel).addClass("d-none");
        /** Voeg bij een error (1) en een warning (2) de bijbehorende css classes toe aan het element en de form-group */ if (inputFout == "error") {
            $(input).closest(".form-group").addClass("has-error");
            $(input).addClass("is-invalid");
        }
        if (inputFout == "warning") {
            $(input).closest(".form-group").addClass("has-warning");
            $(input).addClass("is-warning");
            inputFout = 0;
        }
        return inputFout;
    },
    /** Functie die input valideert onBlur */ checkInputBlur: function() {
        $a60bd1631756ee00$var$validation.checkInput(this);
    },
    checkSubmitFormFieldsLoop: async function(form) {
        let errorCount = 0;
        var elements = Array.from($(form).find("input[data-validate],select[data-validate],textarea[data-validate]"));
        const result = await Promise.all(elements.map(async function(el) {
            const validationResult = await $a60bd1631756ee00$var$validation.checkInput(el);
            if (validationResult == "error") return 1;
            return 0;
        }));
        result.forEach(function(item) {
            errorCount = errorCount + item;
        });
        return errorCount;
    },
    /** Functie die volledig formulier valideert en foutmelding toont als er validatiefouten gevonden zijn */ checkSubmitForm: async function(form) {
        var aantalFouten = await $a60bd1631756ee00$var$validation.checkSubmitFormFieldsLoop(form);
        if (aantalFouten > 0) {
            if (window.app.language == "en_US") (0, $hzkBE.default)("danger", "Please note:", "We have detected " + aantalFouten + " error(s) in the form. This must be corrected before the form can be submitted.");
            else (0, $hzkBE.default)("danger", "Let op: ", aantalFouten + " fout(en) aangetroffen in het formulier. Deze moet gecorrigeerd worden om het formulier te versturen.");
            return false;
        }
        var event = new CustomEvent("validationSuccess");
        document.dispatchEvent(event);
        return true;
    },
    /** Functie die required verwijderd en toevoegd */ internalAddRemoveRequired: function(input, add) {
        var validate = $(input).attr("data-validate");
        if (typeof validate !== "string") validate = "";
        var validateArray = validate.split(" ").filter(function(value) {
            return value != "required";
        });
        if (add == true) validateArray.unshift("required");
        $(input).attr("data-validate", validateArray.join(" "));
    },
    /** Functie die required verwijderd van input */ removeRequired: function(input) {
        $a60bd1631756ee00$var$validation.internalAddRemoveRequired(input, false);
    },
    /** Functie die eventueel eerder toegepaste validation css classes en foutmeldingen verwijderd */ removeValidationClasses: function(input) {
        $(input).closest(".form-group").removeClass("has-error").removeClass("has-warning");
        $(input).removeClass("is-invalid");
        $(input).closest(".form-group").find(".invalid-feedback").html("");
    },
    /** Functie die gormulier checkt onSubmit */ submitForm: function() {
        return $a60bd1631756ee00$var$validation.checkSubmitForm(this);
    },
    /** Functie die gormulier checkt onSubmit */ submitFormOnEvent: function(e) {
        return $a60bd1631756ee00$var$validation.checkSubmitForm(e.target);
    },
    /** Defineer de foutmeldingen */ errorMsg: {
        nl_NL: {
            "alphabetic": "Dit veld mag alleen letters bevatten",
            "mustHaveAlphabetic": "Dit veld moet een letter bevatten",
            "alphabetic_dot": "Dit veld mag alleen letters en punten bevatten",
            "alphabetic_dot_space": "Dit veld mag alleen letters, punten en spaties bevatten",
            "alphanumeric": "Dit veld mag alleen letters en cijfers bevatten",
            "alphabetic_dot_space_add_plus_and_minus": "Dit veld mag alleen letters, mintekens, punten, spaties en cijfers bevatten",
            "alphanumeric_dot_space_add_plus_and_minus": "Dit veld mag alleen letters, cijfers, mintekens, punten, en spaties bevatten",
            "alphanumeric_minus": "Dit veld mag alleen letters, cijfers en mintekens bevatten",
            "alphanumeric_dot_space_minus": "Dit veld mag alleen letters, mintekens, spaties en cijfers bevatten",
            "alphanumeric_dot_space": "Dit veld mag alleen letters, punten, spaties en cijfers bevatten",
            "alphanumeric_username": "Dit veld mag alleen letters, punten, streepjes, @`s en cijfers bevatten",
            "numeric": "Vul hier een geldig getal in.",
            "numericNoDecimals": "Vul een getal in zonder decimalen.",
            "negativeDecimalsAllowed": "Vul een geldig getal in met max 2 decimalen.",
            "decimalsAllowed": "Vul een geldig getal in met max 2 decimalen.",
            "decimalsAllowedPipe": "Vul hier geldige getal in gescheiden door een |.",
            "decimalsRequired": "Vul hier een geldig getal in met 2 decimalen.",
            "negativeDecimalsRequired": "Vul hier een geldig getal in met 2 decimalen.",
            "required": "Dit is een verplicht veld.",
            "checkbox": "Dit is een verplicht veld.",
            "email": "Vul hier een geldig e-mailadres in.",
            "daterange": "Deze datum valt niet binnen het toegestane bereik (#1# t/m #2#).",
            "daterangeTodayWarning": "De opgegeven ingangsdatum ligt in het verleden. Bij het verwerken van deze aanvraag kan de aanvraag hierop worden afgewezen, of een alternatieve ingangsdatum worden voorgesteld.",
            "daterangeTodayDanger": "De ingangsdatum mag niet in het verleden liggen.",
            "date": "Vul hier een geldige datum in (ISO-formaat).",
            "datemonthyear": "Vul hier een maand en jaar in (00-0000)",
            "disabledSelectOption": "De geselecteerde optie is niet toegestaan",
            "kvk": "Vul een geldig KVK-nummer in",
            "loonheffingennummer": "Vul een geldig loonheffingennummer in",
            "range": "Dit getal valt niet binnen het toegestane bereik (#1# t/m #2#).",
            "postcode": "Vul hier een geldige postcode in.",
            "phone": "Vul hier een geldig telefoonnummer in .",
            "gsm": "Vul hier een geldig gsm nummer in.",
            "maxchar": "Maximaal aantal karakters overschreden.",
            "minchar": "Vul het minimaal aantal gevraagde karakters in.",
            "mustAgree": "U moet hiermee akkoord gaan.",
            "password": "Uw wachtwoord of de combinatie van het wachtwoord met uw gebruikersnaam voldoet niet aan de gestelde eisen",
            "password2": "Wachtwoorden komen niet overeen.",
            "bsn": "Het bsn nummer voldoet niet aan de elf proef.",
            "maxFileSize": "Het bestand is groter dan toegestaan.",
            "fileExtension": "Niet toegestaan bestandstype. Toegestane bestandstypen: #1#.",
            "specificValue": 'Deze vraag dient u met "#2#" te beantwoorden',
            "iban": "De ingevoerde IBAN is niet correct",
            "nosemicolon": "Dit veld mag geen puntkomma bevatten",
            "betalingskenmerk": "Betalingskenmerk voldoet niet aan voorwaarden",
            "lowercase": "Dit veld mag geen hoofdletters bevatten",
            "activatieCode": "De activatiecode is incorrect. Een activatiecode heeft deze opbouw: 'a1234' (geen hoofdletters)",
            "relatieGebruikersnaam": "De gebruikersnaam is incorrect. En gebruikersnaam heeft deze opbouw: 'W1234-123' (alleen hoofdletters)",
            "rsin": "Vul een geldig RSIN-nummer in",
            "tel": "Het telefoonnummer dat u heeft ingevoerd is ongeldig"
        },
        en_US: {
            "alphabetic": "This field can contain only alphabetic characters",
            "mustHaveAlphabetic": "This field must contain at least one alphabetic characters",
            "alphabetic_dot": "This field can contain only alphabetic characters and dots",
            "alphabetic_dot_space": "This field can contain only alphabetic characters, dots and spaces",
            "alphanumeric": "This field should only contain alphabetic characters and numbers",
            "alphabetic_dot_space_add_plus_and_minus": "This field should only contain alphabetic characters, spaces and numbers",
            "alphanumeric_dot_space_add_plus_and_minus": "This field should only contain alphabetic characters, numbers, minus, points, spaces and numbers",
            "alphanumeric_minus": "This field should only contain alphabetic characters, numers or minus signs",
            "alphanumeric_dot_space_minus": "This field should only contain alphabetic characters, minus, points, spaces and numbers",
            "alphanumeric_dot_space": "This field should only contain alphabetic characters, spaces and numbers",
            "alphanumeric_username": "This field should only contain alphabetic characters, dots, dashes, add and numbers",
            "numeric": "Please enter a valid number.",
            "numericNoDecimals": "Please enter a valid number.",
            "negativeDecimalsAllowed": "Please enter a valid number with max 2 decimals.",
            "decimalsAllowed": "Please enter a valid number with max 2 decimals.",
            "decimalsAllowedPipe": "Please enter a valid number divided by a |.",
            "decimalsRequired": "Please enter a valid number with 2 decimals.",
            "negativeDecimalsRequired": "Please enter a valid number with 2 decimals.",
            "required": "This value is required.",
            "checkbox": "This value is required.",
            "email": "Please enter a valid e-mail address.",
            "daterange": "The given date is not within the allowed range (#1# untill #2#).",
            "daterangeTodayWarning": "The given date is in the past. When processing this application, the application may be rejected based on this date, or an alternative date may be suggested.",
            "daterangeTodayDanger": "The given date should not be in the past.",
            "date": "Please enter a valid date (ISO-format).",
            "datemonthyear": "Please enter a month and a year (00-0000)",
            "disabledSelectOption": "The selected option is not allowed",
            "kvk": "Enter a valid CoC number",
            "loonheffingennummer": "Enter a valid payroll tax number",
            "range": "This number is not within the allowed range (#1# untill #2#).",
            "postcode": "Please enter a valid postal code.",
            "phone": "Please enter a valid phone number.",
            "gsm": "Please enter a valid mobile phone number.",
            "maxchar": "The maximum allowed characters has been reached.",
            "minchar": "Please enter the requested number of characters.",
            "mustAgree": "You must agree with this statement.",
            "password": "Your password or the combination of the password with your username does not meet the requirements.",
            "password2": "Passwords don`t match.",
            "bsn": "This BSN number does not validate.",
            "maxFileSize": "The size of this file is to large.",
            "fileExtension": "This file extension is not #1#.",
            "specificValue": 'This question should be answered with "#2#"',
            "iban": "The IBAN you entered is not correct",
            "nosemicolon": "This field should not contain a semicolon",
            "betalingskenmerk": "Payment reference code does not have the correct format",
            "lowercase": "This field should not contain capital letters",
            "activatieCode": "This is not a valid activation code. And activation code has the following structure: A1234",
            "relatieGebruikersnaam": "This is not a valid username. And username has the following structure: A1234-123",
            "rsin": "Enter a valid RSIN number",
            "tel": "The phone number you entered is not valid."
        }
    }
};
var $a60bd1631756ee00$export$2e2bcd8739ae039 = $a60bd1631756ee00$var$validation;


var $cbba02f95b4e7e13$var$formValidation = {
    /**
   * Initializes the form validation process.
   *
   * It starts the process by first initializing the 'blur' event for the input elements within
   * forms that require validation using the 'initBlurEvent' method of the 'formValidation' object.
   * It then initializes the 'submit' event for forms that require validation using
   * the 'initSubmitEvent' method of the 'formValidation' object.
   *
   * @function init
   * @returns {void}
   */ init: function(target) {
        $cbba02f95b4e7e13$var$formValidation.initBlurEvent(target);
        $cbba02f95b4e7e13$var$formValidation.initSubmitEvent(target);
    },
    /**
   * Initializes the 'blur' event for input elements within forms that require validation.
   *
   * It targets form elements that have a 'data-validate' attribute within the body element.
   * It then specifies which input elements need to be validated, i.e., 'input[data-validate]',
   * 'select[data-validate]', 'textarea[data-validate]'.
   *
   * For each input type within each form that needs to be validated, it attaches a 'blur' event listener.
   * On triggering the 'blur' event, it checks if the event target is one of the specified inputs.
   * If it's not, the event is ignored; if it is, the 'checkInput' method of the 'validation' object is called.
   *
   * @function initBlurEvent
   * @returns {void}
   */ initBlurEvent: function(target) {
        var forms = target.querySelectorAll("body form[data-validate]");
        var inputs = [
            "input[data-validate]",
            "select[data-validate]",
            "textarea[data-validate]"
        ];
        inputs.forEach(function(input) {
            forms.forEach(function(form) {
                form.addEventListener("blur", function(event) {
                    if (!event.target.matches(input)) return;
                    (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInput(event.target);
                }, true);
            });
        });
    },
    /**
   * Initializes the 'submit' event for each form that requires validation.
   *
   * The function first selects all form elements with a 'data-validate' attribute within the body.
   * It then adds a 'submit' event listener to each of these forms.
   *
   * On the 'submit' event, it checks the 'data-validate-onsubmit-disabled' attribute of the event target.
   * If this attribute value is not 'true', the 'submitFormOnEvent' method of the 'validation' object is called.
   * If the returned value is false, it prevents the form from being submitted by using 'e.preventDefault()'.
   *
   * The event listener is set to capture events during the capturing phase (indicated by the 'true' parameter).
   *
   * @function initSubmitEvent
   * @returns {void}
   */ initSubmitEvent: function(target) {
        var forms = target.querySelectorAll("body form[data-validate]");
        forms.forEach(function(form) {
            form.addEventListener("submit", async function(e) {
                e.preventDefault();
                var noSubmit = e.target.getAttribute("data-validate-onsubmit-disabled") || false;
                if (noSubmit !== "true") {
                    let validated = await (0, $a60bd1631756ee00$export$2e2bcd8739ae039).submitFormOnEvent(e);
                    if (!validated) return;
                    form.submit();
                }
            }, true);
        });
    }
};
var $cbba02f95b4e7e13$export$2e2bcd8739ae039 = $cbba02f95b4e7e13$var$formValidation;



var $7FBkt = parcelRequire("7FBkt");
const $f8a311d146402a10$var$aTable = {
    data: null,
    lastChecked: null,
    cookieName: "atable-list-col-v2",
    /**
   * Initialiseer de aTable
   *
   * @param {object} target
   *
   * @returns {void}
   */ init: function(target) {
        const tableElement = target.querySelector("[data-atable]");
        if (typeof tableElement !== "undefined" && tableElement !== null) {
            const table = $(tableElement);
            var loaded = table.prop("atable-loaded");
            if (typeof loaded === "undefined") table.prop("atable-loaded", true);
            $f8a311d146402a10$var$aTable.initSort(table);
            $f8a311d146402a10$var$aTable.initEvents(table);
            $f8a311d146402a10$var$aTable.initListLength(table);
            $f8a311d146402a10$var$aTable.initColumnsToggle(table);
            $f8a311d146402a10$var$aTable.initLength(table);
            $f8a311d146402a10$var$aTable.load(table);
            $f8a311d146402a10$var$aTable.initSearch(table);
        }
    },
    /**
   * Initialiseer de sortering
   * Definieer default sortering, zoek naar een eventuele voorkeurssortering en pas sortering toe
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ initSort: function(table) {
        // Definieer default sortering en volgorde
        var sort = 1;
        var order = "asc";
        // Verkrijg eventuele voorkeurssortering uit kolommen
        var col = table.find("th[data-aitem-default-sorting]").first();
        if (col.length) {
            sort = col.index();
            order = col.data("aitem-default-sorting");
        }
        // Pas de sortering toe
        table.data("sort", sort);
        table.data("order", order);
    },
    /**
   * Initialiseer de event handlers
   * Definieer DOM basis element en bind click handler aan gewenste elementen
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ initEvents: function(table) {
        // Click handler base element
        var base = $(document.body).find(table.closest("[data-atable-container]"));
        // Paginering events
        base.on("click", "[data-atable-pagination-link]", function(event) {
            event.preventDefault();
            $f8a311d146402a10$var$aTable.page(event, table);
        });
        // Sorterings events
        base.on("click", "[data-atable-column-sorting]", function(event) {
            $f8a311d146402a10$var$aTable.sort(event, table);
        });
        // Zoek events
        base.on("click", "[data-atable-header-toolbar-searchbutton]", function() {
            $f8a311d146402a10$var$aTable.search(table);
        });
        // Zoek reset events
        base.on("click", "[data-atable-header-toolbar-resetButton]", function() {
            $f8a311d146402a10$var$aTable.searchReset(table);
        });
        // Zoek header toolbar events
        base.on("click", "[data-atable-header-filter-search-button]", function() {
            $f8a311d146402a10$var$aTable.reload(table);
        });
        // Download events
        base.on("click", "[data-atable-header-toolbar-downloadbutton]", function() {
            $f8a311d146402a10$var$aTable.download(table);
        });
        // Modal events
        base.on("click", ".showListingModal, [data-atable-toggle-listing-modal]", function(event) {
            event.preventDefault();
            $f8a311d146402a10$var$aTable.getModal(event, table);
        });
        // List events
        base.on("click", "[data-atable-list-title-container], [data-atable-list-summary]", function(event) {
            $f8a311d146402a10$var$aTable.listClick(event, base);
        });
        // Table row click opend eerste action
        base.on("click", "tbody tr", function(event) {
            $f8a311d146402a10$var$aTable.tableClick(event, table);
        });
        // Voorkom klik functie op dropdown menu
        base.on("click", "[data-atable-header-toggle] .dropdown-menu", function(event) {
            event.stopPropagation();
        });
        // Toon of verberg kolom wanneer filter gewijzigd wordt en sla status op in cookie
        base.on("change", "[data-atable-header-toggle-items] a input", function(event) {
            $f8a311d146402a10$var$aTable.toggleColumn(event, table);
        });
        // Zoekvelden keyboard enter key events
        base.on("keypress", "[data-atable-header-filter-search-input]", function(event) {
            var keycode = event.keyCode ? event.keyCode : event.which;
            if (keycode == "13") $f8a311d146402a10$var$aTable.reload(table);
            $f8a311d146402a10$var$aTable.searchEnterKeySubmit(event, table);
        });
        // Bulk header button functie die checkboxes toont
        base.on("click", "[data-atable-header-toolbar-bulkbutton]", function() {
            $f8a311d146402a10$var$aTable.bulkToggleCheckboxColumn(table);
        });
        // Bulk header checkbox function om select all te doen
        base.on("click", "table[data-atable] thead tr th input[type=checkbox]", function(event) {
            $f8a311d146402a10$var$aTable.bulkCheckboxToggleAll(event);
        });
        // Bulk functie om verticale shift selectie te doen
        base.on("click", "table[data-atable] tbody tr td input[type=checkbox]", function(event) {
            $f8a311d146402a10$var$aTable.bulkCheckboxShiftClickSelect(event);
        });
        // Bulk functie om bulk edit button enabled of disabled te maken als er een checkbox geselecteerd wordt
        base.on("change", "table[data-atable] tbody tr td input[type=checkbox]", function() {
            $f8a311d146402a10$var$aTable.bulkToggleEditButton(table);
        });
        // Table header events
        base.on("change", "[data-atable-header-toolbar-length],[data-atable-header-filter-select],[data-atable-header-filter-search-input], [data-atable-header-toolbar-select]", function() {
            $f8a311d146402a10$var$aTable.reload(table);
        });
        // Table modal filter events
        base.on("change", "[data-atable-modal-filter-select],[data-atable-modal-filter-search-input]", function(event) {
            $f8a311d146402a10$var$aTable.modalFilterApplyInputToHeader(table, event);
        });
        // Window resize length to 100 event
        var resizeId;
        var w = $(window).width();
        $(window).resize(function() {
            if (w != $(window).width()) {
                clearTimeout(resizeId);
                resizeId = setTimeout(function() {
                    $f8a311d146402a10$var$aTable.reload(table);
                }, 1000);
            }
        });
    },
    modalFilterApplyInputToHeader: function(table) {
        let base = $(document.body).find(table.closest("[data-atable-container]"));
        let targetId;
        let target;
        let sourceValue;
        let targetValue;
        base.find("[data-atable-modal-search-id], [data-atable-modal-filter-id]").each(function(i, e) {
            targetId = $(e).data("atable-modal-search-id") || $(e).data("atable-modal-filter-id");
            sourceValue = $(e).val();
            if (targetId !== "undefined") {
                target = $("[data-atable-search-id=" + targetId + "]");
                if (!target.length) target = $("[data-atable-filter-id=" + targetId + "]");
                targetValue = target.val();
                if (sourceValue !== targetValue) {
                    target.val(sourceValue);
                    $(target).trigger("change");
                }
            }
        });
    },
    initSearch: function(table) {
        // Verkrijg optie om searcg aan en uit te zetten uit DOM en default naar false
        var searchable = table.data("searchable");
        if (typeof searchable === "undefined") searchable = false;
        // Initieer search
        if (searchable === true) {
            var searchButton = table.closest("[data-atable-container]").find("[data-atable-header-toolbar-searchbutton]");
            searchButton.addClass("d-xl-inline-block ");
        }
    },
    /**
   * Initieer de listing length
   * Zet de length op 100 als de listing view geactiveerd is
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ initListLength: function(table) {
        var listVisible = table.closest("[data-atable-container]").find("[data-atable-list-listing]").is(":visible") || false;
        var lengthSelect = table.closest("[data-atable-container]").find("[data-atable-header-toolbar-length]");
        if (listVisible) lengthSelect.val("500");
    },
    initLength: function(table) {
        // Verkrijg optie om length selectie aan en uit te zetten uit DOM en default naar false
        var lengthSelectable = table.data("length-selectable");
        if (typeof lengthSelectable === "undefined") lengthSelectable = true;
        // Initieer length selectie
        if (lengthSelectable === true) {
            var tableLength = table.closest("[data-atable-container]").find("[data-atable-header-toolbar-length]");
            tableLength.addClass("d-xl-inline-block");
        }
    },
    /**
   * Initieer de columns toggle functie
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ initColumnsToggle: function(table) {
        // Verkrijg optie om toggle aan en uit te zetten uit DOM en default naar false
        var toggleable = table.data("toggleable");
        if (typeof toggleable === "undefined") toggleable = false;
        // Initieer columstoggle
        if (toggleable === true) {
            var toggleButton = table.closest("[data-atable-container]").find("[data-atable-header-toggle]");
            toggleButton.addClass("d-xl-inline-block ");
            // Laad het data columns json object
            var columnsDump = table.data("columns-data");
            // Check of het data columns json object gedefinieerd is
            if (columnsDump && columnsDump.length > 2) // Check of er een cookie is en zo ja activeer de kolommen
            $f8a311d146402a10$var$aTable.toggleColumnsReadCookie(table);
        }
    },
    /**
   * Laad de tabel inhoud
   * Definieer de query, lock de tabel, haal data op, formatteer rows en update inhoud
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ load: function(table) {
        // Check of de tabel niet gelocked is
        if (table.data("lock") == "") {
            // Definieer benodigde variables voor
            var length = parseInt($("[data-atable-header-toolbar-length]").val()) || parseInt($("[data-atable]").data("table-default-length")) || 15;
            var pagina = parseInt(table.data("pagina"));
            var start = pagina * length;
            var queryString = $f8a311d146402a10$var$aTable.formatQuery(table);
            var dateTime = new Date();
            var lock = dateTime.getTime();
            var opacityGroup = table.closest("[data-atable-container]").find("[data-atable-header-toolbar],[data-atable-table-container],[data-atable-list-listing],[data-atable-footer-toolbar]");
            var container = table.closest("[data-atable-container]");
            var spinner = table.closest("[data-atable-container]").find("[data-atable-spinner]");
            var bulkActive = table.attr("data-atable-bulk-active") || false;
            //  Lock the datatable
            table.data("lock", lock);
            // Change loading visibility
            container.removeClass("opacity-0");
            opacityGroup.addClass("opacity-25 pointer-events-none user-select-none");
            spinner.addClass("d-table").removeClass("d-none");
            // Voer de query uit
            (0, $7FBkt.default).send("GET", window.app.url + "data?lock=" + lock + queryString, function(dataString) {
                let data = JSON.parse(dataString);
                if (typeof data.sql !== "undefined") console.log(data.sql);
                // Check of de tabel gelocked is
                if (lock == data.lock) {
                    $f8a311d146402a10$var$aTable.data = data;
                    // Update inhoud en info
                    var draw = data.draw;
                    var list = $f8a311d146402a10$var$aTable.formatList(table, data);
                    var rows = $f8a311d146402a10$var$aTable.formatRows(data, table);
                    var tableInfo = table.closest("[data-atable-container]").find("[data-atable-info]");
                    var tableInfoFilter = table.closest("[data-atable-container]").find("[data-atable-info-filter]");
                    var tablePagination = table.closest("[data-atable-container]").find("[data-atable-pagination]");
                    $f8a311d146402a10$var$aTable.content(table, draw, rows["html"], list);
                    $f8a311d146402a10$var$aTable.info(table, start, length, rows["notEmpty"], data);
                    opacityGroup.removeClass("opacity-25 pointer-events-none user-select-none");
                    spinner.addClass("d-none").removeClass("d-table");
                    table.parent().removeClass("invisible");
                    if (data.recordsFiltered < length) {
                        tableInfoFilter.addClass("invisible");
                        tablePagination.addClass("invisible");
                    } else {
                        tableInfo.removeClass("invisible");
                        tableInfoFilter.removeClass("invisible");
                        tablePagination.removeClass("invisible");
                    }
                    var target = $("table[data-atable]").find("thead tr th:first-child, tbody tr td:first-child");
                    if (bulkActive === "true") target.removeClass("d-none");
                    table.trigger("aTable:loaded");
                }
            });
        }
    },
    /**
   * Geeft zichtare listing terug
   *
   * @param {object} table jQuery table DOM element
   * @returns {string}
   */ view: function(table) {
        var listVisible = table.closest("[data-atable-container]").find("[data-atable-list-listing]").is(":visible") || false;
        if (listVisible) return "list";
        else return "table";
    },
    /**
   * Herlaad de tabel inhoud
   * Ga naar eerste pagina en laad de tabel data
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ reload: function(table) {
        // Set page to first
        table.data("pagina", 0);
        // Get the data
        $f8a311d146402a10$var$aTable.load(table);
    },
    /**
   * Formatteer query
   * Stel de ajax query string samen uit waardes van elementen in de in DOM
   *
   * @param {object} table jQuery table DOM element
   * @returns {string} Geformatteerde string t.b.v. ajax request aan aItem
   */ formatQuery: function(table) {
        // Get sorting and order from table
        var sort = table.data("sort");
        var order = table.data("order");
        // Format sort and order query
        var sortQuery = "&sort=" + sort + "&dir=" + order;
        // Format filter query
        var filterQuery = "";
        $("[data-atable-header-filter-select],[data-atable-header-toolbar-select]").each(function() {
            var select = $(this);
            var filterTarget = select.attr("data-atable-filter-id") || select.attr("id");
            filterQuery = filterQuery + "&filter[" + filterTarget.substr(7) + "]=" + select.val();
        });
        // Format search query
        var searchQuery = "";
        $("input.aTableZoek").each(function() {
            var input = $(this);
            var searchTarget = input.attr("data-atable-search-id") || input.attr("id");
            searchQuery = searchQuery + "&search[" + searchTarget.substr(5) + "]=" + input.val();
        });
        // Format draw
        var draw = parseInt(table.data("draw"));
        var drawQuery = "&draw=" + draw;
        // Format length
        var length = parseInt(table.closest("[data-atable-container]").find("[data-atable-header-toolbar-length]").val()) || parseInt($("[data-atable]").data("table-default-length")) || 15;
        var lengthQuery = "&length=" + length;
        // Format page number
        var pagina = parseInt(table.data("pagina"));
        var start = pagina * length;
        var startQuery = "&start=" + start;
        // Format full query
        var query = drawQuery + startQuery + lengthQuery + sortQuery + filterQuery + searchQuery;
        // Return the full query
        return query;
    },
    /**
   * Formatteer tabelregels
   * Maak de tabelregels aan op basis van de opgehaalde json data
   *
   * @param {object} data
   * @returns {array}
   */ formatRows: function(data, table) {
        var headers = table.data("columns-data");
        var tbdy = document.createElement("tbody");
        var notEmpty = false;
        var totalRows = data.data.length;
        var td;
        var tr;
        for(var r = 0; r < totalRows; r++){
            tr = document.createElement("tr");
            for(var c = 0; c < data.data[r].length; c++){
                td = document.createElement("td");
                if (headers[c].hidden == true) td.className = "d-none";
                if (headers[c].key == "contextualClass") tr.className = "table-" + data.data[r][c];
                if (headers[c].cssClass !== undefined && headers[c].cssClass !== "") td.className = headers[c].cssClass;
                td.innerHTML = data.data[r][c];
                // td.setAttribute('data-raw', data.data[r][c]);
                tr.appendChild(td);
                notEmpty = true;
            }
            tbdy.appendChild(tr);
        }
        if (!notEmpty) {
            tr = document.createElement("tr");
            td = document.createElement("td");
            td.innerHTML = table.data("text-no-result");
            td.colSpan = headers.length;
            td.classList = "text-center p-4 aTable-no-result";
            tr.appendChild(td);
            tbdy.appendChild(tr);
        }
        var arr = [];
        arr["notEmpty"] = notEmpty;
        arr["html"] = tbdy;
        return arr;
    },
    /**
   * Formatteer lijstweergave
   * Maak de list items aan op basis van de opgehaalde json data
   *
   * @param {object} table
   * @param {object} data
   * @returns {array}
   */ formatList: function(table, data) {
        var template = table.closest("[data-atable-container]").find("[data-atable-list-item]").first();
        var notEmpty = false;
        var totalRows = data.data.length;
        var returnArray = [];
        var columnsDump = table.data("columns-data");
        for(var r = 0; r < totalRows; r++){
            // Clone listing item
            var item = template.clone();
            var titleColumn = 0;
            // Vul de titel en eventuele contextual class (kleur van regel)
            for(var n = 1; n < data.data[r].length; n++){
                if (data.data[r][n] != "") {
                    if (typeof columnsDump[n] !== "undefined") {
                        // Vul de titel
                        if (columnsDump[n]["responsiveOrder"] === 0) titleColumn = n;
                        // Vul de context class
                        var columnKey = columnsDump[n]["key"] || false;
                        if (columnKey === "contextualClass" && data.data[r][n] !== "") {
                            var contextualClass = "list-group-item-" + data.data[r][n];
                            item.addClass(contextualClass);
                        }
                    }
                }
            }
            item.find("[data-atable-list-title]").html(data.data[r][titleColumn]);
            // Item details
            var itemDetailTemplate = item.find("[data-atable-list-summary-item]").first();
            var itemDetails = [];
            var itemDetail;
            var last = data.data[r].length;
            item.find("[data-atable-list-item-buttons]").html(data.data[r][last - 1]);
            item.removeClass("d-none");
            for(var c = 0; c < data.data[r].length; c++)if (data.data[r][c] != "" && c !== titleColumn) {
                var responsiveOrder = columnsDump[c]["responsiveOrder"] || false;
                if (responsiveOrder !== false) {
                    itemDetail = itemDetailTemplate.clone().removeClass("d-none").html(data.data[r][c]);
                    itemDetails[responsiveOrder - 1] = itemDetail;
                }
            }
            // Voeg details toe aan summary
            item.find("[data-atable-list-summary]").append(itemDetails);
            // Voeg item toe aan items
            returnArray.push(item);
            notEmpty = true;
        }
        if (!notEmpty) {
            item = template.clone();
            item.html(table.data("text-no-result"));
            item.removeClass("d-none");
            returnArray.push(item);
        }
        return returnArray;
    },
    /**
   * Vul table content
   * Update de tabel content met ingegeven html
   *
   * @param {object} table jQuery table DOM element
   * @param {string} draw
   * @param {string} html
   * @param {string} list
   * @returns {void}
   */ content: function(table, draw, html, list) {
        table.data("lock", "");
        table.data("draw", draw);
        table.find("tbody").remove();
        table.closest("[data-atable-container]").find("[data-atable-list-item]").not(":first").remove();
        var view = $f8a311d146402a10$var$aTable.view(table);
        if (view == "table") table.find("thead").after(html);
        else table.closest("[data-atable-container]").find("[data-atable-list-item]").first().after(list);
        table.trigger("aTable:draw");
    },
    /**
   * Sorteer
   * Pas nieuwe sortering toe op basis van de geklikte kolomheader
   *
   * @param {object} e
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ sort: function(event, table) {
        // Definieer de table kolom header als jquery element
        var th = $(event.target);
        // Check de kolom sorteerbaar is
        if (th.data("orderable") == true) {
            // Draai kolom volgorde om
            $(th).parent().find("i").removeClass("fa-sort-up").removeClass("fa-sort-down").addClass("fa-sort");
            if (th.data("order") == "ASC") {
                th.data("order", "DESC");
                $(th).find("i").removeClass("fa-sort-down").addClass("fa-sort-up");
            } else {
                th.data("order", "ASC");
                $(th).find("i").removeClass("fa-sort-down").addClass("fa-sort-down");
            }
            // Pas de sortering toe op tabel element
            table.data("order", th.data("order"));
            table.data("sort", th.index());
            // Laad de tabel inhoud
            $f8a311d146402a10$var$aTable.load(table);
        }
    },
    /**
   * Laad pagina
   * Ga naar de pagina op basis van de aangegeven waarde in geklikt element
   *
   * @param {object} event
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ page: function(event, table) {
        // Verkrijg het doel uit de DOM
        var index = $(event.target).data("at-idx");
        // Verijg huidige pagina uit DOM
        var pageCurrent = parseInt(table.data("pagina"));
        // Formatteer het nieuwe als int
        var page;
        if (index == "next") page = pageCurrent + 1;
        else if (index == "prev") page = Math.max(0, pageCurrent - 1);
        else page = parseInt(index) - 1;
        // Pas doelpagina toe op table element
        table.data("pagina", page);
        // Laad de tabel inhoud
        $f8a311d146402a10$var$aTable.load(table);
    },
    /**
   * Toon en verberg filters in tabelheader als op de zoek knop geklikt wordt
   *
   * @param {object} table jQuery table DOM elementParentjq
   * @returns {void}
   */ searchReset: function(table) {
        table.find(".aTable-header-filters").find("input, select").val("").trigger("change");
    },
    /**
   * Reset de waarden van de filter
   *
   * @param {object} table jQuery table DOM elementParentjq
   * @returns {void}
   */ search: function(table) {
        table.closest("[data-atable-container]").find(".aTable-header-filters").toggleClass("d-none");
        var resetButton = table.closest("[data-atable-container]").find("[data-atable-header-toolbar-resetButton]");
        if (resetButton[0]?.hasAttribute("disabled")) resetButton?.addClass("d-xl-inline-block").removeAttr("disabled");
        else resetButton?.removeClass("d-xl-inline-block").attr("disabled", true);
    },
    /**
   * Functie die enter toets aan reload koppelt
   *
   * @param {object} table jQuery table DOM elementParentjq
   * @returns {void}
   */ searchEnterKeySubmit: function(event, table) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode == "13") $f8a311d146402a10$var$aTable.reload(table);
    },
    /**
   * Functie de een download url formatteerd en ophaald
   *
   * @param {object} table jQuery table DOM elementParentjq
   * @returns {void}
   */ download: function(table) {
        var queryString = $f8a311d146402a10$var$aTable.formatQuery(table);
        var btn = $("[data-atable-header-toolbar-downloadbutton]");
        var xhr = new XMLHttpRequest();
        btn.find("i").addClass("d-none");
        btn.find(".spinner").removeClass("d-none");
        xhr.responseType = "arraybuffer";
        xhr.open("GET", window.app.url + "download?" + queryString, true);
        xhr.send();
        xhr.onload = function() {
            if (this.status == 200) {
                var blob = new Blob([
                    this.response
                ], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                window.location.href = window.URL.createObjectURL(blob);
                btn.find("i").removeClass("d-none");
                btn.find(".spinner").addClass("d-none");
            }
        };
    },
    /**
   * Tabelinformatie
   * Vul de gewenste DOM elementen met informatie over de opgehaalde data
   *
   * @param {table} data
   * @param {int} start
   * @param {int} length
   * @param {bool} notEmpty
   * @param {object} data
   * @returns {void}
   */ info: function(table, start, length, notEmpty, data) {
        // Define target elements in DOM
        var tableContainer = table.closest("[data-atable-container]");
        var infoStartEl = tableContainer.find("[data-atable-info-start]");
        var infoEndEl = tableContainer.find("[data-atable-info-end]");
        var infoTotalEl = tableContainer.find("[data-atable-info-total]");
        var infoTotalTotalEl = tableContainer.find("[data-atable-filter-total]");
        var pagineationEl = tableContainer.find("[data-atable-pagination]");
        var paginationPreviousEl = tableContainer.find("[data-atable-pagination-previous]");
        var paginationNextEl = tableContainer.find("[data-atable-pagination-next]");
        // Update the content of the info elements in DOM
        infoStartEl.html(start);
        infoEndEl.html(start + data.data.length);
        infoTotalTotalEl.html(data.recordsTotal);
        infoTotalEl.html(data.recordsFiltered);
        if (notEmpty) {
            infoStartEl.html(start + 1);
            infoTotalTotalEl.parent().removeClass("invisible").addClass("invisible");
            if (data.recordsFiltered != data.recordsTotal) infoTotalTotalEl.parent().removeClass("invisible");
            var pagination = [];
            var max = 2;
            var maxEromheen = max * length;
            var maxOnder = start - maxEromheen;
            var maxBoven = start + maxEromheen + -1 * Math.min(0, maxOnder);
            maxOnder = maxOnder + Math.min(0, data.recordsFiltered - maxBoven - 2 * length);
            var last = "";
            for(var b = 0; b * length < data.recordsFiltered; b++){
                var begin = b * length;
                if (begin == 0 || begin > maxOnder && begin <= maxBoven || begin + length >= data.recordsFiltered) {
                    var paginanr = begin / length + 1;
                    pagination.push(paginanr);
                    last = paginanr;
                } else if (last != "...") {
                    paginanr = "...";
                    pagination.push(paginanr);
                    last = paginanr;
                }
            }
            var paginationTxt = "";
            for(var s = 0; s < pagination.length; s++){
                paginanr = pagination[s];
                var className = "";
                if (paginanr == "...") className = "disabled";
                else if ((paginanr - 1) * length == start) {
                    className = "active";
                    paginationPreviousEl.parent().removeClass("disabled");
                    paginationNextEl.parent().removeClass("disabled");
                    if (s == 0) paginationPreviousEl.parent().addClass("disabled");
                    else if (s + 1 == pagination.length) paginationNextEl.parent().addClass("disabled");
                }
                paginationTxt = paginationTxt + '<li class="page-item generated  ' + className + '"><a data-atable-pagination-link href="#" data-at-idx="' + paginanr + '" tabindex="0" class="page-link">' + paginanr + "</a></li>";
            }
            if (paginationTxt != "") {
                pagineationEl.find("li.generated").remove();
                paginationPreviousEl.parent().after(paginationTxt);
            }
        } else {
            pagineationEl.find("li.generated").remove();
            paginationPreviousEl.parent().after("");
        }
    },
    /**
   * Tableweergave click functie
   * Open url van eerste link in actie kolom
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ tableClick: function(event, table) {
        var tableRowClickable = table.data("table-row-clickable") || false;
        if (tableRowClickable == true) {
            var item = $(event.target).closest("tr").find("td:last-child a");
            if (item.length) {
                var url = item.attr("href");
                if (typeof url !== "undefined") window.open(url);
            }
        }
    },
    /**
   * Lijstweergave click functie
   * Toon actie buttons als op een item in de lijst geklikt wordt
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ listClick: function(e, base) {
        // Definieer listing-item als jQuery element
        var item = $(e.target).closest("[data-atable-list-item]");
        var itemButtonsContainer = item.find("[data-atable-list-item-buttons]");
        var itemButtons = itemButtonsContainer.find(".btn");
        // Als er maar één button is laad dan de link van die button
        if (itemButtons.length === 1) {
            var url = $(itemButtons[0]).attr("href");
            if (typeof url !== "undefined") window.location.href = url;
            else $(itemButtons[0]).trigger("click");
        // Als er verschilende buttons zijn toon dan die buttons
        } else {
            // Verberg eventueel getoonde buttons in de list en toon eventueel verborgen list-item content
            base.find("[data-atable-list-item-buttons]").addClass("d-none");
            base.find("[data-atable-list-title-container],[data-atable-list-summary]").removeClass("invisible");
            // Verberg item titel en samenvatting
            item.find("[data-atable-list-title-container],[data-atable-list-summary]").addClass("invisible");
            // Pas aanvullende opmaak classes toe en toon buttens
            itemButtonsContainer.find(".btn").removeClass("btn-xs").addClass("m-0 px-2 ma-1");
            itemButtonsContainer.removeClass("d-none");
        }
    },
    /**
   * Toon en verberg modal
   *
   * @param {int} data_id
   * @param {string} link
   * @returns {void}
   */ loadListingModal: function(data_ids, link, size) {
        var url = window.app.url + link + "/";
        (0, $7FBkt.default).send("POST", url, function(data) {
            if (data != "false" && data != "") {
                let modal = $("[data-atable-modal]");
                let modalContent = $("[data-atable-modal-content]");
                let modalDialog = $("[data-atable-modal] .modal-dialog");
                modalDialog.addClass("modal-" + size);
                modalContent.html(data);
                modal.modal("show");
                (0, $46c3b49fce744198$export$2e2bcd8739ae039).init(modal);
                (0, $4ee4564850efd542$export$2e2bcd8739ae039).init(modal);
                (0, $cbba02f95b4e7e13$export$2e2bcd8739ae039).init(modal[0]);
            } else console.error("Er ging iets mis, probeer het later nogmaals");
        }, (0, $7FBkt.default).encodeFormData({
            data_ids: data_ids
        }));
    },
    /**
   * Toon en verberg modal
   *
   * @param {object} event
   * @returns {void}
   */ getModal: function(event, table) {
        var button = $(event.target);
        var data_id = button.attr("data-id") || null;
        var data_ids = [];
        if (data_id !== null && data_id !== "") data_ids.push(data_id);
        else {
            data_ids = table.attr("data-atable-selected") || null;
            data_ids = JSON.parse(data_ids);
        }
        var link = button.attr("data-modal-link");
        if (typeof link == "undefined" || link == "") link = "data";
        var size = button.attr("data-modal-size");
        if (typeof size == "undefined" || size == "") size = "md";
        if (data_ids !== null && data_ids.length !== 0) {
            $f8a311d146402a10$var$aTable.loadListingModal(data_ids, link, size);
            $("#aTableModal").fadeIn(200);
        }
    },
    /**
   * Initieer de columns toggle functie
   *
   * @param {object} event
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ toggleColumn: function(event, table) {
        var minColumns = table.data("min-columns") || 3;
        // Tel aantal zichtbare kolommen
        var visibleColums = 0;
        table.closest("[data-atable-container]").find("[data-atable-header-toggle-items] input[type=checkbox]:checked").each(function() {
            visibleColums++;
        });
        // Als er tenminste 3 kolommen zichtbaar zijn
        if (visibleColums > parseInt(minColumns) - 1) {
            // Sla column instellingen op in cookie
            $f8a311d146402a10$var$aTable.toggleColumnsSetCookie(table);
            // Toon of verberg de kolom
            var colNumber = $(event.target).attr("data-column");
            var visiblity = $(event.target)[0].checked;
            $f8a311d146402a10$var$aTable.toggleColumnsVisibility(table, colNumber, visiblity);
        } else // Zet checkbox weer op true
        event.target.checked = true;
        // Disable minimum aantal columns
        $f8a311d146402a10$var$aTable.toggleColumnsMinMax(table);
    },
    /**
   * Slaat de zichtbare kolommen op in een cookie
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ toggleColumnsSetCookie: function(table) {
        var obj = {};
        obj["version"] = table.attr("data-version") ?? "";
        obj["columns"] = [];
        table.closest("[data-atable-container]").find("[data-atable-header-toggle-items] input[type=checkbox]").each(function(i, e) {
            var itemColNumber = $(e).attr("data-column");
            obj["columns"][itemColNumber] = false;
            if (this.checked) obj["columns"][itemColNumber] = this.checked;
        });
        let objJSON = JSON.stringify(obj);
        var myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 12);
        document.cookie = $f8a311d146402a10$var$aTable.cookieName + "=" + objJSON + ";domain=" + window.app.cookieDomain + ";SameSite=Strict;expires=" + myDate + ";secure;";
    },
    /**
   * Leest de zichtbare kolommen uit een cookie
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ toggleColumnsReadCookie: function(table) {
        let cookieBase = document.cookie.split(";");
        let columsSetByCookie = false;
        cookieBase.forEach(function(cookieItem) {
            let cookieSplit = cookieItem.split("=");
            let cookieKey = (cookieSplit[0] || "").trim();
            if ($f8a311d146402a10$var$aTable.cookieName === cookieKey) {
                let cookieValue = cookieSplit[1] || "";
                if ($f8a311d146402a10$var$aTable.cookieName === cookieKey && "undefined" !== typeof cookieValue && "" !== cookieValue) {
                    let cookieObject = false;
                    try {
                        let cookieValueDecoded = decodeURIComponent(cookieValue);
                        cookieObject = JSON.parse(cookieValueDecoded);
                    } catch (error) {
                        console.warn("Error parsing cookie JSON:", error);
                    }
                    if (false !== cookieObject) {
                        let tableVersion = table.attr("data-version") ?? "";
                        let cookieVersion = cookieObject["version"] ?? "";
                        let columns = cookieObject["columns"] ?? [];
                        if (cookieVersion === tableVersion) $.each(columns, function(index, value) {
                            if (value == false) $f8a311d146402a10$var$aTable.toggleColumnsVisibility(table, index, false);
                            table.closest("[data-atable-container]").find('[data-atable-header-toggle-items] a input[data-column="' + index + '"]').prop("checked", value);
                            columsSetByCookie = true;
                        });
                    }
                }
            }
        });
        if (!columsSetByCookie) $f8a311d146402a10$var$aTable.toggleColumnsDefault(table);
        $f8a311d146402a10$var$aTable.toggleColumnsMinMax(table);
    },
    /**
   * Toont en verbergt kolommen d.m.v. classes
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ toggleColumnsVisibility: function(table, colNumber, show) {
        var targetClass = "hide-col-" + parseInt(colNumber);
        if (show) table.removeClass(targetClass);
        else table.addClass(targetClass);
    },
    /**
   * Zet toggle kolom checkboxes op disabled als minimaal aantal geselecteerde kolommen bereikt is
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ toggleColumnsMinMax: function(table) {
        var maxColumns = table.data("max-columns") || 6;
        var minColumns = table.data("min-columns") || 3;
        var visibleColums = 0;
        var checked = table.closest("[data-atable-container]").find("[data-atable-header-toggle-items] input[type=checkbox]:checked");
        var unChecked = table.closest("[data-atable-container]").find("[data-atable-header-toggle-items] input[type=checkbox]:not(:checked)");
        if (typeof checked !== "undefined" && typeof unChecked !== "undefined") {
            checked.each(function() {
                visibleColums++;
            });
            if (visibleColums < parseInt(minColumns) + 1) checked.each(function() {
                $(this).attr("disabled", true).closest("a").addClass("disabled");
            });
            else checked.each(function() {
                $(this).attr("disabled", false).closest("a").removeClass("disabled");
            });
            if (visibleColums > parseInt(maxColumns) - 1) unChecked.each(function() {
                $(this).attr("disabled", true).closest("a").addClass("disabled");
            });
            else unChecked.each(function() {
                $(this).attr("disabled", false).closest("a").removeClass("disabled");
            });
        }
    },
    /**
   * Zet de default verborgen en getoonde kolommen aan en uit
   *
   * @param {object} table jQuery table DOM element
   * @returns {void}
   */ toggleColumnsDefault: function(table) {
        var columnsDump = table.data("columns-data");
        if (columnsDump.length) $.each(columnsDump, function(index, col) {
            table.closest("[data-atable-container]").find('[data-atable-header-toggle-items] a input[data-column="' + (index + 1) + '"]').prop("checked", col.toggleableDefault).trigger("change");
        });
    },
    getRows: function() {
        return $f8a311d146402a10$var$aTable.data.data;
    },
    bulkToggleCheckboxColumn: function(table) {
        var target = $("table[data-atable]").find("thead tr th:first-child, tbody tr td:first-child");
        var visible = target.is(":visible");
        if (visible) {
            table.attr("data-atable-bulk-active", false);
            target.addClass("d-none");
        } else {
            table.attr("data-atable-bulk-active", true);
            target.removeClass("d-none");
        }
    },
    bulkCheckboxToggleAll: function(event) {
        var checked = $(event.target).prop("checked");
        var checkboxes = $("table[data-atable] tbody tr td input[type=checkbox]");
        checkboxes.prop("checked", checked).trigger("change");
    },
    bulkCheckboxShiftClickSelect: function(event) {
        var checkboxes = $("table[data-atable] tbody tr td input[type=checkbox]");
        if (typeof $f8a311d146402a10$var$aTable.lastChecked === "undefined") {
            $f8a311d146402a10$var$aTable.lastChecked = event.target;
            return;
        }
        if (event.shiftKey) {
            var start = checkboxes.index(event.target);
            var end = checkboxes.index($f8a311d146402a10$var$aTable.lastChecked);
            checkboxes.slice(Math.min(start, end), Math.max(start, end) + 1).prop("checked", $f8a311d146402a10$var$aTable.lastChecked.checked);
        }
        $f8a311d146402a10$var$aTable.lastChecked = event.target;
    },
    bulkToggleEditButton: function(table) {
        var checkboxes = $("table[data-atable] tbody tr td input[type=checkbox]");
        var bulkbutton = $("[data-atable-header-toolbar-bulkbutton]");
        var bulkEditbutton = $("[data-atable-header-toolbar-bulkEditbutton]");
        var checkedIds = [];
        $.each(checkboxes, function(i, v) {
            var t = $(v);
            if (t.is(":checked")) checkedIds.push(t.data("checkbox-id"));
        });
        var checkedIdsJson = JSON.stringify(checkedIds);
        table.attr("data-atable-selected", checkedIdsJson);
        if (checkboxes.is(":checked")) {
            bulkbutton.addClass("d-none");
            bulkEditbutton.removeClass("d-none");
        } else {
            bulkbutton.removeClass("d-none");
            bulkEditbutton.addClass("d-none");
        }
    }
};
var $f8a311d146402a10$export$2e2bcd8739ae039 = $f8a311d146402a10$var$aTable;


var $fb7f0d699fad3c0f$var$autoEnableSubmitButtons = {
    /**
   * Init
   *
   * @param {object} target
   * @param {int} delay
   *
   * @returns {void}
   */ init: function(target, delay = 300) {
        window.app.domStateReady(function() {
            setTimeout(function() {
                $fb7f0d699fad3c0f$var$autoEnableSubmitButtons.enable(target);
            }, delay);
        });
    },
    enable: function(target) {
        var elements = target.querySelectorAll("[type=submit][data-auto-enable=true]");
        for(var i = 0; i < elements.length; i++)if (elements[i].hasAttribute("disabled")) elements[i].removeAttribute("disabled");
    }
};
var $fb7f0d699fad3c0f$export$2e2bcd8739ae039 = $fb7f0d699fad3c0f$var$autoEnableSubmitButtons;


var $b0b7bd6f4a1378d1$var$browserHistory = {
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        target.addEventListener("click", function(event) {
            for(var eventTarget = event.target; eventTarget && eventTarget != this; eventTarget = eventTarget.parentNode)if (eventTarget.matches("[data-browser-history-back]")) {
                $b0b7bd6f4a1378d1$var$browserHistory.historyBack();
                break;
            }
        }, false);
        target.addEventListener("click", function(event) {
            for(var eventTarget = event.target; eventTarget && eventTarget != this; eventTarget = eventTarget.parentNode)if (eventTarget.matches("[data-browser-history-forward]")) {
                $b0b7bd6f4a1378d1$var$browserHistory.historyForward();
                break;
            }
        }, false);
    },
    /**
   * Navigate browser history back
   *
   * @returns {void}
   */ historyBack: function() {
        window.history.back();
    },
    /**
   * Navigate browser history forward
   *
   * @returns {void}
   */ historyForward: function() {
        window.history.forward();
    }
};
var $b0b7bd6f4a1378d1$export$2e2bcd8739ae039 = $b0b7bd6f4a1378d1$var$browserHistory;


var $ec107908988458ca$var$cardFunctions = {
    /**
   * Init
   *
   * @param {object} target
   *
   * @returns {void}
   */ init: function(target) {
        target.addEventListener("click", (event)=>{
            const cardHeader = event.target.closest(".card-header.card-header-collapse");
            if (cardHeader && !event.target.classList.contains("btn")) this.toggleContent(cardHeader);
        });
    },
    /**
   * Toggle the content of a card
   *
   * @param {HTMLElement} cardHeader - The header element of the card
   *
   * @returns {void}
   */ toggleContent: function(cardHeader) {
        const i = cardHeader.querySelector(".card-header-control i") ?? cardHeader.querySelector("small i"); // Fallback voor card-header-heading, verwijderen na ES6 uitfaseren oud dossier
        const cardBody = cardHeader.closest(".card").querySelector(".card-body");
        i.classList.toggle("fa-chevron-down");
        i.classList.toggle("fa-chevron-left");
        cardBody.style.display = i.classList.contains("fa-chevron-down") ? "" : "none";
        cardBody.classList.toggle("d-none");
    }
};
var $ec107908988458ca$export$2e2bcd8739ae039 = $ec107908988458ca$var$cardFunctions;


var $557886ee49cc5614$var$confirmationModal = {
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        $(target).on("click", "a[data-toggle=confirmation], button[data-toggle=confirmation]", function(e) {
            var element = $(this);
            e.preventDefault();
            var title = element.data("confirmation-title");
            var content = element.data("confirmation-content");
            var size = element.data("confirmation-size");
            var defaultTarget = element.attr("href");
            if (size === undefined) size = "";
            $("#generalModal .modal-dialog").removeAttr("class").addClass("modal-dialog").addClass("modal-" + size);
            if (title === undefined) title = $("#generalModal .modal-title").data("confirmation-default-title");
            $("#generalModal .modal-title").html(title);
            $("#generalModal .modal-body").html(content);
            $("#generalModal .modal-footer").removeClass("d-none");
            var btnCancelLabel = element.data("btn-cancel-label");
            var btnCancelClass = element.data("btn-cancel-class");
            var btnOkLabel = element.data("btn-ok-label");
            var btnOkClass = element.data("btn-ok-class");
            var btnAltLabel = element.data("btn-alt-label");
            var btnAltClass = element.data("btn-alt-class");
            var btnAltTarget = element.data("btn-alt-target");
            if (btnCancelLabel === undefined) btnCancelLabel = $("#generalModal #generalModalBtnCancel").data("confirmation-default-label");
            if (btnCancelClass === undefined) btnCancelClass = "btn-secondary";
            $("#generalModal #generalModalBtnCancel").html(btnCancelLabel).removeAttr("class").addClass("btn").addClass(btnCancelClass);
            if (btnOkLabel === undefined) btnOkLabel = $("#generalModal #generalModalBtnOk").data("confirmation-default-label");
            if (btnOkClass === undefined) btnOkClass = "btn-secondary";
            $("#generalModal #generalModalBtnOk").html(btnOkLabel).removeAttr("class").addClass("btn").addClass(btnOkClass);
            $("#generalModal #generalModalBtnOk").unbind("click").click(function() {
                if (defaultTarget !== undefined) window.location.href = defaultTarget;
                else element.closest("form").submit();
            });
            if (btnAltClass === undefined) btnAltClass = "btn-secondary";
            if (btnAltTarget === undefined) btnAltTarget = "";
            if (btnAltLabel !== undefined) {
                $("#generalModal #generalModalBtnAlt").html(btnAltLabel).removeAttr("class").addClass("btn").addClass(btnAltClass);
                $("#generalModal #generalModalBtnAlt").unbind("click").click(function() {
                    window.location.href = btnAltTarget;
                });
            }
            $("#generalModal").modal("show", {
                keyboard: false,
                backdrop: "static"
            });
        });
    }
};
var $557886ee49cc5614$export$2e2bcd8739ae039 = $557886ee49cc5614$var$confirmationModal;


var $508fcb5c5865a89e$var$checkForChangedInput = {
    /**
   * Initializes the checkForChangedInput functions.
   *
   * @param {object}
   *
   * @returns {void}
   */ init: function(target) {
        $508fcb5c5865a89e$var$checkForChangedInput.initFields(target);
        $508fcb5c5865a89e$var$checkForChangedInput.initEvents(target);
    },
    /**
   * Initializes field attributes.
   *
   * @param {HTMLElement} target - The target DOM element to process field attributes on.
   *
   * @returns {void}
   */ initFields: function(target) {
        const fields = target.querySelectorAll("[data-check-for-changed-input]");
        fields.forEach($508fcb5c5865a89e$var$checkForChangedInput.procesFieldAttributes);
    },
    /**
   * Processes field attributes.
   *
   * @param {HTMLElement} element - The DOM element representing the input field.
   *
   * @returns {void}
   */ procesFieldAttributes: function(element) {
        let nameOriginal = element.getAttribute("name");
        element.setAttribute("data-name-original", nameOriginal);
        element.removeAttribute("name");
        let valueOriginal = element.getAttribute("value") || element.getAttribute("data-value") || "";
        element.setAttribute("data-value-original", valueOriginal);
    },
    /**
   * Initializes event listeners for input fields.
   *
   * @param {HTMLElement} target - The target DOM element to attach event listeners to.
   *
   * @returns {void}
   */ initEvents: function(target) {
        let elements = target.querySelectorAll("[data-check-for-changed-input]");
        elements.forEach(function(element) {
            element.addEventListener("blur", $508fcb5c5865a89e$var$checkForChangedInput.checkForChange);
        });
    },
    /**
   * Handles change detection for an input field.
   *
   * @param {Event} event - The blur event triggered by the input field.
   *
   * @returns {void}
   */ checkForChange: function(event) {
        const field = event.target;
        const originalName = field.getAttribute("data-name-original");
        const originalValue = field.getAttribute("data-value-original");
        if (field.value != originalValue) field.setAttribute("name", originalName);
        else {
            let revertName = field.getAttribute("name");
            if (null !== revertName && "undefined" !== typeof revertName) {
                field.setAttribute("data-name-original", field.getAttribute("name"));
                field.removeAttribute("name");
            }
        }
    }
};
var $508fcb5c5865a89e$export$2e2bcd8739ae039 = $508fcb5c5865a89e$var$checkForChangedInput;



var $ab808cb1ff637aca$var$checkboxInput = {
    /**
   * Init
   *
   * @param {object} target
   *
   * @returns {void}
   */ init: function(target) {
        $ab808cb1ff637aca$var$checkboxInput.initBoolInput(target);
        $ab808cb1ff637aca$var$checkboxInput.initToggleInput(target);
    },
    /**
   * Init
   *
   * @param {object} target
   *
   * @returns {void}
   */ initBoolInput: function(target) {
        var checkboxes = target.querySelectorAll("input[type=checkbox][data-checkbox-text]");
        for(var i = 0; i < checkboxes.length; i++)checkboxes[i].addEventListener("change", function(e) {
            var n = e.target.nextElementSibling;
            if (n.nodeName == "INPUT" && n.hasAttribute("data-checkbox-text-input")) {
                if (e.target.checked) n.value = true;
                else n.value = false;
            }
        });
    },
    /**
   * Init
   *
   * @param {object} target
   *
   * @returns {void}
   */ initToggleInput: function(target) {
        var checkboxes = target.querySelectorAll("input[type=checkbox][data-checkbox-toggle-input]");
        for(var i = 0; i < checkboxes.length; i++)checkboxes[i].addEventListener("change", function(e) {
            let inputs = e.target.parentElement.parentElement.querySelectorAll("[data-checkbox-toggle-input-target]");
            for(var a = 0; a < inputs.length; a++){
                if (!inputs[a].hasAttribute("data-initial-value")) inputs[a].setAttribute("data-initial-value", inputs[a].value);
                inputs[a].removeAttribute("disabled");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(inputs[a]);
                if (!e.target.checked) {
                    (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(inputs[a]);
                    inputs[a].value = inputs[a].getAttribute("data-initial-value") || "";
                    inputs[a].setAttribute("disabled", true);
                }
            }
            if (inputs.length < 2) inputs[a - 1].focus();
        });
    }
};
var $ab808cb1ff637aca$export$2e2bcd8739ae039 = $ab808cb1ff637aca$var$checkboxInput;


var $7be46bbb60d787f3$var$checkboxSelectAll = {
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        target.querySelector("[data-checkbox-select-all]")?.addEventListener("click", function() {
            document.querySelectorAll(this.getAttribute("data-checkbox-select-all") + ' input[type="checkbox"]').forEach(function(checkbox) {
                checkbox.checked = !checkbox.checked;
            });
        });
    }
};
var $7be46bbb60d787f3$export$2e2bcd8739ae039 = $7be46bbb60d787f3$var$checkboxSelectAll;


const $a28461625025ced7$var$vanillaCountdown = {
    settings: null,
    counter: null,
    expireAt: null,
    // Default settings
    defaults: {
        autostart: true,
        seconds: 600,
        offset: 0,
        checkTimeUrl: false,
        checkTimeIntervalSeconds: 30,
        checkTimeCallBack: function() {},
        expireAtTimestamp: false,
        onCompleteCallBack: function() {},
        countdownTimeId: "countdown",
        countdownProgressId: "countdownProgress",
        countdownProgressContainerId: "countdownProgressContainer",
        partTwo: false,
        partTwoSeconds: 220,
        partTwoClass: "text-danger",
        partTwoClassContainer: "danger",
        partTwoClassProgress: "bg-danger",
        partTwoCallBack: function() {},
        callbackBefore: function() {},
        callbackAfter: function() {}
    },
    /**
	 * A simple forEach() implementation for Arrays, Objects and NodeLists
	 * @private
	 * @param {Array|Object|NodeList} collection Collection of items to iterate
	 * @param {Function} callback Callback function for each iteration
	 * @param {Array|Object|NodeList} scope Object/NodeList/Array that forEach is iterating over (aka `this`)
	 */ forEach: function(collection, callback, scope) {
        if (Object.prototype.toString.call(collection) === "[object Object]") {
            for(var prop in collection)if (Object.prototype.hasOwnProperty.call(collection, prop)) callback.call(scope, collection[prop], prop, collection);
        } else for(var i = 0, len = collection.length; i < len; i++)callback.call(scope, collection[i], i, collection);
    },
    /**
	 * Merge defaults with user options
	 * @private
	 * @param {Object} defaults Default settings
	 * @param {Object} options User options
	 * @returns {Object} Merged values of defaults and options
	 */ extend: function(defaults, options) {
        var extended = {};
        $a28461625025ced7$var$vanillaCountdown.forEach(defaults, function(value, prop) {
            extended[prop] = defaults[prop];
        });
        $a28461625025ced7$var$vanillaCountdown.forEach(options, function(value, prop) {
            extended[prop] = options[prop];
        });
        return extended;
    },
    calculateCount: function() {
        var now = new Date();
        var nowMS = now.getTime();
        var currentMS = $a28461625025ced7$var$vanillaCountdown.expireAt.getTime() - nowMS - $a28461625025ced7$var$vanillaCountdown.settings.offset;
        return Math.floor(currentMS / 1000);
    },
    // Timer Functie
    timer: function() {
        var count = $a28461625025ced7$var$vanillaCountdown.calculateCount();
        if ($a28461625025ced7$var$vanillaCountdown.settings.checkTimeUrl) {
            if (count == 60 || count == 10) $a28461625025ced7$var$vanillaCountdown.checkStartTime($a28461625025ced7$var$vanillaCountdown.settings.checkTimeUrl, count);
        }
        var elementCountdownProgressContainer = document.getElementById($a28461625025ced7$var$vanillaCountdown.settings.countdownProgressContainerId);
        var elementCountdownProgress = document.getElementById($a28461625025ced7$var$vanillaCountdown.settings.countdownProgressId);
        var elementCountdownTime = document.getElementById($a28461625025ced7$var$vanillaCountdown.settings.countdownTimeId);
        var countdownProgressContainerIdElement = document.getElementById($a28461625025ced7$var$vanillaCountdown.settings.countdownProgressContainerId);
        var countdownProgressIdElement = document.getElementById($a28461625025ced7$var$vanillaCountdown.settings.countdownProgressId);
        var countdownTimeIdElement = document.getElementById($a28461625025ced7$var$vanillaCountdown.settings.countdownTimeId);
        var progress = -(100 / $a28461625025ced7$var$vanillaCountdown.settings.seconds * count) + 100;
        var sec = count % 60;
        var min = Math.floor(count / 60);
        min %= 60;
        if (typeof elementCountdownTime != "undefined" && elementCountdownTime != null) elementCountdownTime.innerHTML = ("0" + min).slice(-2) + ":" + ("0" + sec).slice(-2);
        if (typeof elementCountdownProgress != "undefined" && elementCountdownProgress != null) elementCountdownProgress.style.width = 98.5 - progress + "%";
        if ($a28461625025ced7$var$vanillaCountdown.settings.partTwo) {
            if (count == $a28461625025ced7$var$vanillaCountdown.settings.partTwoSeconds) {
                if ($a28461625025ced7$var$vanillaCountdown.settings.partTwoClassContainer) {
                    if (typeof elementCountdownProgressContainer != "undefined" && elementCountdownProgressContainer != null) elementCountdownProgressContainer.classList.add($a28461625025ced7$var$vanillaCountdown.settings.partTwoClassContainer);
                }
                if ($a28461625025ced7$var$vanillaCountdown.settings.partTwoClassProgress) {
                    if (typeof elementCountdownProgress != "undefined" && elementCountdownProgress != null) elementCountdownProgress.classList.add($a28461625025ced7$var$vanillaCountdown.settings.partTwoClassProgress);
                }
                if ($a28461625025ced7$var$vanillaCountdown.settings.partTwoClass) {
                    if (typeof elementCountdownTime != "undefined" && elementCountdownTime != null) elementCountdownTime.classList.add($a28461625025ced7$var$vanillaCountdown.settings.partTwoClass);
                }
                $a28461625025ced7$var$vanillaCountdown.settings.partTwoCallBack();
            } else if (count > $a28461625025ced7$var$vanillaCountdown.settings.partTwoSeconds && count % 30 == 0) {
                if ($a28461625025ced7$var$vanillaCountdown.settings.partTwoClassContainer) {
                    if (typeof countdownProgressContainerIdElement != "undefined" && countdownProgressContainerIdElement != null) countdownProgressContainerIdElement.classList.remove($a28461625025ced7$var$vanillaCountdown.settings.partTwoClassContainer);
                }
                if ($a28461625025ced7$var$vanillaCountdown.settings.partTwoClassProgress) {
                    if (typeof countdownProgressIdElement != "undefined" && countdownProgressIdElement != null) countdownProgressIdElement.classList.remove($a28461625025ced7$var$vanillaCountdown.settings.partTwoClassProgress);
                }
                if ($a28461625025ced7$var$vanillaCountdown.settings.partTwoClass) {
                    if (typeof countdownTimeIdElement != "undefined" && countdownTimeIdElement != null) countdownTimeIdElement.classList.remove($a28461625025ced7$var$vanillaCountdown.settings.partTwoClass);
                }
            }
        }
        if (count <= 0) {
            clearInterval($a28461625025ced7$var$vanillaCountdown.counter);
            $a28461625025ced7$var$vanillaCountdown.settings.onCompleteCallBack();
            return;
        }
    },
    //////////////////////////////
    // Public APIs
    //////////////////////////////
    /**
	 * Destroy the current initialization.
	 * @public
	 */ checkIfInPart2: function() {
        if ($a28461625025ced7$var$vanillaCountdown.settings.partTwo) {
            var count = $a28461625025ced7$var$vanillaCountdown.calculateCount();
            if (count <= $a28461625025ced7$var$vanillaCountdown.settings.partTwoSeconds) return true;
        }
        return false;
    },
    /**
	 * Check the start time from the server.
	 * @public
	 * @param {string} checkTimeUrl - The URL to fetch the start time from
	 */ checkStartTime: function(checkTimeUrl) {
        fetch(checkTimeUrl).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (data !== false) {
                var d = new Date();
                d.setTime(data.expireAtTimestamp * 1000);
                $a28461625025ced7$var$vanillaCountdown.expireAt = d;
                $a28461625025ced7$var$vanillaCountdown.settings.checkTimeCallBack();
            }
        }).catch(function(error) {
            console.error("Error checking start time:", error);
        });
    },
    /**
	 * Destroy the current initialization.
	 * @public
	 */ destroy: function() {
        // If plugin isn't already initialized, stop
        if (!$a28461625025ced7$var$vanillaCountdown.settings) return;
        // Remove init class for conditional CSS
        // document.documentElement.classList.remove( vanillaCountdown.settings.initClass );
        // @todo Undo any other init functions...
        // Remove event listeners
        // document.removeEventListener('click', eventHandler, false);
        // Reset variables
        settings = null;
    },
    /**
	 * Initialize Plugin
	 * @public
	 * @param {Object} options User settings
	 */ init: function(options) {
        // Destroy any existing initializations
        $a28461625025ced7$var$vanillaCountdown.destroy();
        // Merge user options with defaults
        $a28461625025ced7$var$vanillaCountdown.settings = $a28461625025ced7$var$vanillaCountdown.extend($a28461625025ced7$var$vanillaCountdown.defaults, options || {});
        if ($a28461625025ced7$var$vanillaCountdown.settings.checkTimeIntervalSeconds >= $a28461625025ced7$var$vanillaCountdown.settings.seconds) $a28461625025ced7$var$vanillaCountdown.settings.checkTimeIntervalSeconds = Math.ceil($a28461625025ced7$var$vanillaCountdown.settings.seconds / 2);
        if ($a28461625025ced7$var$vanillaCountdown.settings.autostart) $a28461625025ced7$var$vanillaCountdown.start();
    },
    /**
	 * Initialize Plugin
	 * @public
	 * @param {Object} options User settings
	 */ start: function() {
        $a28461625025ced7$var$vanillaCountdown.expireAt = new Date();
        if ($a28461625025ced7$var$vanillaCountdown.settings.expireAtTimestamp) $a28461625025ced7$var$vanillaCountdown.expireAt.setTime($a28461625025ced7$var$vanillaCountdown.settings.expireAtTimestamp * 1000);
        $a28461625025ced7$var$vanillaCountdown.counter = setInterval($a28461625025ced7$var$vanillaCountdown.timer, 1000);
        if ($a28461625025ced7$var$vanillaCountdown.settings.checkTimeUrl) setInterval(function() {
            $a28461625025ced7$var$vanillaCountdown.checkStartTime($a28461625025ced7$var$vanillaCountdown.settings.checkTimeUrl);
        }, $a28461625025ced7$var$vanillaCountdown.settings.checkTimeIntervalSeconds * 1000);
    }
};
var $a28461625025ced7$export$2e2bcd8739ae039 = $a28461625025ced7$var$vanillaCountdown;


const $7e7758fe6ef1abb0$var$countdown = {
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        $7e7758fe6ef1abb0$var$countdown.initVanillaCountdown(target);
        $7e7758fe6ef1abb0$var$countdown.initEvents();
    },
    initEvents: function() {
        $("#timeoutModalBtnContinue").on("click", function() {
            (0, $a28461625025ced7$export$2e2bcd8739ae039).checkStartTime($(this).data("extend-time-url"));
        });
    },
    initVanillaCountdown: function(target) {
        /** Toon de teller voor het automatisch uitloggen */ var el = target.querySelector("#countdown");
        if (el) {
            var curtimeMSServer = $("#countdown").attr("data-cur-time") * 1000;
            var now = new Date();
            var curtimeMSClient = now.getTime();
            var offset = curtimeMSClient - curtimeMSServer;
            (0, $a28461625025ced7$export$2e2bcd8739ae039).init({
                seconds: $("#countdown").attr("data-seconds"),
                offset: offset,
                checkTimeUrl: $("#countdown").attr("data-check-time"),
                expireAtTimestamp: $("#countdown").attr("data-expire-time"),
                onCompleteCallBack: function() {
                    var onCompleteUrl = $("#countdown").attr("data-action-url");
                    if (typeof onCompleteUrl != "undefined") window.location.href = onCompleteUrl;
                },
                partTwo: true,
                partTwoCallBack: function() {
                    $("#timeoutModal").modal("show", {
                        backdrop: "static",
                        keyboard: false,
                        show: true
                    });
                },
                checkTimeCallBack: function() {
                    if (!(0, $a28461625025ced7$export$2e2bcd8739ae039).checkIfInPart2()) $("#timeoutModal").modal("hide");
                }
            });
        }
    }
};
var $7e7758fe6ef1abb0$export$2e2bcd8739ae039 = $7e7758fe6ef1abb0$var$countdown;


var $a20b59ef33efb6d1$var$dataLinks = {
    /**
   * Initialize data links functionality by adding click event listener
   *
   * @param {HTMLElement} target - The target element to attach the click listener to
   * @returns {void}
   */ init: function(target) {
        target.addEventListener("click", (event)=>this.handleDataLinkClick(event.target));
    },
    /**
   * Handle click events for elements with data-link attribute
   * Redirects to the URL specified in the data-link attribute
   *
   * @param {Event} event - The click event object
   * @returns {void}
   */ handleDataLinkClick: function(target) {
        const linkElement = target.closest("[data-link]");
        if (linkElement) {
            const dataLink = linkElement.getAttribute("data-link");
            if (dataLink && dataLink.trim() !== "") window.location.href = dataLink;
        }
    }
};
var $a20b59ef33efb6d1$export$2e2bcd8739ae039 = $a20b59ef33efb6d1$var$dataLinks;



var $f0093c65cdad64a6$exports = {};
/*!
 * FilePond 4.31.4
 * Licensed under MIT, https://opensource.org/licenses/MIT/
 * Please visit https://pqina.nl/filepond/ for details.
 */ /* eslint-disable */ (function(global, factory) {
    factory($f0093c65cdad64a6$exports);
})($f0093c65cdad64a6$exports, function(exports1) {
    "use strict";
    var isNode = function isNode(value) {
        return value instanceof HTMLElement;
    };
    var createStore = function createStore(initialState) {
        var queries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var actions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        // internal state
        var state = Object.assign({}, initialState);
        // contains all actions for next frame, is clear when actions are requested
        var actionQueue = [];
        var dispatchQueue = [];
        // returns a duplicate of the current state
        var getState = function getState() {
            return Object.assign({}, state);
        };
        // returns a duplicate of the actions array and clears the actions array
        var processActionQueue = function processActionQueue() {
            // create copy of actions queue
            var queue = [].concat(actionQueue);
            // clear actions queue (we don't want no double actions)
            actionQueue.length = 0;
            return queue;
        };
        // processes actions that might block the main UI thread
        var processDispatchQueue = function processDispatchQueue() {
            // create copy of actions queue
            var queue = [].concat(dispatchQueue);
            // clear actions queue (we don't want no double actions)
            dispatchQueue.length = 0;
            // now dispatch these actions
            queue.forEach(function(_ref) {
                var type = _ref.type, data = _ref.data;
                dispatch(type, data);
            });
        };
        // adds a new action, calls its handler and
        var dispatch = function dispatch(type, data, isBlocking) {
            // is blocking action (should never block if document is hidden)
            if (isBlocking && !document.hidden) {
                dispatchQueue.push({
                    type: type,
                    data: data
                });
                return;
            }
            // if this action has a handler, handle the action
            if (actionHandlers[type]) actionHandlers[type](data);
            // now add action
            actionQueue.push({
                type: type,
                data: data
            });
        };
        var query = function query(str) {
            var _queryHandles;
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return queryHandles[str] ? (_queryHandles = queryHandles)[str].apply(_queryHandles, args) : null;
        };
        var api = {
            getState: getState,
            processActionQueue: processActionQueue,
            processDispatchQueue: processDispatchQueue,
            dispatch: dispatch,
            query: query
        };
        var queryHandles = {};
        queries.forEach(function(query) {
            queryHandles = Object.assign({}, query(state), {}, queryHandles);
        });
        var actionHandlers = {};
        actions.forEach(function(action) {
            actionHandlers = Object.assign({}, action(dispatch, query, state), {}, actionHandlers);
        });
        return api;
    };
    var defineProperty = function defineProperty(obj, property, definition) {
        if (typeof definition === "function") {
            obj[property] = definition;
            return;
        }
        Object.defineProperty(obj, property, Object.assign({}, definition));
    };
    var forin = function forin(obj, cb) {
        for(var key in obj){
            if (!obj.hasOwnProperty(key)) continue;
            cb(key, obj[key]);
        }
    };
    var createObject = function createObject(definition) {
        var obj = {};
        forin(definition, function(property) {
            defineProperty(obj, property, definition[property]);
        });
        return obj;
    };
    var attr = function attr(node, name) {
        var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (value === null) return node.getAttribute(name) || node.hasAttribute(name);
        node.setAttribute(name, value);
    };
    var ns = "http://www.w3.org/2000/svg";
    var svgElements = [
        "svg",
        "path"
    ]; // only svg elements used
    var isSVGElement = function isSVGElement(tag) {
        return svgElements.includes(tag);
    };
    var createElement = function createElement(tag, className) {
        var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (typeof className === "object") {
            attributes = className;
            className = null;
        }
        var element = isSVGElement(tag) ? document.createElementNS(ns, tag) : document.createElement(tag);
        if (className) {
            if (isSVGElement(tag)) attr(element, "class", className);
            else element.className = className;
        }
        forin(attributes, function(name, value) {
            attr(element, name, value);
        });
        return element;
    };
    var appendChild = function appendChild(parent) {
        return function(child, index) {
            if (typeof index !== "undefined" && parent.children[index]) parent.insertBefore(child, parent.children[index]);
            else parent.appendChild(child);
        };
    };
    var appendChildView = function appendChildView(parent, childViews) {
        return function(view, index) {
            if (typeof index !== "undefined") childViews.splice(index, 0, view);
            else childViews.push(view);
            return view;
        };
    };
    var removeChildView = function removeChildView(parent, childViews) {
        return function(view) {
            // remove from child views
            childViews.splice(childViews.indexOf(view), 1);
            // remove the element
            if (view.element.parentNode) parent.removeChild(view.element);
            return view;
        };
    };
    var IS_BROWSER = function() {
        return typeof window !== "undefined" && typeof window.document !== "undefined";
    }();
    var isBrowser = function isBrowser() {
        return IS_BROWSER;
    };
    var testElement = isBrowser() ? createElement("svg") : {};
    var getChildCount = "children" in testElement ? function(el) {
        return el.children.length;
    } : function(el) {
        return el.childNodes.length;
    };
    var getViewRect = function getViewRect(elementRect, childViews, offset, scale) {
        var left = offset[0] || elementRect.left;
        var top = offset[1] || elementRect.top;
        var right = left + elementRect.width;
        var bottom = top + elementRect.height * (scale[1] || 1);
        var rect = {
            // the rectangle of the element itself
            element: Object.assign({}, elementRect),
            // the rectangle of the element expanded to contain its children, does not include any margins
            inner: {
                left: elementRect.left,
                top: elementRect.top,
                right: elementRect.right,
                bottom: elementRect.bottom
            },
            // the rectangle of the element expanded to contain its children including own margin and child margins
            // margins will be added after we've recalculated the size
            outer: {
                left: left,
                top: top,
                right: right,
                bottom: bottom
            }
        };
        // expand rect to fit all child rectangles
        childViews.filter(function(childView) {
            return !childView.isRectIgnored();
        }).map(function(childView) {
            return childView.rect;
        }).forEach(function(childViewRect) {
            expandRect(rect.inner, Object.assign({}, childViewRect.inner));
            expandRect(rect.outer, Object.assign({}, childViewRect.outer));
        });
        // calculate inner width and height
        calculateRectSize(rect.inner);
        // append additional margin (top and left margins are included in top and left automatically)
        rect.outer.bottom += rect.element.marginBottom;
        rect.outer.right += rect.element.marginRight;
        // calculate outer width and height
        calculateRectSize(rect.outer);
        return rect;
    };
    var expandRect = function expandRect(parent, child) {
        // adjust for parent offset
        child.top += parent.top;
        child.right += parent.left;
        child.bottom += parent.top;
        child.left += parent.left;
        if (child.bottom > parent.bottom) parent.bottom = child.bottom;
        if (child.right > parent.right) parent.right = child.right;
    };
    var calculateRectSize = function calculateRectSize(rect) {
        rect.width = rect.right - rect.left;
        rect.height = rect.bottom - rect.top;
    };
    var isNumber = function isNumber(value) {
        return typeof value === "number";
    };
    /**
     * Determines if position is at destination
     * @param position
     * @param destination
     * @param velocity
     * @param errorMargin
     * @returns {boolean}
     */ var thereYet = function thereYet(position, destination, velocity) {
        var errorMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.001;
        return Math.abs(position - destination) < errorMargin && Math.abs(velocity) < errorMargin;
    };
    /**
     * Spring animation
     */ var spring = // default options
    function spring() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$stiffness = _ref.stiffness, stiffness = _ref$stiffness === void 0 ? 0.5 : _ref$stiffness, _ref$damping = _ref.damping, damping = _ref$damping === void 0 ? 0.75 : _ref$damping, _ref$mass = _ref.mass, mass = _ref$mass === void 0 ? 10 : _ref$mass;
        var target = null;
        var position = null;
        var velocity = 0;
        var resting = false;
        // updates spring state
        var interpolate = function interpolate(ts, skipToEndState) {
            // in rest, don't animate
            if (resting) return;
            // need at least a target or position to do springy things
            if (!(isNumber(target) && isNumber(position))) {
                resting = true;
                velocity = 0;
                return;
            }
            // calculate spring force
            var f = -(position - target) * stiffness;
            // update velocity by adding force based on mass
            velocity += f / mass;
            // update position by adding velocity
            position += velocity;
            // slow down based on amount of damping
            velocity *= damping;
            // we've arrived if we're near target and our velocity is near zero
            if (thereYet(position, target, velocity) || skipToEndState) {
                position = target;
                velocity = 0;
                resting = true;
                // we done
                api.onupdate(position);
                api.oncomplete(position);
            } else // progress update
            api.onupdate(position);
        };
        /**
             * Set new target value
             * @param value
             */ var setTarget = function setTarget(value) {
            // if currently has no position, set target and position to this value
            if (isNumber(value) && !isNumber(position)) position = value;
            // next target value will not be animated to
            if (target === null) {
                target = value;
                position = value;
            }
            // let start moving to target
            target = value;
            // already at target
            if (position === target || typeof target === "undefined") {
                // now resting as target is current position, stop moving
                resting = true;
                velocity = 0;
                // done!
                api.onupdate(position);
                api.oncomplete(position);
                return;
            }
            resting = false;
        };
        // need 'api' to call onupdate callback
        var api = createObject({
            interpolate: interpolate,
            target: {
                set: setTarget,
                get: function get() {
                    return target;
                }
            },
            resting: {
                get: function get() {
                    return resting;
                }
            },
            onupdate: function onupdate(value) {},
            oncomplete: function oncomplete(value) {}
        });
        return api;
    };
    var easeLinear = function easeLinear(t) {
        return t;
    };
    var easeInOutQuad = function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    };
    var tween = // default values
    function tween() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 500 : _ref$duration, _ref$easing = _ref.easing, easing = _ref$easing === void 0 ? easeInOutQuad : _ref$easing, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay;
        var start = null;
        var t;
        var p;
        var resting = true;
        var reverse = false;
        var target = null;
        var interpolate = function interpolate(ts, skipToEndState) {
            if (resting || target === null) return;
            if (start === null) start = ts;
            if (ts - start < delay) return;
            t = ts - start - delay;
            if (t >= duration || skipToEndState) {
                t = 1;
                p = reverse ? 0 : 1;
                api.onupdate(p * target);
                api.oncomplete(p * target);
                resting = true;
            } else {
                p = t / duration;
                api.onupdate((t >= 0 ? easing(reverse ? 1 - p : p) : 0) * target);
            }
        };
        // need 'api' to call onupdate callback
        var api = createObject({
            interpolate: interpolate,
            target: {
                get: function get() {
                    return reverse ? 0 : target;
                },
                set: function set(value) {
                    // is initial value
                    if (target === null) {
                        target = value;
                        api.onupdate(value);
                        api.oncomplete(value);
                        return;
                    }
                    // want to tween to a smaller value and have a current value
                    if (value < target) {
                        target = 1;
                        reverse = true;
                    } else {
                        // not tweening to a smaller value
                        reverse = false;
                        target = value;
                    }
                    // let's go!
                    resting = false;
                    start = null;
                }
            },
            resting: {
                get: function get() {
                    return resting;
                }
            },
            onupdate: function onupdate(value) {},
            oncomplete: function oncomplete(value) {}
        });
        return api;
    };
    var animator = {
        spring: spring,
        tween: tween
    };
    /*
                       { type: 'spring', stiffness: .5, damping: .75, mass: 10 };
                       { translation: { type: 'spring', ... }, ... }
                       { translation: { x: { type: 'spring', ... } } }
                      */ var createAnimator = function createAnimator(definition, category, property) {
        // default is single definition
        // we check if transform is set, if so, we check if property is set
        var def = definition[category] && typeof definition[category][property] === "object" ? definition[category][property] : definition[category] || definition;
        var type = typeof def === "string" ? def : def.type;
        var props = typeof def === "object" ? Object.assign({}, def) : {};
        return animator[type] ? animator[type](props) : null;
    };
    var addGetSet = function addGetSet(keys, obj, props) {
        var overwrite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        obj = Array.isArray(obj) ? obj : [
            obj
        ];
        obj.forEach(function(o) {
            keys.forEach(function(key) {
                var name = key;
                var getter = function getter() {
                    return props[key];
                };
                var setter = function setter(value) {
                    return props[key] = value;
                };
                if (typeof key === "object") {
                    name = key.key;
                    getter = key.getter || getter;
                    setter = key.setter || setter;
                }
                if (o[name] && !overwrite) return;
                o[name] = {
                    get: getter,
                    set: setter
                };
            });
        });
    };
    // add to state,
    // add getters and setters to internal and external api (if not set)
    // setup animators
    var animations = function animations(_ref) {
        var mixinConfig = _ref.mixinConfig, viewProps = _ref.viewProps, viewInternalAPI = _ref.viewInternalAPI, viewExternalAPI = _ref.viewExternalAPI;
        // initial properties
        var initialProps = Object.assign({}, viewProps);
        // list of all active animations
        var animations = [];
        // setup animators
        forin(mixinConfig, function(property, animation) {
            var animator = createAnimator(animation);
            if (!animator) return;
            // when the animator updates, update the view state value
            animator.onupdate = function(value) {
                viewProps[property] = value;
            };
            // set animator target
            animator.target = initialProps[property];
            // when value is set, set the animator target value
            var prop = {
                key: property,
                setter: function setter(value) {
                    // if already at target, we done!
                    if (animator.target === value) return;
                    animator.target = value;
                },
                getter: function getter() {
                    return viewProps[property];
                }
            };
            // add getters and setters
            addGetSet([
                prop
            ], [
                viewInternalAPI,
                viewExternalAPI
            ], viewProps, true);
            // add it to the list for easy updating from the _write method
            animations.push(animator);
        });
        // expose internal write api
        return {
            write: function write(ts) {
                var skipToEndState = document.hidden;
                var resting = true;
                animations.forEach(function(animation) {
                    if (!animation.resting) resting = false;
                    animation.interpolate(ts, skipToEndState);
                });
                return resting;
            },
            destroy: function destroy() {}
        };
    };
    var addEvent = function addEvent(element) {
        return function(type, fn) {
            element.addEventListener(type, fn);
        };
    };
    var removeEvent = function removeEvent(element) {
        return function(type, fn) {
            element.removeEventListener(type, fn);
        };
    };
    // mixin
    var listeners = function listeners(_ref) {
        var mixinConfig = _ref.mixinConfig, viewProps = _ref.viewProps, viewInternalAPI = _ref.viewInternalAPI, viewExternalAPI = _ref.viewExternalAPI, viewState = _ref.viewState, view = _ref.view;
        var events = [];
        var add = addEvent(view.element);
        var remove = removeEvent(view.element);
        viewExternalAPI.on = function(type, fn) {
            events.push({
                type: type,
                fn: fn
            });
            add(type, fn);
        };
        viewExternalAPI.off = function(type, fn) {
            events.splice(events.findIndex(function(event) {
                return event.type === type && event.fn === fn;
            }), 1);
            remove(type, fn);
        };
        return {
            write: function write() {
                // not busy
                return true;
            },
            destroy: function destroy() {
                events.forEach(function(event) {
                    remove(event.type, event.fn);
                });
            }
        };
    };
    // add to external api and link to props
    var apis = function apis(_ref) {
        var mixinConfig = _ref.mixinConfig, viewProps = _ref.viewProps, viewExternalAPI = _ref.viewExternalAPI;
        addGetSet(mixinConfig, viewExternalAPI, viewProps);
    };
    var isDefined = function isDefined(value) {
        return value != null;
    };
    // add to state,
    // add getters and setters to internal and external api (if not set)
    // set initial state based on props in viewProps
    // apply as transforms each frame
    var defaults = {
        opacity: 1,
        scaleX: 1,
        scaleY: 1,
        translateX: 0,
        translateY: 0,
        rotateX: 0,
        rotateY: 0,
        rotateZ: 0,
        originX: 0,
        originY: 0
    };
    var styles = function styles(_ref) {
        var mixinConfig = _ref.mixinConfig, viewProps = _ref.viewProps, viewInternalAPI = _ref.viewInternalAPI, viewExternalAPI = _ref.viewExternalAPI, view = _ref.view;
        // initial props
        var initialProps = Object.assign({}, viewProps);
        // current props
        var currentProps = {};
        // we will add those properties to the external API and link them to the viewState
        addGetSet(mixinConfig, [
            viewInternalAPI,
            viewExternalAPI
        ], viewProps);
        // override rect on internal and external rect getter so it takes in account transforms
        var getOffset = function getOffset() {
            return [
                viewProps["translateX"] || 0,
                viewProps["translateY"] || 0
            ];
        };
        var getScale = function getScale() {
            return [
                viewProps["scaleX"] || 0,
                viewProps["scaleY"] || 0
            ];
        };
        var getRect = function getRect() {
            return view.rect ? getViewRect(view.rect, view.childViews, getOffset(), getScale()) : null;
        };
        viewInternalAPI.rect = {
            get: getRect
        };
        viewExternalAPI.rect = {
            get: getRect
        };
        // apply view props
        mixinConfig.forEach(function(key) {
            viewProps[key] = typeof initialProps[key] === "undefined" ? defaults[key] : initialProps[key];
        });
        // expose api
        return {
            write: function write() {
                // see if props have changed
                if (!propsHaveChanged(currentProps, viewProps)) return;
                // moves element to correct position on screen
                applyStyles(view.element, viewProps);
                // store new transforms
                Object.assign(currentProps, Object.assign({}, viewProps));
                // no longer busy
                return true;
            },
            destroy: function destroy() {}
        };
    };
    var propsHaveChanged = function propsHaveChanged(currentProps, newProps) {
        // different amount of keys
        if (Object.keys(currentProps).length !== Object.keys(newProps).length) return true;
        // lets analyze the individual props
        for(var prop in newProps){
            if (newProps[prop] !== currentProps[prop]) return true;
        }
        return false;
    };
    var applyStyles = function applyStyles(element, _ref2) {
        var opacity = _ref2.opacity, perspective = _ref2.perspective, translateX = _ref2.translateX, translateY = _ref2.translateY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, rotateX = _ref2.rotateX, rotateY = _ref2.rotateY, rotateZ = _ref2.rotateZ, originX = _ref2.originX, originY = _ref2.originY, width = _ref2.width, height = _ref2.height;
        var transforms = "";
        var styles = "";
        // handle transform origin
        if (isDefined(originX) || isDefined(originY)) styles += "transform-origin: " + (originX || 0) + "px " + (originY || 0) + "px;";
        // transform order is relevant
        // 0. perspective
        if (isDefined(perspective)) transforms += "perspective(" + perspective + "px) ";
        // 1. translate
        if (isDefined(translateX) || isDefined(translateY)) transforms += "translate3d(" + (translateX || 0) + "px, " + (translateY || 0) + "px, 0) ";
        // 2. scale
        if (isDefined(scaleX) || isDefined(scaleY)) transforms += "scale3d(" + (isDefined(scaleX) ? scaleX : 1) + ", " + (isDefined(scaleY) ? scaleY : 1) + ", 1) ";
        // 3. rotate
        if (isDefined(rotateZ)) transforms += "rotateZ(" + rotateZ + "rad) ";
        if (isDefined(rotateX)) transforms += "rotateX(" + rotateX + "rad) ";
        if (isDefined(rotateY)) transforms += "rotateY(" + rotateY + "rad) ";
        // add transforms
        if (transforms.length) styles += "transform:" + transforms + ";";
        // add opacity
        if (isDefined(opacity)) {
            styles += "opacity:" + opacity + ";";
            // if we reach zero, we make the element inaccessible
            if (opacity === 0) styles += "visibility:hidden;";
            // if we're below 100% opacity this element can't be clicked
            if (opacity < 1) styles += "pointer-events:none;";
        }
        // add height
        if (isDefined(height)) styles += "height:" + height + "px;";
        // add width
        if (isDefined(width)) styles += "width:" + width + "px;";
        // apply styles
        var elementCurrentStyle = element.elementCurrentStyle || "";
        // if new styles does not match current styles, lets update!
        if (styles.length !== elementCurrentStyle.length || styles !== elementCurrentStyle) {
            element.style.cssText = styles;
            // store current styles so we can compare them to new styles later on
            // _not_ getting the style value is faster
            element.elementCurrentStyle = styles;
        }
    };
    var Mixins = {
        styles: styles,
        listeners: listeners,
        animations: animations,
        apis: apis
    };
    var updateRect = function updateRect() {
        var rect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!element.layoutCalculated) {
            rect.paddingTop = parseInt(style.paddingTop, 10) || 0;
            rect.marginTop = parseInt(style.marginTop, 10) || 0;
            rect.marginRight = parseInt(style.marginRight, 10) || 0;
            rect.marginBottom = parseInt(style.marginBottom, 10) || 0;
            rect.marginLeft = parseInt(style.marginLeft, 10) || 0;
            element.layoutCalculated = true;
        }
        rect.left = element.offsetLeft || 0;
        rect.top = element.offsetTop || 0;
        rect.width = element.offsetWidth || 0;
        rect.height = element.offsetHeight || 0;
        rect.right = rect.left + rect.width;
        rect.bottom = rect.top + rect.height;
        rect.scrollTop = element.scrollTop;
        rect.hidden = element.offsetParent === null;
        return rect;
    };
    var createView = // default view definition
    function createView() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$tag = _ref.tag, tag = _ref$tag === void 0 ? "div" : _ref$tag, _ref$name = _ref.name, name = _ref$name === void 0 ? null : _ref$name, _ref$attributes = _ref.attributes, attributes = _ref$attributes === void 0 ? {} : _ref$attributes, _ref$read = _ref.read, read = _ref$read === void 0 ? function() {} : _ref$read, _ref$write = _ref.write, write = _ref$write === void 0 ? function() {} : _ref$write, _ref$create = _ref.create, create = _ref$create === void 0 ? function() {} : _ref$create, _ref$destroy = _ref.destroy, destroy = _ref$destroy === void 0 ? function() {} : _ref$destroy, _ref$filterFrameActio = _ref.filterFrameActionsForChild, filterFrameActionsForChild = _ref$filterFrameActio === void 0 ? function(child, actions) {
            return actions;
        } : _ref$filterFrameActio, _ref$didCreateView = _ref.didCreateView, didCreateView = _ref$didCreateView === void 0 ? function() {} : _ref$didCreateView, _ref$didWriteView = _ref.didWriteView, didWriteView = _ref$didWriteView === void 0 ? function() {} : _ref$didWriteView, _ref$ignoreRect = _ref.ignoreRect, ignoreRect = _ref$ignoreRect === void 0 ? false : _ref$ignoreRect, _ref$ignoreRectUpdate = _ref.ignoreRectUpdate, ignoreRectUpdate = _ref$ignoreRectUpdate === void 0 ? false : _ref$ignoreRectUpdate, _ref$mixins = _ref.mixins, mixins = _ref$mixins === void 0 ? [] : _ref$mixins;
        return function(// each view requires reference to store
        store) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            // root element should not be changed
            var element = createElement(tag, "filepond--" + name, attributes);
            // style reference should also not be changed
            var style = window.getComputedStyle(element, null);
            // element rectangle
            var rect = updateRect();
            var frameRect = null;
            // rest state
            var isResting = false;
            // pretty self explanatory
            var childViews = [];
            // loaded mixins
            var activeMixins = [];
            // references to created children
            var ref = {};
            // state used for each instance
            var state = {};
            // list of writers that will be called to update this view
            var writers = [
                write
            ];
            var readers = [
                read
            ];
            var destroyers = [
                destroy
            ];
            // core view methods
            var getElement = function getElement() {
                return element;
            };
            var getChildViews = function getChildViews() {
                return childViews.concat();
            };
            var getReference = function getReference() {
                return ref;
            };
            var createChildView = function createChildView(store) {
                return function(view, props) {
                    return view(store, props);
                };
            };
            var getRect = function getRect() {
                if (frameRect) return frameRect;
                frameRect = getViewRect(rect, childViews, [
                    0,
                    0
                ], [
                    1,
                    1
                ]);
                return frameRect;
            };
            var getStyle = function getStyle() {
                return style;
            };
            /**
                 * Read data from DOM
                 * @private
                 */ var _read = function _read() {
                frameRect = null;
                // read child views
                childViews.forEach(function(child) {
                    return child._read();
                });
                var shouldUpdate = !(ignoreRectUpdate && rect.width && rect.height);
                if (shouldUpdate) updateRect(rect, element, style);
                // readers
                var api = {
                    root: internalAPI,
                    props: props,
                    rect: rect
                };
                readers.forEach(function(reader) {
                    return reader(api);
                });
            };
            /**
                 * Write data to DOM
                 * @private
                 */ var _write = function _write(ts, frameActions, shouldOptimize) {
                // if no actions, we assume that the view is resting
                var resting = frameActions.length === 0;
                // writers
                writers.forEach(function(writer) {
                    var writerResting = writer({
                        props: props,
                        root: internalAPI,
                        actions: frameActions,
                        timestamp: ts,
                        shouldOptimize: shouldOptimize
                    });
                    if (writerResting === false) resting = false;
                });
                // run mixins
                activeMixins.forEach(function(mixin) {
                    // if one of the mixins is still busy after write operation, we are not resting
                    var mixinResting = mixin.write(ts);
                    if (mixinResting === false) resting = false;
                });
                // updates child views that are currently attached to the DOM
                childViews.filter(function(child) {
                    return !!child.element.parentNode;
                }).forEach(function(child) {
                    // if a child view is not resting, we are not resting
                    var childResting = child._write(ts, filterFrameActionsForChild(child, frameActions), shouldOptimize);
                    if (!childResting) resting = false;
                });
                // append new elements to DOM and update those
                childViews//.filter(child => !child.element.parentNode)
                .forEach(function(child, index) {
                    // skip
                    if (child.element.parentNode) return;
                    // append to DOM
                    internalAPI.appendChild(child.element, index);
                    // call read (need to know the size of these elements)
                    child._read();
                    // re-call write
                    child._write(ts, filterFrameActionsForChild(child, frameActions), shouldOptimize);
                    // we just added somthing to the dom, no rest
                    resting = false;
                });
                // update resting state
                isResting = resting;
                didWriteView({
                    props: props,
                    root: internalAPI,
                    actions: frameActions,
                    timestamp: ts
                });
                // let parent know if we are resting
                return resting;
            };
            var _destroy = function _destroy() {
                activeMixins.forEach(function(mixin) {
                    return mixin.destroy();
                });
                destroyers.forEach(function(destroyer) {
                    destroyer({
                        root: internalAPI,
                        props: props
                    });
                });
                childViews.forEach(function(child) {
                    return child._destroy();
                });
            };
            // sharedAPI
            var sharedAPIDefinition = {
                element: {
                    get: getElement
                },
                style: {
                    get: getStyle
                },
                childViews: {
                    get: getChildViews
                }
            };
            // private API definition
            var internalAPIDefinition = Object.assign({}, sharedAPIDefinition, {
                rect: {
                    get: getRect
                },
                // access to custom children references
                ref: {
                    get: getReference
                },
                // dom modifiers
                is: function is(needle) {
                    return name === needle;
                },
                appendChild: appendChild(element),
                createChildView: createChildView(store),
                linkView: function linkView(view) {
                    childViews.push(view);
                    return view;
                },
                unlinkView: function unlinkView(view) {
                    childViews.splice(childViews.indexOf(view), 1);
                },
                appendChildView: appendChildView(element, childViews),
                removeChildView: removeChildView(element, childViews),
                registerWriter: function registerWriter(writer) {
                    return writers.push(writer);
                },
                registerReader: function registerReader(reader) {
                    return readers.push(reader);
                },
                registerDestroyer: function registerDestroyer(destroyer) {
                    return destroyers.push(destroyer);
                },
                invalidateLayout: function invalidateLayout() {
                    return element.layoutCalculated = false;
                },
                // access to data store
                dispatch: store.dispatch,
                query: store.query
            });
            // public view API methods
            var externalAPIDefinition = {
                element: {
                    get: getElement
                },
                childViews: {
                    get: getChildViews
                },
                rect: {
                    get: getRect
                },
                resting: {
                    get: function get() {
                        return isResting;
                    }
                },
                isRectIgnored: function isRectIgnored() {
                    return ignoreRect;
                },
                _read: _read,
                _write: _write,
                _destroy: _destroy
            };
            // mixin API methods
            var mixinAPIDefinition = Object.assign({}, sharedAPIDefinition, {
                rect: {
                    get: function get() {
                        return rect;
                    }
                }
            });
            // add mixin functionality
            Object.keys(mixins).sort(function(a, b) {
                // move styles to the back of the mixin list (so adjustments of other mixins are applied to the props correctly)
                if (a === "styles") return 1;
                else if (b === "styles") return -1;
                return 0;
            }).forEach(function(key) {
                var mixinAPI = Mixins[key]({
                    mixinConfig: mixins[key],
                    viewProps: props,
                    viewState: state,
                    viewInternalAPI: internalAPIDefinition,
                    viewExternalAPI: externalAPIDefinition,
                    view: createObject(mixinAPIDefinition)
                });
                if (mixinAPI) activeMixins.push(mixinAPI);
            });
            // construct private api
            var internalAPI = createObject(internalAPIDefinition);
            // create the view
            create({
                root: internalAPI,
                props: props
            });
            // append created child views to root node
            var childCount = getChildCount(element); // need to know the current child count so appending happens in correct order
            childViews.forEach(function(child, index) {
                internalAPI.appendChild(child.element, childCount + index);
            });
            // call did create
            didCreateView(internalAPI);
            // expose public api
            return createObject(externalAPIDefinition);
        };
    };
    var createPainter = function createPainter(read, write) {
        var fps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60;
        var name = "__framePainter";
        // set global painter
        if (window[name]) {
            window[name].readers.push(read);
            window[name].writers.push(write);
            return;
        }
        window[name] = {
            readers: [
                read
            ],
            writers: [
                write
            ]
        };
        var painter = window[name];
        var interval = 1000 / fps;
        var last = null;
        var id = null;
        var requestTick = null;
        var cancelTick = null;
        var setTimerType = function setTimerType() {
            if (document.hidden) {
                requestTick = function requestTick() {
                    return window.setTimeout(function() {
                        return tick(performance.now());
                    }, interval);
                };
                cancelTick = function cancelTick() {
                    return window.clearTimeout(id);
                };
            } else {
                requestTick = function requestTick() {
                    return window.requestAnimationFrame(tick);
                };
                cancelTick = function cancelTick() {
                    return window.cancelAnimationFrame(id);
                };
            }
        };
        document.addEventListener("visibilitychange", function() {
            if (cancelTick) cancelTick();
            setTimerType();
            tick(performance.now());
        });
        var tick = function tick(ts) {
            // queue next tick
            id = requestTick(tick);
            // limit fps
            if (!last) last = ts;
            var delta = ts - last;
            if (delta <= interval) // skip frame
            return;
            // align next frame
            last = ts - delta % interval;
            // update view
            painter.readers.forEach(function(read) {
                return read();
            });
            painter.writers.forEach(function(write) {
                return write(ts);
            });
        };
        setTimerType();
        tick(performance.now());
        return {
            pause: function pause() {
                cancelTick(id);
            }
        };
    };
    var createRoute = function createRoute(routes, fn) {
        return function(_ref) {
            var root = _ref.root, props = _ref.props, _ref$actions = _ref.actions, actions = _ref$actions === void 0 ? [] : _ref$actions, timestamp = _ref.timestamp, shouldOptimize = _ref.shouldOptimize;
            actions.filter(function(action) {
                return routes[action.type];
            }).forEach(function(action) {
                return routes[action.type]({
                    root: root,
                    props: props,
                    action: action.data,
                    timestamp: timestamp,
                    shouldOptimize: shouldOptimize
                });
            });
            if (fn) fn({
                root: root,
                props: props,
                actions: actions,
                timestamp: timestamp,
                shouldOptimize: shouldOptimize
            });
        };
    };
    var insertBefore = function insertBefore(newNode, referenceNode) {
        return referenceNode.parentNode.insertBefore(newNode, referenceNode);
    };
    var insertAfter = function insertAfter(newNode, referenceNode) {
        return referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    };
    var isArray = function isArray(value) {
        return Array.isArray(value);
    };
    var isEmpty = function isEmpty(value) {
        return value == null;
    };
    var trim = function trim(str) {
        return str.trim();
    };
    var toString = function toString(value) {
        return "" + value;
    };
    var toArray = function toArray(value) {
        var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
        if (isEmpty(value)) return [];
        if (isArray(value)) return value;
        return toString(value).split(splitter).map(trim).filter(function(str) {
            return str.length;
        });
    };
    var isBoolean = function isBoolean(value) {
        return typeof value === "boolean";
    };
    var toBoolean = function toBoolean(value) {
        return isBoolean(value) ? value : value === "true";
    };
    var isString = function isString(value) {
        return typeof value === "string";
    };
    var toNumber = function toNumber(value) {
        return isNumber(value) ? value : isString(value) ? toString(value).replace(/[a-z]+/gi, "") : 0;
    };
    var toInt = function toInt(value) {
        return parseInt(toNumber(value), 10);
    };
    var toFloat = function toFloat(value) {
        return parseFloat(toNumber(value));
    };
    var isInt = function isInt(value) {
        return isNumber(value) && isFinite(value) && Math.floor(value) === value;
    };
    var toBytes = function toBytes(value) {
        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
        // is in bytes
        if (isInt(value)) return value;
        // is natural file size
        var naturalFileSize = toString(value).trim();
        // if is value in megabytes
        if (/MB$/i.test(naturalFileSize)) {
            naturalFileSize = naturalFileSize.replace(/MB$i/, "").trim();
            return toInt(naturalFileSize) * base * base;
        }
        // if is value in kilobytes
        if (/KB/i.test(naturalFileSize)) {
            naturalFileSize = naturalFileSize.replace(/KB$i/, "").trim();
            return toInt(naturalFileSize) * base;
        }
        return toInt(naturalFileSize);
    };
    var isFunction = function isFunction(value) {
        return typeof value === "function";
    };
    var toFunctionReference = function toFunctionReference(string) {
        var ref = self;
        var levels = string.split(".");
        var level = null;
        while(level = levels.shift()){
            ref = ref[level];
            if (!ref) return null;
        }
        return ref;
    };
    var methods = {
        process: "POST",
        patch: "PATCH",
        revert: "DELETE",
        fetch: "GET",
        restore: "GET",
        load: "GET"
    };
    var createServerAPI = function createServerAPI(outline) {
        var api = {};
        api.url = isString(outline) ? outline : outline.url || "";
        api.timeout = outline.timeout ? parseInt(outline.timeout, 10) : 0;
        api.headers = outline.headers ? outline.headers : {};
        forin(methods, function(key) {
            api[key] = createAction(key, outline[key], methods[key], api.timeout, api.headers);
        });
        // remove process if no url or process on outline
        api.process = outline.process || isString(outline) || outline.url ? api.process : null;
        // special treatment for remove
        api.remove = outline.remove || null;
        // remove generic headers from api object
        delete api.headers;
        return api;
    };
    var createAction = function createAction(name, outline, method, timeout, headers) {
        // is explicitely set to null so disable
        if (outline === null) return null;
        // if is custom function, done! Dev handles everything.
        if (typeof outline === "function") return outline;
        // build action object
        var action = {
            url: method === "GET" || method === "PATCH" ? "?" + name + "=" : "",
            method: method,
            headers: headers,
            withCredentials: false,
            timeout: timeout,
            onload: null,
            ondata: null,
            onerror: null
        };
        // is a single url
        if (isString(outline)) {
            action.url = outline;
            return action;
        }
        // overwrite
        Object.assign(action, outline);
        // see if should reformat headers;
        if (isString(action.headers)) {
            var parts = action.headers.split(/:(.+)/);
            action.headers = {
                header: parts[0],
                value: parts[1]
            };
        }
        // if is bool withCredentials
        action.withCredentials = toBoolean(action.withCredentials);
        return action;
    };
    var toServerAPI = function toServerAPI(value) {
        return createServerAPI(value);
    };
    var isNull = function isNull(value) {
        return value === null;
    };
    var isObject = function isObject(value) {
        return typeof value === "object" && value !== null;
    };
    var isAPI = function isAPI(value) {
        return isObject(value) && isString(value.url) && isObject(value.process) && isObject(value.revert) && isObject(value.restore) && isObject(value.fetch);
    };
    var getType = function getType(value) {
        if (isArray(value)) return "array";
        if (isNull(value)) return "null";
        if (isInt(value)) return "int";
        if (/^[0-9]+ ?(?:GB|MB|KB)$/gi.test(value)) return "bytes";
        if (isAPI(value)) return "api";
        return typeof value;
    };
    var replaceSingleQuotes = function replaceSingleQuotes(str) {
        return str.replace(/{\s*'/g, '{"').replace(/'\s*}/g, '"}').replace(/'\s*:/g, '":').replace(/:\s*'/g, ':"').replace(/,\s*'/g, ',"').replace(/'\s*,/g, '",');
    };
    var conversionTable = {
        array: toArray,
        boolean: toBoolean,
        int: function int(value) {
            return getType(value) === "bytes" ? toBytes(value) : toInt(value);
        },
        number: toFloat,
        float: toFloat,
        bytes: toBytes,
        string: function string(value) {
            return isFunction(value) ? value : toString(value);
        },
        function: function _function(value) {
            return toFunctionReference(value);
        },
        serverapi: toServerAPI,
        object: function object(value) {
            try {
                return JSON.parse(replaceSingleQuotes(value));
            } catch (e) {
                return null;
            }
        }
    };
    var convertTo = function convertTo(value, type) {
        return conversionTable[type](value);
    };
    var getValueByType = function getValueByType(newValue, defaultValue, valueType) {
        // can always assign default value
        if (newValue === defaultValue) return newValue;
        // get the type of the new value
        var newValueType = getType(newValue);
        // is valid type?
        if (newValueType !== valueType) {
            // is string input, let's attempt to convert
            var convertedValue = convertTo(newValue, valueType);
            // what is the type now
            newValueType = getType(convertedValue);
            // no valid conversions found
            if (convertedValue === null) throw 'Trying to assign value with incorrect type to "' + option + '", allowed type: "' + valueType + '"';
            else newValue = convertedValue;
        }
        // assign new value
        return newValue;
    };
    var createOption = function createOption(defaultValue, valueType) {
        var currentValue = defaultValue;
        return {
            enumerable: true,
            get: function get() {
                return currentValue;
            },
            set: function set(newValue) {
                currentValue = getValueByType(newValue, defaultValue, valueType);
            }
        };
    };
    var createOptions = function createOptions(options) {
        var obj = {};
        forin(options, function(prop) {
            var optionDefinition = options[prop];
            obj[prop] = createOption(optionDefinition[0], optionDefinition[1]);
        });
        return createObject(obj);
    };
    var createInitialState = function createInitialState(options) {
        return {
            // model
            items: [],
            // timeout used for calling update items
            listUpdateTimeout: null,
            // timeout used for stacking metadata updates
            itemUpdateTimeout: null,
            // queue of items waiting to be processed
            processingQueue: [],
            // options
            options: createOptions(options)
        };
    };
    var fromCamels = function fromCamels(string) {
        var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
        return string.split(/(?=[A-Z])/).map(function(part) {
            return part.toLowerCase();
        }).join(separator);
    };
    var createOptionAPI = function createOptionAPI(store, options) {
        var obj = {};
        forin(options, function(key) {
            obj[key] = {
                get: function get() {
                    return store.getState().options[key];
                },
                set: function set(value) {
                    store.dispatch("SET_" + fromCamels(key, "_").toUpperCase(), {
                        value: value
                    });
                }
            };
        });
        return obj;
    };
    var createOptionActions = function createOptionActions(options) {
        return function(dispatch, query, state) {
            var obj = {};
            forin(options, function(key) {
                var name = fromCamels(key, "_").toUpperCase();
                obj["SET_" + name] = function(action) {
                    try {
                        state.options[key] = action.value;
                    } catch (e) {} // nope, failed
                    // we successfully set the value of this option
                    dispatch("DID_SET_" + name, {
                        value: state.options[key]
                    });
                };
            });
            return obj;
        };
    };
    var createOptionQueries = function createOptionQueries(options) {
        return function(state) {
            var obj = {};
            forin(options, function(key) {
                obj["GET_" + fromCamels(key, "_").toUpperCase()] = function(action) {
                    return state.options[key];
                };
            });
            return obj;
        };
    };
    var InteractionMethod = {
        API: 1,
        DROP: 2,
        BROWSE: 3,
        PASTE: 4,
        NONE: 5
    };
    var getUniqueId = function getUniqueId() {
        return Math.random().toString(36).substring(2, 11);
    };
    function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    var REACT_ELEMENT_TYPE;
    function _jsx(type, props, key, children) {
        if (!REACT_ELEMENT_TYPE) REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7;
        var defaultProps = type && type.defaultProps;
        var childrenLength = arguments.length - 3;
        if (!props && childrenLength !== 0) props = {
            children: void 0
        };
        if (props && defaultProps) {
            for(var propName in defaultProps)if (props[propName] === void 0) props[propName] = defaultProps[propName];
        } else if (!props) props = defaultProps || {};
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = new Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 3];
            props.children = childArray;
        }
        return {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key === undefined ? null : "" + key,
            ref: null,
            props: props,
            _owner: null
        };
    }
    function _asyncIterator(iterable) {
        var method;
        if (typeof Symbol !== "undefined") {
            if (Symbol.asyncIterator) {
                method = iterable[Symbol.asyncIterator];
                if (method != null) return method.call(iterable);
            }
            if (Symbol.iterator) {
                method = iterable[Symbol.iterator];
                if (method != null) return method.call(iterable);
            }
        }
        throw new TypeError("Object is not async iterable");
    }
    function _AwaitValue(value) {
        this.wrapped = value;
    }
    function _AsyncGenerator(gen) {
        var front, back;
        function send(key, arg) {
            return new Promise(function(resolve, reject) {
                var request = {
                    key: key,
                    arg: arg,
                    resolve: resolve,
                    reject: reject,
                    next: null
                };
                if (back) back = back.next = request;
                else {
                    front = back = request;
                    resume(key, arg);
                }
            });
        }
        function resume(key, arg) {
            try {
                var result = gen[key](arg);
                var value = result.value;
                var wrappedAwait = value instanceof _AwaitValue;
                Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                    if (wrappedAwait) {
                        resume("next", arg);
                        return;
                    }
                    settle(result.done ? "return" : "normal", arg);
                }, function(err) {
                    resume("throw", err);
                });
            } catch (err) {
                settle("throw", err);
            }
        }
        function settle(type, value) {
            switch(type){
                case "return":
                    front.resolve({
                        value: value,
                        done: true
                    });
                    break;
                case "throw":
                    front.reject(value);
                    break;
                default:
                    front.resolve({
                        value: value,
                        done: false
                    });
                    break;
            }
            front = front.next;
            if (front) resume(front.key, front.arg);
            else back = null;
        }
        this._invoke = send;
        if (typeof gen.return !== "function") this.return = undefined;
    }
    if (typeof Symbol === "function" && Symbol.asyncIterator) _AsyncGenerator.prototype[Symbol.asyncIterator] = function() {
        return this;
    };
    _AsyncGenerator.prototype.next = function(arg) {
        return this._invoke("next", arg);
    };
    _AsyncGenerator.prototype.throw = function(arg) {
        return this._invoke("throw", arg);
    };
    _AsyncGenerator.prototype.return = function(arg) {
        return this._invoke("return", arg);
    };
    function _wrapAsyncGenerator(fn) {
        return function() {
            return new _AsyncGenerator(fn.apply(this, arguments));
        };
    }
    function _awaitAsyncGenerator(value) {
        return new _AwaitValue(value);
    }
    function _asyncGeneratorDelegate(inner, awaitWrap) {
        var iter = {}, waiting = false;
        function pump(key, value) {
            waiting = true;
            value = new Promise(function(resolve) {
                resolve(inner[key](value));
            });
            return {
                done: false,
                value: awaitWrap(value)
            };
        }
        if (typeof Symbol === "function" && Symbol.iterator) iter[Symbol.iterator] = function() {
            return this;
        };
        iter.next = function(value) {
            if (waiting) {
                waiting = false;
                return value;
            }
            return pump("next", value);
        };
        if (typeof inner.throw === "function") iter.throw = function(value) {
            if (waiting) {
                waiting = false;
                throw value;
            }
            return pump("throw", value);
        };
        if (typeof inner.return === "function") iter.return = function(value) {
            return pump("return", value);
        };
        return iter;
    }
    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
            var info = gen[key](arg);
            var value = info.value;
        } catch (error) {
            reject(error);
            return;
        }
        if (info.done) resolve(value);
        else Promise.resolve(value).then(_next, _throw);
    }
    function _asyncToGenerator(fn) {
        return function() {
            var self1 = this, args = arguments;
            return new Promise(function(resolve, reject) {
                var gen = fn.apply(self1, args);
                function _next(value) {
                    asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                    asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(undefined);
            });
        };
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _defineEnumerableProperties(obj, descs) {
        for(var key in descs){
            var desc = descs[key];
            desc.configurable = desc.enumerable = true;
            if ("value" in desc) desc.writable = true;
            Object.defineProperty(obj, key, desc);
        }
        if (Object.getOwnPropertySymbols) {
            var objectSymbols = Object.getOwnPropertySymbols(descs);
            for(var i = 0; i < objectSymbols.length; i++){
                var sym = objectSymbols[i];
                var desc = descs[sym];
                desc.configurable = desc.enumerable = true;
                if ("value" in desc) desc.writable = true;
                Object.defineProperty(obj, sym, desc);
            }
        }
        return obj;
    }
    function _defaults(obj, defaults) {
        var keys = Object.getOwnPropertyNames(defaults);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = Object.getOwnPropertyDescriptor(defaults, key);
            if (value && value.configurable && obj[key] === undefined) Object.defineProperty(obj, key, value);
        }
        return obj;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);
            if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
            ownKeys.forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
        }
        return target;
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _isNativeFunction(fn) {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
    function _wrapNativeSuper(Class) {
        var _cache = typeof Map === "function" ? new Map() : undefined;
        _wrapNativeSuper = function _wrapNativeSuper(Class) {
            if (Class === null || !_isNativeFunction(Class)) return Class;
            if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof _cache !== "undefined") {
                if (_cache.has(Class)) return _cache.get(Class);
                _cache.set(Class, Wrapper);
            }
            function Wrapper() {
                return _construct(Class, arguments, _getPrototypeOf(this).constructor);
            }
            Wrapper.prototype = Object.create(Class.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            return _setPrototypeOf(Wrapper, Class);
        };
        return _wrapNativeSuper(Class);
    }
    function _instanceof(left, right) {
        if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
        else return left instanceof right;
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                    else newObj[key] = obj[key];
                }
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function _newArrowCheck(innerThis, boundThis) {
        if (innerThis !== boundThis) throw new TypeError("Cannot instantiate an arrow function");
    }
    function _objectDestructuringEmpty(obj) {
        if (obj == null) throw new TypeError("Cannot destructure undefined");
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _assertThisInitialized(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    function _possibleConstructorReturn(self1, call) {
        if (call && (typeof call === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self1);
    }
    function _superPropBase(object, property) {
        while(!Object.prototype.hasOwnProperty.call(object, property)){
            object = _getPrototypeOf(object);
            if (object === null) break;
        }
        return object;
    }
    function _get(target, property, receiver) {
        if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
        else _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) return desc.get.call(receiver);
            return desc.value;
        };
        return _get(target, property, receiver || target);
    }
    function set(target, property, value, receiver) {
        if (typeof Reflect !== "undefined" && Reflect.set) set = Reflect.set;
        else set = function set(target, property, value, receiver) {
            var base = _superPropBase(target, property);
            var desc;
            if (base) {
                desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.set) {
                    desc.set.call(receiver, value);
                    return true;
                } else if (!desc.writable) return false;
            }
            desc = Object.getOwnPropertyDescriptor(receiver, property);
            if (desc) {
                if (!desc.writable) return false;
                desc.value = value;
                Object.defineProperty(receiver, property, desc);
            } else _defineProperty(receiver, property, value);
            return true;
        };
        return set(target, property, value, receiver);
    }
    function _set(target, property, value, receiver, isStrict) {
        var s = set(target, property, value, receiver || target);
        if (!s && isStrict) throw new Error("failed to set property");
        return value;
    }
    function _taggedTemplateLiteral(strings, raw) {
        if (!raw) raw = strings.slice(0);
        return Object.freeze(Object.defineProperties(strings, {
            raw: {
                value: Object.freeze(raw)
            }
        }));
    }
    function _taggedTemplateLiteralLoose(strings, raw) {
        if (!raw) raw = strings.slice(0);
        strings.raw = raw;
        return strings;
    }
    function _temporalRef(val1, name) {
        if (val1 === _temporalUndefined) throw new ReferenceError(name + " is not defined - temporal dead zone");
        else return val1;
    }
    function _readOnlyError(name) {
        throw new Error('"' + name + '" is read-only');
    }
    function _classNameTDZError(name) {
        throw new Error('Class "' + name + '" cannot be referenced in computed property keys.');
    }
    var _temporalUndefined = {};
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
    }
    function _slicedToArrayLoose(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimitLoose(arr, i) || _nonIterableRest();
    }
    function _toArray(arr) {
        return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        }
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
    }
    function _iterableToArrayLimit(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _iterableToArrayLimitLoose(arr, i) {
        var _arr = [];
        for(var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;){
            _arr.push(_step.value);
            if (i && _arr.length === i) break;
        }
        return _arr;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
    function _skipFirstGeneratorNext(fn) {
        return function() {
            var it = fn.apply(this, arguments);
            it.next();
            return it;
        };
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function _initializerWarningHelper(descriptor, context) {
        throw new Error("Decorating class property failed. Please ensure that proposal-class-properties is enabled and set to use loose mode. To use proposal-class-properties in spec mode with decorators, wait for the next major version of decorators in stage 2.");
    }
    function _initializerDefineProperty(target, property, descriptor, context) {
        if (!descriptor) return;
        Object.defineProperty(target, property, {
            enumerable: descriptor.enumerable,
            configurable: descriptor.configurable,
            writable: descriptor.writable,
            value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
        });
    }
    function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
        var desc = {};
        Object.keys(descriptor).forEach(function(key) {
            desc[key] = descriptor[key];
        });
        desc.enumerable = !!desc.enumerable;
        desc.configurable = !!desc.configurable;
        if ("value" in desc || desc.initializer) desc.writable = true;
        desc = decorators.slice().reverse().reduce(function(desc, decorator) {
            return decorator(target, property, desc) || desc;
        }, desc);
        if (context && desc.initializer !== void 0) {
            desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
            desc.initializer = undefined;
        }
        if (desc.initializer === void 0) {
            Object.defineProperty(target, property, desc);
            desc = null;
        }
        return desc;
    }
    var id = 0;
    function _classPrivateFieldLooseKey(name) {
        return "__private_" + id++ + "_" + name;
    }
    function _classPrivateFieldLooseBase(receiver, privateKey) {
        if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
        return receiver;
    }
    function _classPrivateFieldGet(receiver, privateMap) {
        var descriptor = privateMap.get(receiver);
        if (!descriptor) throw new TypeError("attempted to get private field on non-instance");
        if (descriptor.get) return descriptor.get.call(receiver);
        return descriptor.value;
    }
    function _classPrivateFieldSet(receiver, privateMap, value) {
        var descriptor = privateMap.get(receiver);
        if (!descriptor) throw new TypeError("attempted to set private field on non-instance");
        if (descriptor.set) descriptor.set.call(receiver, value);
        else {
            if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
            descriptor.value = value;
        }
        return value;
    }
    function _classPrivateFieldDestructureSet(receiver, privateMap) {
        if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
        var descriptor = privateMap.get(receiver);
        if (descriptor.set) {
            if (!("__destrObj" in descriptor)) descriptor.__destrObj = {
                set value (v){
                    descriptor.set.call(receiver, v);
                }
            };
            return descriptor.__destrObj;
        } else {
            if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
            return descriptor;
        }
    }
    function _classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) {
        if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
        return descriptor.value;
    }
    function _classStaticPrivateFieldSpecSet(receiver, classConstructor, descriptor, value) {
        if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
        return value;
    }
    function _classStaticPrivateMethodGet(receiver, classConstructor, method) {
        if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
        return method;
    }
    function _classStaticPrivateMethodSet() {
        throw new TypeError("attempted to set read only static private field");
    }
    function _decorate(decorators, factory, superClass, mixins) {
        var api = _getDecoratorsApi();
        if (mixins) for(var i = 0; i < mixins.length; i++)api = mixins[i](api);
        var r = factory(function initialize(O) {
            api.initializeInstanceElements(O, decorated.elements);
        }, superClass);
        var decorated = api.decorateClass(_coalesceClassElements(r.d.map(_createElementDescriptor)), decorators);
        api.initializeClassElements(r.F, decorated.elements);
        return api.runClassFinishers(r.F, decorated.finishers);
    }
    function _getDecoratorsApi() {
        _getDecoratorsApi = function() {
            return api;
        };
        var api = {
            elementsDefinitionOrder: [
                [
                    "method"
                ],
                [
                    "field"
                ]
            ],
            initializeInstanceElements: function(O, elements) {
                [
                    "method",
                    "field"
                ].forEach(function(kind) {
                    elements.forEach(function(element) {
                        if (element.kind === kind && element.placement === "own") this.defineClassElement(O, element);
                    }, this);
                }, this);
            },
            initializeClassElements: function(F, elements) {
                var proto = F.prototype;
                [
                    "method",
                    "field"
                ].forEach(function(kind) {
                    elements.forEach(function(element) {
                        var placement = element.placement;
                        if (element.kind === kind && (placement === "static" || placement === "prototype")) {
                            var receiver = placement === "static" ? F : proto;
                            this.defineClassElement(receiver, element);
                        }
                    }, this);
                }, this);
            },
            defineClassElement: function(receiver, element) {
                var descriptor = element.descriptor;
                if (element.kind === "field") {
                    var initializer = element.initializer;
                    descriptor = {
                        enumerable: descriptor.enumerable,
                        writable: descriptor.writable,
                        configurable: descriptor.configurable,
                        value: initializer === void 0 ? void 0 : initializer.call(receiver)
                    };
                }
                Object.defineProperty(receiver, element.key, descriptor);
            },
            decorateClass: function(elements, decorators) {
                var newElements = [];
                var finishers = [];
                var placements = {
                    static: [],
                    prototype: [],
                    own: []
                };
                elements.forEach(function(element) {
                    this.addElementPlacement(element, placements);
                }, this);
                elements.forEach(function(element) {
                    if (!_hasDecorators(element)) return newElements.push(element);
                    var elementFinishersExtras = this.decorateElement(element, placements);
                    newElements.push(elementFinishersExtras.element);
                    newElements.push.apply(newElements, elementFinishersExtras.extras);
                    finishers.push.apply(finishers, elementFinishersExtras.finishers);
                }, this);
                if (!decorators) return {
                    elements: newElements,
                    finishers: finishers
                };
                var result = this.decorateConstructor(newElements, decorators);
                finishers.push.apply(finishers, result.finishers);
                result.finishers = finishers;
                return result;
            },
            addElementPlacement: function(element, placements, silent) {
                var keys = placements[element.placement];
                if (!silent && keys.indexOf(element.key) !== -1) throw new TypeError("Duplicated element (" + element.key + ")");
                keys.push(element.key);
            },
            decorateElement: function(element, placements) {
                var extras = [];
                var finishers = [];
                for(var decorators = element.decorators, i = decorators.length - 1; i >= 0; i--){
                    var keys = placements[element.placement];
                    keys.splice(keys.indexOf(element.key), 1);
                    var elementObject = this.fromElementDescriptor(element);
                    var elementFinisherExtras = this.toElementFinisherExtras((0, decorators[i])(elementObject) || elementObject);
                    element = elementFinisherExtras.element;
                    this.addElementPlacement(element, placements);
                    if (elementFinisherExtras.finisher) finishers.push(elementFinisherExtras.finisher);
                    var newExtras = elementFinisherExtras.extras;
                    if (newExtras) {
                        for(var j = 0; j < newExtras.length; j++)this.addElementPlacement(newExtras[j], placements);
                        extras.push.apply(extras, newExtras);
                    }
                }
                return {
                    element: element,
                    finishers: finishers,
                    extras: extras
                };
            },
            decorateConstructor: function(elements, decorators) {
                var finishers = [];
                for(var i = decorators.length - 1; i >= 0; i--){
                    var obj = this.fromClassDescriptor(elements);
                    var elementsAndFinisher = this.toClassDescriptor((0, decorators[i])(obj) || obj);
                    if (elementsAndFinisher.finisher !== undefined) finishers.push(elementsAndFinisher.finisher);
                    if (elementsAndFinisher.elements !== undefined) {
                        elements = elementsAndFinisher.elements;
                        for(var j = 0; j < elements.length - 1; j++)for(var k = j + 1; k < elements.length; k++){
                            if (elements[j].key === elements[k].key && elements[j].placement === elements[k].placement) throw new TypeError("Duplicated element (" + elements[j].key + ")");
                        }
                    }
                }
                return {
                    elements: elements,
                    finishers: finishers
                };
            },
            fromElementDescriptor: function(element) {
                var obj = {
                    kind: element.kind,
                    key: element.key,
                    placement: element.placement,
                    descriptor: element.descriptor
                };
                var desc = {
                    value: "Descriptor",
                    configurable: true
                };
                Object.defineProperty(obj, Symbol.toStringTag, desc);
                if (element.kind === "field") obj.initializer = element.initializer;
                return obj;
            },
            toElementDescriptors: function(elementObjects) {
                if (elementObjects === undefined) return;
                return _toArray(elementObjects).map(function(elementObject) {
                    var element = this.toElementDescriptor(elementObject);
                    this.disallowProperty(elementObject, "finisher", "An element descriptor");
                    this.disallowProperty(elementObject, "extras", "An element descriptor");
                    return element;
                }, this);
            },
            toElementDescriptor: function(elementObject) {
                var kind = String(elementObject.kind);
                if (kind !== "method" && kind !== "field") throw new TypeError('An element descriptor\'s .kind property must be either "method" or "field", but a decorator created an element descriptor with .kind "' + kind + '"');
                var key = _toPropertyKey(elementObject.key);
                var placement = String(elementObject.placement);
                if (placement !== "static" && placement !== "prototype" && placement !== "own") throw new TypeError('An element descriptor\'s .placement property must be one of "static", "prototype" or "own", but a decorator created an element descriptor with .placement "' + placement + '"');
                var descriptor = elementObject.descriptor;
                this.disallowProperty(elementObject, "elements", "An element descriptor");
                var element = {
                    kind: kind,
                    key: key,
                    placement: placement,
                    descriptor: Object.assign({}, descriptor)
                };
                if (kind !== "field") this.disallowProperty(elementObject, "initializer", "A method descriptor");
                else {
                    this.disallowProperty(descriptor, "get", "The property descriptor of a field descriptor");
                    this.disallowProperty(descriptor, "set", "The property descriptor of a field descriptor");
                    this.disallowProperty(descriptor, "value", "The property descriptor of a field descriptor");
                    element.initializer = elementObject.initializer;
                }
                return element;
            },
            toElementFinisherExtras: function(elementObject) {
                var element = this.toElementDescriptor(elementObject);
                var finisher = _optionalCallableProperty(elementObject, "finisher");
                var extras = this.toElementDescriptors(elementObject.extras);
                return {
                    element: element,
                    finisher: finisher,
                    extras: extras
                };
            },
            fromClassDescriptor: function(elements) {
                var obj = {
                    kind: "class",
                    elements: elements.map(this.fromElementDescriptor, this)
                };
                var desc = {
                    value: "Descriptor",
                    configurable: true
                };
                Object.defineProperty(obj, Symbol.toStringTag, desc);
                return obj;
            },
            toClassDescriptor: function(obj) {
                var kind = String(obj.kind);
                if (kind !== "class") throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator created a class descriptor with .kind "' + kind + '"');
                this.disallowProperty(obj, "key", "A class descriptor");
                this.disallowProperty(obj, "placement", "A class descriptor");
                this.disallowProperty(obj, "descriptor", "A class descriptor");
                this.disallowProperty(obj, "initializer", "A class descriptor");
                this.disallowProperty(obj, "extras", "A class descriptor");
                var finisher = _optionalCallableProperty(obj, "finisher");
                var elements = this.toElementDescriptors(obj.elements);
                return {
                    elements: elements,
                    finisher: finisher
                };
            },
            runClassFinishers: function(constructor, finishers) {
                for(var i = 0; i < finishers.length; i++){
                    var newConstructor = (0, finishers[i])(constructor);
                    if (newConstructor !== undefined) {
                        if (typeof newConstructor !== "function") throw new TypeError("Finishers must return a constructor.");
                        constructor = newConstructor;
                    }
                }
                return constructor;
            },
            disallowProperty: function(obj, name, objectType) {
                if (obj[name] !== undefined) throw new TypeError(objectType + " can't have a ." + name + " property.");
            }
        };
        return api;
    }
    function _createElementDescriptor(def) {
        var key = _toPropertyKey(def.key);
        var descriptor;
        if (def.kind === "method") descriptor = {
            value: def.value,
            writable: true,
            configurable: true,
            enumerable: false
        };
        else if (def.kind === "get") descriptor = {
            get: def.value,
            configurable: true,
            enumerable: false
        };
        else if (def.kind === "set") descriptor = {
            set: def.value,
            configurable: true,
            enumerable: false
        };
        else if (def.kind === "field") descriptor = {
            configurable: true,
            writable: true,
            enumerable: true
        };
        var element = {
            kind: def.kind === "field" ? "field" : "method",
            key: key,
            placement: def.static ? "static" : def.kind === "field" ? "own" : "prototype",
            descriptor: descriptor
        };
        if (def.decorators) element.decorators = def.decorators;
        if (def.kind === "field") element.initializer = def.value;
        return element;
    }
    function _coalesceGetterSetter(element, other) {
        if (element.descriptor.get !== undefined) other.descriptor.get = element.descriptor.get;
        else other.descriptor.set = element.descriptor.set;
    }
    function _coalesceClassElements(elements) {
        var newElements = [];
        var isSameElement = function(other) {
            return other.kind === "method" && other.key === element.key && other.placement === element.placement;
        };
        for(var i = 0; i < elements.length; i++){
            var element = elements[i];
            var other;
            if (element.kind === "method" && (other = newElements.find(isSameElement))) {
                if (_isDataDescriptor(element.descriptor) || _isDataDescriptor(other.descriptor)) {
                    if (_hasDecorators(element) || _hasDecorators(other)) throw new ReferenceError("Duplicated methods (" + element.key + ") can't be decorated.");
                    other.descriptor = element.descriptor;
                } else {
                    if (_hasDecorators(element)) {
                        if (_hasDecorators(other)) throw new ReferenceError("Decorators can't be placed on different accessors with for the same property (" + element.key + ").");
                        other.decorators = element.decorators;
                    }
                    _coalesceGetterSetter(element, other);
                }
            } else newElements.push(element);
        }
        return newElements;
    }
    function _hasDecorators(element) {
        return element.decorators && element.decorators.length;
    }
    function _isDataDescriptor(desc) {
        return desc !== undefined && !(desc.value === undefined && desc.writable === undefined);
    }
    function _optionalCallableProperty(obj, name) {
        var value = obj[name];
        if (value !== undefined && typeof value !== "function") throw new TypeError("Expected '" + name + "' to be a function");
        return value;
    }
    function _classPrivateMethodGet(receiver, privateSet, fn) {
        if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
        return fn;
    }
    function _classPrivateMethodSet() {
        throw new TypeError("attempted to reassign private method");
    }
    function _wrapRegExp(re, groups) {
        _wrapRegExp = function(re, groups) {
            return new BabelRegExp(re, groups);
        };
        var _RegExp = _wrapNativeSuper(RegExp);
        var _super = RegExp.prototype;
        var _groups = new WeakMap();
        function BabelRegExp(re, groups) {
            var _this = _RegExp.call(this, re);
            _groups.set(_this, groups);
            return _this;
        }
        _inherits(BabelRegExp, _RegExp);
        BabelRegExp.prototype.exec = function(str) {
            var result = _super.exec.call(this, str);
            if (result) result.groups = buildGroups(result, this);
            return result;
        };
        BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
            if (typeof substitution === "string") {
                var groups = _groups.get(this);
                return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                    return "$" + groups[name];
                }));
            } else if (typeof substitution === "function") {
                var _this = this;
                return _super[Symbol.replace].call(this, str, function() {
                    var args = [];
                    args.push.apply(args, arguments);
                    if (typeof args[args.length - 1] !== "object") args.push(buildGroups(args, _this));
                    return substitution.apply(this, args);
                });
            } else return _super[Symbol.replace].call(this, str, substitution);
        };
        function buildGroups(result, re) {
            var g = _groups.get(re);
            return Object.keys(g).reduce(function(groups, name) {
                groups[name] = result[g[name]];
                return groups;
            }, Object.create(null));
        }
        return _wrapRegExp.apply(this, arguments);
    }
    var arrayRemove = function arrayRemove(arr, index) {
        return arr.splice(index, 1);
    };
    var run = function run(cb, sync) {
        if (sync) cb();
        else if (document.hidden) Promise.resolve(1).then(cb);
        else setTimeout(cb, 0);
    };
    var on = function on() {
        var listeners = [];
        var off = function off(event, cb) {
            arrayRemove(listeners, listeners.findIndex(function(listener) {
                return listener.event === event && (listener.cb === cb || !cb);
            }));
        };
        var _fire = function fire(event, args, sync) {
            listeners.filter(function(listener) {
                return listener.event === event;
            }).map(function(listener) {
                return listener.cb;
            }).forEach(function(cb) {
                return run(function() {
                    return cb.apply(void 0, _toConsumableArray(args));
                }, sync);
            });
        };
        return {
            fireSync: function fireSync(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _fire(event, args, true);
            },
            fire: function fire(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _fire(event, args, false);
            },
            on: function on(event, cb) {
                listeners.push({
                    event: event,
                    cb: cb
                });
            },
            onOnce: function onOnce(event, _cb) {
                listeners.push({
                    event: event,
                    cb: function cb() {
                        off(event, _cb);
                        _cb.apply(void 0, arguments);
                    }
                });
            },
            off: off
        };
    };
    var copyObjectPropertiesToObject = function copyObjectPropertiesToObject(src, target, excluded) {
        Object.getOwnPropertyNames(src).filter(function(property) {
            return !excluded.includes(property);
        }).forEach(function(key) {
            return Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(src, key));
        });
    };
    var PRIVATE = [
        "fire",
        "process",
        "revert",
        "load",
        "on",
        "off",
        "onOnce",
        "retryLoad",
        "extend",
        "archive",
        "archived",
        "release",
        "released",
        "requestProcessing",
        "freeze"
    ];
    var createItemAPI = function createItemAPI(item) {
        var api = {};
        copyObjectPropertiesToObject(item, api, PRIVATE);
        return api;
    };
    var removeReleasedItems = function removeReleasedItems(items) {
        items.forEach(function(item, index) {
            if (item.released) arrayRemove(items, index);
        });
    };
    var ItemStatus = {
        INIT: 1,
        IDLE: 2,
        PROCESSING_QUEUED: 9,
        PROCESSING: 3,
        PROCESSING_COMPLETE: 5,
        PROCESSING_ERROR: 6,
        PROCESSING_REVERT_ERROR: 10,
        LOADING: 7,
        LOAD_ERROR: 8
    };
    var FileOrigin = {
        INPUT: 1,
        LIMBO: 2,
        LOCAL: 3
    };
    var getNonNumeric = function getNonNumeric(str) {
        return /[^0-9]+/.exec(str);
    };
    var getDecimalSeparator = function getDecimalSeparator() {
        return getNonNumeric(1.1.toLocaleString())[0];
    };
    var getThousandsSeparator = function getThousandsSeparator() {
        // Added for browsers that do not return the thousands separator (happend on native browser Android 4.4.4)
        // We check against the normal toString output and if they're the same return a comma when decimal separator is a dot
        var decimalSeparator = getDecimalSeparator();
        var thousandsStringWithSeparator = 1000.0.toLocaleString();
        var thousandsStringWithoutSeparator = 1000.0.toString();
        if (thousandsStringWithSeparator !== thousandsStringWithoutSeparator) return getNonNumeric(thousandsStringWithSeparator)[0];
        return decimalSeparator === "." ? "," : ".";
    };
    var Type = {
        BOOLEAN: "boolean",
        INT: "int",
        NUMBER: "number",
        STRING: "string",
        ARRAY: "array",
        OBJECT: "object",
        FUNCTION: "function",
        ACTION: "action",
        SERVER_API: "serverapi",
        REGEX: "regex"
    };
    // all registered filters
    var filters = [];
    // loops over matching filters and passes options to each filter, returning the mapped results
    var applyFilterChain = function applyFilterChain(key, value, utils) {
        return new Promise(function(resolve, reject) {
            // find matching filters for this key
            var matchingFilters = filters.filter(function(f) {
                return f.key === key;
            }).map(function(f) {
                return f.cb;
            });
            // resolve now
            if (matchingFilters.length === 0) {
                resolve(value);
                return;
            }
            // first filter to kick things of
            var initialFilter = matchingFilters.shift();
            // chain filters
            matchingFilters.reduce(// loop over promises passing value to next promise
            function(current, next) {
                return current.then(function(value) {
                    return next(value, utils);
                });
            }, // call initial filter, will return a promise
            initialFilter(value, utils)).then(function(value) {
                return resolve(value);
            }).catch(function(error) {
                return reject(error);
            });
        });
    };
    var applyFilters = function applyFilters(key, value, utils) {
        return filters.filter(function(f) {
            return f.key === key;
        }).map(function(f) {
            return f.cb(value, utils);
        });
    };
    // adds a new filter to the list
    var addFilter = function addFilter(key, cb) {
        return filters.push({
            key: key,
            cb: cb
        });
    };
    var extendDefaultOptions = function extendDefaultOptions(additionalOptions) {
        return Object.assign(defaultOptions, additionalOptions);
    };
    var getOptions = function getOptions() {
        return Object.assign({}, defaultOptions);
    };
    var setOptions = function setOptions(opts) {
        forin(opts, function(key, value) {
            // key does not exist, so this option cannot be set
            if (!defaultOptions[key]) return;
            defaultOptions[key][0] = getValueByType(value, defaultOptions[key][0], defaultOptions[key][1]);
        });
    };
    // default options on app
    var defaultOptions = {
        // the id to add to the root element
        id: [
            null,
            Type.STRING
        ],
        // input field name to use
        name: [
            "filepond",
            Type.STRING
        ],
        // disable the field
        disabled: [
            false,
            Type.BOOLEAN
        ],
        // classname to put on wrapper
        className: [
            null,
            Type.STRING
        ],
        // is the field required
        required: [
            false,
            Type.BOOLEAN
        ],
        // Allow media capture when value is set
        captureMethod: [
            null,
            Type.STRING
        ],
        // - "camera", "microphone" or "camcorder",
        // - Does not work with multiple on apple devices
        // - If set, acceptedFileTypes must be made to match with media wildcard "image/*", "audio/*" or "video/*"
        // sync `acceptedFileTypes` property with `accept` attribute
        allowSyncAcceptAttribute: [
            true,
            Type.BOOLEAN
        ],
        // Feature toggles
        allowDrop: [
            true,
            Type.BOOLEAN
        ],
        allowBrowse: [
            true,
            Type.BOOLEAN
        ],
        allowPaste: [
            true,
            Type.BOOLEAN
        ],
        allowMultiple: [
            false,
            Type.BOOLEAN
        ],
        allowReplace: [
            true,
            Type.BOOLEAN
        ],
        allowRevert: [
            true,
            Type.BOOLEAN
        ],
        allowRemove: [
            true,
            Type.BOOLEAN
        ],
        allowProcess: [
            true,
            Type.BOOLEAN
        ],
        allowReorder: [
            false,
            Type.BOOLEAN
        ],
        allowDirectoriesOnly: [
            false,
            Type.BOOLEAN
        ],
        // Try store file if `server` not set
        storeAsFile: [
            false,
            Type.BOOLEAN
        ],
        // Revert mode
        forceRevert: [
            false,
            Type.BOOLEAN
        ],
        // Input requirements
        maxFiles: [
            null,
            Type.INT
        ],
        checkValidity: [
            false,
            Type.BOOLEAN
        ],
        // Where to put file
        itemInsertLocationFreedom: [
            true,
            Type.BOOLEAN
        ],
        itemInsertLocation: [
            "before",
            Type.STRING
        ],
        itemInsertInterval: [
            75,
            Type.INT
        ],
        // Drag 'n Drop related
        dropOnPage: [
            false,
            Type.BOOLEAN
        ],
        dropOnElement: [
            true,
            Type.BOOLEAN
        ],
        dropValidation: [
            false,
            Type.BOOLEAN
        ],
        ignoredFiles: [
            [
                ".ds_store",
                "thumbs.db",
                "desktop.ini"
            ],
            Type.ARRAY
        ],
        // Upload related
        instantUpload: [
            true,
            Type.BOOLEAN
        ],
        maxParallelUploads: [
            2,
            Type.INT
        ],
        allowMinimumUploadDuration: [
            true,
            Type.BOOLEAN
        ],
        // Chunks
        chunkUploads: [
            false,
            Type.BOOLEAN
        ],
        chunkForce: [
            false,
            Type.BOOLEAN
        ],
        chunkSize: [
            5000000,
            Type.INT
        ],
        chunkRetryDelays: [
            [
                500,
                1000,
                3000
            ],
            Type.ARRAY
        ],
        // The server api end points to use for uploading (see docs)
        server: [
            null,
            Type.SERVER_API
        ],
        // File size calculations, can set to 1024, this is only used for display, properties use file size base 1000
        fileSizeBase: [
            1000,
            Type.INT
        ],
        // Labels and status messages
        labelFileSizeBytes: [
            "bytes",
            Type.STRING
        ],
        labelFileSizeKilobytes: [
            "KB",
            Type.STRING
        ],
        labelFileSizeMegabytes: [
            "MB",
            Type.STRING
        ],
        labelFileSizeGigabytes: [
            "GB",
            Type.STRING
        ],
        labelDecimalSeparator: [
            getDecimalSeparator(),
            Type.STRING
        ],
        labelThousandsSeparator: [
            getThousandsSeparator(),
            Type.STRING
        ],
        labelIdle: [
            'Drag & Drop your files or <span class="filepond--label-action">Browse</span>',
            Type.STRING
        ],
        labelInvalidField: [
            "Field contains invalid files",
            Type.STRING
        ],
        labelFileWaitingForSize: [
            "Waiting for size",
            Type.STRING
        ],
        labelFileSizeNotAvailable: [
            "Size not available",
            Type.STRING
        ],
        labelFileCountSingular: [
            "file in list",
            Type.STRING
        ],
        labelFileCountPlural: [
            "files in list",
            Type.STRING
        ],
        labelFileLoading: [
            "Loading",
            Type.STRING
        ],
        labelFileAdded: [
            "Added",
            Type.STRING
        ],
        labelFileLoadError: [
            "Error during load",
            Type.STRING
        ],
        labelFileRemoved: [
            "Removed",
            Type.STRING
        ],
        labelFileRemoveError: [
            "Error during remove",
            Type.STRING
        ],
        labelFileProcessing: [
            "Uploading",
            Type.STRING
        ],
        labelFileProcessingComplete: [
            "Upload complete",
            Type.STRING
        ],
        labelFileProcessingAborted: [
            "Upload cancelled",
            Type.STRING
        ],
        labelFileProcessingError: [
            "Error during upload",
            Type.STRING
        ],
        labelFileProcessingRevertError: [
            "Error during revert",
            Type.STRING
        ],
        labelTapToCancel: [
            "tap to cancel",
            Type.STRING
        ],
        labelTapToRetry: [
            "tap to retry",
            Type.STRING
        ],
        labelTapToUndo: [
            "tap to undo",
            Type.STRING
        ],
        labelButtonRemoveItem: [
            "Remove",
            Type.STRING
        ],
        labelButtonAbortItemLoad: [
            "Abort",
            Type.STRING
        ],
        labelButtonRetryItemLoad: [
            "Retry",
            Type.STRING
        ],
        labelButtonAbortItemProcessing: [
            "Cancel",
            Type.STRING
        ],
        labelButtonUndoItemProcessing: [
            "Undo",
            Type.STRING
        ],
        labelButtonRetryItemProcessing: [
            "Retry",
            Type.STRING
        ],
        labelButtonProcessItem: [
            "Upload",
            Type.STRING
        ],
        // make sure width and height plus viewpox are even numbers so icons are nicely centered
        iconRemove: [
            '<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><path d="M11.586 13l-2.293 2.293a1 1 0 0 0 1.414 1.414L13 14.414l2.293 2.293a1 1 0 0 0 1.414-1.414L14.414 13l2.293-2.293a1 1 0 0 0-1.414-1.414L13 11.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L11.586 13z" fill="currentColor" fill-rule="nonzero"/></svg>',
            Type.STRING
        ],
        iconProcess: [
            '<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><path d="M14 10.414v3.585a1 1 0 0 1-2 0v-3.585l-1.293 1.293a1 1 0 0 1-1.414-1.415l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.415L14 10.414zM9 18a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2H9z" fill="currentColor" fill-rule="evenodd"/></svg>',
            Type.STRING
        ],
        iconRetry: [
            '<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><path d="M10.81 9.185l-.038.02A4.997 4.997 0 0 0 8 13.683a5 5 0 0 0 5 5 5 5 0 0 0 5-5 1 1 0 0 1 2 0A7 7 0 1 1 9.722 7.496l-.842-.21a.999.999 0 1 1 .484-1.94l3.23.806c.535.133.86.675.73 1.21l-.804 3.233a.997.997 0 0 1-1.21.73.997.997 0 0 1-.73-1.21l.23-.928v-.002z" fill="currentColor" fill-rule="nonzero"/></svg>',
            Type.STRING
        ],
        iconUndo: [
            '<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><path d="M9.185 10.81l.02-.038A4.997 4.997 0 0 1 13.683 8a5 5 0 0 1 5 5 5 5 0 0 1-5 5 1 1 0 0 0 0 2A7 7 0 1 0 7.496 9.722l-.21-.842a.999.999 0 1 0-1.94.484l.806 3.23c.133.535.675.86 1.21.73l3.233-.803a.997.997 0 0 0 .73-1.21.997.997 0 0 0-1.21-.73l-.928.23-.002-.001z" fill="currentColor" fill-rule="nonzero"/></svg>',
            Type.STRING
        ],
        iconDone: [
            '<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><path d="M18.293 9.293a1 1 0 0 1 1.414 1.414l-7.002 7a1 1 0 0 1-1.414 0l-3.998-4a1 1 0 1 1 1.414-1.414L12 15.586l6.294-6.293z" fill="currentColor" fill-rule="nonzero"/></svg>',
            Type.STRING
        ],
        // event handlers
        oninit: [
            null,
            Type.FUNCTION
        ],
        onwarning: [
            null,
            Type.FUNCTION
        ],
        onerror: [
            null,
            Type.FUNCTION
        ],
        onactivatefile: [
            null,
            Type.FUNCTION
        ],
        oninitfile: [
            null,
            Type.FUNCTION
        ],
        onaddfilestart: [
            null,
            Type.FUNCTION
        ],
        onaddfileprogress: [
            null,
            Type.FUNCTION
        ],
        onaddfile: [
            null,
            Type.FUNCTION
        ],
        onprocessfilestart: [
            null,
            Type.FUNCTION
        ],
        onprocessfileprogress: [
            null,
            Type.FUNCTION
        ],
        onprocessfileabort: [
            null,
            Type.FUNCTION
        ],
        onprocessfilerevert: [
            null,
            Type.FUNCTION
        ],
        onprocessfile: [
            null,
            Type.FUNCTION
        ],
        onprocessfiles: [
            null,
            Type.FUNCTION
        ],
        onremovefile: [
            null,
            Type.FUNCTION
        ],
        onpreparefile: [
            null,
            Type.FUNCTION
        ],
        onupdatefiles: [
            null,
            Type.FUNCTION
        ],
        onreorderfiles: [
            null,
            Type.FUNCTION
        ],
        // hooks
        beforeDropFile: [
            null,
            Type.FUNCTION
        ],
        beforeAddFile: [
            null,
            Type.FUNCTION
        ],
        beforeRemoveFile: [
            null,
            Type.FUNCTION
        ],
        beforePrepareFile: [
            null,
            Type.FUNCTION
        ],
        // styles
        stylePanelLayout: [
            null,
            Type.STRING
        ],
        stylePanelAspectRatio: [
            null,
            Type.STRING
        ],
        styleItemPanelAspectRatio: [
            null,
            Type.STRING
        ],
        styleButtonRemoveItemPosition: [
            "left",
            Type.STRING
        ],
        styleButtonProcessItemPosition: [
            "right",
            Type.STRING
        ],
        styleLoadIndicatorPosition: [
            "right",
            Type.STRING
        ],
        styleProgressIndicatorPosition: [
            "right",
            Type.STRING
        ],
        styleButtonRemoveItemAlign: [
            false,
            Type.BOOLEAN
        ],
        // custom initial files array
        files: [
            [],
            Type.ARRAY
        ],
        // show support by displaying credits
        credits: [
            [
                "https://pqina.nl/",
                "Powered by PQINA"
            ],
            Type.ARRAY
        ]
    };
    var getItemByQuery = function getItemByQuery(items, query) {
        // just return first index
        if (isEmpty(query)) return items[0] || null;
        // query is index
        if (isInt(query)) return items[query] || null;
        // if query is item, get the id
        if (typeof query === "object") query = query.id;
        // assume query is a string and return item by id
        return items.find(function(item) {
            return item.id === query;
        }) || null;
    };
    var getNumericAspectRatioFromString = function getNumericAspectRatioFromString(aspectRatio) {
        if (isEmpty(aspectRatio)) return aspectRatio;
        if (/:/.test(aspectRatio)) {
            var parts = aspectRatio.split(":");
            return parts[1] / parts[0];
        }
        return parseFloat(aspectRatio);
    };
    var getActiveItems = function getActiveItems(items) {
        return items.filter(function(item) {
            return !item.archived;
        });
    };
    var Status = {
        EMPTY: 0,
        IDLE: 1,
        ERROR: 2,
        BUSY: 3,
        READY: 4
    };
    var res = null;
    var canUpdateFileInput = function canUpdateFileInput() {
        if (res === null) try {
            var dataTransfer = new DataTransfer();
            dataTransfer.items.add(new File([
                "hello world"
            ], "This_Works.txt"));
            var el = document.createElement("input");
            el.setAttribute("type", "file");
            el.files = dataTransfer.files;
            res = el.files.length === 1;
        } catch (err) {
            res = false;
        }
        return res;
    };
    var ITEM_ERROR = [
        ItemStatus.LOAD_ERROR,
        ItemStatus.PROCESSING_ERROR,
        ItemStatus.PROCESSING_REVERT_ERROR
    ];
    var ITEM_BUSY = [
        ItemStatus.LOADING,
        ItemStatus.PROCESSING,
        ItemStatus.PROCESSING_QUEUED,
        ItemStatus.INIT
    ];
    var ITEM_READY = [
        ItemStatus.PROCESSING_COMPLETE
    ];
    var isItemInErrorState = function isItemInErrorState(item) {
        return ITEM_ERROR.includes(item.status);
    };
    var isItemInBusyState = function isItemInBusyState(item) {
        return ITEM_BUSY.includes(item.status);
    };
    var isItemInReadyState = function isItemInReadyState(item) {
        return ITEM_READY.includes(item.status);
    };
    var isAsync = function isAsync(state) {
        return isObject(state.options.server) && (isObject(state.options.server.process) || isFunction(state.options.server.process));
    };
    var queries = function queries(state) {
        return {
            GET_STATUS: function GET_STATUS() {
                var items = getActiveItems(state.items);
                var EMPTY = Status.EMPTY, ERROR = Status.ERROR, BUSY = Status.BUSY, IDLE = Status.IDLE, READY = Status.READY;
                if (items.length === 0) return EMPTY;
                if (items.some(isItemInErrorState)) return ERROR;
                if (items.some(isItemInBusyState)) return BUSY;
                if (items.some(isItemInReadyState)) return READY;
                return IDLE;
            },
            GET_ITEM: function GET_ITEM(query) {
                return getItemByQuery(state.items, query);
            },
            GET_ACTIVE_ITEM: function GET_ACTIVE_ITEM(query) {
                return getItemByQuery(getActiveItems(state.items), query);
            },
            GET_ACTIVE_ITEMS: function GET_ACTIVE_ITEMS() {
                return getActiveItems(state.items);
            },
            GET_ITEMS: function GET_ITEMS() {
                return state.items;
            },
            GET_ITEM_NAME: function GET_ITEM_NAME(query) {
                var item = getItemByQuery(state.items, query);
                return item ? item.filename : null;
            },
            GET_ITEM_SIZE: function GET_ITEM_SIZE(query) {
                var item = getItemByQuery(state.items, query);
                return item ? item.fileSize : null;
            },
            GET_STYLES: function GET_STYLES() {
                return Object.keys(state.options).filter(function(key) {
                    return /^style/.test(key);
                }).map(function(option1) {
                    return {
                        name: option1,
                        value: state.options[option1]
                    };
                });
            },
            GET_PANEL_ASPECT_RATIO: function GET_PANEL_ASPECT_RATIO() {
                var isShapeCircle = /circle/.test(state.options.stylePanelLayout);
                var aspectRatio = isShapeCircle ? 1 : getNumericAspectRatioFromString(state.options.stylePanelAspectRatio);
                return aspectRatio;
            },
            GET_ITEM_PANEL_ASPECT_RATIO: function GET_ITEM_PANEL_ASPECT_RATIO() {
                return state.options.styleItemPanelAspectRatio;
            },
            GET_ITEMS_BY_STATUS: function GET_ITEMS_BY_STATUS(status) {
                return getActiveItems(state.items).filter(function(item) {
                    return item.status === status;
                });
            },
            GET_TOTAL_ITEMS: function GET_TOTAL_ITEMS() {
                return getActiveItems(state.items).length;
            },
            SHOULD_UPDATE_FILE_INPUT: function SHOULD_UPDATE_FILE_INPUT() {
                return state.options.storeAsFile && canUpdateFileInput() && !isAsync(state);
            },
            IS_ASYNC: function IS_ASYNC() {
                return isAsync(state);
            },
            GET_FILE_SIZE_LABELS: function GET_FILE_SIZE_LABELS(query) {
                return {
                    labelBytes: query("GET_LABEL_FILE_SIZE_BYTES") || undefined,
                    labelKilobytes: query("GET_LABEL_FILE_SIZE_KILOBYTES") || undefined,
                    labelMegabytes: query("GET_LABEL_FILE_SIZE_MEGABYTES") || undefined,
                    labelGigabytes: query("GET_LABEL_FILE_SIZE_GIGABYTES") || undefined
                };
            }
        };
    };
    var hasRoomForItem = function hasRoomForItem(state) {
        var count = getActiveItems(state.items).length;
        // if cannot have multiple items, to add one item it should currently not contain items
        if (!state.options.allowMultiple) return count === 0;
        // if allows multiple items, we check if a max item count has been set, if not, there's no limit
        var maxFileCount = state.options.maxFiles;
        if (maxFileCount === null) return true;
        // we check if the current count is smaller than the max count, if so, another file can still be added
        if (count < maxFileCount) return true;
        // no more room for another file
        return false;
    };
    var limit = function limit(value, min, max) {
        return Math.max(Math.min(max, value), min);
    };
    var arrayInsert = function arrayInsert(arr, index, item) {
        return arr.splice(index, 0, item);
    };
    var insertItem = function insertItem(items, item, index) {
        if (isEmpty(item)) return null;
        // if index is undefined, append
        if (typeof index === "undefined") {
            items.push(item);
            return item;
        }
        // limit the index to the size of the items array
        index = limit(index, 0, items.length);
        // add item to array
        arrayInsert(items, index, item);
        // expose
        return item;
    };
    var isBase64DataURI = function isBase64DataURI(str) {
        return /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*)\s*$/i.test(str);
    };
    var getFilenameFromURL = function getFilenameFromURL(url) {
        return ("" + url).split("/").pop().split("?").shift();
    };
    var getExtensionFromFilename = function getExtensionFromFilename(name) {
        return name.split(".").pop();
    };
    var guesstimateExtension = function guesstimateExtension(type) {
        // if no extension supplied, exit here
        if (typeof type !== "string") return "";
        // get subtype
        var subtype = type.split("/").pop();
        // is svg subtype
        if (/svg/.test(subtype)) return "svg";
        if (/zip|compressed/.test(subtype)) return "zip";
        if (/plain/.test(subtype)) return "txt";
        if (/msword/.test(subtype)) return "doc";
        // if is valid subtype
        if (/[a-z]+/.test(subtype)) {
            // always use jpg extension
            if (subtype === "jpeg") return "jpg";
            // return subtype
            return subtype;
        }
        return "";
    };
    var leftPad = function leftPad(value) {
        var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        return (padding + value).slice(-padding.length);
    };
    var getDateString = function getDateString() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        return date.getFullYear() + "-" + leftPad(date.getMonth() + 1, "00") + "-" + leftPad(date.getDate(), "00") + "_" + leftPad(date.getHours(), "00") + "-" + leftPad(date.getMinutes(), "00") + "-" + leftPad(date.getSeconds(), "00");
    };
    var getFileFromBlob = function getFileFromBlob(blob, filename) {
        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var extension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var file = typeof type === "string" ? blob.slice(0, blob.size, type) : blob.slice(0, blob.size, blob.type);
        file.lastModifiedDate = new Date();
        // copy relative path
        if (blob._relativePath) file._relativePath = blob._relativePath;
        // if blob has name property, use as filename if no filename supplied
        if (!isString(filename)) filename = getDateString();
        // if filename supplied but no extension and filename has extension
        if (filename && extension === null && getExtensionFromFilename(filename)) file.name = filename;
        else {
            extension = extension || guesstimateExtension(file.type);
            file.name = filename + (extension ? "." + extension : "");
        }
        return file;
    };
    var getBlobBuilder = function getBlobBuilder() {
        return window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
    };
    var createBlob = function createBlob(arrayBuffer, mimeType) {
        var BB = getBlobBuilder();
        if (BB) {
            var bb = new BB();
            bb.append(arrayBuffer);
            return bb.getBlob(mimeType);
        }
        return new Blob([
            arrayBuffer
        ], {
            type: mimeType
        });
    };
    var getBlobFromByteStringWithMimeType = function getBlobFromByteStringWithMimeType(byteString, mimeType) {
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for(var i = 0; i < byteString.length; i++)ia[i] = byteString.charCodeAt(i);
        return createBlob(ab, mimeType);
    };
    var getMimeTypeFromBase64DataURI = function getMimeTypeFromBase64DataURI(dataURI) {
        return (/^data:(.+);/.exec(dataURI) || [])[1] || null;
    };
    var getBase64DataFromBase64DataURI = function getBase64DataFromBase64DataURI(dataURI) {
        // get data part of string (remove data:image/jpeg...,)
        var data = dataURI.split(",")[1];
        // remove any whitespace as that causes InvalidCharacterError in IE
        return data.replace(/\s/g, "");
    };
    var getByteStringFromBase64DataURI = function getByteStringFromBase64DataURI(dataURI) {
        return atob(getBase64DataFromBase64DataURI(dataURI));
    };
    var getBlobFromBase64DataURI = function getBlobFromBase64DataURI(dataURI) {
        var mimeType = getMimeTypeFromBase64DataURI(dataURI);
        var byteString = getByteStringFromBase64DataURI(dataURI);
        return getBlobFromByteStringWithMimeType(byteString, mimeType);
    };
    var getFileFromBase64DataURI = function getFileFromBase64DataURI(dataURI, filename, extension) {
        return getFileFromBlob(getBlobFromBase64DataURI(dataURI), filename, null, extension);
    };
    var getFileNameFromHeader = function getFileNameFromHeader(header) {
        // test if is content disposition header, if not exit
        if (!/^content-disposition:/i.test(header)) return null;
        // get filename parts
        var matches = header.split(/filename=|filename\*=.+''/).splice(1).map(function(name) {
            return name.trim().replace(/^["']|[;"']{0,2}$/g, "");
        }).filter(function(name) {
            return name.length;
        });
        return matches.length ? decodeURI(matches[matches.length - 1]) : null;
    };
    var getFileSizeFromHeader = function getFileSizeFromHeader(header) {
        if (/content-length:/i.test(header)) {
            var size = header.match(/[0-9]+/)[0];
            return size ? parseInt(size, 10) : null;
        }
        return null;
    };
    var getTranfserIdFromHeader = function getTranfserIdFromHeader(header) {
        if (/x-content-transfer-id:/i.test(header)) {
            var id = (header.split(":")[1] || "").trim();
            return id || null;
        }
        return null;
    };
    var getFileInfoFromHeaders = function getFileInfoFromHeaders(headers) {
        var info = {
            source: null,
            name: null,
            size: null
        };
        var rows = headers.split("\n");
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var header = _step.value;
                var name = getFileNameFromHeader(header);
                if (name) {
                    info.name = name;
                    continue;
                }
                var size = getFileSizeFromHeader(header);
                if (size) {
                    info.size = size;
                    continue;
                }
                var source = getTranfserIdFromHeader(header);
                if (source) {
                    info.source = source;
                    continue;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        return info;
    };
    var createFileLoader = function createFileLoader(fetchFn) {
        var state = {
            source: null,
            complete: false,
            progress: 0,
            size: null,
            timestamp: null,
            duration: 0,
            request: null
        };
        var getProgress = function getProgress() {
            return state.progress;
        };
        var abort = function abort() {
            if (state.request && state.request.abort) state.request.abort();
        };
        // load source
        var load = function load() {
            // get quick reference
            var source = state.source;
            api.fire("init", source);
            // Load Files
            if (source instanceof File) api.fire("load", source);
            else if (source instanceof Blob) // Load blobs, set default name to current date
            api.fire("load", getFileFromBlob(source, source.name));
            else if (isBase64DataURI(source)) // Load base 64, set default name to current date
            api.fire("load", getFileFromBase64DataURI(source));
            else // Deal as if is external URL, let's load it!
            loadURL(source);
        };
        // loads a url
        var loadURL = function loadURL(url) {
            // is remote url and no fetch method supplied
            if (!fetchFn) {
                api.fire("error", {
                    type: "error",
                    body: "Can't load URL",
                    code: 400
                });
                return;
            }
            // set request start
            state.timestamp = Date.now();
            // load file
            state.request = fetchFn(url, function(response) {
                // update duration
                state.duration = Date.now() - state.timestamp;
                // done!
                state.complete = true;
                // turn blob response into a file
                if (response instanceof Blob) response = getFileFromBlob(response, response.name || getFilenameFromURL(url));
                api.fire("load", // if has received blob, we go with blob, if no response, we return null
                response instanceof Blob ? response : response ? response.body : null);
            }, function(error) {
                api.fire("error", typeof error === "string" ? {
                    type: "error",
                    code: 0,
                    body: error
                } : error);
            }, function(computable, current, total) {
                // collected some meta data already
                if (total) state.size = total;
                // update duration
                state.duration = Date.now() - state.timestamp;
                // if we can't compute progress, we're not going to fire progress events
                if (!computable) {
                    state.progress = null;
                    return;
                }
                // update progress percentage
                state.progress = current / total;
                // expose
                api.fire("progress", state.progress);
            }, function() {
                api.fire("abort");
            }, function(response) {
                var fileinfo = getFileInfoFromHeaders(typeof response === "string" ? response : response.headers);
                api.fire("meta", {
                    size: state.size || fileinfo.size,
                    filename: fileinfo.name,
                    source: fileinfo.source
                });
            });
        };
        var api = Object.assign({}, on(), {
            setSource: function setSource(source) {
                return state.source = source;
            },
            getProgress: getProgress,
            abort: abort,
            load: load
        });
        return api;
    };
    var isGet = function isGet(method) {
        return /GET|HEAD/.test(method);
    };
    var sendRequest = function sendRequest(data, url, options) {
        var api = {
            onheaders: function onheaders() {},
            onprogress: function onprogress() {},
            onload: function onload() {},
            ontimeout: function ontimeout() {},
            onerror: function onerror() {},
            onabort: function onabort() {},
            abort: function abort() {
                aborted = true;
                xhr.abort();
            }
        };
        // timeout identifier, only used when timeout is defined
        var aborted = false;
        var headersReceived = false;
        // set default options
        options = Object.assign({
            method: "POST",
            headers: {},
            withCredentials: false
        }, options);
        // encode url
        url = encodeURI(url);
        // if method is GET, add any received data to url
        if (isGet(options.method) && data) url = "" + url + encodeURIComponent(typeof data === "string" ? data : JSON.stringify(data));
        // create request
        var xhr = new XMLHttpRequest();
        // progress of load
        var process = isGet(options.method) ? xhr : xhr.upload;
        process.onprogress = function(e) {
            // no progress event when aborted ( onprogress is called once after abort() )
            if (aborted) return;
            api.onprogress(e.lengthComputable, e.loaded, e.total);
        };
        // tries to get header info to the app as fast as possible
        xhr.onreadystatechange = function() {
            // not interesting in these states ('unsent' and 'openend' as they don't give us any additional info)
            if (xhr.readyState < 2) return;
            // no server response
            if (xhr.readyState === 4 && xhr.status === 0) return;
            if (headersReceived) return;
            headersReceived = true;
            // we've probably received some useful data in response headers
            api.onheaders(xhr);
        };
        // load successful
        xhr.onload = function() {
            // is classified as valid response
            if (xhr.status >= 200 && xhr.status < 300) api.onload(xhr);
            else api.onerror(xhr);
        };
        // error during load
        xhr.onerror = function() {
            return api.onerror(xhr);
        };
        // request aborted
        xhr.onabort = function() {
            aborted = true;
            api.onabort();
        };
        // request timeout
        xhr.ontimeout = function() {
            return api.ontimeout(xhr);
        };
        // open up open up!
        xhr.open(options.method, url, true);
        // set timeout if defined (do it after open so IE11 plays ball)
        if (isInt(options.timeout)) xhr.timeout = options.timeout;
        // add headers
        Object.keys(options.headers).forEach(function(key) {
            var value = unescape(encodeURIComponent(options.headers[key]));
            xhr.setRequestHeader(key, value);
        });
        // set type of response
        if (options.responseType) xhr.responseType = options.responseType;
        // set credentials
        if (options.withCredentials) xhr.withCredentials = true;
        // let's send our data
        xhr.send(data);
        return api;
    };
    var createResponse = function createResponse(type, code, body, headers) {
        return {
            type: type,
            code: code,
            body: body,
            headers: headers
        };
    };
    var createTimeoutResponse = function createTimeoutResponse(cb) {
        return function(xhr) {
            cb(createResponse("error", 0, "Timeout", xhr.getAllResponseHeaders()));
        };
    };
    var hasQS = function hasQS(str) {
        return /\?/.test(str);
    };
    var buildURL = function buildURL() {
        var url = "";
        for(var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++)parts[_key] = arguments[_key];
        parts.forEach(function(part) {
            url += hasQS(url) && hasQS(part) ? part.replace(/\?/, "&") : part;
        });
        return url;
    };
    var createFetchFunction = function createFetchFunction() {
        var apiUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var action = arguments.length > 1 ? arguments[1] : undefined;
        // custom handler (should also handle file, load, error, progress and abort)
        if (typeof action === "function") return action;
        // no action supplied
        if (!action || !isString(action.url)) return null;
        // set onload hanlder
        var onload = action.onload || function(res) {
            return res;
        };
        var onerror = action.onerror || function(res) {
            return null;
        };
        // internal handler
        return function(url, load, error, progress, abort, headers) {
            // do local or remote request based on if the url is external
            var request = sendRequest(url, buildURL(apiUrl, action.url), Object.assign({}, action, {
                responseType: "blob"
            }));
            request.onload = function(xhr) {
                // get headers
                var headers = xhr.getAllResponseHeaders();
                // get filename
                var filename = getFileInfoFromHeaders(headers).name || getFilenameFromURL(url);
                // create response
                load(createResponse("load", xhr.status, action.method === "HEAD" ? null : getFileFromBlob(onload(xhr.response), filename), headers));
            };
            request.onerror = function(xhr) {
                error(createResponse("error", xhr.status, onerror(xhr.response) || xhr.statusText, xhr.getAllResponseHeaders()));
            };
            request.onheaders = function(xhr) {
                headers(createResponse("headers", xhr.status, null, xhr.getAllResponseHeaders()));
            };
            request.ontimeout = createTimeoutResponse(error);
            request.onprogress = progress;
            request.onabort = abort;
            // should return request
            return request;
        };
    };
    var ChunkStatus = {
        QUEUED: 0,
        COMPLETE: 1,
        PROCESSING: 2,
        ERROR: 3,
        WAITING: 4
    };
    /*
                                                       function signature:
                                                         (file, metadata, load, error, progress, abort, transfer, options) => {
                                                           return {
                                                           abort:() => {}
                                                         }
                                                       }
                                                       */ // apiUrl, action, name, file, metadata, load, error, progress, abort, transfer, options
    var processFileChunked = function processFileChunked(apiUrl, action, name, file, metadata, load, error, progress, abort, transfer, options) {
        // all chunks
        var chunks = [];
        var chunkTransferId = options.chunkTransferId, chunkServer = options.chunkServer, chunkSize = options.chunkSize, chunkRetryDelays = options.chunkRetryDelays;
        // default state
        var state = {
            serverId: chunkTransferId,
            aborted: false
        };
        // set onload handlers
        var ondata = action.ondata || function(fd) {
            return fd;
        };
        var onload = action.onload || function(xhr, method) {
            return method === "HEAD" ? xhr.getResponseHeader("Upload-Offset") : xhr.response;
        };
        var onerror = action.onerror || function(res) {
            return null;
        };
        // create server hook
        var requestTransferId = function requestTransferId(cb) {
            var formData = new FormData();
            // add metadata under same name
            if (isObject(metadata)) formData.append(name, JSON.stringify(metadata));
            var headers = typeof action.headers === "function" ? action.headers(file, metadata) : Object.assign({}, action.headers, {
                "Upload-Length": file.size
            });
            var requestParams = Object.assign({}, action, {
                headers: headers
            });
            // send request object
            var request = sendRequest(ondata(formData), buildURL(apiUrl, action.url), requestParams);
            request.onload = function(xhr) {
                return cb(onload(xhr, requestParams.method));
            };
            request.onerror = function(xhr) {
                return error(createResponse("error", xhr.status, onerror(xhr.response) || xhr.statusText, xhr.getAllResponseHeaders()));
            };
            request.ontimeout = createTimeoutResponse(error);
        };
        var requestTransferOffset = function requestTransferOffset(cb) {
            var requestUrl = buildURL(apiUrl, chunkServer.url, state.serverId);
            var headers = typeof action.headers === "function" ? action.headers(state.serverId) : Object.assign({}, action.headers);
            var requestParams = {
                headers: headers,
                method: "HEAD"
            };
            var request = sendRequest(null, requestUrl, requestParams);
            request.onload = function(xhr) {
                return cb(onload(xhr, requestParams.method));
            };
            request.onerror = function(xhr) {
                return error(createResponse("error", xhr.status, onerror(xhr.response) || xhr.statusText, xhr.getAllResponseHeaders()));
            };
            request.ontimeout = createTimeoutResponse(error);
        };
        // create chunks
        var lastChunkIndex = Math.floor(file.size / chunkSize);
        for(var i = 0; i <= lastChunkIndex; i++){
            var offset = i * chunkSize;
            var data = file.slice(offset, offset + chunkSize, "application/offset+octet-stream");
            chunks[i] = {
                index: i,
                size: data.size,
                offset: offset,
                data: data,
                file: file,
                progress: 0,
                retries: _toConsumableArray(chunkRetryDelays),
                status: ChunkStatus.QUEUED,
                error: null,
                request: null,
                timeout: null
            };
        }
        var completeProcessingChunks = function completeProcessingChunks() {
            return load(state.serverId);
        };
        var canProcessChunk = function canProcessChunk(chunk) {
            return chunk.status === ChunkStatus.QUEUED || chunk.status === ChunkStatus.ERROR;
        };
        var processChunk = function processChunk(chunk) {
            // processing is paused, wait here
            if (state.aborted) return;
            // get next chunk to process
            chunk = chunk || chunks.find(canProcessChunk);
            // no more chunks to process
            if (!chunk) {
                // all done?
                if (chunks.every(function(chunk) {
                    return chunk.status === ChunkStatus.COMPLETE;
                })) completeProcessingChunks();
                // no chunk to handle
                return;
            }
            // now processing this chunk
            chunk.status = ChunkStatus.PROCESSING;
            chunk.progress = null;
            // allow parsing of formdata
            var ondata = chunkServer.ondata || function(fd) {
                return fd;
            };
            var onerror = chunkServer.onerror || function(res) {
                return null;
            };
            // send request object
            var requestUrl = buildURL(apiUrl, chunkServer.url, state.serverId);
            var headers = typeof chunkServer.headers === "function" ? chunkServer.headers(chunk) : Object.assign({}, chunkServer.headers, {
                "Content-Type": "application/offset+octet-stream",
                "Upload-Offset": chunk.offset,
                "Upload-Length": file.size,
                "Upload-Name": file.name
            });
            var request = chunk.request = sendRequest(ondata(chunk.data), requestUrl, Object.assign({}, chunkServer, {
                headers: headers
            }));
            request.onload = function() {
                // done!
                chunk.status = ChunkStatus.COMPLETE;
                // remove request reference
                chunk.request = null;
                // start processing more chunks
                processChunks();
            };
            request.onprogress = function(lengthComputable, loaded, total) {
                chunk.progress = lengthComputable ? loaded : null;
                updateTotalProgress();
            };
            request.onerror = function(xhr) {
                chunk.status = ChunkStatus.ERROR;
                chunk.request = null;
                chunk.error = onerror(xhr.response) || xhr.statusText;
                if (!retryProcessChunk(chunk)) error(createResponse("error", xhr.status, onerror(xhr.response) || xhr.statusText, xhr.getAllResponseHeaders()));
            };
            request.ontimeout = function(xhr) {
                chunk.status = ChunkStatus.ERROR;
                chunk.request = null;
                if (!retryProcessChunk(chunk)) createTimeoutResponse(error)(xhr);
            };
            request.onabort = function() {
                chunk.status = ChunkStatus.QUEUED;
                chunk.request = null;
                abort();
            };
        };
        var retryProcessChunk = function retryProcessChunk(chunk) {
            // no more retries left
            if (chunk.retries.length === 0) return false;
            // new retry
            chunk.status = ChunkStatus.WAITING;
            clearTimeout(chunk.timeout);
            chunk.timeout = setTimeout(function() {
                processChunk(chunk);
            }, chunk.retries.shift());
            // we're going to retry
            return true;
        };
        var updateTotalProgress = function updateTotalProgress() {
            // calculate total progress fraction
            var totalBytesTransfered = chunks.reduce(function(p, chunk) {
                if (p === null || chunk.progress === null) return null;
                return p + chunk.progress;
            }, 0);
            // can't compute progress
            if (totalBytesTransfered === null) return progress(false, 0, 0);
            // calculate progress values
            var totalSize = chunks.reduce(function(total, chunk) {
                return total + chunk.size;
            }, 0);
            // can update progress indicator
            progress(true, totalBytesTransfered, totalSize);
        };
        // process new chunks
        var processChunks = function processChunks() {
            var totalProcessing = chunks.filter(function(chunk) {
                return chunk.status === ChunkStatus.PROCESSING;
            }).length;
            if (totalProcessing >= 1) return;
            processChunk();
        };
        var abortChunks = function abortChunks() {
            chunks.forEach(function(chunk) {
                clearTimeout(chunk.timeout);
                if (chunk.request) chunk.request.abort();
            });
        };
        // let's go!
        if (!state.serverId) requestTransferId(function(serverId) {
            // stop here if aborted, might have happened in between request and callback
            if (state.aborted) return;
            // pass back to item so we can use it if something goes wrong
            transfer(serverId);
            // store internally
            state.serverId = serverId;
            processChunks();
        });
        else requestTransferOffset(function(offset) {
            // stop here if aborted, might have happened in between request and callback
            if (state.aborted) return;
            // mark chunks with lower offset as complete
            chunks.filter(function(chunk) {
                return chunk.offset < offset;
            }).forEach(function(chunk) {
                chunk.status = ChunkStatus.COMPLETE;
                chunk.progress = chunk.size;
            });
            // continue processing
            processChunks();
        });
        return {
            abort: function abort() {
                state.aborted = true;
                abortChunks();
            }
        };
    };
    /*
                                                               function signature:
                                                                 (file, metadata, load, error, progress, abort) => {
                                                                   return {
                                                                   abort:() => {}
                                                                 }
                                                               }
                                                               */ var createFileProcessorFunction = function createFileProcessorFunction(apiUrl, action, name, options) {
        return function(file, metadata, load, error, progress, abort, transfer) {
            // no file received
            if (!file) return;
            // if was passed a file, and we can chunk it, exit here
            var canChunkUpload = options.chunkUploads;
            var shouldChunkUpload = canChunkUpload && file.size > options.chunkSize;
            var willChunkUpload = canChunkUpload && (shouldChunkUpload || options.chunkForce);
            if (file instanceof Blob && willChunkUpload) return processFileChunked(apiUrl, action, name, file, metadata, load, error, progress, abort, transfer, options);
            // set handlers
            var ondata = action.ondata || function(fd) {
                return fd;
            };
            var onload = action.onload || function(res) {
                return res;
            };
            var onerror = action.onerror || function(res) {
                return null;
            };
            var headers = typeof action.headers === "function" ? action.headers(file, metadata) || {} : Object.assign({}, action.headers);
            var requestParams = Object.assign({}, action, {
                headers: headers
            });
            // create formdata object
            var formData = new FormData();
            // add metadata under same name
            if (isObject(metadata)) formData.append(name, JSON.stringify(metadata));
            // Turn into an array of objects so no matter what the input, we can handle it the same way
            (file instanceof Blob ? [
                {
                    name: null,
                    file: file
                }
            ] : file).forEach(function(item) {
                formData.append(name, item.file, item.name === null ? item.file.name : "" + item.name + item.file.name);
            });
            // send request object
            var request = sendRequest(ondata(formData), buildURL(apiUrl, action.url), requestParams);
            request.onload = function(xhr) {
                load(createResponse("load", xhr.status, onload(xhr.response), xhr.getAllResponseHeaders()));
            };
            request.onerror = function(xhr) {
                error(createResponse("error", xhr.status, onerror(xhr.response) || xhr.statusText, xhr.getAllResponseHeaders()));
            };
            request.ontimeout = createTimeoutResponse(error);
            request.onprogress = progress;
            request.onabort = abort;
            // should return request
            return request;
        };
    };
    var createProcessorFunction = function createProcessorFunction() {
        var apiUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var action = arguments.length > 1 ? arguments[1] : undefined;
        var name = arguments.length > 2 ? arguments[2] : undefined;
        var options = arguments.length > 3 ? arguments[3] : undefined;
        // custom handler (should also handle file, load, error, progress and abort)
        if (typeof action === "function") return function() {
            for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++)params[_key] = arguments[_key];
            return action.apply(void 0, [
                name
            ].concat(params, [
                options
            ]));
        };
        // no action supplied
        if (!action || !isString(action.url)) return null;
        // internal handler
        return createFileProcessorFunction(apiUrl, action, name, options);
    };
    /*
                                                      function signature:
                                                      (uniqueFileId, load, error) => { }
                                                      */ var createRevertFunction = function createRevertFunction() {
        var apiUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var action = arguments.length > 1 ? arguments[1] : undefined;
        // is custom implementation
        if (typeof action === "function") return action;
        // no action supplied, return stub function, interface will work, but file won't be removed
        if (!action || !isString(action.url)) return function(uniqueFileId, load) {
            return load();
        };
        // set onload hanlder
        var onload = action.onload || function(res) {
            return res;
        };
        var onerror = action.onerror || function(res) {
            return null;
        };
        // internal implementation
        return function(uniqueFileId, load, error) {
            var request = sendRequest(uniqueFileId, apiUrl + action.url, action // contains method, headers and withCredentials properties
            );
            request.onload = function(xhr) {
                load(createResponse("load", xhr.status, onload(xhr.response), xhr.getAllResponseHeaders()));
            };
            request.onerror = function(xhr) {
                error(createResponse("error", xhr.status, onerror(xhr.response) || xhr.statusText, xhr.getAllResponseHeaders()));
            };
            request.ontimeout = createTimeoutResponse(error);
            return request;
        };
    };
    var getRandomNumber = function getRandomNumber() {
        var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        return min + Math.random() * (max - min);
    };
    var createPerceivedPerformanceUpdater = function createPerceivedPerformanceUpdater(cb) {
        var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var tickMin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
        var tickMax = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
        var timeout = null;
        var start = Date.now();
        var tick = function tick() {
            var runtime = Date.now() - start;
            var delay = getRandomNumber(tickMin, tickMax);
            if (runtime + delay > duration) delay = runtime + delay - duration;
            var progress = runtime / duration;
            if (progress >= 1 || document.hidden) {
                cb(1);
                return;
            }
            cb(progress);
            timeout = setTimeout(tick, delay);
        };
        if (duration > 0) tick();
        return {
            clear: function clear() {
                clearTimeout(timeout);
            }
        };
    };
    var createFileProcessor = function createFileProcessor(processFn, options) {
        var state = {
            complete: false,
            perceivedProgress: 0,
            perceivedPerformanceUpdater: null,
            progress: null,
            timestamp: null,
            perceivedDuration: 0,
            duration: 0,
            request: null,
            response: null
        };
        var allowMinimumUploadDuration = options.allowMinimumUploadDuration;
        var process = function process(file, metadata) {
            var progressFn = function progressFn() {
                // we've not yet started the real download, stop here
                // the request might not go through, for instance, there might be some server trouble
                // if state.progress is null, the server does not allow computing progress and we show the spinner instead
                if (state.duration === 0 || state.progress === null) return;
                // as we're now processing, fire the progress event
                api.fire("progress", api.getProgress());
            };
            var completeFn = function completeFn() {
                state.complete = true;
                api.fire("load-perceived", state.response.body);
            };
            // let's start processing
            api.fire("start");
            // set request start
            state.timestamp = Date.now();
            // create perceived performance progress indicator
            state.perceivedPerformanceUpdater = createPerceivedPerformanceUpdater(function(progress) {
                state.perceivedProgress = progress;
                state.perceivedDuration = Date.now() - state.timestamp;
                progressFn();
                // if fake progress is done, and a response has been received,
                // and we've not yet called the complete method
                if (state.response && state.perceivedProgress === 1 && !state.complete) // we done!
                completeFn();
            }, // random delay as in a list of files you start noticing
            // files uploading at the exact same speed
            allowMinimumUploadDuration ? getRandomNumber(750, 1500) : 0);
            // remember request so we can abort it later
            state.request = processFn(// the file to process
            file, // the metadata to send along
            metadata, // callbacks (load, error, progress, abort, transfer)
            // load expects the body to be a server id if
            // you want to make use of revert
            function(response) {
                // we put the response in state so we can access
                // it outside of this method
                state.response = isObject(response) ? response : {
                    type: "load",
                    code: 200,
                    body: "" + response,
                    headers: {}
                };
                // update duration
                state.duration = Date.now() - state.timestamp;
                // force progress to 1 as we're now done
                state.progress = 1;
                // actual load is done let's share results
                api.fire("load", state.response.body);
                // we are really done
                // if perceived progress is 1 ( wait for perceived progress to complete )
                // or if server does not support progress ( null )
                if (!allowMinimumUploadDuration || allowMinimumUploadDuration && state.perceivedProgress === 1) completeFn();
            }, // error is expected to be an object with type, code, body
            function(error) {
                // cancel updater
                state.perceivedPerformanceUpdater.clear();
                // update others about this error
                api.fire("error", isObject(error) ? error : {
                    type: "error",
                    code: 0,
                    body: "" + error
                });
            }, // actual processing progress
            function(computable, current, total) {
                // update actual duration
                state.duration = Date.now() - state.timestamp;
                // update actual progress
                state.progress = computable ? current / total : null;
                progressFn();
            }, // abort does not expect a value
            function() {
                // stop updater
                state.perceivedPerformanceUpdater.clear();
                // fire the abort event so we can switch visuals
                api.fire("abort", state.response ? state.response.body : null);
            }, // register the id for this transfer
            function(transferId) {
                api.fire("transfer", transferId);
            });
        };
        var abort = function abort() {
            // no request running, can't abort
            if (!state.request) return;
            // stop updater
            state.perceivedPerformanceUpdater.clear();
            // abort actual request
            if (state.request.abort) state.request.abort();
            // if has response object, we've completed the request
            state.complete = true;
        };
        var reset = function reset() {
            abort();
            state.complete = false;
            state.perceivedProgress = 0;
            state.progress = 0;
            state.timestamp = null;
            state.perceivedDuration = 0;
            state.duration = 0;
            state.request = null;
            state.response = null;
        };
        var getProgress = allowMinimumUploadDuration ? function() {
            return state.progress ? Math.min(state.progress, state.perceivedProgress) : null;
        } : function() {
            return state.progress || null;
        };
        var getDuration = allowMinimumUploadDuration ? function() {
            return Math.min(state.duration, state.perceivedDuration);
        } : function() {
            return state.duration;
        };
        var api = Object.assign({}, on(), {
            process: process,
            abort: abort,
            getProgress: getProgress,
            getDuration: getDuration,
            reset: reset
        });
        return api;
    };
    var getFilenameWithoutExtension = function getFilenameWithoutExtension(name) {
        return name.substring(0, name.lastIndexOf(".")) || name;
    };
    var createFileStub = function createFileStub(source) {
        var data = [
            source.name,
            source.size,
            source.type
        ];
        // is blob or base64, then we need to set the name
        if (source instanceof Blob || isBase64DataURI(source)) data[0] = source.name || getDateString();
        else if (isBase64DataURI(source)) {
            // if is base64 data uri we need to determine the average size and type
            data[1] = source.length;
            data[2] = getMimeTypeFromBase64DataURI(source);
        } else if (isString(source)) {
            // url
            data[0] = getFilenameFromURL(source);
            data[1] = 0;
            data[2] = "application/octet-stream";
        }
        return {
            name: data[0],
            size: data[1],
            type: data[2]
        };
    };
    var isFile = function isFile(value) {
        return !!(value instanceof File || value instanceof Blob && value.name);
    };
    var deepCloneObject = function deepCloneObject(src) {
        if (!isObject(src)) return src;
        var target = isArray(src) ? [] : {};
        for(var key in src){
            if (!src.hasOwnProperty(key)) continue;
            var v1 = src[key];
            target[key] = v1 && isObject(v1) ? deepCloneObject(v1) : v1;
        }
        return target;
    };
    var createItem = function createItem() {
        var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var serverFileReference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var file = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        // unique id for this item, is used to identify the item across views
        var id = getUniqueId();
        /**
         * Internal item state
         */ var state = {
            // is archived
            archived: false,
            // if is frozen, no longer fires events
            frozen: false,
            // removed from view
            released: false,
            // original source
            source: null,
            // file model reference
            file: file,
            // id of file on server
            serverFileReference: serverFileReference,
            // id of file transfer on server
            transferId: null,
            // is aborted
            processingAborted: false,
            // current item status
            status: serverFileReference ? ItemStatus.PROCESSING_COMPLETE : ItemStatus.INIT,
            // active processes
            activeLoader: null,
            activeProcessor: null
        };
        // callback used when abort processing is called to link back to the resolve method
        var abortProcessingRequestComplete = null;
        /**
         * Externally added item metadata
         */ var metadata = {};
        // item data
        var setStatus = function setStatus(status) {
            return state.status = status;
        };
        // fire event unless the item has been archived
        var fire = function fire(event) {
            if (state.released || state.frozen) return;
            for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
            api.fire.apply(api, [
                event
            ].concat(params));
        };
        // file data
        var getFileExtension = function getFileExtension() {
            return getExtensionFromFilename(state.file.name);
        };
        var getFileType = function getFileType() {
            return state.file.type;
        };
        var getFileSize = function getFileSize() {
            return state.file.size;
        };
        var getFile = function getFile() {
            return state.file;
        };
        //
        // logic to load a file
        //
        var load = function load(source, loader, onload) {
            // remember the original item source
            state.source = source;
            // source is known
            api.fireSync("init");
            // file stub is already there
            if (state.file) {
                api.fireSync("load-skip");
                return;
            }
            // set a stub file object while loading the actual data
            state.file = createFileStub(source);
            // starts loading
            loader.on("init", function() {
                fire("load-init");
            });
            // we'eve received a size indication, let's update the stub
            loader.on("meta", function(meta) {
                // set size of file stub
                state.file.size = meta.size;
                // set name of file stub
                state.file.filename = meta.filename;
                // if has received source, we done
                if (meta.source) {
                    origin = FileOrigin.LIMBO;
                    state.serverFileReference = meta.source;
                    state.status = ItemStatus.PROCESSING_COMPLETE;
                }
                // size has been updated
                fire("load-meta");
            });
            // the file is now loading we need to update the progress indicators
            loader.on("progress", function(progress) {
                setStatus(ItemStatus.LOADING);
                fire("load-progress", progress);
            });
            // an error was thrown while loading the file, we need to switch to error state
            loader.on("error", function(error) {
                setStatus(ItemStatus.LOAD_ERROR);
                fire("load-request-error", error);
            });
            // user or another process aborted the file load (cannot retry)
            loader.on("abort", function() {
                setStatus(ItemStatus.INIT);
                fire("load-abort");
            });
            // done loading
            loader.on("load", function(file) {
                // as we've now loaded the file the loader is no longer required
                state.activeLoader = null;
                // called when file has loaded succesfully
                var success = function success(result) {
                    // set (possibly) transformed file
                    state.file = isFile(result) ? result : state.file;
                    // file received
                    if (origin === FileOrigin.LIMBO && state.serverFileReference) setStatus(ItemStatus.PROCESSING_COMPLETE);
                    else setStatus(ItemStatus.IDLE);
                    fire("load");
                };
                var error = function error(result) {
                    // set original file
                    state.file = file;
                    fire("load-meta");
                    setStatus(ItemStatus.LOAD_ERROR);
                    fire("load-file-error", result);
                };
                // if we already have a server file reference, we don't need to call the onload method
                if (state.serverFileReference) {
                    success(file);
                    return;
                }
                // no server id, let's give this file the full treatment
                onload(file, success, error);
            });
            // set loader source data
            loader.setSource(source);
            // set as active loader
            state.activeLoader = loader;
            // load the source data
            loader.load();
        };
        var retryLoad = function retryLoad() {
            if (!state.activeLoader) return;
            state.activeLoader.load();
        };
        var abortLoad = function abortLoad() {
            if (state.activeLoader) {
                state.activeLoader.abort();
                return;
            }
            setStatus(ItemStatus.INIT);
            fire("load-abort");
        };
        //
        // logic to process a file
        //
        var process = function process(processor, onprocess) {
            // processing was aborted
            if (state.processingAborted) {
                state.processingAborted = false;
                return;
            }
            // now processing
            setStatus(ItemStatus.PROCESSING);
            // reset abort callback
            abortProcessingRequestComplete = null;
            // if no file loaded we'll wait for the load event
            if (!(state.file instanceof Blob)) {
                api.on("load", function() {
                    process(processor, onprocess);
                });
                return;
            }
            // setup processor
            processor.on("load", function(serverFileReference) {
                // need this id to be able to revert the upload
                state.transferId = null;
                state.serverFileReference = serverFileReference;
            });
            // register transfer id
            processor.on("transfer", function(transferId) {
                // need this id to be able to revert the upload
                state.transferId = transferId;
            });
            processor.on("load-perceived", function(serverFileReference) {
                // no longer required
                state.activeProcessor = null;
                // need this id to be able to rever the upload
                state.transferId = null;
                state.serverFileReference = serverFileReference;
                setStatus(ItemStatus.PROCESSING_COMPLETE);
                fire("process-complete", serverFileReference);
            });
            processor.on("start", function() {
                fire("process-start");
            });
            processor.on("error", function(error) {
                state.activeProcessor = null;
                setStatus(ItemStatus.PROCESSING_ERROR);
                fire("process-error", error);
            });
            processor.on("abort", function(serverFileReference) {
                state.activeProcessor = null;
                // if file was uploaded but processing was cancelled during perceived processor time store file reference
                state.serverFileReference = serverFileReference;
                setStatus(ItemStatus.IDLE);
                fire("process-abort");
                // has timeout so doesn't interfere with remove action
                if (abortProcessingRequestComplete) abortProcessingRequestComplete();
            });
            processor.on("progress", function(progress) {
                fire("process-progress", progress);
            });
            // when successfully transformed
            var success = function success(file) {
                // if was archived in the mean time, don't process
                if (state.archived) return;
                // process file!
                processor.process(file, Object.assign({}, metadata));
            };
            // something went wrong during transform phase
            var error = console.error;
            // start processing the file
            onprocess(state.file, success, error);
            // set as active processor
            state.activeProcessor = processor;
        };
        var requestProcessing = function requestProcessing() {
            state.processingAborted = false;
            setStatus(ItemStatus.PROCESSING_QUEUED);
        };
        var abortProcessing = function abortProcessing() {
            return new Promise(function(resolve) {
                if (!state.activeProcessor) {
                    state.processingAborted = true;
                    setStatus(ItemStatus.IDLE);
                    fire("process-abort");
                    resolve();
                    return;
                }
                abortProcessingRequestComplete = function abortProcessingRequestComplete() {
                    resolve();
                };
                state.activeProcessor.abort();
            });
        };
        //
        // logic to revert a processed file
        //
        var revert = function revert(revertFileUpload, forceRevert) {
            return new Promise(function(resolve, reject) {
                // a completed upload will have a serverFileReference, a failed chunked upload where
                // getting a serverId succeeded but >=0 chunks have been uploaded will have transferId set
                var serverTransferId = state.serverFileReference !== null ? state.serverFileReference : state.transferId;
                // cannot revert without a server id for this process
                if (serverTransferId === null) {
                    resolve();
                    return;
                }
                // revert the upload (fire and forget)
                revertFileUpload(serverTransferId, function() {
                    // reset file server id and transfer id as now it's not available on the server
                    state.serverFileReference = null;
                    state.transferId = null;
                    resolve();
                }, function(error) {
                    // don't set error state when reverting is optional, it will always resolve
                    if (!forceRevert) {
                        resolve();
                        return;
                    }
                    // oh no errors
                    setStatus(ItemStatus.PROCESSING_REVERT_ERROR);
                    fire("process-revert-error");
                    reject(error);
                });
                // fire event
                setStatus(ItemStatus.IDLE);
                fire("process-revert");
            });
        };
        // exposed methods
        var _setMetadata = function setMetadata(key, value, silent) {
            var keys = key.split(".");
            var root = keys[0];
            var last = keys.pop();
            var data = metadata;
            keys.forEach(function(key) {
                return data = data[key];
            });
            // compare old value against new value, if they're the same, we're not updating
            if (JSON.stringify(data[last]) === JSON.stringify(value)) return;
            // update value
            data[last] = value;
            // fire update
            fire("metadata-update", {
                key: root,
                value: metadata[root],
                silent: silent
            });
        };
        var getMetadata = function getMetadata(key) {
            return deepCloneObject(key ? metadata[key] : metadata);
        };
        var api = Object.assign({
            id: {
                get: function get() {
                    return id;
                }
            },
            origin: {
                get: function get() {
                    return origin;
                },
                set: function set(value) {
                    return origin = value;
                }
            },
            serverId: {
                get: function get() {
                    return state.serverFileReference;
                }
            },
            transferId: {
                get: function get() {
                    return state.transferId;
                }
            },
            status: {
                get: function get() {
                    return state.status;
                }
            },
            filename: {
                get: function get() {
                    return state.file.name;
                }
            },
            filenameWithoutExtension: {
                get: function get() {
                    return getFilenameWithoutExtension(state.file.name);
                }
            },
            fileExtension: {
                get: getFileExtension
            },
            fileType: {
                get: getFileType
            },
            fileSize: {
                get: getFileSize
            },
            file: {
                get: getFile
            },
            relativePath: {
                get: function get() {
                    return state.file._relativePath;
                }
            },
            source: {
                get: function get() {
                    return state.source;
                }
            },
            getMetadata: getMetadata,
            setMetadata: function setMetadata(key, value, silent) {
                if (isObject(key)) {
                    var data = key;
                    Object.keys(data).forEach(function(key) {
                        _setMetadata(key, data[key], value);
                    });
                    return key;
                }
                _setMetadata(key, value, silent);
                return value;
            },
            extend: function extend(name, handler) {
                return itemAPI[name] = handler;
            },
            abortLoad: abortLoad,
            retryLoad: retryLoad,
            requestProcessing: requestProcessing,
            abortProcessing: abortProcessing,
            load: load,
            process: process,
            revert: revert
        }, on(), {
            freeze: function freeze() {
                return state.frozen = true;
            },
            release: function release() {
                return state.released = true;
            },
            released: {
                get: function get() {
                    return state.released;
                }
            },
            archive: function archive() {
                return state.archived = true;
            },
            archived: {
                get: function get() {
                    return state.archived;
                }
            },
            // replace source and file object
            setFile: function setFile(file) {
                return state.file = file;
            }
        });
        // create it here instead of returning it instantly so we can extend it later
        var itemAPI = createObject(api);
        return itemAPI;
    };
    var getItemIndexByQuery = function getItemIndexByQuery(items, query) {
        // just return first index
        if (isEmpty(query)) return 0;
        // invalid queries
        if (!isString(query)) return -1;
        // return item by id (or -1 if not found)
        return items.findIndex(function(item) {
            return item.id === query;
        });
    };
    var getItemById = function getItemById(items, itemId) {
        var index = getItemIndexByQuery(items, itemId);
        if (index < 0) return;
        return items[index] || null;
    };
    var fetchBlob = function fetchBlob(url, load, error, progress, abort, headers) {
        var request = sendRequest(null, url, {
            method: "GET",
            responseType: "blob"
        });
        request.onload = function(xhr) {
            // get headers
            var headers = xhr.getAllResponseHeaders();
            // get filename
            var filename = getFileInfoFromHeaders(headers).name || getFilenameFromURL(url);
            // create response
            load(createResponse("load", xhr.status, getFileFromBlob(xhr.response, filename), headers));
        };
        request.onerror = function(xhr) {
            error(createResponse("error", xhr.status, xhr.statusText, xhr.getAllResponseHeaders()));
        };
        request.onheaders = function(xhr) {
            headers(createResponse("headers", xhr.status, null, xhr.getAllResponseHeaders()));
        };
        request.ontimeout = createTimeoutResponse(error);
        request.onprogress = progress;
        request.onabort = abort;
        // should return request
        return request;
    };
    var getDomainFromURL = function getDomainFromURL(url) {
        if (url.indexOf("//") === 0) url = location.protocol + url;
        return url.toLowerCase().replace("blob:", "").replace(/([a-z])?:\/\//, "$1").split("/")[0];
    };
    var isExternalURL = function isExternalURL(url) {
        return (url.indexOf(":") > -1 || url.indexOf("//") > -1) && getDomainFromURL(location.href) !== getDomainFromURL(url);
    };
    var dynamicLabel = function dynamicLabel(label) {
        return function() {
            return isFunction(label) ? label.apply(void 0, arguments) : label;
        };
    };
    var isMockItem = function isMockItem(item) {
        return !isFile(item.file);
    };
    var listUpdated = function listUpdated(dispatch, state) {
        clearTimeout(state.listUpdateTimeout);
        state.listUpdateTimeout = setTimeout(function() {
            dispatch("DID_UPDATE_ITEMS", {
                items: getActiveItems(state.items)
            });
        }, 0);
    };
    var optionalPromise = function optionalPromise(fn) {
        for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
        return new Promise(function(resolve) {
            if (!fn) return resolve(true);
            var result = fn.apply(void 0, params);
            if (result == null) return resolve(true);
            if (typeof result === "boolean") return resolve(result);
            if (typeof result.then === "function") result.then(resolve);
        });
    };
    var sortItems = function sortItems(state, compare) {
        state.items.sort(function(a, b) {
            return compare(createItemAPI(a), createItemAPI(b));
        });
    };
    // returns item based on state
    var getItemByQueryFromState = function getItemByQueryFromState(state, itemHandler) {
        return function() {
            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var query = _ref.query, _ref$success = _ref.success, success = _ref$success === void 0 ? function() {} : _ref$success, _ref$failure = _ref.failure, failure = _ref$failure === void 0 ? function() {} : _ref$failure, options = _objectWithoutProperties(_ref, [
                "query",
                "success",
                "failure"
            ]);
            var item = getItemByQuery(state.items, query);
            if (!item) {
                failure({
                    error: createResponse("error", 0, "Item not found"),
                    file: null
                });
                return;
            }
            itemHandler(item, success, failure, options || {});
        };
    };
    var actions = function actions(dispatch, query, state) {
        return {
            /**
             * Aborts all ongoing processes
             */ ABORT_ALL: function ABORT_ALL() {
                getActiveItems(state.items).forEach(function(item) {
                    item.freeze();
                    item.abortLoad();
                    item.abortProcessing();
                });
            },
            /**
             * Sets initial files
             */ DID_SET_FILES: function DID_SET_FILES(_ref2) {
                var _ref2$value = _ref2.value, value = _ref2$value === void 0 ? [] : _ref2$value;
                // map values to file objects
                var files = value.map(function(file) {
                    return {
                        source: file.source ? file.source : file,
                        options: file.options
                    };
                });
                // loop over files, if file is in list, leave it be, if not, remove
                // test if items should be moved
                var activeItems = getActiveItems(state.items);
                activeItems.forEach(function(item) {
                    // if item not is in new value, remove
                    if (!files.find(function(file) {
                        return file.source === item.source || file.source === item.file;
                    })) dispatch("REMOVE_ITEM", {
                        query: item,
                        remove: false
                    });
                });
                // add new files
                activeItems = getActiveItems(state.items);
                files.forEach(function(file, index) {
                    // if file is already in list
                    if (activeItems.find(function(item) {
                        return item.source === file.source || item.file === file.source;
                    })) return;
                    // not in list, add
                    dispatch("ADD_ITEM", Object.assign({}, file, {
                        interactionMethod: InteractionMethod.NONE,
                        index: index
                    }));
                });
            },
            DID_UPDATE_ITEM_METADATA: function DID_UPDATE_ITEM_METADATA(_ref3) {
                var id = _ref3.id, action = _ref3.action, change = _ref3.change;
                // don't do anything
                if (change.silent) return;
                // if is called multiple times in close succession we combined all calls together to save resources
                clearTimeout(state.itemUpdateTimeout);
                state.itemUpdateTimeout = setTimeout(function() {
                    var item = getItemById(state.items, id);
                    // only revert and attempt to upload when we're uploading to a server
                    if (!query("IS_ASYNC")) {
                        // should we update the output data
                        applyFilterChain("SHOULD_PREPARE_OUTPUT", false, {
                            item: item,
                            query: query,
                            action: action,
                            change: change
                        }).then(function(shouldPrepareOutput) {
                            // plugins determined the output data should be prepared (or not), can be adjusted with beforePrepareOutput hook
                            var beforePrepareFile = query("GET_BEFORE_PREPARE_FILE");
                            if (beforePrepareFile) shouldPrepareOutput = beforePrepareFile(item, shouldPrepareOutput);
                            if (!shouldPrepareOutput) return;
                            dispatch("REQUEST_PREPARE_OUTPUT", {
                                query: id,
                                item: item,
                                success: function success(file) {
                                    dispatch("DID_PREPARE_OUTPUT", {
                                        id: id,
                                        file: file
                                    });
                                }
                            }, true);
                        });
                        return;
                    }
                    // if is local item we need to enable upload button so change can be propagated to server
                    if (item.origin === FileOrigin.LOCAL) dispatch("DID_LOAD_ITEM", {
                        id: item.id,
                        error: null,
                        serverFileReference: item.source
                    });
                    // for async scenarios
                    var upload = function upload() {
                        // we push this forward a bit so the interface is updated correctly
                        setTimeout(function() {
                            dispatch("REQUEST_ITEM_PROCESSING", {
                                query: id
                            });
                        }, 32);
                    };
                    var revert = function revert(doUpload) {
                        item.revert(createRevertFunction(state.options.server.url, state.options.server.revert), query("GET_FORCE_REVERT")).then(doUpload ? upload : function() {}).catch(function() {});
                    };
                    var abort = function abort(doUpload) {
                        item.abortProcessing().then(doUpload ? upload : function() {});
                    };
                    // if we should re-upload the file immediately
                    if (item.status === ItemStatus.PROCESSING_COMPLETE) return revert(state.options.instantUpload);
                    // if currently uploading, cancel upload
                    if (item.status === ItemStatus.PROCESSING) return abort(state.options.instantUpload);
                    if (state.options.instantUpload) upload();
                }, 0);
            },
            MOVE_ITEM: function MOVE_ITEM(_ref4) {
                var query = _ref4.query, index = _ref4.index;
                var item = getItemByQuery(state.items, query);
                if (!item) return;
                var currentIndex = state.items.indexOf(item);
                index = limit(index, 0, state.items.length - 1);
                if (currentIndex === index) return;
                state.items.splice(index, 0, state.items.splice(currentIndex, 1)[0]);
            },
            SORT: function SORT(_ref5) {
                var compare = _ref5.compare;
                sortItems(state, compare);
                dispatch("DID_SORT_ITEMS", {
                    items: query("GET_ACTIVE_ITEMS")
                });
            },
            ADD_ITEMS: function ADD_ITEMS(_ref6) {
                var items = _ref6.items, index = _ref6.index, interactionMethod = _ref6.interactionMethod, _ref6$success = _ref6.success, success = _ref6$success === void 0 ? function() {} : _ref6$success, _ref6$failure = _ref6.failure, failure = _ref6$failure === void 0 ? function() {} : _ref6$failure;
                var currentIndex = index;
                if (index === -1 || typeof index === "undefined") {
                    var insertLocation = query("GET_ITEM_INSERT_LOCATION");
                    var totalItems = query("GET_TOTAL_ITEMS");
                    currentIndex = insertLocation === "before" ? 0 : totalItems;
                }
                var ignoredFiles = query("GET_IGNORED_FILES");
                var isValidFile = function isValidFile(source) {
                    return isFile(source) ? !ignoredFiles.includes(source.name.toLowerCase()) : !isEmpty(source);
                };
                var validItems = items.filter(isValidFile);
                var promises = validItems.map(function(source) {
                    return new Promise(function(resolve, reject) {
                        dispatch("ADD_ITEM", {
                            interactionMethod: interactionMethod,
                            source: source.source || source,
                            success: resolve,
                            failure: reject,
                            index: currentIndex++,
                            options: source.options || {}
                        });
                    });
                });
                Promise.all(promises).then(success).catch(failure);
            },
            /**
             * @param source
             * @param index
             * @param interactionMethod
             */ ADD_ITEM: function ADD_ITEM(_ref7) {
                var source = _ref7.source, _ref7$index = _ref7.index, index = _ref7$index === void 0 ? -1 : _ref7$index, interactionMethod = _ref7.interactionMethod, _ref7$success = _ref7.success, success = _ref7$success === void 0 ? function() {} : _ref7$success, _ref7$failure = _ref7.failure, failure = _ref7$failure === void 0 ? function() {} : _ref7$failure, _ref7$options = _ref7.options, options = _ref7$options === void 0 ? {} : _ref7$options;
                // if no source supplied
                if (isEmpty(source)) {
                    failure({
                        error: createResponse("error", 0, "No source"),
                        file: null
                    });
                    return;
                }
                // filter out invalid file items, used to filter dropped directory contents
                if (isFile(source) && state.options.ignoredFiles.includes(source.name.toLowerCase())) // fail silently
                return;
                // test if there's still room in the list of files
                if (!hasRoomForItem(state)) {
                    // if multiple allowed, we can't replace
                    // or if only a single item is allowed but we're not allowed to replace it we exit
                    if (state.options.allowMultiple || !state.options.allowMultiple && !state.options.allowReplace) {
                        var error = createResponse("warning", 0, "Max files");
                        dispatch("DID_THROW_MAX_FILES", {
                            source: source,
                            error: error
                        });
                        failure({
                            error: error,
                            file: null
                        });
                        return;
                    }
                    // let's replace the item
                    // id of first item we're about to remove
                    var _item = getActiveItems(state.items)[0];
                    // if has been processed remove it from the server as well
                    if (_item.status === ItemStatus.PROCESSING_COMPLETE || _item.status === ItemStatus.PROCESSING_REVERT_ERROR) {
                        var forceRevert = query("GET_FORCE_REVERT");
                        _item.revert(createRevertFunction(state.options.server.url, state.options.server.revert), forceRevert).then(function() {
                            if (!forceRevert) return;
                            // try to add now
                            dispatch("ADD_ITEM", {
                                source: source,
                                index: index,
                                interactionMethod: interactionMethod,
                                success: success,
                                failure: failure,
                                options: options
                            });
                        }).catch(function() {}); // no need to handle this catch state for now
                        if (forceRevert) return;
                    }
                    // remove first item as it will be replaced by this item
                    dispatch("REMOVE_ITEM", {
                        query: _item.id
                    });
                }
                // where did the file originate
                var origin = options.type === "local" ? FileOrigin.LOCAL : options.type === "limbo" ? FileOrigin.LIMBO : FileOrigin.INPUT;
                // create a new blank item
                var item = createItem(// where did this file come from
                origin, // an input file never has a server file reference
                origin === FileOrigin.INPUT ? null : source, // file mock data, if defined
                options.file);
                // set initial meta data
                Object.keys(options.metadata || {}).forEach(function(key) {
                    item.setMetadata(key, options.metadata[key]);
                });
                // created the item, let plugins add methods
                applyFilters("DID_CREATE_ITEM", item, {
                    query: query,
                    dispatch: dispatch
                });
                // where to insert new items
                var itemInsertLocation = query("GET_ITEM_INSERT_LOCATION");
                // adjust index if is not allowed to pick location
                if (!state.options.itemInsertLocationFreedom) index = itemInsertLocation === "before" ? -1 : state.items.length;
                // add item to list
                insertItem(state.items, item, index);
                // sort items in list
                if (isFunction(itemInsertLocation) && source) sortItems(state, itemInsertLocation);
                // get a quick reference to the item id
                var id = item.id;
                // observe item events
                item.on("init", function() {
                    dispatch("DID_INIT_ITEM", {
                        id: id
                    });
                });
                item.on("load-init", function() {
                    dispatch("DID_START_ITEM_LOAD", {
                        id: id
                    });
                });
                item.on("load-meta", function() {
                    dispatch("DID_UPDATE_ITEM_META", {
                        id: id
                    });
                });
                item.on("load-progress", function(progress) {
                    dispatch("DID_UPDATE_ITEM_LOAD_PROGRESS", {
                        id: id,
                        progress: progress
                    });
                });
                item.on("load-request-error", function(error) {
                    var mainStatus = dynamicLabel(state.options.labelFileLoadError)(error);
                    // is client error, no way to recover
                    if (error.code >= 400 && error.code < 500) {
                        dispatch("DID_THROW_ITEM_INVALID", {
                            id: id,
                            error: error,
                            status: {
                                main: mainStatus,
                                sub: error.code + " (" + error.body + ")"
                            }
                        });
                        // reject the file so can be dealt with through API
                        failure({
                            error: error,
                            file: createItemAPI(item)
                        });
                        return;
                    }
                    // is possible server error, so might be possible to retry
                    dispatch("DID_THROW_ITEM_LOAD_ERROR", {
                        id: id,
                        error: error,
                        status: {
                            main: mainStatus,
                            sub: state.options.labelTapToRetry
                        }
                    });
                });
                item.on("load-file-error", function(error) {
                    dispatch("DID_THROW_ITEM_INVALID", {
                        id: id,
                        error: error.status,
                        status: error.status
                    });
                    failure({
                        error: error.status,
                        file: createItemAPI(item)
                    });
                });
                item.on("load-abort", function() {
                    dispatch("REMOVE_ITEM", {
                        query: id
                    });
                });
                item.on("load-skip", function() {
                    item.on("metadata-update", function(change) {
                        if (!isFile(item.file)) return;
                        dispatch("DID_UPDATE_ITEM_METADATA", {
                            id: id,
                            change: change
                        });
                    });
                    dispatch("COMPLETE_LOAD_ITEM", {
                        query: id,
                        item: item,
                        data: {
                            source: source,
                            success: success
                        }
                    });
                });
                item.on("load", function() {
                    var handleAdd = function handleAdd(shouldAdd) {
                        // no should not add this file
                        if (!shouldAdd) {
                            dispatch("REMOVE_ITEM", {
                                query: id
                            });
                            return;
                        }
                        // now interested in metadata updates
                        item.on("metadata-update", function(change) {
                            dispatch("DID_UPDATE_ITEM_METADATA", {
                                id: id,
                                change: change
                            });
                        });
                        // let plugins decide if the output data should be prepared at this point
                        // means we'll do this and wait for idle state
                        applyFilterChain("SHOULD_PREPARE_OUTPUT", false, {
                            item: item,
                            query: query
                        }).then(function(shouldPrepareOutput) {
                            // plugins determined the output data should be prepared (or not), can be adjusted with beforePrepareOutput hook
                            var beforePrepareFile = query("GET_BEFORE_PREPARE_FILE");
                            if (beforePrepareFile) shouldPrepareOutput = beforePrepareFile(item, shouldPrepareOutput);
                            var loadComplete = function loadComplete() {
                                dispatch("COMPLETE_LOAD_ITEM", {
                                    query: id,
                                    item: item,
                                    data: {
                                        source: source,
                                        success: success
                                    }
                                });
                                listUpdated(dispatch, state);
                            };
                            // exit
                            if (shouldPrepareOutput) {
                                // wait for idle state and then run PREPARE_OUTPUT
                                dispatch("REQUEST_PREPARE_OUTPUT", {
                                    query: id,
                                    item: item,
                                    success: function success(file) {
                                        dispatch("DID_PREPARE_OUTPUT", {
                                            id: id,
                                            file: file
                                        });
                                        loadComplete();
                                    }
                                }, true);
                                return;
                            }
                            loadComplete();
                        });
                    };
                    // item loaded, allow plugins to
                    // - read data (quickly)
                    // - add metadata
                    applyFilterChain("DID_LOAD_ITEM", item, {
                        query: query,
                        dispatch: dispatch
                    }).then(function() {
                        optionalPromise(query("GET_BEFORE_ADD_FILE"), createItemAPI(item)).then(handleAdd);
                    }).catch(function(e) {
                        if (!e || !e.error || !e.status) return handleAdd(false);
                        dispatch("DID_THROW_ITEM_INVALID", {
                            id: id,
                            error: e.error,
                            status: e.status
                        });
                    });
                });
                item.on("process-start", function() {
                    dispatch("DID_START_ITEM_PROCESSING", {
                        id: id
                    });
                });
                item.on("process-progress", function(progress) {
                    dispatch("DID_UPDATE_ITEM_PROCESS_PROGRESS", {
                        id: id,
                        progress: progress
                    });
                });
                item.on("process-error", function(error) {
                    dispatch("DID_THROW_ITEM_PROCESSING_ERROR", {
                        id: id,
                        error: error,
                        status: {
                            main: dynamicLabel(state.options.labelFileProcessingError)(error),
                            sub: state.options.labelTapToRetry
                        }
                    });
                });
                item.on("process-revert-error", function(error) {
                    dispatch("DID_THROW_ITEM_PROCESSING_REVERT_ERROR", {
                        id: id,
                        error: error,
                        status: {
                            main: dynamicLabel(state.options.labelFileProcessingRevertError)(error),
                            sub: state.options.labelTapToRetry
                        }
                    });
                });
                item.on("process-complete", function(serverFileReference) {
                    dispatch("DID_COMPLETE_ITEM_PROCESSING", {
                        id: id,
                        error: null,
                        serverFileReference: serverFileReference
                    });
                    dispatch("DID_DEFINE_VALUE", {
                        id: id,
                        value: serverFileReference
                    });
                });
                item.on("process-abort", function() {
                    dispatch("DID_ABORT_ITEM_PROCESSING", {
                        id: id
                    });
                });
                item.on("process-revert", function() {
                    dispatch("DID_REVERT_ITEM_PROCESSING", {
                        id: id
                    });
                    dispatch("DID_DEFINE_VALUE", {
                        id: id,
                        value: null
                    });
                });
                // let view know the item has been inserted
                dispatch("DID_ADD_ITEM", {
                    id: id,
                    index: index,
                    interactionMethod: interactionMethod
                });
                listUpdated(dispatch, state);
                // start loading the source
                var _ref8 = state.options.server || {}, url = _ref8.url, load = _ref8.load, restore = _ref8.restore, fetch = _ref8.fetch;
                item.load(source, // this creates a function that loads the file based on the type of file (string, base64, blob, file) and location of file (local, remote, limbo)
                createFileLoader(origin === FileOrigin.INPUT ? isString(source) && isExternalURL(source) ? fetch ? createFetchFunction(url, fetch) : fetchBlob // remote url
                 : fetchBlob // try to fetch url
                 : origin === FileOrigin.LIMBO ? createFetchFunction(url, restore) // limbo
                 : createFetchFunction(url, load) // local
                ), // called when the file is loaded so it can be piped through the filters
                function(file, success, error) {
                    // let's process the file
                    applyFilterChain("LOAD_FILE", file, {
                        query: query
                    }).then(success).catch(error);
                });
            },
            REQUEST_PREPARE_OUTPUT: function REQUEST_PREPARE_OUTPUT(_ref9) {
                var item = _ref9.item, success = _ref9.success, _ref9$failure = _ref9.failure, failure = _ref9$failure === void 0 ? function() {} : _ref9$failure;
                // error response if item archived
                var err = {
                    error: createResponse("error", 0, "Item not found"),
                    file: null
                };
                // don't handle archived items, an item could have been archived (load aborted) while waiting to be prepared
                if (item.archived) return failure(err);
                // allow plugins to alter the file data
                applyFilterChain("PREPARE_OUTPUT", item.file, {
                    query: query,
                    item: item
                }).then(function(result) {
                    applyFilterChain("COMPLETE_PREPARE_OUTPUT", result, {
                        query: query,
                        item: item
                    }).then(function(result) {
                        // don't handle archived items, an item could have been archived (load aborted) while being prepared
                        if (item.archived) return failure(err);
                        // we done!
                        success(result);
                    });
                });
            },
            COMPLETE_LOAD_ITEM: function COMPLETE_LOAD_ITEM(_ref10) {
                var item = _ref10.item, data = _ref10.data;
                var success = data.success, source = data.source;
                // sort items in list
                var itemInsertLocation = query("GET_ITEM_INSERT_LOCATION");
                if (isFunction(itemInsertLocation) && source) sortItems(state, itemInsertLocation);
                // let interface know the item has loaded
                dispatch("DID_LOAD_ITEM", {
                    id: item.id,
                    error: null,
                    serverFileReference: item.origin === FileOrigin.INPUT ? null : source
                });
                // item has been successfully loaded and added to the
                // list of items so can now be safely returned for use
                success(createItemAPI(item));
                // if this is a local server file we need to show a different state
                if (item.origin === FileOrigin.LOCAL) {
                    dispatch("DID_LOAD_LOCAL_ITEM", {
                        id: item.id
                    });
                    return;
                }
                // if is a temp server file we prevent async upload call here (as the file is already on the server)
                if (item.origin === FileOrigin.LIMBO) {
                    dispatch("DID_COMPLETE_ITEM_PROCESSING", {
                        id: item.id,
                        error: null,
                        serverFileReference: source
                    });
                    dispatch("DID_DEFINE_VALUE", {
                        id: item.id,
                        value: item.serverId || source
                    });
                    return;
                }
                // id we are allowed to upload the file immediately, lets do it
                if (query("IS_ASYNC") && state.options.instantUpload) dispatch("REQUEST_ITEM_PROCESSING", {
                    query: item.id
                });
            },
            RETRY_ITEM_LOAD: getItemByQueryFromState(state, function(item) {
                // try loading the source one more time
                item.retryLoad();
            }),
            REQUEST_ITEM_PREPARE: getItemByQueryFromState(state, function(item, _success, failure) {
                dispatch("REQUEST_PREPARE_OUTPUT", {
                    query: item.id,
                    item: item,
                    success: function success(file) {
                        dispatch("DID_PREPARE_OUTPUT", {
                            id: item.id,
                            file: file
                        });
                        _success({
                            file: item,
                            output: file
                        });
                    },
                    failure: failure
                }, true);
            }),
            REQUEST_ITEM_PROCESSING: getItemByQueryFromState(state, function(item, success, failure) {
                // cannot be queued (or is already queued)
                var itemCanBeQueuedForProcessing = // waiting for something
                item.status === ItemStatus.IDLE || // processing went wrong earlier
                item.status === ItemStatus.PROCESSING_ERROR;
                // not ready to be processed
                if (!itemCanBeQueuedForProcessing) {
                    var processNow = function processNow() {
                        return dispatch("REQUEST_ITEM_PROCESSING", {
                            query: item,
                            success: success,
                            failure: failure
                        });
                    };
                    var process = function process() {
                        return document.hidden ? processNow() : setTimeout(processNow, 32);
                    };
                    // if already done processing or tried to revert but didn't work, try again
                    if (item.status === ItemStatus.PROCESSING_COMPLETE || item.status === ItemStatus.PROCESSING_REVERT_ERROR) item.revert(createRevertFunction(state.options.server.url, state.options.server.revert), query("GET_FORCE_REVERT")).then(process).catch(function() {}); // don't continue with processing if something went wrong
                    else if (item.status === ItemStatus.PROCESSING) item.abortProcessing().then(process);
                    return;
                }
                // already queued for processing
                if (item.status === ItemStatus.PROCESSING_QUEUED) return;
                item.requestProcessing();
                dispatch("DID_REQUEST_ITEM_PROCESSING", {
                    id: item.id
                });
                dispatch("PROCESS_ITEM", {
                    query: item,
                    success: success,
                    failure: failure
                }, true);
            }),
            PROCESS_ITEM: getItemByQueryFromState(state, function(item, success, failure) {
                var maxParallelUploads = query("GET_MAX_PARALLEL_UPLOADS");
                var totalCurrentUploads = query("GET_ITEMS_BY_STATUS", ItemStatus.PROCESSING).length;
                // queue and wait till queue is freed up
                if (totalCurrentUploads === maxParallelUploads) {
                    // queue for later processing
                    state.processingQueue.push({
                        id: item.id,
                        success: success,
                        failure: failure
                    });
                    // stop it!
                    return;
                }
                // if was not queued or is already processing exit here
                if (item.status === ItemStatus.PROCESSING) return;
                var processNext = function processNext() {
                    // process queueud items
                    var queueEntry = state.processingQueue.shift();
                    // no items left
                    if (!queueEntry) return;
                    // get item reference
                    var id = queueEntry.id, success = queueEntry.success, failure = queueEntry.failure;
                    var itemReference = getItemByQuery(state.items, id);
                    // if item was archived while in queue, jump to next
                    if (!itemReference || itemReference.archived) {
                        processNext();
                        return;
                    }
                    // process queued item
                    dispatch("PROCESS_ITEM", {
                        query: id,
                        success: success,
                        failure: failure
                    }, true);
                };
                // we done function
                item.onOnce("process-complete", function() {
                    success(createItemAPI(item));
                    processNext();
                    // if origin is local, and we're instant uploading, trigger remove of original
                    // as revert will remove file from list
                    var server = state.options.server;
                    var instantUpload = state.options.instantUpload;
                    if (instantUpload && item.origin === FileOrigin.LOCAL && isFunction(server.remove)) {
                        var noop = function noop() {};
                        item.origin = FileOrigin.LIMBO;
                        state.options.server.remove(item.source, noop, noop);
                    }
                    // All items processed? No errors?
                    var allItemsProcessed = query("GET_ITEMS_BY_STATUS", ItemStatus.PROCESSING_COMPLETE).length === state.items.length;
                    if (allItemsProcessed) dispatch("DID_COMPLETE_ITEM_PROCESSING_ALL");
                });
                // we error function
                item.onOnce("process-error", function(error) {
                    failure({
                        error: error,
                        file: createItemAPI(item)
                    });
                    processNext();
                });
                // start file processing
                var options = state.options;
                item.process(createFileProcessor(createProcessorFunction(options.server.url, options.server.process, options.name, {
                    chunkTransferId: item.transferId,
                    chunkServer: options.server.patch,
                    chunkUploads: options.chunkUploads,
                    chunkForce: options.chunkForce,
                    chunkSize: options.chunkSize,
                    chunkRetryDelays: options.chunkRetryDelays
                }), {
                    allowMinimumUploadDuration: query("GET_ALLOW_MINIMUM_UPLOAD_DURATION")
                }), // called when the file is about to be processed so it can be piped through the transform filters
                function(file, success, error) {
                    // allow plugins to alter the file data
                    applyFilterChain("PREPARE_OUTPUT", file, {
                        query: query,
                        item: item
                    }).then(function(file) {
                        dispatch("DID_PREPARE_OUTPUT", {
                            id: item.id,
                            file: file
                        });
                        success(file);
                    }).catch(error);
                });
            }),
            RETRY_ITEM_PROCESSING: getItemByQueryFromState(state, function(item) {
                dispatch("REQUEST_ITEM_PROCESSING", {
                    query: item
                });
            }),
            REQUEST_REMOVE_ITEM: getItemByQueryFromState(state, function(item) {
                optionalPromise(query("GET_BEFORE_REMOVE_FILE"), createItemAPI(item)).then(function(shouldRemove) {
                    if (!shouldRemove) return;
                    dispatch("REMOVE_ITEM", {
                        query: item
                    });
                });
            }),
            RELEASE_ITEM: getItemByQueryFromState(state, function(item) {
                item.release();
            }),
            REMOVE_ITEM: getItemByQueryFromState(state, function(item, success, failure, options) {
                var removeFromView = function removeFromView() {
                    // get id reference
                    var id = item.id;
                    // archive the item, this does not remove it from the list
                    getItemById(state.items, id).archive();
                    // tell the view the item has been removed
                    dispatch("DID_REMOVE_ITEM", {
                        error: null,
                        id: id,
                        item: item
                    });
                    // now the list has been modified
                    listUpdated(dispatch, state);
                    // correctly removed
                    success(createItemAPI(item));
                };
                // if this is a local file and the `server.remove` function has been configured,
                // send source there so dev can remove file from server
                var server = state.options.server;
                if (item.origin === FileOrigin.LOCAL && server && isFunction(server.remove) && options.remove !== false) {
                    dispatch("DID_START_ITEM_REMOVE", {
                        id: item.id
                    });
                    server.remove(item.source, function() {
                        return removeFromView();
                    }, function(status) {
                        dispatch("DID_THROW_ITEM_REMOVE_ERROR", {
                            id: item.id,
                            error: createResponse("error", 0, status, null),
                            status: {
                                main: dynamicLabel(state.options.labelFileRemoveError)(status),
                                sub: state.options.labelTapToRetry
                            }
                        });
                    });
                } else {
                    // if is requesting revert and can revert need to call revert handler (not calling request_ because that would also trigger beforeRemoveHook)
                    if (options.revert && item.origin !== FileOrigin.LOCAL && item.serverId !== null || // if chunked uploads are enabled and we're uploading in chunks for this specific file
                    // or if the file isn't big enough for chunked uploads but chunkForce is set then call
                    // revert before removing from the view...
                    state.options.chunkUploads && item.file.size > state.options.chunkSize || state.options.chunkUploads && state.options.chunkForce) item.revert(createRevertFunction(state.options.server.url, state.options.server.revert), query("GET_FORCE_REVERT"));
                    // can now safely remove from view
                    removeFromView();
                }
            }),
            ABORT_ITEM_LOAD: getItemByQueryFromState(state, function(item) {
                item.abortLoad();
            }),
            ABORT_ITEM_PROCESSING: getItemByQueryFromState(state, function(item) {
                // test if is already processed
                if (item.serverId) {
                    dispatch("REVERT_ITEM_PROCESSING", {
                        id: item.id
                    });
                    return;
                }
                // abort
                item.abortProcessing().then(function() {
                    var shouldRemove = state.options.instantUpload;
                    if (shouldRemove) dispatch("REMOVE_ITEM", {
                        query: item.id
                    });
                });
            }),
            REQUEST_REVERT_ITEM_PROCESSING: getItemByQueryFromState(state, function(item) {
                // not instant uploading, revert immediately
                if (!state.options.instantUpload) {
                    dispatch("REVERT_ITEM_PROCESSING", {
                        query: item
                    });
                    return;
                }
                // if we're instant uploading the file will also be removed if we revert,
                // so if a before remove file hook is defined we need to run it now
                var handleRevert = function handleRevert(shouldRevert) {
                    if (!shouldRevert) return;
                    dispatch("REVERT_ITEM_PROCESSING", {
                        query: item
                    });
                };
                var fn = query("GET_BEFORE_REMOVE_FILE");
                if (!fn) return handleRevert(true);
                var requestRemoveResult = fn(createItemAPI(item));
                if (requestRemoveResult == null) // undefined or null
                return handleRevert(true);
                if (typeof requestRemoveResult === "boolean") return handleRevert(requestRemoveResult);
                if (typeof requestRemoveResult.then === "function") requestRemoveResult.then(handleRevert);
            }),
            REVERT_ITEM_PROCESSING: getItemByQueryFromState(state, function(item) {
                item.revert(createRevertFunction(state.options.server.url, state.options.server.revert), query("GET_FORCE_REVERT")).then(function() {
                    var shouldRemove = state.options.instantUpload || isMockItem(item);
                    if (shouldRemove) dispatch("REMOVE_ITEM", {
                        query: item.id
                    });
                }).catch(function() {});
            }),
            SET_OPTIONS: function SET_OPTIONS(_ref11) {
                var options = _ref11.options;
                // get all keys passed
                var optionKeys = Object.keys(options);
                // get prioritized keyed to include (remove once not in options object)
                var prioritizedOptionKeys = PrioritizedOptions.filter(function(key) {
                    return optionKeys.includes(key);
                });
                // order the keys, prioritized first, then rest
                var orderedOptionKeys = [].concat(_toConsumableArray(prioritizedOptionKeys), _toConsumableArray(Object.keys(options).filter(function(key) {
                    return !prioritizedOptionKeys.includes(key);
                })));
                // dispatch set event for each option
                orderedOptionKeys.forEach(function(key) {
                    dispatch("SET_" + fromCamels(key, "_").toUpperCase(), {
                        value: options[key]
                    });
                });
            }
        };
    };
    var PrioritizedOptions = [
        "server"
    ];
    var formatFilename = function formatFilename(name) {
        return name;
    };
    var createElement$1 = function createElement(tagName) {
        return document.createElement(tagName);
    };
    var text = function text(node, value) {
        var textNode = node.childNodes[0];
        if (!textNode) {
            textNode = document.createTextNode(value);
            node.appendChild(textNode);
        } else if (value !== textNode.nodeValue) textNode.nodeValue = value;
    };
    var polarToCartesian = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
        var angleInRadians = (angleInDegrees % 360 - 90) * Math.PI / 180.0;
        return {
            x: centerX + radius * Math.cos(angleInRadians),
            y: centerY + radius * Math.sin(angleInRadians)
        };
    };
    var describeArc = function describeArc(x, y, radius, startAngle, endAngle, arcSweep) {
        var start = polarToCartesian(x, y, radius, endAngle);
        var end = polarToCartesian(x, y, radius, startAngle);
        return [
            "M",
            start.x,
            start.y,
            "A",
            radius,
            radius,
            0,
            arcSweep,
            0,
            end.x,
            end.y
        ].join(" ");
    };
    var percentageArc = function percentageArc(x, y, radius, from, to) {
        var arcSweep = 1;
        if (to > from && to - from <= 0.5) arcSweep = 0;
        if (from > to && from - to >= 0.5) arcSweep = 0;
        return describeArc(x, y, radius, Math.min(0.9999, from) * 360, Math.min(0.9999, to) * 360, arcSweep);
    };
    var create = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        // start at 0
        props.spin = false;
        props.progress = 0;
        props.opacity = 0;
        // svg
        var svg = createElement("svg");
        root.ref.path = createElement("path", {
            "stroke-width": 2,
            "stroke-linecap": "round"
        });
        svg.appendChild(root.ref.path);
        root.ref.svg = svg;
        root.appendChild(svg);
    };
    var write = function write(_ref2) {
        var root = _ref2.root, props = _ref2.props;
        if (props.opacity === 0) return;
        if (props.align) root.element.dataset.align = props.align;
        // get width of stroke
        var ringStrokeWidth = parseInt(attr(root.ref.path, "stroke-width"), 10);
        // calculate size of ring
        var size = root.rect.element.width * 0.5;
        // ring state
        var ringFrom = 0;
        var ringTo = 0;
        // now in busy mode
        if (props.spin) {
            ringFrom = 0;
            ringTo = 0.5;
        } else {
            ringFrom = 0;
            ringTo = props.progress;
        }
        // get arc path
        var coordinates = percentageArc(size, size, size - ringStrokeWidth, ringFrom, ringTo);
        // update progress bar
        attr(root.ref.path, "d", coordinates);
        // hide while contains 0 value
        attr(root.ref.path, "stroke-opacity", props.spin || props.progress > 0 ? 1 : 0);
    };
    var progressIndicator = createView({
        tag: "div",
        name: "progress-indicator",
        ignoreRectUpdate: true,
        ignoreRect: true,
        create: create,
        write: write,
        mixins: {
            apis: [
                "progress",
                "spin",
                "align"
            ],
            styles: [
                "opacity"
            ],
            animations: {
                opacity: {
                    type: "tween",
                    duration: 500
                },
                progress: {
                    type: "spring",
                    stiffness: 0.95,
                    damping: 0.65,
                    mass: 10
                }
            }
        }
    });
    var create$1 = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        root.element.innerHTML = (props.icon || "") + ("<span>" + props.label + "</span>");
        props.isDisabled = false;
    };
    var write$1 = function write(_ref2) {
        var root = _ref2.root, props = _ref2.props;
        var isDisabled = props.isDisabled;
        var shouldDisable = root.query("GET_DISABLED") || props.opacity === 0;
        if (shouldDisable && !isDisabled) {
            props.isDisabled = true;
            attr(root.element, "disabled", "disabled");
        } else if (!shouldDisable && isDisabled) {
            props.isDisabled = false;
            root.element.removeAttribute("disabled");
        }
    };
    var fileActionButton = createView({
        tag: "button",
        attributes: {
            type: "button"
        },
        ignoreRect: true,
        ignoreRectUpdate: true,
        name: "file-action-button",
        mixins: {
            apis: [
                "label"
            ],
            styles: [
                "translateX",
                "translateY",
                "scaleX",
                "scaleY",
                "opacity"
            ],
            animations: {
                scaleX: "spring",
                scaleY: "spring",
                translateX: "spring",
                translateY: "spring",
                opacity: {
                    type: "tween",
                    duration: 250
                }
            },
            listeners: true
        },
        create: create$1,
        write: write$1
    });
    var toNaturalFileSize = function toNaturalFileSize(bytes) {
        var decimalSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".";
        var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var _options$labelBytes = options.labelBytes, labelBytes = _options$labelBytes === void 0 ? "bytes" : _options$labelBytes, _options$labelKilobyt = options.labelKilobytes, labelKilobytes = _options$labelKilobyt === void 0 ? "KB" : _options$labelKilobyt, _options$labelMegabyt = options.labelMegabytes, labelMegabytes = _options$labelMegabyt === void 0 ? "MB" : _options$labelMegabyt, _options$labelGigabyt = options.labelGigabytes, labelGigabytes = _options$labelGigabyt === void 0 ? "GB" : _options$labelGigabyt;
        // no negative byte sizes
        bytes = Math.round(Math.abs(bytes));
        var KB = base;
        var MB = base * base;
        var GB = base * base * base;
        // just bytes
        if (bytes < KB) return bytes + " " + labelBytes;
        // kilobytes
        if (bytes < MB) return Math.floor(bytes / KB) + " " + labelKilobytes;
        // megabytes
        if (bytes < GB) return removeDecimalsWhenZero(bytes / MB, 1, decimalSeparator) + " " + labelMegabytes;
        // gigabytes
        return removeDecimalsWhenZero(bytes / GB, 2, decimalSeparator) + " " + labelGigabytes;
    };
    var removeDecimalsWhenZero = function removeDecimalsWhenZero(value, decimalCount, separator) {
        return value.toFixed(decimalCount).split(".").filter(function(part) {
            return part !== "0";
        }).join(separator);
    };
    var create$2 = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        // filename
        var fileName = createElement$1("span");
        fileName.className = "filepond--file-info-main";
        // hide for screenreaders
        // the file is contained in a fieldset with legend that contains the filename
        // no need to read it twice
        attr(fileName, "aria-hidden", "true");
        root.appendChild(fileName);
        root.ref.fileName = fileName;
        // filesize
        var fileSize = createElement$1("span");
        fileSize.className = "filepond--file-info-sub";
        root.appendChild(fileSize);
        root.ref.fileSize = fileSize;
        // set initial values
        text(fileSize, root.query("GET_LABEL_FILE_WAITING_FOR_SIZE"));
        text(fileName, formatFilename(root.query("GET_ITEM_NAME", props.id)));
    };
    var updateFile = function updateFile(_ref2) {
        var root = _ref2.root, props = _ref2.props;
        text(root.ref.fileSize, toNaturalFileSize(root.query("GET_ITEM_SIZE", props.id), ".", root.query("GET_FILE_SIZE_BASE"), root.query("GET_FILE_SIZE_LABELS", root.query)));
        text(root.ref.fileName, formatFilename(root.query("GET_ITEM_NAME", props.id)));
    };
    var updateFileSizeOnError = function updateFileSizeOnError(_ref3) {
        var root = _ref3.root, props = _ref3.props;
        // if size is available don't fallback to unknown size message
        if (isInt(root.query("GET_ITEM_SIZE", props.id))) {
            updateFile({
                root: root,
                props: props
            });
            return;
        }
        text(root.ref.fileSize, root.query("GET_LABEL_FILE_SIZE_NOT_AVAILABLE"));
    };
    var fileInfo = createView({
        name: "file-info",
        ignoreRect: true,
        ignoreRectUpdate: true,
        write: createRoute({
            DID_LOAD_ITEM: updateFile,
            DID_UPDATE_ITEM_META: updateFile,
            DID_THROW_ITEM_LOAD_ERROR: updateFileSizeOnError,
            DID_THROW_ITEM_INVALID: updateFileSizeOnError
        }),
        didCreateView: function didCreateView(root) {
            applyFilters("CREATE_VIEW", Object.assign({}, root, {
                view: root
            }));
        },
        create: create$2,
        mixins: {
            styles: [
                "translateX",
                "translateY"
            ],
            animations: {
                translateX: "spring",
                translateY: "spring"
            }
        }
    });
    var toPercentage = function toPercentage(value) {
        return Math.round(value * 100);
    };
    var create$3 = function create(_ref) {
        var root = _ref.root;
        // main status
        var main = createElement$1("span");
        main.className = "filepond--file-status-main";
        root.appendChild(main);
        root.ref.main = main;
        // sub status
        var sub = createElement$1("span");
        sub.className = "filepond--file-status-sub";
        root.appendChild(sub);
        root.ref.sub = sub;
        didSetItemLoadProgress({
            root: root,
            action: {
                progress: null
            }
        });
    };
    var didSetItemLoadProgress = function didSetItemLoadProgress(_ref2) {
        var root = _ref2.root, action = _ref2.action;
        var title = action.progress === null ? root.query("GET_LABEL_FILE_LOADING") : root.query("GET_LABEL_FILE_LOADING") + " " + toPercentage(action.progress) + "%";
        text(root.ref.main, title);
        text(root.ref.sub, root.query("GET_LABEL_TAP_TO_CANCEL"));
    };
    var didSetItemProcessProgress = function didSetItemProcessProgress(_ref3) {
        var root = _ref3.root, action = _ref3.action;
        var title = action.progress === null ? root.query("GET_LABEL_FILE_PROCESSING") : root.query("GET_LABEL_FILE_PROCESSING") + " " + toPercentage(action.progress) + "%";
        text(root.ref.main, title);
        text(root.ref.sub, root.query("GET_LABEL_TAP_TO_CANCEL"));
    };
    var didRequestItemProcessing = function didRequestItemProcessing(_ref4) {
        var root = _ref4.root;
        text(root.ref.main, root.query("GET_LABEL_FILE_PROCESSING"));
        text(root.ref.sub, root.query("GET_LABEL_TAP_TO_CANCEL"));
    };
    var didAbortItemProcessing = function didAbortItemProcessing(_ref5) {
        var root = _ref5.root;
        text(root.ref.main, root.query("GET_LABEL_FILE_PROCESSING_ABORTED"));
        text(root.ref.sub, root.query("GET_LABEL_TAP_TO_RETRY"));
    };
    var didCompleteItemProcessing = function didCompleteItemProcessing(_ref6) {
        var root = _ref6.root;
        text(root.ref.main, root.query("GET_LABEL_FILE_PROCESSING_COMPLETE"));
        text(root.ref.sub, root.query("GET_LABEL_TAP_TO_UNDO"));
    };
    var clear = function clear(_ref7) {
        var root = _ref7.root;
        text(root.ref.main, "");
        text(root.ref.sub, "");
    };
    var error = function error(_ref8) {
        var root = _ref8.root, action = _ref8.action;
        text(root.ref.main, action.status.main);
        text(root.ref.sub, action.status.sub);
    };
    var fileStatus = createView({
        name: "file-status",
        ignoreRect: true,
        ignoreRectUpdate: true,
        write: createRoute({
            DID_LOAD_ITEM: clear,
            DID_REVERT_ITEM_PROCESSING: clear,
            DID_REQUEST_ITEM_PROCESSING: didRequestItemProcessing,
            DID_ABORT_ITEM_PROCESSING: didAbortItemProcessing,
            DID_COMPLETE_ITEM_PROCESSING: didCompleteItemProcessing,
            DID_UPDATE_ITEM_PROCESS_PROGRESS: didSetItemProcessProgress,
            DID_UPDATE_ITEM_LOAD_PROGRESS: didSetItemLoadProgress,
            DID_THROW_ITEM_LOAD_ERROR: error,
            DID_THROW_ITEM_INVALID: error,
            DID_THROW_ITEM_PROCESSING_ERROR: error,
            DID_THROW_ITEM_PROCESSING_REVERT_ERROR: error,
            DID_THROW_ITEM_REMOVE_ERROR: error
        }),
        didCreateView: function didCreateView(root) {
            applyFilters("CREATE_VIEW", Object.assign({}, root, {
                view: root
            }));
        },
        create: create$3,
        mixins: {
            styles: [
                "translateX",
                "translateY",
                "opacity"
            ],
            animations: {
                opacity: {
                    type: "tween",
                    duration: 250
                },
                translateX: "spring",
                translateY: "spring"
            }
        }
    });
    /**
     * Button definitions for the file view
     */ var Buttons = {
        AbortItemLoad: {
            label: "GET_LABEL_BUTTON_ABORT_ITEM_LOAD",
            action: "ABORT_ITEM_LOAD",
            className: "filepond--action-abort-item-load",
            align: "LOAD_INDICATOR_POSITION"
        },
        RetryItemLoad: {
            label: "GET_LABEL_BUTTON_RETRY_ITEM_LOAD",
            action: "RETRY_ITEM_LOAD",
            icon: "GET_ICON_RETRY",
            className: "filepond--action-retry-item-load",
            align: "BUTTON_PROCESS_ITEM_POSITION"
        },
        RemoveItem: {
            label: "GET_LABEL_BUTTON_REMOVE_ITEM",
            action: "REQUEST_REMOVE_ITEM",
            icon: "GET_ICON_REMOVE",
            className: "filepond--action-remove-item",
            align: "BUTTON_REMOVE_ITEM_POSITION"
        },
        ProcessItem: {
            label: "GET_LABEL_BUTTON_PROCESS_ITEM",
            action: "REQUEST_ITEM_PROCESSING",
            icon: "GET_ICON_PROCESS",
            className: "filepond--action-process-item",
            align: "BUTTON_PROCESS_ITEM_POSITION"
        },
        AbortItemProcessing: {
            label: "GET_LABEL_BUTTON_ABORT_ITEM_PROCESSING",
            action: "ABORT_ITEM_PROCESSING",
            className: "filepond--action-abort-item-processing",
            align: "BUTTON_PROCESS_ITEM_POSITION"
        },
        RetryItemProcessing: {
            label: "GET_LABEL_BUTTON_RETRY_ITEM_PROCESSING",
            action: "RETRY_ITEM_PROCESSING",
            icon: "GET_ICON_RETRY",
            className: "filepond--action-retry-item-processing",
            align: "BUTTON_PROCESS_ITEM_POSITION"
        },
        RevertItemProcessing: {
            label: "GET_LABEL_BUTTON_UNDO_ITEM_PROCESSING",
            action: "REQUEST_REVERT_ITEM_PROCESSING",
            icon: "GET_ICON_UNDO",
            className: "filepond--action-revert-item-processing",
            align: "BUTTON_PROCESS_ITEM_POSITION"
        }
    };
    // make a list of buttons, we can then remove buttons from this list if they're disabled
    var ButtonKeys = [];
    forin(Buttons, function(key) {
        ButtonKeys.push(key);
    });
    var calculateFileInfoOffset = function calculateFileInfoOffset(root) {
        if (getRemoveIndicatorAligment(root) === "right") return 0;
        var buttonRect = root.ref.buttonRemoveItem.rect.element;
        return buttonRect.hidden ? null : buttonRect.width + buttonRect.left;
    };
    var calculateButtonWidth = function calculateButtonWidth(root) {
        var buttonRect = root.ref.buttonAbortItemLoad.rect.element;
        return buttonRect.width;
    };
    // Force on full pixels so text stays crips
    var calculateFileVerticalCenterOffset = function calculateFileVerticalCenterOffset(root) {
        return Math.floor(root.ref.buttonRemoveItem.rect.element.height / 4);
    };
    var calculateFileHorizontalCenterOffset = function calculateFileHorizontalCenterOffset(root) {
        return Math.floor(root.ref.buttonRemoveItem.rect.element.left / 2);
    };
    var getLoadIndicatorAlignment = function getLoadIndicatorAlignment(root) {
        return root.query("GET_STYLE_LOAD_INDICATOR_POSITION");
    };
    var getProcessIndicatorAlignment = function getProcessIndicatorAlignment(root) {
        return root.query("GET_STYLE_PROGRESS_INDICATOR_POSITION");
    };
    var getRemoveIndicatorAligment = function getRemoveIndicatorAligment(root) {
        return root.query("GET_STYLE_BUTTON_REMOVE_ITEM_POSITION");
    };
    var DefaultStyle = {
        buttonAbortItemLoad: {
            opacity: 0
        },
        buttonRetryItemLoad: {
            opacity: 0
        },
        buttonRemoveItem: {
            opacity: 0
        },
        buttonProcessItem: {
            opacity: 0
        },
        buttonAbortItemProcessing: {
            opacity: 0
        },
        buttonRetryItemProcessing: {
            opacity: 0
        },
        buttonRevertItemProcessing: {
            opacity: 0
        },
        loadProgressIndicator: {
            opacity: 0,
            align: getLoadIndicatorAlignment
        },
        processProgressIndicator: {
            opacity: 0,
            align: getProcessIndicatorAlignment
        },
        processingCompleteIndicator: {
            opacity: 0,
            scaleX: 0.75,
            scaleY: 0.75
        },
        info: {
            translateX: 0,
            translateY: 0,
            opacity: 0
        },
        status: {
            translateX: 0,
            translateY: 0,
            opacity: 0
        }
    };
    var IdleStyle = {
        buttonRemoveItem: {
            opacity: 1
        },
        buttonProcessItem: {
            opacity: 1
        },
        info: {
            translateX: calculateFileInfoOffset
        },
        status: {
            translateX: calculateFileInfoOffset
        }
    };
    var ProcessingStyle = {
        buttonAbortItemProcessing: {
            opacity: 1
        },
        processProgressIndicator: {
            opacity: 1
        },
        status: {
            opacity: 1
        }
    };
    var StyleMap = {
        DID_THROW_ITEM_INVALID: {
            buttonRemoveItem: {
                opacity: 1
            },
            info: {
                translateX: calculateFileInfoOffset
            },
            status: {
                translateX: calculateFileInfoOffset,
                opacity: 1
            }
        },
        DID_START_ITEM_LOAD: {
            buttonAbortItemLoad: {
                opacity: 1
            },
            loadProgressIndicator: {
                opacity: 1
            },
            status: {
                opacity: 1
            }
        },
        DID_THROW_ITEM_LOAD_ERROR: {
            buttonRetryItemLoad: {
                opacity: 1
            },
            buttonRemoveItem: {
                opacity: 1
            },
            info: {
                translateX: calculateFileInfoOffset
            },
            status: {
                opacity: 1
            }
        },
        DID_START_ITEM_REMOVE: {
            processProgressIndicator: {
                opacity: 1,
                align: getRemoveIndicatorAligment
            },
            info: {
                translateX: calculateFileInfoOffset
            },
            status: {
                opacity: 0
            }
        },
        DID_THROW_ITEM_REMOVE_ERROR: {
            processProgressIndicator: {
                opacity: 0,
                align: getRemoveIndicatorAligment
            },
            buttonRemoveItem: {
                opacity: 1
            },
            info: {
                translateX: calculateFileInfoOffset
            },
            status: {
                opacity: 1,
                translateX: calculateFileInfoOffset
            }
        },
        DID_LOAD_ITEM: IdleStyle,
        DID_LOAD_LOCAL_ITEM: {
            buttonRemoveItem: {
                opacity: 1
            },
            info: {
                translateX: calculateFileInfoOffset
            },
            status: {
                translateX: calculateFileInfoOffset
            }
        },
        DID_START_ITEM_PROCESSING: ProcessingStyle,
        DID_REQUEST_ITEM_PROCESSING: ProcessingStyle,
        DID_UPDATE_ITEM_PROCESS_PROGRESS: ProcessingStyle,
        DID_COMPLETE_ITEM_PROCESSING: {
            buttonRevertItemProcessing: {
                opacity: 1
            },
            info: {
                opacity: 1
            },
            status: {
                opacity: 1
            }
        },
        DID_THROW_ITEM_PROCESSING_ERROR: {
            buttonRemoveItem: {
                opacity: 1
            },
            buttonRetryItemProcessing: {
                opacity: 1
            },
            status: {
                opacity: 1
            },
            info: {
                translateX: calculateFileInfoOffset
            }
        },
        DID_THROW_ITEM_PROCESSING_REVERT_ERROR: {
            buttonRevertItemProcessing: {
                opacity: 1
            },
            status: {
                opacity: 1
            },
            info: {
                opacity: 1
            }
        },
        DID_ABORT_ITEM_PROCESSING: {
            buttonRemoveItem: {
                opacity: 1
            },
            buttonProcessItem: {
                opacity: 1
            },
            info: {
                translateX: calculateFileInfoOffset
            },
            status: {
                opacity: 1
            }
        },
        DID_REVERT_ITEM_PROCESSING: IdleStyle
    };
    // complete indicator view
    var processingCompleteIndicatorView = createView({
        create: function create(_ref) {
            var root = _ref.root;
            root.element.innerHTML = root.query("GET_ICON_DONE");
        },
        name: "processing-complete-indicator",
        ignoreRect: true,
        mixins: {
            styles: [
                "scaleX",
                "scaleY",
                "opacity"
            ],
            animations: {
                scaleX: "spring",
                scaleY: "spring",
                opacity: {
                    type: "tween",
                    duration: 250
                }
            }
        }
    });
    /**
     * Creates the file view
     */ var create$4 = function create(_ref2) {
        var root = _ref2.root, props = _ref2.props;
        // copy Buttons object
        var LocalButtons = Object.keys(Buttons).reduce(function(prev, curr) {
            prev[curr] = Object.assign({}, Buttons[curr]);
            return prev;
        }, {});
        var id = props.id;
        // allow reverting upload
        var allowRevert = root.query("GET_ALLOW_REVERT");
        // allow remove file
        var allowRemove = root.query("GET_ALLOW_REMOVE");
        // allow processing upload
        var allowProcess = root.query("GET_ALLOW_PROCESS");
        // is instant uploading, need this to determine the icon of the undo button
        var instantUpload = root.query("GET_INSTANT_UPLOAD");
        // is async set up
        var isAsync = root.query("IS_ASYNC");
        // should align remove item buttons
        var alignRemoveItemButton = root.query("GET_STYLE_BUTTON_REMOVE_ITEM_ALIGN");
        // enabled buttons array
        var buttonFilter;
        if (isAsync) {
            if (allowProcess && !allowRevert) // only remove revert button
            buttonFilter = function buttonFilter(key) {
                return !/RevertItemProcessing/.test(key);
            };
            else if (!allowProcess && allowRevert) // only remove process button
            buttonFilter = function buttonFilter(key) {
                return !/ProcessItem|RetryItemProcessing|AbortItemProcessing/.test(key);
            };
            else if (!allowProcess && !allowRevert) // remove all process buttons
            buttonFilter = function buttonFilter(key) {
                return !/Process/.test(key);
            };
        } else // no process controls available
        buttonFilter = function buttonFilter(key) {
            return !/Process/.test(key);
        };
        var enabledButtons = buttonFilter ? ButtonKeys.filter(buttonFilter) : ButtonKeys.concat();
        // update icon and label for revert button when instant uploading
        if (instantUpload && allowRevert) {
            LocalButtons["RevertItemProcessing"].label = "GET_LABEL_BUTTON_REMOVE_ITEM";
            LocalButtons["RevertItemProcessing"].icon = "GET_ICON_REMOVE";
        }
        // remove last button (revert) if not allowed
        if (isAsync && !allowRevert) {
            var map = StyleMap["DID_COMPLETE_ITEM_PROCESSING"];
            map.info.translateX = calculateFileHorizontalCenterOffset;
            map.info.translateY = calculateFileVerticalCenterOffset;
            map.status.translateY = calculateFileVerticalCenterOffset;
            map.processingCompleteIndicator = {
                opacity: 1,
                scaleX: 1,
                scaleY: 1
            };
        }
        // should align center
        if (isAsync && !allowProcess) {
            [
                "DID_START_ITEM_PROCESSING",
                "DID_REQUEST_ITEM_PROCESSING",
                "DID_UPDATE_ITEM_PROCESS_PROGRESS",
                "DID_THROW_ITEM_PROCESSING_ERROR"
            ].forEach(function(key) {
                StyleMap[key].status.translateY = calculateFileVerticalCenterOffset;
            });
            StyleMap["DID_THROW_ITEM_PROCESSING_ERROR"].status.translateX = calculateButtonWidth;
        }
        // move remove button to right
        if (alignRemoveItemButton && allowRevert) {
            LocalButtons["RevertItemProcessing"].align = "BUTTON_REMOVE_ITEM_POSITION";
            var _map = StyleMap["DID_COMPLETE_ITEM_PROCESSING"];
            _map.info.translateX = calculateFileInfoOffset;
            _map.status.translateY = calculateFileVerticalCenterOffset;
            _map.processingCompleteIndicator = {
                opacity: 1,
                scaleX: 1,
                scaleY: 1
            };
        }
        // show/hide RemoveItem button
        if (!allowRemove) LocalButtons["RemoveItem"].disabled = true;
        // create the button views
        forin(LocalButtons, function(key, definition) {
            // create button
            var buttonView = root.createChildView(fileActionButton, {
                label: root.query(definition.label),
                icon: root.query(definition.icon),
                opacity: 0
            });
            // should be appended?
            if (enabledButtons.includes(key)) root.appendChildView(buttonView);
            // toggle
            if (definition.disabled) {
                buttonView.element.setAttribute("disabled", "disabled");
                buttonView.element.setAttribute("hidden", "hidden");
            }
            // add position attribute
            buttonView.element.dataset.align = root.query("GET_STYLE_" + definition.align);
            // add class
            buttonView.element.classList.add(definition.className);
            // handle interactions
            buttonView.on("click", function(e) {
                e.stopPropagation();
                if (definition.disabled) return;
                root.dispatch(definition.action, {
                    query: id
                });
            });
            // set reference
            root.ref["button" + key] = buttonView;
        });
        // checkmark
        root.ref.processingCompleteIndicator = root.appendChildView(root.createChildView(processingCompleteIndicatorView));
        root.ref.processingCompleteIndicator.element.dataset.align = root.query("GET_STYLE_BUTTON_PROCESS_ITEM_POSITION");
        // create file info view
        root.ref.info = root.appendChildView(root.createChildView(fileInfo, {
            id: id
        }));
        // create file status view
        root.ref.status = root.appendChildView(root.createChildView(fileStatus, {
            id: id
        }));
        // add progress indicators
        var loadIndicatorView = root.appendChildView(root.createChildView(progressIndicator, {
            opacity: 0,
            align: root.query("GET_STYLE_LOAD_INDICATOR_POSITION")
        }));
        loadIndicatorView.element.classList.add("filepond--load-indicator");
        root.ref.loadProgressIndicator = loadIndicatorView;
        var progressIndicatorView = root.appendChildView(root.createChildView(progressIndicator, {
            opacity: 0,
            align: root.query("GET_STYLE_PROGRESS_INDICATOR_POSITION")
        }));
        progressIndicatorView.element.classList.add("filepond--process-indicator");
        root.ref.processProgressIndicator = progressIndicatorView;
        // current active styles
        root.ref.activeStyles = [];
    };
    var write$2 = function write(_ref3) {
        var root = _ref3.root, actions = _ref3.actions, props = _ref3.props;
        // route actions
        route({
            root: root,
            actions: actions,
            props: props
        });
        // select last state change action
        var action = actions.concat().filter(function(action) {
            return /^DID_/.test(action.type);
        }).reverse().find(function(action) {
            return StyleMap[action.type];
        });
        // a new action happened, let's get the matching styles
        if (action) {
            // define new active styles
            root.ref.activeStyles = [];
            var stylesToApply = StyleMap[action.type];
            forin(DefaultStyle, function(name, defaultStyles) {
                // get reference to control
                var control = root.ref[name];
                // loop over all styles for this control
                forin(defaultStyles, function(key, defaultValue) {
                    var value = stylesToApply[name] && typeof stylesToApply[name][key] !== "undefined" ? stylesToApply[name][key] : defaultValue;
                    root.ref.activeStyles.push({
                        control: control,
                        key: key,
                        value: value
                    });
                });
            });
        }
        // apply active styles to element
        root.ref.activeStyles.forEach(function(_ref4) {
            var control = _ref4.control, key = _ref4.key, value = _ref4.value;
            control[key] = typeof value === "function" ? value(root) : value;
        });
    };
    var route = createRoute({
        DID_SET_LABEL_BUTTON_ABORT_ITEM_PROCESSING: function DID_SET_LABEL_BUTTON_ABORT_ITEM_PROCESSING(_ref5) {
            var root = _ref5.root, action = _ref5.action;
            root.ref.buttonAbortItemProcessing.label = action.value;
        },
        DID_SET_LABEL_BUTTON_ABORT_ITEM_LOAD: function DID_SET_LABEL_BUTTON_ABORT_ITEM_LOAD(_ref6) {
            var root = _ref6.root, action = _ref6.action;
            root.ref.buttonAbortItemLoad.label = action.value;
        },
        DID_SET_LABEL_BUTTON_ABORT_ITEM_REMOVAL: function DID_SET_LABEL_BUTTON_ABORT_ITEM_REMOVAL(_ref7) {
            var root = _ref7.root, action = _ref7.action;
            root.ref.buttonAbortItemRemoval.label = action.value;
        },
        DID_REQUEST_ITEM_PROCESSING: function DID_REQUEST_ITEM_PROCESSING(_ref8) {
            var root = _ref8.root;
            root.ref.processProgressIndicator.spin = true;
            root.ref.processProgressIndicator.progress = 0;
        },
        DID_START_ITEM_LOAD: function DID_START_ITEM_LOAD(_ref9) {
            var root = _ref9.root;
            root.ref.loadProgressIndicator.spin = true;
            root.ref.loadProgressIndicator.progress = 0;
        },
        DID_START_ITEM_REMOVE: function DID_START_ITEM_REMOVE(_ref10) {
            var root = _ref10.root;
            root.ref.processProgressIndicator.spin = true;
            root.ref.processProgressIndicator.progress = 0;
        },
        DID_UPDATE_ITEM_LOAD_PROGRESS: function DID_UPDATE_ITEM_LOAD_PROGRESS(_ref11) {
            var root = _ref11.root, action = _ref11.action;
            root.ref.loadProgressIndicator.spin = false;
            root.ref.loadProgressIndicator.progress = action.progress;
        },
        DID_UPDATE_ITEM_PROCESS_PROGRESS: function DID_UPDATE_ITEM_PROCESS_PROGRESS(_ref12) {
            var root = _ref12.root, action = _ref12.action;
            root.ref.processProgressIndicator.spin = false;
            root.ref.processProgressIndicator.progress = action.progress;
        }
    });
    var file = createView({
        create: create$4,
        write: write$2,
        didCreateView: function didCreateView(root) {
            applyFilters("CREATE_VIEW", Object.assign({}, root, {
                view: root
            }));
        },
        name: "file"
    });
    /**
     * Creates the file view
     */ var create$5 = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        // filename
        root.ref.fileName = createElement$1("legend");
        root.appendChild(root.ref.fileName);
        // file appended
        root.ref.file = root.appendChildView(root.createChildView(file, {
            id: props.id
        }));
        // data has moved to data.js
        root.ref.data = false;
    };
    /**
     * Data storage
     */ var didLoadItem = function didLoadItem(_ref2) {
        var root = _ref2.root, props = _ref2.props;
        // updates the legend of the fieldset so screenreaders can better group buttons
        text(root.ref.fileName, formatFilename(root.query("GET_ITEM_NAME", props.id)));
    };
    var fileWrapper = createView({
        create: create$5,
        ignoreRect: true,
        write: createRoute({
            DID_LOAD_ITEM: didLoadItem
        }),
        didCreateView: function didCreateView(root) {
            applyFilters("CREATE_VIEW", Object.assign({}, root, {
                view: root
            }));
        },
        tag: "fieldset",
        name: "file-wrapper"
    });
    var PANEL_SPRING_PROPS = {
        type: "spring",
        damping: 0.6,
        mass: 7
    };
    var create$6 = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        [
            {
                name: "top"
            },
            {
                name: "center",
                props: {
                    translateY: null,
                    scaleY: null
                },
                mixins: {
                    animations: {
                        scaleY: PANEL_SPRING_PROPS
                    },
                    styles: [
                        "translateY",
                        "scaleY"
                    ]
                }
            },
            {
                name: "bottom",
                props: {
                    translateY: null
                },
                mixins: {
                    animations: {
                        translateY: PANEL_SPRING_PROPS
                    },
                    styles: [
                        "translateY"
                    ]
                }
            }
        ].forEach(function(section) {
            createSection(root, section, props.name);
        });
        root.element.classList.add("filepond--" + props.name);
        root.ref.scalable = null;
    };
    var createSection = function createSection(root, section, className) {
        var viewConstructor = createView({
            name: "panel-" + section.name + " filepond--" + className,
            mixins: section.mixins,
            ignoreRectUpdate: true
        });
        var view = root.createChildView(viewConstructor, section.props);
        root.ref[section.name] = root.appendChildView(view);
    };
    var write$3 = function write(_ref2) {
        var root = _ref2.root, props = _ref2.props;
        // update scalable state
        if (root.ref.scalable === null || props.scalable !== root.ref.scalable) {
            root.ref.scalable = isBoolean(props.scalable) ? props.scalable : true;
            root.element.dataset.scalable = root.ref.scalable;
        }
        // no height, can't set
        if (!props.height) return;
        // get child rects
        var topRect = root.ref.top.rect.element;
        var bottomRect = root.ref.bottom.rect.element;
        // make sure height never is smaller than bottom and top seciton heights combined (will probably never happen, but who knows)
        var height = Math.max(topRect.height + bottomRect.height, props.height);
        // offset center part
        root.ref.center.translateY = topRect.height;
        // scale center part
        // use math ceil to prevent transparent lines because of rounding errors
        root.ref.center.scaleY = (height - topRect.height - bottomRect.height) / 100;
        // offset bottom part
        root.ref.bottom.translateY = height - bottomRect.height;
    };
    var panel = createView({
        name: "panel",
        read: function read(_ref3) {
            var root = _ref3.root, props = _ref3.props;
            return props.heightCurrent = root.ref.bottom.translateY;
        },
        write: write$3,
        create: create$6,
        ignoreRect: true,
        mixins: {
            apis: [
                "height",
                "heightCurrent",
                "scalable"
            ]
        }
    });
    var createDragHelper = function createDragHelper(items) {
        var itemIds = items.map(function(item) {
            return item.id;
        });
        var prevIndex = undefined;
        return {
            setIndex: function setIndex(index) {
                prevIndex = index;
            },
            getIndex: function getIndex() {
                return prevIndex;
            },
            getItemIndex: function getItemIndex(item) {
                return itemIds.indexOf(item.id);
            }
        };
    };
    var ITEM_TRANSLATE_SPRING = {
        type: "spring",
        stiffness: 0.75,
        damping: 0.45,
        mass: 10
    };
    var ITEM_SCALE_SPRING = "spring";
    var StateMap = {
        DID_START_ITEM_LOAD: "busy",
        DID_UPDATE_ITEM_LOAD_PROGRESS: "loading",
        DID_THROW_ITEM_INVALID: "load-invalid",
        DID_THROW_ITEM_LOAD_ERROR: "load-error",
        DID_LOAD_ITEM: "idle",
        DID_THROW_ITEM_REMOVE_ERROR: "remove-error",
        DID_START_ITEM_REMOVE: "busy",
        DID_START_ITEM_PROCESSING: "busy processing",
        DID_REQUEST_ITEM_PROCESSING: "busy processing",
        DID_UPDATE_ITEM_PROCESS_PROGRESS: "processing",
        DID_COMPLETE_ITEM_PROCESSING: "processing-complete",
        DID_THROW_ITEM_PROCESSING_ERROR: "processing-error",
        DID_THROW_ITEM_PROCESSING_REVERT_ERROR: "processing-revert-error",
        DID_ABORT_ITEM_PROCESSING: "cancelled",
        DID_REVERT_ITEM_PROCESSING: "idle"
    };
    /**
     * Creates the file view
     */ var create$7 = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        // select
        root.ref.handleClick = function(e) {
            return root.dispatch("DID_ACTIVATE_ITEM", {
                id: props.id
            });
        };
        // set id
        root.element.id = "filepond--item-" + props.id;
        root.element.addEventListener("click", root.ref.handleClick);
        // file view
        root.ref.container = root.appendChildView(root.createChildView(fileWrapper, {
            id: props.id
        }));
        // file panel
        root.ref.panel = root.appendChildView(root.createChildView(panel, {
            name: "item-panel"
        }));
        // default start height
        root.ref.panel.height = null;
        // by default not marked for removal
        props.markedForRemoval = false;
        // if not allowed to reorder file items, exit here
        if (!root.query("GET_ALLOW_REORDER")) return;
        // set to idle so shows grab cursor
        root.element.dataset.dragState = "idle";
        var grab = function grab(e) {
            if (!e.isPrimary) return;
            var removedActivateListener = false;
            var origin = {
                x: e.pageX,
                y: e.pageY
            };
            props.dragOrigin = {
                x: root.translateX,
                y: root.translateY
            };
            props.dragCenter = {
                x: e.offsetX,
                y: e.offsetY
            };
            var dragState = createDragHelper(root.query("GET_ACTIVE_ITEMS"));
            root.dispatch("DID_GRAB_ITEM", {
                id: props.id,
                dragState: dragState
            });
            var drag = function drag(e) {
                if (!e.isPrimary) return;
                e.stopPropagation();
                e.preventDefault();
                props.dragOffset = {
                    x: e.pageX - origin.x,
                    y: e.pageY - origin.y
                };
                // if dragged stop listening to clicks, will re-add when done dragging
                var dist = props.dragOffset.x * props.dragOffset.x + props.dragOffset.y * props.dragOffset.y;
                if (dist > 16 && !removedActivateListener) {
                    removedActivateListener = true;
                    root.element.removeEventListener("click", root.ref.handleClick);
                }
                root.dispatch("DID_DRAG_ITEM", {
                    id: props.id,
                    dragState: dragState
                });
            };
            var drop = function drop(e) {
                if (!e.isPrimary) return;
                props.dragOffset = {
                    x: e.pageX - origin.x,
                    y: e.pageY - origin.y
                };
                reset();
            };
            var cancel = function cancel() {
                reset();
            };
            var reset = function reset() {
                document.removeEventListener("pointercancel", cancel);
                document.removeEventListener("pointermove", drag);
                document.removeEventListener("pointerup", drop);
                root.dispatch("DID_DROP_ITEM", {
                    id: props.id,
                    dragState: dragState
                });
                // start listening to clicks again
                if (removedActivateListener) setTimeout(function() {
                    return root.element.addEventListener("click", root.ref.handleClick);
                }, 0);
            };
            document.addEventListener("pointercancel", cancel);
            document.addEventListener("pointermove", drag);
            document.addEventListener("pointerup", drop);
        };
        root.element.addEventListener("pointerdown", grab);
    };
    var route$1 = createRoute({
        DID_UPDATE_PANEL_HEIGHT: function DID_UPDATE_PANEL_HEIGHT(_ref2) {
            var root = _ref2.root, action = _ref2.action;
            root.height = action.height;
        }
    });
    var write$4 = createRoute({
        DID_GRAB_ITEM: function DID_GRAB_ITEM(_ref3) {
            var root = _ref3.root, props = _ref3.props;
            props.dragOrigin = {
                x: root.translateX,
                y: root.translateY
            };
        },
        DID_DRAG_ITEM: function DID_DRAG_ITEM(_ref4) {
            var root = _ref4.root;
            root.element.dataset.dragState = "drag";
        },
        DID_DROP_ITEM: function DID_DROP_ITEM(_ref5) {
            var root = _ref5.root, props = _ref5.props;
            props.dragOffset = null;
            props.dragOrigin = null;
            root.element.dataset.dragState = "drop";
        }
    }, function(_ref6) {
        var root = _ref6.root, actions = _ref6.actions, props = _ref6.props, shouldOptimize = _ref6.shouldOptimize;
        if (root.element.dataset.dragState === "drop") {
            if (root.scaleX <= 1) root.element.dataset.dragState = "idle";
        }
        // select last state change action
        var action = actions.concat().filter(function(action) {
            return /^DID_/.test(action.type);
        }).reverse().find(function(action) {
            return StateMap[action.type];
        });
        // no need to set same state twice
        if (action && action.type !== props.currentState) {
            // set current state
            props.currentState = action.type;
            // set state
            root.element.dataset.filepondItemState = StateMap[props.currentState] || "";
        }
        // route actions
        var aspectRatio = root.query("GET_ITEM_PANEL_ASPECT_RATIO") || root.query("GET_PANEL_ASPECT_RATIO");
        if (!aspectRatio) {
            route$1({
                root: root,
                actions: actions,
                props: props
            });
            if (!root.height && root.ref.container.rect.element.height > 0) root.height = root.ref.container.rect.element.height;
        } else if (!shouldOptimize) root.height = root.rect.element.width * aspectRatio;
        // sync panel height with item height
        if (shouldOptimize) root.ref.panel.height = null;
        root.ref.panel.height = root.height;
    });
    var item = createView({
        create: create$7,
        write: write$4,
        destroy: function destroy(_ref7) {
            var root = _ref7.root, props = _ref7.props;
            root.element.removeEventListener("click", root.ref.handleClick);
            root.dispatch("RELEASE_ITEM", {
                query: props.id
            });
        },
        tag: "li",
        name: "item",
        mixins: {
            apis: [
                "id",
                "interactionMethod",
                "markedForRemoval",
                "spawnDate",
                "dragCenter",
                "dragOrigin",
                "dragOffset"
            ],
            styles: [
                "translateX",
                "translateY",
                "scaleX",
                "scaleY",
                "opacity",
                "height"
            ],
            animations: {
                scaleX: ITEM_SCALE_SPRING,
                scaleY: ITEM_SCALE_SPRING,
                translateX: ITEM_TRANSLATE_SPRING,
                translateY: ITEM_TRANSLATE_SPRING,
                opacity: {
                    type: "tween",
                    duration: 150
                }
            }
        }
    });
    var getItemsPerRow = function(horizontalSpace, itemWidth) {
        // add one pixel leeway, when using percentages for item width total items can be 1.99 per row
        return Math.max(1, Math.floor((horizontalSpace + 1) / itemWidth));
    };
    var getItemIndexByPosition = function getItemIndexByPosition(view, children, positionInView) {
        if (!positionInView) return;
        var horizontalSpace = view.rect.element.width;
        // const children = view.childViews;
        var l = children.length;
        var last = null;
        // -1, don't move items to accomodate (either add to top or bottom)
        if (l === 0 || positionInView.top < children[0].rect.element.top) return -1;
        // let's get the item width
        var item = children[0];
        var itemRect = item.rect.element;
        var itemHorizontalMargin = itemRect.marginLeft + itemRect.marginRight;
        var itemWidth = itemRect.width + itemHorizontalMargin;
        var itemsPerRow = getItemsPerRow(horizontalSpace, itemWidth);
        // stack
        if (itemsPerRow === 1) {
            for(var index = 0; index < l; index++){
                var child = children[index];
                var childMid = child.rect.outer.top + child.rect.element.height * 0.5;
                if (positionInView.top < childMid) return index;
            }
            return l;
        }
        // grid
        var itemVerticalMargin = itemRect.marginTop + itemRect.marginBottom;
        var itemHeight = itemRect.height + itemVerticalMargin;
        for(var _index = 0; _index < l; _index++){
            var indexX = _index % itemsPerRow;
            var indexY = Math.floor(_index / itemsPerRow);
            var offsetX = indexX * itemWidth;
            var offsetY = indexY * itemHeight;
            var itemTop = offsetY - itemRect.marginTop;
            var itemRight = offsetX + itemWidth;
            var itemBottom = offsetY + itemHeight + itemRect.marginBottom;
            if (positionInView.top < itemBottom && positionInView.top > itemTop) {
                if (positionInView.left < itemRight) return _index;
                else if (_index !== l - 1) last = _index;
                else last = null;
            }
        }
        if (last !== null) return last;
        return l;
    };
    var dropAreaDimensions = {
        height: 0,
        width: 0,
        get getHeight () {
            return this.height;
        },
        set setHeight (val){
            if (this.height === 0 || val === 0) this.height = val;
        },
        get getWidth () {
            return this.width;
        },
        set setWidth (val){
            if (this.width === 0 || val === 0) this.width = val;
        },
        setDimensions: function setDimensions(height, width) {
            if (this.height === 0 || height === 0) this.height = height;
            if (this.width === 0 || width === 0) this.width = width;
        }
    };
    var create$8 = function create(_ref) {
        var root = _ref.root;
        // need to set role to list as otherwise it won't be read as a list by VoiceOver
        attr(root.element, "role", "list");
        root.ref.lastItemSpanwDate = Date.now();
    };
    /**
     * Inserts a new item
     * @param root
     * @param action
     */ var addItemView = function addItemView(_ref2) {
        var root = _ref2.root, action = _ref2.action;
        var id = action.id, index = action.index, interactionMethod = action.interactionMethod;
        root.ref.addIndex = index;
        var now = Date.now();
        var spawnDate = now;
        var opacity = 1;
        if (interactionMethod !== InteractionMethod.NONE) {
            opacity = 0;
            var cooldown = root.query("GET_ITEM_INSERT_INTERVAL");
            var dist = now - root.ref.lastItemSpanwDate;
            spawnDate = dist < cooldown ? now + (cooldown - dist) : now;
        }
        root.ref.lastItemSpanwDate = spawnDate;
        root.appendChildView(root.createChildView(// view type
        item, // props
        {
            spawnDate: spawnDate,
            id: id,
            opacity: opacity,
            interactionMethod: interactionMethod
        }), index);
    };
    var moveItem = function moveItem(item, x, y) {
        var vx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var vy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
        // set to null to remove animation while dragging
        if (item.dragOffset) {
            item.translateX = null;
            item.translateY = null;
            item.translateX = item.dragOrigin.x + item.dragOffset.x;
            item.translateY = item.dragOrigin.y + item.dragOffset.y;
            item.scaleX = 1.025;
            item.scaleY = 1.025;
        } else {
            item.translateX = x;
            item.translateY = y;
            if (Date.now() > item.spawnDate) {
                // reveal element
                if (item.opacity === 0) introItemView(item, x, y, vx, vy);
                // make sure is default scale every frame
                item.scaleX = 1;
                item.scaleY = 1;
                item.opacity = 1;
            }
        }
    };
    var introItemView = function introItemView(item, x, y, vx, vy) {
        if (item.interactionMethod === InteractionMethod.NONE) {
            item.translateX = null;
            item.translateX = x;
            item.translateY = null;
            item.translateY = y;
        } else if (item.interactionMethod === InteractionMethod.DROP) {
            item.translateX = null;
            item.translateX = x - vx * 20;
            item.translateY = null;
            item.translateY = y - vy * 10;
            item.scaleX = 0.8;
            item.scaleY = 0.8;
        } else if (item.interactionMethod === InteractionMethod.BROWSE) {
            item.translateY = null;
            item.translateY = y - 30;
        } else if (item.interactionMethod === InteractionMethod.API) {
            item.translateX = null;
            item.translateX = x - 30;
            item.translateY = null;
        }
    };
    /**
     * Removes an existing item
     * @param root
     * @param action
     */ var removeItemView = function removeItemView(_ref3) {
        var root = _ref3.root, action = _ref3.action;
        var id = action.id;
        // get the view matching the given id
        var view = root.childViews.find(function(child) {
            return child.id === id;
        });
        // if no view found, exit
        if (!view) return;
        // animate view out of view
        view.scaleX = 0.9;
        view.scaleY = 0.9;
        view.opacity = 0;
        // mark for removal
        view.markedForRemoval = true;
    };
    var getItemHeight = function getItemHeight(child) {
        return child.rect.element.height + child.rect.element.marginBottom * 0.5 + child.rect.element.marginTop * 0.5;
    };
    var getItemWidth = function getItemWidth(child) {
        return child.rect.element.width + child.rect.element.marginLeft * 0.5 + child.rect.element.marginRight * 0.5;
    };
    var dragItem = function dragItem(_ref4) {
        var root = _ref4.root, action = _ref4.action;
        var id = action.id, dragState = action.dragState;
        // reference to item
        var item = root.query("GET_ITEM", {
            id: id
        });
        // get the view matching the given id
        var view = root.childViews.find(function(child) {
            return child.id === id;
        });
        var numItems = root.childViews.length;
        var oldIndex = dragState.getItemIndex(item);
        // if no view found, exit
        if (!view) return;
        var dragPosition = {
            x: view.dragOrigin.x + view.dragOffset.x + view.dragCenter.x,
            y: view.dragOrigin.y + view.dragOffset.y + view.dragCenter.y
        };
        // get drag area dimensions
        var dragHeight = getItemHeight(view);
        var dragWidth = getItemWidth(view);
        // get rows and columns (There will always be at least one row and one column if a file is present)
        var cols = Math.floor(root.rect.outer.width / dragWidth);
        if (cols > numItems) cols = numItems;
        // rows are used to find when we have left the preview area bounding box
        var rows = Math.floor(numItems / cols + 1);
        dropAreaDimensions.setHeight = dragHeight * rows;
        dropAreaDimensions.setWidth = dragWidth * cols;
        // get new index of dragged item
        var location1 = {
            y: Math.floor(dragPosition.y / dragHeight),
            x: Math.floor(dragPosition.x / dragWidth),
            getGridIndex: function getGridIndex() {
                if (dragPosition.y > dropAreaDimensions.getHeight || dragPosition.y < 0 || dragPosition.x > dropAreaDimensions.getWidth || dragPosition.x < 0) return oldIndex;
                return this.y * cols + this.x;
            },
            getColIndex: function getColIndex() {
                var items = root.query("GET_ACTIVE_ITEMS");
                var visibleChildren = root.childViews.filter(function(child) {
                    return child.rect.element.height;
                });
                var children = items.map(function(item) {
                    return visibleChildren.find(function(childView) {
                        return childView.id === item.id;
                    });
                });
                var currentIndex = children.findIndex(function(child) {
                    return child === view;
                });
                var dragHeight = getItemHeight(view);
                var l = children.length;
                var idx = l;
                var childHeight = 0;
                var childBottom = 0;
                var childTop = 0;
                for(var i = 0; i < l; i++){
                    childHeight = getItemHeight(children[i]);
                    childTop = childBottom;
                    childBottom = childTop + childHeight;
                    if (dragPosition.y < childBottom) {
                        if (currentIndex > i) {
                            if (dragPosition.y < childTop + dragHeight) {
                                idx = i;
                                break;
                            }
                            continue;
                        }
                        idx = i;
                        break;
                    }
                }
                return idx;
            }
        };
        // get new index
        var index = cols > 1 ? location1.getGridIndex() : location1.getColIndex();
        root.dispatch("MOVE_ITEM", {
            query: view,
            index: index
        });
        // if the index of the item changed, dispatch reorder action
        var currentIndex = dragState.getIndex();
        if (currentIndex === undefined || currentIndex !== index) {
            dragState.setIndex(index);
            if (currentIndex === undefined) return;
            root.dispatch("DID_REORDER_ITEMS", {
                items: root.query("GET_ACTIVE_ITEMS"),
                origin: oldIndex,
                target: index
            });
        }
    };
    /**
     * Setup action routes
     */ var route$2 = createRoute({
        DID_ADD_ITEM: addItemView,
        DID_REMOVE_ITEM: removeItemView,
        DID_DRAG_ITEM: dragItem
    });
    /**
     * Write to view
     * @param root
     * @param actions
     * @param props
     */ var write$5 = function write(_ref5) {
        var root = _ref5.root, props = _ref5.props, actions = _ref5.actions, shouldOptimize = _ref5.shouldOptimize;
        // route actions
        route$2({
            root: root,
            props: props,
            actions: actions
        });
        var dragCoordinates = props.dragCoordinates;
        // available space on horizontal axis
        var horizontalSpace = root.rect.element.width;
        // only draw children that have dimensions
        var visibleChildren = root.childViews.filter(function(child) {
            return child.rect.element.height;
        });
        // sort based on current active items
        var children = root.query("GET_ACTIVE_ITEMS").map(function(item) {
            return visibleChildren.find(function(child) {
                return child.id === item.id;
            });
        }).filter(function(item) {
            return item;
        });
        // get index
        var dragIndex = dragCoordinates ? getItemIndexByPosition(root, children, dragCoordinates) : null;
        // add index is used to reserve the dropped/added item index till the actual item is rendered
        var addIndex = root.ref.addIndex || null;
        // add index no longer needed till possibly next draw
        root.ref.addIndex = null;
        var dragIndexOffset = 0;
        var removeIndexOffset = 0;
        var addIndexOffset = 0;
        if (children.length === 0) return;
        var childRect = children[0].rect.element;
        var itemVerticalMargin = childRect.marginTop + childRect.marginBottom;
        var itemHorizontalMargin = childRect.marginLeft + childRect.marginRight;
        var itemWidth = childRect.width + itemHorizontalMargin;
        var itemHeight = childRect.height + itemVerticalMargin;
        var itemsPerRow = getItemsPerRow(horizontalSpace, itemWidth);
        // stack
        if (itemsPerRow === 1) {
            var offsetY = 0;
            var dragOffset = 0;
            children.forEach(function(child, index) {
                if (dragIndex) {
                    var dist = index - dragIndex;
                    if (dist === -2) dragOffset = -itemVerticalMargin * 0.25;
                    else if (dist === -1) dragOffset = -itemVerticalMargin * 0.75;
                    else if (dist === 0) dragOffset = itemVerticalMargin * 0.75;
                    else if (dist === 1) dragOffset = itemVerticalMargin * 0.25;
                    else dragOffset = 0;
                }
                if (shouldOptimize) {
                    child.translateX = null;
                    child.translateY = null;
                }
                if (!child.markedForRemoval) moveItem(child, 0, offsetY + dragOffset);
                var itemHeight = child.rect.element.height + itemVerticalMargin;
                var visualHeight = itemHeight * (child.markedForRemoval ? child.opacity : 1);
                offsetY += visualHeight;
            });
        } else {
            var prevX = 0;
            var prevY = 0;
            children.forEach(function(child, index) {
                if (index === dragIndex) dragIndexOffset = 1;
                if (index === addIndex) addIndexOffset += 1;
                if (child.markedForRemoval && child.opacity < 0.5) removeIndexOffset -= 1;
                var visualIndex = index + addIndexOffset + dragIndexOffset + removeIndexOffset;
                var indexX = visualIndex % itemsPerRow;
                var indexY = Math.floor(visualIndex / itemsPerRow);
                var offsetX = indexX * itemWidth;
                var offsetY = indexY * itemHeight;
                var vectorX = Math.sign(offsetX - prevX);
                var vectorY = Math.sign(offsetY - prevY);
                prevX = offsetX;
                prevY = offsetY;
                if (child.markedForRemoval) return;
                if (shouldOptimize) {
                    child.translateX = null;
                    child.translateY = null;
                }
                moveItem(child, offsetX, offsetY, vectorX, vectorY);
            });
        }
    };
    /**
     * Filters actions that are meant specifically for a certain child of the list
     * @param child
     * @param actions
     */ var filterSetItemActions = function filterSetItemActions(child, actions) {
        return actions.filter(function(action) {
            // if action has an id, filter out actions that don't have this child id
            if (action.data && action.data.id) return child.id === action.data.id;
            // allow all other actions
            return true;
        });
    };
    var list = createView({
        create: create$8,
        write: write$5,
        tag: "ul",
        name: "list",
        didWriteView: function didWriteView(_ref6) {
            var root = _ref6.root;
            root.childViews.filter(function(view) {
                return view.markedForRemoval && view.opacity === 0 && view.resting;
            }).forEach(function(view) {
                view._destroy();
                root.removeChildView(view);
            });
        },
        filterFrameActionsForChild: filterSetItemActions,
        mixins: {
            apis: [
                "dragCoordinates"
            ]
        }
    });
    var create$9 = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        root.ref.list = root.appendChildView(root.createChildView(list));
        props.dragCoordinates = null;
        props.overflowing = false;
    };
    var storeDragCoordinates = function storeDragCoordinates(_ref2) {
        var root = _ref2.root, props = _ref2.props, action = _ref2.action;
        if (!root.query("GET_ITEM_INSERT_LOCATION_FREEDOM")) return;
        props.dragCoordinates = {
            left: action.position.scopeLeft - root.ref.list.rect.element.left,
            top: action.position.scopeTop - (root.rect.outer.top + root.rect.element.marginTop + root.rect.element.scrollTop)
        };
    };
    var clearDragCoordinates = function clearDragCoordinates(_ref3) {
        var props = _ref3.props;
        props.dragCoordinates = null;
    };
    var route$3 = createRoute({
        DID_DRAG: storeDragCoordinates,
        DID_END_DRAG: clearDragCoordinates
    });
    var write$6 = function write(_ref4) {
        var root = _ref4.root, props = _ref4.props, actions = _ref4.actions;
        // route actions
        route$3({
            root: root,
            props: props,
            actions: actions
        });
        // current drag position
        root.ref.list.dragCoordinates = props.dragCoordinates;
        // if currently overflowing but no longer received overflow
        if (props.overflowing && !props.overflow) {
            props.overflowing = false;
            // reset overflow state
            root.element.dataset.state = "";
            root.height = null;
        }
        // if is not overflowing currently but does receive overflow value
        if (props.overflow) {
            var newHeight = Math.round(props.overflow);
            if (newHeight !== root.height) {
                props.overflowing = true;
                root.element.dataset.state = "overflow";
                root.height = newHeight;
            }
        }
    };
    var listScroller = createView({
        create: create$9,
        write: write$6,
        name: "list-scroller",
        mixins: {
            apis: [
                "overflow",
                "dragCoordinates"
            ],
            styles: [
                "height",
                "translateY"
            ],
            animations: {
                translateY: "spring"
            }
        }
    });
    var attrToggle = function attrToggle(element, name, state) {
        var enabledValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
        if (state) attr(element, name, enabledValue);
        else element.removeAttribute(name);
    };
    var resetFileInput = function resetFileInput(input) {
        // no value, no need to reset
        if (!input || input.value === "") return;
        try {
            // for modern browsers
            input.value = "";
        } catch (err) {}
        // for IE10
        if (input.value) {
            // quickly append input to temp form and reset form
            var form = createElement$1("form");
            var parentNode = input.parentNode;
            var ref = input.nextSibling;
            form.appendChild(input);
            form.reset();
            // re-inject input where it originally was
            if (ref) parentNode.insertBefore(input, ref);
            else parentNode.appendChild(input);
        }
    };
    var create$a = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        // set id so can be referenced from outside labels
        root.element.id = "filepond--browser-" + props.id;
        // set name of element (is removed when a value is set)
        attr(root.element, "name", root.query("GET_NAME"));
        // we have to link this element to the status element
        attr(root.element, "aria-controls", "filepond--assistant-" + props.id);
        // set label, we use labelled by as otherwise the screenreader does not read the "browse" text in the label (as it has tabindex: 0)
        attr(root.element, "aria-labelledby", "filepond--drop-label-" + props.id);
        // set configurable props
        setAcceptedFileTypes({
            root: root,
            action: {
                value: root.query("GET_ACCEPTED_FILE_TYPES")
            }
        });
        toggleAllowMultiple({
            root: root,
            action: {
                value: root.query("GET_ALLOW_MULTIPLE")
            }
        });
        toggleDirectoryFilter({
            root: root,
            action: {
                value: root.query("GET_ALLOW_DIRECTORIES_ONLY")
            }
        });
        toggleDisabled({
            root: root
        });
        toggleRequired({
            root: root,
            action: {
                value: root.query("GET_REQUIRED")
            }
        });
        setCaptureMethod({
            root: root,
            action: {
                value: root.query("GET_CAPTURE_METHOD")
            }
        });
        // handle changes to the input field
        root.ref.handleChange = function(e) {
            if (!root.element.value) return;
            // extract files and move value of webkitRelativePath path to _relativePath
            var files = Array.from(root.element.files).map(function(file) {
                file._relativePath = file.webkitRelativePath;
                return file;
            });
            // we add a little delay so the OS file select window can move out of the way before we add our file
            setTimeout(function() {
                // load files
                props.onload(files);
                // reset input, it's just for exposing a method to drop files, should not retain any state
                resetFileInput(root.element);
            }, 250);
        };
        root.element.addEventListener("change", root.ref.handleChange);
    };
    var setAcceptedFileTypes = function setAcceptedFileTypes(_ref2) {
        var root = _ref2.root, action = _ref2.action;
        if (!root.query("GET_ALLOW_SYNC_ACCEPT_ATTRIBUTE")) return;
        attrToggle(root.element, "accept", !!action.value, action.value ? action.value.join(",") : "");
    };
    var toggleAllowMultiple = function toggleAllowMultiple(_ref3) {
        var root = _ref3.root, action = _ref3.action;
        attrToggle(root.element, "multiple", action.value);
    };
    var toggleDirectoryFilter = function toggleDirectoryFilter(_ref4) {
        var root = _ref4.root, action = _ref4.action;
        attrToggle(root.element, "webkitdirectory", action.value);
    };
    var toggleDisabled = function toggleDisabled(_ref5) {
        var root = _ref5.root;
        var isDisabled = root.query("GET_DISABLED");
        var doesAllowBrowse = root.query("GET_ALLOW_BROWSE");
        var disableField = isDisabled || !doesAllowBrowse;
        attrToggle(root.element, "disabled", disableField);
    };
    var toggleRequired = function toggleRequired(_ref6) {
        var root = _ref6.root, action = _ref6.action;
        // want to remove required, always possible
        if (!action.value) attrToggle(root.element, "required", false);
        else if (root.query("GET_TOTAL_ITEMS") === 0) attrToggle(root.element, "required", true);
    };
    var setCaptureMethod = function setCaptureMethod(_ref7) {
        var root = _ref7.root, action = _ref7.action;
        attrToggle(root.element, "capture", !!action.value, action.value === true ? "" : action.value);
    };
    var updateRequiredStatus = function updateRequiredStatus(_ref8) {
        var root = _ref8.root;
        var element = root.element;
        // always remove the required attribute when more than zero items
        if (root.query("GET_TOTAL_ITEMS") > 0) {
            attrToggle(element, "required", false);
            attrToggle(element, "name", false);
        } else {
            // add name attribute
            attrToggle(element, "name", true, root.query("GET_NAME"));
            // remove any validation messages
            var shouldCheckValidity = root.query("GET_CHECK_VALIDITY");
            if (shouldCheckValidity) element.setCustomValidity("");
            // we only add required if the field has been deemed required
            if (root.query("GET_REQUIRED")) attrToggle(element, "required", true);
        }
    };
    var updateFieldValidityStatus = function updateFieldValidityStatus(_ref9) {
        var root = _ref9.root;
        var shouldCheckValidity = root.query("GET_CHECK_VALIDITY");
        if (!shouldCheckValidity) return;
        root.element.setCustomValidity(root.query("GET_LABEL_INVALID_FIELD"));
    };
    var browser = createView({
        tag: "input",
        name: "browser",
        ignoreRect: true,
        ignoreRectUpdate: true,
        attributes: {
            type: "file"
        },
        create: create$a,
        destroy: function destroy(_ref10) {
            var root = _ref10.root;
            root.element.removeEventListener("change", root.ref.handleChange);
        },
        write: createRoute({
            DID_LOAD_ITEM: updateRequiredStatus,
            DID_REMOVE_ITEM: updateRequiredStatus,
            DID_THROW_ITEM_INVALID: updateFieldValidityStatus,
            DID_SET_DISABLED: toggleDisabled,
            DID_SET_ALLOW_BROWSE: toggleDisabled,
            DID_SET_ALLOW_DIRECTORIES_ONLY: toggleDirectoryFilter,
            DID_SET_ALLOW_MULTIPLE: toggleAllowMultiple,
            DID_SET_ACCEPTED_FILE_TYPES: setAcceptedFileTypes,
            DID_SET_CAPTURE_METHOD: setCaptureMethod,
            DID_SET_REQUIRED: toggleRequired
        })
    });
    var Key = {
        ENTER: 13,
        SPACE: 32
    };
    var create$b = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        // create the label and link it to the file browser
        var label = createElement$1("label");
        attr(label, "for", "filepond--browser-" + props.id);
        // use for labeling file input (aria-labelledby on file input)
        attr(label, "id", "filepond--drop-label-" + props.id);
        // handle keys
        root.ref.handleKeyDown = function(e) {
            var isActivationKey = e.keyCode === Key.ENTER || e.keyCode === Key.SPACE;
            if (!isActivationKey) return;
            // stops from triggering the element a second time
            e.preventDefault();
            // click link (will then in turn activate file input)
            root.ref.label.click();
        };
        root.ref.handleClick = function(e) {
            var isLabelClick = e.target === label || label.contains(e.target);
            // don't want to click twice
            if (isLabelClick) return;
            // click link (will then in turn activate file input)
            root.ref.label.click();
        };
        // attach events
        label.addEventListener("keydown", root.ref.handleKeyDown);
        root.element.addEventListener("click", root.ref.handleClick);
        // update
        updateLabelValue(label, props.caption);
        // add!
        root.appendChild(label);
        root.ref.label = label;
    };
    var updateLabelValue = function updateLabelValue(label, value) {
        label.innerHTML = value;
        var clickable = label.querySelector(".filepond--label-action");
        if (clickable) attr(clickable, "tabindex", "0");
        return value;
    };
    var dropLabel = createView({
        name: "drop-label",
        ignoreRect: true,
        create: create$b,
        destroy: function destroy(_ref2) {
            var root = _ref2.root;
            root.ref.label.addEventListener("keydown", root.ref.handleKeyDown);
            root.element.removeEventListener("click", root.ref.handleClick);
        },
        write: createRoute({
            DID_SET_LABEL_IDLE: function DID_SET_LABEL_IDLE(_ref3) {
                var root = _ref3.root, action = _ref3.action;
                updateLabelValue(root.ref.label, action.value);
            }
        }),
        mixins: {
            styles: [
                "opacity",
                "translateX",
                "translateY"
            ],
            animations: {
                opacity: {
                    type: "tween",
                    duration: 150
                },
                translateX: "spring",
                translateY: "spring"
            }
        }
    });
    var blob = createView({
        name: "drip-blob",
        ignoreRect: true,
        mixins: {
            styles: [
                "translateX",
                "translateY",
                "scaleX",
                "scaleY",
                "opacity"
            ],
            animations: {
                scaleX: "spring",
                scaleY: "spring",
                translateX: "spring",
                translateY: "spring",
                opacity: {
                    type: "tween",
                    duration: 250
                }
            }
        }
    });
    var addBlob = function addBlob(_ref) {
        var root = _ref.root;
        var centerX = root.rect.element.width * 0.5;
        var centerY = root.rect.element.height * 0.5;
        root.ref.blob = root.appendChildView(root.createChildView(blob, {
            opacity: 0,
            scaleX: 2.5,
            scaleY: 2.5,
            translateX: centerX,
            translateY: centerY
        }));
    };
    var moveBlob = function moveBlob(_ref2) {
        var root = _ref2.root, action = _ref2.action;
        if (!root.ref.blob) {
            addBlob({
                root: root
            });
            return;
        }
        root.ref.blob.translateX = action.position.scopeLeft;
        root.ref.blob.translateY = action.position.scopeTop;
        root.ref.blob.scaleX = 1;
        root.ref.blob.scaleY = 1;
        root.ref.blob.opacity = 1;
    };
    var hideBlob = function hideBlob(_ref3) {
        var root = _ref3.root;
        if (!root.ref.blob) return;
        root.ref.blob.opacity = 0;
    };
    var explodeBlob = function explodeBlob(_ref4) {
        var root = _ref4.root;
        if (!root.ref.blob) return;
        root.ref.blob.scaleX = 2.5;
        root.ref.blob.scaleY = 2.5;
        root.ref.blob.opacity = 0;
    };
    var write$7 = function write(_ref5) {
        var root = _ref5.root, props = _ref5.props, actions = _ref5.actions;
        route$4({
            root: root,
            props: props,
            actions: actions
        });
        var blob = root.ref.blob;
        if (actions.length === 0 && blob && blob.opacity === 0) {
            root.removeChildView(blob);
            root.ref.blob = null;
        }
    };
    var route$4 = createRoute({
        DID_DRAG: moveBlob,
        DID_DROP: explodeBlob,
        DID_END_DRAG: hideBlob
    });
    var drip = createView({
        ignoreRect: true,
        ignoreRectUpdate: true,
        name: "drip",
        write: write$7
    });
    var setInputFiles = function setInputFiles(element, files) {
        try {
            // Create a DataTransfer instance and add a newly created file
            var dataTransfer = new DataTransfer();
            files.forEach(function(file) {
                if (file instanceof File) dataTransfer.items.add(file);
                else dataTransfer.items.add(new File([
                    file
                ], file.name, {
                    type: file.type
                }));
            });
            // Assign the DataTransfer files list to the file input
            element.files = dataTransfer.files;
        } catch (err) {
            return false;
        }
        return true;
    };
    var create$c = function create(_ref) {
        var root = _ref.root;
        return root.ref.fields = {};
    };
    var getField = function getField(root, id) {
        return root.ref.fields[id];
    };
    var syncFieldPositionsWithItems = function syncFieldPositionsWithItems(root) {
        root.query("GET_ACTIVE_ITEMS").forEach(function(item) {
            if (!root.ref.fields[item.id]) return;
            root.element.appendChild(root.ref.fields[item.id]);
        });
    };
    var didReorderItems = function didReorderItems(_ref2) {
        var root = _ref2.root;
        return syncFieldPositionsWithItems(root);
    };
    var didAddItem = function didAddItem(_ref3) {
        var root = _ref3.root, action = _ref3.action;
        var fileItem = root.query("GET_ITEM", action.id);
        var isLocalFile = fileItem.origin === FileOrigin.LOCAL;
        var shouldUseFileInput = !isLocalFile && root.query("SHOULD_UPDATE_FILE_INPUT");
        var dataContainer = createElement$1("input");
        dataContainer.type = shouldUseFileInput ? "file" : "hidden";
        dataContainer.name = root.query("GET_NAME");
        root.ref.fields[action.id] = dataContainer;
        syncFieldPositionsWithItems(root);
    };
    var didLoadItem$1 = function didLoadItem(_ref4) {
        var root = _ref4.root, action = _ref4.action;
        var field = getField(root, action.id);
        if (!field) return;
        // store server ref in hidden input
        if (action.serverFileReference !== null) field.value = action.serverFileReference;
        // store file item in file input
        if (!root.query("SHOULD_UPDATE_FILE_INPUT")) return;
        var fileItem = root.query("GET_ITEM", action.id);
        setInputFiles(field, [
            fileItem.file
        ]);
    };
    var didPrepareOutput = function didPrepareOutput(_ref5) {
        var root = _ref5.root, action = _ref5.action;
        // this timeout pushes the handler after 'load'
        if (!root.query("SHOULD_UPDATE_FILE_INPUT")) return;
        setTimeout(function() {
            var field = getField(root, action.id);
            if (!field) return;
            setInputFiles(field, [
                action.file
            ]);
        }, 0);
    };
    var didSetDisabled = function didSetDisabled(_ref6) {
        var root = _ref6.root;
        root.element.disabled = root.query("GET_DISABLED");
    };
    var didRemoveItem = function didRemoveItem(_ref7) {
        var root = _ref7.root, action = _ref7.action;
        var field = getField(root, action.id);
        if (!field) return;
        if (field.parentNode) field.parentNode.removeChild(field);
        delete root.ref.fields[action.id];
    };
    // only runs for server files. will refuse to update the value if the field
    // is a file field
    var didDefineValue = function didDefineValue(_ref8) {
        var root = _ref8.root, action = _ref8.action;
        var field = getField(root, action.id);
        if (!field) return;
        if (action.value === null) // clear field value
        field.removeAttribute("value");
        else // set field value
        if (field.type != "file") field.value = action.value;
        syncFieldPositionsWithItems(root);
    };
    var write$8 = createRoute({
        DID_SET_DISABLED: didSetDisabled,
        DID_ADD_ITEM: didAddItem,
        DID_LOAD_ITEM: didLoadItem$1,
        DID_REMOVE_ITEM: didRemoveItem,
        DID_DEFINE_VALUE: didDefineValue,
        DID_PREPARE_OUTPUT: didPrepareOutput,
        DID_REORDER_ITEMS: didReorderItems,
        DID_SORT_ITEMS: didReorderItems
    });
    var data = createView({
        tag: "fieldset",
        name: "data",
        create: create$c,
        write: write$8,
        ignoreRect: true
    });
    var getRootNode = function getRootNode(element) {
        return "getRootNode" in element ? element.getRootNode() : document;
    };
    var images = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "webp",
        "svg",
        "tiff"
    ];
    var text$1 = [
        "css",
        "csv",
        "html",
        "txt"
    ];
    var map = {
        zip: "zip|compressed",
        epub: "application/epub+zip"
    };
    var guesstimateMimeType = function guesstimateMimeType() {
        var extension = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        extension = extension.toLowerCase();
        if (images.includes(extension)) return "image/" + (extension === "jpg" ? "jpeg" : extension === "svg" ? "svg+xml" : extension);
        if (text$1.includes(extension)) return "text/" + extension;
        return map[extension] || "";
    };
    var requestDataTransferItems = function requestDataTransferItems(dataTransfer) {
        return new Promise(function(resolve, reject) {
            // try to get links from transfer, if found we'll exit immediately (unless a file is in the dataTransfer as well, this is because Firefox could represent the file as a URL and a file object at the same time)
            var links = getLinks(dataTransfer);
            if (links.length && !hasFiles(dataTransfer)) return resolve(links);
            // try to get files from the transfer
            getFiles(dataTransfer).then(resolve);
        });
    };
    /**
     * Test if datatransfer has files
     */ var hasFiles = function hasFiles(dataTransfer) {
        if (dataTransfer.files) return dataTransfer.files.length > 0;
        return false;
    };
    /**
     * Extracts files from a DataTransfer object
     */ var getFiles = function getFiles(dataTransfer) {
        return new Promise(function(resolve, reject) {
            // get the transfer items as promises
            var promisedFiles = (dataTransfer.items ? Array.from(dataTransfer.items) : [])// only keep file system items (files and directories)
            .filter(function(item) {
                return isFileSystemItem(item);
            })// map each item to promise
            .map(function(item) {
                return getFilesFromItem(item);
            });
            // if is empty, see if we can extract some info from the files property as a fallback
            if (!promisedFiles.length) {
                // TODO: test for directories (should not be allowed)
                // Use FileReader, problem is that the files property gets lost in the process
                resolve(dataTransfer.files ? Array.from(dataTransfer.files) : []);
                return;
            }
            // done!
            Promise.all(promisedFiles).then(function(returnedFileGroups) {
                // flatten groups
                var files = [];
                returnedFileGroups.forEach(function(group) {
                    files.push.apply(files, group);
                });
                // done (filter out empty files)!
                resolve(files.filter(function(file) {
                    return file;
                }).map(function(file) {
                    if (!file._relativePath) file._relativePath = file.webkitRelativePath;
                    return file;
                }));
            }).catch(console.error);
        });
    };
    var isFileSystemItem = function isFileSystemItem(item) {
        if (isEntry(item)) {
            var entry = getAsEntry(item);
            if (entry) return entry.isFile || entry.isDirectory;
        }
        return item.kind === "file";
    };
    var getFilesFromItem = function getFilesFromItem(item) {
        return new Promise(function(resolve, reject) {
            if (isDirectoryEntry(item)) {
                getFilesInDirectory(getAsEntry(item)).then(resolve).catch(reject);
                return;
            }
            resolve([
                item.getAsFile()
            ]);
        });
    };
    var getFilesInDirectory = function getFilesInDirectory(entry) {
        return new Promise(function(resolve, reject) {
            var files = [];
            // the total entries to read
            var dirCounter = 0;
            var fileCounter = 0;
            var resolveIfDone = function resolveIfDone() {
                if (fileCounter === 0 && dirCounter === 0) resolve(files);
            };
            // the recursive function
            var readEntries = function readEntries(dirEntry) {
                dirCounter++;
                var directoryReader = dirEntry.createReader();
                // directories are returned in batches, we need to process all batches before we're done
                var readBatch = function readBatch() {
                    directoryReader.readEntries(function(entries) {
                        if (entries.length === 0) {
                            dirCounter--;
                            resolveIfDone();
                            return;
                        }
                        entries.forEach(function(entry) {
                            // recursively read more directories
                            if (entry.isDirectory) readEntries(entry);
                            else {
                                // read as file
                                fileCounter++;
                                entry.file(function(file) {
                                    var correctedFile = correctMissingFileType(file);
                                    if (entry.fullPath) correctedFile._relativePath = entry.fullPath;
                                    files.push(correctedFile);
                                    fileCounter--;
                                    resolveIfDone();
                                });
                            }
                        });
                        // try to get next batch of files
                        readBatch();
                    }, reject);
                };
                // read first batch of files
                readBatch();
            };
            // go!
            readEntries(entry);
        });
    };
    var correctMissingFileType = function correctMissingFileType(file) {
        if (file.type.length) return file;
        var date = file.lastModifiedDate;
        var name = file.name;
        var type = guesstimateMimeType(getExtensionFromFilename(file.name));
        if (!type.length) return file;
        file = file.slice(0, file.size, type);
        file.name = name;
        file.lastModifiedDate = date;
        return file;
    };
    var isDirectoryEntry = function isDirectoryEntry(item) {
        return isEntry(item) && (getAsEntry(item) || {}).isDirectory;
    };
    var isEntry = function isEntry(item) {
        return "webkitGetAsEntry" in item;
    };
    var getAsEntry = function getAsEntry(item) {
        return item.webkitGetAsEntry();
    };
    /**
     * Extracts links from a DataTransfer object
     */ var getLinks = function getLinks(dataTransfer) {
        var links = [];
        try {
            // look in meta data property
            links = getLinksFromTransferMetaData(dataTransfer);
            if (links.length) return links;
            links = getLinksFromTransferURLData(dataTransfer);
        } catch (e) {
        // nope nope nope (probably IE trouble)
        }
        return links;
    };
    var getLinksFromTransferURLData = function getLinksFromTransferURLData(dataTransfer) {
        var data = dataTransfer.getData("url");
        if (typeof data === "string" && data.length) return [
            data
        ];
        return [];
    };
    var getLinksFromTransferMetaData = function getLinksFromTransferMetaData(dataTransfer) {
        var data = dataTransfer.getData("text/html");
        if (typeof data === "string" && data.length) {
            var matches = data.match(/src\s*=\s*"(.+?)"/);
            if (matches) return [
                matches[1]
            ];
        }
        return [];
    };
    var dragNDropObservers = [];
    var eventPosition = function eventPosition(e) {
        return {
            pageLeft: e.pageX,
            pageTop: e.pageY,
            scopeLeft: e.offsetX || e.layerX,
            scopeTop: e.offsetY || e.layerY
        };
    };
    var createDragNDropClient = function createDragNDropClient(element, scopeToObserve, filterElement) {
        var observer = getDragNDropObserver(scopeToObserve);
        var client = {
            element: element,
            filterElement: filterElement,
            state: null,
            ondrop: function ondrop() {},
            onenter: function onenter() {},
            ondrag: function ondrag() {},
            onexit: function onexit() {},
            onload: function onload() {},
            allowdrop: function allowdrop() {}
        };
        client.destroy = observer.addListener(client);
        return client;
    };
    var getDragNDropObserver = function getDragNDropObserver(element) {
        // see if already exists, if so, return
        var observer = dragNDropObservers.find(function(item) {
            return item.element === element;
        });
        if (observer) return observer;
        // create new observer, does not yet exist for this element
        var newObserver = createDragNDropObserver(element);
        dragNDropObservers.push(newObserver);
        return newObserver;
    };
    var createDragNDropObserver = function createDragNDropObserver(element) {
        var clients = [];
        var routes = {
            dragenter: dragenter,
            dragover: dragover,
            dragleave: dragleave,
            drop: drop
        };
        var handlers = {};
        forin(routes, function(event, createHandler) {
            handlers[event] = createHandler(element, clients);
            element.addEventListener(event, handlers[event], false);
        });
        var observer = {
            element: element,
            addListener: function addListener(client) {
                // add as client
                clients.push(client);
                // return removeListener function
                return function() {
                    // remove client
                    clients.splice(clients.indexOf(client), 1);
                    // if no more clients, clean up observer
                    if (clients.length === 0) {
                        dragNDropObservers.splice(dragNDropObservers.indexOf(observer), 1);
                        forin(routes, function(event) {
                            element.removeEventListener(event, handlers[event], false);
                        });
                    }
                };
            }
        };
        return observer;
    };
    var elementFromPoint = function elementFromPoint(root, point) {
        if (!("elementFromPoint" in root)) root = document;
        return root.elementFromPoint(point.x, point.y);
    };
    var isEventTarget = function isEventTarget(e, target) {
        // get root
        var root = getRootNode(target);
        // get element at position
        // if root is not actual shadow DOM and does not have elementFromPoint method, use the one on document
        var elementAtPosition = elementFromPoint(root, {
            x: e.pageX - window.pageXOffset,
            y: e.pageY - window.pageYOffset
        });
        // test if target is the element or if one of its children is
        return elementAtPosition === target || target.contains(elementAtPosition);
    };
    var initialTarget = null;
    var setDropEffect = function setDropEffect(dataTransfer, effect) {
        // is in try catch as IE11 will throw error if not
        try {
            dataTransfer.dropEffect = effect;
        } catch (e) {}
    };
    var dragenter = function dragenter(root, clients) {
        return function(e) {
            e.preventDefault();
            initialTarget = e.target;
            clients.forEach(function(client) {
                var element = client.element, onenter = client.onenter;
                if (isEventTarget(e, element)) {
                    client.state = "enter";
                    // fire enter event
                    onenter(eventPosition(e));
                }
            });
        };
    };
    var dragover = function dragover(root, clients) {
        return function(e) {
            e.preventDefault();
            var dataTransfer = e.dataTransfer;
            requestDataTransferItems(dataTransfer).then(function(items) {
                var overDropTarget = false;
                clients.some(function(client) {
                    var filterElement = client.filterElement, element = client.element, onenter = client.onenter, onexit = client.onexit, ondrag = client.ondrag, allowdrop = client.allowdrop;
                    // by default we can drop
                    setDropEffect(dataTransfer, "copy");
                    // allow transfer of these items
                    var allowsTransfer = allowdrop(items);
                    // only used when can be dropped on page
                    if (!allowsTransfer) {
                        setDropEffect(dataTransfer, "none");
                        return;
                    }
                    // targetting this client
                    if (isEventTarget(e, element)) {
                        overDropTarget = true;
                        // had no previous state, means we are entering this client
                        if (client.state === null) {
                            client.state = "enter";
                            onenter(eventPosition(e));
                            return;
                        }
                        // now over element (no matter if it allows the drop or not)
                        client.state = "over";
                        // needs to allow transfer
                        if (filterElement && !allowsTransfer) {
                            setDropEffect(dataTransfer, "none");
                            return;
                        }
                        // dragging
                        ondrag(eventPosition(e));
                    } else {
                        // should be over an element to drop
                        if (filterElement && !overDropTarget) setDropEffect(dataTransfer, "none");
                        // might have just left this client?
                        if (client.state) {
                            client.state = null;
                            onexit(eventPosition(e));
                        }
                    }
                });
            });
        };
    };
    var drop = function drop(root, clients) {
        return function(e) {
            e.preventDefault();
            var dataTransfer = e.dataTransfer;
            requestDataTransferItems(dataTransfer).then(function(items) {
                clients.forEach(function(client) {
                    var filterElement = client.filterElement, element = client.element, ondrop = client.ondrop, onexit = client.onexit, allowdrop = client.allowdrop;
                    client.state = null;
                    // if we're filtering on element we need to be over the element to drop
                    if (filterElement && !isEventTarget(e, element)) return;
                    // no transfer for this client
                    if (!allowdrop(items)) return onexit(eventPosition(e));
                    // we can drop these items on this client
                    ondrop(eventPosition(e), items);
                });
            });
        };
    };
    var dragleave = function dragleave(root, clients) {
        return function(e) {
            if (initialTarget !== e.target) return;
            clients.forEach(function(client) {
                var onexit = client.onexit;
                client.state = null;
                onexit(eventPosition(e));
            });
        };
    };
    var createHopper = function createHopper(scope, validateItems, options) {
        // is now hopper scope
        scope.classList.add("filepond--hopper");
        // shortcuts
        var catchesDropsOnPage = options.catchesDropsOnPage, requiresDropOnElement = options.requiresDropOnElement, _options$filterItems = options.filterItems, filterItems = _options$filterItems === void 0 ? function(items) {
            return items;
        } : _options$filterItems;
        // create a dnd client
        var client = createDragNDropClient(scope, catchesDropsOnPage ? document.documentElement : scope, requiresDropOnElement);
        // current client state
        var lastState = "";
        var currentState = "";
        // determines if a file may be dropped
        client.allowdrop = function(items) {
            // TODO: if we can, throw error to indicate the items cannot by dropped
            return validateItems(filterItems(items));
        };
        client.ondrop = function(position, items) {
            var filteredItems = filterItems(items);
            if (!validateItems(filteredItems)) {
                api.ondragend(position);
                return;
            }
            currentState = "drag-drop";
            api.onload(filteredItems, position);
        };
        client.ondrag = function(position) {
            api.ondrag(position);
        };
        client.onenter = function(position) {
            currentState = "drag-over";
            api.ondragstart(position);
        };
        client.onexit = function(position) {
            currentState = "drag-exit";
            api.ondragend(position);
        };
        var api = {
            updateHopperState: function updateHopperState() {
                if (lastState !== currentState) {
                    scope.dataset.hopperState = currentState;
                    lastState = currentState;
                }
            },
            onload: function onload() {},
            ondragstart: function ondragstart() {},
            ondrag: function ondrag() {},
            ondragend: function ondragend() {},
            destroy: function destroy() {
                // destroy client
                client.destroy();
            }
        };
        return api;
    };
    var listening = false;
    var listeners$1 = [];
    var handlePaste = function handlePaste(e) {
        // if is pasting in input or textarea and the target is outside of a filepond scope, ignore
        var activeEl = document.activeElement;
        var isActiveElementEditable = activeEl && (/textarea|input/i.test(activeEl.nodeName) || activeEl.getAttribute("contenteditable") === "true");
        if (isActiveElementEditable) {
            // test textarea or input is contained in filepond root
            var inScope = false;
            var element = activeEl;
            while(element !== document.body){
                if (element.classList.contains("filepond--root")) {
                    inScope = true;
                    break;
                }
                element = element.parentNode;
            }
            if (!inScope) return;
        }
        requestDataTransferItems(e.clipboardData).then(function(files) {
            // no files received
            if (!files.length) return;
            // notify listeners of received files
            listeners$1.forEach(function(listener) {
                return listener(files);
            });
        });
    };
    var listen = function listen(cb) {
        // can't add twice
        if (listeners$1.includes(cb)) return;
        // add initial listener
        listeners$1.push(cb);
        // setup paste listener for entire page
        if (listening) return;
        listening = true;
        document.addEventListener("paste", handlePaste);
    };
    var unlisten = function unlisten(listener) {
        arrayRemove(listeners$1, listeners$1.indexOf(listener));
        // clean up
        if (listeners$1.length === 0) {
            document.removeEventListener("paste", handlePaste);
            listening = false;
        }
    };
    var createPaster = function createPaster() {
        var cb = function cb(files) {
            api.onload(files);
        };
        var api = {
            destroy: function destroy() {
                unlisten(cb);
            },
            onload: function onload() {}
        };
        listen(cb);
        return api;
    };
    /**
     * Creates the file view
     */ var create$d = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        root.element.id = "filepond--assistant-" + props.id;
        attr(root.element, "role", "status");
        attr(root.element, "aria-live", "polite");
        attr(root.element, "aria-relevant", "additions");
    };
    var addFilesNotificationTimeout = null;
    var notificationClearTimeout = null;
    var filenames = [];
    var assist = function assist(root, message) {
        root.element.textContent = message;
    };
    var clear$1 = function clear(root) {
        root.element.textContent = "";
    };
    var listModified = function listModified(root, filename, label) {
        var total = root.query("GET_TOTAL_ITEMS");
        assist(root, label + " " + filename + ", " + total + " " + (total === 1 ? root.query("GET_LABEL_FILE_COUNT_SINGULAR") : root.query("GET_LABEL_FILE_COUNT_PLURAL")));
        // clear group after set amount of time so the status is not read twice
        clearTimeout(notificationClearTimeout);
        notificationClearTimeout = setTimeout(function() {
            clear$1(root);
        }, 1500);
    };
    var isUsingFilePond = function isUsingFilePond(root) {
        return root.element.parentNode.contains(document.activeElement);
    };
    var itemAdded = function itemAdded(_ref2) {
        var root = _ref2.root, action = _ref2.action;
        if (!isUsingFilePond(root)) return;
        root.element.textContent = "";
        var item = root.query("GET_ITEM", action.id);
        filenames.push(item.filename);
        clearTimeout(addFilesNotificationTimeout);
        addFilesNotificationTimeout = setTimeout(function() {
            listModified(root, filenames.join(", "), root.query("GET_LABEL_FILE_ADDED"));
            filenames.length = 0;
        }, 750);
    };
    var itemRemoved = function itemRemoved(_ref3) {
        var root = _ref3.root, action = _ref3.action;
        if (!isUsingFilePond(root)) return;
        var item = action.item;
        listModified(root, item.filename, root.query("GET_LABEL_FILE_REMOVED"));
    };
    var itemProcessed = function itemProcessed(_ref4) {
        var root = _ref4.root, action = _ref4.action;
        // will also notify the user when FilePond is not being used, as the user might be occupied with other activities while uploading a file
        var item = root.query("GET_ITEM", action.id);
        var filename = item.filename;
        var label = root.query("GET_LABEL_FILE_PROCESSING_COMPLETE");
        assist(root, filename + " " + label);
    };
    var itemProcessedUndo = function itemProcessedUndo(_ref5) {
        var root = _ref5.root, action = _ref5.action;
        var item = root.query("GET_ITEM", action.id);
        var filename = item.filename;
        var label = root.query("GET_LABEL_FILE_PROCESSING_ABORTED");
        assist(root, filename + " " + label);
    };
    var itemError = function itemError(_ref6) {
        var root = _ref6.root, action = _ref6.action;
        var item = root.query("GET_ITEM", action.id);
        var filename = item.filename;
        // will also notify the user when FilePond is not being used, as the user might be occupied with other activities while uploading a file
        assist(root, action.status.main + " " + filename + " " + action.status.sub);
    };
    var assistant = createView({
        create: create$d,
        ignoreRect: true,
        ignoreRectUpdate: true,
        write: createRoute({
            DID_LOAD_ITEM: itemAdded,
            DID_REMOVE_ITEM: itemRemoved,
            DID_COMPLETE_ITEM_PROCESSING: itemProcessed,
            DID_ABORT_ITEM_PROCESSING: itemProcessedUndo,
            DID_REVERT_ITEM_PROCESSING: itemProcessedUndo,
            DID_THROW_ITEM_REMOVE_ERROR: itemError,
            DID_THROW_ITEM_LOAD_ERROR: itemError,
            DID_THROW_ITEM_INVALID: itemError,
            DID_THROW_ITEM_PROCESSING_ERROR: itemError
        }),
        tag: "span",
        name: "assistant"
    });
    var toCamels = function toCamels(string) {
        var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
        return string.replace(new RegExp(separator + ".", "g"), function(sub) {
            return sub.charAt(1).toUpperCase();
        });
    };
    var debounce = function debounce(func) {
        var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
        var immidiateOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var last = Date.now();
        var timeout = null;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            clearTimeout(timeout);
            var dist = Date.now() - last;
            var fn = function fn() {
                last = Date.now();
                func.apply(void 0, args);
            };
            if (dist < interval) // we need to delay by the difference between interval and dist
            // for example: if distance is 10 ms and interval is 16 ms,
            // we need to wait an additional 6ms before calling the function)
            {
                if (!immidiateOnly) timeout = setTimeout(fn, interval - dist);
            } else // go!
            fn();
        };
    };
    var MAX_FILES_LIMIT = 1000000;
    var prevent = function prevent(e) {
        return e.preventDefault();
    };
    var create$e = function create(_ref) {
        var root = _ref.root, props = _ref.props;
        // Add id
        var id = root.query("GET_ID");
        if (id) root.element.id = id;
        // Add className
        var className = root.query("GET_CLASS_NAME");
        if (className) className.split(" ").filter(function(name) {
            return name.length;
        }).forEach(function(name) {
            root.element.classList.add(name);
        });
        // Field label
        root.ref.label = root.appendChildView(root.createChildView(dropLabel, Object.assign({}, props, {
            translateY: null,
            caption: root.query("GET_LABEL_IDLE")
        })));
        // List of items
        root.ref.list = root.appendChildView(root.createChildView(listScroller, {
            translateY: null
        }));
        // Background panel
        root.ref.panel = root.appendChildView(root.createChildView(panel, {
            name: "panel-root"
        }));
        // Assistant notifies assistive tech when content changes
        root.ref.assistant = root.appendChildView(root.createChildView(assistant, Object.assign({}, props)));
        // Data
        root.ref.data = root.appendChildView(root.createChildView(data, Object.assign({}, props)));
        // Measure (tests if fixed height was set)
        // DOCTYPE needs to be set for this to work
        root.ref.measure = createElement$1("div");
        root.ref.measure.style.height = "100%";
        root.element.appendChild(root.ref.measure);
        // information on the root height or fixed height status
        root.ref.bounds = null;
        // apply initial style properties
        root.query("GET_STYLES").filter(function(style) {
            return !isEmpty(style.value);
        }).map(function(_ref2) {
            var name = _ref2.name, value = _ref2.value;
            root.element.dataset[name] = value;
        });
        // determine if width changed
        root.ref.widthPrevious = null;
        root.ref.widthUpdated = debounce(function() {
            root.ref.updateHistory = [];
            root.dispatch("DID_RESIZE_ROOT");
        }, 250);
        // history of updates
        root.ref.previousAspectRatio = null;
        root.ref.updateHistory = [];
        // prevent scrolling and zooming on iOS (only if supports pointer events, for then we can enable reorder)
        var canHover = window.matchMedia("(pointer: fine) and (hover: hover)").matches;
        var hasPointerEvents = "PointerEvent" in window;
        if (root.query("GET_ALLOW_REORDER") && hasPointerEvents && !canHover) {
            root.element.addEventListener("touchmove", prevent, {
                passive: false
            });
            root.element.addEventListener("gesturestart", prevent);
        }
        // add credits
        var credits = root.query("GET_CREDITS");
        var hasCredits = credits.length === 2;
        if (hasCredits) {
            var frag = document.createElement("a");
            frag.className = "filepond--credits";
            frag.href = credits[0];
            frag.tabIndex = -1;
            frag.target = "_blank";
            frag.rel = "noopener noreferrer";
            frag.textContent = credits[1];
            root.element.appendChild(frag);
            root.ref.credits = frag;
        }
    };
    var write$9 = function write(_ref3) {
        var root = _ref3.root, props = _ref3.props, actions = _ref3.actions;
        // route actions
        route$5({
            root: root,
            props: props,
            actions: actions
        });
        // apply style properties
        actions.filter(function(action) {
            return /^DID_SET_STYLE_/.test(action.type);
        }).filter(function(action) {
            return !isEmpty(action.data.value);
        }).map(function(_ref4) {
            var type = _ref4.type, data = _ref4.data;
            var name = toCamels(type.substring(8).toLowerCase(), "_");
            root.element.dataset[name] = data.value;
            root.invalidateLayout();
        });
        if (root.rect.element.hidden) return;
        if (root.rect.element.width !== root.ref.widthPrevious) {
            root.ref.widthPrevious = root.rect.element.width;
            root.ref.widthUpdated();
        }
        // get box bounds, we do this only once
        var bounds = root.ref.bounds;
        if (!bounds) {
            bounds = root.ref.bounds = calculateRootBoundingBoxHeight(root);
            // destroy measure element
            root.element.removeChild(root.ref.measure);
            root.ref.measure = null;
        }
        // get quick references to various high level parts of the upload tool
        var _root$ref = root.ref, hopper = _root$ref.hopper, label = _root$ref.label, list = _root$ref.list, panel = _root$ref.panel;
        // sets correct state to hopper scope
        if (hopper) hopper.updateHopperState();
        // bool to indicate if we're full or not
        var aspectRatio = root.query("GET_PANEL_ASPECT_RATIO");
        var isMultiItem = root.query("GET_ALLOW_MULTIPLE");
        var totalItems = root.query("GET_TOTAL_ITEMS");
        var maxItems = isMultiItem ? root.query("GET_MAX_FILES") || MAX_FILES_LIMIT : 1;
        var atMaxCapacity = totalItems === maxItems;
        // action used to add item
        var addAction = actions.find(function(action) {
            return action.type === "DID_ADD_ITEM";
        });
        // if reached max capacity and we've just reached it
        if (atMaxCapacity && addAction) {
            // get interaction type
            var interactionMethod = addAction.data.interactionMethod;
            // hide label
            label.opacity = 0;
            if (isMultiItem) label.translateY = -40;
            else {
                if (interactionMethod === InteractionMethod.API) label.translateX = 40;
                else if (interactionMethod === InteractionMethod.BROWSE) label.translateY = 40;
                else label.translateY = 30;
            }
        } else if (!atMaxCapacity) {
            label.opacity = 1;
            label.translateX = 0;
            label.translateY = 0;
        }
        var listItemMargin = calculateListItemMargin(root);
        var listHeight = calculateListHeight(root);
        var labelHeight = label.rect.element.height;
        var currentLabelHeight = !isMultiItem || atMaxCapacity ? 0 : labelHeight;
        var listMarginTop = atMaxCapacity ? list.rect.element.marginTop : 0;
        var listMarginBottom = totalItems === 0 ? 0 : list.rect.element.marginBottom;
        var visualHeight = currentLabelHeight + listMarginTop + listHeight.visual + listMarginBottom;
        var boundsHeight = currentLabelHeight + listMarginTop + listHeight.bounds + listMarginBottom;
        // link list to label bottom position
        list.translateY = Math.max(0, currentLabelHeight - list.rect.element.marginTop) - listItemMargin.top;
        if (aspectRatio) {
            // fixed aspect ratio
            // calculate height based on width
            var width = root.rect.element.width;
            var height = width * aspectRatio;
            // clear history if aspect ratio has changed
            if (aspectRatio !== root.ref.previousAspectRatio) {
                root.ref.previousAspectRatio = aspectRatio;
                root.ref.updateHistory = [];
            }
            // remember this width
            var history = root.ref.updateHistory;
            history.push(width);
            var MAX_BOUNCES = 2;
            if (history.length > MAX_BOUNCES * 2) {
                var l = history.length;
                var bottom = l - 10;
                var bounces = 0;
                for(var i = l; i >= bottom; i--){
                    if (history[i] === history[i - 2]) bounces++;
                    if (bounces >= MAX_BOUNCES) // dont adjust height
                    return;
                }
            }
            // fix height of panel so it adheres to aspect ratio
            panel.scalable = false;
            panel.height = height;
            // available height for list
            var listAvailableHeight = // the height of the panel minus the label height
            height - currentLabelHeight - // the room we leave open between the end of the list and the panel bottom
            (listMarginBottom - listItemMargin.bottom) - // if we're full we need to leave some room between the top of the panel and the list
            (atMaxCapacity ? listMarginTop : 0);
            if (listHeight.visual > listAvailableHeight) list.overflow = listAvailableHeight;
            else list.overflow = null;
            // set container bounds (so pushes siblings downwards)
            root.height = height;
        } else if (bounds.fixedHeight) {
            // fixed height
            // fix height of panel
            panel.scalable = false;
            // available height for list
            var _listAvailableHeight = // the height of the panel minus the label height
            bounds.fixedHeight - currentLabelHeight - // the room we leave open between the end of the list and the panel bottom
            (listMarginBottom - listItemMargin.bottom) - // if we're full we need to leave some room between the top of the panel and the list
            (atMaxCapacity ? listMarginTop : 0);
            // set list height
            if (listHeight.visual > _listAvailableHeight) list.overflow = _listAvailableHeight;
            else list.overflow = null;
        // no need to set container bounds as these are handles by CSS fixed height
        } else if (bounds.cappedHeight) {
            // max-height
            // not a fixed height panel
            var isCappedHeight = visualHeight >= bounds.cappedHeight;
            var panelHeight = Math.min(bounds.cappedHeight, visualHeight);
            panel.scalable = true;
            panel.height = isCappedHeight ? panelHeight : panelHeight - listItemMargin.top - listItemMargin.bottom;
            // available height for list
            var _listAvailableHeight2 = // the height of the panel minus the label height
            panelHeight - currentLabelHeight - // the room we leave open between the end of the list and the panel bottom
            (listMarginBottom - listItemMargin.bottom) - // if we're full we need to leave some room between the top of the panel and the list
            (atMaxCapacity ? listMarginTop : 0);
            // set list height (if is overflowing)
            if (visualHeight > bounds.cappedHeight && listHeight.visual > _listAvailableHeight2) list.overflow = _listAvailableHeight2;
            else list.overflow = null;
            // set container bounds (so pushes siblings downwards)
            root.height = Math.min(bounds.cappedHeight, boundsHeight - listItemMargin.top - listItemMargin.bottom);
        } else {
            // flexible height
            // not a fixed height panel
            var itemMargin = totalItems > 0 ? listItemMargin.top + listItemMargin.bottom : 0;
            panel.scalable = true;
            panel.height = Math.max(labelHeight, visualHeight - itemMargin);
            // set container bounds (so pushes siblings downwards)
            root.height = Math.max(labelHeight, boundsHeight - itemMargin);
        }
        // move credits to bottom
        if (root.ref.credits && panel.heightCurrent) root.ref.credits.style.transform = "translateY(" + panel.heightCurrent + "px)";
    };
    var calculateListItemMargin = function calculateListItemMargin(root) {
        var item = root.ref.list.childViews[0].childViews[0];
        return item ? {
            top: item.rect.element.marginTop,
            bottom: item.rect.element.marginBottom
        } : {
            top: 0,
            bottom: 0
        };
    };
    var calculateListHeight = function calculateListHeight(root) {
        var visual = 0;
        var bounds = 0;
        // get file list reference
        var scrollList = root.ref.list;
        var itemList = scrollList.childViews[0];
        var visibleChildren = itemList.childViews.filter(function(child) {
            return child.rect.element.height;
        });
        var children = root.query("GET_ACTIVE_ITEMS").map(function(item) {
            return visibleChildren.find(function(child) {
                return child.id === item.id;
            });
        }).filter(function(item) {
            return item;
        });
        // no children, done!
        if (children.length === 0) return {
            visual: visual,
            bounds: bounds
        };
        var horizontalSpace = itemList.rect.element.width;
        var dragIndex = getItemIndexByPosition(itemList, children, scrollList.dragCoordinates);
        var childRect = children[0].rect.element;
        var itemVerticalMargin = childRect.marginTop + childRect.marginBottom;
        var itemHorizontalMargin = childRect.marginLeft + childRect.marginRight;
        var itemWidth = childRect.width + itemHorizontalMargin;
        var itemHeight = childRect.height + itemVerticalMargin;
        var newItem = typeof dragIndex !== "undefined" && dragIndex >= 0 ? 1 : 0;
        var removedItem = children.find(function(child) {
            return child.markedForRemoval && child.opacity < 0.45;
        }) ? -1 : 0;
        var verticalItemCount = children.length + newItem + removedItem;
        var itemsPerRow = getItemsPerRow(horizontalSpace, itemWidth);
        // stack
        if (itemsPerRow === 1) children.forEach(function(item) {
            var height = item.rect.element.height + itemVerticalMargin;
            bounds += height;
            visual += height * item.opacity;
        });
        else {
            bounds = Math.ceil(verticalItemCount / itemsPerRow) * itemHeight;
            visual = bounds;
        }
        return {
            visual: visual,
            bounds: bounds
        };
    };
    var calculateRootBoundingBoxHeight = function calculateRootBoundingBoxHeight(root) {
        var height = root.ref.measureHeight || null;
        var cappedHeight = parseInt(root.style.maxHeight, 10) || null;
        var fixedHeight = height === 0 ? null : height;
        return {
            cappedHeight: cappedHeight,
            fixedHeight: fixedHeight
        };
    };
    var exceedsMaxFiles = function exceedsMaxFiles(root, items) {
        var allowReplace = root.query("GET_ALLOW_REPLACE");
        var allowMultiple = root.query("GET_ALLOW_MULTIPLE");
        var totalItems = root.query("GET_TOTAL_ITEMS");
        var maxItems = root.query("GET_MAX_FILES");
        // total amount of items being dragged
        var totalBrowseItems = items.length;
        // if does not allow multiple items and dragging more than one item
        if (!allowMultiple && totalBrowseItems > 1) {
            root.dispatch("DID_THROW_MAX_FILES", {
                source: items,
                error: createResponse("warning", 0, "Max files")
            });
            return true;
        }
        // limit max items to one if not allowed to drop multiple items
        maxItems = allowMultiple ? maxItems : 1;
        if (!allowMultiple && allowReplace) // There is only one item, so there is room to replace or add an item
        return false;
        // no more room?
        var hasMaxItems = isInt(maxItems);
        if (hasMaxItems && totalItems + totalBrowseItems > maxItems) {
            root.dispatch("DID_THROW_MAX_FILES", {
                source: items,
                error: createResponse("warning", 0, "Max files")
            });
            return true;
        }
        return false;
    };
    var getDragIndex = function getDragIndex(list, children, position) {
        var itemList = list.childViews[0];
        return getItemIndexByPosition(itemList, children, {
            left: position.scopeLeft - itemList.rect.element.left,
            top: position.scopeTop - (list.rect.outer.top + list.rect.element.marginTop + list.rect.element.scrollTop)
        });
    };
    /**
     * Enable or disable file drop functionality
     */ var toggleDrop = function toggleDrop(root) {
        var isAllowed = root.query("GET_ALLOW_DROP");
        var isDisabled = root.query("GET_DISABLED");
        var enabled = isAllowed && !isDisabled;
        if (enabled && !root.ref.hopper) {
            var hopper = createHopper(root.element, function(items) {
                // allow quick validation of dropped items
                var beforeDropFile = root.query("GET_BEFORE_DROP_FILE") || function() {
                    return true;
                };
                // all items should be validated by all filters as valid
                var dropValidation = root.query("GET_DROP_VALIDATION");
                return dropValidation ? items.every(function(item) {
                    return applyFilters("ALLOW_HOPPER_ITEM", item, {
                        query: root.query
                    }).every(function(result) {
                        return result === true;
                    }) && beforeDropFile(item);
                }) : true;
            }, {
                filterItems: function filterItems(items) {
                    var ignoredFiles = root.query("GET_IGNORED_FILES");
                    return items.filter(function(item) {
                        if (isFile(item)) return !ignoredFiles.includes(item.name.toLowerCase());
                        return true;
                    });
                },
                catchesDropsOnPage: root.query("GET_DROP_ON_PAGE"),
                requiresDropOnElement: root.query("GET_DROP_ON_ELEMENT")
            });
            hopper.onload = function(items, position) {
                // get item children elements and sort based on list sort
                var list = root.ref.list.childViews[0];
                var visibleChildren = list.childViews.filter(function(child) {
                    return child.rect.element.height;
                });
                var children = root.query("GET_ACTIVE_ITEMS").map(function(item) {
                    return visibleChildren.find(function(child) {
                        return child.id === item.id;
                    });
                }).filter(function(item) {
                    return item;
                });
                applyFilterChain("ADD_ITEMS", items, {
                    dispatch: root.dispatch
                }).then(function(queue) {
                    // these files don't fit so stop here
                    if (exceedsMaxFiles(root, queue)) return false;
                    // go
                    root.dispatch("ADD_ITEMS", {
                        items: queue,
                        index: getDragIndex(root.ref.list, children, position),
                        interactionMethod: InteractionMethod.DROP
                    });
                });
                root.dispatch("DID_DROP", {
                    position: position
                });
                root.dispatch("DID_END_DRAG", {
                    position: position
                });
            };
            hopper.ondragstart = function(position) {
                root.dispatch("DID_START_DRAG", {
                    position: position
                });
            };
            hopper.ondrag = debounce(function(position) {
                root.dispatch("DID_DRAG", {
                    position: position
                });
            });
            hopper.ondragend = function(position) {
                root.dispatch("DID_END_DRAG", {
                    position: position
                });
            };
            root.ref.hopper = hopper;
            root.ref.drip = root.appendChildView(root.createChildView(drip));
        } else if (!enabled && root.ref.hopper) {
            root.ref.hopper.destroy();
            root.ref.hopper = null;
            root.removeChildView(root.ref.drip);
        }
    };
    /**
     * Enable or disable browse functionality
     */ var toggleBrowse = function toggleBrowse(root, props) {
        var isAllowed = root.query("GET_ALLOW_BROWSE");
        var isDisabled = root.query("GET_DISABLED");
        var enabled = isAllowed && !isDisabled;
        if (enabled && !root.ref.browser) root.ref.browser = root.appendChildView(root.createChildView(browser, Object.assign({}, props, {
            onload: function onload(items) {
                applyFilterChain("ADD_ITEMS", items, {
                    dispatch: root.dispatch
                }).then(function(queue) {
                    // these files don't fit so stop here
                    if (exceedsMaxFiles(root, queue)) return false;
                    // add items!
                    root.dispatch("ADD_ITEMS", {
                        items: queue,
                        index: -1,
                        interactionMethod: InteractionMethod.BROWSE
                    });
                });
            }
        })), 0);
        else if (!enabled && root.ref.browser) {
            root.removeChildView(root.ref.browser);
            root.ref.browser = null;
        }
    };
    /**
     * Enable or disable paste functionality
     */ var togglePaste = function togglePaste(root) {
        var isAllowed = root.query("GET_ALLOW_PASTE");
        var isDisabled = root.query("GET_DISABLED");
        var enabled = isAllowed && !isDisabled;
        if (enabled && !root.ref.paster) {
            root.ref.paster = createPaster();
            root.ref.paster.onload = function(items) {
                applyFilterChain("ADD_ITEMS", items, {
                    dispatch: root.dispatch
                }).then(function(queue) {
                    // these files don't fit so stop here
                    if (exceedsMaxFiles(root, queue)) return false;
                    // add items!
                    root.dispatch("ADD_ITEMS", {
                        items: queue,
                        index: -1,
                        interactionMethod: InteractionMethod.PASTE
                    });
                });
            };
        } else if (!enabled && root.ref.paster) {
            root.ref.paster.destroy();
            root.ref.paster = null;
        }
    };
    /**
     * Route actions
     */ var route$5 = createRoute({
        DID_SET_ALLOW_BROWSE: function DID_SET_ALLOW_BROWSE(_ref5) {
            var root = _ref5.root, props = _ref5.props;
            toggleBrowse(root, props);
        },
        DID_SET_ALLOW_DROP: function DID_SET_ALLOW_DROP(_ref6) {
            var root = _ref6.root;
            toggleDrop(root);
        },
        DID_SET_ALLOW_PASTE: function DID_SET_ALLOW_PASTE(_ref7) {
            var root = _ref7.root;
            togglePaste(root);
        },
        DID_SET_DISABLED: function DID_SET_DISABLED(_ref8) {
            var root = _ref8.root, props = _ref8.props;
            toggleDrop(root);
            togglePaste(root);
            toggleBrowse(root, props);
            var isDisabled = root.query("GET_DISABLED");
            if (isDisabled) root.element.dataset.disabled = "disabled";
            else // delete root.element.dataset.disabled; <= this does not work on iOS 10
            root.element.removeAttribute("data-disabled");
        }
    });
    var root = createView({
        name: "root",
        read: function read(_ref9) {
            var root = _ref9.root;
            if (root.ref.measure) root.ref.measureHeight = root.ref.measure.offsetHeight;
        },
        create: create$e,
        write: write$9,
        destroy: function destroy(_ref10) {
            var root = _ref10.root;
            if (root.ref.paster) root.ref.paster.destroy();
            if (root.ref.hopper) root.ref.hopper.destroy();
            root.element.removeEventListener("touchmove", prevent);
            root.element.removeEventListener("gesturestart", prevent);
        },
        mixins: {
            styles: [
                "height"
            ]
        }
    });
    // creates the app
    var createApp = function createApp() {
        var initialOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // let element
        var originalElement = null;
        // get default options
        var defaultOptions = getOptions();
        // create the data store, this will contain all our app info
        var store = createStore(// initial state (should be serializable)
        createInitialState(defaultOptions), // queries
        [
            queries,
            createOptionQueries(defaultOptions)
        ], // action handlers
        [
            actions,
            createOptionActions(defaultOptions)
        ]);
        // set initial options
        store.dispatch("SET_OPTIONS", {
            options: initialOptions
        });
        // kick thread if visibility changes
        var visibilityHandler = function visibilityHandler() {
            if (document.hidden) return;
            store.dispatch("KICK");
        };
        document.addEventListener("visibilitychange", visibilityHandler);
        // re-render on window resize start and finish
        var resizeDoneTimer = null;
        var isResizing = false;
        var isResizingHorizontally = false;
        var initialWindowWidth = null;
        var currentWindowWidth = null;
        var resizeHandler = function resizeHandler() {
            if (!isResizing) isResizing = true;
            clearTimeout(resizeDoneTimer);
            resizeDoneTimer = setTimeout(function() {
                isResizing = false;
                initialWindowWidth = null;
                currentWindowWidth = null;
                if (isResizingHorizontally) {
                    isResizingHorizontally = false;
                    store.dispatch("DID_STOP_RESIZE");
                }
            }, 500);
        };
        window.addEventListener("resize", resizeHandler);
        // render initial view
        var view = root(store, {
            id: getUniqueId()
        });
        //
        // PRIVATE API -------------------------------------------------------------------------------------
        //
        var isResting = false;
        var isHidden = false;
        var readWriteApi = {
            // necessary for update loop
            /**
             * Reads from dom (never call manually)
             * @private
             */ _read: function _read() {
                // test if we're resizing horizontally
                // TODO: see if we can optimize this by measuring root rect
                if (isResizing) {
                    currentWindowWidth = window.innerWidth;
                    if (!initialWindowWidth) initialWindowWidth = currentWindowWidth;
                    if (!isResizingHorizontally && currentWindowWidth !== initialWindowWidth) {
                        store.dispatch("DID_START_RESIZE");
                        isResizingHorizontally = true;
                    }
                }
                if (isHidden && isResting) // test if is no longer hidden
                isResting = view.element.offsetParent === null;
                // if resting, no need to read as numbers will still all be correct
                if (isResting) return;
                // read view data
                view._read();
                // if is hidden we need to know so we exit rest mode when revealed
                isHidden = view.rect.element.hidden;
            },
            /**
             * Writes to dom (never call manually)
             * @private
             */ _write: function _write(ts) {
                // get all actions from store
                var actions = store.processActionQueue()// filter out set actions (these will automatically trigger DID_SET)
                .filter(function(action) {
                    return !/^SET_/.test(action.type);
                });
                // if was idling and no actions stop here
                if (isResting && !actions.length) return;
                // some actions might trigger events
                routeActionsToEvents(actions);
                // update the view
                isResting = view._write(ts, actions, isResizingHorizontally);
                // will clean up all archived items
                removeReleasedItems(store.query("GET_ITEMS"));
                // now idling
                if (isResting) store.processDispatchQueue();
            }
        };
        //
        // EXPOSE EVENTS -------------------------------------------------------------------------------------
        //
        var createEvent = function createEvent(name) {
            return function(data) {
                // create default event
                var event = {
                    type: name
                };
                // no data to add
                if (!data) return event;
                // copy relevant props
                if (data.hasOwnProperty("error")) event.error = data.error ? Object.assign({}, data.error) : null;
                if (data.status) event.status = Object.assign({}, data.status);
                if (data.file) event.output = data.file;
                // only source is available, else add item if possible
                if (data.source) event.file = data.source;
                else if (data.item || data.id) {
                    var item = data.item ? data.item : store.query("GET_ITEM", data.id);
                    event.file = item ? createItemAPI(item) : null;
                }
                // map all items in a possible items array
                if (data.items) event.items = data.items.map(createItemAPI);
                // if this is a progress event add the progress amount
                if (/progress/.test(name)) event.progress = data.progress;
                // copy relevant props
                if (data.hasOwnProperty("origin") && data.hasOwnProperty("target")) {
                    event.origin = data.origin;
                    event.target = data.target;
                }
                return event;
            };
        };
        var eventRoutes = {
            DID_DESTROY: createEvent("destroy"),
            DID_INIT: createEvent("init"),
            DID_THROW_MAX_FILES: createEvent("warning"),
            DID_INIT_ITEM: createEvent("initfile"),
            DID_START_ITEM_LOAD: createEvent("addfilestart"),
            DID_UPDATE_ITEM_LOAD_PROGRESS: createEvent("addfileprogress"),
            DID_LOAD_ITEM: createEvent("addfile"),
            DID_THROW_ITEM_INVALID: [
                createEvent("error"),
                createEvent("addfile")
            ],
            DID_THROW_ITEM_LOAD_ERROR: [
                createEvent("error"),
                createEvent("addfile")
            ],
            DID_THROW_ITEM_REMOVE_ERROR: [
                createEvent("error"),
                createEvent("removefile")
            ],
            DID_PREPARE_OUTPUT: createEvent("preparefile"),
            DID_START_ITEM_PROCESSING: createEvent("processfilestart"),
            DID_UPDATE_ITEM_PROCESS_PROGRESS: createEvent("processfileprogress"),
            DID_ABORT_ITEM_PROCESSING: createEvent("processfileabort"),
            DID_COMPLETE_ITEM_PROCESSING: createEvent("processfile"),
            DID_COMPLETE_ITEM_PROCESSING_ALL: createEvent("processfiles"),
            DID_REVERT_ITEM_PROCESSING: createEvent("processfilerevert"),
            DID_THROW_ITEM_PROCESSING_ERROR: [
                createEvent("error"),
                createEvent("processfile")
            ],
            DID_REMOVE_ITEM: createEvent("removefile"),
            DID_UPDATE_ITEMS: createEvent("updatefiles"),
            DID_ACTIVATE_ITEM: createEvent("activatefile"),
            DID_REORDER_ITEMS: createEvent("reorderfiles")
        };
        var exposeEvent = function exposeEvent(event) {
            // create event object to be dispatched
            var detail = Object.assign({
                pond: exports1
            }, event);
            delete detail.type;
            view.element.dispatchEvent(new CustomEvent("FilePond:" + event.type, {
                // event info
                detail: detail,
                // event behaviour
                bubbles: true,
                cancelable: true,
                composed: true
            }));
            // event object to params used for `on()` event handlers and callbacks `oninit()`
            var params = [];
            // if is possible error event, make it the first param
            if (event.hasOwnProperty("error")) params.push(event.error);
            // file is always section
            if (event.hasOwnProperty("file")) params.push(event.file);
            // append other props
            var filtered = [
                "type",
                "error",
                "file"
            ];
            Object.keys(event).filter(function(key) {
                return !filtered.includes(key);
            }).forEach(function(key) {
                return params.push(event[key]);
            });
            // on(type, () => { })
            exports1.fire.apply(exports1, [
                event.type
            ].concat(params));
            // oninit = () => {}
            var handler = store.query("GET_ON" + event.type.toUpperCase());
            if (handler) handler.apply(void 0, params);
        };
        var routeActionsToEvents = function routeActionsToEvents(actions) {
            if (!actions.length) return;
            actions.filter(function(action) {
                return eventRoutes[action.type];
            }).forEach(function(action) {
                var routes = eventRoutes[action.type];
                (Array.isArray(routes) ? routes : [
                    routes
                ]).forEach(function(route) {
                    // this isn't fantastic, but because of the stacking of settimeouts plugins can handle the did_load before the did_init
                    if (action.type === "DID_INIT_ITEM") exposeEvent(route(action.data));
                    else setTimeout(function() {
                        exposeEvent(route(action.data));
                    }, 0);
                });
            });
        };
        //
        // PUBLIC API -------------------------------------------------------------------------------------
        //
        var setOptions = function setOptions(options) {
            return store.dispatch("SET_OPTIONS", {
                options: options
            });
        };
        var getFile = function getFile(query) {
            return store.query("GET_ACTIVE_ITEM", query);
        };
        var prepareFile = function prepareFile(query) {
            return new Promise(function(resolve, reject) {
                store.dispatch("REQUEST_ITEM_PREPARE", {
                    query: query,
                    success: function success(item) {
                        resolve(item);
                    },
                    failure: function failure(error) {
                        reject(error);
                    }
                });
            });
        };
        var addFile = function addFile(source) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return new Promise(function(resolve, reject) {
                addFiles([
                    {
                        source: source,
                        options: options
                    }
                ], {
                    index: options.index
                }).then(function(items) {
                    return resolve(items && items[0]);
                }).catch(reject);
            });
        };
        var isFilePondFile = function isFilePondFile(obj) {
            return obj.file && obj.id;
        };
        var removeFile = function removeFile(query, options) {
            // if only passed options
            if (typeof query === "object" && !isFilePondFile(query) && !options) {
                options = query;
                query = undefined;
            }
            // request item removal
            store.dispatch("REMOVE_ITEM", Object.assign({}, options, {
                query: query
            }));
            // see if item has been removed
            return store.query("GET_ACTIVE_ITEM", query) === null;
        };
        var addFiles = function addFiles() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return new Promise(function(resolve, reject) {
                var sources = [];
                var options = {};
                // user passed a sources array
                if (isArray(args[0])) {
                    sources.push.apply(sources, args[0]);
                    Object.assign(options, args[1] || {});
                } else {
                    // user passed sources as arguments, last one might be options object
                    var lastArgument = args[args.length - 1];
                    if (typeof lastArgument === "object" && !(lastArgument instanceof Blob)) Object.assign(options, args.pop());
                    // add rest to sources
                    sources.push.apply(sources, args);
                }
                store.dispatch("ADD_ITEMS", {
                    items: sources,
                    index: options.index,
                    interactionMethod: InteractionMethod.API,
                    success: resolve,
                    failure: reject
                });
            });
        };
        var getFiles = function getFiles() {
            return store.query("GET_ACTIVE_ITEMS");
        };
        var processFile = function processFile(query) {
            return new Promise(function(resolve, reject) {
                store.dispatch("REQUEST_ITEM_PROCESSING", {
                    query: query,
                    success: function success(item) {
                        resolve(item);
                    },
                    failure: function failure(error) {
                        reject(error);
                    }
                });
            });
        };
        var prepareFiles = function prepareFiles() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            var queries = Array.isArray(args[0]) ? args[0] : args;
            var items = queries.length ? queries : getFiles();
            return Promise.all(items.map(prepareFile));
        };
        var processFiles = function processFiles() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            var queries = Array.isArray(args[0]) ? args[0] : args;
            if (!queries.length) {
                var files = getFiles().filter(function(item) {
                    return !(item.status === ItemStatus.IDLE && item.origin === FileOrigin.LOCAL) && item.status !== ItemStatus.PROCESSING && item.status !== ItemStatus.PROCESSING_COMPLETE && item.status !== ItemStatus.PROCESSING_REVERT_ERROR;
                });
                return Promise.all(files.map(processFile));
            }
            return Promise.all(queries.map(processFile));
        };
        var removeFiles = function removeFiles() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var queries = Array.isArray(args[0]) ? args[0] : args;
            var options;
            if (typeof queries[queries.length - 1] === "object") options = queries.pop();
            else if (Array.isArray(args[0])) options = args[1];
            var files = getFiles();
            if (!queries.length) return Promise.all(files.map(function(file) {
                return removeFile(file, options);
            }));
            // when removing by index the indexes shift after each file removal so we need to convert indexes to ids
            var mappedQueries = queries.map(function(query) {
                return isNumber(query) ? files[query] ? files[query].id : null : query;
            }).filter(function(query) {
                return query;
            });
            return mappedQueries.map(function(q) {
                return removeFile(q, options);
            });
        };
        var exports1 = Object.assign({}, on(), {}, readWriteApi, {}, createOptionAPI(store, defaultOptions), {
            /**
                 * Override options defined in options object
                 * @param options
                 */ setOptions: setOptions,
            /**
                 * Load the given file
                 * @param source - the source of the file (either a File, base64 data uri or url)
                 * @param options - object, { index: 0 }
                 */ addFile: addFile,
            /**
                 * Load the given files
                 * @param sources - the sources of the files to load
                 * @param options - object, { index: 0 }
                 */ addFiles: addFiles,
            /**
                 * Returns the file objects matching the given query
                 * @param query { string, number, null }
                 */ getFile: getFile,
            /**
                 * Upload file with given name
                 * @param query { string, number, null  }
                 */ processFile: processFile,
            /**
                 * Request prepare output for file with given name
                 * @param query { string, number, null  }
                 */ prepareFile: prepareFile,
            /**
                 * Removes a file by its name
                 * @param query { string, number, null  }
                 */ removeFile: removeFile,
            /**
                 * Moves a file to a new location in the files list
                 */ moveFile: function moveFile(query, index) {
                return store.dispatch("MOVE_ITEM", {
                    query: query,
                    index: index
                });
            },
            /**
                 * Returns all files (wrapped in public api)
                 */ getFiles: getFiles,
            /**
                 * Starts uploading all files
                 */ processFiles: processFiles,
            /**
                 * Clears all files from the files list
                 */ removeFiles: removeFiles,
            /**
                 * Starts preparing output of all files
                 */ prepareFiles: prepareFiles,
            /**
                 * Sort list of files
                 */ sort: function sort(compare) {
                return store.dispatch("SORT", {
                    compare: compare
                });
            },
            /**
                 * Browse the file system for a file
                 */ browse: function browse() {
                // needs to be trigger directly as user action needs to be traceable (is not traceable in requestAnimationFrame)
                var input = view.element.querySelector("input[type=file]");
                if (input) input.click();
            },
            /**
                 * Destroys the app
                 */ destroy: function destroy() {
                // request destruction
                exports1.fire("destroy", view.element);
                // stop active processes (file uploads, fetches, stuff like that)
                // loop over items and depending on states call abort for ongoing processes
                store.dispatch("ABORT_ALL");
                // destroy view
                view._destroy();
                // stop listening to resize
                window.removeEventListener("resize", resizeHandler);
                // stop listening to the visiblitychange event
                document.removeEventListener("visibilitychange", visibilityHandler);
                // dispatch destroy
                store.dispatch("DID_DESTROY");
            },
            /**
                 * Inserts the plugin before the target element
                 */ insertBefore: function insertBefore$1(element) {
                return insertBefore(view.element, element);
            },
            /**
                 * Inserts the plugin after the target element
                 */ insertAfter: function insertAfter$1(element) {
                return insertAfter(view.element, element);
            },
            /**
                 * Appends the plugin to the target element
                 */ appendTo: function appendTo(element) {
                return element.appendChild(view.element);
            },
            /**
                 * Replaces an element with the app
                 */ replaceElement: function replaceElement(element) {
                // insert the app before the element
                insertBefore(view.element, element);
                // remove the original element
                element.parentNode.removeChild(element);
                // remember original element
                originalElement = element;
            },
            /**
                 * Restores the original element
                 */ restoreElement: function restoreElement() {
                if (!originalElement) return; // no element to restore
                // restore original element
                insertAfter(originalElement, view.element);
                // remove our element
                view.element.parentNode.removeChild(view.element);
                // remove reference
                originalElement = null;
            },
            /**
                 * Returns true if the app root is attached to given element
                 * @param element
                 */ isAttachedTo: function isAttachedTo(element) {
                return view.element === element || originalElement === element;
            },
            /**
                 * Returns the root element
                 */ element: {
                get: function get() {
                    return view.element;
                }
            },
            /**
                 * Returns the current pond status
                 */ status: {
                get: function get() {
                    return store.query("GET_STATUS");
                }
            }
        });
        // Done!
        store.dispatch("DID_INIT");
        // create actual api object
        return createObject(exports1);
    };
    var createAppObject = function createAppObject() {
        var customOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // default options
        var defaultOptions = {};
        forin(getOptions(), function(key, value) {
            defaultOptions[key] = value[0];
        });
        // set app options
        var app = createApp(Object.assign({}, defaultOptions, {}, customOptions));
        // return the plugin instance
        return app;
    };
    var lowerCaseFirstLetter = function lowerCaseFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    };
    var attributeNameToPropertyName = function attributeNameToPropertyName(attributeName) {
        return toCamels(attributeName.replace(/^data-/, ""));
    };
    var mapObject = function mapObject(object, propertyMap) {
        // remove unwanted
        forin(propertyMap, function(selector, mapping) {
            forin(object, function(property, value) {
                // create regexp shortcut
                var selectorRegExp = new RegExp(selector);
                // tests if
                var matches = selectorRegExp.test(property);
                // no match, skip
                if (!matches) return;
                // if there's a mapping, the original property is always removed
                delete object[property];
                // should only remove, we done!
                if (mapping === false) return;
                // move value to new property
                if (isString(mapping)) {
                    object[mapping] = value;
                    return;
                }
                // move to group
                var group = mapping.group;
                if (isObject(mapping) && !object[group]) object[group] = {};
                object[group][lowerCaseFirstLetter(property.replace(selectorRegExp, ""))] = value;
            });
            // do submapping
            if (mapping.mapping) mapObject(object[mapping.group], mapping.mapping);
        });
    };
    var getAttributesAsObject = function getAttributesAsObject(node) {
        var attributeMapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        // turn attributes into object
        var attributes = [];
        forin(node.attributes, function(index) {
            attributes.push(node.attributes[index]);
        });
        var output = attributes.filter(function(attribute) {
            return attribute.name;
        }).reduce(function(obj, attribute) {
            var value = attr(node, attribute.name);
            obj[attributeNameToPropertyName(attribute.name)] = value === attribute.name ? true : value;
            return obj;
        }, {});
        // do mapping of object properties
        mapObject(output, attributeMapping);
        return output;
    };
    var createAppAtElement = function createAppAtElement(element) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        // how attributes of the input element are mapped to the options for the plugin
        var attributeMapping = {
            // translate to other name
            "^class$": "className",
            "^multiple$": "allowMultiple",
            "^capture$": "captureMethod",
            "^webkitdirectory$": "allowDirectoriesOnly",
            // group under single property
            "^server": {
                group: "server",
                mapping: {
                    "^process": {
                        group: "process"
                    },
                    "^revert": {
                        group: "revert"
                    },
                    "^fetch": {
                        group: "fetch"
                    },
                    "^restore": {
                        group: "restore"
                    },
                    "^load": {
                        group: "load"
                    }
                }
            },
            // don't include in object
            "^type$": false,
            "^files$": false
        };
        // add additional option translators
        applyFilters("SET_ATTRIBUTE_TO_OPTION_MAP", attributeMapping);
        // create final options object by setting options object and then overriding options supplied on element
        var mergedOptions = Object.assign({}, options);
        var attributeOptions = getAttributesAsObject(element.nodeName === "FIELDSET" ? element.querySelector("input[type=file]") : element, attributeMapping);
        // merge with options object
        Object.keys(attributeOptions).forEach(function(key) {
            if (isObject(attributeOptions[key])) {
                if (!isObject(mergedOptions[key])) mergedOptions[key] = {};
                Object.assign(mergedOptions[key], attributeOptions[key]);
            } else mergedOptions[key] = attributeOptions[key];
        });
        // if parent is a fieldset, get files from parent by selecting all input fields that are not file upload fields
        // these will then be automatically set to the initial files
        mergedOptions.files = (options.files || []).concat(Array.from(element.querySelectorAll("input:not([type=file])")).map(function(input) {
            return {
                source: input.value,
                options: {
                    type: input.dataset.type
                }
            };
        }));
        // build plugin
        var app = createAppObject(mergedOptions);
        // add already selected files
        if (element.files) Array.from(element.files).forEach(function(file) {
            app.addFile(file);
        });
        // replace the target element
        app.replaceElement(element);
        // expose
        return app;
    };
    // if an element is passed, we create the instance at that element, if not, we just create an up object
    var createApp$1 = function createApp() {
        return isNode(arguments.length <= 0 ? undefined : arguments[0]) ? createAppAtElement.apply(void 0, arguments) : createAppObject.apply(void 0, arguments);
    };
    var PRIVATE_METHODS = [
        "fire",
        "_read",
        "_write"
    ];
    var createAppAPI = function createAppAPI(app) {
        var api = {};
        copyObjectPropertiesToObject(app, api, PRIVATE_METHODS);
        return api;
    };
    /**
     * Replaces placeholders in given string with replacements
     * @param string - "Foo {bar}""
     * @param replacements - { "bar": 10 }
     */ var replaceInString = function replaceInString(string, replacements) {
        return string.replace(/(?:{([a-zA-Z]+)})/g, function(match, group) {
            return replacements[group];
        });
    };
    var createWorker = function createWorker(fn) {
        var workerBlob = new Blob([
            "(",
            fn.toString(),
            ")()"
        ], {
            type: "application/javascript"
        });
        var workerURL = URL.createObjectURL(workerBlob);
        var worker = new Worker(workerURL);
        return {
            transfer: function transfer(message, cb) {},
            post: function post(message, cb, transferList) {
                var id = getUniqueId();
                worker.onmessage = function(e) {
                    if (e.data.id === id) cb(e.data.message);
                };
                worker.postMessage({
                    id: id,
                    message: message
                }, transferList);
            },
            terminate: function terminate() {
                worker.terminate();
                URL.revokeObjectURL(workerURL);
            }
        };
    };
    var loadImage = function loadImage(url) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = function(e) {
                reject(e);
            };
            img.src = url;
        });
    };
    var renameFile = function renameFile(file, name) {
        var renamedFile = file.slice(0, file.size, file.type);
        renamedFile.lastModifiedDate = file.lastModifiedDate;
        renamedFile.name = name;
        return renamedFile;
    };
    var copyFile = function copyFile(file) {
        return renameFile(file, file.name);
    };
    // already registered plugins (can't register twice)
    var registeredPlugins = [];
    // pass utils to plugin
    var createAppPlugin = function createAppPlugin(plugin) {
        // already registered
        if (registeredPlugins.includes(plugin)) return;
        // remember this plugin
        registeredPlugins.push(plugin);
        // setup!
        var pluginOutline = plugin({
            addFilter: addFilter,
            utils: {
                Type: Type,
                forin: forin,
                isString: isString,
                isFile: isFile,
                toNaturalFileSize: toNaturalFileSize,
                replaceInString: replaceInString,
                getExtensionFromFilename: getExtensionFromFilename,
                getFilenameWithoutExtension: getFilenameWithoutExtension,
                guesstimateMimeType: guesstimateMimeType,
                getFileFromBlob: getFileFromBlob,
                getFilenameFromURL: getFilenameFromURL,
                createRoute: createRoute,
                createWorker: createWorker,
                createView: createView,
                createItemAPI: createItemAPI,
                loadImage: loadImage,
                copyFile: copyFile,
                renameFile: renameFile,
                createBlob: createBlob,
                applyFilterChain: applyFilterChain,
                text: text,
                getNumericAspectRatioFromString: getNumericAspectRatioFromString
            },
            views: {
                fileActionButton: fileActionButton
            }
        });
        // add plugin options to default options
        extendDefaultOptions(pluginOutline.options);
    };
    // feature detection used by supported() method
    var isOperaMini = function isOperaMini() {
        return Object.prototype.toString.call(window.operamini) === "[object OperaMini]";
    };
    var hasPromises = function hasPromises() {
        return "Promise" in window;
    };
    var hasBlobSlice = function hasBlobSlice() {
        return "slice" in Blob.prototype;
    };
    var hasCreateObjectURL = function hasCreateObjectURL() {
        return "URL" in window && "createObjectURL" in window.URL;
    };
    var hasVisibility = function hasVisibility() {
        return "visibilityState" in document;
    };
    var hasTiming = function hasTiming() {
        return "performance" in window;
    }; // iOS 8.x
    var hasCSSSupports = function hasCSSSupports() {
        return "supports" in (window.CSS || {});
    }; // use to detect Safari 9+
    var isIE11 = function isIE11() {
        return /MSIE|Trident/.test(window.navigator.userAgent);
    };
    var supported = function() {
        // Runs immediately and then remembers result for subsequent calls
        var isSupported = // Has to be a browser
        isBrowser() && // Can't run on Opera Mini due to lack of everything
        !isOperaMini() && // Require these APIs to feature detect a modern browser
        hasVisibility() && hasPromises() && hasBlobSlice() && hasCreateObjectURL() && hasTiming() && // doesn't need CSSSupports but is a good way to detect Safari 9+ (we do want to support IE11 though)
        (hasCSSSupports() || isIE11());
        return function() {
            return isSupported;
        };
    }();
    /**
     * Plugin internal state (over all instances)
     */ var state = {
        // active app instances, used to redraw the apps and to find the later
        apps: []
    };
    // plugin name
    var name = "filepond";
    /**
     * Public Plugin methods
     */ var fn = function fn() {};
    exports1.Status = {};
    exports1.FileStatus = {};
    exports1.FileOrigin = {};
    exports1.OptionTypes = {};
    exports1.create = fn;
    exports1.destroy = fn;
    exports1.parse = fn;
    exports1.find = fn;
    exports1.registerPlugin = fn;
    exports1.getOptions = fn;
    exports1.setOptions = fn;
    // if not supported, no API
    if (supported()) {
        // start painter and fire load event
        createPainter(function() {
            state.apps.forEach(function(app) {
                return app._read();
            });
        }, function(ts) {
            state.apps.forEach(function(app) {
                return app._write(ts);
            });
        });
        // fire loaded event so we know when FilePond is available
        var dispatch = function dispatch() {
            // let others know we have area ready
            document.dispatchEvent(new CustomEvent("FilePond:loaded", {
                detail: {
                    supported: supported,
                    create: exports1.create,
                    destroy: exports1.destroy,
                    parse: exports1.parse,
                    find: exports1.find,
                    registerPlugin: exports1.registerPlugin,
                    setOptions: exports1.setOptions
                }
            }));
            // clean up event
            document.removeEventListener("DOMContentLoaded", dispatch);
        };
        if (document.readyState !== "loading") // move to back of execution queue, FilePond should have been exported by then
        setTimeout(function() {
            return dispatch();
        }, 0);
        else document.addEventListener("DOMContentLoaded", dispatch);
        // updates the OptionTypes object based on the current options
        var updateOptionTypes = function updateOptionTypes() {
            return forin(getOptions(), function(key, value) {
                exports1.OptionTypes[key] = value[1];
            });
        };
        exports1.Status = Object.assign({}, Status);
        exports1.FileOrigin = Object.assign({}, FileOrigin);
        exports1.FileStatus = Object.assign({}, ItemStatus);
        exports1.OptionTypes = {};
        updateOptionTypes();
        // create method, creates apps and adds them to the app array
        exports1.create = function create() {
            var app = createApp$1.apply(void 0, arguments);
            app.on("destroy", exports1.destroy);
            state.apps.push(app);
            return createAppAPI(app);
        };
        // destroys apps and removes them from the app array
        exports1.destroy = function destroy(hook) {
            // returns true if the app was destroyed successfully
            var indexToRemove = state.apps.findIndex(function(app) {
                return app.isAttachedTo(hook);
            });
            if (indexToRemove >= 0) {
                // remove from apps
                var app = state.apps.splice(indexToRemove, 1)[0];
                // restore original dom element
                app.restoreElement();
                return true;
            }
            return false;
        };
        // parses the given context for plugins (does not include the context element itself)
        exports1.parse = function parse(context) {
            // get all possible hooks
            var matchedHooks = Array.from(context.querySelectorAll("." + name));
            // filter out already active hooks
            var newHooks = matchedHooks.filter(function(newHook) {
                return !state.apps.find(function(app) {
                    return app.isAttachedTo(newHook);
                });
            });
            // create new instance for each hook
            return newHooks.map(function(hook) {
                return exports1.create(hook);
            });
        };
        // returns an app based on the given element hook
        exports1.find = function find(hook) {
            var app = state.apps.find(function(app) {
                return app.isAttachedTo(hook);
            });
            if (!app) return null;
            return createAppAPI(app);
        };
        // adds a plugin extension
        exports1.registerPlugin = function registerPlugin() {
            for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
            // register plugins
            plugins.forEach(createAppPlugin);
            // update OptionTypes, each plugin might have extended the default options
            updateOptionTypes();
        };
        exports1.getOptions = function getOptions$1() {
            var opts = {};
            forin(getOptions(), function(key, value) {
                opts[key] = value[0];
            });
            return opts;
        };
        exports1.setOptions = function setOptions$1(opts) {
            if (isObject(opts)) {
                // update existing plugins
                state.apps.forEach(function(app) {
                    app.setOptions(opts);
                });
                // override defaults
                setOptions(opts);
            }
            // return new options
            return exports1.getOptions();
        };
    }
    exports1.supported = supported;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


var $9333a3dab47a374d$exports = {};
/*!
 * FilePondPluginFileValidateType 1.2.9
 * Licensed under MIT, https://opensource.org/licenses/MIT/
 * Please visit https://pqina.nl/filepond/ for details.
 */ /* eslint-disable */ (function(global, factory) {
    $9333a3dab47a374d$exports = factory();
})($9333a3dab47a374d$exports, function() {
    "use strict";
    var plugin = function plugin(_ref) {
        var addFilter = _ref.addFilter, utils = _ref.utils;
        // get quick reference to Type utils
        var Type = utils.Type, isString = utils.isString, replaceInString = utils.replaceInString, guesstimateMimeType = utils.guesstimateMimeType, getExtensionFromFilename = utils.getExtensionFromFilename, getFilenameFromURL = utils.getFilenameFromURL;
        var mimeTypeMatchesWildCard = function mimeTypeMatchesWildCard(mimeType, wildcard) {
            var mimeTypeGroup = (/^[^/]+/.exec(mimeType) || []).pop(); // image/png -> image
            var wildcardGroup = wildcard.slice(0, -2); // image/* -> image
            return mimeTypeGroup === wildcardGroup;
        };
        var isValidMimeType = function isValidMimeType(acceptedTypes, userInputType) {
            return acceptedTypes.some(function(acceptedType) {
                // accepted is wildcard mime type
                if (/\*$/.test(acceptedType)) return mimeTypeMatchesWildCard(userInputType, acceptedType);
                // is normal mime type
                return acceptedType === userInputType;
            });
        };
        var getItemType = function getItemType(item) {
            // if the item is a url we guess the mime type by the extension
            var type = "";
            if (isString(item)) {
                var filename = getFilenameFromURL(item);
                var extension = getExtensionFromFilename(filename);
                if (extension) type = guesstimateMimeType(extension);
            } else type = item.type;
            return type;
        };
        var validateFile = function validateFile(item, acceptedFileTypes, typeDetector) {
            // no types defined, everything is allowed \o/
            if (acceptedFileTypes.length === 0) return true;
            // gets the item type
            var type = getItemType(item);
            // no type detector, test now
            if (!typeDetector) return isValidMimeType(acceptedFileTypes, type);
            // use type detector
            return new Promise(function(resolve, reject) {
                typeDetector(item, type).then(function(detectedType) {
                    if (isValidMimeType(acceptedFileTypes, detectedType)) resolve();
                    else reject();
                }).catch(reject);
            });
        };
        var applyMimeTypeMap = function applyMimeTypeMap(map) {
            return function(acceptedFileType) {
                return map[acceptedFileType] === null ? false : map[acceptedFileType] || acceptedFileType;
            };
        };
        // setup attribute mapping for accept
        addFilter("SET_ATTRIBUTE_TO_OPTION_MAP", function(map) {
            return Object.assign(map, {
                accept: "acceptedFileTypes"
            });
        });
        // filtering if an item is allowed in hopper
        addFilter("ALLOW_HOPPER_ITEM", function(file, _ref2) {
            var query = _ref2.query;
            // if we are not doing file type validation exit
            if (!query("GET_ALLOW_FILE_TYPE_VALIDATION")) return true;
            // we validate the file against the accepted file types
            return validateFile(file, query("GET_ACCEPTED_FILE_TYPES"));
        });
        // called for each file that is loaded
        // right before it is set to the item state
        // should return a promise
        addFilter("LOAD_FILE", function(file, _ref3) {
            var query = _ref3.query;
            return new Promise(function(resolve, reject) {
                if (!query("GET_ALLOW_FILE_TYPE_VALIDATION")) {
                    resolve(file);
                    return;
                }
                var acceptedFileTypes = query("GET_ACCEPTED_FILE_TYPES");
                // custom type detector method
                var typeDetector = query("GET_FILE_VALIDATE_TYPE_DETECT_TYPE");
                // if invalid, exit here
                var validationResult = validateFile(file, acceptedFileTypes, typeDetector);
                var handleRejection = function handleRejection() {
                    var acceptedFileTypesMapped = acceptedFileTypes.map(applyMimeTypeMap(query("GET_FILE_VALIDATE_TYPE_LABEL_EXPECTED_TYPES_MAP"))).filter(function(label) {
                        return label !== false;
                    });
                    var acceptedFileTypesMappedUnique = acceptedFileTypesMapped.filter(function(item, index) {
                        return acceptedFileTypesMapped.indexOf(item) === index;
                    });
                    reject({
                        status: {
                            main: query("GET_LABEL_FILE_TYPE_NOT_ALLOWED"),
                            sub: replaceInString(query("GET_FILE_VALIDATE_TYPE_LABEL_EXPECTED_TYPES"), {
                                allTypes: acceptedFileTypesMappedUnique.join(", "),
                                allButLastType: acceptedFileTypesMappedUnique.slice(0, -1).join(", "),
                                lastType: acceptedFileTypesMappedUnique[acceptedFileTypesMappedUnique.length - 1]
                            })
                        }
                    });
                };
                // has returned new filename immidiately
                if (typeof validationResult === "boolean") {
                    if (!validationResult) return handleRejection();
                    return resolve(file);
                }
                // is promise
                validationResult.then(function() {
                    resolve(file);
                }).catch(handleRejection);
            });
        });
        // expose plugin
        return {
            // default options
            options: {
                // Enable or disable file type validation
                allowFileTypeValidation: [
                    true,
                    Type.BOOLEAN
                ],
                // What file types to accept
                acceptedFileTypes: [
                    [],
                    Type.ARRAY
                ],
                // - must be comma separated
                // - mime types: image/png, image/jpeg, image/gif
                // - extensions: .png, .jpg, .jpeg ( not enabled yet )
                // - wildcards: image/*
                // label to show when a type is not allowed
                labelFileTypeNotAllowed: [
                    "File is of invalid type",
                    Type.STRING
                ],
                // nicer label
                fileValidateTypeLabelExpectedTypes: [
                    "Expects {allButLastType} or {lastType}",
                    Type.STRING
                ],
                // map mime types to extensions
                fileValidateTypeLabelExpectedTypesMap: [
                    {},
                    Type.OBJECT
                ],
                // Custom function to detect type of file
                fileValidateTypeDetectType: [
                    null,
                    Type.FUNCTION
                ]
            }
        };
    };
    // fire pluginloaded event if running in browser, this allows registering the plugin when using async script tags
    var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
    if (isBrowser) document.dispatchEvent(new CustomEvent("FilePond:pluginloaded", {
        detail: plugin
    }));
    return plugin;
});


var $17c25264098a0cc7$exports = {};
/*!
 * FilePondPluginFileValidateSize 2.2.8
 * Licensed under MIT, https://opensource.org/licenses/MIT/
 * Please visit https://pqina.nl/filepond/ for details.
 */ /* eslint-disable */ (function(global, factory) {
    $17c25264098a0cc7$exports = factory();
})($17c25264098a0cc7$exports, function() {
    "use strict";
    var plugin = function plugin(_ref) {
        var addFilter = _ref.addFilter, utils = _ref.utils;
        // get quick reference to Type utils
        var Type = utils.Type, replaceInString = utils.replaceInString, toNaturalFileSize = utils.toNaturalFileSize;
        // filtering if an item is allowed in hopper
        addFilter("ALLOW_HOPPER_ITEM", function(file, _ref2) {
            var query = _ref2.query;
            if (!query("GET_ALLOW_FILE_SIZE_VALIDATION")) return true;
            var sizeMax = query("GET_MAX_FILE_SIZE");
            if (sizeMax !== null && file.size > sizeMax) return false;
            var sizeMin = query("GET_MIN_FILE_SIZE");
            if (sizeMin !== null && file.size < sizeMin) return false;
            return true;
        });
        // called for each file that is loaded
        // right before it is set to the item state
        // should return a promise
        addFilter("LOAD_FILE", function(file, _ref3) {
            var query = _ref3.query;
            return new Promise(function(resolve, reject) {
                // if not allowed, all fine, exit
                if (!query("GET_ALLOW_FILE_SIZE_VALIDATION")) return resolve(file);
                // check if file should be filtered
                var fileFilter = query("GET_FILE_VALIDATE_SIZE_FILTER");
                if (fileFilter && !fileFilter(file)) return resolve(file);
                // reject or resolve based on file size
                var sizeMax = query("GET_MAX_FILE_SIZE");
                if (sizeMax !== null && file.size > sizeMax) {
                    reject({
                        status: {
                            main: query("GET_LABEL_MAX_FILE_SIZE_EXCEEDED"),
                            sub: replaceInString(query("GET_LABEL_MAX_FILE_SIZE"), {
                                filesize: toNaturalFileSize(sizeMax, ".", query("GET_FILE_SIZE_BASE"), query("GET_FILE_SIZE_LABELS", query))
                            })
                        }
                    });
                    return;
                }
                // reject or resolve based on file size
                var sizeMin = query("GET_MIN_FILE_SIZE");
                if (sizeMin !== null && file.size < sizeMin) {
                    reject({
                        status: {
                            main: query("GET_LABEL_MIN_FILE_SIZE_EXCEEDED"),
                            sub: replaceInString(query("GET_LABEL_MIN_FILE_SIZE"), {
                                filesize: toNaturalFileSize(sizeMin, ".", query("GET_FILE_SIZE_BASE"), query("GET_FILE_SIZE_LABELS", query))
                            })
                        }
                    });
                    return;
                }
                // returns the current option value
                var totalSizeMax = query("GET_MAX_TOTAL_FILE_SIZE");
                if (totalSizeMax !== null) {
                    // get the current total file size
                    var currentTotalSize = query("GET_ACTIVE_ITEMS").reduce(function(total, item) {
                        return total + item.fileSize;
                    }, 0);
                    // get the size of the new file
                    if (currentTotalSize > totalSizeMax) {
                        reject({
                            status: {
                                main: query("GET_LABEL_MAX_TOTAL_FILE_SIZE_EXCEEDED"),
                                sub: replaceInString(query("GET_LABEL_MAX_TOTAL_FILE_SIZE"), {
                                    filesize: toNaturalFileSize(totalSizeMax, ".", query("GET_FILE_SIZE_BASE"), query("GET_FILE_SIZE_LABELS", query))
                                })
                            }
                        });
                        return;
                    }
                }
                // file is fine, let's pass it back
                resolve(file);
            });
        });
        return {
            options: {
                // Enable or disable file type validation
                allowFileSizeValidation: [
                    true,
                    Type.BOOLEAN
                ],
                // Max individual file size in bytes
                maxFileSize: [
                    null,
                    Type.INT
                ],
                // Min individual file size in bytes
                minFileSize: [
                    null,
                    Type.INT
                ],
                // Max total file size in bytes
                maxTotalFileSize: [
                    null,
                    Type.INT
                ],
                // Filter the files that need to be validated for size
                fileValidateSizeFilter: [
                    null,
                    Type.FUNCTION
                ],
                // error labels
                labelMinFileSizeExceeded: [
                    "File is too small",
                    Type.STRING
                ],
                labelMinFileSize: [
                    "Minimum file size is {filesize}",
                    Type.STRING
                ],
                labelMaxFileSizeExceeded: [
                    "File is too large",
                    Type.STRING
                ],
                labelMaxFileSize: [
                    "Maximum file size is {filesize}",
                    Type.STRING
                ],
                labelMaxTotalFileSizeExceeded: [
                    "Maximum total size exceeded",
                    Type.STRING
                ],
                labelMaxTotalFileSize: [
                    "Maximum total file size is {filesize}",
                    Type.STRING
                ]
            }
        };
    };
    // fire pluginloaded event if running in browser, this allows registering the plugin when using async script tags
    var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
    if (isBrowser) document.dispatchEvent(new CustomEvent("FilePond:pluginloaded", {
        detail: plugin
    }));
    return plugin;
});


var $48f23611b62cf521$var$fileInput = {
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        $48f23611b62cf521$var$fileInput.initEvents(target);
        $48f23611b62cf521$var$fileInput.initFilepond(target);
    },
    /**
   * Init events
   *
   * @param {object} target
   * @returns {void}
   */ initEvents: function(target) {
        target.addEventListener("click", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches("body .form-fileinput [data-fileinput-remove]")) {
                $48f23611b62cf521$var$fileInput.togglePlaceholder(event);
                break;
            }
        }, false);
    },
    /**
   * Toggle placeholder function
   *
   * @param {object} event
   * @returns {void}
   */ togglePlaceholder: function(event) {
        let parent = event.target.closest(".form-fileinput");
        let placeholder = parent.querySelector(".form-fileinput-placeholder");
        let input = parent.querySelector(".form-fileinput-input");
        let validation = input.getAttribute("data-validate-org") || "";
        input.setAttribute("data-validate", validation);
        placeholder.classList.add("d-none");
        input.classList.remove("d-none");
    },
    /**
   * Init Filepond
   *
   * @param {object} target
   * @returns {void}
   */ initFilepond: function(target) {
        setTimeout(function() {
            $f0093c65cdad64a6$exports.registerPlugin((0, (/*@__PURE__*/$parcel$interopDefault($9333a3dab47a374d$exports))));
            $f0093c65cdad64a6$exports.registerPlugin((0, (/*@__PURE__*/$parcel$interopDefault($17c25264098a0cc7$exports))));
            var elements = target.querySelectorAll('input[type="file"].filepond');
            window.pond = [];
            elements.forEach(function(element, index) {
                var required = false;
                if (element.hasAttribute("data-validate") && element.getAttribute("data-validate") == "required") required = true;
                var testId = false;
                if (element.hasAttribute("data-test-id")) testId = element.getAttribute("data-test-id");
                var acceptedFileTypes = [
                    "image/*",
                    "application/pdf"
                ];
                if (element.hasAttribute("data-filepond-accepted-filetypes")) acceptedFileTypes = JSON.parse(element.getAttribute("data-filepond-accepted-filetypes"));
                var fileEndpoint = element.getAttribute("data-file-endpoint");
                window.pond[index] = $f0093c65cdad64a6$exports.create(element, {
                    server: {
                        process: fileEndpoint,
                        revert: fileEndpoint,
                        fetch: null
                    },
                    acceptedFileTypes: acceptedFileTypes,
                    maxFileSize: "10MB",
                    oninit () {
                        var target = window.pond[index].element.querySelector('input[type="file"]');
                        if (required) target.setAttribute("data-validate", "required");
                        if (testId) target.setAttribute("data-test-id", testId);
                    },
                    onprocessfile () {
                        $48f23611b62cf521$var$fileInput.onUpdate(index, required);
                    },
                    onremovefile () {
                        $48f23611b62cf521$var$fileInput.onUpdate(index, required);
                    }
                });
                if (window.app.language != "en_US") $f0093c65cdad64a6$exports.setOptions($48f23611b62cf521$var$fileInput.filepondLabelsNL);
            });
        }, 100);
    },
    onUpdate: function(index, required) {
        var files = window.pond[index].getFiles();
        var target = window.pond[index].element.querySelector('input[type="file"]');
        if (!files.length) {
            if (required) target.setAttribute("data-validate", "required");
        } else {
            if (required) target.setAttribute("data-validate", "");
            window.pond[index].element.closest(".form-group").classList.remove("has-error");
        }
    },
    /**
   * Filepond NL Localisation
   */ filepondLabelsNL: {
        labelIdle: "Sleep bestand hierheen of selecteer...",
        labelInvalidField: "U heeft een bestandstype geselecteerd dat niet is toegestaan",
        labelFileWaitingForSize: "Moment geduld a.u.b.",
        labelFileSizeNotAvailable: "Bestandsgrootte niet te bepalen",
        labelFileLoading: "Moment geduld a.u.b.",
        labelFileLoadError: "Fout tijdens laden",
        labelFileProcessing: "Bestand uploaden",
        labelFileProcessingComplete: "Upload klaar",
        labelFileProcessingAborted: "Upload afgebroken",
        labelFileProcessingError: "Fout tijdens uploaden",
        labelTapToCancel: "Afbreken",
        labelButtonRemoveItem: "Verwijderen",
        labelButtonAbortItemLoad: "Afbreken",
        labelButtonRetryItemLoad: "Opnieuw",
        labelButtonAbortItemProcessing: "Afbreken",
        labelButtonUndoItemProcessing: "Ongedaan maken",
        labelButtonRetryItemProcessing: "Normaals proberen",
        labelButtonProcessItem: "Uploaden",
        labelMaxFileSizeExceeded: "Bestand is te groot",
        labelMaxFileSize: "Maximale bestandsgrootte: {filesize}",
        labelMaxTotalFileSizeExceeded: "Maximaal aantal bestanden overschreden",
        labelMaxTotalFileSize: "De maximale totale grootte is: {filesize}",
        labelFileTypeNotAllowed: "Ongeldig bestandsformaat",
        fileValidateTypeLabelExpectedTypes: "Werwacht {allButLastType} of {lastType}",
        imageValidateSizeLabelFormatError: "Ongeldig bestandsformaat",
        imageValidateSizeLabelImageSizeTooSmall: "Afbeelding is te klein",
        imageValidateSizeLabelImageSizeTooBig: "Afbeelding is te groot",
        imageValidateSizeLabelExpectedMinSize: "Minimaal formaat is: {minWidth} \xd7 {minHeight}",
        imageValidateSizeLabelExpectedMaxSize: "Maximaal formaat is: {maxWidth} \xd7 {maxHeight}",
        imageValidateSizeLabelImageResolutionTooLow: "Resolutie is te laag",
        imageValidateSizeLabelImageResolutionTooHigh: "Resolutie is te hoog",
        imageValidateSizeLabelExpectedMinResolution: "Minimale resolutie: {minResolution}",
        imageValidateSizeLabelExpectedMaxResolution: "Maximale resolutie: {maxResolution}"
    }
};
var $48f23611b62cf521$export$2e2bcd8739ae039 = $48f23611b62cf521$var$fileInput;



var $JSMaE = parcelRequire("JSMaE");
var $92a9257e94e58e2f$var$format = {
    /**
   * Initialiseer de formatter
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        target.addEventListener("change", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches("input[data-format]")) {
                $92a9257e94e58e2f$var$format.proces(event.target);
                break;
            }
        }, false);
    },
    /**
   * Verwerk formatting
   *
   * @param {object} target
   * @returns {void}
   */ proces: function(target) {
        let formatter = target.getAttribute("data-format") || null;
        if (formatter !== null && typeof formatter == "string") {
            let valueFormatted = (0, $JSMaE.default)[formatter](target.value);
            target.value = valueFormatted;
        }
    }
};
var $92a9257e94e58e2f$export$2e2bcd8739ae039 = $92a9257e94e58e2f$var$format;


var $880ccf6cc429821e$exports = {};
/*
 * International Telephone Input v21.2.8
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */ // UMD
(function(factory) {
    if (0, $880ccf6cc429821e$exports) $880ccf6cc429821e$exports = factory();
    else window.intlTelInput = factory();
})(()=>{
    var factoryOutput = (()=>{
        var __defProp = Object.defineProperty;
        var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
        var __getOwnPropNames = Object.getOwnPropertyNames;
        var __hasOwnProp = Object.prototype.hasOwnProperty;
        var __export = (target, all)=>{
            for(var name in all)__defProp(target, name, {
                get: all[name],
                enumerable: true
            });
        };
        var __copyProps = (to, from, except, desc)=>{
            if (from && typeof from === "object" || typeof from === "function") {
                for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: ()=>from[key],
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            }
            return to;
        };
        var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
                value: true
            }), mod);
        // src/js/intl-tel-input.ts
        var intl_tel_input_exports = {};
        __export(intl_tel_input_exports, {
            Iti: ()=>Iti,
            default: ()=>intl_tel_input_default
        });
        // src/js/intl-tel-input/data.ts
        var rawCountryData = [
            [
                "af",
                "93"
            ],
            [
                "al",
                "355"
            ],
            [
                "dz",
                "213"
            ],
            [
                "as",
                "1",
                5,
                [
                    "684"
                ]
            ],
            [
                "ad",
                "376"
            ],
            [
                "ao",
                "244"
            ],
            [
                "ai",
                "1",
                6,
                [
                    "264"
                ]
            ],
            [
                "ag",
                "1",
                7,
                [
                    "268"
                ]
            ],
            [
                "ar",
                "54"
            ],
            [
                "am",
                "374"
            ],
            [
                "aw",
                "297"
            ],
            [
                "ac",
                "247"
            ],
            [
                "au",
                "61",
                0
            ],
            [
                "at",
                "43"
            ],
            [
                "az",
                "994"
            ],
            [
                "bs",
                "1",
                8,
                [
                    "242"
                ]
            ],
            [
                "bh",
                "973"
            ],
            [
                "bd",
                "880"
            ],
            [
                "bb",
                "1",
                9,
                [
                    "246"
                ]
            ],
            [
                "by",
                "375"
            ],
            [
                "be",
                "32"
            ],
            [
                "bz",
                "501"
            ],
            [
                "bj",
                "229"
            ],
            [
                "bm",
                "1",
                10,
                [
                    "441"
                ]
            ],
            [
                "bt",
                "975"
            ],
            [
                "bo",
                "591"
            ],
            [
                "ba",
                "387"
            ],
            [
                "bw",
                "267"
            ],
            [
                "br",
                "55"
            ],
            [
                "io",
                "246"
            ],
            [
                "vg",
                "1",
                11,
                [
                    "284"
                ]
            ],
            [
                "bn",
                "673"
            ],
            [
                "bg",
                "359"
            ],
            [
                "bf",
                "226"
            ],
            [
                "bi",
                "257"
            ],
            [
                "kh",
                "855"
            ],
            [
                "cm",
                "237"
            ],
            [
                "ca",
                "1",
                1,
                [
                    "204",
                    "226",
                    "236",
                    "249",
                    "250",
                    "263",
                    "289",
                    "306",
                    "343",
                    "354",
                    "365",
                    "367",
                    "368",
                    "382",
                    "387",
                    "403",
                    "416",
                    "418",
                    "428",
                    "431",
                    "437",
                    "438",
                    "450",
                    "584",
                    "468",
                    "474",
                    "506",
                    "514",
                    "519",
                    "548",
                    "579",
                    "581",
                    "584",
                    "587",
                    "604",
                    "613",
                    "639",
                    "647",
                    "672",
                    "683",
                    "705",
                    "709",
                    "742",
                    "753",
                    "778",
                    "780",
                    "782",
                    "807",
                    "819",
                    "825",
                    "867",
                    "873",
                    "879",
                    "902",
                    "905"
                ]
            ],
            [
                "cv",
                "238"
            ],
            [
                "bq",
                "599",
                1,
                [
                    "3",
                    "4",
                    "7"
                ]
            ],
            [
                "ky",
                "1",
                12,
                [
                    "345"
                ]
            ],
            [
                "cf",
                "236"
            ],
            [
                "td",
                "235"
            ],
            [
                "cl",
                "56"
            ],
            [
                "cn",
                "86"
            ],
            [
                "cx",
                "61",
                2,
                [
                    "89164"
                ]
            ],
            [
                "cc",
                "61",
                1,
                [
                    "89162"
                ]
            ],
            [
                "co",
                "57"
            ],
            [
                "km",
                "269"
            ],
            [
                "cg",
                "242"
            ],
            [
                "cd",
                "243"
            ],
            [
                "ck",
                "682"
            ],
            [
                "cr",
                "506"
            ],
            [
                "ci",
                "225"
            ],
            [
                "hr",
                "385"
            ],
            [
                "cu",
                "53"
            ],
            [
                "cw",
                "599",
                0
            ],
            [
                "cy",
                "357"
            ],
            [
                "cz",
                "420"
            ],
            [
                "dk",
                "45"
            ],
            [
                "dj",
                "253"
            ],
            [
                "dm",
                "1",
                13,
                [
                    "767"
                ]
            ],
            [
                "do",
                "1",
                2,
                [
                    "809",
                    "829",
                    "849"
                ]
            ],
            [
                "ec",
                "593"
            ],
            [
                "eg",
                "20"
            ],
            [
                "sv",
                "503"
            ],
            [
                "gq",
                "240"
            ],
            [
                "er",
                "291"
            ],
            [
                "ee",
                "372"
            ],
            [
                "sz",
                "268"
            ],
            [
                "et",
                "251"
            ],
            [
                "fk",
                "500"
            ],
            [
                "fo",
                "298"
            ],
            [
                "fj",
                "679"
            ],
            [
                "fi",
                "358",
                0
            ],
            [
                "fr",
                "33"
            ],
            [
                "gf",
                "594"
            ],
            [
                "pf",
                "689"
            ],
            [
                "ga",
                "241"
            ],
            [
                "gm",
                "220"
            ],
            [
                "ge",
                "995"
            ],
            [
                "de",
                "49"
            ],
            [
                "gh",
                "233"
            ],
            [
                "gi",
                "350"
            ],
            [
                "gr",
                "30"
            ],
            [
                "gl",
                "299"
            ],
            [
                "gd",
                "1",
                14,
                [
                    "473"
                ]
            ],
            [
                "gp",
                "590",
                0
            ],
            [
                "gu",
                "1",
                15,
                [
                    "671"
                ]
            ],
            [
                "gt",
                "502"
            ],
            [
                "gg",
                "44",
                1,
                [
                    "1481",
                    "7781",
                    "7839",
                    "7911"
                ]
            ],
            [
                "gn",
                "224"
            ],
            [
                "gw",
                "245"
            ],
            [
                "gy",
                "592"
            ],
            [
                "ht",
                "509"
            ],
            [
                "hn",
                "504"
            ],
            [
                "hk",
                "852"
            ],
            [
                "hu",
                "36"
            ],
            [
                "is",
                "354"
            ],
            [
                "in",
                "91"
            ],
            [
                "id",
                "62"
            ],
            [
                "ir",
                "98"
            ],
            [
                "iq",
                "964"
            ],
            [
                "ie",
                "353"
            ],
            [
                "im",
                "44",
                2,
                [
                    "1624",
                    "74576",
                    "7524",
                    "7924",
                    "7624"
                ]
            ],
            [
                "il",
                "972"
            ],
            [
                "it",
                "39",
                0
            ],
            [
                "jm",
                "1",
                4,
                [
                    "876",
                    "658"
                ]
            ],
            [
                "jp",
                "81"
            ],
            [
                "je",
                "44",
                3,
                [
                    "1534",
                    "7509",
                    "7700",
                    "7797",
                    "7829",
                    "7937"
                ]
            ],
            [
                "jo",
                "962"
            ],
            [
                "kz",
                "7",
                1,
                [
                    "33",
                    "7"
                ]
            ],
            [
                "ke",
                "254"
            ],
            [
                "ki",
                "686"
            ],
            [
                "xk",
                "383"
            ],
            [
                "kw",
                "965"
            ],
            [
                "kg",
                "996"
            ],
            [
                "la",
                "856"
            ],
            [
                "lv",
                "371"
            ],
            [
                "lb",
                "961"
            ],
            [
                "ls",
                "266"
            ],
            [
                "lr",
                "231"
            ],
            [
                "ly",
                "218"
            ],
            [
                "li",
                "423"
            ],
            [
                "lt",
                "370"
            ],
            [
                "lu",
                "352"
            ],
            [
                "mo",
                "853"
            ],
            [
                "mg",
                "261"
            ],
            [
                "mw",
                "265"
            ],
            [
                "my",
                "60"
            ],
            [
                "mv",
                "960"
            ],
            [
                "ml",
                "223"
            ],
            [
                "mt",
                "356"
            ],
            [
                "mh",
                "692"
            ],
            [
                "mq",
                "596"
            ],
            [
                "mr",
                "222"
            ],
            [
                "mu",
                "230"
            ],
            [
                "yt",
                "262",
                1,
                [
                    "269",
                    "639"
                ]
            ],
            [
                "mx",
                "52"
            ],
            [
                "fm",
                "691"
            ],
            [
                "md",
                "373"
            ],
            [
                "mc",
                "377"
            ],
            [
                "mn",
                "976"
            ],
            [
                "me",
                "382"
            ],
            [
                "ms",
                "1",
                16,
                [
                    "664"
                ]
            ],
            [
                "ma",
                "212",
                0
            ],
            [
                "mz",
                "258"
            ],
            [
                "mm",
                "95"
            ],
            [
                "na",
                "264"
            ],
            [
                "nr",
                "674"
            ],
            [
                "np",
                "977"
            ],
            [
                "nl",
                "31"
            ],
            [
                "nc",
                "687"
            ],
            [
                "nz",
                "64"
            ],
            [
                "ni",
                "505"
            ],
            [
                "ne",
                "227"
            ],
            [
                "ng",
                "234"
            ],
            [
                "nu",
                "683"
            ],
            [
                "nf",
                "672"
            ],
            [
                "kp",
                "850"
            ],
            [
                "mk",
                "389"
            ],
            [
                "mp",
                "1",
                17,
                [
                    "670"
                ]
            ],
            [
                "no",
                "47",
                0
            ],
            [
                "om",
                "968"
            ],
            [
                "pk",
                "92"
            ],
            [
                "pw",
                "680"
            ],
            [
                "ps",
                "970"
            ],
            [
                "pa",
                "507"
            ],
            [
                "pg",
                "675"
            ],
            [
                "py",
                "595"
            ],
            [
                "pe",
                "51"
            ],
            [
                "ph",
                "63"
            ],
            [
                "pl",
                "48"
            ],
            [
                "pt",
                "351"
            ],
            [
                "pr",
                "1",
                3,
                [
                    "787",
                    "939"
                ]
            ],
            [
                "qa",
                "974"
            ],
            [
                "re",
                "262",
                0
            ],
            [
                "ro",
                "40"
            ],
            [
                "ru",
                "7",
                0
            ],
            [
                "rw",
                "250"
            ],
            [
                "ws",
                "685"
            ],
            [
                "sm",
                "378"
            ],
            [
                "st",
                "239"
            ],
            [
                "sa",
                "966"
            ],
            [
                "sn",
                "221"
            ],
            [
                "rs",
                "381"
            ],
            [
                "sc",
                "248"
            ],
            [
                "sl",
                "232"
            ],
            [
                "sg",
                "65"
            ],
            [
                "sx",
                "1",
                21,
                [
                    "721"
                ]
            ],
            [
                "sk",
                "421"
            ],
            [
                "si",
                "386"
            ],
            [
                "sb",
                "677"
            ],
            [
                "so",
                "252"
            ],
            [
                "za",
                "27"
            ],
            [
                "kr",
                "82"
            ],
            [
                "ss",
                "211"
            ],
            [
                "es",
                "34"
            ],
            [
                "lk",
                "94"
            ],
            [
                "bl",
                "590",
                1
            ],
            [
                "sh",
                "290"
            ],
            [
                "kn",
                "1",
                18,
                [
                    "869"
                ]
            ],
            [
                "lc",
                "1",
                19,
                [
                    "758"
                ]
            ],
            [
                "mf",
                "590",
                2
            ],
            [
                "pm",
                "508"
            ],
            [
                "vc",
                "1",
                20,
                [
                    "784"
                ]
            ],
            [
                "sd",
                "249"
            ],
            [
                "sr",
                "597"
            ],
            [
                "sj",
                "47",
                1,
                [
                    "79"
                ]
            ],
            [
                "se",
                "46"
            ],
            [
                "ch",
                "41"
            ],
            [
                "sy",
                "963"
            ],
            [
                "tw",
                "886"
            ],
            [
                "tj",
                "992"
            ],
            [
                "tz",
                "255"
            ],
            [
                "th",
                "66"
            ],
            [
                "tl",
                "670"
            ],
            [
                "tg",
                "228"
            ],
            [
                "tk",
                "690"
            ],
            [
                "to",
                "676"
            ],
            [
                "tt",
                "1",
                22,
                [
                    "868"
                ]
            ],
            [
                "tn",
                "216"
            ],
            [
                "tr",
                "90"
            ],
            [
                "tm",
                "993"
            ],
            [
                "tc",
                "1",
                23,
                [
                    "649"
                ]
            ],
            [
                "tv",
                "688"
            ],
            [
                "ug",
                "256"
            ],
            [
                "ua",
                "380"
            ],
            [
                "ae",
                "971"
            ],
            [
                "gb",
                "44",
                0
            ],
            [
                "us",
                "1",
                0
            ],
            [
                "uy",
                "598"
            ],
            [
                "vi",
                "1",
                24,
                [
                    "340"
                ]
            ],
            [
                "uz",
                "998"
            ],
            [
                "vu",
                "678"
            ],
            [
                "va",
                "39",
                1,
                [
                    "06698"
                ]
            ],
            [
                "ve",
                "58"
            ],
            [
                "vn",
                "84"
            ],
            [
                "wf",
                "681"
            ],
            [
                "eh",
                "212",
                1,
                [
                    "5288",
                    "5289"
                ]
            ],
            [
                "ye",
                "967"
            ],
            [
                "zm",
                "260"
            ],
            [
                "zw",
                "263"
            ],
            [
                "ax",
                "358",
                1,
                [
                    "18"
                ]
            ]
        ];
        var allCountries = [];
        for(let i = 0; i < rawCountryData.length; i++){
            const c = rawCountryData[i];
            allCountries[i] = {
                name: "",
                // this is now populated in the plugin
                iso2: c[0],
                dialCode: c[1],
                priority: c[2] || 0,
                areaCodes: c[3] || null,
                nodeById: {}
            };
        }
        var data_default = allCountries;
        // src/js/i18n/en/countries.ts
        var countries_default = {
            af: "Afghanistan",
            ax: "\xc5land Islands",
            al: "Albania",
            dz: "Algeria",
            as: "American Samoa",
            ad: "Andorra",
            ao: "Angola",
            ai: "Anguilla",
            aq: "Antarctica",
            ag: "Antigua & Barbuda",
            ar: "Argentina",
            am: "Armenia",
            aw: "Aruba",
            au: "Australia",
            at: "Austria",
            az: "Azerbaijan",
            bs: "Bahamas",
            bh: "Bahrain",
            bd: "Bangladesh",
            bb: "Barbados",
            by: "Belarus",
            be: "Belgium",
            bz: "Belize",
            bj: "Benin",
            bm: "Bermuda",
            bt: "Bhutan",
            bo: "Bolivia",
            ba: "Bosnia & Herzegovina",
            bw: "Botswana",
            bv: "Bouvet Island",
            br: "Brazil",
            io: "British Indian Ocean Territory",
            vg: "British Virgin Islands",
            bn: "Brunei",
            bg: "Bulgaria",
            bf: "Burkina Faso",
            bi: "Burundi",
            kh: "Cambodia",
            cm: "Cameroon",
            ca: "Canada",
            cv: "Cape Verde",
            bq: "Caribbean Netherlands",
            ky: "Cayman Islands",
            cf: "Central African Republic",
            td: "Chad",
            cl: "Chile",
            cn: "China",
            cx: "Christmas Island",
            cc: "Cocos (Keeling) Islands",
            co: "Colombia",
            km: "Comoros",
            cg: "Congo - Brazzaville",
            cd: "Congo - Kinshasa",
            ck: "Cook Islands",
            cr: "Costa Rica",
            ci: "C\xf4te d\u2019Ivoire",
            hr: "Croatia",
            cu: "Cuba",
            cw: "Cura\xe7ao",
            cy: "Cyprus",
            cz: "Czechia",
            dk: "Denmark",
            dj: "Djibouti",
            dm: "Dominica",
            do: "Dominican Republic",
            ec: "Ecuador",
            eg: "Egypt",
            sv: "El Salvador",
            gq: "Equatorial Guinea",
            er: "Eritrea",
            ee: "Estonia",
            sz: "Eswatini",
            et: "Ethiopia",
            fk: "Falkland Islands",
            fo: "Faroe Islands",
            fj: "Fiji",
            fi: "Finland",
            fr: "France",
            gf: "French Guiana",
            pf: "French Polynesia",
            tf: "French Southern Territories",
            ga: "Gabon",
            gm: "Gambia",
            ge: "Georgia",
            de: "Germany",
            gh: "Ghana",
            gi: "Gibraltar",
            gr: "Greece",
            gl: "Greenland",
            gd: "Grenada",
            gp: "Guadeloupe",
            gu: "Guam",
            gt: "Guatemala",
            gg: "Guernsey",
            gn: "Guinea",
            gw: "Guinea-Bissau",
            gy: "Guyana",
            ht: "Haiti",
            hm: "Heard & McDonald Islands",
            hn: "Honduras",
            hk: "Hong Kong SAR China",
            hu: "Hungary",
            is: "Iceland",
            in: "India",
            id: "Indonesia",
            ir: "Iran",
            iq: "Iraq",
            ie: "Ireland",
            im: "Isle of Man",
            il: "Israel",
            it: "Italy",
            jm: "Jamaica",
            jp: "Japan",
            je: "Jersey",
            jo: "Jordan",
            kz: "Kazakhstan",
            ke: "Kenya",
            ki: "Kiribati",
            kw: "Kuwait",
            kg: "Kyrgyzstan",
            la: "Laos",
            lv: "Latvia",
            lb: "Lebanon",
            ls: "Lesotho",
            lr: "Liberia",
            ly: "Libya",
            li: "Liechtenstein",
            lt: "Lithuania",
            lu: "Luxembourg",
            mo: "Macao SAR China",
            mg: "Madagascar",
            mw: "Malawi",
            my: "Malaysia",
            mv: "Maldives",
            ml: "Mali",
            mt: "Malta",
            mh: "Marshall Islands",
            mq: "Martinique",
            mr: "Mauritania",
            mu: "Mauritius",
            yt: "Mayotte",
            mx: "Mexico",
            fm: "Micronesia",
            md: "Moldova",
            mc: "Monaco",
            mn: "Mongolia",
            me: "Montenegro",
            ms: "Montserrat",
            ma: "Morocco",
            mz: "Mozambique",
            mm: "Myanmar (Burma)",
            na: "Namibia",
            nr: "Nauru",
            np: "Nepal",
            nl: "Netherlands",
            nc: "New Caledonia",
            nz: "New Zealand",
            ni: "Nicaragua",
            ne: "Niger",
            ng: "Nigeria",
            nu: "Niue",
            nf: "Norfolk Island",
            kp: "North Korea",
            mk: "North Macedonia",
            mp: "Northern Mariana Islands",
            no: "Norway",
            om: "Oman",
            pk: "Pakistan",
            pw: "Palau",
            ps: "Palestinian Territories",
            pa: "Panama",
            pg: "Papua New Guinea",
            py: "Paraguay",
            pe: "Peru",
            ph: "Philippines",
            pn: "Pitcairn Islands",
            pl: "Poland",
            pt: "Portugal",
            pr: "Puerto Rico",
            qa: "Qatar",
            re: "R\xe9union",
            ro: "Romania",
            ru: "Russia",
            rw: "Rwanda",
            ws: "Samoa",
            sm: "San Marino",
            st: "S\xe3o Tom\xe9 & Pr\xedncipe",
            sa: "Saudi Arabia",
            sn: "Senegal",
            rs: "Serbia",
            sc: "Seychelles",
            sl: "Sierra Leone",
            sg: "Singapore",
            sx: "Sint Maarten",
            sk: "Slovakia",
            si: "Slovenia",
            sb: "Solomon Islands",
            so: "Somalia",
            za: "South Africa",
            gs: "South Georgia & South Sandwich Islands",
            kr: "South Korea",
            ss: "South Sudan",
            es: "Spain",
            lk: "Sri Lanka",
            bl: "St. Barth\xe9lemy",
            sh: "St. Helena",
            kn: "St. Kitts & Nevis",
            lc: "St. Lucia",
            mf: "St. Martin",
            pm: "St. Pierre & Miquelon",
            vc: "St. Vincent & Grenadines",
            sd: "Sudan",
            sr: "Suriname",
            sj: "Svalbard & Jan Mayen",
            se: "Sweden",
            ch: "Switzerland",
            sy: "Syria",
            tw: "Taiwan",
            tj: "Tajikistan",
            tz: "Tanzania",
            th: "Thailand",
            tl: "Timor-Leste",
            tg: "Togo",
            tk: "Tokelau",
            to: "Tonga",
            tt: "Trinidad & Tobago",
            tn: "Tunisia",
            tr: "Turkey",
            tm: "Turkmenistan",
            tc: "Turks & Caicos Islands",
            tv: "Tuvalu",
            um: "U.S. Outlying Islands",
            vi: "U.S. Virgin Islands",
            ug: "Uganda",
            ua: "Ukraine",
            ae: "United Arab Emirates",
            gb: "United Kingdom",
            us: "United States",
            uy: "Uruguay",
            uz: "Uzbekistan",
            vu: "Vanuatu",
            va: "Vatican City",
            ve: "Venezuela",
            vn: "Vietnam",
            wf: "Wallis & Futuna",
            eh: "Western Sahara",
            ye: "Yemen",
            zm: "Zambia",
            zw: "Zimbabwe"
        };
        // src/js/i18n/en/interface.ts
        var interface_default = {
            selectedCountryAriaLabel: "Selected country",
            noCountrySelected: "No country selected",
            countryListAriaLabel: "List of countries",
            searchPlaceholder: "Search",
            zeroSearchResults: "No results found",
            oneSearchResult: "1 result found",
            multipleSearchResults: "${count} results found",
            // additional countries (not supported by country-list library)
            ac: "Ascension Island",
            xk: "Kosovo"
        };
        // src/js/i18n/en/index.ts
        var en_default = {
            ...countries_default,
            ...interface_default
        };
        // src/js/intl-tel-input.ts
        var id = 0;
        var defaults = {
            //* Whether or not to allow the dropdown.
            allowDropdown: true,
            //* Add a placeholder in the input with an example number for the selected country.
            autoPlaceholder: "polite",
            //* Add a country search input at the top of the dropdown.
            countrySearch: true,
            //* Modify the parentClass.
            containerClass: "",
            //* Modify the auto placeholder.
            customPlaceholder: null,
            //* Append menu to specified element.
            dropdownContainer: null,
            //* Don't display these countries.
            excludeCountries: [],
            //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
            fixDropdownWidth: true,
            //* Format the number as the user types
            formatAsYouType: true,
            //* Format the input value during initialisation and on setNumber.
            formatOnDisplay: true,
            //* geoIp lookup function.
            geoIpLookup: null,
            //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
            hiddenInput: null,
            //* Internationalise the plugin text e.g. search input placeholder, country names.
            i18n: {},
            //* Initial country.
            initialCountry: "",
            //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
            nationalMode: true,
            //* Display only these countries.
            onlyCountries: [],
            //* Number type to use for placeholders.
            placeholderNumberType: "MOBILE",
            //* The countries at the top of the list.
            preferredCountries: [],
            //* Option to hide the flags - must be used with showSelectedDialCode, or allowDropdown=false.
            showFlags: true,
            //* Display the international dial code next to the selected flag.
            showSelectedDialCode: false,
            //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
            strictMode: false,
            //* Use full screen popup instead of dropdown for country list.
            useFullscreenPopup: typeof navigator !== "undefined" && typeof window !== "undefined" ? //* We cannot just test screen size as some smartphones/website meta tags will report desktop resolutions.
            //* Note: to target Android Mobiles (and not Tablets), we must find 'Android' and 'Mobile'
            /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 500 : false,
            //* Specify the path to the libphonenumber script to enable validation/formatting.
            utilsScript: ""
        };
        var regionlessNanpNumbers = [
            "800",
            "822",
            "833",
            "844",
            "855",
            "866",
            "877",
            "880",
            "881",
            "882",
            "883",
            "884",
            "885",
            "886",
            "887",
            "888",
            "889"
        ];
        var getNumeric = (s)=>s.replace(/\D/g, "");
        var normaliseString = (s = "")=>s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        var toggleClass = (el, className, shouldHaveClass)=>{
            if (shouldHaveClass && !el.classList.contains(className)) el.classList.add(className);
            else if (!shouldHaveClass && el.classList.contains(className)) el.classList.remove(className);
        };
        var isRegionlessNanp = (number)=>{
            const numeric = getNumeric(number);
            if (numeric.charAt(0) === "1") {
                const areaCode = numeric.substr(1, 3);
                return regionlessNanpNumbers.indexOf(areaCode) !== -1;
            }
            return false;
        };
        var countryNameSort = (a, b)=>{
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        };
        var translateCursorPosition = (relevantChars, formattedValue, prevCaretPos, isDeleteForwards)=>{
            if (prevCaretPos === 0 && !isDeleteForwards) return 0;
            let count = 0;
            for(let i = 0; i < formattedValue.length; i++){
                if (/[+0-9]/.test(formattedValue[i])) count++;
                if (count === relevantChars && !isDeleteForwards) return i + 1;
                if (isDeleteForwards && count === relevantChars + 1) return i;
            }
            return formattedValue.length;
        };
        var createEl = (name, attrs, container)=>{
            const el = document.createElement(name);
            if (attrs) Object.entries(attrs).forEach(([key, value])=>el.setAttribute(key, value));
            if (container) container.appendChild(el);
            return el;
        };
        var forEachInstance = (method)=>{
            const { instances: instances } = window.intlTelInputGlobals;
            Object.values(instances).forEach((instance)=>instance[method]());
        };
        var Iti = class {
            //* Can't be private as it's called from intlTelInput convenience wrapper.
            id;
            //* NOT Private
            promise;
            //* Private
            telInput;
            activeItem;
            highlightedItem;
            options;
            hadInitialPlaceholder;
            isRTL;
            selectedCountryData;
            countries;
            dialCodeMaxLen;
            dialCodeToIso2Map;
            dialCodes;
            preferredCountries;
            countryContainer;
            selectedCountry;
            selectedCountryInner;
            selectedCountryA11yText;
            selectedDialCode;
            dropdownArrow;
            dropdownContent;
            searchInput;
            searchResultsA11yText;
            countryList;
            dropdown;
            hiddenInput;
            hiddenInputCountry;
            maxCoreNumberLength;
            defaultCountry;
            _handleHiddenInputSubmit;
            _handleLabelClick;
            _handleClickSelectedCountry;
            _handleCountryContainerKeydown;
            _handleInputEvent;
            _handleKeydownEvent;
            _handleWindowScroll;
            _handleMouseoverCountryList;
            _handleClickCountryList;
            _handleClickOffToClose;
            _handleKeydownOnDropdown;
            _handleSearchChange;
            resolveAutoCountryPromise;
            rejectAutoCountryPromise;
            resolveUtilsScriptPromise;
            rejectUtilsScriptPromise;
            constructor(input, customOptions = {}){
                this.id = id++;
                this.telInput = input;
                this.activeItem = null;
                this.highlightedItem = null;
                this.options = Object.assign({}, defaults, customOptions);
                this.hadInitialPlaceholder = Boolean(input.getAttribute("placeholder"));
            }
            //* Can't be private as it's called from intlTelInput convenience wrapper.
            _init() {
                if (this.options.useFullscreenPopup) this.options.fixDropdownWidth = false;
                if (this.options.countrySearch && !this.options.useFullscreenPopup) this.options.fixDropdownWidth = true;
                const forceShowFlags = this.options.allowDropdown && !this.options.showSelectedDialCode;
                if (!this.options.showFlags && forceShowFlags) this.options.showFlags = true;
                if (this.options.useFullscreenPopup && !this.options.dropdownContainer) this.options.dropdownContainer = document.body;
                this.isRTL = !!this.telInput.closest("[dir=rtl]");
                this.options.i18n = {
                    ...en_default,
                    ...this.options.i18n
                };
                const autoCountryPromise = new Promise((resolve, reject)=>{
                    this.resolveAutoCountryPromise = resolve;
                    this.rejectAutoCountryPromise = reject;
                });
                const utilsScriptPromise = new Promise((resolve, reject)=>{
                    this.resolveUtilsScriptPromise = resolve;
                    this.rejectUtilsScriptPromise = reject;
                });
                this.promise = Promise.all([
                    autoCountryPromise,
                    utilsScriptPromise
                ]);
                this.selectedCountryData = {};
                this._processCountryData();
                this._generateMarkup();
                this._setInitialState();
                this._initListeners();
                this._initRequests();
            }
            //********************
            //*  PRIVATE METHODS
            //********************
            //* Prepare all of the country data, including onlyCountries, excludeCountries and preferredCountries options.
            _processCountryData() {
                this._processAllCountries();
                this._processDialCodes();
                this._processPreferredCountries();
                this._translateCountryNames();
                if (this.options.onlyCountries.length || this.options.i18n) this.countries.sort(countryNameSort);
            }
            //* Add a dial code to this.dialCodeToIso2Map.
            _addToDialCodeMap(iso2, dialCode, priority) {
                if (dialCode.length > this.dialCodeMaxLen) this.dialCodeMaxLen = dialCode.length;
                if (!this.dialCodeToIso2Map.hasOwnProperty(dialCode)) this.dialCodeToIso2Map[dialCode] = [];
                for(let i = 0; i < this.dialCodeToIso2Map[dialCode].length; i++){
                    if (this.dialCodeToIso2Map[dialCode][i] === iso2) return;
                }
                const index = priority !== void 0 ? priority : this.dialCodeToIso2Map[dialCode].length;
                this.dialCodeToIso2Map[dialCode][index] = iso2;
            }
            //* Process onlyCountries or excludeCountries array if present.
            _processAllCountries() {
                const { onlyCountries: onlyCountries, excludeCountries: excludeCountries } = this.options;
                if (onlyCountries.length) {
                    const lowerCaseOnlyCountries = onlyCountries.map((country)=>country.toLowerCase());
                    this.countries = data_default.filter((country)=>lowerCaseOnlyCountries.indexOf(country.iso2) > -1);
                } else if (excludeCountries.length) {
                    const lowerCaseExcludeCountries = excludeCountries.map((country)=>country.toLowerCase());
                    this.countries = data_default.filter((country)=>lowerCaseExcludeCountries.indexOf(country.iso2) === -1);
                } else this.countries = data_default;
            }
            //* Translate Countries by object literal provided on config.
            _translateCountryNames() {
                for(let i = 0; i < this.countries.length; i++){
                    const iso2 = this.countries[i].iso2.toLowerCase();
                    if (this.options.i18n.hasOwnProperty(iso2)) this.countries[i].name = this.options.i18n[iso2];
                }
            }
            //* Generate this.dialCodes and this.dialCodeToIso2Map.
            _processDialCodes() {
                this.dialCodes = {};
                this.dialCodeMaxLen = 0;
                this.dialCodeToIso2Map = {};
                for(let i = 0; i < this.countries.length; i++){
                    const c = this.countries[i];
                    if (!this.dialCodes[c.dialCode]) this.dialCodes[c.dialCode] = true;
                    this._addToDialCodeMap(c.iso2, c.dialCode, c.priority);
                }
                for(let i = 0; i < this.countries.length; i++){
                    const c = this.countries[i];
                    if (c.areaCodes) {
                        const rootIso2Code = this.dialCodeToIso2Map[c.dialCode][0];
                        for(let j = 0; j < c.areaCodes.length; j++){
                            const areaCode = c.areaCodes[j];
                            for(let k = 1; k < areaCode.length; k++){
                                const partialDialCode = c.dialCode + areaCode.substr(0, k);
                                this._addToDialCodeMap(rootIso2Code, partialDialCode);
                                this._addToDialCodeMap(c.iso2, partialDialCode);
                            }
                            this._addToDialCodeMap(c.iso2, c.dialCode + areaCode);
                        }
                    }
                }
            }
            //* Process preferred countries - iterate through the preferences, fetching the country data for each one.
            _processPreferredCountries() {
                this.preferredCountries = [];
                for(let i = 0; i < this.options.preferredCountries.length; i++){
                    const iso2 = this.options.preferredCountries[i].toLowerCase();
                    const countryData = this._getCountryData(iso2, true);
                    if (countryData) this.preferredCountries.push(countryData);
                }
            }
            //* Generate all of the markup for the plugin: the selected country overlay, and the dropdown.
            _generateMarkup() {
                this.telInput.classList.add("iti__tel-input");
                if (!this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete"))) this.telInput.setAttribute("autocomplete", "off");
                const { allowDropdown: allowDropdown, showSelectedDialCode: showSelectedDialCode, showFlags: showFlags, containerClass: containerClass, hiddenInput: hiddenInput, dropdownContainer: dropdownContainer, fixDropdownWidth: fixDropdownWidth, useFullscreenPopup: useFullscreenPopup, countrySearch: countrySearch, i18n: i18n } = this.options;
                let parentClass = "iti";
                if (allowDropdown) parentClass += " iti--allow-dropdown";
                if (showSelectedDialCode) parentClass += " iti--show-selected-dial-code";
                if (showFlags) parentClass += " iti--show-flags";
                if (containerClass) parentClass += ` ${containerClass}`;
                if (!useFullscreenPopup) parentClass += " iti--inline-dropdown";
                const wrapper = createEl("div", {
                    class: parentClass
                });
                this.telInput.parentNode?.insertBefore(wrapper, this.telInput);
                if (showFlags || showSelectedDialCode) {
                    this.countryContainer = createEl("div", {
                        class: "iti__country-container"
                    }, wrapper);
                    this.selectedCountry = createEl("button", {
                        type: "button",
                        class: "iti__selected-country",
                        ...allowDropdown && {
                            "aria-expanded": "false",
                            "aria-label": this.options.i18n.selectedCountryAriaLabel,
                            "aria-haspopup": countrySearch ? "true" : "listbox",
                            "aria-controls": countrySearch ? `iti-${this.id}__dropdown-content` : `iti-${this.id}__country-listbox`,
                            ...countrySearch ? {
                                role: "combobox"
                            } : {}
                        }
                    }, this.countryContainer);
                    this.selectedCountryInner = createEl("div", null, this.selectedCountry);
                    this.selectedCountryA11yText = createEl("span", {
                        class: "iti__a11y-text"
                    }, this.selectedCountryInner);
                }
                wrapper.appendChild(this.telInput);
                if (this.selectedCountry && this.telInput.disabled) this.selectedCountry.setAttribute("aria-disabled", "true");
                if (showSelectedDialCode) this.selectedDialCode = createEl("div", {
                    class: "iti__selected-dial-code"
                }, this.selectedCountry);
                if (allowDropdown) {
                    if (!this.telInput.disabled) this.selectedCountry.setAttribute("tabindex", "0");
                    this.dropdownArrow = createEl("div", {
                        class: "iti__arrow",
                        "aria-hidden": "true"
                    }, this.selectedCountry);
                    const extraClasses = fixDropdownWidth ? "" : "iti--flexible-dropdown-width";
                    this.dropdownContent = createEl("div", {
                        id: `iti-${this.id}__dropdown-content`,
                        class: `iti__dropdown-content iti__hide ${extraClasses}`
                    });
                    if (countrySearch) {
                        this.searchInput = createEl("input", {
                            type: "text",
                            class: "iti__search-input",
                            placeholder: i18n.searchPlaceholder,
                            role: "combobox",
                            "aria-expanded": "true",
                            "aria-label": i18n.searchPlaceholder,
                            "aria-controls": `iti-${this.id}__country-listbox`,
                            "aria-autocomplete": "list",
                            "autocomplete": "off"
                        }, this.dropdownContent);
                        this.searchResultsA11yText = createEl("span", {
                            class: "iti__a11y-text"
                        }, this.dropdownContent);
                    }
                    this.countryList = createEl("ul", {
                        class: "iti__country-list",
                        id: `iti-${this.id}__country-listbox`,
                        role: "listbox",
                        "aria-label": i18n.countryListAriaLabel
                    }, this.dropdownContent);
                    if (this.preferredCountries.length && !countrySearch) {
                        this._appendListItems(this.preferredCountries, "iti__preferred", true);
                        createEl("li", {
                            class: "iti__divider",
                            "aria-hidden": "true"
                        }, this.countryList);
                    }
                    this._appendListItems(this.countries, "iti__standard");
                    if (countrySearch) this._updateSearchResultsText();
                    if (dropdownContainer) {
                        let dropdownClasses = "iti iti--container";
                        if (useFullscreenPopup) dropdownClasses += " iti--fullscreen-popup";
                        else dropdownClasses += " iti--inline-dropdown";
                        if (countrySearch) dropdownClasses += " iti--country-search";
                        this.dropdown = createEl("div", {
                            class: dropdownClasses
                        });
                        this.dropdown.appendChild(this.dropdownContent);
                    } else this.countryContainer.appendChild(this.dropdownContent);
                }
                if (hiddenInput) {
                    const telInputName = this.telInput.getAttribute("name") || "";
                    const names = hiddenInput(telInputName);
                    if (names.phone) {
                        this.hiddenInput = createEl("input", {
                            type: "hidden",
                            name: names.phone
                        });
                        wrapper.appendChild(this.hiddenInput);
                    }
                    if (names.country) {
                        this.hiddenInputCountry = createEl("input", {
                            type: "hidden",
                            name: names.country
                        });
                        wrapper.appendChild(this.hiddenInputCountry);
                    }
                }
            }
            //* For each of the passed countries: add a country <li> to the countryList <ul> container.
            _appendListItems(countries, className, preferred) {
                for(let i = 0; i < countries.length; i++){
                    const c = countries[i];
                    const idSuffix = preferred ? "-preferred" : "";
                    const listItem = createEl("li", {
                        id: `iti-${this.id}__item-${c.iso2}${idSuffix}`,
                        class: `iti__country ${className}`,
                        tabindex: "-1",
                        role: "option",
                        "data-dial-code": c.dialCode,
                        "data-country-code": c.iso2,
                        "aria-selected": "false"
                    }, this.countryList);
                    c.nodeById[this.id] = listItem;
                    let content = "";
                    if (this.options.showFlags) content += `<div class='iti__flag-box'><div class='iti__flag iti__${c.iso2}'></div></div>`;
                    content += `<span class='iti__country-name'>${c.name}</span>`;
                    content += `<span class='iti__dial-code'>+${c.dialCode}</span>`;
                    listItem.insertAdjacentHTML("beforeend", content);
                }
            }
            //* Set the initial state of the input value and the selected country by:
            //* 1. Extracting a dial code from the given number
            //* 2. Using explicit initialCountry
            //* 3. Picking the first preferred country
            //* 4. Picking the first country
            _setInitialState(overrideAutoCountry = false) {
                const attributeValue = this.telInput.getAttribute("value");
                const inputValue = this.telInput.value;
                const useAttribute = attributeValue && attributeValue.charAt(0) === "+" && (!inputValue || inputValue.charAt(0) !== "+");
                const val = useAttribute ? attributeValue : inputValue;
                const dialCode = this._getDialCode(val);
                const isRegionlessNanpNumber = isRegionlessNanp(val);
                const { initialCountry: initialCountry } = this.options;
                if (dialCode && !isRegionlessNanpNumber) this._updateCountryFromNumber(val);
                else if (initialCountry !== "auto" || overrideAutoCountry) {
                    const lowerInitialCountry = initialCountry ? initialCountry.toLowerCase() : "";
                    const isValidInitialCountry = lowerInitialCountry && this._getCountryData(lowerInitialCountry, true);
                    if (isValidInitialCountry) this._setCountry(lowerInitialCountry);
                    else if (dialCode && isRegionlessNanpNumber) this._setCountry("us");
                    else this._setCountry();
                }
                if (val) this._updateValFromNumber(val);
            }
            //* Initialise the main event listeners: input keyup, and click selected country.
            _initListeners() {
                this._initTelInputListeners();
                if (this.options.allowDropdown) this._initDropdownListeners();
                if ((this.hiddenInput || this.hiddenInputCountry) && this.telInput.form) this._initHiddenInputListener();
            }
            //* Update hidden input on form submit.
            _initHiddenInputListener() {
                this._handleHiddenInputSubmit = ()=>{
                    if (this.hiddenInput) this.hiddenInput.value = this.getNumber();
                    if (this.hiddenInputCountry) this.hiddenInputCountry.value = this.getSelectedCountryData().iso2 || "";
                };
                this.telInput.form?.addEventListener("submit", this._handleHiddenInputSubmit);
            }
            //* initialise the dropdown listeners.
            _initDropdownListeners() {
                this._handleLabelClick = (e)=>{
                    if (this.dropdownContent.classList.contains("iti__hide")) this.telInput.focus();
                    else e.preventDefault();
                };
                const label = this.telInput.closest("label");
                if (label) label.addEventListener("click", this._handleLabelClick);
                this._handleClickSelectedCountry = ()=>{
                    if (this.dropdownContent.classList.contains("iti__hide") && !this.telInput.disabled && !this.telInput.readOnly) this._openDropdown();
                };
                this.selectedCountry.addEventListener("click", this._handleClickSelectedCountry);
                this._handleCountryContainerKeydown = (e)=>{
                    const isDropdownHidden = this.dropdownContent.classList.contains("iti__hide");
                    if (isDropdownHidden && [
                        "ArrowUp",
                        "ArrowDown",
                        " ",
                        "Enter"
                    ].includes(e.key)) {
                        e.preventDefault();
                        e.stopPropagation();
                        this._openDropdown();
                    }
                    if (e.key === "Tab") this._closeDropdown();
                };
                this.countryContainer.addEventListener("keydown", this._handleCountryContainerKeydown);
            }
            //* Init many requests: utils script / geo ip lookup.
            _initRequests() {
                if (this.options.utilsScript && !window.intlTelInputUtils) {
                    if (window.intlTelInputGlobals.documentReady()) window.intlTelInputGlobals.loadUtils(this.options.utilsScript);
                    else window.addEventListener("load", ()=>{
                        window.intlTelInputGlobals.loadUtils(this.options.utilsScript);
                    });
                } else this.resolveUtilsScriptPromise();
                if (this.options.initialCountry === "auto" && !this.selectedCountryData.iso2) this._loadAutoCountry();
                else this.resolveAutoCountryPromise();
            }
            //* Perform the geo ip lookup.
            _loadAutoCountry() {
                if (window.intlTelInputGlobals.autoCountry) this.handleAutoCountry();
                else if (!window.intlTelInputGlobals.startedLoadingAutoCountry) {
                    window.intlTelInputGlobals.startedLoadingAutoCountry = true;
                    if (typeof this.options.geoIpLookup === "function") this.options.geoIpLookup((iso2 = "")=>{
                        const iso2Lower = iso2.toLowerCase();
                        const isValidIso2 = iso2Lower && this._getCountryData(iso2Lower, true);
                        if (isValidIso2) {
                            window.intlTelInputGlobals.autoCountry = iso2Lower;
                            setTimeout(()=>forEachInstance("handleAutoCountry"));
                        } else {
                            this._setInitialState(true);
                            forEachInstance("rejectAutoCountryPromise");
                        }
                    }, ()=>{
                        this._setInitialState(true);
                        forEachInstance("rejectAutoCountryPromise");
                    });
                }
            }
            //* Initialize the tel input listeners.
            _initTelInputListeners() {
                const { strictMode: strictMode, formatAsYouType: formatAsYouType } = this.options;
                let userOverrideFormatting = false;
                this._handleInputEvent = (e)=>{
                    if (this._updateCountryFromNumber(this.telInput.value)) this._triggerCountryChange();
                    const isFormattingChar = e && e.data && /[^+0-9]/.test(e.data);
                    const isPaste = e && e.inputType === "insertFromPaste" && this.telInput.value;
                    if (isFormattingChar || isPaste && !strictMode) userOverrideFormatting = true;
                    else if (!/[^+0-9]/.test(this.telInput.value)) userOverrideFormatting = false;
                    if (formatAsYouType && !userOverrideFormatting) {
                        const currentCaretPos = this.telInput.selectionStart || 0;
                        const valueBeforeCaret = this.telInput.value.substring(0, currentCaretPos);
                        const relevantCharsBeforeCaret = valueBeforeCaret.replace(/[^+0-9]/g, "").length;
                        const isDeleteForwards = e && e.inputType === "deleteContentForward";
                        const formattedValue = this._formatNumberAsYouType();
                        const newCaretPos = translateCursorPosition(relevantCharsBeforeCaret, formattedValue, currentCaretPos, isDeleteForwards);
                        this.telInput.value = formattedValue;
                        this.telInput.setSelectionRange(newCaretPos, newCaretPos);
                    }
                };
                this.telInput.addEventListener("input", this._handleInputEvent);
                if (strictMode) {
                    this._handleKeydownEvent = (e)=>{
                        if (e.key && e.key.length === 1 && !e.altKey && !e.ctrlKey && !e.metaKey) {
                            const isInitialPlus = this.telInput.selectionStart === 0 && e.key === "+";
                            const isNumeric = /^[0-9]$/.test(e.key);
                            const isAllowedChar = isInitialPlus || isNumeric;
                            const fullNumber = this._getFullNumber();
                            const coreNumber = window.intlTelInputUtils.getCoreNumber(fullNumber, this.selectedCountryData.iso2);
                            const hasReachedMaxLength = this.maxCoreNumberLength && coreNumber.length >= this.maxCoreNumberLength;
                            if (!isAllowedChar || hasReachedMaxLength) e.preventDefault();
                        }
                    };
                    this.telInput.addEventListener("keydown", this._handleKeydownEvent);
                }
            }
            //* Adhere to the input's maxlength attr.
            _cap(number) {
                const max = parseInt(this.telInput.getAttribute("maxlength") || "", 10);
                return max && number.length > max ? number.substr(0, max) : number;
            }
            //* Trigger a custom event on the input.
            _trigger(name) {
                const e = new Event(name, {
                    bubbles: true,
                    cancelable: true
                });
                this.telInput.dispatchEvent(e);
            }
            //* Open the dropdown.
            _openDropdown() {
                const { fixDropdownWidth: fixDropdownWidth, countrySearch: countrySearch } = this.options;
                if (fixDropdownWidth) this.dropdownContent.style.width = `${this.telInput.offsetWidth}px`;
                this.dropdownContent.classList.remove("iti__hide");
                this.selectedCountry.setAttribute("aria-expanded", "true");
                this._setDropdownPosition();
                if (this.activeItem && !countrySearch) {
                    this._highlightListItem(this.activeItem, false);
                    this._scrollTo(this.activeItem, true);
                } else {
                    const firstCountryItem = this.countryList.firstElementChild;
                    if (firstCountryItem) {
                        this._highlightListItem(firstCountryItem, false);
                        this.countryList.scrollTop = 0;
                    }
                    if (countrySearch) this.searchInput.focus();
                }
                this._bindDropdownListeners();
                this.dropdownArrow.classList.add("iti__arrow--up");
                this._trigger("open:countrydropdown");
            }
            //* Decide if should position dropdown above or below input (depends on position within viewport, and scroll).
            _setDropdownPosition() {
                if (this.options.dropdownContainer) this.options.dropdownContainer.appendChild(this.dropdown);
                if (!this.options.useFullscreenPopup) {
                    const inputPosRelativeToVP = this.telInput.getBoundingClientRect();
                    const scrollTop = document.documentElement.scrollTop;
                    const inputTopAbsolute = inputPosRelativeToVP.top + scrollTop;
                    const inputHeight = this.telInput.offsetHeight;
                    const dropdownHeight = this.dropdownContent.offsetHeight;
                    const dropdownFitsBelow = inputTopAbsolute + inputHeight + dropdownHeight < scrollTop + window.innerHeight;
                    const dropdownFitsAbove = inputTopAbsolute - dropdownHeight > scrollTop;
                    const positionDropdownAboveInput = !this.options.countrySearch && !dropdownFitsBelow && dropdownFitsAbove;
                    toggleClass(this.dropdownContent, "iti__dropdown-content--dropup", positionDropdownAboveInput);
                    if (this.options.dropdownContainer) {
                        const extraTop = positionDropdownAboveInput ? 0 : inputHeight;
                        this.dropdown.style.top = `${inputPosRelativeToVP.top + extraTop}px`;
                        this.dropdown.style.left = `${inputPosRelativeToVP.left}px`;
                        this._handleWindowScroll = ()=>this._closeDropdown();
                        window.addEventListener("scroll", this._handleWindowScroll);
                    }
                }
            }
            //* We only bind dropdown listeners when the dropdown is open.
            _bindDropdownListeners() {
                this._handleMouseoverCountryList = (e)=>{
                    const listItem = e.target?.closest(".iti__country");
                    if (listItem) this._highlightListItem(listItem, false);
                };
                this.countryList.addEventListener("mouseover", this._handleMouseoverCountryList);
                this._handleClickCountryList = (e)=>{
                    const listItem = e.target?.closest(".iti__country");
                    if (listItem) this._selectListItem(listItem);
                };
                this.countryList.addEventListener("click", this._handleClickCountryList);
                let isOpening = true;
                this._handleClickOffToClose = ()=>{
                    if (!isOpening) this._closeDropdown();
                    isOpening = false;
                };
                document.documentElement.addEventListener("click", this._handleClickOffToClose);
                let query = "";
                let queryTimer = null;
                this._handleKeydownOnDropdown = (e)=>{
                    if ([
                        "ArrowUp",
                        "ArrowDown",
                        "Enter",
                        "Escape"
                    ].includes(e.key)) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") this._handleUpDownKey(e.key);
                        else if (e.key === "Enter") this._handleEnterKey();
                        else if (e.key === "Escape") this._closeDropdown();
                    }
                    if (!this.options.countrySearch && /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(e.key)) {
                        e.stopPropagation();
                        if (queryTimer) clearTimeout(queryTimer);
                        query += e.key.toLowerCase();
                        this._searchForCountry(query);
                        queryTimer = setTimeout(()=>{
                            query = "";
                        }, 1e3);
                    }
                };
                document.addEventListener("keydown", this._handleKeydownOnDropdown);
                if (this.options.countrySearch) {
                    const doFilter = ()=>{
                        const inputQuery = this.searchInput.value.trim();
                        if (inputQuery) this._filterCountries(inputQuery);
                        else this._filterCountries("", true);
                    };
                    let keyupTimer = null;
                    this._handleSearchChange = ()=>{
                        if (keyupTimer) clearTimeout(keyupTimer);
                        keyupTimer = setTimeout(()=>{
                            doFilter();
                            keyupTimer = null;
                        }, 100);
                    };
                    this.searchInput.addEventListener("input", this._handleSearchChange);
                    this.searchInput.addEventListener("click", (e)=>e.stopPropagation());
                }
            }
            _filterCountries(query, isReset = false) {
                let isFirst = true;
                this.countryList.innerHTML = "";
                const normalisedQuery = normaliseString(query);
                for(let i = 0; i < this.countries.length; i++){
                    const c = this.countries[i];
                    const normalisedCountryName = normaliseString(c.name);
                    const fullDialCode = `+${c.dialCode}`;
                    if (isReset || normalisedCountryName.includes(normalisedQuery) || fullDialCode.includes(normalisedQuery) || c.iso2.includes(normalisedQuery)) {
                        const listItem = c.nodeById[this.id];
                        if (listItem) this.countryList.appendChild(listItem);
                        if (isFirst) {
                            this._highlightListItem(listItem, false);
                            isFirst = false;
                        }
                    }
                }
                this.countryList.scrollTop = 0;
                this._updateSearchResultsText();
            }
            //* Update search results text (for a11y).
            _updateSearchResultsText() {
                const { i18n: i18n } = this.options;
                const count = this.countryList.childElementCount;
                let searchText;
                if (count === 0) searchText = i18n.zeroSearchResults;
                else if (count === 1) searchText = i18n.oneSearchResult;
                else searchText = i18n.multipleSearchResults.replace("${count}", count.toString());
                this.searchResultsA11yText.textContent = searchText;
            }
            //* Highlight the next/prev item in the list (and ensure it is visible).
            _handleUpDownKey(key) {
                let next = key === "ArrowUp" ? this.highlightedItem?.previousElementSibling : this.highlightedItem?.nextElementSibling;
                if (next) {
                    if (next.classList.contains("iti__divider")) next = key === "ArrowUp" ? next.previousElementSibling : next.nextElementSibling;
                } else if (this.countryList.childElementCount > 1) next = key === "ArrowUp" ? this.countryList.lastElementChild : this.countryList.firstElementChild;
                if (next) {
                    this._scrollTo(next, false);
                    const doFocus = !this.options.countrySearch;
                    this._highlightListItem(next, doFocus);
                }
            }
            //* Select the currently highlighted item.
            _handleEnterKey() {
                if (this.highlightedItem) this._selectListItem(this.highlightedItem);
            }
            //* Find the first list item whose name starts with the query string.
            _searchForCountry(query) {
                for(let i = 0; i < this.countries.length; i++){
                    const c = this.countries[i];
                    const startsWith = c.name.substr(0, query.length).toLowerCase() === query;
                    if (startsWith) {
                        const listItem = c.nodeById[this.id];
                        this._highlightListItem(listItem, false);
                        this._scrollTo(listItem, true);
                        break;
                    }
                }
            }
            //* Update the input's value to the given val (format first if possible)
            //* NOTE: this is called from _setInitialState, handleUtils and setNumber.
            _updateValFromNumber(fullNumber) {
                let number = fullNumber;
                if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
                    const useNational = this.options.nationalMode || number.charAt(0) !== "+" && !this.options.showSelectedDialCode;
                    const { NATIONAL: NATIONAL, INTERNATIONAL: INTERNATIONAL } = window.intlTelInputUtils.numberFormat;
                    const format = useNational ? NATIONAL : INTERNATIONAL;
                    number = window.intlTelInputUtils.formatNumber(number, this.selectedCountryData.iso2, format);
                }
                number = this._beforeSetNumber(number);
                this.telInput.value = number;
            }
            //* Check if need to select a new country based on the given number
            //* Note: called from _setInitialState, keyup handler, setNumber.
            _updateCountryFromNumber(fullNumber) {
                const plusIndex = fullNumber.indexOf("+");
                let number = plusIndex ? fullNumber.substring(plusIndex) : fullNumber;
                const selectedDialCode = this.selectedCountryData.dialCode;
                const isNanp = selectedDialCode === "1";
                if (number && isNanp && number.charAt(0) !== "+") {
                    if (number.charAt(0) !== "1") number = `1${number}`;
                    number = `+${number}`;
                }
                if (this.options.showSelectedDialCode && selectedDialCode && number.charAt(0) !== "+") number = `+${selectedDialCode}${number}`;
                const dialCode = this._getDialCode(number, true);
                const numeric = getNumeric(number);
                let iso2 = null;
                if (dialCode) {
                    const iso2Codes = this.dialCodeToIso2Map[getNumeric(dialCode)];
                    const alreadySelected = iso2Codes.indexOf(this.selectedCountryData.iso2) !== -1 && numeric.length <= dialCode.length - 1;
                    const isRegionlessNanpNumber = selectedDialCode === "1" && isRegionlessNanp(numeric);
                    if (!isRegionlessNanpNumber && !alreadySelected) {
                        for(let j = 0; j < iso2Codes.length; j++)if (iso2Codes[j]) {
                            iso2 = iso2Codes[j];
                            break;
                        }
                    }
                } else if (number.charAt(0) === "+" && numeric.length) iso2 = "";
                else if ((!number || number === "+") && !this.selectedCountryData.iso2) iso2 = this.defaultCountry;
                if (iso2 !== null) return this._setCountry(iso2);
                return false;
            }
            //* Remove highlighting from other list items and highlight the given item.
            _highlightListItem(listItem, shouldFocus) {
                const prevItem = this.highlightedItem;
                if (prevItem) {
                    prevItem.classList.remove("iti__highlight");
                    prevItem.setAttribute("aria-selected", "false");
                }
                this.highlightedItem = listItem;
                this.highlightedItem.classList.add("iti__highlight");
                this.highlightedItem.setAttribute("aria-selected", "true");
                this.selectedCountry.setAttribute("aria-activedescendant", listItem.getAttribute("id") || "");
                if (this.options.countrySearch) this.searchInput.setAttribute("aria-activedescendant", listItem.getAttribute("id") || "");
                if (shouldFocus) this.highlightedItem.focus();
            }
            //* Find the country data for the given iso2 code
            //* the ignoreOnlyCountriesOption is only used during init() while parsing the onlyCountries array
            _getCountryData(iso2, allowFail) {
                for(let i = 0; i < this.countries.length; i++){
                    if (this.countries[i].iso2 === iso2) return this.countries[i];
                }
                if (allowFail) return null;
                throw new Error(`No country data for '${iso2}'`);
            }
            //* Update the selected country, dial code (if showSelectedDialCode), placeholder, title, and active list item.
            //* Note: called from _setInitialState, _updateCountryFromNumber, _selectListItem, setCountry.
            _setCountry(iso2) {
                const { allowDropdown: allowDropdown, showSelectedDialCode: showSelectedDialCode, showFlags: showFlags, countrySearch: countrySearch, i18n: i18n } = this.options;
                const prevCountry = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
                this.selectedCountryData = iso2 ? this._getCountryData(iso2, false) || {} : {};
                if (this.selectedCountryData.iso2) this.defaultCountry = this.selectedCountryData.iso2;
                if (this.selectedCountryInner) {
                    let flagClass = "";
                    let a11yText = "";
                    if (iso2) {
                        if (showFlags) {
                            flagClass = `iti__flag iti__${iso2}`;
                            a11yText = `${this.selectedCountryData.name} +${this.selectedCountryData.dialCode}`;
                        }
                    } else {
                        flagClass = "iti__flag iti__globe";
                        a11yText = i18n.noCountrySelected;
                    }
                    this.selectedCountryInner.className = flagClass;
                    this.selectedCountryA11yText.textContent = a11yText;
                }
                this._setSelectedCountryTitleAttribute(iso2, showSelectedDialCode);
                if (showSelectedDialCode) {
                    const dialCode = this.selectedCountryData.dialCode ? `+${this.selectedCountryData.dialCode}` : "";
                    this.selectedDialCode.innerHTML = dialCode;
                    const selectedCountryWidth = this.selectedCountry.offsetWidth || this._getHiddenSelectedCountryWidth();
                    if (this.isRTL) this.telInput.style.paddingRight = `${selectedCountryWidth + 6}px`;
                    else this.telInput.style.paddingLeft = `${selectedCountryWidth + 6}px`;
                }
                this._updatePlaceholder();
                this._updateMaxLength();
                if (allowDropdown && !countrySearch) {
                    const prevItem = this.activeItem;
                    if (prevItem) {
                        prevItem.classList.remove("iti__active");
                        prevItem.setAttribute("aria-selected", "false");
                    }
                    if (iso2) {
                        const nextItem = this.countryList.querySelector(`#iti-${this.id}__item-${iso2}-preferred`) || this.countryList.querySelector(`#iti-${this.id}__item-${iso2}`);
                        if (nextItem) {
                            nextItem.setAttribute("aria-selected", "true");
                            nextItem.classList.add("iti__active");
                            this.activeItem = nextItem;
                        }
                    }
                }
                return prevCountry.iso2 !== iso2;
            }
            //* Update the maximum valid number length for the currently selected country.
            _updateMaxLength() {
                if (this.options.strictMode && window.intlTelInputUtils) {
                    if (this.selectedCountryData.iso2) {
                        const numberType = window.intlTelInputUtils.numberType[this.options.placeholderNumberType];
                        let exampleNumber = window.intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, false, numberType, true);
                        let validNumber = exampleNumber;
                        while(window.intlTelInputUtils.isPossibleNumber(exampleNumber, this.selectedCountryData.iso2)){
                            validNumber = exampleNumber;
                            exampleNumber += "0";
                        }
                        const coreNumber = window.intlTelInputUtils.getCoreNumber(validNumber, this.selectedCountryData.iso2);
                        this.maxCoreNumberLength = coreNumber.length;
                    } else this.maxCoreNumberLength = null;
                }
            }
            _setSelectedCountryTitleAttribute(iso2 = null, showSelectedDialCode) {
                if (!this.selectedCountry) return;
                let title;
                if (iso2 && !showSelectedDialCode) title = `${this.selectedCountryData.name}: +${this.selectedCountryData.dialCode}`;
                else if (iso2) title = this.selectedCountryData.name;
                else title = "Unknown";
                this.selectedCountry.setAttribute("title", title);
            }
            //* When the input is in a hidden container during initialisation, we must inject some markup
            //* into the end of the DOM to calculate the correct offsetWidth.
            //* NOTE: this is only used when showSelectedDialCode is enabled, so countryContainer and selectedCountry
            //* will definitely exist.
            _getHiddenSelectedCountryWidth() {
                if (this.telInput.parentNode) {
                    const containerClone = this.telInput.parentNode.cloneNode(false);
                    containerClone.style.visibility = "hidden";
                    document.body.appendChild(containerClone);
                    const countryContainerClone = this.countryContainer.cloneNode();
                    containerClone.appendChild(countryContainerClone);
                    const selectedCountryClone = this.selectedCountry.cloneNode(true);
                    countryContainerClone.appendChild(selectedCountryClone);
                    const width = selectedCountryClone.offsetWidth;
                    document.body.removeChild(containerClone);
                    return width;
                }
                return 0;
            }
            //* Update the input placeholder to an example number from the currently selected country.
            _updatePlaceholder() {
                const { autoPlaceholder: autoPlaceholder, placeholderNumberType: placeholderNumberType, nationalMode: nationalMode, customPlaceholder: customPlaceholder } = this.options;
                const shouldSetPlaceholder = autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && autoPlaceholder === "polite";
                if (window.intlTelInputUtils && shouldSetPlaceholder) {
                    const numberType = window.intlTelInputUtils.numberType[placeholderNumberType];
                    let placeholder = this.selectedCountryData.iso2 ? window.intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, nationalMode, numberType) : "";
                    placeholder = this._beforeSetNumber(placeholder);
                    if (typeof customPlaceholder === "function") placeholder = customPlaceholder(placeholder, this.selectedCountryData);
                    this.telInput.setAttribute("placeholder", placeholder);
                }
            }
            //* Called when the user selects a list item from the dropdown.
            _selectListItem(listItem) {
                const countryChanged = this._setCountry(listItem.getAttribute("data-country-code"));
                this._closeDropdown();
                this._updateDialCode(listItem.getAttribute("data-dial-code"));
                this.telInput.focus();
                if (countryChanged) this._triggerCountryChange();
            }
            //* Close the dropdown and unbind any listeners.
            _closeDropdown() {
                this.dropdownContent.classList.add("iti__hide");
                this.selectedCountry.setAttribute("aria-expanded", "false");
                this.selectedCountry.removeAttribute("aria-activedescendant");
                if (this.highlightedItem) this.highlightedItem.setAttribute("aria-selected", "false");
                if (this.options.countrySearch) this.searchInput.removeAttribute("aria-activedescendant");
                this.dropdownArrow.classList.remove("iti__arrow--up");
                document.removeEventListener("keydown", this._handleKeydownOnDropdown);
                if (this.options.countrySearch) this.searchInput.removeEventListener("input", this._handleSearchChange);
                document.documentElement.removeEventListener("click", this._handleClickOffToClose);
                this.countryList.removeEventListener("mouseover", this._handleMouseoverCountryList);
                this.countryList.removeEventListener("click", this._handleClickCountryList);
                if (this.options.dropdownContainer) {
                    if (!this.options.useFullscreenPopup) window.removeEventListener("scroll", this._handleWindowScroll);
                    if (this.dropdown.parentNode) this.dropdown.parentNode.removeChild(this.dropdown);
                }
                this._trigger("close:countrydropdown");
            }
            //* Check if an element is visible within it's container, else scroll until it is.
            _scrollTo(element, middle) {
                const container = this.countryList;
                const scrollTop = document.documentElement.scrollTop;
                const containerHeight = container.offsetHeight;
                const containerTop = container.getBoundingClientRect().top + scrollTop;
                const containerBottom = containerTop + containerHeight;
                const elementHeight = element.offsetHeight;
                const elementTop = element.getBoundingClientRect().top + scrollTop;
                const elementBottom = elementTop + elementHeight;
                let newScrollTop = elementTop - containerTop + container.scrollTop;
                const middleOffset = containerHeight / 2 - elementHeight / 2;
                if (elementTop < containerTop) {
                    if (middle) newScrollTop -= middleOffset;
                    container.scrollTop = newScrollTop;
                } else if (elementBottom > containerBottom) {
                    if (middle) newScrollTop += middleOffset;
                    const heightDifference = containerHeight - elementHeight;
                    container.scrollTop = newScrollTop - heightDifference;
                }
            }
            //* Replace any existing dial code with the new one
            //* Note: called from _selectListItem and setCountry
            _updateDialCode(newDialCodeBare) {
                const inputVal = this.telInput.value;
                const newDialCode = `+${newDialCodeBare}`;
                let newNumber;
                if (inputVal.charAt(0) === "+") {
                    const prevDialCode = this._getDialCode(inputVal);
                    if (prevDialCode) newNumber = inputVal.replace(prevDialCode, newDialCode);
                    else newNumber = newDialCode;
                    this.telInput.value = newNumber;
                }
            }
            //* Try and extract a valid international dial code from a full telephone number.
            //* Note: returns the raw string inc plus character and any whitespace/dots etc.
            _getDialCode(number, includeAreaCode) {
                let dialCode = "";
                if (number.charAt(0) === "+") {
                    let numericChars = "";
                    for(let i = 0; i < number.length; i++){
                        const c = number.charAt(i);
                        if (!isNaN(parseInt(c, 10))) {
                            numericChars += c;
                            if (includeAreaCode) {
                                if (this.dialCodeToIso2Map[numericChars]) dialCode = number.substr(0, i + 1);
                            } else if (this.dialCodes[numericChars]) {
                                dialCode = number.substr(0, i + 1);
                                break;
                            }
                            if (numericChars.length === this.dialCodeMaxLen) break;
                        }
                    }
                }
                return dialCode;
            }
            //* Get the input val, adding the dial code if showSelectedDialCode is enabled.
            _getFullNumber() {
                const val = this.telInput.value.trim();
                const { dialCode: dialCode } = this.selectedCountryData;
                let prefix;
                const numericVal = getNumeric(val);
                if (this.options.showSelectedDialCode && !this.options.nationalMode && val.charAt(0) !== "+" && dialCode && numericVal) prefix = `+${dialCode}`;
                else prefix = "";
                return prefix + val;
            }
            //* Remove the dial code if showSelectedDialCode is enabled also cap the length if the input has a maxlength attribute
            _beforeSetNumber(fullNumber) {
                let number = fullNumber;
                if (this.options.showSelectedDialCode) {
                    let dialCode = this._getDialCode(number);
                    if (dialCode) {
                        dialCode = `+${this.selectedCountryData.dialCode}`;
                        const start = number[dialCode.length] === " " || number[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
                        number = number.substr(start);
                    }
                }
                return this._cap(number);
            }
            //* Trigger the 'countrychange' event.
            _triggerCountryChange() {
                this._trigger("countrychange");
            }
            //* Format the number as the user types.
            _formatNumberAsYouType() {
                const val = this._getFullNumber();
                const result = window.intlTelInputUtils ? window.intlTelInputUtils.formatNumberAsYouType(val, this.selectedCountryData.iso2) : val;
                const { dialCode: dialCode } = this.selectedCountryData;
                if (this.options.showSelectedDialCode && !this.options.nationalMode && this.telInput.value.charAt(0) !== "+" && result.includes(`+${dialCode}`)) {
                    const afterDialCode = result.split(`+${dialCode}`)[1] || "";
                    return afterDialCode.trim();
                }
                return result;
            }
            //**************************
            //*  SECRET PUBLIC METHODS
            //**************************
            //* This is called when the geoip call returns.
            handleAutoCountry() {
                if (this.options.initialCountry === "auto" && window.intlTelInputGlobals.autoCountry) {
                    this.defaultCountry = window.intlTelInputGlobals.autoCountry;
                    if (!this.telInput.value) this.setCountry(this.defaultCountry);
                    this.resolveAutoCountryPromise();
                }
            }
            //* This is called when the utils request completes.
            handleUtils() {
                if (window.intlTelInputUtils) {
                    if (this.telInput.value) this._updateValFromNumber(this.telInput.value);
                    if (this.selectedCountryData.iso2) {
                        this._updatePlaceholder();
                        this._updateMaxLength();
                    }
                }
                this.resolveUtilsScriptPromise();
            }
            //********************
            //*  PUBLIC METHODS
            //********************
            //* Remove plugin.
            destroy() {
                if (this.options.allowDropdown) {
                    this._closeDropdown();
                    this.selectedCountry.removeEventListener("click", this._handleClickSelectedCountry);
                    this.countryContainer.removeEventListener("keydown", this._handleCountryContainerKeydown);
                    const label = this.telInput.closest("label");
                    if (label) label.removeEventListener("click", this._handleLabelClick);
                }
                const { form: form } = this.telInput;
                if (this._handleHiddenInputSubmit && form) form.removeEventListener("submit", this._handleHiddenInputSubmit);
                this.telInput.removeEventListener("input", this._handleInputEvent);
                if (this._handleKeydownEvent) this.telInput.removeEventListener("keydown", this._handleKeydownEvent);
                this.telInput.removeAttribute("data-intl-tel-input-id");
                const wrapper = this.telInput.parentNode;
                wrapper?.parentNode?.insertBefore(this.telInput, wrapper);
                wrapper?.parentNode?.removeChild(wrapper);
                delete window.intlTelInputGlobals.instances[this.id];
            }
            //* Get the extension from the current number.
            getExtension() {
                if (window.intlTelInputUtils) return window.intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2);
                return "";
            }
            //* Format the number to the given format.
            getNumber(format) {
                if (window.intlTelInputUtils) {
                    const { iso2: iso2 } = this.selectedCountryData;
                    return window.intlTelInputUtils.formatNumber(this._getFullNumber(), iso2, format);
                }
                return "";
            }
            //* Get the type of the entered number e.g. landline/mobile.
            getNumberType() {
                if (window.intlTelInputUtils) return window.intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2);
                return -99;
            }
            //* Get the country data for the currently selected country.
            getSelectedCountryData() {
                return this.selectedCountryData;
            }
            //* Get the validation error.
            getValidationError() {
                if (window.intlTelInputUtils) {
                    const { iso2: iso2 } = this.selectedCountryData;
                    return window.intlTelInputUtils.getValidationError(this._getFullNumber(), iso2);
                }
                return -99;
            }
            //* Validate the input val - assumes the global function isPossibleNumber (from utilsScript).
            isValidNumber(mobileOnly = true) {
                const val = this._getFullNumber();
                if (/\p{L}/u.test(val)) return false;
                return window.intlTelInputUtils ? window.intlTelInputUtils.isPossibleNumber(val, this.selectedCountryData.iso2, mobileOnly) : null;
            }
            //* Validate the input val (precise) - assumes the global function isValidNumber (from utilsScript).
            isValidNumberPrecise() {
                const val = this._getFullNumber();
                if (/\p{L}/u.test(val)) return false;
                return window.intlTelInputUtils ? window.intlTelInputUtils.isValidNumber(val, this.selectedCountryData.iso2) : null;
            }
            //* Update the selected country, and update the input val accordingly.
            setCountry(iso2) {
                const iso2Lower = iso2.toLowerCase();
                if (this.selectedCountryData.iso2 !== iso2Lower) {
                    this._setCountry(iso2Lower);
                    this._updateDialCode(this.selectedCountryData.dialCode);
                    this._triggerCountryChange();
                }
            }
            //* Set the input value and update the country.
            setNumber(number) {
                const countryChanged = this._updateCountryFromNumber(number);
                this._updateValFromNumber(number);
                if (countryChanged) this._triggerCountryChange();
            }
            //* Set the placeholder number typ
            setPlaceholderNumberType(type) {
                this.options.placeholderNumberType = type;
                this._updatePlaceholder();
            }
        };
        var injectScript = (path, handleSuccess, handleFailure)=>{
            const script = document.createElement("script");
            script.onload = ()=>{
                forEachInstance("handleUtils");
                if (handleSuccess) handleSuccess();
            };
            script.onerror = ()=>{
                forEachInstance("rejectUtilsScriptPromise");
                if (handleFailure) handleFailure();
            };
            script.className = "iti-load-utils";
            script.async = true;
            script.src = path;
            document.body.appendChild(script);
        };
        var loadUtils = (path)=>{
            if (!window.intlTelInputUtils && !window.intlTelInputGlobals.startedLoadingUtilsScript) {
                window.intlTelInputGlobals.startedLoadingUtilsScript = true;
                return new Promise((resolve, reject)=>injectScript(path, resolve, reject));
            }
            return null;
        };
        if (typeof window === "object" && !window.intlTelInputGlobals) {
            const intlTelInputGlobals = {
                defaults: defaults,
                //* Using a global like this allows us to mock it in the tests.
                documentReady: ()=>document.readyState === "complete",
                //* Get the country data object.
                getCountryData: ()=>data_default,
                //* A getter for the plugin instance.
                getInstance: (input)=>{
                    const id2 = input.getAttribute("data-intl-tel-input-id");
                    return id2 ? intlTelInputGlobals.instances[id2] : null;
                },
                //* A map from instance ID to instance object.
                instances: {},
                loadUtils: loadUtils,
                version: "21.2.8"
            };
            window.intlTelInputGlobals = intlTelInputGlobals;
        }
        var intlTelInput = (input, options)=>{
            const iti = new Iti(input, options);
            iti._init();
            input.setAttribute("data-intl-tel-input-id", iti.id.toString());
            window.intlTelInputGlobals.instances[iti.id] = iti;
            return iti;
        };
        var intl_tel_input_default = intlTelInput;
        return __toCommonJS(intl_tel_input_exports);
    })();
    // UMD
    return factoryOutput.default;
});



var $2e7bde4cc392dbaa$var$formIntlTelInput = {
    /**
   * Init
   *
   * @param {object} target
   *
   * @returns {void}
   */ init: async function(target) {
        window.itiInstances = {};
        const utilsScript = await (parcelRequire("av3Vx"));
        target.querySelectorAll("[data-init-IntlTelInput]").forEach(function(element) {
            if (typeof window.intlTelInput === "undefined") window.intlTelInput = $880ccf6cc429821e$exports;
            const elementIdentifier = $2e7bde4cc392dbaa$var$formIntlTelInput.generateId();
            element.setAttribute("data-iti-id", elementIdentifier);
            window.itiInstances[elementIdentifier] = window.intlTelInput(element, {
                autoPlaceholder: "aggressive",
                initialCountry: "nl",
                placeholderNumberType: "FIXED_LINE",
                preferredCountries: [
                    "nl",
                    "be",
                    "de",
                    "gb",
                    "lu"
                ],
                utilsScript: utilsScript
            });
        });
    },
    /**
   * Generate unique ID
   *
   * @returns {string}
   */ generateId: function() {
        return "iti-" + Math.random().toString(36).substring(2, 20);
    }
};
var $2e7bde4cc392dbaa$export$2e2bcd8739ae039 = $2e7bde4cc392dbaa$var$formIntlTelInput;



var $dac0a50539495737$var$keyboardShortcuts = {
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function() {
        var elements = document.querySelectorAll("[data-keyboard-shortcut]");
        var key;
        if (typeof elements !== "undefined") document.addEventListener("keyup", function(event) {
            for (let [index, element] of Object.entries(elements)){
                key = elements[index].getAttribute("data-keyboard-shortcut") || null;
                if (key !== null) {
                    if (event.ctrlKey && event.altKey && event.shiftKey && event.code === "Key" + key) {
                        var clickEvent = new Event("click");
                        element.dispatchEvent(clickEvent);
                    }
                }
            }
        });
    }
};
var $dac0a50539495737$export$2e2bcd8739ae039 = $dac0a50539495737$var$keyboardShortcuts;





const $db34121f0e960780$var$modal = {
    /**
   * Initialisseer de modal functie
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        // Bind permission buttons met changePermission function
        target.addEventListener("click", function(event) {
            if (event.target.matches("[data-toggle=content-modal], [data-toggle-content-modal]")) {
                event.preventDefault();
                $db34121f0e960780$var$modal.getModal(event);
            }
        });
    },
    /**
   * Toon en verberg modal
   *
   * @param {object} event
   * @return {void}
   */ getModal: function(event) {
        // Verkrijg modal in DOM
        var m = $("#generalModal");
        // Verberg de huidige content in de modal
        m.find(".modal-title").addClass("d-none");
        m.find(".modal-spinner").removeClass("d-none");
        m.find(".modal-body").addClass("d-none");
        // Verkrijg target elements uit DOM
        var target = $(event.target);
        // Verkrijg data uit event
        var param1 = target.attr("data-content-modal-param1");
        var param2 = target.attr("data-content-modal-param2");
        var title = target.attr("data-content-modal-title");
        var errorMessage = target.attr("data-content-modal-error-message") || "Er ging iets mis, probeer het later nogmaals";
        var contentContainerTarget = target.attr("data-content-modal-content-target");
        var content;
        // Verberg titel van modal in DOM als er geen titel gedefineerd is
        m.find(".modal-title").html(title);
        if (typeof title == "undefined" || title == "") m.find(".modal-title").addClass("d-none");
        // Verberg altijd de footer van de modal
        m.find(".modal-footer").addClass("d-none");
        // Gebruik de data id om content met AJAX  te laden of vul de modal met content uit de dom
        if (typeof param1 != "undefined" && param1 != "") {
            // Verkrijg de sub id uit de DOM en pas deze toe
            if (typeof param2 == "undefined" || param2 == "") param2 = "";
            // Verkrijg de link uit de DOM en pas deze toe
            var path = target.attr("data-content-modal-path");
            if (typeof path == "undefined" || path == "") path = "data";
            // Verkrijg het formaat van de modal uit de DOM en pas deze toe
            var size = target.attr("data-content-modal-size");
            if (typeof size != "undefined" && size != "") {
                size = "modal-" + size;
                m.find(".modal-dialog").removeClass("modal-sm").addClass(size);
            }
            // Verkrijg de data URL uit de DOM en verkrijg de data met AJAS
            var url = window.app.url;
            var urlFull = url + path + "/" + param1 + "/" + param2;
            $.get(urlFull, function(data) {
                if (data != "false" && data != "") content = data;
                // Toon de content in de modal
                m.find(".modal-body").html(content).hide().removeClass("d-none").fadeIn(200);
                m.find(".modal-spinner").addClass("d-none");
                m.find(".modal-title").hide().removeClass("d-none").fadeIn(200);
                // Init eventuele form elementen
                let formElement = m.find(".modal-body form");
                if (formElement.length) {
                    (0, $46c3b49fce744198$export$2e2bcd8739ae039).init(m.find(".modal-body form"));
                    (0, $4ee4564850efd542$export$2e2bcd8739ae039).init(m.find(".modal-body form"));
                    (0, $cbba02f95b4e7e13$export$2e2bcd8739ae039).init(m.find(".modal-body form"));
                }
            });
        } else {
            // Vul de modal met de content uit de DOM of geef een foutmelding
            content = $(contentContainerTarget).html();
            if (typeof content == "undefined" || content == "") content = errorMessage;
            // Toon de content in de modal
            m.find(".modal-body").html(content).removeClass("d-none").fadeIn(200);
            m.find(".modal-spinner").addClass("d-none");
            m.find(".modal-title").removeClass("d-none").fadeIn(200);
        }
        // Toon de modal
        var bootstrapModal = new bootstrap.Modal(m);
        bootstrapModal.show();
    }
};
var $db34121f0e960780$export$2e2bcd8739ae039 = $db34121f0e960780$var$modal;


var $77bea213b9b26e33$var$selectMultiple = {
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        $(target).find("[data-select-multiple]").on("change", function(e) {
            $77bea213b9b26e33$var$selectMultiple.setValue(e);
        });
        $77bea213b9b26e33$var$selectMultiple.initValue("[data-select-multiple]");
    },
    /** Functie die op basis van de waarde van de multi select in losse inputs zet  */ setValue: function(e) {
        var values = $(e.target).val();
        var name = $(e.target).attr("name") || $(e.target).attr("data-original-name");
        $(e.target).attr("data-original-name", name).removeAttr("name");
        $('[data-select-multiple-group="' + name + '"]').remove();
        $.each(values, function(index) {
            var input = document.createElement("input");
            input.name = name + "[]";
            input.value = values[index];
            input.setAttribute("data-select-multiple-group", name);
            input.setAttribute("type", "hidden");
            $(e.target).parent()[0].appendChild(input);
        });
    },
    /** Functie die de waarden van de multiple select toepast  */ initValue: function(target) {
        $(target).each(function() {
            var values = $(this).data("select-multiple");
            $(this).val(values).trigger("change");
        });
    }
};
var $77bea213b9b26e33$export$2e2bcd8739ae039 = $77bea213b9b26e33$var$selectMultiple;


var $e3d067c130f35958$var$permission = {
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        /**
     * Bind permission buttons met changePermission function
     */ $(target).find("[data-permission-key] a.btn").on("click", function(e) {
            $e3d067c130f35958$var$permission.changePermission(e);
        });
        /**
     * Bind permission buttons met changePermissionGroup function
     */ $(target).find("[data-permission-group] a.btn[data-permission-group-val]").on("click", function(e) {
            $e3d067c130f35958$var$permission.changePermissionGroup(e);
        });
    },
    /**
   * Functie die de complete set met permissies geset in de DOM als JSON teruggeeft
   *
   * @param {object}
   * @returns {string}
   */ getPermissionGroupJson: function(group) {
        var permissionArray = {};
        $(group).find("[data-permission-key]").each(function() {
            var key = $(this).data("permission-key");
            var val = $(this).parent().find("a.active").data("permission-val");
            permissionArray[key] = val;
        });
        var permissionJson = JSON.stringify(permissionArray);
        return permissionJson;
    },
    /**
   * Functie die de permission JSON in de DOM in texareas opslaat
   *
   * @returns {void}
   */ setPermissionToDOM: function() {
        $("[data-permission-group]").each(function() {
            var group = $(this);
            var textarea = $(this).find("textarea");
            var permissionJSON = $e3d067c130f35958$var$permission.getPermissionGroupJson(group);
            textarea.val(permissionJSON);
        });
    },
    /**
   * Functie voor het veranderen van een individuele permissie met een update van de json in het permission veld in de DOM
   *
   * @param {object} e
   * @returns {void}
   */ changePermission: function(e) {
        $(e.target).parent().find("a").removeClass("active");
        $(e.target).addClass("active");
        $e3d067c130f35958$var$permission.setPermissionToDOM();
    },
    /**
   * Functie om de permissie van een groep te wijzigen
   *
   * @param {object} e
   * @returns {void}
   */ changePermissionGroup: function(e) {
        var parentButton = $(e.target);
        var parentGroup = $(e.target).closest("[data-permission-group]");
        var childButtons = $(e.target).closest("[data-permission-group").find("a");
        childButtons.removeClass("active");
        parentButton.addClass("active");
        var value = parentButton.data("permission-group-val");
        parentGroup.find("[data-permission-val=" + value + "]").addClass("active");
        $e3d067c130f35958$var$permission.setPermissionToDOM();
    }
};
var $e3d067c130f35958$export$2e2bcd8739ae039 = $e3d067c130f35958$var$permission;


var $efdf6815285cb677$var$radioToggle = {
    /**
   * Init de radioToggle functies
   *
   * @param {object} target
   *
   * @returns {void}
   */ init: function(target) {
        $efdf6815285cb677$var$radioToggle.initFunctions(target);
        $efdf6815285cb677$var$radioToggle.initEvents(target);
    },
    /**
   * Init de radioToggle functies
   *
   * @param {object} target
   *
   * @returns {void}
   */ initFunctions: function(target) {
        var toggleRadioElements = target.querySelectorAll("[data-radio-target-toggle-select]");
        toggleRadioElements.forEach(function(element) {
            $efdf6815285cb677$var$radioToggle.toggleTargetRadio(element);
        });
    },
    /**
   * Init de radioToggle events
   *
   * @returns {void}
   */ initEvents: function() {
        document.addEventListener("change", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches("[data-radio-target-toggle-select]")) {
                $efdf6815285cb677$var$radioToggle.toggleTargetRadio(event.target);
                break;
            }
        }, false);
    },
    /**
   * Toon of verberg elementen opgegeven in data attribute
   *
   * @param {object} element
   * @returns {void}
   */ toggleTargetRadio: function(element) {
        if (element.checked) {
            let target = element.getAttribute("data-radio-target-toggle-select");
            let targetElement = document.querySelector(target);
            targetElement.value = element.value;
        }
    }
};
var $efdf6815285cb677$export$2e2bcd8739ae039 = $efdf6815285cb677$var$radioToggle;


var $a62691fe6134b0e6$var$redirect = {
    /**
   * Initialize redirect functionality by handling redirect elements in the target
   * Looks for elements with data-redirect-url attribute
   *
   * @param {HTMLElement} target - The DOM element to search for redirect elements
   * @returns {void}
   */ init: function(target) {
        $a62691fe6134b0e6$var$redirect.handleRedirectElement(target);
    },
    /**
   * Finds redirect elements and extracts their parameters to trigger redirection
   * Looks for data-redirect-url, data-redirect-enabled and data-redirect-delay attributes
   *
   * @param {HTMLElement} target - The DOM element to search for redirect elements
   * @returns {void}
   */ handleRedirectElement: function(target) {
        var elements = target.querySelectorAll("[data-redirect-url]");
        if (elements.length > 1) console.warn("Multiple redirect elements found. Only the first one will be processed.");
        if (typeof elements[0] !== "undefined" && elements[0] !== null) {
            var link = elements[0].getAttribute("data-redirect-url");
            var enabled = elements[0].getAttribute("data-redirect-enabled") || 1;
            var delay = elements[0].getAttribute("data-redirect-delay") || 0;
            if (link && link.trim() !== "") $a62691fe6134b0e6$var$redirect.gotoUrl(link, enabled, delay);
        }
    },
    /**
   * Redirects the browser to a specified URL after an optional delay
   * Only redirects if enabled parameter evaluates to true
   *
   * @param {string} link - The URL to redirect to
   * @param {string|number|boolean} enabled - Whether the redirect should occur. Defaults to 1
   * @param {string|number} delay - Delay in milliseconds before redirect occurs. Defaults to 0
   * @returns {void}
   */ gotoUrl: function(link, enabled = 1, delay = 0) {
        if (typeof enabled !== "undefined" && enabled !== false) {
            if (parseInt(enabled) == 1 || enabled == true) window.setTimeout(function() {
                window.location.href = link;
            }, delay);
        }
    }
};
var $a62691fe6134b0e6$export$2e2bcd8739ae039 = $a62691fe6134b0e6$var$redirect;



var $655a329fece5bd81$var$selectSearch = {
    init: function() {
        if (typeof jQuery.fn.select2 === "function") jQuery(".select2-general, .select2-multiple").select2({
            theme: "bootstrap-5"
        });
    }
};
var $655a329fece5bd81$export$2e2bcd8739ae039 = $655a329fece5bd81$var$selectSearch;








var $7FBkt = parcelRequire("7FBkt");



const $d879645a047cc454$var$selectToggle = {
    /**
   * Init de selectToggle functies
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        window.app.domStateReady(function() {
            $d879645a047cc454$var$selectToggle.initFunctions(target);
            $d879645a047cc454$var$selectToggle.initEvents();
        });
    },
    /**
   * Init de selectToggle functies
   *
   * @param {object} target
   * @returns {void}
   */ initFunctions: function(target) {
        if (target !== null) {
            var toggleVisibilityElements = target[0].querySelectorAll("[data-select-target-toggle-visibility]");
            toggleVisibilityElements.forEach(function(element) {
                $d879645a047cc454$var$selectToggle.toggleTargetVisibility(element);
            });
            var toggleReadonlyElements = target[0].querySelectorAll("[data-select-target-toggle-readonly]");
            toggleReadonlyElements.forEach(function(element) {
                $d879645a047cc454$var$selectToggle.toggleTargetReadonly(element);
            });
            var toggleDisabledElements = target[0].querySelectorAll("[data-select-target-toggle-disabled]");
            toggleDisabledElements.forEach(function(element) {
                $d879645a047cc454$var$selectToggle.toggleTargetDisabled(element);
            });
            var toggleValueElements = target[0].querySelectorAll("[data-select-target-toggle-value]");
            toggleValueElements.forEach(function(element) {
                $d879645a047cc454$var$selectToggle.toggleTargetValue(element);
            });
            var toggleAttributeElements = target[0].querySelectorAll("[data-select-target-toggle-attribute]");
            toggleAttributeElements.forEach(function(element) {
                $d879645a047cc454$var$selectToggle.toggleTargetAttribute(element);
            });
            var toggleHtmlElements = target[0].querySelectorAll("[data-select-target-toggle-html]");
            toggleHtmlElements.forEach(function(element) {
                $d879645a047cc454$var$selectToggle.toggleTargetHTML(element);
            });
        }
    },
    /**
   * Init de selectToggle events
   *
   * @returns {void}
   */ initEvents: function() {
        var body = document.body;
        body.addEventListener("change", (event)=>{
            var target = event.target;
            if (target.hasAttribute("data-select-target-toggle-visibility")) $d879645a047cc454$var$selectToggle.toggleTargetVisibility(target);
            if (target.hasAttribute("data-select-target-toggle-disabled")) $d879645a047cc454$var$selectToggle.toggleTargetDisabled(target);
            if (target.hasAttribute("data-select-target-toggle-readonly")) $d879645a047cc454$var$selectToggle.toggleTargetReadonly(target);
            if (target.hasAttribute("data-select-target-toggle-value")) $d879645a047cc454$var$selectToggle.toggleTargetValue(target);
            if (target.hasAttribute("data-select-target-toggle-attribute")) $d879645a047cc454$var$selectToggle.toggleTargetAttribute(target);
            if (target.hasAttribute("data-select-target-toggle-html")) $d879645a047cc454$var$selectToggle.toggleTargetHTML(target);
        });
    },
    /**
   * Toon of verberg elementen opgegeven in data attribute
   *
   * @param {object} element
   * @returns {void}
   */ toggleTargetVisibility: function(element) {
        var selectedOption = element.options[element.selectedIndex] || false;
        if (selectedOption !== false) {
            var targetString = selectedOption.getAttribute("data-toggle-visibility-target") || false;
            var targetArray = JSON.parse("[" + targetString + "]");
            if (targetString !== false) for(var i = 0; i < targetArray.length; i++){
                var target = targetArray[i][0] || false;
                var state = targetArray[i][1] || false;
                var required = true;
                if (typeof targetArray[i][2] !== "undefined") required = targetArray[i][2];
                var targetElements = document.querySelectorAll(target);
                var targetElement = document.querySelectorAll(target)[0];
                if (typeof targetElement !== "undefined") {
                    if ($d879645a047cc454$var$selectToggle.isFormElement(targetElement)) $d879645a047cc454$var$selectToggle.toggleFormGroup(targetElement, state, required);
                    else $d879645a047cc454$var$selectToggle.toggleElementVisibility(targetElements, state);
                }
            }
        }
    },
    /**
   * Toon of verberg elementen opgegeven in data attribute
   *
   * @param {object} element
   * @returns {void}
   */ toggleTargetDisabled: function(element) {
        var selectedOption = element.options[element.selectedIndex] || false;
        var targetString = selectedOption.getAttribute("data-toggle-disabled-target") || false;
        var targetArray = JSON.parse("[" + targetString + "]");
        if (targetString !== false) for(var i = 0; i < targetArray.length; i++){
            var target = targetArray[i][0] || false;
            var state = targetArray[i][1] || false;
            var targetElements = document.querySelectorAll(target);
            if (typeof targetElements !== "undefined") targetElements.forEach(function(targetElement) {
                targetElement.removeAttribute("disabled");
                if (state == "disabled") {
                    targetElement.setAttribute("disabled", true);
                    if (targetElement.parentNode.nodeName == "SELECT") targetElement.parentNode.value = "";
                }
            });
        }
    },
    /**
   * Toon of verberg elementen opgegeven in data attribute
   *
   * @param {object} element
   * @returns {void}
   */ toggleTargetReadonly: function(element) {
        var selectedOption = element.options[element.selectedIndex] || false;
        if (selectedOption !== false) {
            var targetString = selectedOption.getAttribute("data-toggle-readonly-target") || false;
            var targetArray = JSON.parse("[" + targetString + "]");
            if (targetString !== false) for(var i = 0; i < targetArray.length; i++){
                var target = targetArray[i][0] || false;
                var state = targetArray[i][1] || false;
                var targetElement = document.querySelectorAll(target)[0];
                if (typeof targetElement !== "undefined") {
                    targetElement.removeAttribute("readonly");
                    if (state == "readonly") {
                        targetElement.setAttribute("readonly", true);
                        if (targetElement.parentNode.nodeName == "SELECT") targetElement.parentNode.value = "";
                    }
                }
            }
        }
    },
    /**
   * Toon of verberg elementen opgegeven in data attribute
   *
   * @param {object} element
   * @returns {void}
   */ toggleTargetValue: function(element) {
        var selectedOption = element.options[element.selectedIndex] || false;
        if (selectedOption !== false) {
            var targetString = selectedOption.getAttribute("data-toggle-value-target") || false;
            var targetArray = JSON.parse("[" + targetString + "]");
            if (targetString !== false) for(var i = 0; i < targetArray.length; i++){
                var target = targetArray[i][0] || false;
                var value = targetArray[i][1] || "";
                var targetElement = document.querySelectorAll(target)[0];
                if (typeof targetElement !== "undefined") targetElement.value = value;
            }
        }
    },
    /**
   * Toon of verberg elementen opgegeven in data attribute
   *
   * @param {object} element
   * @param {string} target
   * @param {bool} required
   * @param {bool} reset
   * @returns {void}
   */ toggleFormGroup: function(element, state, required, reset = false) {
        var target = element.closest(".form-group");
        target.classList.add("d-none");
        element.setAttribute("disabled", "true");
        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(element);
        if (reset == true) element.value = "";
        if (state == "visible") {
            target.classList.remove("d-none");
            element.removeAttribute("disabled");
            if (required) (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(element);
        }
    },
    /**
   * Toon of verberg elementen opgegeven in data attribute
   *
   * @param {object} element
   * @param {string} target
   * @returns {void}
   */ toggleTargetHTML: function(target) {
        var targetElementName = target.getAttribute("data-select-target-toggle-html-target") || null;
        var targetElement = document.querySelector(targetElementName);
        var vars = target.options[target.selectedIndex].value;
        var group = target.closest(".form-group");
        var form = target.closest("form");
        var spinner = group.querySelector("[data-form-group-spinner]");
        if (typeof vars !== "undefined" && vars !== "") {
            target.setAttribute("disabled", true);
            spinner.classList.remove("d-none");
            var dataPath = window.app.ajaxPath + target.getAttribute("data-select-target-toggle-html-path") + vars;
            (0, $7FBkt.default).send("GET", dataPath, function(data) {
                targetElement.innerHTML = data;
                (0, $48f23611b62cf521$export$2e2bcd8739ae039).initFilepond(form);
                setTimeout(function() {
                    (0, $ab808cb1ff637aca$export$2e2bcd8739ae039).init(form);
                    (0, $46c3b49fce744198$export$2e2bcd8739ae039).init(form.parentElement);
                    (0, $4ee4564850efd542$export$2e2bcd8739ae039).init();
                    (0, $cbba02f95b4e7e13$export$2e2bcd8739ae039).initBlurEvent(form.parentElement);
                    (0, $2e7bde4cc392dbaa$export$2e2bcd8739ae039).init(form);
                    (0, $92a9257e94e58e2f$export$2e2bcd8739ae039).init(form);
                    spinner.classList.add("d-none");
                    target.removeAttribute("disabled");
                }, 100);
            });
        } else targetElement.innerHTML = "";
    },
    /**
   * Set data attribute van element
   *
   * @param {object} element
   * @returns {void}
   */ toggleTargetAttribute: function(element) {
        var selectedOption = element.options[element.selectedIndex] || false;
        var targetString = selectedOption.getAttribute("data-toggle-attribute-target") || false;
        var targetArray = JSON.parse("[" + targetString + "]");
        if (targetString !== false) for(var i = 0; i < targetArray.length; i++){
            var target = targetArray[i][0] || false;
            var attribute = targetArray[i][1] || "";
            var value = targetArray[i][2] || "";
            var targetElement = document.querySelectorAll(target)[0];
            if (typeof targetElement !== "undefined") targetElement.setAttribute(attribute, value);
        }
    },
    /**
   * Toon of verberg elementen opgegeven in data attribute
   *
   * @param {object} element
   * @param {string} target
   * @returns {void}
   */ toggleElementVisibility: function(elements, state) {
        elements.forEach(function(element) {
            element.classList.add("d-none");
            if (state == "visible") element.classList.remove("d-none");
        });
    },
    /**
   * Check of element een form element betreft
   *
   * @param {object} element
   * @param {string} target
   * @returns {void}
   */ isFormElement: function(element) {
        var isFormElement = false;
        if (element.nodeName == "INPUT" || element.nodeName == "SELECT") isFormElement = true;
        return isFormElement;
    }
};
var $d879645a047cc454$export$2e2bcd8739ae039 = $d879645a047cc454$var$selectToggle;



var $8cff758c33a8b62b$var$loading = {
    /**
   * Initializes loading behavior for forms with data-loading-message attribute
   *
   * Finds all forms with data-loading-message attribute within the target element
   * and sets up loading behavior for each form. The loading behavior shows a modal
   * with a loading message when the form is submitted.
   *
   * @param {HTMLElement} [target=document.body] - The root element to search for forms
   *
   * @returns {void}
   */ init: function(target = document.body) {
        target.querySelectorAll("form[data-loading-message]").forEach((form)=>{
            this.handleFormLoadingBehavior(form);
        });
    },
    /**
   * Handles the loading behavior for a form
   * Shows a loading modal when the form is submitted or validation succeeds
   *
   * @param {HTMLFormElement} form - The form element to handle loading behavior for
   *
   * @returns {void}
   */ handleFormLoadingBehavior: function(form) {
        const loadingMessage = form.getAttribute("data-loading-message");
        if (form.hasAttribute("data-loading-message")) document.addEventListener("validationSuccess", ()=>{
            $8cff758c33a8b62b$var$loading.showLoadingModal(loadingMessage);
        });
        else form.addEventListener("submit", (event)=>{
            setTimeout(()=>{
                if (!event.defaultPrevented) $8cff758c33a8b62b$var$loading.showLoadingModal(loadingMessage);
            }, 500);
        });
    },
    /**
   * Shows a loading modal with a custom message
   *
   * Creates and displays a Bootstrap modal that cannot be dismissed by the user.
   * The modal shows a loading message and prevents interaction with the page
   * while an action is being processed.
   *
   * @param {string} loadingMessage - The message to display in the loading modal
   *
   * @returns {void}
   */ showLoadingModal: function(loadingMessage) {
        document.getElementById("loadingMessageModal").innerHTML = loadingMessage;
        var loadingModal = document.getElementById("loadingModal");
        var bootstrapModal = new bootstrap.Modal(loadingModal, {
            keyboard: false,
            backdrop: "static"
        });
        bootstrapModal.show();
    }
};
var $8cff758c33a8b62b$export$2e2bcd8739ae039 = $8cff758c33a8b62b$var$loading;


var $56fd38b9f11fa9d4$var$testValue = {
    /**
   * Init event listeners
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        if (window.app.environment !== "live") document.addEventListener("keyup", function(event) {
            if (event.ctrlKey && event.altKey && event.shiftKey && event.code === "KeyT" || event.altKey && event.shiftKey && event.code === "KeyY" || event.altKey && event.shiftKey && event.code === "KeyT") $56fd38b9f11fa9d4$var$testValue.applyTestValues(target);
        });
    },
    /**
   * Functie om test values toe te passen op velden
   *
   * @param {object} target
   * @returns {void}
   */ applyTestValues: function(target) {
        target.querySelectorAll("[data-test-values]").forEach((el)=>{
            try {
                const values = JSON.parse(el.getAttribute("data-test-values"));
                el.value = values[Math.floor(Math.random() * values.length)];
                el.dispatchEvent(new CustomEvent("blur"));
            } catch (e) {
                if (e instanceof SyntaxError) console.warn("Invalid JSON in data-test-values attribute:", e);
                else console.warn("Error applying test value:", e);
            }
        });
    }
};
var $56fd38b9f11fa9d4$export$2e2bcd8739ae039 = $56fd38b9f11fa9d4$var$testValue;


var $bb3670d9c3a88333$var$toggleDisabled = {
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        /** Bind toggle disabled aan data-toggle-disabled attribute  */ if (target.querySelector("[data-toggle-disabled]")) target.querySelector("[data-toggle-disabled]").addEventListener("change", function() {
            if (this.getAttribute("data-toggle-disabled") != "") {
                var target = this.getAttribute("data-toggle-disabled");
                $bb3670d9c3a88333$var$toggleDisabled.toggleDisabled(target);
            }
        });
    },
    /** Toggle disabled function  */ toggleDisabled: function(t) {
        if (document.querySelector(t)) {
            var target = document.querySelector(t);
            if (target.hasAttribute("disabled")) target.removeAttribute("disabled");
            else target.setAttribute("disabled", "true");
        }
    }
};
var $bb3670d9c3a88333$export$2e2bcd8739ae039 = $bb3670d9c3a88333$var$toggleDisabled;


var $877044f68a9a3cdb$var$togglePasswordVisibility = {
    /**
   * Init
   *
   * @param {object} target
   * @returns {void}
   */ init: function(target) {
        const elements = target.querySelectorAll("[data-toggle-password]");
        elements.forEach(function(element) {
            /* Password field naar textveld converteren op basis van data-toggle-password attribute */ const showPassword = function() {
                const prevElement = this.previousElementSibling;
                if (prevElement) prevElement.type = "text";
            };
            /* Textfield naar password field converteren op basis van data-toggle-password attribute  */ const hidePassword = function() {
                const prevElement = this.previousElementSibling;
                if (prevElement) prevElement.type = "password";
            };
            /* Event listeners for desktop (mousedown/mouseup) */ element.addEventListener("mousedown", showPassword);
            element.addEventListener("mouseup", hidePassword);
            element.addEventListener("mouseleave", hidePassword);
            /* Event listeners for mobile (touchstart/touchend) */ element.addEventListener("touchstart", showPassword);
            element.addEventListener("touchend", hidePassword);
        });
    }
};
var $877044f68a9a3cdb$export$2e2bcd8739ae039 = $877044f68a9a3cdb$var$togglePasswordVisibility;


var $eb5bb415b70a23f4$exports = {};







/*!
  * Bootstrap tooltip.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $eb5bb415b70a23f4$exports = factory((parcelRequire("i9Aqn")), (parcelRequire("heTgs")), (parcelRequire("1GheJ")), (parcelRequire("kRRoH")), (parcelRequire("94df5")), (parcelRequire("16soP")), (parcelRequire("2VzTm")));
})($eb5bb415b70a23f4$exports, function(Popper, BaseComponent, EventHandler, Manipulator, index_js, sanitizer_js, TemplateFactory) {
    "use strict";
    function _interopNamespaceDefault(e) {
        const n = Object.create(null, {
            [Symbol.toStringTag]: {
                value: "Module"
            }
        });
        if (e) {
            for(const k in e)if (k !== "default") {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: ()=>e[k]
                });
            }
        }
        n.default = e;
        return Object.freeze(n);
    }
    const Popper__namespace = /*#__PURE__*/ _interopNamespaceDefault(Popper);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tooltip.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = "tooltip";
    const DISALLOWED_ATTRIBUTES = new Set([
        "sanitize",
        "allowList",
        "sanitizeFn"
    ]);
    const CLASS_NAME_FADE = "fade";
    const CLASS_NAME_MODAL = "modal";
    const CLASS_NAME_SHOW = "show";
    const SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
    const SELECTOR_MODAL = `.${CLASS_NAME_MODAL}`;
    const EVENT_MODAL_HIDE = "hide.bs.modal";
    const TRIGGER_HOVER = "hover";
    const TRIGGER_FOCUS = "focus";
    const TRIGGER_CLICK = "click";
    const TRIGGER_MANUAL = "manual";
    const EVENT_HIDE = "hide";
    const EVENT_HIDDEN = "hidden";
    const EVENT_SHOW = "show";
    const EVENT_SHOWN = "shown";
    const EVENT_INSERTED = "inserted";
    const EVENT_CLICK = "click";
    const EVENT_FOCUSIN = "focusin";
    const EVENT_FOCUSOUT = "focusout";
    const EVENT_MOUSEENTER = "mouseenter";
    const EVENT_MOUSELEAVE = "mouseleave";
    const AttachmentMap = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: index_js.isRTL() ? "left" : "right",
        BOTTOM: "bottom",
        LEFT: index_js.isRTL() ? "right" : "left"
    };
    const Default = {
        allowList: sanitizer_js.DefaultAllowlist,
        animation: true,
        boundary: "clippingParents",
        container: false,
        customClass: "",
        delay: 0,
        fallbackPlacements: [
            "top",
            "right",
            "bottom",
            "left"
        ],
        html: false,
        offset: [
            0,
            6
        ],
        placement: "top",
        popperConfig: null,
        sanitize: true,
        sanitizeFn: null,
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title: "",
        trigger: "hover focus"
    };
    const DefaultType = {
        allowList: "object",
        animation: "boolean",
        boundary: "(string|element)",
        container: "(string|element|boolean)",
        customClass: "(string|function)",
        delay: "(number|object)",
        fallbackPlacements: "array",
        html: "boolean",
        offset: "(array|string|function)",
        placement: "(string|function)",
        popperConfig: "(null|object|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        selector: "(string|boolean)",
        template: "string",
        title: "(string|element|function)",
        trigger: "string"
    };
    /**
   * Class definition
   */ class Tooltip extends BaseComponent {
        constructor(element, config){
            if (typeof Popper__namespace === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
            super(element, config);
            // Private
            this._isEnabled = true;
            this._timeout = 0;
            this._isHovered = null;
            this._activeTrigger = {};
            this._popper = null;
            this._templateFactory = null;
            this._newContent = null;
            // Protected
            this.tip = null;
            this._setListeners();
            if (!this._config.selector) this._fixTitle();
        }
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        enable() {
            this._isEnabled = true;
        }
        disable() {
            this._isEnabled = false;
        }
        toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        }
        toggle() {
            if (!this._isEnabled) return;
            this._activeTrigger.click = !this._activeTrigger.click;
            if (this._isShown()) {
                this._leave();
                return;
            }
            this._enter();
        }
        dispose() {
            clearTimeout(this._timeout);
            EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
            if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
            this._disposePopper();
            super.dispose();
        }
        show() {
            if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
            if (!(this._isWithContent() && this._isEnabled)) return;
            const showEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOW));
            const shadowRoot = index_js.findShadowRoot(this._element);
            const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
            if (showEvent.defaultPrevented || !isInTheDom) return;
            // TODO: v6 remove this or make it optional
            this._disposePopper();
            const tip = this._getTipElement();
            this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
            const { container: container } = this._config;
            if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                container.append(tip);
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_INSERTED));
            }
            this._popper = this._createPopper(tip);
            tip.classList.add(CLASS_NAME_SHOW);
            // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.on(element, "mouseover", index_js.noop);
            const complete = ()=>{
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOWN));
                if (this._isHovered === false) this._leave();
                this._isHovered = false;
            };
            this._queueCallback(complete, this.tip, this._isAnimated());
        }
        hide() {
            if (!this._isShown()) return;
            const hideEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDE));
            if (hideEvent.defaultPrevented) return;
            const tip = this._getTipElement();
            tip.classList.remove(CLASS_NAME_SHOW);
            // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, "mouseover", index_js.noop);
            this._activeTrigger[TRIGGER_CLICK] = false;
            this._activeTrigger[TRIGGER_FOCUS] = false;
            this._activeTrigger[TRIGGER_HOVER] = false;
            this._isHovered = null; // it is a trick to support manual triggering
            const complete = ()=>{
                if (this._isWithActiveTrigger()) return;
                if (!this._isHovered) this._disposePopper();
                this._element.removeAttribute("aria-describedby");
                EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDDEN));
            };
            this._queueCallback(complete, this.tip, this._isAnimated());
        }
        update() {
            if (this._popper) this._popper.update();
        }
        // Protected
        _isWithContent() {
            return Boolean(this._getTitle());
        }
        _getTipElement() {
            if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
            return this.tip;
        }
        _createTipElement(content) {
            const tip = this._getTemplateFactory(content).toHtml();
            // TODO: remove this check in v6
            if (!tip) return null;
            tip.classList.remove(CLASS_NAME_FADE, CLASS_NAME_SHOW);
            // TODO: v6 the following can be achieved with CSS only
            tip.classList.add(`bs-${this.constructor.NAME}-auto`);
            const tipId = index_js.getUID(this.constructor.NAME).toString();
            tip.setAttribute("id", tipId);
            if (this._isAnimated()) tip.classList.add(CLASS_NAME_FADE);
            return tip;
        }
        setContent(content) {
            this._newContent = content;
            if (this._isShown()) {
                this._disposePopper();
                this.show();
            }
        }
        _getTemplateFactory(content) {
            if (this._templateFactory) this._templateFactory.changeContent(content);
            else this._templateFactory = new TemplateFactory({
                ...this._config,
                content: // the `content` var has to be after `this._config`
                // to override config.content in case of popover
                content,
                extraClass: this._resolvePossibleFunction(this._config.customClass)
            });
            return this._templateFactory;
        }
        _getContentForTemplate() {
            return {
                [SELECTOR_TOOLTIP_INNER]: this._getTitle()
            };
        }
        _getTitle() {
            return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
        }
        // Private
        _initializeOnDelegatedTarget(event) {
            return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
        }
        _isAnimated() {
            return this._config.animation || this.tip && this.tip.classList.contains(CLASS_NAME_FADE);
        }
        _isShown() {
            return this.tip && this.tip.classList.contains(CLASS_NAME_SHOW);
        }
        _createPopper(tip) {
            const placement = index_js.execute(this._config.placement, [
                this,
                tip,
                this._element
            ]);
            const attachment = AttachmentMap[placement.toUpperCase()];
            return Popper__namespace.createPopper(this._element, tip, this._getPopperConfig(attachment));
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
            if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _resolvePossibleFunction(arg) {
            return index_js.execute(arg, [
                this._element
            ]);
        }
        _getPopperConfig(attachment) {
            const defaultBsPopperConfig = {
                placement: attachment,
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            fallbackPlacements: this._config.fallbackPlacements
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "arrow",
                        options: {
                            element: `.${this.constructor.NAME}-arrow`
                        }
                    },
                    {
                        name: "preSetPlacement",
                        enabled: true,
                        phase: "beforeMain",
                        fn: (data)=>{
                            // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                            // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                            this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                        }
                    }
                ]
            };
            return {
                ...defaultBsPopperConfig,
                ...index_js.execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ])
            };
        }
        _setListeners() {
            const triggers = this._config.trigger.split(" ");
            for (const trigger of triggers){
                if (trigger === "click") EventHandler.on(this._element, this.constructor.eventName(EVENT_CLICK), this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context.toggle();
                });
                else if (trigger !== TRIGGER_MANUAL) {
                    const eventIn = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSEENTER) : this.constructor.eventName(EVENT_FOCUSIN);
                    const eventOut = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSELEAVE) : this.constructor.eventName(EVENT_FOCUSOUT);
                    EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                        const context = this._initializeOnDelegatedTarget(event);
                        context._activeTrigger[event.type === "focusin" ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
                        context._enter();
                    });
                    EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                        const context = this._initializeOnDelegatedTarget(event);
                        context._activeTrigger[event.type === "focusout" ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                        context._leave();
                    });
                }
            }
            this._hideModalHandler = ()=>{
                if (this._element) this.hide();
            };
            EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
        }
        _fixTitle() {
            const title = this._element.getAttribute("title");
            if (!title) return;
            if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
            this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
            this._element.removeAttribute("title");
        }
        _enter() {
            if (this._isShown() || this._isHovered) {
                this._isHovered = true;
                return;
            }
            this._isHovered = true;
            this._setTimeout(()=>{
                if (this._isHovered) this.show();
            }, this._config.delay.show);
        }
        _leave() {
            if (this._isWithActiveTrigger()) return;
            this._isHovered = false;
            this._setTimeout(()=>{
                if (!this._isHovered) this.hide();
            }, this._config.delay.hide);
        }
        _setTimeout(handler, timeout) {
            clearTimeout(this._timeout);
            this._timeout = setTimeout(handler, timeout);
        }
        _isWithActiveTrigger() {
            return Object.values(this._activeTrigger).includes(true);
        }
        _getConfig(config) {
            const dataAttributes = Manipulator.getDataAttributes(this._element);
            for (const dataAttribute of Object.keys(dataAttributes))if (DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
            config = {
                ...dataAttributes,
                ...typeof config === "object" && config ? config : {}
            };
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            config.container = config.container === false ? document.body : index_js.getElement(config.container);
            if (typeof config.delay === "number") config.delay = {
                show: config.delay,
                hide: config.delay
            };
            if (typeof config.title === "number") config.title = config.title.toString();
            if (typeof config.content === "number") config.content = config.content.toString();
            return config;
        }
        _getDelegateConfig() {
            const config = {};
            for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
            config.selector = false;
            config.trigger = "manual";
            // In the future can be replaced with:
            // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
            // `Object.fromEntries(keysWithDifferentValues)`
            return config;
        }
        _disposePopper() {
            if (this._popper) {
                this._popper.destroy();
                this._popper = null;
            }
            if (this.tip) {
                this.tip.remove();
                this.tip = null;
            }
        }
        // Static
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Tooltip.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
    }
    /**
   * jQuery
   */ index_js.defineJQueryPlugin(Tooltip);
    return Tooltip;
});


const $5559bcad9cf8f504$var$tooltips = {
    defaultTarget: document.querySelector("body"),
    /**
   * Init
   *
   * @param {object} target
   *
   * @returns {void}
   */ init: function(target = $5559bcad9cf8f504$var$tooltips.defaultTarget) {
        window.app.domStateReady(function() {
            const tooltipTriggerList = target.querySelectorAll('[data-bs-toggle="tooltip"]');
            [
                ...tooltipTriggerList
            ].map((tooltipTriggerEl)=>new (0, (/*@__PURE__*/$parcel$interopDefault($eb5bb415b70a23f4$exports)))(tooltipTriggerEl));
        });
    }
};
var $5559bcad9cf8f504$export$2e2bcd8739ae039 = $5559bcad9cf8f504$var$tooltips;


var $2fdb429b3f21d464$export$2e2bcd8739ae039 = {
    init () {},
    finalize () {
        const target = document.querySelector("body");
        (0, $f386ddc081ca0f1d$export$2e2bcd8739ae039).init(target);
        (0, $f8a311d146402a10$export$2e2bcd8739ae039).init(target);
        (0, $fb7f0d699fad3c0f$export$2e2bcd8739ae039).init(target);
        (0, $b0b7bd6f4a1378d1$export$2e2bcd8739ae039).init(target);
        (0, $ec107908988458ca$export$2e2bcd8739ae039).init(target);
        (0, $557886ee49cc5614$export$2e2bcd8739ae039).init(target);
        (0, $508fcb5c5865a89e$export$2e2bcd8739ae039).init(target);
        (0, $ab808cb1ff637aca$export$2e2bcd8739ae039).init(target);
        (0, $7be46bbb60d787f3$export$2e2bcd8739ae039).init(target);
        (0, $7e7758fe6ef1abb0$export$2e2bcd8739ae039).init(target);
        (0, $a20b59ef33efb6d1$export$2e2bcd8739ae039).init(target);
        (0, $4ee4564850efd542$export$2e2bcd8739ae039).init();
        (0, $48f23611b62cf521$export$2e2bcd8739ae039).init(target);
        (0, $92a9257e94e58e2f$export$2e2bcd8739ae039).init(target);
        (0, $2e7bde4cc392dbaa$export$2e2bcd8739ae039).init(target);
        (0, $cbba02f95b4e7e13$export$2e2bcd8739ae039).init(target);
        (0, $dac0a50539495737$export$2e2bcd8739ae039).init(target);
        (0, $db34121f0e960780$export$2e2bcd8739ae039).init(target);
        (0, $77bea213b9b26e33$export$2e2bcd8739ae039).init(target);
        (0, $e3d067c130f35958$export$2e2bcd8739ae039).init(target);
        (0, $efdf6815285cb677$export$2e2bcd8739ae039).init(target);
        (0, $a62691fe6134b0e6$export$2e2bcd8739ae039).init(target);
        (0, $655a329fece5bd81$export$2e2bcd8739ae039).init();
        (0, $d879645a047cc454$export$2e2bcd8739ae039).init(document.querySelectorAll("body"));
        (0, $46c3b49fce744198$export$2e2bcd8739ae039).init(target);
        (0, $8cff758c33a8b62b$export$2e2bcd8739ae039).init();
        (0, $56fd38b9f11fa9d4$export$2e2bcd8739ae039).init(target);
        (0, $bb3670d9c3a88333$export$2e2bcd8739ae039).init(target);
        (0, $877044f68a9a3cdb$export$2e2bcd8739ae039).init(target);
        (0, $5559bcad9cf8f504$export$2e2bcd8739ae039).init();
    }
};


const $ed366d317c62ef73$var$view = {
    init () {
        // Verkrijg de fetchUrl uit het data-fetch-url attribuut van het element
        const fetchUrl = document.querySelector("[data-fetch-url]").getAttribute("data-fetch-url");
        // Functie om het resultaat van de fetch te tonen
        function showResult(result) {
            // Verberg het animatie-element
            document.querySelector("[data-fetch-el-animation]").classList.add("d-none");
            // Toon het element met het bijbehorende resultaat
            document.querySelector("[data-fetch-el-" + result + "]").classList.remove("d-none");
        }
        // Maak een nieuw XMLHttpRequest-object
        const xhr = new XMLHttpRequest();
        // Open het verzoek met de GET-methode en de fetchUrl
        xhr.open("GET", fetchUrl, true);
        // Functie om te controleren of het verzoek is geladen
        xhr.onload = function() {
            // Controleer of de status van het verzoek succesvol is
            if (xhr.status >= 200 && xhr.status < 400) {
                // Converteer het ontvangen JSON-antwoord naar een JavaScript-object
                let data = JSON.parse(xhr.responseText);
                // Stel het 'response'-attribuut van het .failure-element in op het ontvangen antwoord
                document.querySelector("[data-fetch-el-failure]").setAttribute("response", xhr.responseText);
                // Controleer of de data niet false, 'lockfile' of 'unknown_file_type' is
                if (data !== false && data !== "lockfile" && data !== "unknown_file_type") // Stel een timer in om na 500ms het succesresultaat te tonen en de pagina te vernieuwen
                setTimeout(function() {
                    showResult("success");
                    // window.location.href = window.location.href; // TODO: Deze regel is uitgecomment omdat hij niet door de eslint kwam. Deze comment mag na enige tijd verwijderd worden
                    window.location.reload(true); // Doet hetzelfde als window.location.href = window.location.href
                }, 500);
                else // Toon het falen van de fetch
                showResult("failure");
            } else // Toon het falen van de fetch
            showResult("failure");
        };
        // Functie om te controleren of er een fout is opgetreden tijdens het verzoek
        xhr.onerror = function() {
            // Toon het falen van de fetch
            showResult("failure");
        };
        // Verstuur het verzoek
        xhr.send();
    }
};
var $ed366d317c62ef73$export$2e2bcd8739ae039 = $ed366d317c62ef73$var$view;


const $1dd0a2fe0bfa7311$var$view = {
    init () {
        // Open modal wanner gebruiker op switch klikt
        document.querySelectorAll("[data-target-modal]").forEach(function(element) {
            element.addEventListener("click", function(event) {
                let target = event.target.getAttribute("data-target-modal");
                let element = document.getElementById(target);
                let bootstrapModal = new bootstrap.Modal(element);
                bootstrapModal.show();
                return false;
            });
        });
    }
};
var $1dd0a2fe0bfa7311$export$2e2bcd8739ae039 = $1dd0a2fe0bfa7311$var$view;


const $67117d67c059a2f7$var$showDashboard = {
    init () {
        // KvK opnieuw opvragen
        const stelUwVraagLink = document.querySelector("a#stelUwVraag");
        const uwVraagDiv = document.querySelector("div#uwVraag");
        if (stelUwVraagLink && uwVraagDiv) stelUwVraagLink.addEventListener("click", function(event) {
            event.preventDefault();
            uwVraagDiv.classList.toggle("d-none");
        });
    }
};
var $67117d67c059a2f7$export$2e2bcd8739ae039 = $67117d67c059a2f7$var$showDashboard;



const $b02a5f4f9add32ad$var$showDashboard = {
    init () {
        // Toon en verberg formulier wanner de checkbox van een connector wordt aangevinkt
        $("input.connector-checkbox").on("change", function() {
            $(this).closest("div.connector").find("div.connector-items").removeClass("d-none");
            if (!$(this).prop("checked")) $(this).closest("div.connector").find("div.connector-items").addClass("d-none").find("input,select").removeAttr("data-validate").attr("disabled", true);
            else $(this).closest("div.connector").find("div.connector-items").find("input,select").each(function() {
                $(this).attr("data-validate", $(this).attr("data-validate_org")).attr("disabled", false);
            });
            // Initialiseer de validatie opnieuw
            $("input[data-validate],select[data-validate]").unbind("blur", (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInputBlur);
            $("input[data-validate],select[data-validate]").blur((0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInputBlur);
        });
        // Tigger toon / verberg functie wanneer de pagina geladen wordt
        $("input.connector-checkbox").trigger("change");
        function setTypeMeldingen() {
            var typeMeldingen = $("#typeMeldingen");
            if ($("#richting").val() == "inkomend") typeMeldingen.removeAttr("data-validate");
            else typeMeldingen.attr("data-validate", typeMeldingen.attr("data-validate_org"));
        }
        // TODO: bij inkomend, dan geen type meldingen.
        $("#richting").on("change", setTypeMeldingen);
        setTypeMeldingen();
    }
};
var $b02a5f4f9add32ad$export$2e2bcd8739ae039 = $b02a5f4f9add32ad$var$showDashboard;



const $1f8bcf5265c48222$var$edit = {
    init () {
        // bij nieuwe dienstverlener_relatie
        if ($("select#dienstverlener_id").length) {
            // Toon en verberg connector wanner select wordt aangepast
            $("select#dienstverlener_id").change(function(e) {
                var dienstverlener_id = $(this).val();
                $1f8bcf5265c48222$var$edit.toonCorrectConnectors(dienstverlener_id);
                // Draai functie die op basis van het type meldingen op de dienstverlender de melding type checkboxes activeerd
                $1f8bcf5265c48222$var$edit.preSetTypeMelding(e);
            });
            $("select#dienstverlener_id").trigger("change");
        }
        // bij bestaande dienstverlener_relatie
        if ($("input#dienstverlener_id").length) {
            var dienstverlener_id = $("input#dienstverlener_id").val();
            $1f8bcf5265c48222$var$edit.toonCorrectConnectors(dienstverlener_id);
        }
        // Toon en verberg formulier wanner de checkbox van een connector wordt aangevinkt
        $("input.connector-checkbox").change(function() {
            $(this).closest(".form-section").find("div").removeClass("d-none");
            if (!$(this).prop("checked")) $(this).closest(".form-section").find("div").addClass("d-none").find("input,select").removeAttr("data-validate");
            else $(this).closest(".form-section").find("div").find("input,select").each(function() {
                $(this).attr("data-validate", $(this).attr("data-validate_org"));
            });
            // Initialiseer validatie opnieuw
            $("input[data-validate],select[data-validate]").unbind("blur", (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInputBlur);
            $("input[data-validate],select[data-validate]").blur((0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInputBlur);
        });
        // Trigger change van checkbox zodat functie onpageload geinitieerd wordt
        $("input.connector-checkbox").trigger("change");
        // Bind functie die het contactpersoon veld aan en uit ziet wanneer checkbox wordt gewijzigd aan checkbox
        $("#gebruikAlsContactpersoon").on("change", function(e) {
            $1f8bcf5265c48222$var$edit.toggleContactpersoon(e);
        });
    },
    // functie die het contactpersoon veld aan en uit ziet wanneer checkbox wordt gewijzigd
    toggleContactpersoon: function(e) {
        var targetEl = $(".form-section-contactpersoon-algemeen");
        targetEl.removeClass("d-none");
        if (!$(e.target).prop("checked")) targetEl.addClass("d-none");
    },
    // Functie die op basis van het type meldingen op de dienstverlender de melding type checkboxes activeerd
    preSetTypeMelding: function(e) {
        var typen = $(e.target).find("option:selected").data("melding-type") || [];
        $("input[type=checkbox][data-melding-type]").prop("checked", false);
        if (typeof typen === "string") typen = [
            typen
        ];
        $.each(typen, function(i, v) {
            $("input[type=checkbox][data-melding-type=" + v + "]").prop("checked", true);
        });
    },
    // Functie die op basis van het type meldingen op de dienstverlender de melding type checkboxes activeerd
    toonCorrectConnectors: function(dienstverlener_id) {
        if (dienstverlener_id === "" || typeof dienstverlener_id === "undefined") {
            if (!$("div#connectors").hasClass("d-none")) $("div#connectors").addClass("d-none");
            if (!$("div.connector").hasClass("d-none")) {
                $("div.connector").addClass("d-none");
                $("div.connector :input").attr("disabled", true);
            }
            $("#btnSubmit").attr("disabled", true);
        } else {
            if ($("div#connectors").hasClass("d-none")) $("div#connectors").removeClass("d-none");
            $("div.connector").each(function() {
                if (!$(this).hasClass("d-none")) {
                    $(this).addClass("d-none");
                    $("div.connector :input,select").attr("disabled", true).removeAttr("data-validate");
                }
            });
            if ($("div#" + dienstverlener_id).hasClass("d-none")) {
                $("div#" + dienstverlener_id).removeClass("d-none");
                $("div#" + dienstverlener_id + " :input,select").attr("disabled", false);
            }
            $("#btnSubmit").attr("disabled", false);
        }
    }
};
var $1f8bcf5265c48222$export$2e2bcd8739ae039 = $1f8bcf5265c48222$var$edit;


/**
 * Clipboard class that allows you to copy the content of a target element to the clipboard based on a data attribute
 *
 */ class $3305b19220bf984e$var$Clipboard {
    /**
   * Creates an instance of Clipboard.
   *
   * @constructor
   *
   * @param {string} containerSelector - The selector for the container element.
   * @param {string} targetAttribute - The name of the target attribute.
   */ constructor(containerSelector = "body", targetAttribute = "data-clipboard-target"){
        /**
     * The selector for the container element.
     *
     * @type {string}
     */ this.containerSelector = containerSelector;
        /**
     * The name of the target attribute.
     *
     * @type {string}
     */ this.targetAttribute = targetAttribute;
        /**
     * The selector for the target elements.
     *
     * @type {string}
     */ this.targetSelector = "[" + targetAttribute + "]";
        /**
     * The container element.
     *
     * @type {HTMLElement}
     */ this.container = document.querySelector(this.containerSelector);
        /**
     * The collection of target elements.
     *
     * @type {NodeList}
     */ this.elements = this.container.querySelectorAll(this.targetSelector);
    }
    /**
   * Initialize the clipboard dom functionality
   *
   * @param {HTMLElement} target - The target element to initialize clipboard functionality on
   *
   * @returns {void}
   */ init = ()=>{
        return this.initEvents();
    };
    /**
   * Initialize events for clipboard functionality
   *
   * @returns {void}
   */ initEvents = ()=>{
        this.elements?.forEach((element)=>{
            element.addEventListener("click", (event)=>this.handleClipboardClickEvent(event));
        });
    };
    /**
   * Handle click event on event target element
   *
   * @param {Event} event - The click event
   *
   * @returns {void}
   */ handleClipboardClickEvent = (event)=>{
        const targetSelector = event.currentTarget.getAttribute(this.targetAttribute);
        const targetElement = document.querySelector(targetSelector);
        if (targetElement) this.copyToClipboard(targetElement);
    };
    /**
   * Copy content to clipboard
   *
   * @param {HTMLElement} element - The element containing the content to be copied
   *
   * @returns {void}
   */ copyToClipboard = (element)=>{
        const content = element.textContent || element.value;
        if (content) {
            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(content).catch(()=>{
                this.fallbackCopyToClipboard(content);
            });
            else this.fallbackCopyToClipboard(content);
        }
    };
    /**
   * Fallback method to copy content to clipboard
   *
   * @param {string} content - The content to be copied
   *
   * @returns {void}
   */ fallbackCopyToClipboard = (content)=>{
        const textArea = document.createElement("textarea");
        textArea.value = content;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand("copy");
        } catch (err) {
            console.error("Fallback: Unable to copy text to clipboard:", err);
        }
        document.body.removeChild(textArea);
    };
}
var $3305b19220bf984e$export$2e2bcd8739ae039 = $3305b19220bf984e$var$Clipboard;


const $a24512ec72264b89$var$validateView = {
    init () {
        new (0, $3305b19220bf984e$export$2e2bcd8739ae039)().init();
        // Disabled button if value is empty or not set
        function disableIfEmpty(t, v) {
            t.disabled = true;
            if (v !== null || v !== "") t.disabled = false;
        }
        // Bind opmerkingen select function to select
        document.body.addEventListener("change", function(event) {
            if (event.target.classList.contains("toelichting-keuze")) {
                var modal = event.target.closest(".modal");
                var toelichtingInput = modal.querySelector(".toelichting");
                toelichtingInput.value = event.target.value;
                var submitButton = modal.querySelector("[type=submit]");
                disableIfEmpty(submitButton, event.target.value);
            }
        });
    }
};
var $a24512ec72264b89$export$2e2bcd8739ae039 = $a24512ec72264b89$var$validateView;




var $hzkBE = parcelRequire("hzkBE");
const $3ead3f471dc81ac2$var$stap1 = {
    init () {
        // Set start
        var start = 1;
        // Functie om de bijbehorende dekkingen bij de maatschapij in de select te tonen
        function getDekkingen4Mij(product, Mij) {
            var actionArray = [
                document.URL,
                "getDekkingen4Mij",
                product,
                Mij,
                ""
            ];
            $.getJSON(actionArray.join("/"), function(data) {
                if (data == false) (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
                else {
                    var options = [];
                    options.push('<option value=""> - </option>');
                    if (data != "geen") $.each(data, function(key, item) {
                        if (item.correct.status == 1) {
                            var text = "";
                            if (item.textConsumer) text = item.textConsumer;
                            else text = item.text;
                            if (// Dienstverlening
                            product == "P610" || product == "P611" || product == "P612" || product == "P614" || product == "P642" || product == "P643" || product == "P644" || product == "P645" || product == "P646" || product == "P800" || product == "P613" || product == "P833" || product == "P841" || product == "P842" || product == "P843" || product == "P844") text = text + " &euro;" + (item.correct.factor * 1).toFixed(2) + " per medewerker - &euro;" + item.correct.premie.toFixed(2) + " totaal";
                            else if (// Consultancy
                            product == "P834" || product == "P836" || product == "P837" || product == "P838" || product == "P839" || product == "P840") text = "Aanvraag indienen";
                            else text = text + " " + (item.correct.factor * 100).toFixed(3) + "% &euro;" + item.correct.premie.toFixed(2);
                            options.push('<option value="', key, '" >', text, "</option>");
                        }
                    });
                    $("select#Dekking_" + product).html(options.join(""));
                    $("select#Dekking_" + product).val($("select#Dekking_" + product).attr("data-value"));
                    $("select#Dekking_" + product).attr("data-value", "");
                    $("select#Dekking_" + product).attr("name", "prodMij[" + product + "][" + Mij + "]");
                }
                checkOfVolgendeMag();
            });
        }
        // Functie om de getDekkingen4Mij functie te draaien op de huidige select
        function getDekkingen() {
            var selectedMij = $(this);
            getDekkingen4Mij(selectedMij.attr("id").split("_").pop(), selectedMij.val());
        }
        // Functie om de controleren of de producten / maatschappijen gecombineerd mogen worden
        function checkOfVolgendeMag() {
            var errorText = "<br/><br/>Indien u &eacute;&eacute;n van de vereiste dekkingen reeds bij dezelfde Maatschappij in volmacht heeft afgesloten en dus niet opnieuw afsluit, kunt u de Maatschappij selecteren, maar de variant leeglaten.";
            var errorMsg = {};
            errorMsg["12jaarPropositie"] = "De producten Ziektewet ERD en/of WGA ERD kunnen alleen in combinatie met een Ziekteverzuimverzekering bij dezelfde maatschappij worden aangevraagd.";
            errorMsg["PlusPakket"] = "De door u gekozen dekkingssamenstelling is helaas niet mogelijk. Neem voor meer informatie contact op.";
            errorMsg["WIAExcedent"] = "WGA en IVA excedent kunnen niet los en niet bij separate Maatschappijen worden aangevraagd.";
            $("[data-button-submit]").attr("disabled", true);
            var mag = 0;
            var magFamily = 1;
            var magVerplichtMet = 1;
            var familyObject = {};
            var familyObjectShow = {};
            $("table.table-indienen select.dekking").each(function() {
                if ($(this).val() != "") {
                    var Mij = $(this).attr("name").split("][").slice(-1).pop().slice(0, -1);
                    // var Prod = $(this).attr('name').split('[').slice(-2).shift().slice(0, -1);
                    var curFamily = $(this).attr("data-family");
                    if (curFamily != "") {
                        $("select.dekking[family=" + curFamily + "]").closest("tr").removeClass("has-error");
                        if (familyObject.hasOwnProperty(curFamily)) {
                            if (familyObject[curFamily] != Mij) {
                                if (errorMsg.hasOwnProperty(curFamily)) {
                                    if (start != 1) {
                                        if (!familyObjectShow.hasOwnProperty(curFamily)) {
                                            (0, $hzkBE.default)("danger", "Let op!", errorMsg[curFamily] + errorText);
                                            familyObjectShow[curFamily] = 1;
                                        }
                                    }
                                    magFamily = 0;
                                }
                                $("select.dekking[data-value][family=" + curFamily + "]").closest("tr").addClass("has-error");
                            }
                        } else familyObject[curFamily] = Mij;
                    }
                    var curVerplichtMet = $(this).attr("data-verplichtMet");
                    if (curVerplichtMet != "") {
                        var verplichtArray = curVerplichtMet.split("|");
                        for(var i = 0; i < verplichtArray.length; i++){
                            var value = $("select#Dekking_" + verplichtArray[i]).val();
                            if (value == "") {
                                magVerplichtMet = 0;
                                (0, $hzkBE.default)("danger", "Let op!", "Dit product kan alleen afgesloten worden met " + $("td#ProdName_" + verplichtArray[i]).html());
                            }
                        }
                    }
                    mag = 1;
                } else $(this).closest("tr").removeClass("has-error");
            });
            if (mag == 1 && magFamily == 1 && magVerplichtMet == 1) $("[data-button-submit]").attr("disabled", false);
        }
        window.app.domStateReady(function() {
            // Voer checkOfVolgendeMag functie uit als pagina geladen is
            checkOfVolgendeMag();
            // Bind selects aan getdekking functie
            $("table.table-indienen select.Mij").change(getDekkingen);
            // Bind selects aan checkofvolgende mag functie functie
            $("table.table-indienen select.dekking").change(checkOfVolgendeMag);
            // Als er maar 1 aanbieder is zet dan de pulldown op die aanbieder
            $(".table-indienen tr select.Mij").each(function() {
                if ($(this).find("option").length == 2) $(this).find("option:eq(1)").attr("selected", "selected");
            });
            // Trigger change op elke select zodat de waarde goed staat als de pagina geladen wordt
            $("table.table-indienen select").each(function() {
                $(this).trigger("change");
            });
            // Zet start op 0 als de pagina geladen is
            setTimeout(function() {
                start = 0;
            }, 1000);
        });
    }
};
var $3ead3f471dc81ac2$export$2e2bcd8739ae039 = $3ead3f471dc81ac2$var$stap1;



const $82d2297bbee1dcb3$var$stap2 = {
    init () {
        // Run immediately
        this.displayContactBlock("financieel");
        this.displayContactBlock("arbo");
        // Also run on DOMContentLoaded in case the DOM isn't ready yet
        document.addEventListener("DOMContentLoaded", ()=>{
            this.displayContactBlock("financieel");
            this.displayContactBlock("arbo");
        });
        // Toon de financiele contactpersoon
        document.getElementById("activate_contact_financieel").addEventListener("change", ()=>{
            this.displayContactBlock("financieel");
        });
        // Toon de contactpersoon van arbo
        document.getElementById("activate_contact_arbo").addEventListener("change", ()=>{
            this.displayContactBlock("arbo");
        });
    },
    displayContactBlock (role) {
        const checkbox = document.getElementById(`activate_contact_${role}`);
        const contactBlock = document.querySelector(`.contact-block-${role}`);
        if (checkbox.checked) {
            contactBlock.classList.remove("d-none");
            contactBlock.querySelectorAll("input:not(.tussenvoegsel):not(.iti__search-input), select:not(.tussenvoegsel)").forEach((element)=>{
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(element);
            });
        } else {
            contactBlock.classList.add("d-none");
            contactBlock.querySelectorAll("input:not(.tussenvoegsel), select:not(.tussenvoegsel)").forEach((element)=>{
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(element);
            });
        }
    }
};
var $82d2297bbee1dcb3$export$2e2bcd8739ae039 = $82d2297bbee1dcb3$var$stap2;


const $3216b35133dc5b06$var$stap3 = {
    init () {
        $3216b35133dc5b06$var$stap3.betalingstermijnChange();
        $3216b35133dc5b06$var$stap3.nieuweArbodienstSelected();
        /**
     * Bind functies aan events dom elementen
     */ $("#TERMIJN").change($3216b35133dc5b06$var$stap3.betalingstermijnChange);
        $("#nieuweArboSelect").change($3216b35133dc5b06$var$stap3.nieuweArbodienstSelected);
    },
    /**
   * Enable en disable de optie "maatschappij-incasso" ('Nota') wanneer maand, kwartaal of halfjaar wordt gekozen (afhankelijk van company)
   *
   * @returns {void}
   */ betalingstermijnChange: function() {
        // Verkrijg Company ID
        var c = $("#TERMIJN").data("company-id");
        // Definieer object met niet toegestane waarden per company
        var d = {
            "base": [
                "maand"
            ],
            "C028": [
                "maand",
                "kwartaal",
                "halfjaar"
            ],
            "C030": [],
            "C032": [
                "maand",
                "kwartaal",
                "halfjaar"
            ]
        };
        // Kijk of de company id voorkomt in niet array toegestane waarden
        if (!d.hasOwnProperty(c)) c = "base";
        // Check of er een niet toegestane waarde is
        if (d[c].indexOf($("#TERMIJN").val()) > -1) {
            $("#KD_INKASSO").val("Automatische-incasso");
            $("#KD_INKASSO").find('option[value="Maatschappij-incasso"]').attr("disabled", "true");
        } else $("#KD_INKASSO").find('option[value="Maatschappij-incasso"]').removeAttr("disabled");
        $("#KD_INKASSO").trigger("change");
    },
    /**
   * Enable en disable de optie "maatschappij-incasso" ('Nota') wanneer maand, kwartaal of halfjaar wordt gekozen (afhankelijk van company)
   *
   * @returns {void}
   */ nieuweArbodienstSelected: function() {
        if ($('#nieuweArboSelect option[value="' + $("#nieuweArbo").val() + '"]').length == 0) {
            $('#nieuweArboSelect option[value="ONB"]').attr("selected", "selected").trigger("change.select2");
            $("#nieuweArbo").attr("data-validate", "required").removeClass("d-none");
        }
        if ($("#nieuweArboSelect").val() !== "ONB") $("#nieuweArbo").val($("#nieuweArboSelect").val());
        if ($("#nieuweArboSelect").val() == "ONB") {
            if ($('#nieuweArboSelect option[value="' + $("#nieuweArbo").val() + '"]').length > 0) $("#nieuweArbo").val("");
            $("#nieuweArbo").attr("data-validate", "required").removeClass("d-none");
        } else if (!$("#nieuweArbo").hasClass("d-none")) $("#nieuweArbo").attr("data-validate", "").addClass("d-none");
    }
};
var $3216b35133dc5b06$export$2e2bcd8739ae039 = $3216b35133dc5b06$var$stap3;



const $e5765fcf3acfa016$var$stap4 = {
    init () {
        $(document).ready(function() {
            $e5765fcf3acfa016$var$stap4.inhoudPakketChange();
            $e5765fcf3acfa016$var$stap4.toggleGarantieverklaring();
        });
        $("#P790_inhoudPakket").change($e5765fcf3acfa016$var$stap4.inhoudPakketChange);
        $(".garantieverklaring").change($e5765fcf3acfa016$var$stap4.toggleGarantieverklaring);
    },
    inhoudPakketChange: function() {
        if ($("#P790_inhoudPakket").val() == "ZW-Compleet") {
            $("#P790_arbo").val("ja");
            $("#P790_arbo").attr("disabled", true);
            $("#P790_verloning").val("ja");
            $("#P790_verloning").attr("disabled", true);
        }
        if ($("#P790_inhoudPakket").val() == "ZW-Verzekerd") {
            $("#P790_arbo").val("nee");
            $("#P790_arbo").attr("disabled", true);
            $("#P790_verloning").val("nee");
            $("#P790_verloning").attr("disabled", true);
        }
        if ($("#P790_inhoudPakket").val() == "ZW-Begeleiding") {
            $("#P790_arbo").val("ja");
            $("#P790_arbo").attr("disabled", true);
            $("#P790_verloning").val("nee");
            $("#P790_verloning").attr("disabled", true);
        }
        if ($("#P790_inhoudPakket").val() == "ZW-BegeleidingPlus") {
            $("#P790_arbo").val("ja");
            $("#P790_arbo").attr("disabled", true);
            $("#P790_verloning").val("ja");
            $("#P790_verloning").attr("disabled", true);
        } else $("#P790_arbo").closest(".form-group").show();
    },
    // Functie om garantieverklaring te tonen en verbergen
    toggleGarantieverklaring: function() {
        var e = $(".garantieverklaring");
        var b = $(".ingangsdatumEigenrisicodragerschapBestaandeWerkgever");
        var o = $(".vervalDatumGarantieVorigeBank");
        var i = $(".ingangsDatumGarantieNieuweBank");
        var h = $(".naamHuidigeVerzekeraarOfBank");
        b.closest(".form-group").addClass("d-none");
        o.closest(".form-group").addClass("d-none");
        i.closest(".form-group").addClass("d-none");
        h.closest(".form-group").addClass("d-none");
        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(b);
        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(o);
        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(i);
        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(h);
        if (e.length) {
            if (e.val() == "bestaande-werkgever-die-eigenrisicodrager-wordt") {
                b.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(b);
            } else if (e.val() == "eigenrisicodrager-die-overstapt-naar-bank-of-verzekeraar") {
                o.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(o);
                i.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(i);
                h.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(h);
            }
        }
    }
};
var $e5765fcf3acfa016$export$2e2bcd8739ae039 = $e5765fcf3acfa016$var$stap4;


const $936bfe68e2ecf267$var$aanvraagIndienen = {
    init () {
        (0, $f386ddc081ca0f1d$export$2e2bcd8739ae039).initTab([
            (0, $3ead3f471dc81ac2$export$2e2bcd8739ae039),
            (0, $82d2297bbee1dcb3$export$2e2bcd8739ae039),
            (0, $3216b35133dc5b06$export$2e2bcd8739ae039),
            (0, $e5765fcf3acfa016$export$2e2bcd8739ae039)
        ]);
    }
};
var $936bfe68e2ecf267$export$2e2bcd8739ae039 = $936bfe68e2ecf267$var$aanvraagIndienen;




const $4d698ae5d99ce37c$var$stap1 = {
    init () {
        // Focus op eerste veld van formulier
        $("input:enabled:visible:first").focus();
        // Start het ophalen van de KvK gegevens
        $4d698ae5d99ce37c$var$stap1.getKvK(1);
        // Draai getKvK functie als kvk veld verlaten wordt
        $("form[data-validate] input#NR_KVK").blur($4d698ae5d99ce37c$var$stap1.getKvK);
        // Maak correspondentiegegevens velden enabled als geladen gegevens niet correct zijn
        $("select#nawCorrect").on("change", function() {
            if (typeof this.value !== "undefined" && this.value == "nee") {
                $(".kvk_data").prop("disabled", false);
                $("#nawCorrectUitleg").prop("disabled", false).closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired($("#nawCorrectUitleg"));
            // $('#NM_RELATIE').prop('disabled', true);
            } else {
                $(".kvk_data").prop("disabled", true);
                $("#nawCorrectUitleg").prop("disabled", true).closest(".form-group").removeClass("d-none").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired($("#nawCorrectUitleg"));
            }
        });
    },
    // Functie om op basis van KvK nummer bedrijfsgegevens op te halen bij KvK
    getKvK: function(start) {
        start = typeof start !== "undefined" ? start : 0;
        if (start != 1) start = 0;
        var NR_KVK = $("#NR_KVK").val();
        if (NR_KVK.length == 8) {
            // Toon het laden spinner
            $(".kvk-spinner").removeClass("d-none").removeClass("d-none");
            $.getJSON(document.URL + "/getRelatieThroughKvK/" + NR_KVK + "/", function(data) {
                var fields = [
                    "SBIKODE",
                    "SBIKODE2",
                    "SBIKODE3",
                    "KD_SECTOR",
                    "CAO",
                    "KOR_ADR",
                    "KOR_ADRNR",
                    "KOR_ADRTOEV",
                    "POSTKD",
                    "WOONPL",
                    "KD_LAND",
                    "nawCorrect",
                    "nawCorrectUitleg"
                ];
                $.each(fields, function(index, fieldname) {
                    var value = "";
                    if (data != false && typeof data.values[fieldname] !== "undefined") value = data.values[fieldname];
                    if ("CAO" === fieldname) {
                        if (value === undefined || "" === value) value = "n_v_t";
                    }
                    if ("nawCorrect" === fieldname) {
                        if ("nee" === value) value = "nee";
                        else value = "ja";
                    }
                    if ("KD_LAND" === fieldname) {
                        if (value == "NLD") value = "NL";
                        else if (value == "DEU") value = "DE";
                        else if (value == "BEL") value = "BE";
                        else if (value == "GBR") value = "GB";
                        else if (value == "POL") value = "PL";
                        else if (value == "FRA") value = "FR";
                        else if (value == "LUX") value = "LU";
                        else if (value == "DNK") value = "DK";
                        else if (value == "USA") value = "US";
                    }
                    // Maak de SBIKODE velden zichtbaar als ze missen in de KvK data
                    if (fieldname == "SBIKODE" || fieldname == "SBIKODE2" || fieldname == "SBIKODE3") value;
                    $("#" + fieldname).val(value).trigger("blur");
                });
                var NM_RELATIE = "";
                if (data != false && typeof data.base["NM_RELATIE"] !== "undefined") {
                    NM_RELATIE = data.base["NM_RELATIE"];
                    // NM_RELATIE = heTool.decode(NM_RELATIE);
                    NM_RELATIE = $4d698ae5d99ce37c$var$stap1.decodeHtmlEntities(NM_RELATIE);
                    $("#NM_RELATIE").val(NM_RELATIE).trigger("blur");
                }
                if (data != false) {
                    $(".select2-general").trigger("change");
                    $4d698ae5d99ce37c$var$stap1.toggleFields(1);
                    // $('#NM_RELATIE,#KOR_ADR,#KOR_ADRNR,#POSTKD,#WOONPL,#KD_LAND,#SBIKODE').attr('data-validate', '');
                    if ("" == NM_RELATIE) {
                        $("#modal_kvk_Warning").modal("show");
                        $4d698ae5d99ce37c$var$stap1.toggleFields(0);
                    // $('#NM_RELATIE,#KOR_ADR,#KOR_ADRNR,#POSTKD,#WOONPL,#KD_LAND,#SBIKODE').attr('data-validate', 'required');
                    }
                } else if (start == 0) {
                    $("#modal_kvk_Warning").modal("show");
                    $4d698ae5d99ce37c$var$stap1.toggleFields(0);
                // $('#NM_RELATIE,#KOR_ADR,#KOR_ADRNR,#POSTKD,#WOONPL,#KD_LAND,#SBIKODE').attr('data-validate', 'required');
                } else $("#NR_KVK").focus();
                $("#nawCorrect").trigger("change");
                // Verberg het laden spinner
                $(".kvk-spinner").addClass("d-none").addClass("d-none");
            });
        }
    },
    // Functie om SBI velden te tonen en te verbergen
    toggleFields: function(goed) {
        goed = typeof goed !== "undefined" ? goed : 0;
        if (goed == 1) {
            // $('form[data-validate] input#SBIKODE, form[data-validate] input#SBIKODE2, form[data-validate] input#SBIKODE3 ').closest('.form-group').addClass('d-none');
            $("#NoKvK").addClass("d-none").addClass("d-none");
            $(".kvk_data").prop("disabled", true);
            $(".kvk-form-field").removeClass("d-none").removeClass("d-none");
            if ($("form[data-validate] input#SBIKODE").val() == "") // $('form[data-validate] input#SBIKODE, form[data-validate] input#SBIKODE2, form[data-validate] input#SBIKODE3 ').closest('.form-group').removeClass('d-none');
            $(".kvk_data").prop("disabled", false);
        } else {
            // $('form[data-validate] input#SBIKODE, form[data-validate] input#SBIKODE2, form[data-validate] input#SBIKODE3 ').closest('.form-group').removeClass('d-none');
            $("form[data-validate] input#NR_KVK").css("background-color", "#EEE");
            $("form[data-validate] input#SBIKODE").focus();
            $(".kvk_data").prop("disabled", false);
            $("#NoKvK").addClass("d-none").addClass("d-none");
            $(".kvk-form-field").removeClass("d-none").removeClass("d-none");
        }
    },
    decodeHtmlEntities: function(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }
};
var $4d698ae5d99ce37c$export$2e2bcd8739ae039 = $4d698ae5d99ce37c$var$stap1;


const $7a30f49a43cd8f0f$var$stap2 = {
    init () {
        window.app.domStateReady(function() {
            document.getElementById("stap2form").submit();
        });
    }
};
var $7a30f49a43cd8f0f$export$2e2bcd8739ae039 = $7a30f49a43cd8f0f$var$stap2;




const $6cfaa02207439bef$var$stap3 = {
    init () {
        document.getElementById("modalWerknemersGegevensLink")?.addEventListener("click", async ()=>{
            const grid = await (parcelRequire("kORcI"));
            grid.default.init();
        });
        // Bind datumPersoneelInDienstChange functie onblur aan datumPersoneelInDienst veld
        $("#datumPersoneelInDienst").blur($6cfaa02207439bef$var$stap3.datumPersoneelInDienstChange);
        // Toon percentage veld bij provisie
        $("#provisie").change($6cfaa02207439bef$var$stap3.toggleProvisieChange);
        $("#provisiePercentage").change($6cfaa02207439bef$var$stap3.toggleProvisieChange);
        // Toon verberg provisiepercentage bij pageload
        $6cfaa02207439bef$var$stap3.toggleProvisieChange();
        // Draai datumPersoneelInDienstChange functie bij pageload
        $6cfaa02207439bef$var$stap3.datumPersoneelInDienstChange();
        // Binding van toggleUploadType functie aan select
        $("#loyalisAanlevering").change(function() {
            $6cfaa02207439bef$var$stap3.toggleUploadType();
        });
        // Toon of verberg bijbehorende velden bij pageload
        $6cfaa02207439bef$var$stap3.toggleUploadType();
        // Koppel functie aan mantel veld
        $("#wensenEnBehoeftenToets").change(function() {
            $6cfaa02207439bef$var$stap3.toggleIndicatieWensenEnBehoeften();
        });
        // Draai functie bij laden van pagina
        $6cfaa02207439bef$var$stap3.toggleIndicatieWensenEnBehoeften();
        // set werknemersCount label
        $6cfaa02207439bef$var$stap3.getWerknemersCountFromDOM();
    },
    // Functie om verzuimpercentage velden te tonen en te verbergen op basis van datum personeel in dienst
    datumPersoneelInDienstChange: function() {
        // Voer inhoud van functie alleen uit als het veld #datumPersoneelInDienst bestaat
        if ($("#datumPersoneelInDienst").length) {
            $("#PC_VERZUIM1").attr("data-validate", "").closest(".form-group").addClass("d-none");
            $("#PC_VERZUIM2").attr("data-validate", "").closest(".form-group").addClass("d-none");
            $("#PC_VERZUIM3").attr("data-validate", "").closest(".form-group").addClass("d-none");
            $("#verzuimRapportage1").attr("data-validate", "").closest(".form-group").addClass("d-none");
            $("#verzuimRapportage2").attr("data-validate", "").closest(".form-group").addClass("d-none");
            $("#verzuimRapportage3").attr("data-validate", "").closest(".form-group").addClass("d-none");
            var value = $("#datumPersoneelInDienst").val();
            var m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
            if (m != null) {
                var ingangsdatum = new Date(m[3], m[2] - 1, m[1]);
                var PC_VERZUIM1 = new Date($("#PC_VERZUIM1").attr("data-showByYear"), 12, 0);
                if (ingangsdatum.getTime() <= PC_VERZUIM1.getTime()) {
                    $("#PC_VERZUIM1").attr("data-validate", "required decimalsAllowed range").closest(".form-group").removeClass("d-none");
                    $("#verzuimRapportage1").closest(".form-group").removeClass("d-none");
                }
                var PC_VERZUIM2 = new Date($("#PC_VERZUIM2").attr("data-showByYear"), 12, 0);
                if (ingangsdatum.getTime() <= PC_VERZUIM2.getTime()) {
                    $("#PC_VERZUIM2").attr("data-validate", "required decimalsAllowed range").closest(".form-group").removeClass("d-none");
                    $("#verzuimRapportage2").closest(".form-group").removeClass("d-none");
                }
                var PC_VERZUIM3 = new Date($("#PC_VERZUIM3").attr("data-showByYear"), 12, 0);
                if (ingangsdatum.getTime() <= PC_VERZUIM3.getTime()) {
                    $("#PC_VERZUIM3").attr("data-validate", "required decimalsAllowed range").closest(".form-group").removeClass("d-none");
                    $("#verzuimRapportage3").closest(".form-group").removeClass("d-none");
                }
            }
        }
    },
    // Functie om provisiepercentage aan en uit te toggelen TODO: Validate netjes maken
    toggleProvisieChange: function() {
        if ($("#provisie").val() == "exclusief") {
            $("#provisiePercentage").attr("data-validate", "").closest(".form-group").addClass("d-none").addClass("d-none");
            $("#provisiePercentage").append($("<option></option>").attr("value", "0").text("0%"));
            $("#provisiePercentage").val(0);
        } else if ($("#provisie").val() == "inclusief") {
            if ($("#provisiePercentage").val() == 0) $("#provisiePercentage").val($("#provisiePercentage").attr("data-value"));
            $("#provisiePercentage option[value=0]").remove();
            $("#provisiePercentage").attr("data-validate", "required decimalsAllowedNoChange").closest(".form-group").removeClass("d-none").removeClass("d-none");
            $("#provisiePercentage").attr("data-value", $("#provisiePercentage").val());
            $("#provisiePercentage").focus();
        }
    },
    // Functie die toont of verbergt bijbehorende velden bij soort upload
    toggleUploadType: function() {
        if ($("#loyalisAanlevering").val() == "los") {
            $("#loyalisWerknemersUpload,#loyalisZiekenUpload,#loyalisWiaInstroomUpload").closest(".form-group").removeClass("d-none");
            $("#loyalisWerknemersUpload,#loyalisZiekenUpload,#loyalisWiaInstroomUpload").each(function() {
                if ($(this).data("file") == "") (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired($(this));
            });
            $("#loyalisAdfizUpload").closest(".form-group").addClass("d-none");
            (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired($("#loyalisAdfizUpload"));
        } else {
            $("#loyalisWerknemersUpload,#loyalisZiekenUpload,#loyalisWiaInstroomUpload").closest(".form-group").addClass("d-none");
            (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired($("#loyalisWerknemersUpload,#loyalisZiekenUpload,#loyalisWiaInstroomUpload"));
            $("#loyalisAdfizUpload").closest(".form-group").removeClass("d-none");
            if ($("#loyalisAdfizUpload").data("file") == "") (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired($("#loyalisAdfizUpload"));
        }
    },
    // Functie om Indicatie wensen en behoefte te tonen en verbergen
    toggleIndicatieWensenEnBehoeften: function() {
        var e = $("#wensenEnBehoeftenToets");
        var t = $("#wensenEnBehoeftenToetsIndicatie");
        if (e.length) {
            if (e.val() === "j") {
                t.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(t);
            } else {
                t.closest(".form-group").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(t);
            }
        }
    },
    /**
   * Verkrijg de eventueel eerder opgeslagen werknemersgegevens uit DOM veld werknemersUploadV2
   *
   * @return void
   */ getWerknemersCountFromDOM: function() {
        var werknemersUploadV2 = document.getElementById("werknemersUploadV2") || null;
        if (null !== werknemersUploadV2) {
            var werknemersDataCSV = document.getElementById("werknemersUploadV2").value;
            if (werknemersDataCSV !== "") {
                var werknemersLines = werknemersDataCSV.split("|");
                document.getElementById("werknemersUploadV2Count").innerHTML = werknemersLines.length;
            }
        }
    }
};
var $6cfaa02207439bef$export$2e2bcd8739ae039 = $6cfaa02207439bef$var$stap3;



var $hzkBE = parcelRequire("hzkBE");

/**
 * Offerte Aanvragen - Stap 4
 */ const $30745de6392e4b87$var$stap4 = {
    /**
   * Initialiseert stap 4 functies
   */ init () {
        // Init events
        $30745de6392e4b87$var$stap4.initEvents();
        // Hernummer voor elk product de dekkingsvarianten
        document.querySelectorAll(".dekkingen[data-product]").forEach(function(element) {
            const product = element.getAttribute("data-product");
            $30745de6392e4b87$var$stap4.dekking.hernummeren(product);
        });
    },
    /**
   * Initialiseert event listeners voor stap 4
   */ initEvents () {
        // Bind dekkingToevoegen aan button
        document.body.addEventListener("click", function(e) {
            const targetButton = e.target.closest("[data-button-dekking-toevoegen]");
            if (targetButton) $30745de6392e4b87$var$stap4.dekking.toevoegen(targetButton);
        });
        // P-400 Collectieve ongevallen
        document.addEventListener("change", (e)=>{
            if (e.target.matches(".P400-uitoverlijd")) $30745de6392e4b87$var$stap4.product.updateInvaliditeitsuitkering(e.target);
        });
        // Voeg click event toe (delegated) voor dekking-verwijderen buttons
        document.body.addEventListener("click", function(e) {
            const targetButton = e.target.closest("[data-button-dekking-verwijderen]");
            if (targetButton) $30745de6392e4b87$var$stap4.dekking.verwijderen(targetButton);
        });
    },
    /**
   * Functionaliteit voor het toevoegen en verwijderen van dekkingsvarianten
   */ dekking: {
        /**
     * Verwijdert een dekkingsvariant
     *
     * @param {HTMLElement} el - Het element dat de verwijdering heeft geactiveerd
     *
     * @returns {void}
     */ verwijderen: function(el) {
            const product = el.closest(".dekkingen").getAttribute("data-product");
            const dekkingen = document.querySelectorAll('.dekkingen[data-product="' + product + '"] .dekking');
            if (dekkingen.length > 1) {
                el.closest(".dekking").remove();
                $30745de6392e4b87$var$stap4.dekking.hernummeren(product);
            } else (0, $hzkBE.default)("danger", "LET OP!", "Je moet minimaal 1 dekking behouden.");
        },
        /**
     * Hernummert bestaande dekkingsvarianten en werkt hun formulierveldnamen bij
     *
     * @param {string} product - De product identificatie
     *
     * @returns {void}
     */ hernummeren: function(product) {
            const dekkingen = document.querySelectorAll('.dekkingen[data-product="' + product + '"] .dekking');
            dekkingen.forEach((dekking, indexd)=>{
                const dekkingNummers = dekking.querySelectorAll("span.dekking-nummer");
                const lastDekkingNummer = dekkingNummers[dekkingNummers.length - 1];
                if (lastDekkingNummer) lastDekkingNummer.textContent = indexd + 1;
                dekking.querySelectorAll("select, input").forEach((element)=>{
                    const nameA = element.getAttribute("name").split("][");
                    const name = nameA.slice(-1)[0].slice(0, -1);
                    element.setAttribute("name", product + "[dekkingArray][" + indexd + "][" + name + "]");
                });
            });
            const removeButtons = document.querySelectorAll('.dekkingen[data-product="' + product + '"] .dekking [data-button-dekking-verwijderen]');
            removeButtons.forEach((button)=>{
                if (dekkingen.length > 1) button.classList.remove("invisible");
                else button.classList.add("invisible");
            });
        },
        /**
     * Voegt een nieuwe dekkingsvariant toe door de laatste te klonen
     *
     * @param {HTMLElement} el - Het element dat de toevoeging heeft geactiveerd
     *
     * @returns {void}
     */ toevoegen: function(el) {
            const product = el.getAttribute("data-product");
            const dekkingContainer = document.querySelector('.dekkingen[data-product="' + product + '"]');
            const maxDekkingen = parseInt(dekkingContainer.getAttribute("data-max-dekkingen"));
            const existingDekkingen = dekkingContainer.querySelectorAll(".dekking");
            if (existingDekkingen.length < maxDekkingen) {
                const lastDekking = existingDekkingen[existingDekkingen.length - 1];
                const newDekking = lastDekking.cloneNode(true);
                newDekking.style.display = "none";
                dekkingContainer.appendChild(newDekking);
                setTimeout(()=>{
                    newDekking.style.display = "";
                }, 0);
                const validateElements = newDekking.querySelectorAll("input[data-validate], select[data-validate]");
                validateElements.forEach((element)=>{
                    element.removeEventListener("blur", (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInputBlur);
                    element.addEventListener("blur", (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInputBlur);
                });
                $30745de6392e4b87$var$stap4.dekking.hernummeren(product);
            } else {
                const aantal = maxDekkingen === 1 ? "1 dekking" : maxDekkingen + " dekkingen";
                let bericht = "je kan maximaal " + aantal;
                const productElement = document.querySelector('.product-vragen[data-product="' + product + '"] h4');
                const product_txt = productElement ? productElement.innerHTML : "";
                if (product_txt) bericht = bericht + " voor " + product_txt;
                bericht = bericht + " selecteren.";
                (0, $hzkBE.default)("warning", "Helaas", bericht);
            }
        }
    },
    /**
   * Product functionaliteiten
   */ product: {
        /**
     * Updates the invaliditeitsuitkering to be twice the overlijdensuitkering
     *
     * @param {HTMLElement} element - Het input element van de overlijdensuitkering
     *
     * @returns {void}
     */ updateInvaliditeitsuitkering (element) {
            element.closest(".dekking").querySelector(".P400-uitinvalide").value = element.value * 2;
        }
    }
};
var $30745de6392e4b87$export$2e2bcd8739ae039 = $30745de6392e4b87$var$stap4;


const $0f450a2e08b13621$var$offerteAanvragen = {
    init () {
        (0, $f386ddc081ca0f1d$export$2e2bcd8739ae039).initTab([
            (0, $4d698ae5d99ce37c$export$2e2bcd8739ae039),
            (0, $7a30f49a43cd8f0f$export$2e2bcd8739ae039),
            (0, $6cfaa02207439bef$export$2e2bcd8739ae039),
            (0, $30745de6392e4b87$export$2e2bcd8739ae039)
        ]);
    }
};
var $0f450a2e08b13621$export$2e2bcd8739ae039 = $0f450a2e08b13621$var$offerteAanvragen;




var $hzkBE = parcelRequire("hzkBE");
const $2f9f7497e26f7642$var$stap1 = {
    init () {
        // Set start
        var start = 1;
        // Voer checkOfVolgendeMag functie uit als pagina geladen is
        $2f9f7497e26f7642$var$stap1.checkOfVolgendeMag();
        // Bind selects aan getdekking functie
        $("table.table-indienen select.Mij").change($2f9f7497e26f7642$var$stap1.getDekkingen);
        // Bind selects aan checkofvolgende mag functie functie
        $("table.table-indienen select.dekking").change($2f9f7497e26f7642$var$stap1.checkOfVolgendeMag);
        // Als er maar 1 aanbieder is zet dan de pulldown op die aanbieder
        $(".table-indienen tr select.Mij").each(function() {
            if ($(this).find("option").length == 2) $(this).find("option:eq(1)").attr("selected", "selected");
        });
        // Trigger change op elke select zodat de waarde goed staat als de pagina geladen wordt
        $("table.table-indienen select").each(function() {
            $(this).trigger("change");
        });
        // Zet start op 0 als de pagina geladen is
        setTimeout(function() {
            start = 0;
        }, 1000);
    },
    // Functie om de bijbehorende dekkingen bij de maatschapij in de select te tonen
    getDekkingen4Mij: function(product, Mij) {
        var actionArray = [
            document.URL,
            "getDekkingen4Mij",
            product,
            Mij,
            ""
        ];
        $.getJSON(actionArray.join("/"), function(data) {
            if (data == false) (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
            else {
                var options = [];
                options.push('<option value=""> - </option>');
                if (data != "geen") $.each(data, function(key, item) {
                    if (item.correct.status == 1) {
                        var text = "";
                        if (item.textConsumer) text = item.textConsumer;
                        else text = item.text;
                        if (// Dienstverlening
                        product == "P610" || product == "P611" || product == "P612" || product == "P614" || product == "P642" || product == "P643" || product == "P644" || product == "P645" || product == "P646" || product == "P800" || product == "P613" || product == "P833" || product == "P841" || product == "P842" || product == "P843" || product == "P844") text = text + " &euro;" + (item.correct.factor * 1).toFixed(2) + " per medewerker - &euro;" + item.correct.premie.toFixed(2) + " totaal";
                        else if (// Consultancy
                        product == "P834" || product == "P836" || product == "P837" || product == "P838" || product == "P839" || product == "P840") text = "Aanvraag indienen";
                        else text = text + " " + (item.correct.factor * 100).toFixed(3) + "% &euro;" + item.correct.premie.toFixed(2);
                        options.push('<option value="', key, '" >', text, "</option>");
                    }
                });
                $("select#Dekking_" + product).html(options.join(""));
                $("select#Dekking_" + product).val($("select#Dekking_" + product).attr("data-value"));
                $("select#Dekking_" + product).attr("data-value", "");
                $("select#Dekking_" + product).attr("name", "prodMij[" + product + "][" + Mij + "]");
            }
            $2f9f7497e26f7642$var$stap1.checkOfVolgendeMag();
        });
    },
    // Functie om de getDekkingen4Mij functie te draaien op de huidige select
    getDekkingen: function() {
        var selectedMij = $(this);
        $2f9f7497e26f7642$var$stap1.getDekkingen4Mij(selectedMij.attr("id").split("_").pop(), selectedMij.val());
    },
    // Functie om de controleren of de producten / maatschappijen gecombineerd mogen worden
    checkOfVolgendeMag: function() {
        var errorText = "<br/><br/>Indien u &eacute;&eacute;n van de vereiste dekkingen reeds bij dezelfde Maatschappij in volmacht heeft afgesloten en dus niet opnieuw afsluit, kunt u de Maatschappij selecteren, maar de variant leeglaten.";
        var errorMsg = {};
        errorMsg["12jaarPropositie"] = "De producten Ziektewet ERD en/of WGA ERD kunnen alleen in combinatie met een Ziekteverzuimverzekering bij dezelfde maatschappij worden aangevraagd.";
        errorMsg["PlusPakket"] = "De door u gekozen dekkingssamenstelling is helaas niet mogelijk. Neem voor meer informatie contact op.";
        errorMsg["WIAExcedent"] = "WGA en IVA excedent kunnen niet los en niet bij separate Maatschappijen worden aangevraagd.";
        $("[data-button-submit]").attr("disabled", true);
        var mag = 0;
        var magFamily = 1;
        var magVerplichtMet = 1;
        var familyObject = {};
        var familyObjectShow = {};
        $("table.table-indienen select.dekking").each(function() {
            if ($(this).val() != "") {
                var Mij = $(this).attr("name").split("][").slice(-1).pop().slice(0, -1);
                // var Prod = $(this).attr('name').split('[').slice(-2).shift().slice(0, -1);
                var curFamily = $(this).attr("data-family");
                if (curFamily != "") {
                    $("select.dekking[family=" + curFamily + "]").closest("tr").removeClass("has-error");
                    if (familyObject.hasOwnProperty(curFamily)) {
                        if (familyObject[curFamily] != Mij) {
                            if (errorMsg.hasOwnProperty(curFamily)) {
                                if ($2f9f7497e26f7642$var$stap1.start != 1) {
                                    if (!familyObjectShow.hasOwnProperty(curFamily)) {
                                        (0, $hzkBE.default)("danger", "Let op!", errorMsg[curFamily] + errorText);
                                        familyObjectShow[curFamily] = 1;
                                    }
                                }
                                magFamily = 0;
                            }
                            $("select.dekking[data-value][family=" + curFamily + "]").closest("tr").addClass("has-error");
                        }
                    } else familyObject[curFamily] = Mij;
                }
                var curVerplichtMet = $(this).attr("data-verplichtMet");
                if (curVerplichtMet != "") {
                    var verplichtArray = curVerplichtMet.split("|");
                    for(var i = 0; i < verplichtArray.length; i++){
                        var value = $("select#Dekking_" + verplichtArray[i]).val();
                        if (value == "") {
                            magVerplichtMet = 0;
                            (0, $hzkBE.default)("danger", "Let op!", "Dit product kan alleen afgesloten worden met " + $("td#ProdName_" + verplichtArray[i]).html());
                        }
                    }
                }
                mag = 1;
            } else $(this).closest("tr").removeClass("has-error");
        });
        if (mag == 1 && magFamily == 1 && magVerplichtMet == 1) $("[data-button-submit]").attr("disabled", false);
    }
};
var $2f9f7497e26f7642$export$2e2bcd8739ae039 = $2f9f7497e26f7642$var$stap1;






const $d6d2a798183dfb56$var$stap5 = {
    init () {
        $(document).ready(function() {
            $d6d2a798183dfb56$var$stap5.verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenChange();
        });
        $("#verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaarden").change($d6d2a798183dfb56$var$stap5.verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenChange);
        $("#aanrakingPolitieJustitie").change($d6d2a798183dfb56$var$stap5.verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenChange);
        $("#acceptatieCollectieveOngevallen").change($d6d2a798183dfb56$var$stap5.verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenChange);
        $(".needValiditeitsverklaringOnNee").change(function() {
            if ($(this).val() == "nee") {
                $(this).closest(".form-group").addClass("has-warning");
                if (window.app.language == "en_US") var errorMsg = "Due to the given answer a validity statement is mandatory";
                $(this).closest(".form-group").find(".error-label").html(errorMsg);
                $(this).unbind("blur");
                $("#validiteitsVerklaringUpload").closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired($("#validiteitsVerklaringUpload"));
            } else {
                $(this).closest(".form-group").removeClass("has-error").removeClass("has-warning");
                $(this).closest(".form-group").find(".error-label").html("");
                $(this).blur((0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInputBlur);
                $("#validiteitsVerklaringUpload").closest(".form-group").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired($("#validiteitsVerklaringUpload"));
            }
        });
        $("#werknemersIngestroomdInWGAOfAfgewezenWGA35Min, #fusiesOvernamesLopendeUitkeringen, #werknemersWiaIngestroomd").change(function() {
            $("#werknemersWiaIngestroomdUpload").closest(".form-group").addClass("d-none");
            (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired($("#werknemersWiaIngestroomdUpload"));
            $("#werknemersIngestroomdInWGAOfAfgewezenWGA35Min, #fusiesOvernamesLopendeUitkeringen, #werknemersWiaIngestroomd").each(function() {
                if ($(this).val() == "ja") {
                    $("#werknemersWiaIngestroomdUpload").closest(".form-group").removeClass("d-none");
                    (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired($("#werknemersWiaIngestroomdUpload"));
                }
            });
        });
        $(document).ready(function() {
            $(".needValiditeitsverklaringOnNee").trigger("change");
        });
        // Submits
        $("form[data-validate]").attr("data-validate-onsubmit-disabled", true);
        $("form[data-validate]").submit(async function() {
            let validated = await (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkSubmitForm(this);
            if (validated) {
                $("#validatieModal").modal("show");
                $("#validatieModalAkkoord").click(function() {
                    $("form[data-validate]").unbind("submit");
                    $("form[data-validate]").submit();
                });
            }
            return false;
        });
    },
    verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenChange: function() {
        if ($("#verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaarden").val() == "ja" || $("#aanrakingPolitieJustitie").val() == "ja" || $("#acceptatieCollectieveOngevallen").val() == "nee") $("#verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenToelichting").attr("data-validate", "required").closest(".form-group").show();
        else $("#verzekeringGeweigerdOpgezegdVerhoogdePremieOfVoorwaardenToelichting").attr("data-validate", "").closest(".form-group").hide();
    }
};
var $d6d2a798183dfb56$export$2e2bcd8739ae039 = $d6d2a798183dfb56$var$stap5;


const $0a294aad802e516b$var$aanvraagIndienen = {
    init () {
        (0, $f386ddc081ca0f1d$export$2e2bcd8739ae039).initTab([
            (0, $2f9f7497e26f7642$export$2e2bcd8739ae039),
            (0, $82d2297bbee1dcb3$export$2e2bcd8739ae039),
            (0, $3216b35133dc5b06$export$2e2bcd8739ae039),
            (0, $e5765fcf3acfa016$export$2e2bcd8739ae039),
            (0, $d6d2a798183dfb56$export$2e2bcd8739ae039)
        ]);
    }
};
var $0a294aad802e516b$export$2e2bcd8739ae039 = $0a294aad802e516b$var$aanvraagIndienen;




var $hzkBE = parcelRequire("hzkBE");
const $a02519817463ba7c$var$aanvraagVerwerken = {
    init () {
        $("#aanvraagGoedkeuren").attr("href-backup", $("#aanvraagGoedkeuren").attr("href"));
        $(".validate-row").click(function() {
            $a02519817463ba7c$var$aanvraagVerwerken.validateRow($(this).closest("tr"), "success", 1, 0, 0);
        });
        $(".validate-row-ccs").click(function() {
            $a02519817463ba7c$var$aanvraagVerwerken.validateRow($(this).closest("tr"), "success", 0, 0, 1);
        });
        // Functie om ccs relatie nummer veld op 0 te zetten
        $(".validate-row-ccs-new").click(function() {
            $($(this).closest("tr")).find("input[name=CCS_relnr]").val("0");
            $a02519817463ba7c$var$aanvraagVerwerken.validateRow($(this).closest("tr"), "success", 0, 1, 1);
        });
        $(".delete-row").click(function() {
            $a02519817463ba7c$var$aanvraagVerwerken.validateRow($(this).closest("tr"), "danger", 1, 0, 0);
        });
        $(".opmerking-row-submit").click(function() {
            var status = $(this).closest("tr").attr("class");
            $a02519817463ba7c$var$aanvraagVerwerken.validateRow($(this).closest("tr"), status, 1, 1, 0);
            $(this).closest("tr").find("div.opmerkingen").hide(200);
        });
        $(".opmerking-row").click(function() {
            $(this).closest("tr").find("div.opmerkingen").show(400);
        });
        $("button.terugzetten").click(function(e) {
            e.preventDefault();
            window.location.href = "1/terugzetten/concept";
        });
        $("button.afwijzen").click(function(e) {
            e.preventDefault();
            window.location.href = "1/afwijzen/concept";
        });
        $("button.claim").click(function(e) {
            e.preventDefault();
            window.location.href = "1/claim";
        });
        $(".tab-pane table tbody").each(function() {
            $a02519817463ba7c$var$aanvraagVerwerken.validateTab($(this).find("tr").first());
        });
        $(function() {
            $("#fileUploadButton").click(function(e) {
                $("#fileUploadField").click();
                e.preventDefault();
            });
        });
        $("#fileUploadField").on("change", function() {
            $("#uploadFileForm").submit();
        });
        $("#opmerkingenOpslaan").click(function() {
            $("#opmerkingen").attr("target", "");
            $("#formAction").val("");
            $("#opmerkingen").submit();
        });
        $("#offerteUitbrengen").click(function() {
            $("#opmerkingen").attr("target", "");
            $("#formAction").val("offerteUitbrengen");
            $("#opmerkingen").submit();
        });
        $("#offerteInzien").click(function() {
            $("#formAction").val("offerteInzien");
            $("#opmerkingen").attr("target", "_blank");
            $("#opmerkingen").submit();
        });
        $("#garantieVerklaringInzien").click(function() {
            $a02519817463ba7c$var$aanvraagVerwerken.saveGarantieverklaring();
            setTimeout(function() {
                $("#formAction").val("garantieVerklaringInzien");
                $("#formProductID").val($(this).data("product-id"));
                $("#formMaatschappij").val($(this).data("maatschappij"));
                $("#opmerkingen").attr("target", "_blank");
                $("#opmerkingen").submit();
            }, 1000);
        });
        $("#opmerkingenOpslaan").click(function() {
            $("#formAction").val("");
            $("#opmerkingen").attr("target", "");
            $("#opmerkingen").submit();
        });
        $(".submit-modal").click(function() {
            var product = $(this).attr("product");
            var Mij = $(this).attr("Mij");
            var dekking = $(this).attr("dekking");
            var error = new Array();
            $("form#modalForm" + product + " input[data-validate],select[data-validate],textarea[data-validate]").each(function() {
                if ($(this).prop("disabled") == false) {
                    if ((0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInput(this) === "error") error.push($(this).attr("name"));
                }
            });
            if (error.length > 0) (0, $hzkBE.default)("danger", "", "Er zitten fouten in de velden: <br>" + error.join(",<br>") + "!");
            else {
                var actionArray = [
                    document.URL,
                    "SaveModalAanpassing",
                    product,
                    Mij,
                    dekking,
                    "",
                    ""
                ];
                var post_data = $("form#modalForm" + product).serialize();
                $.post(actionArray.join("/"), post_data, function(data) {
                    if (data == false) (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
                    else {
                        $(".modal").modal("hide");
                        $("#showAanpassingTeken" + product).removeClass("d-none");
                        if ($("form#modalForm" + product).find("input[type=checkbox]").is(":checked")) $("#showAanpassingTeken" + product).removeClass("d-none");
                        else $("#showAanpassingTeken" + product).addClass("d-none");
                    }
                });
            }
        });
        $(".submit-garantieverklaring-modal").click(function() {
            $a02519817463ba7c$var$aanvraagVerwerken.saveGarantieverklaring();
        });
        $(".product-modal .input-group-text").parent().click(function() {
            if ($(this).find("input").is(":checked")) $(this).parent().find(".form-control:last-of-type(),.form-select:last-of-type()").removeAttr("disabled").focus().closest("div.form-group").parent().closest("div.form-group").removeClass("has-error").find(".mutatie-reden").removeAttr("disabled").closest("div.form-group").removeClass("has-error");
            else $(this).parent().find(".form-control,.form-select").attr("disabled", "true").closest("div.form-group").removeClass("has-error").parent().closest("div.form-group").find(".mutatie-reden").attr("disabled", "true").closest("div.form-group").removeClass("has-error");
            var disabled = true;
            if ($("#content-wrapper form input[type=checkbox]").is(":checked")) disabled = false;
            $(this).closest("form").find("button").attr("disabled", disabled);
        });
        $(".handmatig-verwerken").change(function() {
            if ($(this).is(":checked")) $(this).closest("div.form-group").find("textarea").removeAttr("disabled").closest("div.form-group").css("display", "none").removeClass("d-none").slideDown(300);
            else $(this).closest("div.form-group").find("textarea").closest("div.form-group").slideUp(300, function() {
                $(this).addClass("d-none").find("textarea").attr("disabled", "true");
            });
        });
        $(".modal.product-modal").on("shown.bs.modal", function() {
            // Check of de waarde in veld b gelijk is aan de waarde in veld a
            $(this).find("input[type=checkbox]").each(function() {
                if ($(this).is(":checked")) {
                    if ($(this).hasClass("handmatig-verwerken")) $(this).trigger("change");
                    else $(this).parent().trigger("click");
                }
            });
        });
        $("#aanvraagvalidatie_checklist_aanvraag .checklist-vraag td:first-child").click(function(e) {
            e.preventDefault();
            var answer = $(this).parent().find(".answer-value").val();
            if (answer == "ja") $(this).parent().find("input[type=checkbox].nee").click();
            else if (answer == "nee") $(this).parent().find("input[type=checkbox].nvt").click();
            else $(this).parent().find("input[type=checkbox].ja").click();
        });
        $("#aanvraagvalidatie_checklist_aanvraag .checklist-vraag input[type=checkbox]").change(function() {
            var checked = $(this).is(":checked");
            $(this).parent().parent().find("input[type=checkbox]").prop("checked", false);
            if (checked) {
                $(this).prop("checked", true);
                var answer = $(this).prop("name").split("_").pop();
                $(this).parent().parent().find(".answer-value").val(answer);
                $(this).parent().parent().find(".answer-feedback").removeAttr("disabled");
            } else {
                $(this).parent().parent().find(".answer-value").val("");
                $(this).parent().parent().find(".answer-feedback").attr("disabled", true);
            }
        });
        $("#aanvraagvalidatie_checklist_aanvraag .checklist-vraag input").change(function() {
            var key = $(this).parent().parent().data("key");
            var vraagkey = $(this).parent().parent().data("vraag-key");
            var value = $(this).parent().parent().find(".answer-value").val();
            var actionArray = [
                document.URL,
                "SaveChecklistRow",
                key,
                vraagkey,
                value,
                ""
            ];
            var this_row = $(this).parent().parent();
            $.post(actionArray.join("/"), {
                toelichting: $(this).parent().parent().find(".answer-feedback").val()
            }, function(data) {
                var status;
                if (data == false) {
                    status = "warning";
                    (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!", 5000);
                } else if (value == "") status = "warning table-warning";
                else status = "success table-success";
                // $(this_row).removeClass('warning').removeClass('success').removeClass('danger').addClass(status);
                $(this_row).removeClass("warning").removeClass("success").removeClass("danger").removeClass("table-warning").removeClass("table-success").removeClass("table-danger").addClass(status);
                $a02519817463ba7c$var$aanvraagVerwerken.validateTab(this_row);
            });
        });
        $(".product-modal").each(function() {
            $(this).find(".input-group-text input[type=checkbox]:checked").closest(".input-group ").find("input,select").removeAttr("disabled").closest(".input-group ").find("input.mutatie-reden").removeAttr("disabled");
        });
        $(document).ready(function() {
            $a02519817463ba7c$var$aanvraagVerwerken.toggleGarantieverklaring();
        });
        $(".garantieverklaring").change($a02519817463ba7c$var$aanvraagVerwerken.toggleGarantieverklaring);
        // Activate first tab
        var firstTabEl = document.querySelector(".premie-validatie-tabs li:first-child a");
        if (firstTabEl !== null) {
            var firstTab = new bootstrap.Tab(firstTabEl);
            firstTab.show();
        }
    },
    validateComplete: function() {
        // Valideer alle premieverzoeken van alle maatschappijen
        if ($(".tab-pane table tbody").children().hasClass("warning")) {
            // Maak de offerte knoppen selecteerbaar (enabled)
            $("ul.nav-tabs.premie-validatie-tabs button:not(.no-disable)").attr("disabled", true);
            $("ul.nav-tabs.premie-validatie-tabs a.btn:not(.no-disable)").attr("disabled", true);
            $("ul.nav-tabs.premie-validatie-tabs a.btn:not(.no-disable)").each(function() {
                $(this).attr("href", "#");
            });
        } else {
            // Maak de offerte knoppen NIET selecteerbaar (disabled)
            $("ul.nav-tabs.premie-validatie-tabs button").attr("disabled", false);
            $("ul.nav-tabs.premie-validatie-tabs a").attr("disabled", false);
            $("ul.nav-tabs.premie-validatie-tabs a.btn:not(.no-disable)").each(function() {
                $(this).attr("href", $(this).attr("href-backup"));
            });
        }
    },
    validateTab: function(this_row) {
        var tab = $(this_row).closest("div.tab-pane").attr("tab");
        // VALIDEER DE HUIDIGE TABEL OP OPENSTAANDE PREMIEVERZOEKEN
        if ($(this_row).closest(".tab-pane[tab=" + tab + "] table tbody").children().hasClass("warning")) // MAAK DE MAATSCHAPPIJ TAB GRIJS
        $("ul.nav-tabs li[tab=" + tab + "] a.maatschapij-tab").removeClass("bg-warning").removeClass("bg-success").addClass("bg-warning bg-opacity-25");
        else // MAAK DE MAATSCHAPPIJ TAB GROEN
        $("ul.nav-tabs li[tab=" + tab + "] a.maatschapij-tab").removeClass("bg-warning").removeClass("bg-success").addClass("bg-success bg-opacity-25");
        $a02519817463ba7c$var$aanvraagVerwerken.validateComplete();
    },
    SaveRow: function(this_row, status) {
        var product = $(this_row).attr("product");
        var Mij = $(this_row).attr("Mij");
        var dekking = $(this_row).attr("dekking");
        var actionArray = [
            document.URL,
            "SaveRow",
            product,
            Mij,
            dekking,
            status,
            ""
        ];
        $.post(actionArray.join("/"), {
            opmerking: $(this_row).find("textarea[name=opmerking]").val()
        }, function(data) {
            if (data == false) {
                $a02519817463ba7c$var$aanvraagVerwerken.validateRow(this_row, "warning", 0, 0);
                (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
            }
        });
    },
    SaveRowCCS: function(this_row) {
        var field = $(this_row).find("input").attr("name");
        var value = $(this_row).find("input").val();
        var actionArray = [
            document.URL,
            "SaveRowCCS",
            field,
            value,
            ""
        ];
        $.getJSON(actionArray.join("/"), function(data) {
            if (data == false) {
                $a02519817463ba7c$var$aanvraagVerwerken.validateRow(this_row, "warning", 0, 0, 0);
                (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
            }
        });
    },
    validateRow: function(this_row, status, save, overwrite, saveccs) {
        if ($(this_row).hasClass(status) && overwrite == 0) {
            // kleur de rij(this_row) oranje
            $(this_row).removeClass(status).addClass("warning");
            status = "warning";
        }
        $(this_row).removeClass("warning").removeClass("success").removeClass("danger").removeClass("table-warning").removeClass("table-success").removeClass("table-danger").addClass("table-" + status);
        if (save == 1) $a02519817463ba7c$var$aanvraagVerwerken.SaveRow(this_row, status);
        if (saveccs == 1) $a02519817463ba7c$var$aanvraagVerwerken.SaveRowCCS(this_row, status);
        $a02519817463ba7c$var$aanvraagVerwerken.validateTab(this_row);
    },
    saveGarantieverklaring: function() {
        var product = $(".submit-garantieverklaring-modal").attr("product");
        var Mij = $(".submit-garantieverklaring-modal").attr("Mij");
        var dekking = $(".submit-garantieverklaring-modal").attr("dekking");
        var actionArray = [
            document.URL,
            "SaveGarantieVerklaringAanpassing",
            product,
            Mij,
            dekking,
            "",
            ""
        ];
        var post_data = $("form#modalFormGarantieVerklaring" + product).serialize();
        $("#modal_garantieverklaring_" + product + " .loading-spinner").removeClass("d-none");
        $.post(actionArray.join("/"), post_data, function(data) {
            if (data == false) (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
            $("#modal_garantieverklaring_" + product + " .loading-spinner").addClass("d-none");
        });
    },
    // Functie om garantieverklaring te tonen en verbergen
    toggleGarantieverklaring: function() {
        var e = $(".garantieverklaring");
        var b = $(".ingangsdatumEigenrisicodragerschapBestaandeWerkgever");
        var o = $(".vervalDatumGarantieVorigeBank");
        var i = $(".ingangsDatumGarantieNieuweBank");
        var h = $(".naamHuidigeVerzekeraarOfBank");
        b.closest(".form-group").addClass("d-none");
        o.closest(".form-group").addClass("d-none");
        i.closest(".form-group").addClass("d-none");
        h.closest(".form-group").addClass("d-none");
        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(b);
        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(o);
        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(i);
        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(h);
        o.val("");
        i.val("");
        b.val("");
        if (e.length) {
            if (e.val() == "bestaande-werkgever-die-eigenrisicodrager-wordt") {
                b.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(b);
            } else if (e.val() == "eigenrisicodrager-die-overstapt-naar-bank-of-verzekeraar") {
                o.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(o);
                i.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(i);
                h.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(h);
            }
        }
    }
};
var $a02519817463ba7c$export$2e2bcd8739ae039 = $a02519817463ba7c$var$aanvraagVerwerken;




const $8a0f29bc3d42e759$var$stap2 = {
    init () {
        // Draai check table functie on click op checkbox, cel en header images
        $("table.product-table input[type=checkbox], table.product-table tbody td, table.product-table thead th img").click(function() {
            setTimeout(function() {
                $8a0f29bc3d42e759$var$stap2.checkTable();
            }, 100);
        });
        // Draai check table functie on pageload
        $8a0f29bc3d42e759$var$stap2.checkTable();
        // Na het laden van de pagina, het mogelijk maken dat de producten tabel op verschillende manieren geselecteerd kan worden. Hierdoor kunnen producten per rrij geselecteerd worden, maar ook per kollom of cel
        $("table.product-table tr").click(function() {
            var curVerplichtMet = $(this).attr("data-verplichtMet");
            if (typeof curVerplichtMet != "undefined" && curVerplichtMet != "") {
                var verplichtArray = curVerplichtMet.split("|");
                for(var i = 0; i < verplichtArray.length; i++)$(this).find("td.checkbox_field input").each(function() {
                    var checked = $(this).prop("checked");
                    var id = $(this).attr("id");
                    var idArray = id.split("_");
                    idArray[1] = verplichtArray[i];
                    if (checked == true) {
                        $("#" + idArray.join("_")).prop("checked", true).parent().removeClass("checked").addClass("checked");
                        $8a0f29bc3d42e759$var$stap2.checkVerplichtMetAanbieder($("#" + idArray.join("_")));
                    } else {
                        $("#" + idArray.join("_")).prop("checked", false).parent().removeClass("checked");
                        $8a0f29bc3d42e759$var$stap2.checkVerplichtMetAanbieder($("#" + idArray.join("_")));
                    }
                });
            }
        });
        // Voegt de class 'checked' toe aan een cel in de tabel als de checkbox in die cel aangevinkt is
        $("table.product-table tr .checkbox_field input").each(function() {
            var target = $(this).parent();
            if ($(this).prop("checked") == true) target.addClass("checked");
            else target.removeClass("checked");
        });
        // click td - goed TODO: Comment
        $("table.product-table tr .checkbox_field").click(function() {
            if ($(this).hasClass("checked")) $(this).removeClass("checked").children().prop("checked", false).trigger("change");
            else $(this).addClass("checked").children().prop("checked", true).trigger("change");
        });
        // click first child PRODUCT - goed TODO: Comment
        $("table.product-table tr td:first-child").click(function() {
            var row = $(this).parent().parent().children().index($(this).parent()) + 1;
            var target = $(this).parent().parent().find("tr:nth-child(" + row + ") td");
            if (target.hasClass("checked")) {
                target.removeClass("checked");
                target.children().prop("checked", false).trigger("change");
            } else {
                target.addClass("checked");
                target.children().prop("checked", true).trigger("change");
            }
        });
        // hover first child PRODUCT - goed TODO: Comment
        $("table.product-table tr td:first-child").hover(function() {
            var row = $(this).parent().parent().children().index($(this).parent()) + 1;
            $(this).closest("table").find("tr:nth-child(" + row + ") td").addClass("hover");
        }, function() {
            var row = $(this).parent().parent().children().index($(this).parent()) + 1;
            $(this).closest("table").find("tr:nth-child(" + row + ") td").removeClass("hover");
        });
        // click first child Mij - goed TODO: Comment
        $("table.product-table tr th").click(function() {
            var col = $(this).parent().children().index($(this)) + 1;
            var target = $(this).parent().parent().parent().find("tr td:nth-child(" + col + ")");
            if (target.hasClass("checked")) {
                target.removeClass("checked");
                target.children().prop("checked", false).trigger("change");
            } else {
                target.addClass("checked");
                target.children().prop("checked", true).trigger("change");
            }
        });
        // hover first child Mij - goed TODO: Comment
        $("table.product-table tr th").not(":first-child").hover(function() {
            var col = $(this).parent().children().index($(this)) + 1;
            var target = $(this).parent().parent().parent().find("tr td:nth-child(" + col + ")");
            target.addClass("hover");
        }, function() {
            var col = $(this).parent().children().index($(this)) + 1;
            var target = $(this).parent().parent().parent().find("tr td:nth-child(" + col + ")");
            target.removeClass("hover");
        });
        // deselecteer alles - goed TODO: Comment
        $("table.product-table tr th:first-child button").click(function() {
            $(this).closest("table").find("tbody tr td").removeClass("checked").children().prop("checked", false);
        });
        // TODO: Comment
        $("input[type=checkbox][data-verplichtMetAanbieder]").on("change", function() {
            $8a0f29bc3d42e759$var$stap2.checkVerplichtMetAanbieder($(this));
        });
        if (typeof this.value !== "undefined" && this.value == "nee") {
            $(".kvk_data").prop("disabled", false);
            $("#NM_RELATIE").prop("disabled", true);
        } else $(".kvk_data").prop("disabled", true);
    },
    // Functie die checkt of in de producttabel voldoende maar niet te veel producten zijn aangevinkt
    checkTable: function() {
        var total = $("table.product-table").find("input[type=checkbox]:checked").length;
        if (total > 0) $("button[type=submit]").removeAttr("disabled");
        // per tr controleren hoeveel gecheckt zijn max 6 per regel
        var myArray = new Array();
        $("table.product-table tr").each(function() {
            var rowTotal = $(this).find("input[type=checkbox]:checked").length;
            myArray.push(rowTotal);
        });
        var maxValueInArray = Math.max.apply(Math, myArray);
        $("button[type=submit]").removeAttr("disabled");
        $(".button-row-message.warning").fadeOut(300);
        if (total == 0) $("button[type=submit]").attr("disabled", "true");
        else {
            if (maxValueInArray > 8) {
                $("button[type=submit]").attr("disabled", "true");
                $(".button-row-message.warning").fadeIn(300);
            }
            if (maxValueInArray < 9) {
                $("button[type=submit]").removeAttr("disabled");
                $(".button-row-message.warning").fadeOut(300);
            }
        }
    },
    // Functie die checkt of product verplicht is bij een andere aanbieder en vinkt het bijbehoorende product dan aan
    checkVerplichtMetAanbieder: function(t) {
        var verplichtMetAanbieder = $(t).attr("data-verplichtMetAanbieder");
        if (typeof verplichtMetAanbieder != "undefined" && verplichtMetAanbieder != "") {
            var v = verplichtMetAanbieder.split("|");
            var r = $(t).closest("tr");
            r.find("input[type=checkbox][data-verplichtMetAanbieder]").each(function(i, el) {
                $.each(v, function(index, val) {
                    if (el.getAttribute("id").match(val)) $(el).prop("checked", $(t).prop("checked"));
                });
            });
        }
    }
};
var $8a0f29bc3d42e759$export$2e2bcd8739ae039 = $8a0f29bc3d42e759$var$stap2;




const $b78ff4e4d9df46a7$var$offerteAanvragen = {
    init () {
        (0, $f386ddc081ca0f1d$export$2e2bcd8739ae039).initTab([
            (0, $4d698ae5d99ce37c$export$2e2bcd8739ae039),
            (0, $8a0f29bc3d42e759$export$2e2bcd8739ae039),
            (0, $6cfaa02207439bef$export$2e2bcd8739ae039),
            (0, $30745de6392e4b87$export$2e2bcd8739ae039)
        ]);
    }
};
var $b78ff4e4d9df46a7$export$2e2bcd8739ae039 = $b78ff4e4d9df46a7$var$offerteAanvragen;



var $hzkBE = parcelRequire("hzkBE");

var $JSMaE = parcelRequire("JSMaE");

const $8e06696975a37362$var$premieVerzoekenVerwerken = {
    init: function() {
        // Maak ingegeven waarde van factor veld de juiste opmaak
        $("tr.product-regel input[name=factor],input[name=factorBruto],input[name=kortingPercentage]").on("change", function() {
            var value = $(this).val();
            value = value.replace(",", ".");
            var valueSplit = value.split(".");
            if (valueSplit[0].length == 0) valueSplit[0] = 0;
            if (typeof valueSplit[1] !== "undefined") valueSplit[1] = valueSplit[1].substring(0, 6);
            $(this).val(valueSplit.join("."));
        });
        // Bind opslaan button in relatie tab aan valideer functie
        $(".validate-row-ccs").click(function() {
            $8e06696975a37362$var$premieVerzoekenVerwerken.validateRow($(this).closest("tr"), "success", 0, 1, 0);
        });
        // Bind opslaan button in algemeen tab aan valideer functie
        $(".validate-row-algemeen").click(function() {
            $8e06696975a37362$var$premieVerzoekenVerwerken.validateRow($(this).closest("tr"), "success", 0, 0, 1);
        });
        // Functie om ccs relatie nummer veld op 0 te zetten
        $(".validate-row-ccs-new").click(function() {
            $($(this).closest("tr")).find("input[name=CCS_relnr]").val("0");
            $8e06696975a37362$var$premieVerzoekenVerwerken.validateRow($(this).closest("tr"), "success", 0, 1, 0);
        });
        // Bind valideer button aan validateRow functie
        $(".validate-row").click(function() {
            $8e06696975a37362$var$premieVerzoekenVerwerken.validateRow($(this).closest("tr"), "success", 1, 0, 0);
        });
        // Bind verwijder button aan validateRow functie
        $(".delete-row").click(function() {
            $8e06696975a37362$var$premieVerzoekenVerwerken.validateRow($(this).closest("tr"), "danger", 1, 0, 0);
        });
        // Valideer alle tabs als pagina geladen wordt
        $(".tab-pane table tbody").each(function() {
            $8e06696975a37362$var$premieVerzoekenVerwerken.validateTab($(this).find("tr").first());
        });
        // Bind functie om aantal ingegeven regels te limmiteren aan opmerkingen veld
        $("textarea[name=opmerkingenOfferte]").keyup(function() {
            $8e06696975a37362$var$premieVerzoekenVerwerken.limitTextarea(this, 5, 55);
        });
        // Functie om geupload bestand op te slaan
        $("#fileUploadField").on("change", function() {
            $("#uploadFileForm").submit();
        });
        // Functie om opmerkingen veld op te slaan
        $("#opmerkingenOpslaan").click(function() {
            $("#formAction").val("");
            $("#opmerkingen").attr("target", "");
            $("#opmerkingen").submit();
        });
        // Functie om offerte uit te brengen
        $("#offerteUitbrengen").click(function() {
            $("#formAction").val("offerteUitbrengen");
            $("#opmerkingen").attr("target", "");
            $("#opmerkingen").submit();
        });
        // Functie om offerte in te zien
        $("#offerteInzien").click(function() {
            $("#formAction").val("offerteInzien");
            $("#opmerkingen").attr("target", "_blank");
            $("#opmerkingen").submit();
        });
        // Functie om offerte in te zien
        $("#offerteHtmlInzien").click(function() {
            $("#formAction").val("offerteHtmlInzien");
            $("#opmerkingen").attr("target", "_blank");
            $("#opmerkingen").submit();
        });
        // TODO: Checken of deze functie relevant is
        $("#vergelijkingInzien").click(function() {
            $("#formAction").val("vergelijkingInzien");
            $("#opmerkingen").attr("target", "_blank");
            $("#opmerkingen").submit();
        });
        // Functie status offerte afwachting op derden adviseur
        $("#offerteAfwachtDerdenAdviseur").click(function() {
            $("#formAction").val("offerteAfwachtDerdenAdviseur");
            $("#opmerkingen").attr("target", "");
            $("#opmerkingen").submit();
        });
        // Functie status offerte afwachting op derden risicodrager
        $("#offerteAfwachtDerdenRisicodrager").click(function() {
            $("#formAction").val("offerteAfwachtDerdenRisicodrager");
            $("#opmerkingen").attr("target", "");
            $("#opmerkingen").submit();
        });
        // Functie status offerte hervatten
        $("#offerteHervatten").click(function() {
            $("#formAction").val("offerteHervatten");
            $("#opmerkingen").attr("target", "");
            $("#opmerkingen").submit();
        });
        // TODO: Checken of deze functie relevant is
        $("#offerteClaim").click(function() {
            $("#formAction").val("offerteClaim");
            $("#opmerkingen").attr("target", "");
            $("#opmerkingen").submit();
        });
        // Functie om checkboxen op regel van checklist te toggelen
        $(".checklist-vraag td:first-child").click(function(e) {
            e.preventDefault();
            var answer = $(this).parent().find(".answer-value").val();
            if (answer == "ja") $(this).parent().find("input[type=checkbox].nee").click();
            else if (answer == "nee") $(this).parent().find("input[type=checkbox].nvt").click();
            else $(this).parent().find("input[type=checkbox].ja").click();
        });
        // Functie om checkbox op regel van checklist te toggelen
        $(".checklist-vraag input[type=checkbox]").change(function() {
            var checked = $(this).is(":checked");
            $(this).parent().parent().find("input[type=checkbox]").prop("checked", false);
            if (checked) {
                $(this).prop("checked", true);
                var answer = $(this).prop("name").split("_").pop();
                $(this).parent().parent().find(".answer-value").val(answer);
                $(this).parent().parent().find(".answer-feedback").removeAttr("disabled");
            } else {
                $(this).parent().parent().find(".answer-value").val("");
                $(this).parent().parent().find(".answer-feedback").attr("disabled", true);
            }
        });
        // Functie om waarde van checkbox in checklist op te slaan
        $(".checklist-vraag input").change(function() {
            var key = $(this).parent().parent().data("key");
            var vraagkey = $(this).parent().parent().data("vraag-key");
            var value = $(this).parent().parent().find(".answer-value").val();
            var urlSplit = window.location.href.split("#");
            var url = urlSplit[0];
            if (url.charAt(url.length - 1) != "/") url = url + "/";
            var actionArray = [
                url + "SaveChecklistRow",
                key,
                vraagkey,
                value,
                ""
            ];
            var this_row = $(this).parent().parent();
            $.post(actionArray.join("/"), {
                toelichting: $(this).parent().parent().find(".answer-feedback").val()
            }, function(data) {
                if (data == false) {
                    var status = "warning table-warning";
                    (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
                } else if (value == "") status = "warning table-warning";
                else status = "success table-success";
                $(this_row).removeClass("warning").removeClass("success").removeClass("danger").removeClass("table-warning").removeClass("table-success").removeClass("table-danger").addClass(status);
                $8e06696975a37362$var$premieVerzoekenVerwerken.validateTab(this_row);
            });
        });
        // Maark link aan die alle checkboxes in de checklist onder specials op n.v.t. checkt
        $(".checklist table tbody tr th").append('&nbsp;&nbsp;<a href="javascript:void(0)" class="link-nvt">n.v.t.</a>');
        $("body").on("click", ".checklist table tbody tr th .link-nvt", function() {
            $(this).closest("tbody").find(".nvt").prop("checked", true).trigger("change");
        });
        // Functie om inhoud van 'Aanpassing Doorvoeren' modal op te slaan
        $(".submit-modal").click(function() {
            var product = $(this).closest(".product-modal").attr("data-product");
            var error = new Array();
            $("form#modalForm" + product + " input[data-validate],select[data-validate],textarea[data-validate]").each(function() {
                if ($(this).prop("disabled") == false) {
                    if ((0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInput(this) === "error") error.push($(this).attr("name"));
                }
            });
            if (error.length > 0) (0, $hzkBE.default)("danger", "", "Er zitten fouten in de velden: <br>" + error.join(",<br>") + "!");
            else {
                var actionArray = [
                    document.URL,
                    "SaveModalAanpassing",
                    product,
                    ""
                ];
                var post_data = $("form#modalForm" + product).serialize();
                $.post(actionArray.join("/"), post_data, function(data) {
                    if (data == false) (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
                    else $(".modal").modal("hide");
                });
            }
            // Maak controleer knop groen als de data in het modal wordt opgeslagen
            $('.product-regel[data-product="' + product + '"]').find(".btn-controleer").removeClass("btn-danger").addClass("btn-success").text("Gecontroleerd");
        });
        // Functie bind aan pulldown
        $("#bmLadderVanToepassing").change(function(e) {
            e.preventDefault();
            $8e06696975a37362$var$premieVerzoekenVerwerken.bmLadderVanToepassing();
        });
        // Functie bind aan pulldown
        $("#holdingVanToepassing").change(function(e) {
            e.preventDefault();
            $8e06696975a37362$var$premieVerzoekenVerwerken.holdingVanToepassing();
        });
        // Run functie on keyup
        $("body").on("keyup", "#NR_EXTERN,#CCS_relnr", function() {
            $8e06696975a37362$var$premieVerzoekenVerwerken.compareCSSFields();
        });
        // Bind 'toevoegen' knop aan functie om tabelregel toe te voegen
        $(".modal .form-section").on("click", "button.btn-add", function(e) {
            $8e06696975a37362$var$premieVerzoekenVerwerken.addTableRow($(e.target));
        });
        // Bind 'toevoegen' knop aan functie om tabelregel toe te voegen
        $(".modal .form-section").on("click", ".btn-remove", function(e) {
            $8e06696975a37362$var$premieVerzoekenVerwerken.removeTableRow($(e.target).closest("tr"));
        });
        // KortingPercentage limiteren op 0-10
        $("[name=kortingPercentage]").on("blur", function() {
            $8e06696975a37362$var$premieVerzoekenVerwerken.formatLimitKorting($(this));
        });
        // Maak regel onklaar als input gefocused wordt
        $(".product-regel input").on("focus", function() {
            $8e06696975a37362$var$premieVerzoekenVerwerken.validateRow($(this).closest("tr"), "warning", 0, 0, 0);
        });
        // Bind loyalisCombinatieKorting select aan cunctie om combinatiekorting gekozen in modal toe te passen op productregel
        $("[data-korting]").on("keyup change", function(event) {
            $8e06696975a37362$var$premieVerzoekenVerwerken.pasKortingToeOpProductregel(event);
        });
        //
        $("[data-korting]").on("change", function(event) {
            var target = $(event.target);
            var modal = target.closest(".product-modal");
            var productNumber = modal.attr("data-product");
            var productRow = $(".product-regel[data-product=" + productNumber + "]");
            $8e06696975a37362$var$premieVerzoekenVerwerken.validateRow(productRow, "warning", 0, 0, 0);
        });
        // Trigger korting functie als modal geladen wordt
        $(".product-modal").on("shown.bs.modal", function(event) {
            $(event.target).find("[data-korting]").trigger("keyup");
        });
        // Functie om de bedrijfsnaam in de DOM te wijzigen als deze wordt opgeslagen
        $("[name=bedrijfsnaamOrigineel]+button.validate-row-algemeen").click(function() {
            var bedrijfsnaamOrigineel = $("#tab_ccs input[name=bedrijfsnaamOrigineel]").val();
            $("#tab_ccs input[name=NM_RELATIE]").val(bedrijfsnaamOrigineel);
        });
        // Bind functie om de inhoud van opmerkingen te schonen aan veld
        $("#opmerkingenAcceptatie").blur(function(e) {
            e.preventDefault();
            $8e06696975a37362$var$premieVerzoekenVerwerken.sanitizeOpmerkingen(e);
        });
        // Bind upload button click functie
        $("#fileUploadButton").click(function(e) {
            $("#fileUploadField").click();
            e.preventDefault();
        });
        // Functie uitvoeren wanneer pagina geladen wordt
        $8e06696975a37362$var$premieVerzoekenVerwerken.bmLadderVanToepassing();
        // Functie uitvoeren wanneer pagina geladen wordt
        $8e06696975a37362$var$premieVerzoekenVerwerken.holdingVanToepassing();
        // Run functie on pageload
        $8e06696975a37362$var$premieVerzoekenVerwerken.compareCSSFields();
        // Activate first tab
        var firstTabEl = document.querySelector(".premie-validatie-tabs li:first-child a");
        if (firstTabEl !== null) {
            var firstTab = new bootstrap.Tab(firstTabEl);
            firstTab.show();
        }
        // Tab dropdowns
        document.addEventListener("click", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches("[data-bs-toggle=tabDropdown]")) {
                var targetTab = event.target.getAttribute("data-bs-target-tab");
                var tabEl = document.querySelector('.premie-validatie-tabs li[data-tab="' + targetTab + '"] a');
                new bootstrap.Tab(tabEl).show();
                break;
            }
        }, false);
    },
    // Functie om volledige premieverzoek te valideren
    validateComplete: function() {
        // Valideer alle premieverzoeken van alle maatschappijen
        if ($(".tab-pane table tbody").children().hasClass("warning")) // Maak de offerte-buttons disabled als er warnings zijn
        $("ul.nav-tabs.premie-validatie-tabs button#offerteUitbrengen").attr("disabled", true);
        else {
            // Maak object met per product alle maatschappijen
            var Producten = {};
            $(".product-regel.table-success").each(function(key, this_row) {
                var product = $(this_row).attr("data-product");
                var Mij = $(this_row).attr("data-Mij");
                if (Producten[product] === undefined) Producten[product] = {};
                Producten[product][Mij] = 1;
            });
            // Controleer of er maximaal 6 maatschappijen per product geselecteerd zijn
            var fouten = "";
            for(var key in Producten)if (Producten.hasOwnProperty(key)) {
                var aantal = Object.keys(Producten[key]).length;
                if (aantal > 6) fouten = fouten + key + " heeft " + aantal + " geselecteerde maatschapijen en 6 is het maximum<br/>";
            }
            // Maak de offerte-buttons enabled als er geen fouten zijn
            if (fouten == "") $("ul.nav-tabs.premie-validatie-tabs button#offerteUitbrengen").attr("disabled", false);
            else {
                $("ul.nav-tabs.premie-validatie-tabs button").attr("disabled", true);
                (0, $hzkBE.default)("danger", "Let op:", fouten);
            }
        }
    },
    // Functie om alle regels in tab te valideren
    validateTab: function(this_row) {
        var tab = $(this_row).closest("div.tab-pane").attr("data-tab");
        // Valideer de huidige tabel op openstaande premieverzoeken
        if ($(this_row).closest(".tab-pane[data-tab=" + tab + "] table tbody").children().hasClass("warning")) // Maak de maatschappij tab grijs
        $("ul.nav-tabs li[data-tab=" + tab + "] a.maatschapij-tab").removeClass("bg-warning").removeClass("bg-success").addClass("bg-warning bg-opacity-25");
        else // Maak de maatschappij tab groen
        $("ul.nav-tabs li[data-tab=" + tab + "] a.maatschapij-tab").removeClass("bg-warning").removeClass("bg-success").addClass("bg-success bg-opacity-25");
        // Voer volledige validatie uit van premieverzoek
        $8e06696975a37362$var$premieVerzoekenVerwerken.validateComplete();
    },
    // Sla dekkingsregel op
    SaveRow: function(this_row, status) {
        var product = $(this_row).attr("data-product");
        var Mij = $(this_row).attr("data-Mij");
        var dekking = $(this_row).attr("data-dekking");
        var factorBruto = $(this_row).find("input[name=factorBruto]").val();
        var grondslag = $(this_row).find("input[name=grondslag]").val();
        var kortingPercentage = $(this_row).find("input[name=kortingPercentage]").val();
        var polis_id = $("[data-polis-id]").attr("data-polis-id");
        var url = window.app.ajaxPath + polis_id + "/1";
        var actionArray = [
            url,
            "SaveRow",
            product,
            Mij,
            dekking,
            status,
            factorBruto,
            grondslag,
            kortingPercentage,
            ""
        ];
        $.getJSON(actionArray.join("/"), function(data) {
            if (data == false) {
                $8e06696975a37362$var$premieVerzoekenVerwerken.validateRow(this_row, "warning", 0, 0, 0);
                (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
            } else {
                $(this_row).find("input[name=factorBruto]").val(data.factorBruto);
                $(this_row).find("input[name=grondslag]").val(data.grondslag);
                $(this_row).find("input[name=kortingPercentage]").val(data.kortingPercentage);
                $(this_row).find("span.factorNetto").html(data.factorNetto);
                $(this_row).find("span.premieNetto").html(data.premieNetto);
                $(this_row).find("span.premieBruto").html(data.premieBruto);
            }
        });
    },
    // Functie om regel in relatie tab op te slaan
    SaveRowCCS: function(this_row) {
        var field = $(this_row).find("input").attr("name");
        var value = $(this_row).find("input").val();
        var actionArray = [
            document.URL,
            "SaveRowCCS",
            field,
            value,
            ""
        ];
        $.getJSON(actionArray.join("/"), function(data) {
            if (data == false) {
                $8e06696975a37362$var$premieVerzoekenVerwerken.validateRow(this_row, "warning", 0, 0, 0);
                (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens");
            }
        });
    },
    // Functie om regel in algemeen tab op te slaan
    SaveRowAlgemeen: function(this_row) {
        var field = $(this_row).find("input,select").attr("name");
        var value = $(this_row).find("input,select").val();
        var actionArray = [
            document.URL,
            "SaveRowAlgemeen",
            field,
            value,
            ""
        ];
        $.getJSON(actionArray.join("/"), function(data) {
            if (data == false) {
                $8e06696975a37362$var$premieVerzoekenVerwerken.validateRow(this_row, "warning", 0, 0, 0);
                (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
            }
        });
    },
    // Functie om regel te valideren
    validateRow: function(this_row, status, save, saverelatie, savealgemeen) {
        if ($(this_row).hasClass(status) && saverelatie == 0 && savealgemeen == 0) {
            // kleur de rij(this_row) oranje
            $(this_row).removeClass(status).addClass("warning");
            status = "warning";
        }
        $(this_row).removeClass("warning").removeClass("table-warning").removeClass("table-success").removeClass("table-danger").addClass(status).addClass("table-" + status);
        if (save == 1) $8e06696975a37362$var$premieVerzoekenVerwerken.SaveRow(this_row, status);
        if (saverelatie == 1) $8e06696975a37362$var$premieVerzoekenVerwerken.SaveRowCCS(this_row, status);
        if (savealgemeen == 1) $8e06696975a37362$var$premieVerzoekenVerwerken.SaveRowAlgemeen(this_row, status);
        $8e06696975a37362$var$premieVerzoekenVerwerken.validateTab(this_row);
    },
    // Functie om aantal ingegeven regels in texareas te limiteren
    limitTextarea: function(textarea, maxLines, maxChar) {
        var lines = textarea.value.replace(/\r/g, "").split("\n"), lines_removed, char_removed, i;
        if (maxLines && lines.length > maxLines) {
            lines = lines.slice(0, maxLines);
            lines_removed = 1;
        }
        if (maxChar) {
            i = lines.length;
            while(i-- > 0)if (lines[i].length > maxChar) {
                lines[i] = lines[i].slice(0, maxChar);
                char_removed = 1;
            }
            if (char_removed || lines_removed) textarea.value = lines.join("\n");
        }
    },
    // Functie om waarden in css velden te vergelijken en tekst een kleur te geven
    compareCSSFields: function() {
        if ($("#NR_EXTERN").val() != $("#CCS_relnr").val()) {
            $("#NR_EXTERN,#CCS_relnr").addClass("text-danger");
            $("#NR_EXTERN,#CCS_relnr").removeClass("text-success");
        } else {
            $("#NR_EXTERN,#CCS_relnr").removeClass("text-danger");
            $("#NR_EXTERN,#CCS_relnr").addClass("text-success");
        }
    },
    // Functie om de BM ladder velden in de gegevens model te tonen of the verbergen
    bmLadderVanToepassing: function() {
        if ($("#bmLadderVanToepassing").val() == "1") $(".form-section.form-section-bm-ladder").removeClass("d-none");
        else $(".form-section.form-section-bm-ladder").addClass("d-none");
    },
    // Functie om de holding velden in de gegevens model te tonen of the verbergen
    holdingVanToepassing: function() {
        if ($("#holdingVanToepassing").val() == "1") $(".form-section.form-section-holding").removeClass("d-none");
        else $(".form-section.form-section-holding").addClass("d-none");
    },
    // Functie om tabelregel toe te voegen
    addTableRow: function(targetElement) {
        // Definieer table body
        var tableBody = targetElement.closest(".form-section").find("table tbody");
        // Dupliceer de eerste regel
        var nr = tableBody.find("tr").first().clone()// Maak alle waardes leeg
        .find("input,select").val("")// Maak het element zichtbaar
        .closest("tr").removeClass("d-none");
        // Plaats het bij de rest van de dekkingen
        nr.appendTo(tableBody);
        // Init datepicker
        $(nr).find(".datepicker").datepicker({
            format: "dd-mm-yyyy",
            language: window.app.language.replace("_", "-"),
            autoclose: true,
            forceParse: false,
            enableOnReadonly: false
        });
        $8e06696975a37362$var$premieVerzoekenVerwerken.nameRowInputs(targetElement);
    },
    // Functie om input velden in rows het juiste name attribute te geven
    nameRowInputs: function(targetElement) {
        // Definieer table body
        var tableRows = targetElement.closest(".form-section").find("table tbody tr");
        // Geef op elke row elke input een name attribute met nummer
        tableRows.each(function(rowIndex) {
            $(this).find("input").each(function() {
                var inputName = $(this).data("name") + rowIndex;
                $(this).attr("name", inputName);
            });
        });
    },
    // Functie om tabelregel te verwijderen
    removeTableRow: function(targetRow) {
        var tableBody = targetRow.closest(".form-section").find("table tbody");
        $("[data-toggle=tooltip]").tooltip("hide");
        targetRow.find("input").attr("value", "");
        targetRow.hide();
        $8e06696975a37362$var$premieVerzoekenVerwerken.nameRowInputs(tableBody);
    },
    // Number limiteer
    formatLimitKorting: function(t) {
        // Verkrijg maximale korting
        var m = t.data("max-korting") || 0.00;
        // Verkrijg huidige waarde
        var v = t.val();
        // Var returnValue
        var r;
        // Limiteer op max korting of geef oorspronkelijke waarde terug
        if (parseFloat(t.val()) > m) r = (0.00 + parseFloat(m)).toFixed(2);
        else if (t.val() < 0) r = 0.00.toFixed(2);
        else r = (0.00 + parseFloat(v)).toFixed(2);
        // Return de waarde
        t.val(r);
    },
    // Functie om combinatiekorting gekozen in modal toe te passen op productregel
    pasKortingToeOpProductregel: function(event) {
        var target = $(event.target);
        var modal = target.closest(".product-modal");
        var productNumber = modal.attr("data-product");
        var productRow = $(".product-regel[data-product=" + productNumber + "] [name=kortingPercentage]");
        var totaleKortingVeld = modal.find("[name=loyalisKortingTotaal]");
        var kortingsVelden = modal.find("[data-korting]");
        var totaleKorting = 0;
        $.each(kortingsVelden, function(index, element) {
            var value = $(element).val() || 0;
            var value = (0, $JSMaE.default).cleanString2CorrectNumber(value);
            totaleKorting = ((parseFloat(totaleKorting) * 100 + parseFloat(value) * 100) / 100).toFixed(2);
        });
        productRow.val(totaleKorting);
        totaleKortingVeld.val((0, $JSMaE.default).dotToComma(totaleKorting));
        productRow.trigger("blur");
    },
    // Functie om de inhoud van opmerkingen te schonen
    sanitizeOpmerkingen: function(e) {
        var target = $(e.target);
        var value = target.val();
        var returnValue = (0, $JSMaE.default).sanitizeString(value);
        target.val(returnValue);
    }
};
var $8e06696975a37362$export$2e2bcd8739ae039 = $8e06696975a37362$var$premieVerzoekenVerwerken;


const $ef1414d30154ec5c$var$volmachtAanvraagBekijken = {
    /**
   * Initializes the module
   */ init () {
        // Disable modal inputs
        this.disableModalInputs(document.querySelectorAll(".modal input"));
        // Handle manual processing checkboxes
        document.querySelectorAll(".modal .handmatig-verwerken").forEach((checkbox)=>this.toggleHandmatigVerwerken(checkbox));
        // Initialize event listeners
        this.initEvents();
    },
    /**
   * Initializes all event listeners for the page functionality
   */ initEvents () {
        const uploadButton = document.getElementById("fileUploadButton");
        const uploadField = document.getElementById("fileUploadField");
        const opmerkingenOpslaan = document.getElementById("opmerkingenOpslaan");
        const uploadFileForm = document.getElementById("uploadFileForm");
        // Opmerkingen opslaan
        opmerkingenOpslaan.addEventListener("click", ()=>this.submitOpmerkingen());
        // Upload button
        uploadButton.addEventListener("click", ()=>uploadField.click());
        // Upload file select
        uploadField.addEventListener("change", ()=>uploadFileForm.submit());
    },
    /**
   * Disables all input fields within modal dialogs
   *
   * @param {NodeList} inputs - List of input elements to disable
   */ disableModalInputs (inputs) {
        inputs.forEach((input)=>{
            input.setAttribute("disabled", "true");
        });
    },
    /**
   * Shows/hides textarea based on checkbox state for manual processing
   *
   * @param {HTMLInputElement} checkbox - The manual processing checkbox that triggers the toggle
   */ toggleHandmatigVerwerken (checkbox) {
        if (checkbox.checked) {
            const textareaGroup = checkbox.closest(".form-group").querySelector("textarea").closest(".form-group");
            if (textareaGroup.classList.contains("d-none")) textareaGroup.classList.remove("d-none");
        }
    },
    /**
   * Prepares and submits the comments form by clearing action and target
   *
   * @param {HTMLFormElement} form - The comments form element to submit
   * @param {HTMLInputElement} formAction - The form action input field to clear
   */ submitOpmerkingen () {
        document.getElementById("formAction").value = "";
        document.getElementById("opmerkingen").submit();
    }
};
var $ef1414d30154ec5c$export$2e2bcd8739ae039 = $ef1414d30154ec5c$var$volmachtAanvraagBekijken;



var $hzkBE = parcelRequire("hzkBE");
const $c84fdb535a392bd5$var$checkVolmacht = {
    init () {
        // Functie om te voorkomen dat een dropdown dicht gaat als er op een select geklikt wordt
        $("#content-wrapper .dropdown-menu").on("click", function(e) {
            e.stopPropagation();
        });
        // $('button.float-right').click(postFields);
        // Functie om verschil te berekenen als correctie wordt ingegeven
        var start = true;
        $("td input.correctie").change(function() {
            var trId = $(this).closest("tr").attr("id");
            var jaar = $(this).attr("data-jaar");
            var check = $(this).attr("data-check");
            var nieuw = Math.round(parseFloat($(this).val().replace(",", ".")));
            var oud = Math.round(parseFloat($("tr#" + trId + " .form-group." + check + " input.oud[data-jaar=" + jaar + "]").val().replace(",", ".")));
            var verschil = nieuw - oud;
            $("tr#" + trId + " .form-group." + check + " input.verschil[data-jaar=" + jaar + "]").closest("div.form-group").removeClass("has-error").removeClass("has-success").removeClass("has-warning");
            $("tr#" + trId + " .form-group." + check + " input.verschil[data-jaar=" + jaar + "]").val(verschil);
            $("tr#" + trId + " .form-group." + check + " input.correctie[data-jaar=" + jaar + "]").val(nieuw);
            if (verschil < 0) $("tr#" + trId + " .form-group." + check + " input.verschil[data-jaar=" + jaar + "]").closest("div.form-group").addClass("has-error");
            else $("tr#" + trId + " .form-group." + check + " input.verschil[data-jaar=" + jaar + "]").closest("div.form-group").addClass("has-success");
            if (start != true) $c84fdb535a392bd5$var$checkVolmacht.postFields();
        // actionArray = [document.URL, "savePart", trId.replace('_','/'), jaar, check, nieuw];
        // $.getJSON(actionArray.join('/'), function (data) {
        // 	if (data == false) {
        // 		bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
        // 		$('tr#'+trId+' td.'+check+' input.verschil[data-jaar='+jaar+']').closest('div.form-group').addClass('has-warning');
        // 	} else {
        // 		if(verschil<0){
        // 			$('tr#'+trId+' td.'+check+' input.verschil[data-jaar='+jaar+']').closest('div.form-group').addClass('has-error');
        // 		} else {
        // 			$('tr#'+trId+' td.'+check+' input.verschil[data-jaar='+jaar+']').closest('div.form-group').addClass('has-success');
        // 		}
        // 	}
        // });
        });
        $("td input.correctie").trigger("change");
        start = false;
        $c84fdb535a392bd5$var$checkVolmacht.postFields();
        // Geef upload soort mee aan click functie
        $(".dropdown-upload").click(function(e) {
            e.preventDefault();
            $("input#fileUploadField").attr("name", $(this).data("upload-type") + "[]");
            $("input#fileUploadField").click();
        });
        // Submit direct als bestand geselecteerd wordt
        $("#fileUploadField").on("change", function() {
            $("#uploadFileForm").submit();
        });
        // Vul standaard reden in reden veld in
        $("#afwijzenStandaardReden").change(function() {
            var value = $(this).val();
            if (value != "") {
                if ($("#afwijsReden").val() != "") {
                    (0, $hzkBE.default)("danger", "Let op:", "Er staat al tekst in het reden veld. Verwijder dit eerst.");
                    $(this).val("");
                } else $("#afwijsReden").val($(this).find("option[value='" + $(this).val() + "']").text().trim()).trigger("blur");
            }
        });
        // Toon waarschuwing als deze actie reeds wordt bewerkt
        if ($("#claimModal").length) {
            $("#claimModal").modal("show");
            // Sluit de modal en maak de pagina onbruikbaar
            $(".btn-inzien").on("click", function(e) {
                e.stopPropagation();
                $("#claimModal").modal("hide");
                $("#content-wrapper").find("[data-disable-inzien]").addClass("pointer-events-none").find("input,select,button,a,textarea").attr("disabled", true);
            });
        }
    },
    // Functie om velden te submitten via ajax
    postFields: function() {
        var postFields = {};
        postFields["formAction"] = "bewaar_volmacht_velden";
        postFields["totalen"] = {};
        $("td input.correctie").each(function() {
            var trId = $(this).closest("tr").attr("id");
            var jaar = $(this).attr("data-jaar");
            var check = $(this).attr("data-check");
            var nieuw = Math.round(parseFloat($(this).val().replace(",", ".")));
            // var fieldname = trId+'['+jaar+']['+check+']';
            // var object = {};
            if (postFields["totalen"][trId] === undefined) postFields["totalen"][trId] = {};
            if (postFields["totalen"][trId][jaar] === undefined) postFields["totalen"][trId][jaar] = {};
            if (postFields["totalen"][trId][jaar][check] === undefined) postFields["totalen"][trId][jaar][check] = {};
            postFields["totalen"][trId][jaar][check] = nieuw;
        });
        var actionArray = [
            document.URL,
            "saveVolmachtFields"
        ];
        $.post(actionArray.join("/"), postFields, function(data) {
            if (data == false) {
                (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
                $("tr td input.verschil").closest("div.form-group").removeClass("has-error").removeClass("has-success").removeClass("has-warning").addClass("has-warning");
            } else $("tr td input.verschil").closest("div.form-group").removeClass("has-warning");
        });
    }
};
var $c84fdb535a392bd5$export$2e2bcd8739ae039 = $c84fdb535a392bd5$var$checkVolmacht;



var $hzkBE = parcelRequire("hzkBE");
var $ff915a4c23403e07$exports = {};
/**
 * easytimer.js
 * Generated: 2023-08-28
 * Version: 4.6.0
 */ (function(global, factory) {
    factory($ff915a4c23403e07$exports);
})($ff915a4c23403e07$exports, function(exports1) {
    "use strict";
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function leftPadding(string, padLength, character) {
        var i;
        var characters = "";
        string = typeof string === "number" ? String(string) : string;
        if (string.length > padLength) return string;
        for(i = 0; i < padLength; i = i + 1)characters += String(character);
        return (characters + string).slice(-characters.length);
    }
    function TimeCounter() {
        this.reset();
    }
    /**
   * [toString convert the counted values on a string]
   * @param  {array} units           [array with the units to display]
   * @param  {string} separator       [separator of the units]
   * @param  {number} leftZeroPadding [number of zero padding]
   * @return {string}                 [result string]
   */ TimeCounter.prototype.toString = function() {
        var units = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "hours",
            "minutes",
            "seconds"
        ];
        var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ":";
        var leftZeroPadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
        units = units || [
            "hours",
            "minutes",
            "seconds"
        ];
        separator = separator || ":";
        leftZeroPadding = leftZeroPadding || 2;
        var arrayTime = [];
        var i;
        for(i = 0; i < units.length; i = i + 1)if (this[units[i]] !== undefined) {
            if (units[i] === "secondTenths") arrayTime.push(this[units[i]]);
            else arrayTime.push(leftPadding(this[units[i]], leftZeroPadding, "0"));
        }
        return arrayTime.join(separator);
    };
    /**
   * [reset reset counter]
   */ TimeCounter.prototype.reset = function() {
        this.secondTenths = 0;
        this.seconds = 0;
        this.minutes = 0;
        this.hours = 0;
        this.days = 0;
    };
    function EventEmitter() {
        this.events = {};
    }
    EventEmitter.prototype.on = function(event, listener) {
        var _this = this;
        if (!Array.isArray(this.events[event])) this.events[event] = [];
        this.events[event].push(listener);
        return function() {
            return _this.removeListener(event, listener);
        };
    };
    EventEmitter.prototype.removeListener = function(event, listener) {
        if (Array.isArray(this.events[event])) {
            var eventIndex = this.events[event].indexOf(listener);
            if (eventIndex > -1) this.events[event].splice(eventIndex, 1);
        }
    };
    EventEmitter.prototype.removeAllListeners = function(event) {
        if (!event) this.events = {};
        else if (Array.isArray(this.events[event])) this.events[event] = [];
    };
    EventEmitter.prototype.emit = function(event) {
        var _this2 = this;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (Array.isArray(this.events[event])) this.events[event].forEach(function(listener) {
            return listener.apply(_this2, args);
        });
    };
    /*
   * General functions, variables and constants
   */ var SECOND_TENTHS_PER_SECOND = 10;
    var SECONDS_PER_MINUTE = 60;
    var MINUTES_PER_HOUR = 60;
    var HOURS_PER_DAY = 24;
    var SECOND_TENTHS_POSITION = 0;
    var SECONDS_POSITION = 1;
    var MINUTES_POSITION = 2;
    var HOURS_POSITION = 3;
    var DAYS_POSITION = 4;
    var SECOND_TENTHS = "secondTenths";
    var SECONDS = "seconds";
    var MINUTES = "minutes";
    var HOURS = "hours";
    var DAYS = "days";
    var VALID_INPUT_VALUES = [
        SECOND_TENTHS,
        SECONDS,
        MINUTES,
        HOURS,
        DAYS
    ];
    var unitsInMilliseconds = {
        secondTenths: 100,
        seconds: 1000,
        minutes: 60000,
        hours: 3600000,
        days: 86400000
    };
    var groupedUnits = {
        secondTenths: SECOND_TENTHS_PER_SECOND,
        seconds: SECONDS_PER_MINUTE,
        minutes: MINUTES_PER_HOUR,
        hours: HOURS_PER_DAY
    };
    function mod(number, module) {
        return (number % module + module) % module;
    }
    /**
   * [Timer Timer/Chronometer/Countdown compatible with AMD and NodeJS.
   * Can update time values with different time intervals: tenth of seconds,
   * seconds, minutes and hours.]
   */ function Timer() {
        var defaultParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        /*
    * PRIVATE variables and Functions
    */ var counters = new TimeCounter();
        var totalCounters = new TimeCounter();
        var intervalId;
        var eventEmitter = new EventEmitter();
        var running = false;
        var paused = false;
        var precision;
        var timerTypeFactor;
        var customCallback;
        var timerConfig = {};
        var currentParams;
        var targetValues;
        var startValues;
        var countdown;
        var startingDate;
        var targetDate;
        var eventData = {
            detail: {
                timer: this
            }
        };
        setParams(defaultParams);
        function updateCounters(precision, roundedValue) {
            var unitsPerGroup = groupedUnits[precision];
            totalCounters[precision] = roundedValue;
            if (precision === DAYS) counters[precision] = Math.abs(roundedValue);
            else if (roundedValue >= 0) counters[precision] = mod(roundedValue, unitsPerGroup);
            else counters[precision] = mod(unitsPerGroup - mod(roundedValue, unitsPerGroup), unitsPerGroup);
        }
        function updateDays(value) {
            return updateUnitByPrecision(value, DAYS);
        }
        function updateHours(value) {
            return updateUnitByPrecision(value, HOURS);
        }
        function updateMinutes(value) {
            return updateUnitByPrecision(value, MINUTES);
        }
        function updateSeconds(value) {
            return updateUnitByPrecision(value, SECONDS);
        }
        function updateSecondTenths(value) {
            return updateUnitByPrecision(value, SECOND_TENTHS);
        }
        function updateUnitByPrecision(value, precision) {
            var previousValue = totalCounters[precision];
            updateCounters(precision, calculateIntegerUnitQuotient(value, unitsInMilliseconds[precision]));
            return totalCounters[precision] !== previousValue;
        }
        function stopTimerAndResetCounters() {
            stopTimer();
            resetCounters();
        }
        function stopTimer() {
            clearInterval(intervalId);
            intervalId = undefined;
            running = false;
            paused = false;
        }
        function setParamsAndStartTimer(params) {
            if (!isPaused()) setParams(params);
            else {
                startingDate = calculateStartingDate();
                targetValues = setTarget(currentParams.target);
            }
            startTimer();
        }
        function startTimer() {
            var interval = unitsInMilliseconds[precision];
            if (isTargetAchieved(roundTimestamp(Date.now()))) return;
            intervalId = setInterval(updateTimerAndDispatchEvents, interval);
            running = true;
            paused = false;
        }
        function calculateStartingDate() {
            return roundTimestamp(Date.now()) - totalCounters.secondTenths * unitsInMilliseconds[SECOND_TENTHS] * timerTypeFactor;
        }
        function updateTimerAndDispatchEvents() {
            var currentTime = roundTimestamp(Date.now());
            var valuesUpdated = updateTimer();
            dispatchEvents(valuesUpdated);
            customCallback(eventData.detail.timer);
            if (isTargetAchieved(currentTime)) {
                stop();
                dispatchEvent("targetAchieved", eventData);
            }
        }
        function updateTimer() {
            var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roundTimestamp(Date.now());
            var elapsedTime = timerTypeFactor > 0 ? currentTime - startingDate : startingDate - currentTime;
            var valuesUpdated = {};
            valuesUpdated[SECOND_TENTHS] = updateSecondTenths(elapsedTime);
            valuesUpdated[SECONDS] = updateSeconds(elapsedTime);
            valuesUpdated[MINUTES] = updateMinutes(elapsedTime);
            valuesUpdated[HOURS] = updateHours(elapsedTime);
            valuesUpdated[DAYS] = updateDays(elapsedTime);
            return valuesUpdated;
        }
        function roundTimestamp(timestamp) {
            return Math.floor(timestamp / unitsInMilliseconds[precision]) * unitsInMilliseconds[precision];
        }
        function dispatchEvents(valuesUpdated) {
            if (valuesUpdated[SECOND_TENTHS]) dispatchEvent("secondTenthsUpdated", eventData);
            if (valuesUpdated[SECONDS]) dispatchEvent("secondsUpdated", eventData);
            if (valuesUpdated[MINUTES]) dispatchEvent("minutesUpdated", eventData);
            if (valuesUpdated[HOURS]) dispatchEvent("hoursUpdated", eventData);
            if (valuesUpdated[DAYS]) dispatchEvent("daysUpdated", eventData);
        }
        function isTargetAchieved(currentDate) {
            return targetValues instanceof Array && currentDate >= targetDate;
        }
        function resetCounters() {
            counters.reset();
            totalCounters.reset();
        }
        function setParams(params) {
            params = params || {};
            precision = checkPrecision(params.precision);
            customCallback = typeof params.callback === "function" ? params.callback : function() {};
            countdown = params.countdown === true;
            timerTypeFactor = countdown === true ? -1 : 1;
            if (_typeof(params.startValues) === "object") setStartValues(params.startValues);
            else startValues = null;
            startingDate = calculateStartingDate();
            updateTimer();
            if (_typeof(params.target) === "object") targetValues = setTarget(params.target);
            else if (countdown) {
                params.target = {
                    seconds: 0
                };
                targetValues = setTarget(params.target);
            } else targetValues = null;
            timerConfig = {
                precision: precision,
                callback: customCallback,
                countdown: _typeof(params) === "object" && params.countdown === true,
                target: targetValues,
                startValues: startValues
            };
            currentParams = params;
        }
        function checkPrecision(precision) {
            precision = typeof precision === "string" ? precision : SECONDS;
            if (!isValidInputValue(precision)) throw new Error("Error in precision parameter: ".concat(precision, " is not a valid value"));
            return precision;
        }
        function isValidInputValue(value) {
            return VALID_INPUT_VALUES.indexOf(value) >= 0;
        }
        function configInputValues(inputValues) {
            var values;
            if (_typeof(inputValues) === "object") {
                if (inputValues instanceof Array) {
                    if (inputValues.length !== 5) throw new Error("Array size not valid");
                    values = inputValues;
                } else {
                    for(var value in inputValues){
                        if (VALID_INPUT_VALUES.indexOf(value) < 0) throw new Error("Error in startValues or target parameter: ".concat(value, " is not a valid input value"));
                    }
                    values = [
                        inputValues.secondTenths || 0,
                        inputValues.seconds || 0,
                        inputValues.minutes || 0,
                        inputValues.hours || 0,
                        inputValues.days || 0
                    ];
                }
            }
            values = values.map(function(value) {
                return parseInt(value, 10);
            });
            var secondTenths = values[SECOND_TENTHS_POSITION];
            var seconds = values[SECONDS_POSITION] + calculateIntegerUnitQuotient(secondTenths, SECOND_TENTHS_PER_SECOND);
            var minutes = values[MINUTES_POSITION] + calculateIntegerUnitQuotient(seconds, SECONDS_PER_MINUTE);
            var hours = values[HOURS_POSITION] + calculateIntegerUnitQuotient(minutes, MINUTES_PER_HOUR);
            var days = values[DAYS_POSITION] + calculateIntegerUnitQuotient(hours, HOURS_PER_DAY);
            values[SECOND_TENTHS_POSITION] = secondTenths % SECOND_TENTHS_PER_SECOND;
            values[SECONDS_POSITION] = seconds % SECONDS_PER_MINUTE;
            values[MINUTES_POSITION] = minutes % MINUTES_PER_HOUR;
            values[HOURS_POSITION] = hours % HOURS_PER_DAY;
            values[DAYS_POSITION] = days;
            return values;
        }
        function calculateIntegerUnitQuotient(unit, divisor) {
            var quotient = unit / divisor;
            return quotient < 0 ? Math.ceil(quotient) : Math.floor(quotient);
        }
        function setTarget(inputTarget) {
            if (!inputTarget) return;
            targetValues = configInputValues(inputTarget);
            var targetCounter = calculateTotalCounterFromValues(targetValues);
            targetDate = startingDate + targetCounter.secondTenths * unitsInMilliseconds[SECOND_TENTHS] * timerTypeFactor;
            return targetValues;
        }
        function setStartValues(inputStartValues) {
            startValues = configInputValues(inputStartValues);
            counters.secondTenths = startValues[SECOND_TENTHS_POSITION];
            counters.seconds = startValues[SECONDS_POSITION];
            counters.minutes = startValues[MINUTES_POSITION];
            counters.hours = startValues[HOURS_POSITION];
            counters.days = startValues[DAYS_POSITION];
            totalCounters = calculateTotalCounterFromValues(startValues, totalCounters);
        }
        function calculateTotalCounterFromValues(values, outputCounter) {
            var total = outputCounter || {};
            total.days = values[DAYS_POSITION];
            total.hours = total.days * HOURS_PER_DAY + values[HOURS_POSITION];
            total.minutes = total.hours * MINUTES_PER_HOUR + values[MINUTES_POSITION];
            total.seconds = total.minutes * SECONDS_PER_MINUTE + values[SECONDS_POSITION];
            total.secondTenths = total.seconds * SECOND_TENTHS_PER_SECOND + values[[
                SECOND_TENTHS_POSITION
            ]];
            return total;
        }
        /*
     * PUBLIC functions
     */ /**
     * [stop stops the timer and resets the counters. Dispatch stopped event]
     */ function stop() {
            stopTimerAndResetCounters();
            dispatchEvent("stopped", eventData);
        }
        /**
     * [stop stops and starts the timer. Dispatch stopped event]
     */ function reset() {
            stopTimerAndResetCounters();
            setParamsAndStartTimer(currentParams);
            dispatchEvent("reset", eventData);
        }
        /**
     * [start starts the timer configured by the params object. Dispatch started event]
     * @param  {object} params [Configuration parameters]
     */ function start() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            params = _objectSpread2(_objectSpread2({}, defaultParams), params);
            if (isRunning()) return;
            setParamsAndStartTimer(params);
            dispatchEvent("started", eventData);
        }
        /**
     * [pause stops the timer without resetting the counters. The timer it can be restarted with start function.
     * Dispatch paused event]
     * @return {type} [description]
     */ function pause() {
            stopTimer();
            paused = true;
            dispatchEvent("paused", eventData);
        }
        /**
     * [addEventListener Adds event listener to the timer]
     * @param {string} eventType      [event to listen]
     * @param {function} listener   [the event listener function]
     */ function addEventListener(eventType, listener) {
            eventEmitter.on(eventType, listener);
        }
        /**
     * [removeEventListener Removes event listener to the timer]
     * @param  {string} eventType    [event to remove listener]
     * @param  {function} listener [listener to remove]
     */ function removeEventListener(eventType, listener) {
            eventEmitter.removeListener(eventType, listener);
        }
        /**
     * [removeAllEventListeners Removes all events listeners for the given type, no type to remove all types]
     * @param  {string} [eventType]  [event to remove listener]
     */ function removeAllEventListeners(eventType) {
            eventEmitter.removeAllListeners(eventType);
        }
        /**
     * [dispatchEvent dispatches an event]
     * @param  {string} eventType [event to dispatch]
     * @param data
     */ function dispatchEvent(eventType, data) {
            eventEmitter.emit(eventType, data);
        }
        /**
     * [isRunning return true if the timer is running]
     * @return {Boolean}
     */ function isRunning() {
            return running;
        }
        /**
     * [isPaused returns true if the timer is paused]
     * @return {Boolean}
     */ function isPaused() {
            return paused;
        }
        /**
     * [getTimeValues returns the counter with the current timer values]
     * @return {TimeCounter}
     */ function getTimeValues() {
            return counters;
        }
        /**
     * [getTotalTimeValues returns the counter with the current timer total values]
     * @return {TimeCounter}
     */ function getTotalTimeValues() {
            return totalCounters;
        }
        /**
     * [getConfig returns the configuration parameters]
     * @return {type}
     */ function getConfig() {
            return timerConfig;
        }
        /**
     * Public API
     * Definition of Timer instance public functions
     */ if (typeof this !== "undefined") {
            this.start = start;
            this.pause = pause;
            this.stop = stop;
            this.reset = reset;
            this.isRunning = isRunning;
            this.isPaused = isPaused;
            this.getTimeValues = getTimeValues;
            this.getTotalTimeValues = getTotalTimeValues;
            this.getConfig = getConfig;
            this.addEventListener = addEventListener;
            this.on = addEventListener;
            this.removeEventListener = removeEventListener;
            this.removeAllEventListeners = removeAllEventListeners;
            this.off = removeEventListener;
        }
    }
    exports1.Timer = Timer;
    exports1.default = Timer;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


const $ec507a6ded59648f$var$checkVolmachtWerknemers = {
    init () {
        // Functie om te voorkomen dat een dropdown dicht gaat als er op een select geklikt wordt
        $("#content-wrapper .dropdown-menu").on("click", function(e) {
            e.stopPropagation();
        });
        // $('button.float-right').click(postFields);
        // Functie om verschil te berekenen als correctie wordt ingegeven
        var start = true;
        $("td input.correctie").change(function() {
            var trId = $(this).closest("tr").attr("id");
            var jaar = $(this).attr("jaar");
            var check = $(this).attr("check");
            var nieuw = Math.round(parseFloat($(this).val().replace(",", ".")));
            var oud = Math.round(parseFloat($(".form-group." + check + " input.oud[jaar=" + jaar + "]").val().replace(",", ".")));
            var verschil = nieuw - oud;
            $("tr#" + trId + " .form-group." + check + " input.verschil[jaar=" + jaar + "]").closest("div.form-group").removeClass("has-error").removeClass("has-success").removeClass("has-warning");
            $("tr#" + trId + " .form-group." + check + " input.verschil[jaar=" + jaar + "]").val(verschil);
            $("tr#" + trId + " .form-group." + check + " input.correctie[jaar=" + jaar + "]").val(nieuw);
            if (verschil < 0) $("tr#" + trId + " .form-group." + check + " input.verschil[jaar=" + jaar + "]").closest("div.form-group").addClass("has-error");
            else $("tr#" + trId + " .form-group." + check + " input.verschil[jaar=" + jaar + "]").closest("div.form-group").addClass("has-success");
            if (start != true) $ec507a6ded59648f$var$checkVolmachtWerknemers.postFields();
        // actionArray = [document.URL, "savePart", trId.replace('_','/'), jaar, check, nieuw];
        // $.getJSON(actionArray.join('/'), function (data) {
        // 	if (data == false) {
        // 		bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
        // 		$('tr#'+trId+' td.'+check+' input.verschil[jaar='+jaar+']').closest('div.form-group').addClass('has-warning');
        // 	} else {
        // 		if(verschil<0){
        // 			$('tr#'+trId+' td.'+check+' input.verschil[jaar='+jaar+']').closest('div.form-group').addClass('has-error');
        // 		} else {
        // 			$('tr#'+trId+' td.'+check+' input.verschil[jaar='+jaar+']').closest('div.form-group').addClass('has-success');
        // 		}
        // 	}
        // });
        });
        $("td input.correctie").trigger("change");
        start = false;
        $ec507a6ded59648f$var$checkVolmachtWerknemers.postFields();
        // Geef upload soort mee aan click functie
        $(".dropdown-upload").click(function(e) {
            e.preventDefault();
            $("input#fileUploadField").attr("name", $(this).data("upload-type"));
            $("input#fileUploadField").click();
        });
        // Submit direct als bestand geselecteerd wordt
        $("#fileUploadField").on("change", function() {
            $("#uploadFileForm").submit();
        });
        // Vul standaard reden in reden veld in
        $("#afwijzenStandaardReden").change(function() {
            var value = $(this).val();
            if (value != "") {
                if ($("#afwijsReden").val() != "") {
                    (0, $hzkBE.default)("danger", "Let op:", "Er staat al tekst in het reden veld. Verwijder dit eerst.");
                    $(this).val("");
                } else $("#afwijsReden").val($(this).find("option[value='" + $(this).val() + "']").text().trim()).trigger("blur");
            }
        });
        // Logout Timer
        timer = new timer();
        timer.start({
            countdown: true,
            startValues: {
                seconds: 1200
            }
        });
        timer.addEventListener("secondsUpdated", function() {
            $("#actionCountdown").html(timer.getTimeValues().toString([
                "minutes",
                "seconds"
            ]));
        });
        // Toon waarschuwing als deze actie reeds wordt bewerkt
        if ($("#claimModal").length) $("#claimModal").modal({
            backdrop: "static",
            keyboard: false
        }, "show");
        // Init table range
        $("[data-atable]").checkboxes("range", true);
        // Voeg arcering toe
        $("[data-atable] input[type=checkbox]").change(function(e) {
            var p = $(this).closest("tr");
            p.removeClass("table-success");
            if (e.target.checked) p.addClass("table-success");
        });
        // Maak gehele row clickable
        $("[data-atable] tbody td").not("a").click(function() {
            var t = $(this).closest("tr").find("input[type=checkbox]");
            t.trigger("click").trigger("change");
        });
        $("[data-atable] tbody td i.fa-clipboard-check").click(function(e) {
            e.preventDefault();
        });
    },
    // Functie om velden te submitten via ajax
    postFields: function() {
        var postFields = {};
        postFields["formAction"] = "bewaar_volmacht_velden";
        postFields["totalen"] = {};
        $("td input.correctie").each(function() {
            var trId = $(this).closest("tr").attr("id");
            var jaar = $(this).attr("jaar");
            var check = $(this).attr("check");
            var nieuw = Math.round(parseFloat($(this).val().replace(",", ".")));
            // var fieldname = trId+'['+jaar+']['+check+']';
            // var object = {};
            if (postFields["totalen"][trId] === undefined) postFields["totalen"][trId] = {};
            if (postFields["totalen"][trId][jaar] === undefined) postFields["totalen"][trId][jaar] = {};
            if (postFields["totalen"][trId][jaar][check] === undefined) postFields["totalen"][trId][jaar][check] = {};
            postFields["totalen"][trId][jaar][check] = nieuw;
        });
        var actionArray = [
            document.URL,
            "saveVolmachtFields"
        ];
        $.post(actionArray.join("/"), postFields, function(data) {
            if (data == false) {
                (0, $hzkBE.default)("danger", "", "Er is iets fout gegaan met het opslaan van de gegevens!");
                $("tr td input.verschil").closest("div.form-group").removeClass("has-error").removeClass("has-success").removeClass("has-warning").addClass("has-warning");
            } else $("tr td input.verschil").closest("div.form-group").removeClass("has-warning");
        });
    }
};
var $ec507a6ded59648f$export$2e2bcd8739ae039 = $ec507a6ded59648f$var$checkVolmachtWerknemers;



var $JSMaE = parcelRequire("JSMaE");

const $a24eff37ee5ac0c7$var$individueel = {
    init () {
        // Initialiseer stappen
        $a24eff37ee5ac0c7$var$individueel.initSteps();
        // Verkrijg stap nummer uit navigatie tabs
        var stap = $(".nav-tabs").data("stap");
        // Fade de content in
        $(".tab-content").hide().removeClass("d-none").fadeIn(300);
        // Toon het introductiemodal in stap 1
        if (stap == 1) $(".modal-naverrekening-introductie").modal("show", {
            backdrop: "static",
            keyboard: false
        });
        // Javascript t.b.v. stap 1
        if (stap == 2) {
            // Bind functie om het format van het periodeLoon af te dwingen aan input
            $("input.periodeLoon").change(function() {
                $a24eff37ee5ac0c7$var$individueel.formatPeriodeloon();
            });
            // Format het periodeLoon als de pagina geladen wordt
            $a24eff37ee5ac0c7$var$individueel.formatPeriodeloon();
        }
        // Javascript t.b.v. stap 3
        if (stap == 3) {
            // Unbind de submit, toon de bevestigingsmodal en bind submit aan de submit modal
            $("form[data-validate]").attr("data-validate-onsubmit-disabled", true);
            $("form[data-validate]").submit(async function() {
                let validated = await (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkSubmitForm(this);
                if (validated) {
                    $(".modal-naverrekening-indienen").modal("show");
                    $(".btn-definitief-indienen").click(function() {
                        $("form[data-validate]").unbind("submit");
                        $("form[data-validate]").submit();
                        $("#loadingModal").modal("show", {
                            keyboard: false,
                            backdrop: "static"
                        });
                    });
                }
                return false;
            });
        }
        // Javascript t.b.v. stap 9
        if (stap == 9) {
            // Enable de input als de checkbox van de input-group aangevinkt wordt
            $('.input-group-addon input[type="checkbox"]').change(function() {
                var checked = $(this).is(":checked");
                if (checked) {
                    $(this).closest("tr").find('input[type="text"]').removeAttr("disabled");
                    $(this).closest("tr").find('input[type="text"]').each(function() {
                        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(this);
                    });
                    $(this).closest("tr").find('.input-group input[type="text"]:first-of-type').focus();
                } else {
                    $(this).closest("tr").find('input[type="text"]').attr("disabled", "true");
                    $(this).closest("tr").find('input[type="text"]').each(function() {
                        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(this);
                    });
                }
            });
            $(".input-group-addon input").trigger("change");
        }
    },
    // Functie om het format van het periodeLoon af te dwingen
    formatPeriodeloon: function() {
        var periodeLoonVerloondSV = $("#periodeLoonVerloondSV").val();
        periodeLoonVerloondSV = (0, $JSMaE.default).currencyNoSeparator(periodeLoonVerloondSV);
        $("#periodeLoonVerloondSV").val(periodeLoonVerloondSV);
    },
    // Functie om de stappen te initialiseren
    initSteps: function() {
        // Tel totaal aantal tabs (stappen)
        var stepsTotal = $(".sw-main ul.nav-tabs li").length;
        // Nummer de stappen op basis van aanwezig aantal tabs
        $(".nav-tabs li a b.step-number").each(function(i) {
            $(this).text(i + 1);
        });
        // Bereken de breedte van de tabs
        $(".sw-main ul.nav-tabs li").css("width", "calc((100%)/" + stepsTotal + ")");
        // Fade de tabs in
        $(".sw-main").hide().removeClass("d-none").fadeIn(300);
    }
};
var $a24eff37ee5ac0c7$export$2e2bcd8739ae039 = $a24eff37ee5ac0c7$var$individueel;




const $1035751ca8e81f91$var$standaard = {
    init () {
        const target = document.querySelector("body");
        (0, $f8a311d146402a10$export$2e2bcd8739ae039).init(target);
        // Verkrijg stap nummer uit navigatie tabs
        var stap = $(".nav-tabs").data("stap");
        // Initialiseer stappen
        $1035751ca8e81f91$var$standaard.initProgressBar();
        // Toon submit button bovenaan tabel als er meer dan 20 werknemers in de tabel staan.
        $1035751ca8e81f91$var$standaard.toggleTopSubmitButton();
        // Toon de introductie modal in stap 1 en fade de loading waarschuwing in en fade de content in en toon de aTable als die aanwezig en geladen is
        $1035751ca8e81f91$var$standaard.initContent(stap);
        // Toon checkbox "Er zijn in deze periode geen werknemers met een actief dienstverband geweest" wanneer nodig
        $1035751ca8e81f91$var$standaard.toggleGeenWerknemersInDienst();
        // Javascript t.b.v. stap 7
        if (stap == 7) {
            // Unbind de submit, toon de bevestigingsmodal en bind submit aan de submit modal
            $("form[data-validate]").attr("data-validate-onsubmit-disabled", true);
            $("form[data-validate]").submit(async function() {
                let validated = await (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkSubmitForm(this);
                if (validated) {
                    $(".modal-naverrekening-indienen").modal("show");
                    $(".btn-definitief-indienen").click(function() {
                        $("form[data-validate]").unbind("submit");
                        $("form[data-validate]").submit();
                        $(".modal-naverrekening-indienen").modal("hide");
                        $("#loadingModal").modal("show", {
                            keyboard: false,
                            backdrop: "static"
                        });
                    });
                }
                return false;
            });
        }
        // Upload bevestiging
        $("#uploadBevestiging, #importUpload").change(function(e) {
            e.preventDefault();
            $1035751ca8e81f91$var$standaard.checkImportOk(this);
        });
        // Draai checkSubmitOk validatie functie in stap 2 t/, 6 en normale validatie in stap 1
        switch(stap){
            case 2:
            case 3:
            case 4:
                $(".btn-import-export-modal").click(function(e) {
                    e.preventDefault();
                    $("#importExportModal").modal("hide");
                    $("#importExportToelichtingModal").modal("show");
                });
                $(".btn-import-export-modal-terug").click(function(e) {
                    e.preventDefault();
                    $("#importExportToelichtingModal").modal("hide");
                    $("#importExportModal").modal("show");
                });
            case 5:
            case 6:
                // Draai checkSubmitOk validatie functie
                $("form[data-validate]#mainForm").submit($1035751ca8e81f91$var$standaard.checkSubmitOk);
                break;
            case 1:
            default:
                // Draai normale validatie functie
                $("form[data-validate]#mainForm").submit((0, $a60bd1631756ee00$export$2e2bcd8739ae039).submitForm);
                break;
        }
        // Javascript t.b.v. stap 4 en 6
        switch(stap){
            case 4:
            case 6:
                // Valideer salarisformulier on submit
                $("form[data-validate]#form-salarissen").submit((0, $a60bd1631756ee00$export$2e2bcd8739ae039).submitForm);
                // Draai functie als inhoude van tabel geladen is
                // Draai functie als inhoude van tabel geladen is
                $("[data-atable]").on("aTable:draw", function() {
                    // Deactiveer click functie op
                    $(".open-salaris-modal").unbind("click");
                    // Functie om salaris modal te openen met buttons in listing
                    $(".open-salaris-modal").click($1035751ca8e81f91$var$standaard.openSalarisModal);
                });
                // Submit modal als op opslaan geklikt wordt
                $("#salarisAanpassenModal .btn-success").click(function() {
                    $("#salarisAanpassenModal form").submit();
                });
                // Controleer of het salaris al voorkomt
                $("#salarisAanpassenModal #Begindatum").change($1035751ca8e81f91$var$standaard.controleerOfSalarisVoorkomt);
                // Toon de importExportModalFeedback modal als hij er is.
                if ($("#importExportModalFeedback").length) $("#importExportModalFeedback").modal("show");
                break;
        }
    },
    // Functie om de stappen te initialiseren
    initProgressBar: function() {
        // Nummer de stappen op basis van aanwezig aantal tabs
        $(".nav-tabs li a b.step-number").each(function(i) {
            $(this).text(i + 1);
        });
        // Tel totaal aantal tabs (stappen) en bereken de breedte van de tabs
        var stepsTotal = $(".sw-main ul.nav-tabs li").length;
        $(".sw-main ul.nav-tabs li").css("width", "calc((100%)/" + stepsTotal + ")");
        // Fade de tabs in
        $(".sw-main").hide().removeClass("d-none").fadeIn(300);
    },
    // Functie die checkt of er een bestand is geselecteed en de gebruiker akkoord is
    checkImportOk: function(m) {
        var c = $("#uploadBevestiging").prop("checked");
        var u = $("#importUpload");
        var t = $("#buttonImport");
        var f = $("#feedbackCSV");
        var e = u.val().split(".").pop().toLowerCase();
        if (c == true && u[0].files.length == true && e == "csv") {
            t.removeAttr("disabled");
            f.addClass("d-none").removeClass("d-inline");
        } else {
            t.attr("disabled", true);
            if ($(m).attr("name") == "importUpload") {
                f.removeClass("d-none").addClass("d-inline");
                if (e != "csv") {
                    u.attr("value", "");
                    u.blur();
                    setTimeout(function() {
                        u.closest(".form-group").find(".file-input-wrapper span").html(u.attr("title"));
                    }, 100);
                }
            }
        }
        if (e == "csv") f.addClass("d-none").removeClass("d-inline");
    },
    // Functie om te stap te valideren voor submit
    checkSubmitOk: function(stap) {
        // Verberg de bevestigingsmodal
        $(".modal-naverrekening-indienen").modal("hide");
        // Verkrijg stap nummer uit navigatie tabs
        stap = $(".nav-tabs").data("stap");
        if (stap == 6) {
            // Check of de checkbox "geen werknemers in dienst" is aangevinkt
            var geenWerknemersInDienst = $("[name=geenWerknemersInDienst]").val();
            if (geenWerknemersInDienst === "true") return true;
        }
        // Geef waarschuwing als aTable leeg is
        var count = (0, $f8a311d146402a10$export$2e2bcd8739ae039).getRows().length;
        if (count == 0) {
            $("#modalGeenMedewerkers").modal("show");
            return false;
        }
        // Controleer in stap 4 en 6 of er ontbrekende salarissen zijn
        if (stap == 4 || stap == 6) {
            // Tel de ontbrekende salarissen
            var ontbrekendeSalarissen = 0;
            // var rows = document.querySelectorAll('[data-atable]')[0].aTable().getRows();
            var rows = (0, $f8a311d146402a10$export$2e2bcd8739ae039).getRows();
            $.each(rows, function(i, e) {
                if (e[1] == "danger") ontbrekendeSalarissen++;
            });
            // Toon waarschuwing bij ontbrekende salarissen
            if (ontbrekendeSalarissen > 0) {
                $("#modalSalarisOntbreekt").modal("show");
                $("#modalSalarisOntbreekt #ontbrekendeSalarissen").text(ontbrekendeSalarissen);
                if (ontbrekendeSalarissen > 1) $("#modalSalarisOntbreekt #ontbrekendeSalarissenMeervoud").removeClass("d-none");
                else $("#modalSalarisOntbreekt #ontbrekendeSalarissenEnkelvoud").removeClass("d-none");
                return false;
            }
        }
        return true;
    },
    // Function om salaris modal te openen
    openSalarisModal: function(e) {
        // Deactiveer default functie van geklikt element
        e.preventDefault();
        // Verberg element d.m.v. bootstrap display none class
        $("#salarisAanpassenModal .salaris-type").removeClass("d-none").addClass("d-none");
        // Geef werknemer ID mee aan modal en input
        var salarisModal = this;
        var werknemer_id = $(this).data("werknemer_id");
        $("#salarisAanpassenModal").data("werknemer_id", werknemer_id);
        $("#salarisAanpassenModal #werknemer_id").val(werknemer_id);
        // Geef werknemer ID mee aan modal en input
        var werknemer_salaris_id = $(this).data("werknemer_salaris_id");
        $("#salarisAanpassenModal").data("werknemer_salaris_id", werknemer_salaris_id);
        $("#salarisAanpassenModal #werknemer_salaris_id").val(werknemer_salaris_id);
        // Toon modal titel en voeg "corrigeren" of "toevoegen" toe als werknemer_salaris_id nog niet bestaat
        $("#salarisAanpassenModal h4").removeClass("d-none").addClass("d-none");
        if (werknemer_salaris_id == "") {
            $("#salarisAanpassenModal h4#salarisAanpassenModalLabelToevoegen").removeClass("d-none");
            $("#salarisAanpassenModal #Begindatum").removeAttr("READONLY");
        } else {
            $("#salarisAanpassenModal h4#salarisAanpassenModalLabelCorrigeren").removeClass("d-none");
            $("#salarisAanpassenModal #Begindatum").attr("READONLY", true);
        }
        // Voeg naam van werknemer toe aan modal titel
        var werknemer_naam = $(this).data("werknemer_naam");
        $(".modal-title .werknemer-naam").html(werknemer_naam);
        // Verkrijg juiste begindatum
        var Begindatum = $(this).data("begindatum");
        var BegindatumDefault = $("#salarisAanpassenModal #Begindatum").data("default");
        var re = /^\d{1,2}-\d{1,2}-\d{4}?$/;
        if (re.test(Begindatum)) {
            var BegindatumSplit = Begindatum.split("-");
            var jaar = parseInt(BegindatumSplit[2]);
            var BegindatumDefaultSplit = BegindatumDefault.split("-");
            var jaarDefault = parseInt(BegindatumDefaultSplit[2]);
            if (jaar < jaarDefault) Begindatum = BegindatumDefault;
        } else Begindatum = BegindatumDefault;
        $("#salarisAanpassenModal #Begindatum").val(Begindatum);
        // Vergrijg de juiste einddatum
        var Einddatum = $(this).data("einddatum");
        var EinddatumDefault = $("#salarisAanpassenModal #Einddatum").data("default");
        // Valideer en formateer de einddatum
        re = /^\d{1,2}-\d{1,2}-\d{4}?$/;
        if (re.test(Einddatum)) {
            var EinddatumSplit = Einddatum.split("-");
            jaar = parseInt(EinddatumSplit[2]);
            var EinddatumDefaultSplit = EinddatumDefault.split("-");
            jaarDefault = parseInt(EinddatumDefaultSplit[2]);
            if (jaar < jaarDefault) Einddatum = EinddatumDefault;
        } else Einddatum = EinddatumDefault;
        $("#salarisAanpassenModal #Einddatum").val(Einddatum);
        // Maak salaris afkorting soort kleine leters
        $("#salarisAanpassenModal .salaris-type").each(function() {
            var type = $(this).data("type");
            $("#salarisAanpassenModal .salaris-type-" + type + " input").val($(salarisModal).data("salaris_" + type.toLowerCase()));
        });
        // Maak begindatum required
        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired($("#salarisAanpassenModal #Begindatum"));
        $("#salarisAanpassenModal #Begindatum").trigger("change");
        // Open salaris modal
        $("#salarisAanpassenModal").modal("show", {
            backdrop: "static",
            keyboard: false
        });
        // Haal validatie classes weg na het openen van de modal
        $("#salarisAanpassenModal input,select").each(function() {
            (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeValidationClasses(this);
        });
    },
    // Function om te controleren of ingevoerd salaris reeds voorkomt
    controleerOfSalarisVoorkomt: function() {
        if ($("#salarisAanpassenModal #Begindatum").val() != "") {
            var path = $("#salarisAanpassenModal").data("duplicate-check-url");
            $.getJSON(path + $("#salarisAanpassenModal").data("werknemer_id") + "/" + $("#salarisAanpassenModal").data("werknemer_salaris_id") + "/get-types/" + $("#salarisAanpassenModal #Begindatum").val() + "/", function(data) {
                $("#salarisAanpassenModal .salaris-type").removeClass("d-none").addClass("d-none");
                $("#salarisAanpassenModal .salaris-type").find("input").each(function() {
                    (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(this);
                    $(this).attr("data-minvalue", 0);
                });
                $.each(data, function(index, val) {
                    $("#salarisAanpassenModal .salaris-type-" + val).removeClass("d-none");
                    $("#salarisAanpassenModal .salaris-type-" + val).find("input").each(function() {
                        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(this);
                        $(this).attr("data-minvalue", 1);
                    });
                });
            });
        }
    },
    // Toon checkbox "Er zijn in deze periode geen werknemers met een actief dienstverband geweest" wanneer nodig
    toggleTopSubmitButton: function() {
        $("[data-atable]").on("aTable:draw", function() {
            var c = (0, $f8a311d146402a10$export$2e2bcd8739ae039).getRows().length;
            var t = $("#geenWerknemersInDienst").closest(".form-group");
            if (c == 0) t.removeClass("d-none");
            else t.addClass("d-none");
        });
    },
    // Toon submit button bovenaan tabel als er meer dan 20 werknemers in de tabel staan.
    toggleGeenWerknemersInDienst: function() {
        $("[data-atable]").on("aTable:loaded", function() {
            var c = (0, $f8a311d146402a10$export$2e2bcd8739ae039).getRows().length;
            if (c > 20) $(".btn-next-top").removeClass("d-none");
        });
    },
    // Toon de introductie modal in stap 1 en fade de loading waarschuwing in en fade de content in en toon de aTable als die aanwezig en geladen is
    initContent: function(stap) {
        if (stap == 1) $(".modal-naverrekening-introductie").modal("show");
        else {
            $(".tab-loading").hide().removeClass("d-none").fadeIn(300);
            if ($("[data-atable]").length) $("[data-atable]").on("aTable:loaded", function() {
                $(".tab-loading").fadeOut(100, function() {
                    $(".tab-content").hide().removeClass("d-none").fadeIn(300);
                });
            });
            else $(".tab-loading").fadeOut(100, function() {
                $(".tab-content").hide().removeClass("d-none").fadeIn(300);
            });
        }
    }
};
var $1035751ca8e81f91$export$2e2bcd8739ae039 = $1035751ca8e81f91$var$standaard;



const $dd86f89524440111$var$verkort = {
    init () {
        // Verkrijg stap nummer uit navigatie tabs
        var stap = $(".nav-tabs").data("stap");
        // Initialiseer stappen
        $dd86f89524440111$var$verkort.initProgressBar();
        // Toon de introductie modal in stap 1 en fade de content in
        $dd86f89524440111$var$verkort.initContent(stap);
        // Javascript t.b.v. stap 4
        $dd86f89524440111$var$verkort.initSubmit(stap);
    },
    // Functie om de stappen te initialiseren
    initProgressBar: function() {
        // Nummer de stappen op basis van aanwezig aantal tabs
        $(".nav-tabs li a b.step-number").each(function(i) {
            $(this).text(i + 1);
        });
        // Tel totaal aantal tabs (stappen) en bereken de breedte van de tabs
        var stepsTotal = $(".sw-main ul.nav-tabs li").length;
        $(".sw-main ul.nav-tabs li").css("width", "calc((100%)/" + stepsTotal + ")");
        // Fade de tabs in
        $(".sw-main").hide().removeClass("d-none").fadeIn(300);
    },
    // Toon de introductie modal in stap 1 en fade de content in
    initContent: function(stap) {
        $(".tab-content").hide().removeClass("d-none").fadeIn(300);
        if (stap == 1) $(".modal-naverrekening-introductie").modal("show");
    },
    // Initialiseer de submit functies
    initSubmit: function(stap) {
        if (stap == 4) {
            // Unbind de submit, toon de bevestigingsmodal en bind submit aan de submit modal
            $("form[data-validate]").attr("data-validate-onsubmit-disabled", true);
            $("form[data-validate]").submit(async function() {
                let validated = await (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkSubmitForm(this);
                if (validated) {
                    $(".modal-naverrekening-indienen").modal("show");
                    $(".btn-definitief-indienen").click(function() {
                        $("form[data-validate]").unbind("submit");
                        $("form[data-validate]").submit();
                        $("#loadingModal").modal("show", {
                            keyboard: false,
                            backdrop: "static"
                        });
                    });
                }
                return false;
            });
        }
    }
};
var $dd86f89524440111$export$2e2bcd8739ae039 = $dd86f89524440111$var$verkort;



const $ff4afcbe59d9ce69$var$uitvraag = {
    init () {
        // Toon en verbeg kvk upload
        $("[name=gelieerdeOndernemingen]").on("change", function() {
            var t = $("[name=kvkUittreksel]");
            var g = t.closest(".form-group");
            (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(t);
            g.removeClass("d-none");
            if ($(this).val() == "n") {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(t);
                g.addClass("d-none");
            }
        });
        // Toon bevestigings modal na submit
        $("form[data-validate]").attr("data-validate-onsubmit-disabled", true);
        $("form[data-validate]").submit(async function() {
            let validated = await (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkSubmitForm(this);
            if (validated) {
                $("#modalBevestigen").modal("show");
                $(".btn-submit-confirm").click(function() {
                    $("form[data-validate]").unbind("submit");
                    $("form[data-validate]").submit();
                });
            }
            return false;
        });
    }
};
var $ff4afcbe59d9ce69$export$2e2bcd8739ae039 = $ff4afcbe59d9ce69$var$uitvraag;


const $951cd980113f19a9$var$importInitieel = {
    init: function() {
        (0, $ff4afcbe59d9ce69$export$2e2bcd8739ae039).init();
    }
};
var $951cd980113f19a9$export$2e2bcd8739ae039 = $951cd980113f19a9$var$importInitieel;



const $b3dac3cd90f7bd92$var$importInitieel = {
    init: function() {
        (0, $ff4afcbe59d9ce69$export$2e2bcd8739ae039).init();
    }
};
var $b3dac3cd90f7bd92$export$2e2bcd8739ae039 = $b3dac3cd90f7bd92$var$importInitieel;



const $d3b8a62ef2695f79$var$importInitieel = {
    init: function() {
        (0, $ff4afcbe59d9ce69$export$2e2bcd8739ae039).init();
    }
};
var $d3b8a62ef2695f79$export$2e2bcd8739ae039 = $d3b8a62ef2695f79$var$importInitieel;



const $96ae22bde93b0bf6$var$importInitieel = {
    init: function() {
        (0, $ff4afcbe59d9ce69$export$2e2bcd8739ae039).init();
    }
};
var $96ae22bde93b0bf6$export$2e2bcd8739ae039 = $96ae22bde93b0bf6$var$importInitieel;



const $e1676fb863008070$var$importInitieel = {
    init: function() {
        (0, $ff4afcbe59d9ce69$export$2e2bcd8739ae039).init();
    }
};
var $e1676fb863008070$export$2e2bcd8739ae039 = $e1676fb863008070$var$importInitieel;



const $bd64fdb00bd2c910$var$importInitieel = {
    init: function() {
        (0, $ff4afcbe59d9ce69$export$2e2bcd8739ae039).init();
    }
};
var $bd64fdb00bd2c910$export$2e2bcd8739ae039 = $bd64fdb00bd2c910$var$importInitieel;



const $72035e080057ca24$var$importInitieel = {
    init: function() {
        (0, $ff4afcbe59d9ce69$export$2e2bcd8739ae039).init();
    }
};
var $72035e080057ca24$export$2e2bcd8739ae039 = $72035e080057ca24$var$importInitieel;



const $2db1873f34f25cfe$var$controleren = {
    init () {
        // Bind opmerkingen select fuctie aan select
        $("body").on("change", ".toelichting-keuze", function(e) {
            $(e.target).closest(".modal").find(".toelichting").val(e.target.value);
            $2db1873f34f25cfe$var$controleren.disableIfEmpty($(".modal [type=submit]"), e.target.value);
        });
    },
    // Disabled button if value is empty or not set
    disableIfEmpty: function(t, v) {
        t.prop("disabled", true);
        if (v !== null || v !== "") t.prop("disabled", false);
    }
};
var $2db1873f34f25cfe$export$2e2bcd8739ae039 = $2db1873f34f25cfe$var$controleren;




var $4Cg4a = parcelRequire("4Cg4a");

var $6OMV8 = parcelRequire("6OMV8");

var $d553s = parcelRequire("d553s");

var $g7vmf = parcelRequire("g7vmf");

var $hzkBE = parcelRequire("hzkBE");

const $939aa8313e578024$var$uitvraag = {
    init: function() {
        var stap = document.querySelector("div.step-tabs ul.nav.nav-tabs").getAttribute("data-tab-active");
        document.querySelector(".nav-tabs-active-" + stap + " .nav-link").classList.add("active");
        if (typeof window.app.router !== "undefined" && (window.app.router.routerType || "build") === "dev") setTimeout(async ()=>{
            $939aa8313e578024$var$uitvraag.initGrid();
        }, 200);
        else setTimeout(async ()=>{
            const vendor = await (parcelRequire("7K2tQ"));
            $939aa8313e578024$var$uitvraag.initGrid();
        }, 200);
    },
    initGrid () {
        // Check of er een handsontable element is in DOM
        if ($("#handsontable").length) {
            (0, $6OMV8.default).init();
            (0, $d553s.default).init();
            (0, $g7vmf.default).init();
            // Define Handsontable Element and get settings from DOM
            var hotEl = document.getElementById("handsontable");
            var gridSettings = JSON.parse(hotEl.getAttribute("data-settings"));
            var gridData = JSON.parse(hotEl.getAttribute("data-data"));
            var gridDescription = hotEl.getAttribute("data-description");
            var gridStap = hotEl.getAttribute("data-stap");
            var uitvraagID = $(".form-uitvraag").data("uitvraag-id");
            var allowEmpty = hotEl.getAttribute("data-allow-empty") || false;
            // Init Handsontable instance
            window.app.hot = new Handsontable(hotEl, {
                colHeaders: gridSettings[gridDescription]["headers"],
                columns: gridSettings[gridDescription]["columns"],
                colWidths: gridSettings[gridDescription]["colWidths"],
                contextMenu: [
                    "row_above",
                    "row_below",
                    "remove_row",
                    "copy",
                    "cut",
                    "paste"
                ],
                data: gridData,
                licenseKey: "non-commercial-and-evaluation",
                rowHeights: 30,
                stretchH: "all",
                outsideClickDeselects: false,
                afterChange: function(changes, source) {
                    setTimeout(function() {
                        // Geef velden in DOM de JSON en de CSV als waarde
                        document.getElementsByName("dataJSON")[0].value = JSON.stringify(window.app.hot.getData());
                        (0, $4Cg4a.default).saveData(window.app.hot, gridStap, window.app.ajaxPath, uitvraagID);
                        var columns = {};
                        columns.settings = gridSettings[gridDescription]["columns"];
                        (0, $4Cg4a.default).formatAfterChange(changes, source, columns, window.app.hot);
                        window.app.hot.validateCells();
                    }, 0);
                },
                afterGetColHeader: function(col, th) {
                    (0, $4Cg4a.default).createHeaderTooltip(col, th, gridSettings[gridDescription]);
                },
                afterInit: function() {
                    (0, $4Cg4a.default).removePreloader();
                    setTimeout(function() {
                        window.app.hot.validateCells();
                        $("form[data-validate] button[type=button]").removeAttr("disabled");
                    }, 0);
                }
            });
            // Submit function that check if there are no validation errors before submitting
            $("form[data-validate] button[type=submit].btn-submit").attr("type", "button");
            $("form[data-validate] button[type=button].btn-submit").on("click", function() {
                window.app.hot.validateCells();
                // Definieer of het grid leeg mag zijn
                var hasRows;
                if (allowEmpty) hasRows = true;
                else hasRows = (0, $4Cg4a.default).hasRows(window.app.hot);
                // Valideer het grid, check of het grid leeg is terwijl het niet leeg mag zijn en open bevestigsmodaal of toon foutmelding
                if ((0, $4Cg4a.default).isValid(window.app.hot) && hasRows == true) {
                    (0, $4Cg4a.default).saveData(window.app.hot, gridStap, window.app.ajaxPath, uitvraagID);
                    $("#modalBevestigen").modal("show", {
                        keyboard: false,
                        backdrop: "static"
                    });
                } else (0, $hzkBE.default)("danger", "", "Er zijn fouten gevonden in het grid. Zorg dat er tenminste \xe9\xe9n regel toegevoegd en corrigeer roodgekleurde cellen.", 5000);
                return false;
            });
        } else $("form[data-validate] button[type=submit].btn-submit").removeAttr("disabled");
        // Bind functie die de ingevoerde gegevens in het formulier submit aan button in modal
        $("#modalBevestigen").on("click", ".btn-submit-confirm", function() {
            $939aa8313e578024$var$uitvraag.submitForm();
        });
    },
    // Functie die de ingevoerde gegevens in het formulier submit
    submitForm: function() {
        $("#modalBevestigen").modal("hide");
        setTimeout(function() {
            $("form[data-validate]")[0].submit();
        }, 200);
    }
};
var $939aa8313e578024$export$2e2bcd8739ae039 = $939aa8313e578024$var$uitvraag;


const $754671175fcc1d98$var$uitvraagP710StopLossNaverrekend = {
    init () {
        (0, $939aa8313e578024$export$2e2bcd8739ae039).init();
        // Verkrijg stap vanuit de DOM
        var stap = document.querySelector("div.step-tabs ul.nav.nav-tabs").getAttribute("data-tab-active");
        document.querySelector(".nav-tabs-active-" + stap + " .nav-link").classList.add("active");
        // Definieer submitbutton
        var submitButton = $("form[data-validate] button.btn-submit");
        // Toon modal in stap 4
        if (stap == 4) $("input[name=arborapportage]").on("change", function() {
            if ($(this).val() == "") {
                submitButton.attr("type", "submit");
                submitButton.attr("disabled", "true");
            } else {
                submitButton.attr("type", "button");
                submitButton.removeAttr("disabled");
            }
        });
        // Definieer of de cofirmation modal getoond moet worden
        if (stap == 2) {
            $("select[name=indienenZonderDeclaratie]").on("change", function() {
                if ($(this).val() == "j" && (0, $939aa8313e578024$export$2e2bcd8739ae039).checkSubmitAllowed()) submitButton.attr("type", "button");
                else submitButton.attr("type", "submit");
            });
            $("form.form-uitvraag input[type=file]").on("change", function() {
                $("select[name=indienenZonderDeclaratie]").trigger("change");
            });
        }
        // Open bevestigingsmodal
        $("body").on("click", "button[type=button].btn-submit", function() {
            $("#modalBevestigen").modal("show", {
                keyboard: false,
                backdrop: "static"
            });
        });
        // Bind functie die de ingevoerde gegevens in het formulier submit aan button in modal
        $("#modalBevestigen").on("click", ".btn-submit-confirm", function() {
            (0, $939aa8313e578024$export$2e2bcd8739ae039).submitForm();
        });
    },
    // Functie die de ingevoerde gegevens in het formulier submit
    submitForm: function() {
        $("#modalBevestigen").modal("hide");
        $("#loadingModal").modal("show", {
            keyboard: false,
            backdrop: "static"
        });
        setTimeout(function() {
            $("form[data-validate]")[0].submit();
        }, 200);
    },
    // Function om te controleren of alle checkboxes zijn aangevinkt en enable button
    checkSubmitAllowed: function() {
        var allowed = true;
        $("form.form-uitvraag input[type=file]").each(function() {
            if ($(this).val() == "") allowed = false;
        });
        return allowed;
    }
};
var $754671175fcc1d98$export$2e2bcd8739ae039 = $754671175fcc1d98$var$uitvraagP710StopLossNaverrekend;



const $b3542b11fb2f8081$var$P710StopLoss = {
    init () {
        (0, $939aa8313e578024$export$2e2bcd8739ae039).init();
        // Verkrijg stap vanuit de DOM
        var stap = document.querySelector("div.step-tabs ul.nav.nav-tabs").getAttribute("data-tab-active");
        document.querySelector(".nav-tabs-active-" + stap + " .nav-link").classList.add("active");
        // Definieer submitbutton
        var submitButton = $("form[data-validate] button.btn-submit");
        // Toon modal in stap 4
        if (stap == 4) $("input[name=arborapportage]").on("change", function() {
            if ($(this).val() == "") {
                submitButton.attr("type", "submit");
                submitButton.attr("disabled", "true");
            } else {
                submitButton.attr("type", "button");
                submitButton.removeAttr("disabled");
            }
        });
        // Definieer of de cofirmation modal getoond moet worden
        if (stap == 2) {
            $("select[name=indienenZonderDeclaratie]").on("change", function() {
                if ($(this).val() == "j" && (0, $939aa8313e578024$export$2e2bcd8739ae039).checkSubmitAllowed()) submitButton.attr("type", "button");
                else submitButton.attr("type", "submit");
            });
            $("form.form-uitvraag input[type=file]").on("change", function() {
                $("select[name=indienenZonderDeclaratie]").trigger("change");
            });
        }
        // Open bevestigingsmodal
        $("body").on("click", "button[type=button].btn-submit", function() {
            $("#modalBevestigen").modal("show", {
                keyboard: false,
                backdrop: "static"
            });
        });
        // Bind functie die de ingevoerde gegevens in het formulier submit aan button in modal
        $("#modalBevestigen").on("click", ".btn-submit-confirm", function() {
            (0, $939aa8313e578024$export$2e2bcd8739ae039).submitForm();
        });
    },
    // Functie die de ingevoerde gegevens in het formulier submit
    submitForm: function() {
        $("#modalBevestigen").modal("hide");
        $("#loadingModal").modal("show", {
            keyboard: false,
            backdrop: "static"
        });
        setTimeout(function() {
            $("form[data-validate]")[0].submit();
        }, 200);
    },
    // Function om te controleren of alle checkboxes zijn aangevinkt en enable button
    checkSubmitAllowed: function() {
        var allowed = true;
        $("form.form-uitvraag input[type=file]").each(function() {
            if ($(this).val() == "") allowed = false;
        });
        return allowed;
    }
};
var $b3542b11fb2f8081$export$2e2bcd8739ae039 = $b3542b11fb2f8081$var$P710StopLoss;


const $3c885aed24d4b502$var$uitvraag = {
    init () {
        // Stap activetab
        var stap = document.querySelector("div.step-tabs ul.nav.nav-tabs").getAttribute("data-tab-active");
        document.querySelector(".nav-tabs-active-" + stap + " .nav-link").classList.add("active");
        // Disable submit button
        $("button[type=button].btn-submit").attr("disabled", "true");
        // Controleer of alle checkboxes zijn aangevinkt
        $("form.form-uitvraag input[type=checkbox]").on("change", function() {
            $3c885aed24d4b502$var$uitvraag.checkSubmitAllowed();
        });
        // Bind functie die de ingevoerde gegevens in het formulier submit aan button in modal
        $("#modalBevestigen").on("click", ".btn-submit-confirm", function() {
            $3c885aed24d4b502$var$uitvraag.submitForm();
        });
    },
    // Function om te controleren of alle checkboxes zijn aangevinkt en enable button
    checkSubmitAllowed: function() {
        var button = $("form.form-uitvraag button[type=button]");
        button.removeAttr("disabled");
        $("form.form-uitvraag input[type=checkbox]").each(function() {
            if (!$(this).is(":checked")) button.attr("disabled", true);
        });
    },
    // Functie die de ingevoerde gegevens in het formulier submit
    submitForm: function() {
        $("#modalBevestigen").modal("hide");
        setTimeout(function() {
            $("form[data-validate]")[0].submit();
        }, 200);
    }
};
var $3c885aed24d4b502$export$2e2bcd8739ae039 = $3c885aed24d4b502$var$uitvraag;



const $29c4ff330639d932$var$uitvraag = {
    init: function() {
        (0, $939aa8313e578024$export$2e2bcd8739ae039).init();
    }
};
var $29c4ff330639d932$export$2e2bcd8739ae039 = $29c4ff330639d932$var$uitvraag;



const $bf2f381b07c35dd7$var$vergelijken = {
    init () {
        var stap = $("#container-vergelijking").attr("stap");
        // Definieer url variabele op basis van de locatie van browservenster
        var url = window.location.href;
        // Voeg forward slash toe als deze er niet is
        if (url.charAt(url.length - 1) != "/") url = url + "/";
        // Javascript voor stap 2
        if (stap == 2) {
            $(".btn-print").click(function(e) {
                e.preventDefault();
                window.print();
            });
            // Click functie voor checkbox in dropdown menu
            $("#maatschappijSelect input[type=checkbox]").click(function() {
                // Simuleer click op bovenliggend anchor element
                $(this).parent().trigger("click");
            });
            // Click functie voor anchor in dropdown menu
            $("#maatschappijSelect a").click(function() {
                // Trigger click op input checkbox
                $(this).find("input").trigger("click");
            });
            // Voorkom dropdown standaard functie
            $(".dropdown-menu").click(function(e) {
                e.stopPropagation();
            });
            // Functie op maarschappij kolommen te tonen en verbergen
            $("#maatschappijSelect input").change(function(e) {
                // Voorkom standaard functie van inputs
                e.preventDefault;
                // Check of huidige input al gecheckt is en check deze als dat zo is
                $(this).find("input").prop("checked", !$(this).find("input").prop("checked"));
                // Maak nieuwe array aan voor maatschappijen
                var maatschappijen = new Array();
                // Voeg item aan array toe voor elke checkbox
                $(this).closest("div").find("input:checked").each(function() {
                    maatschappijen.push($(this).data("mij"));
                });
                // Verberg alle kolommen
                $(".table-voorwaarden-vergelijker tbody tr td").addClass("d-none");
                $(".table-voorwaarden-vergelijker thead tr th.aanbieder").addClass("d-none");
                // Als er geen aanbieders geselecteerd zijn toon dan een lege kolom
                if (maatschappijen.length == 0) {
                    $(".table-voorwaarden-vergelijker tbody tr.row-property td:last-child").removeClass("d-none");
                    $(".table-voorwaarden-vergelijker thead tr th:last-child").removeClass("d-none");
                } else $(".table-voorwaarden-vergelijker thead tr th:last-child").addClass("d-none");
                // Voor elke aanbieder toon de kolom en trigger de select zodat de kolom wordt gevuld
                $.each(maatschappijen, function(key, value) {
                    $(".table-voorwaarden-vergelijker").find("thead,tbody").find(".aanbieder_" + value).removeClass("d-none");
                    $(".table-voorwaarden-vergelijker").find("thead,tbody").find(".aanbieder_" + value).find("select").trigger("change");
                });
                // Werk de colspan van de titels bij a.h.v. het aantal geselecteerde aanbieders
                var l = $("#maatschappijSelect ul.dropdown-menu input:checked").length;
                var s = $(".table-voorwaarden-vergelijker tbody tr:nth-child(2) td:visible").length + 1;
                if (l != 0) $(".row-title th").hide(0).attr("colspan", s).show(0);
                else $(".row-title th").hide(0).attr("colspan", 100).show(0);
                // Voorkom standaard gedrag van input
                return false;
            });
            // Functie die de kolom vult a.h.v. de gekozen
            $(".voorwaarde-selector").change(function() {
                // Haal aanbieder id uit aanbieder data attibuut
                var aanbieder = $(this).data("aanbieder");
                // Haal voorwaarde id uit aanbieder data attibuut
                var voorwaarde_id = $(this).val();
                // Als de id niet leeg is
                if (voorwaarde_id != "" && voorwaarde_id != null) {
                    // Definieer url met daarin de kokozen waarden
                    var actionArray = [
                        url + aanbieder,
                        voorwaarde_id,
                        ""
                    ];
                    // Ajax functie
                    $.ajax({
                        type: "GET",
                        url: actionArray.join("/"),
                        success: function(data) {
                            // Wanneer de waarde die teruggegeven wordt niet leeg is
                            if (data.length != 0) // Voor elk item in het dataobject
                            $.each(data, function(group_key, value) {
                                // Voor elke voorwaarde in item in het
                                $.each(value, function(key, item) {
                                    // Vervang u20ac voor euro teken
                                    item = item.replace(/u20ac/g, "\u20AC");
                                    // Vul de cellen met de juste waarde
                                    $(".aanbieder_" + aanbieder + ".vraag_" + group_key + "-" + key).html($bf2f381b07c35dd7$var$vergelijken.linkify(item));
                                });
                            });
                        }
                    });
                }
            });
        }
    },
    linkify: function(inputText) {
        var replacedText, replacePattern1, replacePattern2;
        //URLs starting with http://, https://, or ftp://
        replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        replacedText = inputText.replace(replacePattern1, '<u><a href="$1" target="_blank">Bekijken</a></u>');
        //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replace(replacePattern2, '$1<u><a href="http://$2" target="_blank">Bekijken</a></u>');
        return replacedText;
    }
};
var $bf2f381b07c35dd7$export$2e2bcd8739ae039 = $bf2f381b07c35dd7$var$vergelijken;


var $4df9d5532b128906$var$elementTextFilter = {
    /**
   * Init event listeners
   *
   * @param {object} target
   *
   * @returns {void}
   */ init: function(target) {
        if (target) target.addEventListener("keyup", function() {
            var parentSelector = this.getAttribute("data-element-text-filter-parent-selector") || "[data-element-text-filter-parent]";
            var groupSelector = this.getAttribute("data-element-text-filter-group-selector") || "[data-element-text-filter-group]";
            var childSelector = this.getAttribute("data-element-text-filter-child-selector") || "[data-element-text-filter-list-item]";
            var termSelector = this.getAttribute("data-element-text-filter-term-selector") || "[data-element-text-filter-list-item-term]";
            var hideClass = this.getAttribute("data-element-text-filter-hide-class") || "d-none";
            $4df9d5532b128906$var$elementTextFilter.filter(target, parentSelector, childSelector, termSelector, hideClass, groupSelector);
        });
    },
    /**
   * Filter elelement children by string
   *
   * @param {Element} input
   * @param {String} parentSelector
   * @param {String} childSelector
   * @param {String} termSelector
   * @param {String} hideClass
   *
   * @return {void}
   */ filter: function(input, parentSelector, childSelector, termSelector, hideClass, groupSelector = null) {
        let filter = input.value.toUpperCase();
        let parent = document.querySelector(parentSelector);
        let children = parent.querySelectorAll(childSelector);
        children.forEach((child)=>{
            let termString = "";
            let termElements = child.querySelectorAll(termSelector);
            termElements.forEach((element)=>{
                termString = termString + " " + element.textContent;
            });
            child.classList.remove(hideClass);
            if (!(termString.toUpperCase().indexOf(filter) > -1)) child.classList.add(hideClass);
        });
        if (groupSelector !== null) {
            let groups = parent.querySelectorAll(groupSelector);
            groups.forEach((group)=>{
                group.classList.remove(hideClass);
                let visibleChildren = group.querySelectorAll("[data-element-text-filter-list-item]:not(." + hideClass + ")");
                if (visibleChildren.length === 0) group.classList.add(hideClass);
            });
        }
    }
};
var $4df9d5532b128906$export$2e2bcd8739ae039 = $4df9d5532b128906$var$elementTextFilter;


const $226ab816504d4b0f$var$edit = {
    init () {
        var elementTextFilterElement = document.querySelector("[data-element-text-filter-input]");
        (0, $4df9d5532b128906$export$2e2bcd8739ae039).init(elementTextFilterElement);
        $226ab816504d4b0f$var$edit.toggleToestemmingen();
        $226ab816504d4b0f$var$edit.toggleAutovalidatieSalaris();
        $226ab816504d4b0f$var$edit.initEvents();
    },
    initEvents () {
        $("#neemDefaultToestemmingenOver").on("change", function() {
            $226ab816504d4b0f$var$edit.toggleToestemmingen();
        });
        $("#actieSalarisAutovalidatie").on("change", function() {
            $226ab816504d4b0f$var$edit.toggleAutovalidatieSalaris();
        });
        $(".nav-link#rechten-tab").on("click", function() {
            document.querySelector("[data-element-text-filter-input]").focus();
        });
    },
    // Functie om toestemmingsswitches te tonen en verbergen
    toggleToestemmingen: function() {
        var checked = $("#neemDefaultToestemmingenOver").prop("checked");
        var target = $("[data-default-toestemming]").closest(".form-group");
        target.addClass("d-none");
        if (checked) target.removeClass("d-none");
    },
    // Functie om toestemmingsswitches te tonen en verbergen
    toggleAutovalidatieSalaris: function() {
        var checked = $("#actieSalarisAutovalidatie").prop("checked");
        var target = $("[data-salaris-autovalidatie]").closest(".form-group");
        target.addClass("d-none");
        if (checked) target.removeClass("d-none");
    }
};
var $226ab816504d4b0f$export$2e2bcd8739ae039 = $226ab816504d4b0f$var$edit;


const $2e4767040da3bc4c$var$werknemerListing = {
    init () {
        // Download export button functie die op basis van daterange een download url maakt
        $("#buttonDownloadExport").click(function() {
            var url = $(this).data("url");
            url = url + "/" + $("#begindatum").val() + "/" + $("#einddatum").val() + "/";
            window.location.href = url;
        });
        // Zet on change uit te voeren wijziging in de tabel
        $("select.werknemer-select").change(function() {
            var werknemer_id = $(this).val();
            $(this).closest("tr").find("td.werknemer-diff").html("Geen");
            $(this).closest("tr").find("td.adres-diff").html("Geen");
            if (werknemer_id != "nieuw" && werknemer_id != "overslaan") {
                var werknemerDiff = JSON.parse($(this).closest("tr").find("textarea").val());
                var tableClassColor = "table-warning";
                var table = [];
                table.push("<th>Wijziging</th><th>Van</th><th>Naar</th>");
                $.each(werknemerDiff[werknemer_id]["werknemer"], function(key, value) {
                    var classColor = "";
                    if (key == "achternaam" || key == "voorletters" || key == "geboorte_datum") {
                        classColor = "text-danger";
                        tableClassColor = "table-danger";
                        $(".alert-naamswijziging").removeClass("d-none");
                    }
                    table.push("<tr class=" + classColor + "><td>" + key + "</td><td>" + value.old + "</td><td>" + value.new + "</td></tr>");
                // table.push('<td>' + key + '</td><td>' + value.old + '</td><td>' + value.new + '</td></tr>');
                });
                if (table.length > 1) // $(this).closest('tr').find('td.werknemer-diff').html('<table class="table table-striped"><tr>' + table.join('</tr><tr>') + '</tr></table>');
                $(this).closest("tr").find("td.werknemer-diff").html('<table class="table table-striped ' + tableClassColor + ' mb-0">' + table.join("") + "</table>");
                table = [];
                table.push("<th>Wijziging</th><th>Van</th><th>Naar</th>");
                $.each(werknemerDiff[werknemer_id]["adres"], function(key, value) {
                    // table.push('<td>' + key + '</td><td>' + value.old + '</td><td>' + value.new + '</td>');
                    table.push("<tr><td>" + key + "</td><td>" + value.old + "</td><td>" + value.new + "</td></tr>");
                });
                if (table.length > 1) // $(this).closest('tr').find('td.adres-diff').html('<table class="table table-striped"><tr>' + table.join('</tr><tr>') + '</tr></table>');
                $(this).closest("tr").find("td.adres-diff").html('<table class="table table-striped">' + table.join("") + "</table>");
            }
        });
        // Trigger een change event voor alle werknemer select elementen
        $("select.werknemer-select").each(function() {
            $(this).trigger("change");
        });
        // Toon import errors wanneer pagina geladen wordt
        $(".modal-import-errors").modal("show");
        // Maak tooltip aan met error toelichting voor alle rijen
        $(".modal-import-errors table tbody tr").each(function() {
            $("[data-toggle=tooltip]").tooltip();
        });
    }
};
var $2e4767040da3bc4c$export$2e2bcd8739ae039 = $2e4767040da3bc4c$var$werknemerListing;



const $e5ade9b062cebabb$var$importInitieel = {
    init: function() {
        (0, $2e4767040da3bc4c$export$2e2bcd8739ae039).init();
    }
};
var $e5ade9b062cebabb$export$2e2bcd8739ae039 = $e5ade9b062cebabb$var$importInitieel;



const $7e54e2b2a4e482ba$var$importInitieel = {
    init: function() {
        (0, $2e4767040da3bc4c$export$2e2bcd8739ae039).init();
    }
};
var $7e54e2b2a4e482ba$export$2e2bcd8739ae039 = $7e54e2b2a4e482ba$var$importInitieel;



var $7FBkt = parcelRequire("7FBkt");
const $7db43d2ac6fd7342$var$activatePreGeneratedAccount = {
    init: function() {
        // Functie die controleerd of akkoord is gegaan met de voorwaarden
        function checkVoorwaarden() {
            var verder = true;
            $(".voorwaardenAkkoordCheckbox").each(function() {
                if (!this.checked) verder = false;
            });
            return verder;
        }
        // Functie om te controleren of alle validaties in het formulier succesvol zijn afgerond
        function checkActivationForm() {
            if (checkVoorwaarden()) $("button#btnActivateAccount").removeAttr("disabled");
            else $("button#btnActivateAccount").attr("disabled", "true");
        }
        // Controleer gehele formulier als voorwaarden checkbox wordt aangeklikt
        $(".voorwaardenAkkoordCheckbox").on("click", checkActivationForm);
    }
};
var $7db43d2ac6fd7342$export$2e2bcd8739ae039 = $7db43d2ac6fd7342$var$activatePreGeneratedAccount;


const $8de5bcd956907ab0$var$activatePreGeneratedAccount = {
    /**
   * Initialize the activate pre-generated account functionality
   *
   * @returns {void}
   */ init () {
        // Initialize the gullActivatePreGeneratedAccount module
        (0, $7db43d2ac6fd7342$export$2e2bcd8739ae039).init();
        // Add event listener to the username input
        document.getElementById("username").addEventListener("change", $8de5bcd956907ab0$var$activatePreGeneratedAccount.handleUsernameChange);
    },
    /**
   * Handle username input changes and fetch group data if needed
   *
   * @param {Event} event - The change event
   *
   * @returns {void}
   */ handleUsernameChange (event) {
        const groupId = event.target.value.toUpperCase();
        $8de5bcd956907ab0$var$activatePreGeneratedAccount.resetToestemmingsverklaring();
        if ($8de5bcd956907ab0$var$activatePreGeneratedAccount.isValidGroupId(groupId)) (0, $7FBkt.default).get(window.app.ajaxPath + "nl/group/" + groupId, function(data) {
            data = JSON.parse(data);
            $8de5bcd956907ab0$var$activatePreGeneratedAccount.updateCheckboxesFromGroupData(data);
        });
    },
    /**
   * Update checkboxes based on group data
   *
   * @param {Object} data - The group data containing checkbox values
   *
   * @returns {void}
   */ updateCheckboxesFromGroupData (data) {
        const element = document.querySelector(".toestemmingsverklaring");
        if (element.classList.contains("d-none")) element.classList.remove("d-none");
        Object.entries(data).forEach(([key, item])=>{
            const checkbox = document.getElementById("toestemming-" + key + "-checkbox");
            if (checkbox && item !== "") checkbox.checked = true;
        });
    },
    /**
   * Reset the toestemmingsverklaring section by hiding it and unchecking all checkboxes
   *
   * @returns {void}
   */ resetToestemmingsverklaring () {
        const element = document.querySelector(".toestemmingsverklaring");
        if (!element.classList.contains("d-none")) element.classList.add("d-none");
        document.querySelectorAll(".toestemmingsverklaring input[type=checkbox]").forEach((checkbox)=>checkbox.checked = false);
    },
    /**
   * Check if the group ID is valid for fetching data
   *
   * @param {string} groupId - The group ID to validate
   *
   * @returns {boolean}
   */ isValidGroupId (groupId) {
        return groupId.charAt(0) === "R" && groupId.length > 6;
    }
};
var $8de5bcd956907ab0$export$2e2bcd8739ae039 = $8de5bcd956907ab0$var$activatePreGeneratedAccount;


const $6690f65deb8613d2$var$edit = {
    init () {
        // Vervang u20ac voor euro teken
        $(".form-section input").each(function() {
            $(this).val($(this).val().replace(/u20ac/g, "\u20AC"));
        });
        // Initieer tab verwijder functie on focus, blue en keyup van elke input
        $("body").on("focus blur keyup", "input", function() {
            $(this).val($6690f65deb8613d2$var$edit.trimTabsFromString($(this).val()));
        });
    },
    // Functie om tabs te verwijderen uit string
    trimTabsFromString: function(i) {
        return i.replace("	", "");
    }
};
var $6690f65deb8613d2$export$2e2bcd8739ae039 = $6690f65deb8613d2$var$edit;


const $c44a083a872a04c1$var$send2 = {
    init () {
        const redirectHref = document.querySelector("a#redirectUrl");
        if (redirectHref) {
            const time = redirectHref.getAttribute("time");
            const delayInMilliseconds = time * 1000;
            window.setTimeout(()=>{
                const opener = window.open(redirectHref.getAttribute("href"));
                window.setTimeout(()=>{
                    if (!opener || opener.closed || typeof opener.closed === "undefined") {
                        redirectHref.classList.add("btn", "btn-success");
                        const popupBlocker = document.querySelector("span.popup-blocker");
                        if (popupBlocker) {
                            popupBlocker.classList.remove("d-none");
                            popupBlocker.style.display = "block";
                        }
                    }
                }, 1000);
                window.setTimeout(()=>{
                    redirectHref.parentElement.style.display = "none";
                    redirectHref.removeAttribute("href");
                    redirectHref.setAttribute("disabled", true);
                    const linkVerlopen = document.querySelector("span.link-verlopen");
                    if (linkVerlopen) {
                        linkVerlopen.classList.remove("d-none");
                        linkVerlopen.style.display = "block";
                    }
                }, 600000);
            }, delayInMilliseconds);
        }
    }
};
var $c44a083a872a04c1$export$2e2bcd8739ae039 = $c44a083a872a04c1$var$send2;


const $7a1e712dd3e4e1af$var$dashboardView = {
    init () {
        // Functie voor het uitbreiden en samenvouwen van documentatie-items
        document.querySelectorAll(".accordion-header").forEach(function(element) {
            element.addEventListener("click", function(event) {
                event.preventDefault();
                $7a1e712dd3e4e1af$var$dashboardView.toggleDocumentatie(event);
            });
        });
        // Functie voor het tonen van een toestemming modal
        document.querySelectorAll("[data-target-modal]").forEach(function(element) {
            element.addEventListener("click", function(event) {
                event.preventDefault();
                $7a1e712dd3e4e1af$var$dashboardView.openTargetModal(event);
            });
        });
    },
    // Bind functie voor het in en uitklappen van documentatie items aan panel
    toggleDocumentatie: function(event) {
        // Define dom targets and css classes
        let arrow = document.querySelector(event.target).parentNode.querySelector("span.rotation-arrow");
        let group = Array.from(document.querySelector(event.target).closest(".panel-group").querySelectorAll(".panel > .panel-heading > a > small > span.rotation-arrow"));
        let right = "fa-chevron-right";
        let down = "fa-chevron-down";
        if (arrow.classList.contains(down)) {
            // If arrow is pointing down, close all others, remove the 'down' class and add 'right' class
            group.forEach(function(element) {
                element.classList.add(right);
                element.classList.remove(down);
            });
            arrow.classList.remove(down);
            arrow.classList.add(right);
        } else if (arrow.classList.contains(right)) {
            // If arrow is pointing right, close all others, remove the 'right' class add 'down' class
            group.forEach(function(element) {
                element.classList.add(right);
                element.classList.remove(down);
            });
            arrow.classList.remove(right);
            arrow.classList.add(down);
        }
    },
    // Bind functie tonen van een toestemming modal
    openTargetModal: function(event) {
        let target = event.target.getAttribute("data-target-modal");
        let element = document.getElementById(target);
        let modal = new bootstrap.Modal(element, {});
        modal.show();
    }
};
var $7a1e712dd3e4e1af$export$2e2bcd8739ae039 = $7a1e712dd3e4e1af$var$dashboardView;




var $4Cg4a = parcelRequire("4Cg4a");

var $6OMV8 = parcelRequire("6OMV8");

var $d553s = parcelRequire("d553s");

var $g7vmf = parcelRequire("g7vmf");

var $hzkBE = parcelRequire("hzkBE");


const $e3a21f11cf892222$var$addMultipleView = {
    init: function() {
        if (typeof window.app.router !== "undefined" && (window.app.router.routerType || "build") === "dev") setTimeout(async ()=>{
            $e3a21f11cf892222$var$addMultipleView.initGrid();
        }, 200);
        else setTimeout(async ()=>{
            const vendor = await (parcelRequire("7K2tQ"));
            $e3a21f11cf892222$var$addMultipleView.initGrid();
        }, 200);
    },
    initGrid: function() {
        // Check if handsontable element exists in dom
        if (document.getElementById("handsontable")) {
            (0, $6OMV8.default).init();
            (0, $d553s.default).init();
            (0, $g7vmf.default).init();
            // Define Handsontable Element and get settings from DOM
            var hotEl = document.getElementById("handsontable");
            var werknemers = JSON.parse(hotEl.getAttribute("data-werknemers"));
            var werknemersMeldingIds = JSON.parse(hotEl.getAttribute("data-werknemersMeldingIds"));
            var relatieId = $("#handsontable").attr("data-relatie-id");
            // Definieer Handsontable columns
            var columns = {
                settings: [
                    {
                        type: "dropdown",
                        className: "htMiddle",
                        allowEmpty: false,
                        source: werknemers
                    },
                    {
                        type: "dropdown",
                        className: "htMiddle",
                        validator: "notEmpty",
                        allowEmpty: false
                    },
                    {
                        type: "date",
                        className: "htMiddle",
                        allowEmpty: false,
                        dateFormat: "DD-MM-YYYY",
                        correctFormat: true
                    },
                    {
                        type: "date",
                        className: "htMiddle",
                        allowEmpty: false,
                        dateFormat: "DD-MM-YYYY",
                        correctFormat: true
                    },
                    {
                        type: "numeric",
                        className: "htMiddle",
                        allowEmpty: false,
                        renderer: "bedrag",
                        numericFormat: {
                            pattern: "\u20AC0,0",
                            culture: "nl-NL"
                        },
                        validator: "salarisNegativeAndZeroAllowedOrEmpty",
                        formatter: "currencyNoSeparator"
                    },
                    {
                        type: "numeric",
                        className: "htMiddle",
                        allowEmpty: false,
                        renderer: "bedrag",
                        numericFormat: {
                            pattern: "\u20AC0,0",
                            culture: "nl-NL"
                        },
                        validator: "salarisNegativeAllowed",
                        formatter: "currencyNoSeparator"
                    }
                ],
                tooltips: [
                    null,
                    "Selecteer het juiste dossier op basis van de combinatie dossiernummer, eerste ziektedag en de begindatum van het dossier. Bij twijfel kunt u het juiste dossier bepalen door op medewerker niveau de meldingen te bekijken.",
                    null,
                    null,
                    "Op maand basis",
                    null
                ]
            };
            // Definieer Handsontable dummy data
            var data = [
                [
                    "",
                    "",
                    "",
                    "",
                    "0",
                    "0"
                ]
            ];
            // Definieer Handsontable Settings
            var hotSettings = {
                colHeaders: [
                    "Werknemer",
                    "Melding / 1e ziektedag / Begindatum",
                    "Periode van",
                    "Periode tot",
                    "Bruto loon",
                    "Factuurbedrag"
                ],
                contextMenu: [
                    "row_above",
                    "row_below",
                    "remove_row"
                ],
                colWidths: [
                    200,
                    260,
                    100,
                    100,
                    100,
                    100
                ],
                data: data,
                fillHandle: false,
                columns: columns.settings,
                language: "nl-NL",
                licenseKey: "non-commercial-and-evaluation",
                rowHeights: 30,
                stretchH: "all",
                copyPaste: false,
                outsideClickDeselects: false,
                afterSetDataAtCell: function(changes) {
                    $e3a21f11cf892222$var$addMultipleView.updateDossiernummers(changes, relatieId, werknemersMeldingIds);
                },
                afterChange: function(changes, source) {
                    setTimeout(function() {
                        document.getElementsByName("werknemersDataJSON")[0].value = JSON.stringify(window.app.hot.getData());
                        (0, $4Cg4a.default).formatAfterChange(changes, source, columns, window.app.hot);
                    }, 0);
                    (0, $4Cg4a.default).disableForPaste(hotEl, source, false);
                },
                beforeChange: function(changes, source) {
                    (0, $4Cg4a.default).disableForPaste(hotEl, source);
                },
                afterGetColHeader: function(col, th) {
                    (0, $4Cg4a.default).createHeaderTooltip(col, th, columns);
                },
                afterInit: function() {
                    // Verberg loading spinner
                    var element = document.getElementById("handsontableLoader");
                    element.parentNode.removeChild(element);
                    // Maak form button enabled
                    setTimeout(function() {
                        $("form[data-validate] button[type=button]").removeAttr("disabled");
                    }, 0);
                }
            };
            // Init Handsontable instance
            window.app.hot = new window.Handsontable(hotEl, hotSettings);
            // Toon en verberg juiste opvolgende velden op basis van ingevoerde waarde in betalingAan
            $("#betalingAan").change(function(e) {
                e.preventDefault();
                // Verberg melding over betaalbewijs
                $(".melding-betaling-werkgever").addClass("d-none");
                // Verberg melding over UWV
                $(".melding-betaling-uwv").addClass("d-none");
                // Disable iban voor submit
                $("#IBAN").attr("name", "").closest(".form-group").addClass("d-none");
                // Disable volgnummer iban voor submit
                $("#VOLGNR_BANK").attr("name", "");
                // Verberg melding dat er geen iban bekend is
                $(".melding-geen-iban").addClass("d-none");
                // Verberg bewijsoverboeking upload
                $("#bewijsOverboeking").closest(".form-group").addClass("d-none");
                // Verwijder validatie op overboekingsbewijs
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired($("#bewijsOverboeking"));
                // Verwijder validatie op iban
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired($("#IBAN"));
                if ($(this).val() == "werkgever") {
                    // Toon melding over betaalbewijs
                    $(".melding-betaling-werkgever").removeClass("d-none");
                    // Toon toon bewijs van overboeking
                    $("#bewijsOverboeking").closest(".form-group").removeClass("d-none");
                    // Voeg attribuut name weer toe
                    $("#IBAN").attr("name", "IBAN").closest(".form-group").removeClass("d-none");
                    // Enable Volgnummer iban voor submit
                    $("#VOLGNR_BANK").attr("name", "VOLGNR_BANK");
                    // Toon melding dat er geen iban bekend is
                    $(".melding-geen-iban").removeClass("d-none");
                    // Voeg required toe aan iban
                    (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired($("#IBAN"));
                    if ($(this).data("company") !== "C030") // Voeg validatie toe aan bewijs van overboeking
                    (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired($("#bewijsOverboeking"));
                    if ($("#IBAN").length < 1) $("#form-beschikking button").attr("disabled", true);
                } else {
                    // Toon melding over UWV
                    $(".melding-betaling-uwv").removeClass("d-none");
                    $("#form-beschikking button").removeAttr("disabled");
                }
            });
            // Toon en verberg functie uit als pagina geladen wordt
            $("#betalingAan").trigger("change");
            // Wijzig volgnummer veld als andere iban wordt geselecteerd
            $("#IBAN").change(function(e) {
                $("input[name=VOLGNR_BANK").val($(e.target).children("option:selected").data("nr"));
            });
            // Valideer velden onBlur
            $("form.form-beschikking").find("input,select,textarea").filter("[data-validate]").blur((0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInputBlur);
            // Submit functie die checkt of het grid gevalideerd wordt voor submit
            $("form.form-beschikking button[type=submit].btn-submit").attr("type", "button").removeAttr("disabled");
            $("form.form-beschikking button[type=button].btn-submit").on("click", function() {
                $e3a21f11cf892222$var$addMultipleView.validateComplete();
            });
            // Bind functie die de ingevoerde gegevens in het formulier submit aan button in modal
            $("#modalBevestigen").on("click", ".btn-submit-confirm", function() {
                $e3a21f11cf892222$var$addMultipleView.submitForm();
            });
        }
    },
    // Update dossiernummer cell op basis van gekozen werknemer
    updateDossiernummers: function(changes, relatieId, werknemersMeldingIds) {
        // Voer voor elke gewijzigde cel functie uit
        $.each(changes, function(i, e) {
            // Definieer column van betreffende wijziging
            var column = e[1];
            // Als het column 1 betreft
            if (column == 0) {
                // Definieer row van betreffende wijziging
                var rowNumber = e[0];
                // Definieer column waarin functie uitgevoerd moet worden
                var colNumber = 1;
                // Verkrijg werknemer van betreffende wijziging
                var werknemer = e[3];
                // Definieer werknemnerID op basis van array uit dom
                var werknemerId = werknemersMeldingIds[werknemer];
                // Voer ajax request uit die open meldingen van werknemer teruggeeft
                $.getJSON(window.app.ajaxPath + relatieId + "/data/" + werknemerId).done(function(d) {
                    // Verwijder de huidige waarde uit de cel (om te voorkomen dat er een reeds geselecteerde waarde gesubmit wordt)
                    window.app.hot.setDataAtCell(rowNumber, colNumber, "");
                    // Maak nieuwe array aan met de cell eigenschappen
                    var cellProp = {};
                    // Maak opties array aan
                    var opties = [];
                    // Geef de cell het type "dropdown"
                    cellProp.type = "dropdown";
                    // Als er meldingen worden teruggegeven
                    if (d !== "") {
                        // Verkrijg de meldingen als array uit ajax response
                        var meldingen = d;
                        // Verkrijg de reeds geselecteerde meldingen als array
                        var selected = window.app.hot.getDataAtCol(1);
                        // Haal de reeds geselecteerde meldingen af van de meldingen
                        opties = meldingen.filter((n)=>!selected.includes(n));
                        // Kies eerste item uit melding
                        if (opties.length) window.app.hot.setDataAtCell(rowNumber, colNumber, opties[0]);
                    // Als er geen beschikbare meldingen terug gegeven worden
                    } else {
                        window.app.hot.setDataAtCell(rowNumber, colNumber, "Reeds een lopende betalingsaanvraag aanvraag...");
                        // Geef dan een melding
                        (0, $hzkBE.default)("danger", "", "Het is niet mogelijk een dossier te selecteren voor deze medewerker omdat er nog een ander betaalverzoek in behandeling is.", 5000);
                    }
                    // Geef de opties van de select
                    cellProp.source = opties;
                    // Voeg nieuwe cel van het type dropdown met de de nog niet eerde geselecteerde meldingen toe op de juiste plek in de tabel
                    window.app.hot.setCellMetaObject(rowNumber, colNumber, cellProp);
                });
            }
        });
    },
    // Functie die de ingevoerde gegevens in het formulier submit
    submitForm: function() {
        $("#modalBevestigen").modal("hide");
        setTimeout(function() {
            $("form.form-beschikking")[0].submit();
        }, 200);
    },
    // Functie om volledige pagina te valideren
    validateComplete: function() {
        // Valideer formulier en geef indien nodig foutmelding
        var aantalFouten = 0;
        $("form.form-beschikking").find("input[data-validate],select[data-validate],textarea[data-validate]").each(function() {
            if ((0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkInput(this) == "error") aantalFouten = aantalFouten + 1;
        });
        if (aantalFouten > 0) (0, $hzkBE.default)("danger", "", "Er zijn fouten gevonden in het formulier. Deze moet gecorrigeerd worden om het formulier te versturen.", 5000);
        // Valideer grid en geef indien nodig foutmelding
        window.app.hot.validateCells(function() {
            if ((0, $4Cg4a.default).isValid(window.app.hot) && (0, $4Cg4a.default).hasRows(window.app.hot) && aantalFouten == 0) $("#modalBevestigen").modal("show", {
                keyboard: false,
                backdrop: "static"
            });
            else (0, $hzkBE.default)("danger", "", "Er zijn fouten gevonden in het grid. Zorg dat er tenminste \xe9\xe9n werknemer is toegevoegd en corrigeer roodgekleurde cellen.", 5000);
            return false;
        });
    }
};
var $e3a21f11cf892222$export$2e2bcd8739ae039 = $e3a21f11cf892222$var$addMultipleView;








var $13AFs = parcelRequire("13AFs");
/**
 * Module for handling multiple document reader view in insurance insight application.
 *
 * @type {Object}
 */ class $537663f7e81661f0$var$VerzamelBeschikking {
    constructor(){
        /**
     * Configuration config for the module.
     * @type {Object}
     * @property {number} initialDelay - Initial delay in milliseconds before first check.
     * @property {number} requestInterval - Interval in milliseconds between subsequent checks.
     * @property {string|null} step - Current step in the process.
     * @property {string} url - URL for checking results.
     */ this.config = {
            initialDelay: 0,
            timeout: 60000,
            requestInterval: 1000,
            step: null,
            url: null,
            processStep: 2,
            path: "/check",
            rowSignalClasses: {
                success: "table-success",
                warning: "table-warning",
                danger: "table-danger"
            },
            selectors: {
                form: "[data-docreader-form]",
                result: "[data-docreader-result-element]",
                progress: "[data-docreader-progress-element]",
                resultTable: "[data-docreader-result-table]",
                alertSuccess: "[data-docreader-alert-success-element]",
                alertWarning: "[data-docreader-alert-warning-element]",
                currentStep: "[data-docreader-current-step]",
                resultName: "[data-docreader-result-name]",
                submit: "[data-docreader-submit]",
                declaratiesAdd: "[data-docreader-declaraties-add]",
                declaratiesRemove: "[data-docreader-declaraties-remove]",
                declaratiesTemplate: "[data-docreader-declaraties-template]",
                factuurBedragTotal: "[data-docreader-factuur-bedrag-total]",
                factuurBedrag: "[data-docreader-factuur-bedrag]",
                selectDossier: "[data-docreader-select-dossier]",
                dossierNameOption: "[data-docreader-dossier-name-option]",
                dossierWerknemerIdOption: "[data-docreader-werknemer-id-option]"
            },
            el: null
        };
    }
    /**
   * Initializes the module.
   *
   * @returns {void}
   */ init = ()=>{
        this.initConfig();
        this.initCheckResult();
    };
    /**
   * Assigns DOM elements to an object based on provided selectors.
   *
   * @param {Object} selectors - An object containing selector strings as keys.
   *
   * @returns {Object} An object with the same keys as the selectors object, where each value is the corresponding DOM element or null if not found.
   */ initDomElements = (selectors)=>{
        const elements = {};
        Object.keys(selectors).forEach((key)=>{
            elements[key] = document.querySelector(selectors[key]) || null;
        });
        return elements;
    };
    /**
   * Initializes the check result process.
   * If the current step is '2' and a result element exists, it schedules a checkResult call after a specified delay.
   *
   * @returns {void}
   */ initCheckResult = ()=>{
        const step = this.config.step;
        const result = this.config.el.result;
        if (step !== null && step == "2" && result) setTimeout(()=>{
            this.checkResult();
            console.info("checkResult: Send initial request after " + this.config.initialDelay + "ms");
        }, this.config.initialDelay);
    };
    /**
   * Initializes the config for the view module.
   *
   * This function sets up the URL for AJAX requests and retrieves the current step from the DOM.
   * It uses the formatAjaxUrl method to construct the URL and the getStepFromDOM method to get the current step.
   *
   * @returns {void}
   */ initConfig = ()=>{
        this.config.basePath = window.app.ajaxPath;
        this.config.el = this.initDomElements(this.config.selectors);
        this.config.url = this.formatAjaxUrl(this.config.basePath, this.config.processStep, this.config.path);
        this.config.step = this.getStepFromDOM(this.config.selectors.currentStep);
    };
    /**
   * Initializes events for the module.
   *
   * @returns {void}
   */ initEvents = ()=>{
        // Monitor selects with [data-docreader-select-dossier] attribute using event delegation
        document.addEventListener("change", (event)=>{
            if (event.target.matches(this.config.selectors.selectDossier)) this.selectDossierEventHandler(event);
        });
        // Monitor input fields with [data-factuur-bedrag] attribute using event delegation
        document.addEventListener("keyup", (event)=>{
            if (event.target.matches(this.config.selectors.factuurBedrag)) this.changeFactuurBedragEventHandler(event);
        });
        // Monitor input fields with [data-factuur-bedrag] attribute using event delegation
        document.addEventListener("blur", (event)=>{
            if (event.target.matches(this.config.selectors.factuurBedrag)) this.changeFactuurBedragEventHandler(event);
        });
        // Monitor button with [data-docreader-add-declaratie] attribute using event delegation
        document.addEventListener("click", (event)=>{
            if (event.target.matches(this.config.selectors.declaratiesAdd)) this.addDeclaratieRowEventHandler();
        });
        // Monitor button with [data-docreader-remove-declaratie] attribute using event delegation
        document.addEventListener("click", (event)=>{
            if (event.target.matches(this.config.selectors.declaratiesRemove)) this.removeDeclaratieRowEventHandler(event);
        });
    };
    /**
   * Formats the AJAX URL by combining the base path, step, and path.
   *
   * @param {string} basePath - The base path of the URL.
   * @param {string} step - The step to be included in the URL.
   * @param {string} path - The specific path to be appended.
   *
   * @returns {string} The formatted AJAX URL.
   */ formatAjaxUrl = (basePath, step, path)=>{
        const url = basePath + step + path;
        return url;
    };
    /**
   * Handles the change of the factuur bedrag.
   *
   * @param {Event} event - The event object.
   *
   * @returns {void}
   */ changeFactuurBedragEventHandler = ()=>{
        const total = this.calculateTotal(this.config.el.resultTable, this.config.selectors.selectDossier, this.config.selectors.factuurBedrag);
        this.config.el.factuurBedragTotal.value = total;
    };
    /**
   * Handles the change of the select dossier.
   *
   * @param {Event} event - The event object.
   *
   * @returns {void}
   */ selectDossierEventHandler = (event)=>{
        const selectedValue = event.target.value;
        const rowElement = event.target.closest("tr");
        const total = this.calculateTotal(this.config.el.resultTable, this.config.selectors.selectDossier, this.config.selectors.factuurBedrag);
        this.setRowSignal(rowElement, selectedValue);
        this.config.el.factuurBedragTotal.value = total;
    };
    /**
   * Sets the signal for a row based on the selected value.
   *
   * @param {Element} row - The row element.
   * @param {string} selectedValue - The selected value.
   *
   * @returns {void}
   */ setRowSignal = (row, selectedValue)=>{
        const classes = this.config.rowSignalClasses;
        row.classList.remove(classes.success, classes.warning, classes.danger);
        if (selectedValue === "uitsluiten") row.classList.add(classes.danger);
        else if (selectedValue === "") row.classList.add(classes.warning);
        else row.classList.add(classes.success);
    };
    /**
   * Calculates the total of valid rows.
   *
   * @todo: Test die dmv een mockup table met een tr kijkt of a.h.v. juiste string de juiste class wordt toegevoegd
   *
   * @param {Element} tableElement - The table element.
   * @param {string} dossierSelector - The selector for the dossier.
   * @param {string} factuurBedragSelector - The selector for the factuur bedrag.
   *
   * @returns {string} The total formatted as a currency string.
   */ calculateTotal = (tableElement, dossierSelector, factuurBedragSelector)=>{
        let total = (0, (/*@__PURE__*/$parcel$interopDefault($13AFs)))(0);
        const rows = tableElement.querySelectorAll("tbody tr");
        rows.forEach((row)=>{
            const select = row.querySelector(dossierSelector);
            const factuurBedrag = row.querySelector(factuurBedragSelector);
            const selectedValue = select.value;
            if (selectedValue !== "uitsluiten" && selectedValue !== "") {
                const amount = (0, (/*@__PURE__*/$parcel$interopDefault($13AFs)))(factuurBedrag.value, {
                    separator: "",
                    decimal: ","
                });
                total = total.add(amount);
            }
        });
        return total.format({
            separator: "",
            decimal: ",",
            symbol: ""
        });
    };
    /**
   * Retrieves the current step from the DOM.
   *
   * @todo: test die dmv een mockup de step uit de dom haalt
   *
   * @param {string} selector - The selector for the current step.
   *
   * @returns {void}
   */ getStepFromDOM = (selector)=>{
        const element = document.querySelector(selector);
        const step = element.dataset.docreaderCurrentStep;
        const stepInt = parseInt(step);
        return stepInt;
    };
    /**
   * Checks the result by making an AJAX request.
   *
   * @returns {void}
   */ checkResult = ()=>{
        const startTime = Date.now();
        const checkTimeout = ()=>{
            if (Date.now() - startTime > this.config.timeout) {
                this.domShowResults("", true);
                console.warn("Error: Request timed out");
                return;
            }
            fetch(this.config.url).then((response)=>response.text()).then((data)=>{
                const parsedData = JSON.parse(data);
                console.info(parsedData);
                try {
                    const parsedData = JSON.parse(data);
                    if (parsedData.status == "inProgress") {
                        console.info("Send request: No result yet...");
                        setTimeout(checkTimeout, this.config.requestInterval);
                    } else if (parsedData.status == "success") this.domShowResults(parsedData.template);
                    else if (parsedData.status == "failed") {
                        this.domShowResults(parsedData.template, true);
                        console.warn("failed");
                    }
                } catch (error) {
                    console.warn("Error parsing JSON:", error);
                }
            }).catch((error)=>{
                console.warn("Error:", error);
            });
        };
        checkTimeout();
    };
    /**
   * Applies the result to the DOM.
   *
   * @param {string} data - The result data to be applied.
   * @param {boolean} error - Whether the result is an error.
   *
   * @returns {void}
   */ domShowResults = (data, error = false)=>{
        this.config.el.result.innerHTML = data;
        this.config.el.result.classList.remove("d-none");
        this.config.el.progress.classList.add("d-none");
        this.config.el = this.initDomElements(this.config.selectors);
        if (error) {
            this.config.el.alertWarning.classList.remove("d-none");
            this.addDeclaratieRow(this.config.el.resultTable?.querySelector("tbody"), this.config.el.declaratiesTemplate);
        } else this.config.el.alertSuccess.classList.remove("d-none");
        (0, $5559bcad9cf8f504$export$2e2bcd8739ae039).init(this.config.el.form);
        (0, $46c3b49fce744198$export$2e2bcd8739ae039).init(this.config.el.form);
        (0, $d879645a047cc454$export$2e2bcd8739ae039).init(this.config.el.form);
        (0, $4ee4564850efd542$export$2e2bcd8739ae039).init(this.config.el.form);
        (0, $92a9257e94e58e2f$export$2e2bcd8739ae039).init(this.config.el.form);
        this.initEvents();
        if (!error) this.matchNamesInTable(this.config.el.resultTable, this.config.selectors.resultName, this.config.selectors.selectDossier, this.config.selectors.dossierNameOption);
    };
    /**
   * Calculates the Levenshtein distance between two strings.
   *
   * @todo: test genereren
   *
   * @param {string} a - The first string.
   * @param {string} b - The second string.
   *
   * @returns {number} The Levenshtein distance between the two strings.
   */ levenshteinDistance = (a, b)=>{
        const matrix = [];
        // Increment along the first column of each row
        for(let i = 0; i <= b.length; i++)matrix[i] = [
            i
        ];
        // Increment each column in the first row
        for(let j = 0; j <= a.length; j++)matrix[0][j] = j;
        // Fill the rest of the matrix
        for(let i = 1; i <= b.length; i++){
            for(let j = 1; j <= a.length; j++)if (b.charAt(i - 1) === a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
            else matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
            matrix[i][j - 1] + 1, // insertion
            matrix[i - 1][j] + 1 // deletion
            );
        }
        return matrix[b.length][a.length];
    };
    /**
   * Finds the closest match based on Levenshtein Distance and additional criteria.
   *
   * @todo: test genereren die string matcht met een array van objecten
   *
   * @param {string} targetName - The target name.
   * @param {Array} optionsArray - The array of options.
   *
   * @returns {Element|null} The closest matching option or null if no match is found.
   */ findClosestMatch = (targetName, optionsArray, threshold)=>{
        let closestMatch = null;
        let minDistance = Infinity;
        optionsArray.forEach((item)=>{
            const distance = this.levenshteinDistance(targetName.toLowerCase(), item.werknemerNaam.toLowerCase());
            const maxLength = Math.max(targetName.length, item.werknemerNaam.length);
            const normalizedDistance = distance / maxLength;
            if (normalizedDistance < threshold && normalizedDistance < minDistance) {
                minDistance = normalizedDistance;
                closestMatch = item;
            }
        });
        return closestMatch;
    };
    /**
   * Matches the names in the table.
   *
   * @todo: tableElement en inputFieldSelector en dossierNameSelector en dossierNameOptionSelector meegeven en testen met mockup
   *
   * @param {Element} tableElement - The table element.
   * @param {string} inputFieldSelector - The selector for the input field.
   * @param {string} dossierNameSelector - The selector for the dossier name.
   * @param {string} dossierNameOptionSelector - The selector for the dossier name option.
   *
   * @returns {void}
   */ matchNamesInTable = (tableElement, inputFieldSelector, dossierNameSelector, dossierNameOptionSelector)=>{
        const rows = tableElement.querySelectorAll("tbody tr");
        rows.forEach((row)=>{
            const inputField = row.querySelector(inputFieldSelector);
            const targetName = inputField.value.trim();
            const select = row.querySelector(dossierNameSelector);
            const options = select.querySelectorAll(dossierNameOptionSelector);
            const optionsArray = this.mapOptionsToArray(options);
            const closestMatchedOption = this.findClosestMatch(targetName, optionsArray, 0.6);
            if (closestMatchedOption) {
                if (!this.hasDuplicateWerknemerId(optionsArray, closestMatchedOption.werknemerId)) {
                    select.value = closestMatchedOption.werknemerMeldingId || "";
                    this.setRowSignal(row, closestMatchedOption);
                }
            }
        });
    };
    /**
   * Checks if the werknemerId appears more than once in the options array.
   *
   * @param {Array} optionsArray - The array of options.
   * @param {string} werknemerId - The werknemerId to check.
   *
   * @returns {boolean} True if the werknemerId appears more than once, false otherwise.
   */ hasDuplicateWerknemerId = (optionsArray, werknemerId)=>{
        const count = optionsArray.filter((option)=>option.werknemerId === werknemerId).length;
        return count > 1;
    };
    /**
   * Maps option elements to an array of objects containing werknemerId and werknemerNaam.
   *
   * @param {NodeList} options - The NodeList of option elements.
   *
   * @returns {Array} An array of objects with werknemerId and werknemerNaam properties.
   */ mapOptionsToArray = (options)=>{
        return Array.from(options).map((option)=>({
                werknemerMeldingId: option.value,
                werknemerNaam: option.dataset.docreaderDossierNameOption,
                werknemerId: option.dataset.docreaderWerknemerIdOption
            }));
    };
    /**
   * Handles the addition of a declaratie row.
   *
   * @returns {void}
   */ addDeclaratieRowEventHandler = ()=>{
        const tableBodyElement = this.config.el.resultTable.querySelector("tbody");
        const templateElement = this.config.el.declaratiesTemplate;
        const clone = this.addDeclaratieRow(tableBodyElement, templateElement);
        this.renumberDeclaraties(tableBodyElement, clone, "declaraties");
        (0, $4ee4564850efd542$export$2e2bcd8739ae039).init(clone);
        (0, $92a9257e94e58e2f$export$2e2bcd8739ae039).init(clone);
        (0, $5559bcad9cf8f504$export$2e2bcd8739ae039).init(clone);
    };
    /**
   * Adds a declaratie row to the table.
   *
   * @todo: test die op basis van een mockup kijkt of er een tr wordt toegevoegd aan table op bassis van template
   *
   * @param {Element} templateElement - The template element.
   *
   * @returns {Element|null} The cloned element or null if the template element is not found.§
   */ addDeclaratieRow = (tableBodyElement, templateElement)=>{
        const clone = templateElement?.content.cloneNode(true) || null;
        if (clone) tableBodyElement.appendChild(clone);
        return clone;
    };
    /**
   * Renumbers the declaratie rows.
   *
   * @todo: test die op basis van een mockup kijkt of input en select elementen in een table worden genummerd
   *
   * @param {Element} tableBodyElement - The table body element.
   * @param {Element} clone - The clone element.
   * @param {string} baseName - The base name.
   *
   * @returns {void}
   */ renumberDeclaraties = (tableBodyElement, clone, baseName)=>{
        tableBodyElement.querySelectorAll("tr").forEach((row, index)=>{
            row.querySelectorAll("input, select").forEach((element)=>{
                const dataNameValue = element.getAttribute("data-docreader-name");
                if (dataNameValue) {
                    const name = `${baseName}[${index + 1}][${dataNameValue}]`;
                    element.setAttribute("name", name);
                }
            });
        });
    };
    /**
   * Handles the removal of a declaratie row.
   *
   * @param {Event} event - The event object triggered by clicking the remove button.
   *
   * @returns {void}
   */ removeDeclaratieRowEventHandler = (event)=>{
        this.removeDeclaratieRow(event.target);
    };
    /**
   * Removes a declaratie row from the table.
   *
   * @param {Element} target - The element that triggered the removal.
   *
   * @todo: test die op basis van een mockup kijkt of regel wordt verwijderd waar het target element zich in bevindt
   *
   * @returns {void}
   */ removeDeclaratieRow = (target)=>{
        const row = target.closest("tr");
        if (row) row.remove();
    };
}
var $537663f7e81661f0$export$2e2bcd8739ae039 = $537663f7e81661f0$var$VerzamelBeschikking;


const $18b36b650f433b5c$var$addView = {
    init: function() {
        let verzamelBeschikking = new (0, $537663f7e81661f0$export$2e2bcd8739ae039)();
        verzamelBeschikking.init();
    }
};
var $18b36b650f433b5c$export$2e2bcd8739ae039 = $18b36b650f433b5c$var$addView;



const $be28f1d4b01953b3$var$edit = {
    init () {
        // laad de datum kiezer voor einddatum op basis van de begindatum
        $("#Begindatum").change(function(e) {
            e.preventDefault();
            $("input#Einddatum").attr("data-enddate", $("input#Begindatum").attr("data-enddate"));
            // $('input#Einddatum').data('datepicker').setEndDate($('input#Begindatum').attr('data-enddate')); // omgezet naar onderstaande regel wegens error na bundling
            $("input#Einddatum").datepicker((0, $4ee4564850efd542$export$2e2bcd8739ae039).settings.date, "setEndDate", $("input#Begindatum").attr("data-enddate"));
            $("input#Einddatum").attr("data-startdate", $("input#Begindatum").val());
            // $('input#Einddatum').data('datepicker').setStartDate($('input#Begindatum').val()); // omgezet naar onderstaande regel wegens error na bundling
            $("input#Einddatum").datepicker((0, $4ee4564850efd542$export$2e2bcd8739ae039).settings.date, "setStartDate", $("input#Begindatum").val());
            $be28f1d4b01953b3$var$edit.checkDuplicate();
        });
        // Trigger change van begindatum als pagina geladen wordt
        $("#Begindatum").trigger("change");
        // Voer controle op dubbelle invoer uit als einddatum gewijzigd wordt
        $("#Einddatum").change(function(e) {
            e.preventDefault();
            $be28f1d4b01953b3$var$edit.checkDuplicate();
        });
        // Trigger change van einddatum als pagina geladen wordt
        $("#Einddatum").trigger("change");
    },
    // Functie om te controleren op dubbele invoer
    checkDuplicate: function() {
        if ($("#Begindatum").val() != "") $.getJSON(window.app.ajaxPath + $("#form-afstandsverklaring").data("werknemer_id") + "/" + $("#form-afstandsverklaring").data("deelname_afstandsverklaring_id") + "/duplicate-check/" + $("#Begindatum").val() + "/" + $("#Einddatum").val() + "/", function(data) {
            if (data != false) {
                // Er is een overlappend salaris
                if (!$("#form_suggestion").is(":visible")) {
                    $("#form_suggestion").hide().removeClass("d-none").fadeIn();
                    $("#form_continue").hide();
                }
                $(".gevonden-afstandsverklaring *").remove();
                $.each(data, function(index, val) {
                    var tr = "<tr><td>" + val.begindatum + "</td><td>" + val.einddatum + "</td><td>" + val.action + "</td></tr>";
                    $(".gevonden-afstandsverklaring").append(tr);
                });
            } else // Er is nog geen overlappend salaris
            $be28f1d4b01953b3$var$edit.hideFormSuggestion();
        });
    },
    // Verberg het blok met als deze zichtbaar is
    hideFormSuggestion: function() {
        $("#form_suggestion").fadeOut(100, function() {
            $("#form_continue").hide().removeClass("d-none").fadeIn();
        });
    }
};
var $be28f1d4b01953b3$export$2e2bcd8739ae039 = $be28f1d4b01953b3$var$edit;



const $49e7ba0e8f1e18fc$var$toevoegenVanHisPolis = {
    init () {
        // Unbind gebruikelijke submit functie en creeer nieuwe submit die via modal verloopt
        $("form[data-validate]").attr("data-validate-onsubmit-disabled", true);
        $("form[data-validate]").submit(async function() {
            let validated = await (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkSubmitForm(this);
            if (validated) {
                $("#loadingModal").modal("show", {
                    backdrop: "static",
                    keyboard: false
                });
                setTimeout(function() {
                    $("form[data-validate]").unbind("submit");
                    $("form[data-validate]").submit();
                }, 1000);
            //
            }
            return false;
        });
        // Toon en verberg gevonden afstandsverklaringen als begindatum gewijzigd wordt
        $("#Begindatum").change(function(e) {
            e.preventDefault();
            if ($("#Begindatum").val() != "") $.getJSON(window.app.ajaxPath + $("#form-afstandsverklaring").data("werknemer_id") + "/" + $("#form-afstandsverklaring").data("administratie_hispolis_id") + "/duplicate-check/" + $("#Begindatum").val() + "/" + "/", function(data) {
                if (data != false) {
                    // Er is een overlappend salaris
                    if (!$("#form_suggestion").is(":visible")) {
                        $("#form_suggestion").hide().removeClass("d-none").fadeIn();
                        $("#form_continue").hide();
                    }
                    $(".gevonden-afstandsverklaring *").remove();
                    $.each(data, function(index, val) {
                        var tr = "<tr><td>" + val.begindatum + "</td><td>" + val.einddatum + "</td><td>" + val.action + "</td></tr>";
                        $(".gevonden-afstandsverklaring").append(tr);
                    });
                } else // Er is nog geen overlappend salaris
                $49e7ba0e8f1e18fc$var$toevoegenVanHisPolis.hideFormSuggestion();
            });
        });
        // Trigger change van begindatum als pagina geladen wordt
        $("#Begindatum").trigger("change");
    },
    // Verberg het blok met als deze zichtbaar is
    hideFormSuggestion: function() {
        $("#form_suggestion").fadeOut(100, function() {
            $("#form_continue").hide().removeClass("d-none").fadeIn();
        });
    }
};
var $49e7ba0e8f1e18fc$export$2e2bcd8739ae039 = $49e7ba0e8f1e18fc$var$toevoegenVanHisPolis;


const $5f869cccb76a9dd5$var$werknemerListing = {
    init () {
        // Forward naar geselecteerde jaartal
        const selectElements = document.querySelectorAll(".listing-nav select");
        selectElements.forEach((select)=>{
            select.addEventListener("change", function() {
                window.location.href = this.value;
            });
        });
    }
};
var $5f869cccb76a9dd5$export$2e2bcd8739ae039 = $5f869cccb76a9dd5$var$werknemerListing;



var $7FBkt = parcelRequire("7FBkt");
const $b0b939dd34df01dc$var$editView = {
    /**
   * Init events en dom
   *
   * @returns {void}
   */ init () {
        $b0b939dd34df01dc$var$editView.initEvents();
        // Trigger functies bij laden van de pagina
        if (document.getElementById("form-arbeidsovereenkomst")) {
            $b0b939dd34df01dc$var$editView.toggleUitdienstDatum();
            $b0b939dd34df01dc$var$editView.toggleParttimePercentage();
            $b0b939dd34df01dc$var$editView.updateEinddatumRange();
            $b0b939dd34df01dc$var$editView.checkOverlappendDienstverband();
        }
        $b0b939dd34df01dc$var$editView.showModalBeeindiging();
    },
    /**
   * Init de event listeners
   *
   * @returns {void}
   */ initEvents () {
        // Contract veld - Toon of verberg uitdienst datum
        [
            "change",
            "blur"
        ].forEach((eventType)=>{
            document.getElementById("Contract")?.addEventListener(eventType, ()=>{
                $b0b939dd34df01dc$var$editView.toggleUitdienstDatum();
            });
        });
        // Dienstverband veld - Toon of verberg het percentage voor een parttime medewerker
        [
            "change",
            "blur"
        ].forEach((eventType)=>{
            document.getElementById("Dienstverband")?.addEventListener(eventType, ()=>{
                $b0b939dd34df01dc$var$editView.toggleParttimePercentage();
            });
        });
        // Begindatum veld - Laad de datum kiezer voor einddatum op basis van de begindatum
        [
            "change",
            "blur"
        ].forEach((eventType)=>{
            document.getElementById("Begindatum")?.addEventListener(eventType, ()=>{
                $b0b939dd34df01dc$var$editView.updateEinddatumRange();
            });
        });
        // Begindatum, Einddatum en Contract velden - Toon of verberg het blok voor overlappend dienstverband op basis van de begindatum voor een nieuw dienstverband en de einddatum van reeds bestaande dienstverbanden.
        [
            "Begindatum",
            "Einddatum",
            "Contract"
        ].forEach((field)=>{
            [
                "change",
                "blur",
                "input"
            ].forEach((eventType)=>{
                document.getElementById(field)?.addEventListener(eventType, ()=>{
                    $b0b939dd34df01dc$var$editView.checkOverlappendDienstverband();
                });
            });
        });
        // Beeindigingsmelding knop - Toon of verberg beindigingsmodal
        document.getElementById("beeindig-melding-button")?.addEventListener("click", (event)=>{
            event.preventDefault();
            $b0b939dd34df01dc$var$editView.toggleModalBeeindigingMelding(event);
        });
        // Vul suggestie verlengdatum in
        document.querySelectorAll(".btn-verlengdatum")?.forEach((button)=>{
            button.addEventListener("click", (event)=>{
                $b0b939dd34df01dc$var$editView.verlengdatumSuggestie(event);
            });
        });
    },
    /**
   * Toont of verbergt het einddatum veld op basis van het contract type
   *
   * @returns {void}
   */ toggleUitdienstDatum: function() {
        const einddatumInput = document.querySelector("input#Einddatum");
        const contractValue = document.querySelector("#Contract").value;
        if ("BEP" === contractValue) {
            einddatumInput.setAttribute("data-validate", "required date daterange");
            einddatumInput.value = einddatumInput.getAttribute("valueOrg");
            einddatumInput.closest(".form-group").classList.remove("d-none");
            einddatumInput.dispatchEvent(new Event("update.datepicker"));
        } else {
            einddatumInput.value = "";
            einddatumInput.setAttribute("data-validate", "");
            einddatumInput.closest(".form-group").classList.add("d-none");
        }
    },
    /**
   * Toont of verbergt het parttime percentage veld op basis van het dienstverband type
   *
   * @returns {void}
   */ toggleParttimePercentage: function() {
        const percentageInput = document.querySelector("input#ParttimePercentage");
        const dienstverbandValue = document.querySelector("#Dienstverband").value;
        if ("PT" === dienstverbandValue) {
            percentageInput.setAttribute("data-required", "true");
            percentageInput.value = percentageInput.getAttribute("valueOrg");
            percentageInput.closest(".form-group").classList.remove("d-none");
            percentageInput.focus();
        } else {
            percentageInput.removeAttribute("data-required");
            percentageInput.value = "100";
            percentageInput.closest(".form-group").classList.add("d-none");
        }
    },
    /**
   * Werkt de einddatum datepicker bij op basis van de startdatum
   *
   * @returns {void}
   */ updateEinddatumRange: function() {
        const target = document.querySelector("input#Einddatum");
        const begindatum = document.querySelector("input#Begindatum");
        target.setAttribute("data-enddate", begindatum.getAttribute("data-enddate"));
        target.setAttribute("data-startdate", begindatum.value);
        $(target).datepicker("setEndDate", begindatum.getAttribute("data-enddate"));
        $(target).datepicker("setStartDate", begindatum.value);
    },
    /**
   * Controleert op overlappende arbeidsovereenkomsten op basis van start- en einddatum
   *
   * @returns {void}
   */ checkOverlappendDienstverband: function() {
        if ("" !== document.getElementById("Begindatum").value) {
            const werknemer_id = document.getElementById("form-arbeidsovereenkomst").getAttribute("data-werknemer_id");
            const dienstverband_arbeidsovereenkomst_id = document.getElementById("form-arbeidsovereenkomst").getAttribute("data-dienstverband_arbeidsovereenkomst_id");
            const begindatum = document.getElementById("Begindatum").value;
            const einddatum = document.getElementById("Einddatum").value;
            const url = window.app.ajaxPath + werknemer_id + "/" + dienstverband_arbeidsovereenkomst_id + "/duplicate-check/" + begindatum + "/" + einddatum + "/" + dienstverband_arbeidsovereenkomst_id + "/";
            (0, $7FBkt.default).get(url, $b0b939dd34df01dc$var$editView.checkOverlappendDienstverbandParseResponse);
        }
    },
    /**
   * Parses the response from checking for overlapping employment contracts
   *
   * @param {Array|boolean} data - Array of overlapping contract IDs or false if no overlap
   *
   * @returns {void}
   */ checkOverlappendDienstverbandParseResponse: function(data) {
        data = JSON.parse(data);
        if (data && data.length > 0) $b0b939dd34df01dc$var$editView.handleOverlappendDienstverband(data);
        else $b0b939dd34df01dc$var$editView.handleGeenOverlappendDienstverband();
    },
    /**
   * Handelt het geval af wanneer overlappende arbeidsovereenkomsten worden gevonden
   * Toont overlap waarschuwing en verbergt formulier voortzetting sectie terwijl actie links worden getoond
   *
   * @param {Array<string>} data - Array van overlappende contract IDs
   *
   * @returns {void}
   */ handleOverlappendDienstverband: function(data) {
        document.getElementById("form_suggestion")?.classList.remove("d-none");
        document.getElementById("form_continue")?.classList.add("d-none");
        data.forEach(function(id) {
            let rows = document.querySelectorAll('.table-arbeidsovereenkomsten tr[data-dienstverband_arbeidsovereenkomst_id="' + id + '"]');
            rows.forEach(function(row) {
                let linkContainers = row.querySelectorAll("td a");
                linkContainers.forEach(function(link) {
                    link.classList.remove("d-none");
                    link.closest("td").classList.remove("d-none");
                });
            });
        });
    },
    /**
   * Handelt het geval af wanneer geen overlappende arbeidsovereenkomsten worden gevonden
   * Verbergt actie links, overlap waarschuwing en toont formulier voortzetting sectie
   *
   * @returns {void}
   */ handleGeenOverlappendDienstverband: function() {
        const allRows = document.querySelectorAll(".table-arbeidsovereenkomsten tr");
        allRows.forEach(function(row) {
            row.classList.remove("text-danger");
            let links = row.querySelectorAll("a");
            links.forEach(function(link) {
                link.classList.add("d-none");
            });
            let linkContainer = row.querySelector("a");
            if (linkContainer) linkContainer.closest("td").classList.add("d-none");
        });
        document.getElementById("form_suggestion")?.classList.add("d-none");
        document.getElementById("form_continue")?.classList.remove("d-none");
    },
    /**
   * Toont of verbergt de beëindigingsmodal op basis van overlappende arbeidsovereenkomsten
   *
   * @param {Event} event - Het klik event object
   *
   * @returns {void}
   */ toggleModalBeeindigingMelding: function(event) {
        const url = event.target.getAttribute("href");
        (0, $7FBkt.default).get(url, $b0b939dd34df01dc$var$editView.toggleModalBeeindigingMeldingParseResponse);
    },
    /**
   * Parse de response van de beëindigingsmelding
   *
   * @param {string} data - De response data
   *
   * @returns {void}
   */ toggleModalBeeindigingMeldingParseResponse: function(data) {
        if (false !== data) {
            data = JSON.parse(data);
            const modal = document.getElementById("modalBeeindigMelding");
            const bsModal = bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);
            bsModal.hide();
        }
    },
    /**
   * Toont de beëindigingsmodal als er een lopende melding is
   *
   * @returns {void}
   */ showModalBeeindiging: function() {
        const modal = document.getElementById("modalBeeindigMelding");
        if (modal) {
            const bsModal = new bootstrap.Modal(modal);
            bsModal.show();
        }
    },
    /**
   * Vult de voorgestelde verlengdatum in als gebruiker op 'Vul hieronder deze datum in' klikt
   *
   * @param {Event} event - Het klik event object
   *
   * @returns {void}
   */ verlengdatumSuggestie: function(event) {
        const verlengdatum = event.target.dataset.verlengdatum;
        const begindatumInput = document.querySelector("input[name=Begindatum]");
        if (begindatumInput) {
            begindatumInput.value = verlengdatum;
            begindatumInput.dispatchEvent(new Event("blur"));
        }
    }
};
var $b0b939dd34df01dc$export$2e2bcd8739ae039 = $b0b939dd34df01dc$var$editView;


const $3c5ba2f796f41652$var$endView = {
    init () {
        // Toon of verberg het blok voor overlappend dienstverband op basis van de begindatum voor een nieuw dienstverband en de einddatum van reeds bestaande dienstverbanden.
        $("#beeindig-melding-button").click(function(e) {
            e.preventDefault();
            $.getJSON($(this).attr("href"), function(data) {
                if (data != false) $("#modalBeeindigMelding").modal("toggle");
            });
        });
        // Open modal waarschuwing dat er een lopende melding is
        if ($("#modalBeeindigMelding").length) $("#modalBeeindigMelding").modal({
            keyboard: false,
            backdrop: "static"
        });
    }
};
var $3c5ba2f796f41652$export$2e2bcd8739ae039 = $3c5ba2f796f41652$var$endView;


const $643b83bdb147d5f9$var$importExport = {
    init () {
        // Download export button functie die op basis van daterange een download url maakt
        $("#buttonDownloadExport").click(function() {
            var url = $(this).data("url");
            url = url + "/" + $("#begindatum").val() + "/" + $("#einddatum").val() + "/";
            window.location.href = url;
        });
        // Zet on change uit te voeren wijziging in de tabel
        $("select.werknemer-select").change(function() {
            var werknemer_id = $(this).val();
            $(this).closest("tr").find("td.werknemer-diff").html("Geen");
            $(this).closest("tr").find("td.adres-diff").html("Geen");
            if (werknemer_id != "nieuw" && werknemer_id != "overslaan") {
                var werknemerDiff = JSON.parse($(this).closest("tr").find("textarea").val());
                var tableClassColor = "table-warning";
                var table = [];
                table.push("<th>Wijziging</th><th>Van</th><th>Naar</th>");
                $.each(werknemerDiff[werknemer_id]["werknemer"], function(key, value) {
                    var classColor = "";
                    if (key == "achternaam" || key == "voorletters" || key == "geboorte_datum") {
                        classColor = "text-danger";
                        tableClassColor = "table-danger";
                        $(".alert-naamswijziging").removeClass("d-none");
                    }
                    table.push("<tr class=" + classColor + "><td>" + key + "</td><td>" + value.old + "</td><td>" + value.new + "</td></tr>");
                // table.push('<td>' + key + '</td><td>' + value.old + '</td><td>' + value.new + '</td></tr>');
                });
                if (table.length > 1) // $(this).closest('tr').find('td.werknemer-diff').html('<table class="table table-striped"><tr>' + table.join('</tr><tr>') + '</tr></table>');
                $(this).closest("tr").find("td.werknemer-diff").html('<table class="table table-striped ' + tableClassColor + ' mb-0">' + table.join("") + "</table>");
                table = [];
                table.push("<th>Wijziging</th><th>Van</th><th>Naar</th>");
                $.each(werknemerDiff[werknemer_id]["adres"], function(key, value) {
                    // table.push('<td>' + key + '</td><td>' + value.old + '</td><td>' + value.new + '</td>');
                    table.push("<tr><td>" + key + "</td><td>" + value.old + "</td><td>" + value.new + "</td></tr>");
                });
                if (table.length > 1) // $(this).closest('tr').find('td.adres-diff').html('<table class="table table-striped"><tr>' + table.join('</tr><tr>') + '</tr></table>');
                $(this).closest("tr").find("td.adres-diff").html('<table class="table table-striped">' + table.join("") + "</table>");
            }
        });
        // Trigger een change event voor alle werknemer select elementen
        $("select.werknemer-select").each(function() {
            $(this).trigger("change");
        });
        // Toon import errors wanneer pagina geladen wordt
        $(".modal-import-errors").modal("show");
        // Maak tooltip aan met error toelichting voor alle rijen
        $(".modal-import-errors table tbody tr").each(function() {
            $("[data-toggle=tooltip]").tooltip();
        });
    }
};
var $643b83bdb147d5f9$export$2e2bcd8739ae039 = $643b83bdb147d5f9$var$importExport;



var $hzkBE = parcelRequire("hzkBE");



var $JSMaE = parcelRequire("JSMaE");


var $7FBkt = parcelRequire("7FBkt");



/**
 * ContentFunctions method object.
 *
 * Vult Cards en/of Modals in DOM met data retured door POSTrequest met payload contentDefinition en contentVars zoals geset in DOM (data-content-definition en data-content-vars attributes)
 * Zie lib/Dossier/default.yml en App/Werknemers/Dossier.php
 *
 * ContentDefinition opbouw: {'classname':{'functionTarget':{'functionName':'defaultOpen'}} 'classname' is de PHP Class (zie lib/Dossier/default.yml) en 'functionTarget' (bijv. 'card') en 'functionName' (bijv. 'listing') vormen samen de php functie naam (bijv. cardListing() ). Benodigde permissions zijn gedefinieerd in lib/Dossier/default.yml.
 *
 * - Card elementen worden onDomStateReady gevuld op basis van data retured door een POST request met als payload de defaultContentDefinition ([data-default-content-definition] attribute) geset in de DOM op het #content-wrapper element.
 * Bijv: Een defaultContentDefinition met {'beschikking':{'card':{'listing':true}},'betaling':{'card':{'listing':true}}} worden in de DOM de card Beschikking en de card Betaling gevuld met de data gereturned door de PHP functie cardListing in de Betaling en Beschikking PHP Class en zijn default opengeklapt.
 *
 * - Een click of change event getriggerd door een element met het attribute [data-content-function-modal] triggerd een Modal element in de DOM en vuld deze  met data geretured door een POST request als payload de contentDefinition en contentVars zoals geset in de DOM op het event.target element (data-content-definition en data-content-vars attributes)
 * Bijv : Een click event (bijv. een button click) -> triggerd HttpRequest.Send met de bijv. de payload: {"log":{"modal":{"add":true}}} -> Deze returned data waarmee een log toevoegen modal wordt geopend en gereturned door de PHP functie modalAdd() in de Log Class (zie lib/Dossier/default.yml)
 *
 *
 * @property {HTMLElement} targetElement - Het doelelement in de DOM die de aan te passen elementen bevat.
 * @property {Object} pageMethods - Aangepaste methods met betrekking tot de pagina eventueel gedefinieerd in de pagina specifieke js.
 * @property {string|null} contentId - Het ID van de van de betreffende content, wordt gedefinieerd in de DOM.
 * @property {string|null} defaultContentDefinition - De default content definition bij laden van de pagina.
 */ var $48bf720eac6dca02$var$contentFunctions = {
    targetElement: null,
    pageMethods: null,
    contentId: null,
    defaultContentDefinition: null,
    /**
   * Initialiseerd de contentFunctions functies
   *
   *
   * @param {string} targetElement - Het doelelement in de DOM die de aan te passen elementen bevat.
   * @param {Object} [methods={}] - Aangepaste methods met betrekking tot de pagina eventueel gedefinieerd in de pagina specifieke js.
   * @returns {void}
   */ init: function(targetElement = "#content-wrapper", methods = {}) {
        $48bf720eac6dca02$var$contentFunctions.pageMethods = methods;
        $48bf720eac6dca02$var$contentFunctions.targetElement = targetElement;
        $48bf720eac6dca02$var$contentFunctions.contentId = document.querySelectorAll($48bf720eac6dca02$var$contentFunctions.targetElement)[0].getAttribute("data-content-id") || null;
        $48bf720eac6dca02$var$contentFunctions.defaultContentDefinition = document.querySelectorAll($48bf720eac6dca02$var$contentFunctions.targetElement)[0].getAttribute("data-default-content-definition") || null;
        $48bf720eac6dca02$var$contentFunctions.getData();
        $48bf720eac6dca02$var$contentFunctions.initEvents();
    },
    /**
   * Initeer DOM events
   *
   * @returns {string}
   */ initEvents: function() {
        /** Koppel openModal functie aan buttons met data-content-function-modal attribute */ // TODO: title, contentDef en contentVars horen ws in losse functie
        document.addEventListener("click", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches("a[data-content-function-modal], button[data-content-function-modal]")) {
                var title = target.getAttribute("data-content-title") || "";
                var contentDef = JSON.parse(target.getAttribute("data-content-definition"));
                var contentVars = JSON.parse(target.getAttribute("data-content-vars")) || {};
                $48bf720eac6dca02$var$contentFunctions.openModal(title, contentDef, contentVars);
                break;
            }
        }, false);
        /** Koppel selectToggleModalContent functie aan selects met data-content-function-modal attribute */ document.addEventListener("change", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches("select[data-content-function-modal]")) {
                $48bf720eac6dca02$var$contentFunctions.selectToggleModalContent(target);
                break;
            }
        }, false);
        /** Koppel saveModal functie aan submit events */ // TODO: #generalModalContent niet gebruiken maar data attribute
        document.addEventListener("submit", function(event) {
            event.preventDefault();
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches("body #generalModalContent form[data-validate]")) {
                $48bf720eac6dca02$var$contentFunctions.saveModal(event.target);
                break;
            }
        }, false);
    },
    /**
   * Opens a modal and populates it with content based on contentDefinition and contentVars.
   *
   * @param {string} title - De titel van de Modal
   * @param {string} contentDef - De contentDefinition gebruikt voor de POST request in getData
   * @param {Object} contentVars - De contentVars gebruikt voor de POST request in getData
   * @returns {void}
   */ openModal: function(title, contentDef, contentVars) {
        /**
     * Empty the general modal and set the title.
     * @type {JQuery<HTMLElement>}
     */ var modal = $("#generalModal");
        modal.find(".modal-title").html(title);
        modal.find(".modal-body").html("");
        /**
     * Retrieve the data and populate the modal when it's available.
     */ $48bf720eac6dca02$var$contentFunctions.getData(contentDef, contentVars);
    },
    /**
   * Functie waarmee de data uit het formulier in de modal wordt opgeslagen en loading state wordt getriggerd
   *
   * @returns {string}
   */ saveModal: async function(form) {
        var validated = await (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkSubmitForm(form);
        if (validated) {
            $48bf720eac6dca02$var$contentFunctions.toggleSubmitButtonLoadingState(form, true);
            var contentDef = JSON.parse(form.getAttribute("data-content-definition"));
            var id = form.getAttribute("data-id");
            var reload = form.getAttribute("data-content-definition-reload");
            var fields = $48bf720eac6dca02$var$contentFunctions.parseFormFields(form);
            $48bf720eac6dca02$var$contentFunctions.saveData(contentDef, id, fields, reload, form);
        }
    },
    /**
   * Functie waarmee de functionele loading state van het gesubmitte formulier in de DOM wordt ingeschakeld of uitgeschakeld.
   *
   * @param {object} form
   * @param {bool} state
   *
   * @returns {string}
   */ toggleSubmitButtonLoadingState: function(form, state) {
        var submitButton = form.querySelectorAll("button[type=submit]")[0];
        var spinner = submitButton.querySelectorAll("span.spinner")[0];
        if (state) {
            submitButton.setAttribute("disabled", "true");
            spinner.classList.remove("d-none");
        } else {
            submitButton.removeAttribute("disabled");
            spinner.classList.add("d-none");
        }
    },
    /**
   * Functie waarmee de data wordt opgehaald
   *
   * @param {string} contentDef
   * @param {object} vars
   *
   * @returns {string}
   */ selectToggleModalContent: function(target) {
        var title = target.getAttribute("data-content-title") || "";
        var group = target.closest(".form-group");
        var spinner = group.querySelector("[data-form-group-spinner]");
        var contentDef = JSON.parse(target.getAttribute("data-content-definition"));
        var contentVars = JSON.parse(target.getAttribute("data-content-vars")) || {};
        var name = target.getAttribute("name");
        contentVars[name] = target.options[target.selectedIndex].value;
        spinner.classList.remove("d-none");
        setTimeout(function() {
            $48bf720eac6dca02$var$contentFunctions.openModal(title, contentDef, contentVars);
        }, 10);
    },
    /**
   * Functie waarmee de benodigde data, op basis van de contentDefinition en variables, wordt opgehaald met een HttpRequest
   *
   * @param {string} contentDef -
   * @param {object} vars
   *
   * @returns {string}
   */ getData: function(contentDef = null, vars = null) {
        var postData = {
            types: contentDef || $48bf720eac6dca02$var$contentFunctions.defaultContentDefinition || "",
            vars: vars || []
        };
        (0, $7FBkt.default).send("POST", $48bf720eac6dca02$var$contentFunctions.getDataPath(), $48bf720eac6dca02$var$contentFunctions.parseData, $48bf720eac6dca02$var$contentFunctions.encodeFormData(postData));
    },
    /**
   * Functie waarmee de data wordt opgeslagen op basis van de contentDefinition en de fields
   *
   * @param {string} contentDef - De contentdefinitie
   * @param {string} id - Het id van het betreffende item (optioneel).
   * @param {object} fields - De velden die opgeslagen moeten worden.
   * @param {Array} reload - Een array van elementen die herladen moeten worden na opslaan (optioneel).
   * @param {Element} form - Het formulierelement (optioneel).
   *
   * @returns {void}
   */ saveData: function(contentDef = null, id = "", fields = null, reload = [], form) {
        var postData = {
            id: id,
            fields: fields || [],
            reload: reload || [],
            save: contentDef || ""
        };
        (0, $7FBkt.default).send("POST", $48bf720eac6dca02$var$contentFunctions.getDataPath(), function(response) {
            response = JSON.parse(response);
            if (!response.success) {
                var report = response.report || "Gegevens niet opgeslagen";
                (0, $hzkBE.default)("danger", "", report);
                $48bf720eac6dca02$var$contentFunctions.toggleSubmitButtonLoadingState(form, false);
            } else {
                (0, $hzkBE.default)("success", "", "Gegevens opgeslagen");
                $(".modal").modal("hide");
                if (response.action.gotoUrl !== "") window.location.href = response.action.gotoUrl;
                else if (response.action.reloadPage) window.location.reload(false);
                else $48bf720eac6dca02$var$contentFunctions.getData(response.action.reloadContent);
            }
        }, $48bf720eac6dca02$var$contentFunctions.encodeFormData(postData));
    },
    /**
   * Voer voor elke class/functie, geset in de data, de ModalContent of CardContent functie uit om de inhoud van deze te setten
   *
   * Bijvoorbeeld: {"log":{"modal":{"add":"<div>Voorbeeld</div>"}}} - Vult modal body met '<div>Voorbeeld</div>' en opent modal)
   * Bijvoorbeeld: {"actie":{"card":{"listing":{"heading":"<div>Voorbeeld</div>","body":"<div>Voorbeeld</div>"}}}} - Vult card head met '<div>Voorbeeld</div>' en body met '<div>Voorbeeld</div>')
   *
   * @param {object} data
   *
   * @returns {string}
   */ parseData: function(data) {
        var dataJSON = JSON.parse(data);
        var functionName;
        for (let [classname, functions] of Object.entries(dataJSON)){
            for (let [target, contents] of Object.entries(functions))for (let [name, content] of Object.entries(contents)){
                functionName = "setContent" + (0, $JSMaE.default).upperCaseFirst(classname) + (0, $JSMaE.default).upperCaseFirst(target) + (0, $JSMaE.default).upperCaseFirst(name);
                if (typeof $48bf720eac6dca02$var$contentFunctions.pageMethods[functionName] === "function") $48bf720eac6dca02$var$contentFunctions.pageMethods[functionName](content);
                else if (target == "modal") $48bf720eac6dca02$var$contentFunctions.setModalContent(content);
                else $48bf720eac6dca02$var$contentFunctions.setCardContent(classname, target, name, content);
            }
        }
    },
    /**
   * Vul in de DOM een modal element met de geladen inhoud
   *
   * @param {string} content
   *
   * @returns {string}
   */ setModalContent: function(content) {
        /** Vul en open de modal */ var modal = $("#generalModal");
        modal.find(".modal-body").html(content);
        modal.modal("show");
        modal.on("shown.bs.modal", function() {
            modal.find(".form-group:first-of-type [data-focus]").focus();
        });
        /** Initieer de benodigde functies voor de formulieren */ var form = modal.find(".modal-body form");
        (0, $46c3b49fce744198$export$2e2bcd8739ae039).init(form);
        (0, $d879645a047cc454$export$2e2bcd8739ae039).init(form);
        (0, $4ee4564850efd542$export$2e2bcd8739ae039).init(form);
        (0, $48f23611b62cf521$export$2e2bcd8739ae039).initFilepond(modal[0]);
        (0, $cbba02f95b4e7e13$export$2e2bcd8739ae039).initBlurEvent(modal[0]);
    },
    /**
   * Vul in de DOM een Card element met de geladen inhoud, bestaande uit een Heading en een Body van de card
   *
   * @param {string} classname
   * @param {string} target
   * @param {string} name
   * @param {string} content
   *
   * @returns {string}
   */ setCardContent: function(classname, target, name, content) {
        var cardHeading = document.querySelectorAll("[data-content-slug=" + (classname + "-" + target + "-" + name) + "] [data-card-content-heading]");
        if (typeof cardHeading[0] !== "undefined") $(cardHeading).html(content.heading);
        var cardBody = document.querySelectorAll("[data-content-slug=" + (classname + "-" + target + "-" + name) + "] [data-card-content-body]");
        if (typeof cardBody[0] !== "undefined") $(cardBody).fadeOut(200, function() {
            $(cardBody).html(content.body);
            $(cardBody).fadeIn(200);
        });
    },
    /**
   * Verwerk de velden in form voor submit
   *
   * @param {object} form
   *
   * @returns {object}
   */ parseFormFields: function(form) {
        var obj = {};
        $.each($(form).serializeArray(), function(i, o) {
            var n = o.name, v = o.value;
            obj[n] = obj[n] === undefined ? v : $.isArray(obj[n]) ? obj[n].concat(v) : [
                obj[n],
                v
            ];
        });
        return obj;
    },
    /**
   * Encode data voor submit
   *
   * @param {object} data
   *
   * @returns {string}
   */ encodeFormData: function(data) {
        var formData = new FormData();
        for (let [index, value] of Object.entries(data)){
            if (typeof value == "object") value = JSON.stringify(value);
            formData.append(index, value);
        }
        return formData;
    },
    /**
   * Verkrijg data path op basis van content id en ajax url
   *
   * @returns {string}s
   */ getDataPath: function() {
        return window.app.ajaxPath + "content/";
    }
};
var $48bf720eac6dca02$export$2e2bcd8739ae039 = $48bf720eac6dca02$var$contentFunctions;



const $91089521b1ff886b$var$editView = {
    init () {
        // Controleer of er reeds een werknemer id geset is
        if ($("#form-werknemer").data("werknemer_id") == "") {
            // Controleer of er al een werknemer voorkomt met deze geslacht / geboortedatum combi
            $("#geboorte_datum").on("change", function() {
                $91089521b1ff886b$var$editView.toggleFormContinue();
            });
            // Controleer of er al een werknemer voorkomt met deze geslacht / geboortedatum combi
            $("#geboorte_datum").on("blur", function() {
                $91089521b1ff886b$var$editView.toggleFormContinue();
            });
            // Controleer of er al een werknemer voorkomt met deze geslacht / geboortedatum combi
            $("#geslacht").on("change", function() {
                $91089521b1ff886b$var$editView.toggleFormContinue();
            });
            // Verberg suggestieformulier wanneer een nieuwe werknemer wordt ingevoerd
            $("#nieuwe_werknemer").on("click", function() {
                $91089521b1ff886b$var$editView.hideFormSuggestion();
            });
        } else // Verberg het suggestieformulier als er nog geen werknemer ID geset is
        $91089521b1ff886b$var$editView.hideFormSuggestion();
        // Zet voorletters in juiste format onChange
        $("#voorletters").on("change", function() {
            var val = $(this).val();
            if (val !== "") {
                val = val.toUpperCase().match(/[A-Z]+/g).join("");
                val = val.split("").join(".") + ".";
                $(this).val(val.substring(0, 10));
            }
        });
        // Haal op basis van postcode de adresgegvens op
        $(".postcode-check").on("change", function(e) {
            e.preventDefault();
            var land = $(this).closest(".adres").find(".land").val();
            var postcode = $(this).closest(".adres").find(".postcode").val();
            var huisnummer = $(this).closest(".adres").find(".huisnummer").val();
            var current_element = this;
            // Maak postcode veld alleen verplicht als het om een nederlands adres gaat
            // if (land == 'NL') {
            // 	$(this).closest('.adres').find('.postcode').attr('data-validate', 'required postcode');
            // }
            // Als het volledige adres is ingevuld
            if (land != "" && land == "NL" && postcode != "" && huisnummer != "") // Haal adresgegevens op
            $.getJSON(window.app.ajaxPath + $("#form-werknemer").data("administratie_relatie_id") + "/" + $("#form-werknemer").data("werknemer_id") + "/postcode-check/" + land + "/" + postcode + "/" + huisnummer + "/", function(data) {
                if (data != false) {
                    $(current_element).closest(".adres").find(".plaats").val(data.woonplaats).attr("readonly", true);
                    $(current_element).closest(".adres").find(".straat").val(data.straat).attr("readonly", true);
                    $(current_element).closest(".adres").find(".postcode-check-niet-gevonden").hide();
                } else {
                    $(current_element).closest(".adres").find(".plaats").val("").removeAttr("readonly");
                    $(current_element).closest(".adres").find(".straat").val("").removeAttr("readonly");
                    $(current_element).closest(".adres").find(".postcode-check-niet-gevonden").hide().removeClass("d-none").show();
                }
            });
        });
        // Maak van de eerste letter van achternaam een hoofdletter
        $("#achternaam").keyup(function() {
            var v = $(this).val();
            $(this).val(v.substr(0, 1).toUpperCase() + v.substr(1));
        });
        // Valideer adres tekstvelden opnieuw wanneer je land aanpast
        $("body").on("change", ".land", function() {
            $(".form-section-woonadres, .form-section-postadres").find("input[type=text]").each(function() {
                if ($(this).val().length > 0) $(this).trigger("blur");
            });
        });
        // Initieer showPostAdres als zelfde_als_woonadres checkbox gewijzgd wordt
        $("input.zelfde_als_woonadres").change($91089521b1ff886b$var$editView.showPostAdres);
        // Initieer showPostAdres on page load
        $91089521b1ff886b$var$editView.showPostAdres();
        // Bind permission buttons met changePermission function
        $("[data-toggle=content-modal-change]").on("change", function(event) {
            (0, $db34121f0e960780$export$2e2bcd8739ae039).getModal(event);
        });
        // Bind permission buttons met changePermission function
        $("[data-toggle=content-modal-blur]").on("blur", function(event) {
            var origineleWaarde = $(event.target).attr("data-content-modal-param2");
            var nieuweWaarde = $(event.target).val();
            var datepicker = $(".datepicker-dropdown");
            if (origineleWaarde !== nieuweWaarde && !datepicker.length) (0, $db34121f0e960780$export$2e2bcd8739ae039).getModal(event);
        });
        // Bind functie om wijziging ongedaan te maken aan button en verberg modal
        $("body").on("click", "#wijzigingOngedaanMaken", function(event) {
            $91089521b1ff886b$var$editView.wijzigingOngedaanMaken(event);
            $("#generalModal").modal("toggle");
        });
    },
    toggleFormContinue: function() {
        if ($("#geslacht").val() != "" && $("#geboorte_datum").val() != "") $.getJSON(window.app.ajaxPath + $("#form-werknemer").data("administratie_relatie_id") + "/" + $("#form-werknemer").data("werknemer_id") + "/duplicate-check/" + $("#geboorte_datum").val() + "/" + $("#geslacht").val() + "/", function(data) {
            if (data != false) {
                // Er bestaat reeds een werknemer met deze geboortedatum / geslacht
                $("#form_suggestion").hide().removeClass("d-none").fadeIn();
                $("#form_continue").hide();
                $(".gevonden-werknemers *").remove();
                $.each(data, function(index, val) {
                    $(".gevonden-werknemers").append('<p><a href="' + val.url + '">' + val.naam + "</a><br></p>");
                });
            // Als er nog geen werknemer met deze geboortedatum / geslacht is
            } else // Verberg het formulier
            $91089521b1ff886b$var$editView.hideFormSuggestion();
        });
    },
    // Verberg eerste deel van formulier en toon tweede deel
    hideFormSuggestion: function() {
        $("#form_suggestion").fadeOut(100, function() {
            $("#form_continue").hide().removeClass("d-none").fadeIn();
        });
    },
    // Functie om postadres te tonen
    showPostAdres: function() {
        if ($("input.zelfde_als_woonadres").is(":checked")) {
            $("div.postadres_fields").addClass("d-none");
            $("div.postadres_fields").find("input,select").each(function() {
                var validate = $(this).attr("data-validate");
                $(this).attr("data-validate", "").attr("data-validate-org", validate);
            });
        } else {
            $("div.postadres_fields").removeClass("d-none");
            $("div.postadres_fields").find("input,select").each(function() {
                var validate = $(this).attr("data-validate-org");
                $(this).attr("data-validate-org", "").attr("data-validate", validate);
            });
        }
    },
    // Functie om wijziging ongedaan te maken op basis van een meegegeven veldnaam en waarde
    wijzigingOngedaanMaken: function(event) {
        var field = $(event.target).data("field");
        var value = $(event.target).data("value");
        $("#" + field).val(value);
    }
};
var $91089521b1ff886b$export$2e2bcd8739ae039 = $91089521b1ff886b$var$editView;



var $hzkBE = parcelRequire("hzkBE");


var $94iP7 = parcelRequire("94iP7");
// import logoutTimer from './valideerActie/logoutTimer.js';
const $a61b9fb361780bff$var$valideerActie = {
    init () {
        // logoutTimer.init();
        // Toon waarschuwing als deze actie reeds wordt bewerkt
        if ($("#claimModal").length) $("#claimModal").modal({
            backdrop: "static",
            keyboard: false
        }, "show");
        // Functie om te voorkomen dat een dropdown dicht gaat als er op een select geklikt wordt
        $("#content-wrapper .dropdown-menu").on("click", function(e) {
            e.stopPropagation();
        });
        // Toon en verberg aanvullende validatie velden bij valideer met of zonder wijziging
        $(".valideerMetWijziging").change(function() {
            var t = $(this).closest("form").find(".verbergZonderWijziging").closest(".form-group");
            if ($(this).val() == "metWijziging") t.removeClass("d-none").find("input,select").not("#NR_SCHMIJ").each(function(i, e) {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(e);
            });
            else t.removeClass("d-none").addClass("d-none").find("input,select").each(function(i, e) {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(e);
            });
        });
        $(".valideerMetWijziging").trigger("change");
        // Toon en verberg einddatum wanneer bekend
        $('select[name="stopzettenEinddatumBekend"]').change(function() {
            var t = $(".stopzetten-einddatum").closest(".form-group").parent("div");
            if ($(this).val() == "einddatumBekend") t.removeClass("d-none").find("input,select").each(function(i, e) {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(e);
            });
            else t.addClass("d-none").find("input,select").each(function(i, e) {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(e);
            });
        });
        $("#stopzettenEinddatumBekend").trigger("change");
        // Vul standaard reden in reden veld in
        $("#afwijzenStandaardReden").change(function() {
            var value = $(this).val();
            if (value != "") {
                if ($("#afwijsReden").val() != "") {
                    (0, $hzkBE.default)("danger", "Let op:", "Er staat al text in het reden veld. Verwijder dit eerst.");
                    $(this).val("");
                } else $("#afwijsReden").val($(this).find('option[value="' + $(this).val() + '"]').text().trim()).trigger("blur");
            }
        });
        $("select.VervolgActie").change(function() {
            var t = $(this).closest("form").find(".ExtraCheckDefault");
            if ($(this).val() == "claimbeheer|ExtraCheck") {
                t.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(t);
            } else {
                t.closest(".form-group").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(t);
            }
        });
        $("select.ExtraCheckDefault").change(function() {
            var t = $(this).closest("form").find(".ExtraCheck");
            if ($(this).val() == "anders") {
                t.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(t);
            } else {
                t.val($(this).val()).closest(".form-group").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(t);
            }
        });
        // Vul standaard reden in reden veld in
        $("#rappelAction").change(function() {
            var value = $(this).val();
            if (value !== "rappel_verzenden_zonder") $("#rappelReden").val($(this).find('option[value="' + $(this).val() + '"]').text().trim()).trigger("blur");
        });
        $(".meldingsdatum-aanpassen").click(function() {
            $("#meldingsdatumModal").modal("show");
        });
        $(".uitkeringsgrondslag-bewerken").click(function() {
            $a61b9fb361780bff$var$valideerActie.showUitkeringsgrondslagModal(this, "bewerken");
        });
        $(".uitkeringsgrondslag-verwijderen").click(function() {
            $a61b9fb361780bff$var$valideerActie.showUitkeringsgrondslagModal(this, "verwijderen");
        });
        $(".uitkeringsgrondslag-nieuw").click(function() {
            $a61b9fb361780bff$var$valideerActie.showUitkeringsgrondslagModal(this, "toevoegen");
            $("#uitkeringsGrondslagModal").find('input[name="uitkeringsgrondslag_id"]').val("");
            $("#uitkeringsGrondslagModal").find(".form-group").removeClass("has-error").find("input,select").removeClass("is-invalid");
        });
        $(".actie-wijzigen").click(function() {
            $a61b9fb361780bff$var$valideerActie.showActieModal(this, "wijzigen");
        });
        $(".signalering-bewerken").click(function() {
            $a61b9fb361780bff$var$valideerActie.showSignaleringModal(this, "bewerken");
        });
        $(".signalering-verwijderen").click(function() {
            $a61b9fb361780bff$var$valideerActie.showSignaleringModal(this, "verwijderen");
        });
        $(".signalering-nieuw").click(function() {
            $a61b9fb361780bff$var$valideerActie.showSignaleringModal(this, "toevoegen");
            $("#signaleringModal").find('input[name="signalering_id"]').val("");
            $("#signaleringModal").find(".form-group").removeClass("has-error").find("input,select").removeClass("is-invalid");
        });
        // Toon en verberg einddatum wanneer bekend
        $('select[name="EinddatumBekend"]').change(function() {
            var t = $('input[name="Einddatum"]').closest(".form-group").parent("div");
            if ($(this).val() == "einddatumBekend") t.removeClass("d-none").find("input,select").each(function(i, e) {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(e);
            });
            else t.addClass("d-none").find("input,select").each(function(i, e) {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(e);
            });
        });
        // Toon en verberg rappel signalering
        $("select#rappelAction").change(function() {
            var t = $(".form-section-met-rappel").find("input,select");
            if ($(this).val() == "rappel_verzenden_met") t.each(function(i, e) {
                $(e).closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(e);
            });
            else t.each(function(i, e) {
                $(e).closest(".form-group").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(e);
            });
        });
        // Functie om text op countdown knop te wijzigen
        $("#actionCountdownButton").hover(function() {
            $(this).find(".btn-inner").addClass("d-none");
            $(this).find(".btn-hover").removeClass("d-none");
        }, function() {
            $(this).find(".btn-hover").addClass("d-none");
            $(this).find(".btn-inner").removeClass("d-none");
        });
        // Zet soort betaling op bruto als de betaling aan werkgever of uwv dient te
        $("body").on("change", "#betalingAan", function() {
            var t = $(this).closest("form").find("#soortBetaling");
            if ($(this).val() == "uwv" || $(this).val() == "werkgever") {
                t.val("bruto");
                t.find("option[value=netto]").attr("disabled", "true");
            } else t.find("option[value=netto]").removeAttr("disabled");
        });
        // Toon IBAN als betaling aan werkgever wordt gedaan
        $("body").on("change", "#betalingAan", function() {
            var t = $(this);
            var v = t.val();
            var w = $(".werkgeverIBAN");
            var i = w.closest(".form-group");
            var n = $("input[name=VOLGNR_BANK");
            if (v !== "uwv") {
                i.removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(w);
            } else {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(w);
                i.addClass("d-none");
                w.val("");
                n.val("");
            }
        });
        // Toon IBAN als betaling aan werkgever wordt gedaan
        $("body").on("change", ".werkgeverIBAN", function(e) {
            $("input[name=VOLGNR_BANK").val($(e.target).children("option:selected").data("nr"));
        });
        // Toon loonheffingkorting als betaling aan werknemer wordt gedaan
        $("body").on("change", "#betalingAan", function() {
            var t = $(this);
            var v = t.val();
            var w = $(".loonheffingskorting");
            var i = w.closest(".form-group");
            w.val("");
            if (v == "werknemer") {
                i.removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(w);
            } else {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(w);
                i.addClass("d-none");
            }
        });
        // Toon Zvw velden als betaling aan werknemer wordt gedaan
        $("body").on("change", "#betalingAan", function() {
            var t = $(this);
            var v = t.val();
            var b = $(".zvwBijdrage");
            var bg = b.closest(".form-group");
            var p = $(".zvwBijdragePercentage");
            var pg = p.closest(".form-group");
            if (v == "werknemer") {
                bg.removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(b);
                pg.removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(p);
            } else {
                bg.addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(b);
                pg.addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(p);
                b.val("");
                p.val("");
            }
        });
        // Pas juiste Zvw percentage toe wanneer zvwBijdrage wordt
        $("body").on("change", ".zvwBijdrage", function() {
            var v = $(this).find("option:selected").data("percentage");
            $(".zvwBijdragePercentage").val(v);
        });
        // Toon en verberg aanvullende validatie velden bij valideer met of zonder wijziging
        $(".polisnummer").change(function() {
            var t = $(this).closest("form").find(".verbergZonderWijziging").closest(".form-group");
            if ($(this).val() !== "") {
                t.removeClass("d-none").find("input,select").each(function() {
                // validation.addRequired(e);
                });
                $(".betaling-aan").trigger("change");
            } else t.removeClass("d-none").addClass("d-none").find("input,select").each(function(i, e) {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(e);
            });
        });
        $(".polisnummer").trigger("change");
        // Toon en verberg Betaling aan opties
        $(".modal .polisnummer").change(function() {
            var p = $(this).find("option:selected").data("prod");
            var v = p.toString();
            var inputBetalingAan = $(".modal select.betaling-aan");
            var soortBetaling = $(".modal select.soort-betaling");
            var berekening = $(".modal .berekening");
            var datumBrief = $(".modal .datum-brief");
            var betaalDatum = $(".modal .betaal-datum");
            var brutoLoon = $(".modal .bruto-loon");
            var betalingsKenmerk = $(".modal .betalings-kenmerk");
            var toelichtingUpload = $(".modal .toelichting-upload");
            var betalingBrief = $(".modal .betaling-brief");
            var bewijsOverboeking = $(".modal .bewijs-overboeking");
            if (v == "") $(".verbergZonderWijziging").closest(".form-group").addClass("d-none");
            else if (v == 720 || v == 721 || v == 722 || v == 725 || v == 927 || v == 928 || v == 929) {
                inputBetalingAan.find("option[value=werknemer]").addClass("d-none");
                inputBetalingAan.find("option[value=uwv]").removeClass("d-none");
                soortBetaling.find("option[value=netto]").addClass("d-none");
                berekening.closest(".form-group").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(berekening);
                datumBrief.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(datumBrief);
                betaalDatum.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(betaalDatum);
                brutoLoon.closest(".form-group").removeClass("d-none");
                // validation.addRequired(brutoLoon);
                betalingsKenmerk.closest(".form-group").removeClass("d-none");
                // validation.addRequired(betalingsKenmerk);
                betalingBrief.removeClass("d-none");
                // validation.addRequired(betalingBrief.find('input'));
                bewijsOverboeking.removeClass("d-none");
                // validation.addRequired(bewijsOverboeking.find('input'));
                toelichtingUpload.addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(toelichtingUpload.find("input"));
            } else {
                inputBetalingAan.find("option[value=werknemer]").removeClass("d-none");
                inputBetalingAan.find("option[value=uwv]").addClass("d-none");
                soortBetaling.find("option[value=netto]").removeClass("d-none");
                berekening.closest(".form-group").removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(berekening);
                datumBrief.closest(".form-group").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(datumBrief);
                betaalDatum.closest(".form-group").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(betaalDatum);
                brutoLoon.closest(".form-group").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(brutoLoon);
                betalingsKenmerk.closest(".form-group").addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(betalingsKenmerk);
                betalingBrief.addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(betalingBrief.find("input"));
                bewijsOverboeking.addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(bewijsOverboeking.find("input"));
                toelichtingUpload.removeClass("d-none");
            }
        });
        // Toon of verberg volledige beschrijving in log
        $(".log-beschrijving-toggle").click(function(e) {
            e.preventDefault();
            var p = $(this).closest("table");
            var f = p.find(".beschrijving-full");
            var s = p.find(".beschrijving-short");
            if (f.hasClass("d-none")) {
                f.removeClass("d-none");
                s.addClass("d-none");
                $(this).text("Lees minder...");
            } else {
                f.addClass("d-none");
                s.removeClass("d-none");
                $(this).text("Lees meer...");
            }
        });
        // Maak nieuwe betaling modal leeg wanneer deze geopend wordt
        $("button.betaling-toevoegen").click(function() {
            $("#betalingToevoegenModal").find("input, select").not('[type="hidden"]').val("");
            $("#betalingToevoegenModal select.polisnummer").trigger("change");
            $("#betalingToevoegenModal").find('input[type="upload"]').each(function(i, e) {
                $(this).addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(e);
            });
        });
        // Trigger change op upload modal als op validatieknop geklikt wordt
        $('button[data-target="#valideerModal"]').click(function() {
            $("#valideerModal select.polisnummer").trigger("change");
        });
        // Bind functie om de claimdagen te berekenen
        $(".input-claimdagen-berekenen").on("change", function(e) {
            $a61b9fb361780bff$var$valideerActie.berekenClaimDagen(e);
        });
    },
    showUitkeringsgrondslagModal: function(this_item, type) {
        if (type == "verwijderen") {
            $("#uitkeringsGrondslagModal").find('input[name="action"]').val("uitkeringsgrondslag_verwijderen");
            var button_txt = "Verwijderen";
            var button_class = "btn-danger";
        } else {
            $("#uitkeringsGrondslagModal").find('input[name="action"]').val("uitkeringsgrondslag_wijzigen");
            button_txt = "Opslaan";
            button_class = "btn-primary";
        }
        $('#uitkeringsGrondslagModal .modal-footer button[type="submit"]').text(button_txt).removeClass("btn-primary").removeClass("btn-danger").addClass(button_class);
        $("#uitkeringsGrondslagModal #uitkeringsGrondslagModalLabel span").text(type);
        var uitkeringsgrondslag_id = $(this_item).closest("tr").data("uitkeringsgrondslag_id");
        $("#uitkeringsGrondslagModal").find('input[name="uitkeringsgrondslag_id"]').val(uitkeringsgrondslag_id);
        $("#uitkeringsGrondslagModal").find('input[name="Begindatum"]').val($(this_item).closest("tr").find("td.Begindatum").text()).trigger("blur");
        $("#uitkeringsGrondslagModal").find('input[name="Begindatum"]').datepicker("update");
        $("#uitkeringsGrondslagModal").find('select[name="Periode"]').val($(this_item).closest("tr").find("td.Periode").text()).trigger("blur");
        $("#uitkeringsGrondslagModal").find('input[name="PeriodeLoon"]').val($(this_item).closest("tr").find("td.PeriodeLoon").data("value")).trigger("blur");
        $("#uitkeringsGrondslagModal").find('select[name="Type"]').val($(this_item).closest("tr").find("td.Type").text()).trigger("blur");
        $("#uitkeringsGrondslagModal").modal("show");
    },
    showActieModal: function(this_item, type) {
        if (type == "intrekken") {
            $("#actieModal").find('input[name="action"]').val("actie_intrekken");
            var button_txt = "Intrekken";
            var button_class = "btn-danger";
        } else {
            $("#actieModal").find('input[name="action"]').val("actie_wijzigen");
            button_txt = "Opslaan";
            button_class = "btn-primary";
        }
        $('#actieModal .modal-footer button[type="submit"]').text(button_txt).removeClass("btn-primary").removeClass("btn-danger").addClass(button_class);
        $("#actieModal #actieModalLabel span").text(type);
        var actie_id = $(this_item).closest("tr").data("actie_id");
        $("#actieModal").find('input[name="actie_id"]').val(actie_id);
        $("#actieModal").modal("show");
    },
    showSignaleringModal: function(this_item, type) {
        if (type == "verwijderen") {
            $("#signaleringModal").find('input[name="action"]').val("signalering_verwijderen");
            var button_txt = "Verwijderen";
            var button_class = "btn-danger";
        } else {
            $("#signaleringModal").find('input[name="action"]').val("signalering_wijzigen");
            button_txt = "Opslaan";
            button_class = "btn-primary";
        }
        $('#signaleringModal .modal-footer button[type="submit"]').text(button_txt).removeClass("btn-primary").removeClass("btn-danger").addClass(button_class);
        $("#signaleringModal #signaleringModalLabel span").text(type);
        var signalering_id = $(this_item).closest("tr").data("signalering_id");
        $("#signaleringModal").find('input[name="signalering_id"]').val(signalering_id);
        $("#signaleringModal").find('input[name="Begindatum"]').val($(this_item).closest("tr").find("td.Begindatum").text()).trigger("blur");
        $("#signaleringModal").find('input[name="Begindatum"]').datepicker("update");
        var Einddatum = $(this_item).closest("tr").find("td.Einddatum").text().trim();
        if (Einddatum == "-" || type == "toevoegen") {
            Einddatum = "";
            $("#signaleringModal").find('select[name="EinddatumBekend"]').val("einddatumNietBekend").trigger("change");
        } else $("#signaleringModal").find('select[name="EinddatumBekend"]').val("einddatumBekend").trigger("change");
        $("#signaleringModal").find('input[name="Einddatum"]').val(Einddatum).trigger("blur");
        $("#signaleringModal").find('input[name="Einddatum"]').datepicker("update");
        $("#signaleringModal").find('input[name="PeriodeLoon"]').val($(this_item).closest("tr").find("td.PeriodeLoon").data("value")).trigger("blur");
        $("#signaleringModal").find('select[name="Type"]').val($(this_item).closest("tr").find("td.Type").text()).trigger("blur");
        $("#signaleringModal").modal("show");
    },
    // Functie om de claimdagen te berekenen
    berekenClaimDagen: function(e) {
        var d = $(e.target).val();
        if (typeof d !== "undefined") {
            d = d.split("-");
            d = d[1] + "/" + d[0] + "/" + d[2];
        }
        var t = (0, $94iP7.default)().format("l");
        var gewenst = new Date(d);
        var vandaag = new Date(t);
        var difference = Math.abs(gewenst - vandaag);
        var days = difference / 86400000;
        var claimdagen = parseInt(days) / 7 * 5;
        claimdagen = Math.floor(claimdagen);
        if (!isNaN(claimdagen)) $(".input-claimdagen").val(claimdagen);
    }
};
var $a61b9fb361780bff$export$2e2bcd8739ae039 = $a61b9fb361780bff$var$valideerActie;



const $3aa7ff2b72fec92c$var$logoutTimer = {
    init () {
        // Init logout Timer
        timer = new timer();
        timer.start({
            countdown: true,
            startValues: {
                seconds: 300
            }
        });
        timer.addEventListener("secondsUpdated", function() {
            $("#actionCountdown").html(timer.getTimeValues().toString([
                "minutes",
                "seconds"
            ]));
        });
    }
};
var $3aa7ff2b72fec92c$export$2e2bcd8739ae039 = $3aa7ff2b72fec92c$var$logoutTimer;




const $6d3835e0bbcfcf79$var$form = {
    /**
   * Initializes form functions
   *
   * @returns {void}
   */ init: function() {
        $6d3835e0bbcfcf79$var$form.initEvents();
        $6d3835e0bbcfcf79$var$form.initPopover();
        $6d3835e0bbcfcf79$var$form.conditionalQuestions.init();
    },
    /**
   * Initializes event listeners for various form-related events such as change, blur, keyup, and form submission.
   *
   * @returns {void}
   */ initEvents: function() {
        document.addEventListener("change", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches(".btn-group-toggle input")) {
                $6d3835e0bbcfcf79$var$form.applyToDOM(event);
                $6d3835e0bbcfcf79$var$form.conditionalQuestions.toggle();
                $6d3835e0bbcfcf79$var$form.conditionalQuestions.toggleUploads(event);
                break;
            }
        }, false);
        document.addEventListener("change", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches("[data-alert] [type=radio]")) {
                $6d3835e0bbcfcf79$var$form.alert(event);
                break;
            }
        }, false);
        document.addEventListener("blur", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches(".opbouw-schema-item:last-child .input-group .opbouw-schema-item-datum")) {
                $6d3835e0bbcfcf79$var$form.opbouwschema.get();
                break;
            }
        }, false);
        document.addEventListener("keyup", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches(".opbouw-schema-item:last-child .input-group .opbouw-schema-item-datum")) {
                $6d3835e0bbcfcf79$var$form.opbouwschema.get();
                break;
            }
        }, false);
        document.addEventListener("blur", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches(".opbouw-schema-item:last-child .input-group .opbouw-schema-item-uren")) {
                $6d3835e0bbcfcf79$var$form.opbouwschema.get();
                break;
            }
        }, false);
        document.addEventListener("keyup", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches(".opbouw-schema-item:last-child .input-group .opbouw-schema-item-uren")) {
                $6d3835e0bbcfcf79$var$form.opbouwschema.get();
                break;
            }
        }, false);
        document.addEventListener("click", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches("#opbouwSchemaToevoegen")) {
                $6d3835e0bbcfcf79$var$form.opbouwschema.add();
                break;
            }
        }, false);
        document.addEventListener("click", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches(".opbouw-schema-item-verwijder")) {
                $6d3835e0bbcfcf79$var$form.opbouwschema.delete(event);
                break;
            }
        }, false);
        $("form[data-validate]").submit(function() {
            $(".form-actie select").each(function() {
                if ($(this).hasClass("is-invalid")) $(this).closest("[data-actie-werkgever-vraag]").find(".btn").addClass("btn-outline-danger");
                else $(this).closest("[data-actie-werkgever-vraag]").find(".btn").removeClass("btn-outline-danger");
            });
        });
    },
    /**
   * Initializes Bootstrap popovers for elements with the 'data-bs-toggle="popover"' attribute.
   *
   * @returns {void}
   */ initPopover: function() {
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
        [
            ...popoverTriggerList
        ].map((popoverTriggerEl)=>new bootstrap.Popover(popoverTriggerEl));
    },
    /**
   * Displays a warning modal based on the specified conditions and values from the form.
   *
   * @param {Event} event - The event triggering the alert functionality.
   * @returns {void}
   */ alert: function(event) {
        const datasetJSON = event.target.closest("[data-actie-werkgever-vraag]").dataset.alert;
        const dataset = JSON.parse(datasetJSON);
        const condition = dataset[0];
        const heading = dataset[1];
        const message = dataset[2];
        const submitButton = event.target.closest("form").querySelector("[type=submit]");
        const value = event.target.closest(".btn-group-toggle").querySelector("[type=radio]:checked").value;
        const modalElement = document.getElementById("modalWaarschuwing");
        const modalElementHeading = modalElement.querySelector(".modal-header .modal-title");
        const modalElementBody = modalElement.querySelector(".modal-body p");
        if (condition == value) {
            submitButton.setAttribute("disabled", "true");
            modalElementHeading.innerHTML = heading;
            modalElementBody.innerHTML = message;
            const alertModal = new bootstrap.Modal(modalElement);
            alertModal.show();
        } else submitButton.removeAttribute("disabled");
    },
    /**
   * Applies changes to the DOM based on the provided event.
   *
   * @param {Event} event - The event triggering the DOM changes.
   *
   * @returns {void}
   */ applyToDOM: function(event) {
        const value = event.target.value || "";
        const select = event.target.closest("div").querySelector("select");
        const container = event.target.closest(".btn-group-toggle").querySelector(".btn");
        select.value = value;
        select.dispatchEvent(new Event("change"));
        select.classList.remove("is-invalid");
        container.classList.remove("btn-outline-danger");
    },
    conditionalQuestions: {
        /**
     * Initializes the conditionalQuestions by hiding specified containers and removing validation requirements from selects and inputs.
     *
     * @returns {void}
     */ init: function() {
            const containers = document.querySelectorAll("[data-conditions]");
            const selects = document.querySelectorAll("[data-conditions] select");
            const inputs = document.querySelectorAll("[data-conditions] input");
            containers.forEach((el)=>el.classList.add("d-none"));
            containers.forEach((el)=>el.classList.remove("d-md-table-row"));
            selects.forEach((el)=>(0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(el));
            inputs.forEach((el)=>(0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(el));
        },
        /**
     * Toggles the visibility of file input fields, removes name attributes for hidden inputs,
     * and updates a corresponding hidden input field to indicate the presence of visible file inputs.
     *
     * @returns {void}
     */ toggleUploads: function() {
            var uploadElements = [];
            document.querySelectorAll(".form-actie [data-actie-werkgever-vraag].d-none input[type=file]").forEach(function(element) {
                const originalName = element.getAttribute("name");
                element.setAttribute("data-original-name", originalName);
                element.removeAttribute("name");
            });
            document.querySelectorAll(".form-actie  [data-actie-werkgever-vraag]:not(.d-none) input[type=file]").forEach(function(element) {
                const originalName = element.getAttribute("data-original-name");
                element.setAttribute("name", originalName);
                uploadElements.push(element);
            });
            var elemenNoFileUploadInput = document.querySelector("[name=noFileUpload]");
            if (elemenNoFileUploadInput !== null) {
                if (uploadElements.length > 0) elemenNoFileUploadInput.value = 0;
                else elemenNoFileUploadInput.value = 1;
            }
        },
        /**
     * Toggles the visibility of elements based on conditional questions and adjusts validation requirements accordingly.
     *
     * @returns {void}
     */ toggle: function() {
            document.querySelectorAll("[data-conditions]").forEach(function(element) {
                const visibilityConditions = $6d3835e0bbcfcf79$var$form.conditionalQuestions.check(element);
                if (visibilityConditions) {
                    element.classList.remove("d-none");
                    element.classList.add("d-md-table-row");
                    element.querySelectorAll("select,input:not([type=hidden]:not([type=radio])").forEach((el)=>(0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(el));
                } else {
                    element.classList.add("d-none");
                    element.classList.remove("d-md-table-row");
                    element.querySelectorAll("select,input").forEach((el)=>(0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(el));
                    element.querySelectorAll("input[type=radio]").forEach((radioButton)=>radioButton.checked = false);
                    element.querySelectorAll("[data-actie-werkgever-antwoord]").forEach((antwoord)=>antwoord.value = "");
                }
            });
        },
        /**
     * Checks the visibility conditions of an element based on preceeding questions' values.
     *
     * @param {HTMLElement} el - The element to check conditions for.
     *
     * @returns {boolean} - True if conditions are met, otherwise false.
     */ check: function(el) {
            let conditionsMet = true;
            let currentQuestionConditions = JSON.parse(el.dataset.conditions);
            Object.keys(currentQuestionConditions).forEach((id)=>{
                let targetValue = document.getElementById(id).value?.toLowerCase();
                let conditionValues = currentQuestionConditions[id];
                if (typeof conditionValues == "string") conditionValues = [
                    conditionValues
                ];
                let conditionValuesLowercase = conditionValues.map((item)=>item.toLowerCase());
                if (!conditionValuesLowercase.includes(targetValue)) conditionsMet = false;
            });
            return conditionsMet;
        }
    },
    opbouwschema: {
        /**
     * Retrieves data from the 'opbouwSchemaContainer' and updates the 'opbouwSchema' input field.
     * Uses a setTimeout to delay the retrieval, likely for asynchronous purposes.
     *
     * @returns {void}
     */ get: function() {
            setTimeout(function() {
                var opbouwSchema = {};
                var elements = document.querySelectorAll("#opbouwSchemaContainer .opbouw-schema-item");
                for(var i = 0; i < elements.length; i++){
                    var childElements = elements[i].getElementsByClassName("opbouw-schema-item-input");
                    var period = {};
                    for(var a = 0; a < childElements.length; a++){
                        var key = childElements[a].getAttribute("data-opbouw-key");
                        var val = childElements[a].value;
                        period[key] = val;
                    }
                    opbouwSchema["periode_" + (i + 1)] = period;
                }
                document.getElementById("opbouwSchema").value = JSON.stringify(opbouwSchema);
            }, 250);
        },
        /**
     * Adds a new opbouw schema item to the 'opbouwSchemaContainer'.
     * Initializes necessary elements and event listeners for the added item.
     *
     * @returns {void}
     */ add: function() {
            const clone = document.querySelector(".opbouw-schema-item").cloneNode(true);
            const container = document.getElementById("opbouwSchemaContainer");
            container.appendChild(clone);
            const buttonDelete = document.querySelector(".opbouw-schema-item:last-child .opbouw-schema-item-verwijder");
            buttonDelete.classList.remove("invisible");
            document.querySelector(".opbouw-schema-item:last-child .input-group .opbouw-schema-item-datum").value = "";
            document.querySelector(".opbouw-schema-item:last-child .input-group .opbouw-schema-item-uren").value = "";
            (0, $4ee4564850efd542$export$2e2bcd8739ae039).init(container);
        },
        /**
     * Deletes the opbouw-schema item from the DOM based on the provided event.
     *
     * @param {Event} event - The event triggering the deletion.
     *
     * @returns {void}
     */ delete: function(event) {
            const el = event.target.closest(".opbouw-schema-item");
            el.parentNode.removeChild(el);
        }
    }
};
var $6d3835e0bbcfcf79$export$2e2bcd8739ae039 = $6d3835e0bbcfcf79$var$form;



const $8e8f53a8df2b9db2$var$werkgeverSalaris = {
    init () {
        // Toon en verberg aanvullende salarisvelden bij oproepbasis
        $("#oproepBasis").change(function() {
            // Verberg alle salarisvelden
            $(".form-section-salaris-a, .form-section-salaris-b-c ").addClass("d-none").find("input,select").not(".file-caption-name").each(function(i, e) {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(e);
            });
            if ($(this).val() == "ja") // Toon alle salaris velden
            $(".form-section-salaris-a, .form-section-salaris-b-c ").removeClass("d-none").find("input,select").not(".file-caption-name").each(function(i, e) {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(e);
            });
            else // Toon alleen de laatste salaris velden
            $(".form-section-salaris-a").removeClass("d-none").find("input,select").not(".file-caption-name").each(function(i, e) {
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(e);
            });
        });
        $("#oproepBasis").trigger("change");
        // Submit
        $("form[data-validate]").attr("data-validate-onsubmit-disabled", true);
        $("form[data-validate]").submit(async function() {
            let validated = await (0, $a60bd1631756ee00$export$2e2bcd8739ae039).checkSubmitForm(this);
            if (validated) {
                $("#loadingModal").modal("show", {
                    backdrop: "static",
                    keyboard: false
                });
                setTimeout(function() {
                    $("form[data-validate]").unbind("submit");
                    $("form[data-validate]").submit();
                }, 1000);
            //
            }
            return false;
        });
    }
};
var $8e8f53a8df2b9db2$export$2e2bcd8739ae039 = $8e8f53a8df2b9db2$var$werkgeverSalaris;


const $f80fd1b24eaecaaf$var$form = {
    init () {
        // Wanneer begindatum verandert, controleer dan of deze niet overlapt met een bestaande salaris
        $("#Begindatum").change(function(e) {
            e.preventDefault();
            if ($("#Begindatum").val() != "") $.getJSON(window.app.ajaxPath + $("#form-aopercentage").data("werknemer_melding_id") + "/" + $("#form-aopercentage").data("aopercentage_id") + "/duplicate-check/" + $("#Begindatum").val() + "/" + $("#form-aopercentage").data("aopercentage_id") + "/", function(data) {
                if (data != false) {
                    // Er is een overlappend salaris
                    if (!$("#form_suggestion").is(":visible")) {
                        $("#form_suggestion").hide().removeClass("d-none").fadeIn();
                        $("#form_continue").hide();
                    }
                    $(".gevonden-aopercentages *").remove();
                    $.each(data, function(index, val) {
                        var tr = "<tr><td>" + val.begindatum + "</td><td>" + val.einddatum + "</td><td>" + val.aopercentage + "</td><td>" + val.action + "</td></tr>";
                        $(".gevonden-aopercentages").append(tr);
                    });
                } else // Er is nog geen overlappend salaris
                $f80fd1b24eaecaaf$var$form.hideFormSuggestion();
            });
        });
        $("#Begindatum").trigger("change");
    },
    // Verberg het blok met als deze zichtbaar is
    hideFormSuggestion: function() {
        $("#form_suggestion").fadeOut(100, function() {
            $("#form_continue").hide().removeClass("d-none").fadeIn();
        });
    }
};
var $f80fd1b24eaecaaf$export$2e2bcd8739ae039 = $f80fd1b24eaecaaf$var$form;



var $7FBkt = parcelRequire("7FBkt");

var $hGrZR = parcelRequire("hGrZR");
const $dec17dae955a5816$var$edit = {
    /**
   * ID's die gevuld worden vanuit de DOM in de init functie
   */ meldingId: null,
    werknemerId: null,
    /**
   * DOM elements
   */ elementAlertOverlappendeMelding: document.getElementById("alertOverlappendeMelding"),
    elementAlertGeenActiefDienstverband: document.getElementById("alertGeenActiefDienstverband"),
    elementAlertDienstverbandMetEinddatum: document.getElementById("alertDienstverbandMetEinddatum"),
    elementFormDetails: document.querySelector('[data-form-section="details"]'),
    elementInputBeginDatum: document.getElementById("Begindatum"),
    elementInputType: document.getElementById("Type"),
    elementTextDienstverbandEinddatum: document.getElementById("dienstverbandEinddatum"),
    /**
   * Function: init
   * Initial function to run when the page is loaded
   * This function will set the initial values for the edit object
   *
   * @returns {void}
   */ init: function() {
        if (document.getElementById("form-melding") !== null) {
            $dec17dae955a5816$var$edit.meldingId = document.getElementById("form-melding").getAttribute("data-melding_id");
            $dec17dae955a5816$var$edit.werknemerId = document.getElementById("form-melding").getAttribute("data-werknemer_id");
            $dec17dae955a5816$var$edit.initEvents();
            $dec17dae955a5816$var$edit.getDienstverleners();
        }
    },
    /**
   * Function: initEvents
   * This function will initialize the events for the edit page
   *
   * @returns {void}
   */ initEvents: function() {
        $("#Type").change(function() {
            $dec17dae955a5816$var$edit.getDienstverleners();
        });
        $("#Begindatum").on("change", function(event) {
            $dec17dae955a5816$var$edit.begindatumChangeEventHandler(event);
        });
        $("#Begindatum").on("keyup", function(event) {
            $dec17dae955a5816$var$edit.begindatumKeyupEventHandler(event);
        });
    },
    /**
   * Function: begindatumChangeEventHandler
   * This function will handle the change event for the begindatum input
   *
   * @param {Event} event - The event object
   *
   * @returns {void}
   */ begindatumChangeEventHandler: function(event) {
        if ((0, $hGrZR.default).date($dec17dae955a5816$var$edit.elementInputBeginDatum.value) === "success") $dec17dae955a5816$var$edit.checkBegindatum();
    },
    /**
   * Function: begindatumKeyupEventHandler
   * This function will handle the keyup event for the begindatum input
   *
   * @param {Event} event - The event object
   *
   * @returns {void}
   */ begindatumKeyupEventHandler: function(event) {
        const key = event.key;
        if (key >= "0" && key <= "9" || key === "-") {
            if ((0, $hGrZR.default).date($dec17dae955a5816$var$edit.elementInputBeginDatum.value) === "success") {
                $dec17dae955a5816$var$edit.checkBegindatum();
                $(event.target).datepicker("hide");
            }
        }
    },
    /**
   * Function: checkBegindatum
   * This function will check the begindatum for the current melding
   * and show the correct alerts if needed
   *
   * @returns {void}
   */ checkBegindatum: function() {
        const url = window.app.ajaxPath + $dec17dae955a5816$var$edit.werknemerId + "/" + $dec17dae955a5816$var$edit.meldingId + "/duplicate-check/" + $dec17dae955a5816$var$edit.elementInputBeginDatum.value + "/" + $dec17dae955a5816$var$edit.meldingId + "/";
        (0, $7FBkt.default).send("POST", url, function(data) {
            data = JSON.parse(data);
            if (!data.success) {
                $dec17dae955a5816$var$edit.hideAlertsAndFormSections();
                $dec17dae955a5816$var$edit.elementInputBeginDatum.setAttribute("disabled", true);
                if (data.duplicate != false) $dec17dae955a5816$var$edit.showAlertOverlappendeMelding(data);
                else if (data.dienstverband == false) $dec17dae955a5816$var$edit.showAlertGeenActiefDienstverband();
                else if (data.dienstverband_einddatum !== false) $dec17dae955a5816$var$edit.showAlertDienstverbandMetEinddatum(data);
                else $dec17dae955a5816$var$edit.elementFormDetails.classList.remove("d-none");
                $dec17dae955a5816$var$edit.elementInputBeginDatum.removeAttribute("disabled");
            }
        });
        $dec17dae955a5816$var$edit.getDienstverleners();
    },
    /**
   * Function: hideAlertsAndFormSections
   * This function will hide all alerts and the form details
   *
   * @returns {void}
   */ hideAlertsAndFormSections: function() {
        $dec17dae955a5816$var$edit.elementAlertOverlappendeMelding.classList.add("d-none");
        $dec17dae955a5816$var$edit.elementAlertGeenActiefDienstverband.classList.add("d-none");
        $dec17dae955a5816$var$edit.elementAlertDienstverbandMetEinddatum.classList.add("d-none");
        $dec17dae955a5816$var$edit.elementFormDetails.classList.add("d-none");
    },
    /**
   * Function: showAlertOverlappendeMelding
   * This function will show the alert for overlapping meldingen
   *
   * @returns {void}
   */ showAlertOverlappendeMelding: function(data) {
        $dec17dae955a5816$var$edit.elementAlertOverlappendeMelding.classList.remove("d-none");
        document.querySelectorAll(".gevonden-melding *").forEach((el)=>el.innerHTML = "");
        data.duplicate.forEach(function(val) {
            var tr = document.createElement("tr");
            tr.innerHTML = "<td>" + val.begindatum + "</td><td>" + val.einddatum + "</td><td>" + val.type + "</td><td>" + val.action + "</td>";
            document.querySelector(".gevonden-melding").appendChild(tr);
        });
    },
    /**
   * Function: showAlertGeenActiefDienstverband
   * This function will show the alert for no active dienstverband
   *
   * @returns {void}
   */ showAlertGeenActiefDienstverband: function() {
        $dec17dae955a5816$var$edit.elementAlertGeenActiefDienstverband.classList.remove("d-none");
    },
    /**
   * Function: showAlertDienstverbandMetEinddatum
   * This function will show the alert for dienstverband met einddatum
   *
   * @param {Object} data - The data object containing the dienstverband_einddatum value.
   *
   * @returns {void}
   */ showAlertDienstverbandMetEinddatum: function(data) {
        $dec17dae955a5816$var$edit.elementTextDienstverbandEinddatum.innerHTML = data.dienstverband_einddatum;
        $dec17dae955a5816$var$edit.elementAlertDienstverbandMetEinddatum.classList.remove("d-none");
        $dec17dae955a5816$var$edit.elementFormDetails.classList.remove("d-none");
    },
    /**
   * Function: getDienstverleners
   * This function will get the dienstverleners for the current melding
   *
   * @returns {void}
   */ getDienstverleners: function() {
        const url = window.app.ajaxPath + $dec17dae955a5816$var$edit.werknemerId + "/" + $dec17dae955a5816$var$edit.meldingId + "/get-dienstverleners/" + $dec17dae955a5816$var$edit.elementInputBeginDatum.value + "/" + $dec17dae955a5816$var$edit.elementInputType.value + "/";
        (0, $7FBkt.default).send("POST", url, function(data) {
            data = JSON.parse(data);
            if (!data.success) $dec17dae955a5816$var$edit.listDienstverleners(data);
        });
    },
    /**
   * Function: listDienstverleners
   * This function will list the dienstverleners for the current melding
   *
   * @param {Object} data - The data object containing the dienstverleners.
   *
   * @returns {void}
   */ listDienstverleners: function(data) {
        if (data.length === 0) document.querySelector("[data-form-section=dienstverleners]").classList.add("d-none");
        else {
            const parentElement = document.querySelector("[data-dienstverleners]");
            const existingElements = document.querySelectorAll("[data-dienstverlener-item]");
            const cloneElement = parentElement.querySelector("[data-dienstverlener-item-parent]");
            existingElements.forEach((el)=>el.remove());
            parentElement.classList.remove("d-none");
            data.forEach(function(v) {
                let clone = cloneElement.cloneNode(true);
                clone.removeAttribute("data-dienstverlener-item-parent");
                clone.setAttribute("data-dienstverlener-item", "");
                clone.classList.remove("d-none");
                let nameTarget = clone.querySelector("[data-dienstverlener-naam]");
                let connectorTarget = clone.querySelector("[data-dienstverlener-connector-actief]");
                nameTarget.value = v.naam;
                if (v.connectorActief === true) connectorTarget.classList.remove("d-none");
                parentElement.appendChild(clone);
            });
            document.querySelector("[data-form-section=dienstverleners]").classList.remove("d-none");
        }
    }
};
var $dec17dae955a5816$export$2e2bcd8739ae039 = $dec17dae955a5816$var$edit;



const $040177286cd0f424$var$endView = {
    init () {
        // Het beëindigen van een melding bij een werknemer.
        $("body").on("change", "#EindReden,#Einddatum", function() {
            $(".alert-confirmation").closest(".row").addClass("d-none");
            if ($("#EindReden").val() != "" && $("#Einddatum").val() != "") {
                var reden = $("#EindReden option[value=" + $("#EindReden").val() + "]").html();
                var eindDatumArray = $("#Einddatum").val().split("-");
                var datum = new Date(eindDatumArray[2] + "-" + eindDatumArray[1] + "-" + eindDatumArray[0]);
                var today = new Date();
                if (datum > today) {
                    $("#toelichtingEindmeldingToekomst").closest(".row").removeClass("d-none");
                    (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired($("#toelichtingEindmeldingToekomst"));
                } else {
                    $("#toelichtingEindmeldingToekomst").closest(".row").addClass("d-none");
                    (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired($("#toelichtingEindmeldingToekomst"));
                }
                datum.setDate(datum.getDate() + 1);
                datum = datum.getDate() + "-" + (datum.getUTCMonth() + 1) + "-" + datum.getFullYear();
                if (typeof reden !== "undefined" && reden != "") {
                    if (reden != "Overig") {
                        if (reden.charAt(0) != "W" && reden.charAt(0) != "I" && reden.charAt(0) != "A") $(".alert-confirmation").find("span").html(datum + " " + reden.charAt(0).toLowerCase() + reden.slice(1));
                        else $(".alert-confirmation").find("span").html(datum + " " + reden);
                        $(".alert-confirmation").closest(".row").removeClass("d-none");
                    }
                }
            }
        });
        $("#Einddatum").trigger("change");
        // Toon of verberg het blok voor overlappend dienstverband op basis van de begindatum voor een nieuw dienstverband en de einddatum van reeds bestaande dienstverbanden.
        $("#beeindig-arbeidsovereenkomst-button").click(function(e) {
            e.preventDefault();
            $.getJSON($(this).attr("href"), function(data) {
                if (data != false) $("#modalBeeindigArbeidsovereenkomst").modal("toggle");
            });
        });
        // Open modal waarschuwing dat er een lopende melding is
        if ($("#modalBeeindigArbeidsovereenkomst").length) $("#modalBeeindigArbeidsovereenkomst").modal("show", {
            keyboard: false,
            backdrop: "static"
        });
    }
};
var $040177286cd0f424$export$2e2bcd8739ae039 = $040177286cd0f424$var$endView;



const $7f1ba9305a0f800b$var$newOpvolgend = {
    init () {
        // Toon en verberg velden wanneer soort melding wordt gewijzigd
        $("#Type").change(function(e) {
            e.preventDefault();
            var v = $(this).val();
            var a = $(".form-section-algemeen");
            var d = $(".form-section-details");
            var t = $(".form-section-42eweek");
            var w = $(".form-section-wia");
            var z = $(".form-section-ziektewet");
            $("span.opvolg-soort-label").text(v);
            $.each([
                a,
                d,
                t,
                w,
                z
            ], function(i, e) {
                e.addClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(e.find("input[type=text],select"));
            });
            if (v == "Ziektewet") {
                z.removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(z.find("input[type=text],select"));
            } else if (v == "WIA") {
                w.removeClass("d-none");
                (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(w.find("input[type=text],select"));
            }
        });
        // Trigger change van Type veld wanneer pagina geladen wordt
        $("#Type").trigger("change");
        // Het beëindigen van een melding bij een werknemer.
        $("body").on("change", "#Begindatum", function() {
            $(".alert-confirmation").closest(".row").addClass("d-none");
            if ($("#Begindatum").val() != "") {
                var eindDatumArray = $("#Begindatum").val().split("-");
                var datum = new Date(eindDatumArray[2] + "-" + eindDatumArray[1] + "-" + eindDatumArray[0]);
                var datumTxt = datum.getDate() + "-" + (datum.getUTCMonth() + 1) + "-" + datum.getFullYear();
                $(".alert-confirmation").find("span.uitdienst-begindatum-0").html(datumTxt);
                datum.setDate(datum.getDate() - 1);
                datumTxt = datum.getDate() + "-" + (datum.getUTCMonth() + 1) + "-" + datum.getFullYear();
                $(".alert-confirmation").find("span.uitdienst-begindatum-1").html(datumTxt);
                $(".alert-confirmation").closest(".row").removeClass("d-none");
            }
        });
        $("#Begindatum").trigger("change");
    }
};
var $7f1ba9305a0f800b$export$2e2bcd8739ae039 = $7f1ba9305a0f800b$var$newOpvolgend;


var $637147d595b93f1f$var$whaValidate = {
    outputData: {},
    inputData: {},
    init: function() {
        var target = document.querySelector("[data-whavalidator-container]") || null;
        if (null !== target) {
            $637147d595b93f1f$var$whaValidate.initDomElements(target);
            $637147d595b93f1f$var$whaValidate.initData();
            $637147d595b93f1f$var$whaValidate.initEvents();
        }
    },
    initDomElements: function(target) {
        $637147d595b93f1f$var$whaValidate.elTableWha = target.querySelector("[data-table-wha]");
        $637147d595b93f1f$var$whaValidate.elTableAo = target.querySelector("[data-table-ao]");
        $637147d595b93f1f$var$whaValidate.elTableResult = target.querySelector("[data-table-result]");
        $637147d595b93f1f$var$whaValidate.elDataFieldInput = target.querySelector("[data-whaValidator-data-input]");
        $637147d595b93f1f$var$whaValidate.elDataFieldOutput = target.querySelector("[data-whaValidator-data-output]");
    },
    initData: function() {
        $637147d595b93f1f$var$whaValidate.inputData = $637147d595b93f1f$var$whaValidate.getInputData($637147d595b93f1f$var$whaValidate.elDataFieldInput);
        $637147d595b93f1f$var$whaValidate.outputData = $637147d595b93f1f$var$whaValidate.getInputData($637147d595b93f1f$var$whaValidate.elDataFieldInput);
        $637147d595b93f1f$var$whaValidate.applyInputToDom("werknemer_melding_werkhervattingspercentage", $637147d595b93f1f$var$whaValidate.elTableWha);
        $637147d595b93f1f$var$whaValidate.applyInputToDom("werknemer_melding_aopercentage", $637147d595b93f1f$var$whaValidate.elTableAo);
        $637147d595b93f1f$var$whaValidate.elDataFieldOutput.value = JSON.stringify($637147d595b93f1f$var$whaValidate.inputData);
        $637147d595b93f1f$var$whaValidate.applyOutputDataToDom();
    },
    initEvents: function() {
        document.addEventListener("click", function(event) {
            for(var target = event.target; target && target != this; target = target.parentNode)if (target.matches("[data-table-wha] tbody tr, [data-table-ao] tbody tr")) {
                $637147d595b93f1f$var$whaValidate.toggleRowState(event.target);
                $637147d595b93f1f$var$whaValidate.uncheckDuplicate(event.target);
                $637147d595b93f1f$var$whaValidate.applyDomSelectionToOutputData();
                $637147d595b93f1f$var$whaValidate.applyOutputDataToDom();
                break;
            }
        }, false);
    },
    uncheckDuplicate: function(target) {
        var checkbox = target.parentNode.querySelector("input[type=checkbox]");
        if (checkbox !== null) {
            var date = checkbox.getAttribute("data-date");
            var type = checkbox.getAttribute("data-type");
            if (type == "werknemer_melding_werkhervattingspercentage") target = $637147d595b93f1f$var$whaValidate.elTableAo.querySelector('input[type=checkbox][data-date="' + date + '"]');
            else if (type == "werknemer_melding_aopercentage") target = $637147d595b93f1f$var$whaValidate.elTableWha.querySelector('input[type=checkbox][data-date="' + date + '"]');
            if (target !== null) {
                target.checked = false;
                $637147d595b93f1f$var$whaValidate.toggleSignal(target);
            }
        }
    },
    getInputData: function(target) {
        var dataElement = target;
        if (dataElement) {
            var jsonString = dataElement.value;
            var object = JSON.parse(jsonString);
            return object;
        }
    },
    applyInputToDom: function(type, target) {
        var rowTemplate = target.querySelector("[data-tr-template]");
        var tableBody = target.querySelector("tbody");
        var werknemer_melding_id = "";
        for (let [date, content] of Object.entries($637147d595b93f1f$var$whaValidate.inputData)){
            if (content["werknemer_melding_id"] !== werknemer_melding_id && werknemer_melding_id !== "") {
                var emptyClone = rowTemplate.cloneNode(true);
                emptyClone.querySelector("[data-tr-template-check]").innerHTML = "";
                emptyClone.classList.add("bg-disabled");
                emptyClone.classList.remove("d-none");
                tableBody.appendChild(emptyClone);
            }
            werknemer_melding_id = content["werknemer_melding_id"];
            var clone = rowTemplate.cloneNode(true);
            if (content[type] !== undefined) {
                clone.setAttribute("data-type", type);
                clone.setAttribute("data-tr-row", "true");
                clone.removeAttribute("data-tr-template");
                clone.querySelector("[data-tr-template-date]").innerHTML = date;
                clone.querySelector("[data-tr-template-percentage]").innerHTML = content[type]["oapercentage"];
                clone.querySelector("[data-tr-template-checkbox]").checked = content[type]["selected"];
                clone.querySelector("[data-tr-template-checkbox]").disabled = content[type]["protected"];
                clone.querySelector("[data-tr-template-checkbox]").setAttribute("data-date", date);
                clone.querySelector("[data-tr-template-checkbox]").setAttribute("data-type", type);
                $637147d595b93f1f$var$whaValidate.toggleSignal(clone.querySelector("[data-tr-template-checkbox]"));
            } else clone.querySelector("[data-tr-template-check]").innerHTML = "&nbsp;";
            clone.classList.remove("d-none");
            tableBody.appendChild(clone);
        }
    },
    toggleRowState: function(target) {
        var row = target.parentNode;
        var checkbox = row.querySelector("input[type=checkbox]");
        if (checkbox !== null) {
            var disabled = checkbox.disabled;
            if (!disabled) {
                checkbox.checked = !checkbox.checked;
                $637147d595b93f1f$var$whaValidate.toggleSignal(checkbox);
            }
        }
    },
    toggleSignal: function(target) {
        var row = target.parentNode.parentNode;
        row.classList.add("table-success");
        if (!target.checked) row.classList.remove("table-success");
    },
    clearSelection: function() {
        for (let [date, content] of Object.entries($637147d595b93f1f$var$whaValidate.outputData))for (let [key] of Object.entries(content))$637147d595b93f1f$var$whaValidate.outputData[date][key]["selected"] = false;
    },
    applyDomSelectionToOutputData: function() {
        $637147d595b93f1f$var$whaValidate.clearSelection();
        [
            "elTableWha",
            "elTableAo"
        ].forEach(function(table) {
            $637147d595b93f1f$var$whaValidate[table].querySelectorAll("input[type=checkbox]:checked").forEach(function(element) {
                var date = element.getAttribute("data-date");
                var type = element.getAttribute("data-type");
                // console.log(date);
                // console.log(type);
                $637147d595b93f1f$var$whaValidate.outputData[date][type]["selected"] = true;
            });
        });
        $637147d595b93f1f$var$whaValidate.elDataFieldOutput.value = JSON.stringify($637147d595b93f1f$var$whaValidate.outputData);
    },
    applyOutputDataToDom: function() {
        var tableBody = $637147d595b93f1f$var$whaValidate.elTableResult.querySelector("tbody");
        var rowTemplate = $637147d595b93f1f$var$whaValidate.elTableResult.querySelector("[data-tr-template]");
        var werknemer_melding_id = "";
        tableBody.innerHTML = "";
        for (let [date, content] of Object.entries($637147d595b93f1f$var$whaValidate.outputData)){
            var clone = rowTemplate.cloneNode(true);
            clone.querySelectorAll("[data-tr-template-date], [data-tr-template-percentage], [data-tr-template-type]").forEach((el)=>el.innerHTML = "&nbsp;");
            for (let [key, value] of Object.entries(content)){
                if (content["werknemer_melding_id"] !== werknemer_melding_id && werknemer_melding_id !== "") {
                    var emptyClone = rowTemplate.cloneNode(true);
                    emptyClone.querySelectorAll("[data-tr-template-date], [data-tr-template-percentage], [data-tr-template-type]").forEach((el)=>el.innerHTML = "");
                    emptyClone.querySelector("[data-tr-template-type]").innerHTML = "";
                    emptyClone.classList.add("bg-disabled");
                    emptyClone.classList.remove("d-none");
                    tableBody.appendChild(emptyClone);
                }
                werknemer_melding_id = content["werknemer_melding_id"];
                if (value.selected != undefined && value.selected == true) {
                    clone.querySelector("[data-tr-template-date]").innerHTML = date;
                    clone.querySelector("[data-tr-template-percentage]").innerHTML = value["oapercentage"];
                    clone.querySelector("[data-tr-template-type]").innerHTML = key == "werknemer_melding_aopercentage" ? "AO %" : "WHA %";
                }
            }
            clone.classList.remove("d-none");
            tableBody.appendChild(clone);
        }
    }
};
var $637147d595b93f1f$export$2e2bcd8739ae039 = $637147d595b93f1f$var$whaValidate;


const $00699e68abccc2b6$var$zoekWerknemer = {
    init () {
        // Focus op naam veld als pagina geladen wordt
        $(function() {
            $("#naam").focus();
        });
        // Zoekfunctie
        $("button.zoek-werknemer-knop").click(function() {
            // Verberg 'geen resultaten text'
            $(".geen-resultaten").addClass("d-none");
            // Toon resultaten formulier
            $("#form_suggestion").removeClass("d-none");
            // Definieer form data object
            var formData = {
                naam: $("form.zoek-scherm input#naam").val(),
                //geboorte_datum: $('form.zoek-scherm input#geboorte_datum').val(),
                geslacht: $("form.zoek-scherm select#geslacht").val()
            };
            // Ajax functie
            $.ajax({
                url: window.app.ajaxPath + $("form.zoek-scherm").data("administratie_relatie_id") + "/zoek/",
                type: "POST",
                data: formData,
                success: function(data) {
                    // Loop door de zoekresultaten
                    if (data.werknemers.length == data.aantal) {
                        // Toon 'geen resultaten' text als er gen resultaten zijn
                        $(".btn-werknemer-toevoegen").addClass("d-none");
                        $("#list-group-accordion").removeClass("d-none");
                        $("#form_suggestion h4").removeClass("d-none");
                        if (!data.werknemers.length) {
                            $(".geen-resultaten").removeClass("d-none");
                            $(".btn-werknemer-toevoegen").removeClass("d-none");
                            $("#list-group-accordion").addClass("d-none");
                            $("#form_suggestion h4").addClass("d-none");
                        }
                        $("div.list-group-results span.list-group-item").remove();
                        $.each(data.werknemers, function(key, werknemer) {
                            $.each(werknemer, function(keyw, value) {
                                $("div#collapseWerknemerTemplate span.list-group-item span." + keyw).html(value);
                            });
                            $("div#collapseWerknemerTemplate span.list-group-item .list-group-item-details").attr("id", "collapseResult" + key);
                            $("div#collapseWerknemerTemplate span.list-group-item").attr("aria-controls", "collapseResult" + key);
                            $("div#collapseWerknemerTemplate span.list-group-item").attr("href", "#collapseResult" + key);
                            $("div#collapseWerknemerTemplate span.list-group-item").attr("data-werknemer_id", werknemer.werknemer_id);
                            // medling ID melding_id
                            $("div#collapseWerknemerTemplate button, div#collapseWerknemerTemplate span.label-bestaande-melding").hide(0);
                            if (werknemer.melding_id != "") $("div#collapseWerknemerTemplate .visible-bestaande-melding").show(0);
                            else $("div#collapseWerknemerTemplate .visible-geen-bestaande-melding").show(0);
                            $("div#collapseWerknemerTemplate span.list-group-item").clone().appendTo("div.list-group-results");
                        });
                    }
                },
                error: function() {
                    $("div.list-group-results span.list-group-item").remove();
                    $(".geen-resultaten").removeClass("d-none");
                }
            });
        });
        // Click functie voor knoppen gevonden werknemers
        $(".gevonden-werknemers").on("click", "button", function(e) {
            e.preventDefault();
            e.stopPropagation();
            var w = $(this).closest("span").data("werknemer_id");
            var p = $(this).attr("url");
            window.location.href = p + w;
        });
        // Accordion functie voor gevonden werknemers
        $(".gevonden-werknemers").on("click", "span.list-group-item", function() {
            $(".gevonden-werknemers .fa").removeClass("fa-caret-down").addClass("fa-caret-right");
            if ($(this).attr("aria-expanded") == "true") $(this).find(".fa").removeClass("fa-caret-down").addClass("fa-caret-right");
            else $(this).find(".fa").removeClass("fa-caret-right").addClass("fa-caret-down");
            $(".list-group-item-details").collapse("hide");
        });
        // Click zoek button als gebruiker op enter toets drukt
        $(".form-section input, .form-section select").keyup(function(e) {
            if (e.keyCode === 13) $("button.zoek-werknemer-knop").click();
        });
    }
};
var $00699e68abccc2b6$export$2e2bcd8739ae039 = $00699e68abccc2b6$var$zoekWerknemer;



const $49ab054f8bb59995$var$edit = {
    init () {
        // Toon of verberg het blok voor overlappend nrp op basis van de begindatum voor een nieuw nrp en de einddatum van reeds bestaande nrp.
        $("#Begindatum, #Einddatum, #noriskSoort").change(function(e) {
            e.preventDefault();
            if ($("#Begindatum").val() != "" && $("#noriskSoort").val() != "") $.getJSON(document.URL + "/duplicate-check/" + $("#Begindatum").val() + "/" + $("#Einddatum").val() + "/" + $("#noriskSoort").val() + "/" + $("#form-noriskpolis").attr("noriskpolis_id") + "/", function(data) {
                if (data != false) {
                    // Er is een overlappend nrp
                    if (!$("#form_suggestion").is(":visible")) {
                        $("#form_suggestion").hide().removeClass("d-none").fadeIn();
                        $("#form_continue").hide();
                    }
                    $(".gevonden-noriskpolissen *").remove();
                    $.each(data, function(index, val) {
                        var tr = "<tr><td>" + val.begindatum + "</td><td>" + val.einddatum + "</td><td>" + $('#noriskSoort option[value="' + val.contract + '"]').text() + "</td><td>" + val.action + "</td></tr>";
                        $(".gevonden-noriskpolissen").append(tr);
                    });
                } else // Er is nog geen overlappend nrp
                $49ab054f8bb59995$var$edit.hideFormSuggestion();
            });
        });
        // laad de datum kiezer voor einddatum op basis van de begindatum
        $("#Begindatum").change(function(e) {
            e.preventDefault();
            $("input#Einddatum").attr("data-enddate", $("input#Begindatum").attr("data-enddate"));
            $("input#Einddatum").attr("data-startdate", $("input#Begindatum").val());
        });
        $("#Begindatum").trigger("change");
        // Toon of verberg einddatum na het selecteren van een soort.
        $("#noriskSoort").change(function(e) {
            e.preventDefault();
            if ($(this).val().toLowerCase() != "wajong") {
                $("input#Einddatum").attr("data-validate", "required date daterange").val($("input#Einddatum").attr("valueOrg")).closest(".form-group").removeClass("d-none");
                // $('input#Einddatum').datepicker('update');  // omgezet naar onderstaande regel wegens error na bundling waardoor verkeerde datum opmaak werd gebruikt
                $("input#Einddatum").datepicker((0, $4ee4564850efd542$export$2e2bcd8739ae039).settings.date, "update");
            } else $("input#Einddatum").val("").attr("data-validate", "").closest(".form-group").addClass("d-none");
        });
        $("#noriskSoort").trigger("change");
    },
    // Verberg het blok voor overlappend nrp
    hideFormSuggestion: function() {
        $("#form_suggestion").fadeOut(100, function() {
            $("#form_continue").hide().removeClass("d-none").fadeIn();
        });
    }
};
var $49ab054f8bb59995$export$2e2bcd8739ae039 = $49ab054f8bb59995$var$edit;


const $d00efe5e55939222$var$relatieDeelnameListing = {
    init () {
        // Verwijderd atable event attibute
        const filterYearElement = document.getElementById("filter_year");
        if (filterYearElement) filterYearElement.removeAttribute("data-atable-header-toolbar-select");
        // Verkrijg huidige jaartal uit url en set select values
        const year = window.location.pathname.split("/").pop();
        if (typeof year !== "undefined" && filterYearElement) filterYearElement.value = year;
        // Forward naar geselecteerde jaartal
        if (filterYearElement) filterYearElement.addEventListener("change", function() {
            window.location.href = this.value;
        });
    }
};
var $d00efe5e55939222$export$2e2bcd8739ae039 = $d00efe5e55939222$var$relatieDeelnameListing;



const $8ce411d869469115$var$edit = {
    init () {
        // Haal salaris type op als begindatum gewijzigd wordt
        $("#Begindatum").change(function() {
            if ($("#Begindatum").val() != "") $.getJSON(window.app.ajaxPath + $("#form-salarissen").data("werknemer_id") + "/" + $("#form-salarissen").data("salaris_id") + "/get-types/" + $("#Begindatum").val() + "/", function(data) {
                $(".salaris-type").removeClass("d-none").addClass("d-none");
                $(".salaris-type").find("input").each(function() {
                    (0, $a60bd1631756ee00$export$2e2bcd8739ae039).removeRequired(this);
                });
                $.each(data, function(index, val) {
                    $(".salaris-type-" + val).removeClass("d-none");
                    $(".salaris-type-" + val).find("input").each(function() {
                        (0, $a60bd1631756ee00$export$2e2bcd8739ae039).addRequired(this);
                    });
                });
            });
        });
        // Wanneer begindatum verandert, controleer dan of deze niet overlapt met een bestaande salaris
        $("#Begindatum,#Periode").change(function(e) {
            e.preventDefault();
            if ($("#Begindatum").val() != "" && $("#Periode").val() != "") $.getJSON(window.app.ajaxPath + $("#form-salarissen").data("werknemer_id") + "/" + $("#form-salarissen").data("salaris_id") + "/duplicate-check/" + $("#Begindatum").val() + "/" + $("#form-salarissen").data("salaris_id") + "/", function(data) {
                if (data != false) {
                    // Er is een overlappend salaris
                    if (!$("#form_suggestion").is(":visible")) {
                        $("#form_suggestion").hide().removeClass("d-none").fadeIn();
                        $("#form_continue").hide();
                    }
                    // var keer = $('#Contract option:selected').attr('keer');
                    $(".gevonden-salarissen *").remove();
                    $.each(data, function(index, val) {
                        var tr = "<tr><td>" + val.begindatum + "</td><td>" + val.einddatum + "</td><td>" + val.action + "</td></tr>";
                        $(".gevonden-salarissen").append(tr);
                    });
                } else // Er is nog geen overlappend salaris
                $8ce411d869469115$var$edit.hideFormSuggestion();
            });
        });
        $("#Begindatum").trigger("change");
        // Verander jaarloon op basis van het aanpassen van periodeloon en periode
        $(".periodeLoon, #Periode").change(function(e) {
            e.preventDefault();
            $8ce411d869469115$var$edit.calculateJaarLoon();
        });
        $("#Periode").trigger("change");
        // Focus op bovenste veld wanneer pagina geladen is
        $(function() {
            $("#Begindatum").focus();
        });
    },
    // Verberg het blok met als deze zichtbaar is
    hideFormSuggestion: function() {
        $("#form_suggestion").fadeOut(100, function() {
            $("#form_continue").hide().removeClass("d-none").fadeIn();
        });
    },
    // Bereken het jaarloon op basis van perodeloon en periode
    calculateJaarLoon: function() {
        // var keer = $('#Periode option:selected').attr('keer');
        var periode = $("#Periode option:selected").html();
        $("span.periode").html(periode.toLowerCase());
    }
};
var $8ce411d869469115$export$2e2bcd8739ae039 = $8ce411d869469115$var$edit;


const $e367ddb4b36188e0$var$showDashboard = {
    init () {
        // Download export button functie die op basis van daterange een download url maakt
        $("#buttonDownloadExport").click(function() {
            var url = $(this).data("url");
            url = url + "/" + $("#begindatum").val() + "/" + $("#einddatum").val() + "/";
            window.location.href = url;
        });
        // Zet on change uit te voeren wijziging in de tabel
        $("select.werknemer-select").change(function() {
            var werknemer_id = $(this).val();
            $(this).closest("tr").find("td.werknemer-diff").html("Geen");
            $(this).closest("tr").find("td.adres-diff").html("Geen");
            if (werknemer_id != "nieuw" && werknemer_id != "overslaan") {
                var werknemerDiff = JSON.parse($(this).closest("tr").find("textarea").val());
                var tableClassColor = "table-warning";
                var table = [];
                table.push("<th>Wijziging</th><th>Van</th><th>Naar</th>");
                $.each(werknemerDiff[werknemer_id]["werknemer"], function(key, value) {
                    var classColor = "";
                    if (key == "achternaam" || key == "voorletters" || key == "geboorte_datum") {
                        classColor = "text-danger";
                        tableClassColor = "table-danger";
                        $(".alert-naamswijziging").removeClass("d-none");
                    }
                    table.push("<tr class=" + classColor + "><td>" + key + "</td><td>" + value.old + "</td><td>" + value.new + "</td></tr>");
                // table.push('<td>' + key + '</td><td>' + value.old + '</td><td>' + value.new + '</td></tr>');
                });
                if (table.length > 1) // $(this).closest('tr').find('td.werknemer-diff').html('<table class="table table-striped"><tr>' + table.join('</tr><tr>') + '</tr></table>');
                $(this).closest("tr").find("td.werknemer-diff").html('<table class="table table-striped ' + tableClassColor + ' mb-0">' + table.join("") + "</table>");
                table = [];
                table.push("<th>Wijziging</th><th>Van</th><th>Naar</th>");
                $.each(werknemerDiff[werknemer_id]["adres"], function(key, value) {
                    // table.push('<td>' + key + '</td><td>' + value.old + '</td><td>' + value.new + '</td>');
                    table.push("<tr><td>" + key + "</td><td>" + value.old + "</td><td>" + value.new + "</td></tr>");
                });
                if (table.length > 1) // $(this).closest('tr').find('td.adres-diff').html('<table class="table table-striped"><tr>' + table.join('</tr><tr>') + '</tr></table>');
                $(this).closest("tr").find("td.adres-diff").html('<table class="table table-striped">' + table.join("") + "</table>");
            }
        });
        // Trigger een change event voor alle werknemer select elementen
        $("select.werknemer-select").each(function() {
            $(this).trigger("change");
        });
        // Toon import errors wanneer pagina geladen wordt
        $(".modal-import-errors").modal("show");
        // Maak tooltip aan met error toelichting voor alle rijen
        $(".modal-import-errors table tbody tr").each(function() {
            $("[data-toggle=tooltip]").tooltip();
        });
    }
};
var $e367ddb4b36188e0$export$2e2bcd8739ae039 = $e367ddb4b36188e0$var$showDashboard;


const $6ad6b49af19332ca$var$edit = {
    init () {
        // Toon of verberg uitdienst datum
        $("#Type").on("change, blur", function(e) {
            e.preventDefault();
            var einddatumVerplicht = $("#Type option:selected").data("einddatum");
            if (einddatumVerplicht == true) {
                $("input#Einddatum").attr("data-validate", "required date daterange").val($("input#Einddatum").attr("data-valueOrg")).attr("placeholder", $("input#Begindatum").attr("placeholder"));
                $("input#Einddatum").datepicker("update");
            } else // TODO: Controle of veld daadwerkelijk zichtbaar is!
            $("input#Einddatum").attr("data-validate", "").attr("placeholder", $("input#Einddatum").attr("data-placeholderNietVerplicht"));
        });
        $("#Type").trigger("change");
        // laad de datum kiezer voor einddatum op basis van de begindatum
        $("#Begindatum").on("change, blur", function(e) {
            e.preventDefault();
            $("input#Einddatum").attr("data-enddate", $("input#Begindatum").attr("data-enddate"));
            // $('input#Einddatum').data('datepicker').setEndDate($('input#Begindatum').attr('data-enddate')); // omgezet naar onderstaande regel wegens error na bundling
            $("input#Einddatum").datepicker("setEndDate", $("input#Begindatum").attr("data-enddate"));
            $("input#Einddatum").attr("data-startdate", $("input#Begindatum").val());
            // $('input#Einddatum').data('datepicker').setStartDate($('input#Begindatum').val()); // omgezet naar onderstaande regel wegens error na bundling
            $("input#Einddatum").datepicker("setStartDate", $("input#Begindatum").val());
        });
        // Toon of verberg het blok voor overlappend dienstverband op basis van de begindatum voor een nieuw dienstverband en de einddatum van reeds bestaande dienstverbanden.
        $("#Begindatum, #Einddatum, #Type").change(function(e) {
            e.preventDefault();
            if ($("#Begindatum").val() != "") $.getJSON(window.app.ajaxPath + $("#form-signalering").data("signalering_id") + "/" + "-" + "/duplicate-check/" + $("#Type").val() + "/" + $("#Begindatum").val() + "/" + $("#Einddatum").val() + "/" + "/", function(data) {
                if (data != false) {
                    // Er is een overlappend dienstverband
                    if (!$("#form_suggestion").is(":visible")) {
                        $("#form_suggestion").hide().removeClass("d-none").fadeIn();
                        $("#form_continue").hide();
                    }
                    $(".gevonden-signaleringen *").remove();
                    $.each(data, function(index, val) {
                        var tr = "<tr><td>" + val.begindatum + "</td><td>" + val.einddatum + "</td><td>" + $('#Type option[value="' + val.type + '"]').text() + "</td></tr>";
                        $(".gevonden-signaleringen").append(tr);
                    });
                    $("#form_continue button").html("Toch opslaan");
                } else $("#form_suggestion").fadeOut(100, function() {
                    $("#form_continue button").html("Opslaan");
                });
                $("#form_continue").hide().removeClass("d-none").fadeIn();
            });
        });
        $("#Begindatum").trigger("change");
        // Focus op bovenste veld wanneer pagina geladen is
        $(function() {
            $("#Begindatum").focus();
        });
    }
};
var $6ad6b49af19332ca$export$2e2bcd8739ae039 = $6ad6b49af19332ca$var$edit;


const $6f6ef00491c1a383$var$routeFunctions = {
    verzekeringsinzichtAppAdministratieDocumentenView: $ed366d317c62ef73$export$2e2bcd8739ae039,
    verzekeringsinzichtAppAdministratieRelatieView: $1dd0a2fe0bfa7311$export$2e2bcd8739ae039,
    verzekeringsinzichtAppDienstenArbeidsjuristShowDashboard: $67117d67c059a2f7$export$2e2bcd8739ae039,
    verzekeringsinzichtAppDienstverlenerEditView: $b02a5f4f9add32ad$export$2e2bcd8739ae039,
    verzekeringsinzichtAppDienstverlenerRelatieEdit: $1f8bcf5265c48222$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelAanvraagVerwerkingValidateView: $a24512ec72264b89$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelMV7MKBAanvraagIndienen: $936bfe68e2ecf267$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelMV7MKBofferteAanvragen: $0f450a2e08b13621$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelMV7xxaanvraagIndienen: $0a294aad802e516b$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelMV7xxAanvraagVerwerken: $a02519817463ba7c$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelMV7xxofferteAanvragen: $b78ff4e4d9df46a7$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelMV7xxPremieVerzoekenVerwerken: $8e06696975a37362$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelMV7xxVolmachtAanvraagBekijken: $ef1414d30154ec5c$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelNaverrekeningCheckVolmacht: $c84fdb535a392bd5$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelNaverrekeningCheckVolmachtWerknemers: $ec507a6ded59648f$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelNaverrekeningIndividueel: $a24eff37ee5ac0c7$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelNaverrekeningStandaard: $1035751ca8e81f91$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelNaverrekeningVerkort: $dd86f89524440111$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagBEURSNaverrekeningAVBalgemeenUitvraag: $951cd980113f19a9$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagBEURSNaverrekeningAVBasbestUitvraag: $b3dac3cd90f7bd92$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagBEURSNaverrekeningAVBrowUitvraag: $d3b8a62ef2695f79$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagBEURSNaverrekeningBrandBSUitvraag: $96ae22bde93b0bf6$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagBEURSNaverrekeningCARUitvraag: $e1676fb863008070$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagBEURSNaverrekeningTransportUitvraag: $bd64fdb00bd2c910$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagBEURSNaverrekeningVVAUitvraag: $72035e080057ca24$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagBEURSUitvraag: $ff4afcbe59d9ce69$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagControleren: $2db1873f34f25cfe$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagFELP710StopLossNaverrekendUitvraag: $754671175fcc1d98$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagFELP710StopLossUitvraag: $b3542b11fb2f8081$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagLOYP927BevestigingZiekenUitvraag: $3c885aed24d4b502$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagLOYP927Uitvraag: $29c4ff330639d932$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelUitvraagUitvraag: $939aa8313e578024$export$2e2bcd8739ae039,
    verzekeringsinzichtAppFunnelVoorwaardenVergelijkerVergelijken: $bf2f381b07c35dd7$export$2e2bcd8739ae039,
    verzekeringsinzichtAppGroupsEdit: $226ab816504d4b0f$export$2e2bcd8739ae039,
    verzekeringsinzichtAppImportaImportSalarisCSVImportInitieel: $2e4767040da3bc4c$export$2e2bcd8739ae039,
    verzekeringsinzichtAppImportKeylaneCSVImportInitieel: $e5ade9b062cebabb$export$2e2bcd8739ae039,
    verzekeringsinzichtAppImportUkuUkuCSVImportInitieel: $7e54e2b2a4e482ba$export$2e2bcd8739ae039,
    verzekeringsinzichtAppLoginActivatePreGeneratedAccount: $8de5bcd956907ab0$export$2e2bcd8739ae039,
    verzekeringsinzichtAppProductenPolisvoorwaardenEdit: $6690f65deb8613d2$export$2e2bcd8739ae039,
    verzekeringsinzichtAppSSOSend2: $c44a083a872a04c1$export$2e2bcd8739ae039,
    verzekeringsinzichtAppUsersDashboardView: $7a1e712dd3e4e1af$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersDeclaratieAddMultipleView: $e3a21f11cf892222$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersDeclaratieVerzamelbeschikkingAddview: $18b36b650f433b5c$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersDeelnameAfstandsverklaringEdit: $be28f1d4b01953b3$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersDeelnameAfstandsverklaringToevoegenVanHisPolis: $49e7ba0e8f1e18fc$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersDeelnameWerknemerListing: $5f869cccb76a9dd5$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersDienstverbandArbeidsovereenkomstEditView: $b0b939dd34df01dc$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersDienstverbandArbeidsovereenkomstEndView: $3c5ba2f796f41652$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersDienstverbandArbeidsovereenkomstImportExport: $643b83bdb147d5f9$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersDossierBekijk: $48bf720eac6dca02$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersEditView: $91089521b1ff886b$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersMeldingActieValideerActie: $a61b9fb361780bff$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersMeldingActievalideerActieLogoutTimer: $3aa7ff2b72fec92c$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersMeldingActieWerkgeverPeriodiek: $6d3835e0bbcfcf79$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersMeldingActieWerkgeverSalaris: $8e8f53a8df2b9db2$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersMeldingAOPercentageEditView: $f80fd1b24eaecaaf$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersMeldingEditView: $dec17dae955a5816$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersMeldingEndView: $040177286cd0f424$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersMeldingNewOpvolgend: $7f1ba9305a0f800b$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersMeldingWerkhervattingsPercentageValideer: $637147d595b93f1f$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersMeldingZoekWerknemer: $00699e68abccc2b6$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersNoRiskPolisEdit: $49ab054f8bb59995$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersRelatieDeelnameListing: $d00efe5e55939222$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersSalarisEdit: $8ce411d869469115$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersSalarisImportExport: $e367ddb4b36188e0$export$2e2bcd8739ae039,
    verzekeringsinzichtAppWerknemersSignaleringEdit: $6ad6b49af19332ca$export$2e2bcd8739ae039
};
var $6f6ef00491c1a383$export$2e2bcd8739ae039 = $6f6ef00491c1a383$var$routeFunctions;


const $c525dcf82e73d710$var$check = {
    init: function() {
        /**
     * Listen to keydown event
     *
     * @type {HTMLElement} - the target of the event
     * @listens document#keydown - the namespace and name of the event
     */ document.querySelectorAll(".input-mfa").forEach(function(inputElement) {
            inputElement.addEventListener("keydown", function(e) {
                $c525dcf82e73d710$var$check.nextOrPrevInput(e);
            });
        });
        /**
     * Listen to keyup event
     *
     * @type {HTMLElement} - the target of the event
     * @listens document#keyup - the namespace and name of the event
     */ document.querySelectorAll(".input-mfa").forEach(function(inputElement) {
            inputElement.addEventListener("keyup", function() {
                $c525dcf82e73d710$var$check.submitForm();
            });
        });
        /**
     * Listen to paste event
     *
     * @type {HTMLElement} - the target of the event
     * @listens document#paste - the namespace and name of the event
     */ document.querySelectorAll(".input-mfa").forEach(function(inputElement) {
            inputElement.addEventListener("paste", function(e) {
                $c525dcf82e73d710$var$check.pasteHandler(e);
                $c525dcf82e73d710$var$check.submitForm();
            });
        });
        /**
     * Listen to paste event
     *
     * @type {HTMLElement} - the target of the event
     * @listens document#paste - the namespace and name of the event
     */ document.querySelector("#MFA_code").addEventListener("paste", function(e) {
            var pastedData = $c525dcf82e73d710$var$check.getClipboardData(e);
            document.querySelector("#MFA_code").value = pastedData;
        });
    },
    /**
   * nextOrPrevInput
   * @param {event} e
   */ nextOrPrevInput: function(e) {
        var el = e.target;
        if (e.keyCode === 8) {
            el.value = "";
            var prevElement = el.previousElementSibling;
            if (prevElement) {
                prevElement.value = "";
                prevElement.focus();
            }
        } else if (e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 13 && e.keyCode !== 16) {
            var val = el.value;
            if (val !== "") {
                var nextElement = el.nextElementSibling;
                if (nextElement) nextElement.focus();
            }
        }
    },
    /**
   * getClipboardData
   * @param {event} e
   * @returns {string} pastedData
   */ getClipboardData: function(e) {
        var clipboardData = e.clipboardData || window.clipboardData || e.originalEvent.clipboardData;
        return clipboardData.getData("Text").replace(/[^0-9]/g, "");
    },
    /**
   * pasteHandler
   * @param {event} e
   */ pasteHandler: function(e) {
        var pastedData = $c525dcf82e73d710$var$check.getClipboardData(e);
        var codeArray = pastedData.split("");
        var mfaFields = document.querySelectorAll(".form-group-mfa input");
        codeArray.forEach(function(v, i) {
            mfaFields[i].value = v;
        });
    },
    /**
   * mergeMfaInputValues
   * @returns {string} MfaValue
   */ mergeMfaInputValues: function() {
        var value = "";
        var inputs = document.querySelectorAll(".form-group-mfa input");
        inputs.forEach(function(input) {
            value += input.value;
        });
        return value;
    },
    /**
   * submitform
   * @returns {string} MfaValue
   */ submitForm: function() {
        var fields = document.querySelectorAll(".form-group-mfa input");
        var code = $c525dcf82e73d710$var$check.mergeMfaInputValues();
        document.querySelector("#MFA_code").value = code;
        if (code.length == 6) {
            fields.forEach(function(field) {
                field.blur();
                field.setAttribute("readonly", true);
            });
            document.querySelector("#mfaForm").submit();
        }
    }
};
var $c525dcf82e73d710$export$2e2bcd8739ae039 = $c525dcf82e73d710$var$check;



const $66d5a9831de7482c$var$selectUserId = {
    init: function() {
        const elementTextFilterElement = document.querySelector("[data-element-text-filter-input]");
        (0, $4df9d5532b128906$export$2e2bcd8739ae039).init(elementTextFilterElement);
    }
};
var $66d5a9831de7482c$export$2e2bcd8739ae039 = $66d5a9831de7482c$var$selectUserId;


const $4f3bdf129ffb0553$var$loginForward = {
    init: function() {
        $4f3bdf129ffb0553$var$loginForward.forwardAfterAuth();
    },
    forwardAfterAuth: function() {
        let btn = document.getElementById("buttonReturnToApp");
        if (btn !== null) setTimeout(function() {
            btn.click();
        }, 500);
    }
};
var $4f3bdf129ffb0553$export$2e2bcd8739ae039 = $4f3bdf129ffb0553$var$loginForward;


const $5b7812f3dace09ef$var$check = {
    init: function() {
        $(".voorwaardenAkkoordCheckbox").click(function() {
            var verder = true;
            $(".voorwaardenAkkoordCheckbox").each(function() {
                if (!this.checked) verder = false;
            });
            if (verder) $("#voorwaardenAkkoord").attr("disabled", false);
            else $("#voorwaardenAkkoord").attr("disabled", true);
        });
    }
};
var $5b7812f3dace09ef$export$2e2bcd8739ae039 = $5b7812f3dace09ef$var$check;


const $0e14b1ff2d269f13$var$changeSettings = {
    init: function() {
        // Email change handler
        document.getElementById("email").addEventListener("change", function() {
            const email = this;
            const oldEmail = email.getAttribute("data-original");
            const newEmail = email.value;
            const form = email.closest("form");
            const submitButton = form.querySelector('button[type="submit"]');
            const changeEmail = form.querySelector("#confirmEmailChange");
            if (newEmail === oldEmail) {
                if (submitButton.disabled) {
                    submitButton.disabled = false;
                    changeEmail.classList.add("d-none");
                }
            } else {
                submitButton.disabled = true;
                changeEmail.classList.remove("d-none");
            }
        });
        // Confirm email change handler
        document.getElementById("confirmChangeEmail").addEventListener("change", function() {
            const confirm = this;
            const value = confirm.value;
            const form = confirm.closest("form");
            const submitButton = form.querySelector('button[type="submit"]');
            if (value !== "Y") submitButton.setAttribute("disabled", "disabled");
            else submitButton.removeAttribute("disabled");
        });
    }
};
var $0e14b1ff2d269f13$export$2e2bcd8739ae039 = $0e14b1ff2d269f13$var$changeSettings;


const $a8c2900499f61dcd$var$totp = {
    init: function() {
        document.getElementById("buttonDisable")?.addEventListener("click", function() {
            document.querySelector("input[name=action]").value = "disable";
        });
        document.getElementById("buttonRegenerate")?.addEventListener("click", function() {
            document.querySelector("input[name=action]").value = "regenerate";
        });
    }
};
var $a8c2900499f61dcd$export$2e2bcd8739ae039 = $a8c2900499f61dcd$var$totp;


// import gullFrameworkLoginactivatePreGeneratedAccount from './routes/Gull/Framework/Login/activatePreGeneratedAccount.js';
const $f1b1f92570942b7c$var$routeFunctions = {
    gullFrameworkMultiFactorAuthCheck: $c525dcf82e73d710$export$2e2bcd8739ae039,
    gullFrameworkAuthSelectuserid: $66d5a9831de7482c$export$2e2bcd8739ae039,
    gullFrameworkAuthLoginforward: $4f3bdf129ffb0553$export$2e2bcd8739ae039,
    gullFrameworkVoorwaardenCheck: $5b7812f3dace09ef$export$2e2bcd8739ae039,
    gullFrameworkUsersChangesettings: $0e14b1ff2d269f13$export$2e2bcd8739ae039,
    gullFrameworkLoginTotp: $a8c2900499f61dcd$export$2e2bcd8739ae039
};
var $f1b1f92570942b7c$export$2e2bcd8739ae039 = $f1b1f92570942b7c$var$routeFunctions;


class $42fa52476a8cebae$var$App {
    constructor(appAutoload, frameworkAutoload, appRoutes, frameworkRoutes){
        window.app = this;
        this.ajaxPath = this.getAjaxPath() ?? null;
        this.cookieDomain = document.head.querySelector("meta[name=cookie-domain]")?.getAttribute("content") ?? null;
        this.environment = document.head.querySelector("meta[name=environment]")?.getAttribute("content") ?? null;
        this.framework = document.head.querySelector("meta[name=framework]")?.getAttribute("content") ?? null;
        this.language = this.getLanguage();
        this.route = document.head.querySelector("meta[name=route]")?.getAttribute("content") ?? null;
        this.routePath = document.head.querySelector("meta[name=route-path]")?.getAttribute("content") ?? null;
        this.currentRouteName = this.formatCurrentRouteName(this.route);
        this.url = this.getUrl();
        this.passwordStrengtUrl = "/logins/passwordstrength";
        this.version = document.head.querySelector("meta[name=version]")?.getAttribute("content") ?? null;
        this.appAutoload = appAutoload;
        this.frameworkAutoload = frameworkAutoload;
        this.routeScripts = {
            ...appRoutes,
            ...frameworkRoutes
        };
    }
    init(Router) {
        this.router = new Router(this.route, this.routePath, this.appAutoload, this.frameworkAutoload, this.routeScripts, this.currentRouteName);
        this.domStateReady(()=>{
            if (this.environment == "dev" || this.environment == "stage") console.log(this);
        });
    }
    getAjaxPath() {
        let ajaxPath = document.head.querySelector("meta[name=path]")?.getAttribute("content");
        if (typeof ajaxPath !== "undefined" && ajaxPath !== "" && ajaxPath?.charAt(ajaxPath.length - 1) != "/") ajaxPath = ajaxPath + "/";
        return ajaxPath ?? null;
    }
    getLanguage(language = "nl_NL") {
        let metaAppLang = document.head.querySelector("meta[name=app-language]")?.getAttribute("content");
        if (typeof metaAppLang !== "undefined" && metaAppLang !== "" && /^[a-z]{2}_[A-Z]{2}$/i.test(metaAppLang)) {
            if (metaAppLang.substring(0, 2) == "nl") language = "nl_NL";
            else if (metaAppLang.substring(0, 2) == "en") language = "en_US";
        }
        return language;
    }
    getUrl() {
        let url = window.location.href;
        if (typeof url !== "undefined" && url !== "") {
            if (url.charAt(url.length - 1) == "#") url = url.substr(0, url.length - 1);
            if (url.charAt(url.length - 1) != "/") url = url + "/";
        }
        return url || null;
    }
    formatCurrentRouteName(currentRoute) {
        return currentRoute?.toLowerCase().replace(/\/(.)/g, (_, c)=>c.toUpperCase());
    }
    domStateReady(callbackFunction) {
        if (document.readyState !== "loading") setTimeout(callbackFunction, 1);
        else document.addEventListener("DOMContentLoaded", ()=>{
            setTimeout(callbackFunction, 1);
        });
    }
    log(message) {
        if (this.environment == "dev" || this.environment == "stage") console.log(message);
    }
}
var $42fa52476a8cebae$export$2e2bcd8739ae039 = $42fa52476a8cebae$var$App;


class $0b1de9f264360d58$var$Router {
    /**
   * Create a new Router
   *
   * @param {Object} routes
   * @param {String} currentRoute
   * @param {String} routePath
   */ constructor(currentRoute, routePath, appAutoload, frameworkAutoload, routeFunctions, currentRouteName){
        this.currentRoute = currentRoute;
        this.routePath = routePath;
        this.appAutoload = appAutoload;
        this.frameworkAutoload = frameworkAutoload;
        this.routeFunctions = routeFunctions;
        this.currentRouteName = currentRouteName;
        this.routerType = "build";
        this.init();
    }
    init() {
        this.appAutoload.init();
        this.frameworkAutoload.init();
        this.routeFunctions = this.lowercaseKeys(this.routeFunctions);
        this.currentRouteName = this.currentRouteName.toLowerCase();
        if (typeof this.routeFunctions[this.currentRouteName] !== "undefined" && typeof this.routeFunctions[this.currentRouteName].init == "function") this.routeFunctions[this.currentRouteName].init();
        this.appAutoload.finalize();
        this.frameworkAutoload.finalize();
    }
    lowercaseKeys(obj) {
        return Object.entries(obj).reduce((acc, [key, value])=>{
            acc[key.toLowerCase()] = value;
            return acc;
        }, {});
    }
}
var $0b1de9f264360d58$export$2e2bcd8739ae039 = $0b1de9f264360d58$var$Router;


let $50947d4c8c62fc19$var$appInstance = new (0, $42fa52476a8cebae$export$2e2bcd8739ae039)((0, $87dc804c4fdb363e$export$2e2bcd8739ae039), (0, $2fdb429b3f21d464$export$2e2bcd8739ae039), (0, $6f6ef00491c1a383$export$2e2bcd8739ae039), (0, $f1b1f92570942b7c$export$2e2bcd8739ae039));
$50947d4c8c62fc19$var$appInstance.init((0, $0b1de9f264360d58$export$2e2bcd8739ae039));

})();
//# sourceMappingURL=bundle.main.min.js.map
